(function() {
    'use strict';

    angular
        .module('app.pages.auth.yiman-thank-you', ['ipCookie'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        $stateProvider.state('app.pages_auth_yiman-thank-you', {
            url: '/yiman-admin-class-sign-up-thank-you',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.pages_auth_yiman-thank-you': {
                    templateUrl: 'app/main/pages/auth/thank-you/yiman-thank-you.html',
                    controller: 'YimanThankYouController as vm'
                }
            },
            bodyClass: 'yiman-thank-you'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/thank-you');


    }

})();
(function() {
    'use strict';

    angular
        .module('app.pages.auth.yiman-thank-you')
        .controller('YimanThankYouController', YimanThankYouController);

    /** @ngInject */
    function YimanThankYouController(ApiService, Utils) {
        // Data
        var vm = this;
        // Methods

        //////////
    }
})();
(function() {
    'use strict';

    angular
        .module('app.pages.auth.indoslang-thank-you', ['ipCookie'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

        $stateProvider.state('app.pages_auth_indoslang-thank-you', {
            url: '/indoslang-admin-class-sign-up-thank-you',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.pages_auth_indoslang-thank-you': {
                    templateUrl: 'app/main/pages/auth/thank-you/indoslang-thank-you.html',
                    controller: 'IndoslangThankYouController as vm'
                }
            },
            bodyClass: 'indoslang-thank-you'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/thank-you');


    }

})();
(function() {
    'use strict';

    angular
        .module('app.pages.auth.indoslang-thank-you')
        .controller('IndoslangThankYouController', IndoslangThankYouController);

    /** @ngInject */
    function IndoslangThankYouController(ApiService, Utils) {
        // Data
        var vm = this;
        // Methods

        //////////
    }
})();
(function() {
    'use strict';

    angular
        .module('app.pages.auth.hana-thank-you', ['ipCookie'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        $stateProvider.state('app.pages_auth_hana-thank-you', {
            url: '/hana-admin-class-sign-up-thank-you',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.pages_auth_hana-thank-you': {
                    templateUrl: 'app/main/pages/auth/thank-you/hana-thank-you.html',
                    controller: 'HanaThankYouController as vm'
                }
            },
            bodyClass: 'hana-thank-you'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/thank-you');


    }

})();
(function() {
    'use strict';

    angular
        .module('app.pages.auth.hana-thank-you')
        .controller('HanaThankYouController', HanaThankYouController);

    /** @ngInject */
    function HanaThankYouController(ApiService, Utils) {
        // Data
        var vm = this;
        // Methods
        //////////
    }
})();
(function() {
    'use strict';

    angular
        .module('app.pages.auth.english-express-thank-you', ['ipCookie'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

        $stateProvider.state('app.pages_auth_english-express-thank-you', {
            url: '/english-express-admin-class-sign-up-thank-you',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.pages_auth_english-express-thank-you': {
                    templateUrl: 'app/main/pages/auth/thank-you/english-express-thank-you.html',
                    controller: 'EnglishExpressThankYouController as vm'
                }
            },
            bodyClass: 'english-express-thank-you'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/thank-you');


    }

})();
(function() {
    'use strict';

    angular
        .module('app.pages.auth.english-express-thank-you')
        .controller('EnglishExpressThankYouController', EnglishExpressThankYouController);

    /** @ngInject */
    function EnglishExpressThankYouController(ApiService, Utils) {
        // Data
        var vm = this;
        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.reset-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_reset-password', {
            url      : '/reset-password',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_reset-password': {
                    templateUrl: 'app/main/pages/auth/reset-password/reset-password.html',
                    controller : 'ResetPasswordController as vm'
                }
            },
            bodyClass: 'reset-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/reset-password');

        // Navigation
        // msNavigationServiceProvider.saveItem('pages.auth.reset-password', {
        //     title : 'Reset Password',
        //     state : 'app.pages_auth_reset-password',
        //     weight: 6
        // });
    }

})();
(function()
{
    'use strict';
    angular
            .module('app.pages.auth.reset-password')
            .controller('ResetPasswordController', ResetPasswordController);
    /** @ngInject */
    function ResetPasswordController($location, ApiService, Utils, api)
    {
        // Data
        var vm = this;
        window.h = vm;
        vm.passwordNotMatch = true;
        vm.checkPasswordEntered = function() {
            if (vm.form.passwordConfirm == undefined) {
                vm.passwordNotMatch = true;
            }
        }
        vm.checkPasswordMatch = function() {
            if (vm.form.passwordConfirm != undefined) {
                vm.passwordNotMatch = angular.equals(vm.form.password, vm.form.passwordConfirm);
            }
        }

       
        // Methods
        vm.setResetPassword = function() {
            var param = $location.search();
            if (param.id) {
                var id = param.id;
                if (vm.form.password) {
                    var requestData =
                            {
                                "key": id,
                                "password": vm.form.password
                            }
                    ApiService.setPassword({
                        data: requestData,
                        success: function(response) {
                            Utils.showLoader(false);
                            if (response.status == 0) {
                                Utils.showToast({text: response.data.message});
                                $location.url($location.path("/login"));
//                                $location.path();
                            } else {
                                Utils.showToast({text: response.data.message});
                                $location.url($location.path("/login"));
                            }
                        }
                    });
                }
            }
        }
        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.pages_auth_register', {
            url  : '/pages/auth/register',
            views: {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/basic.html'
                },
                'content@app.pages_auth_register': {
                    templateUrl: 'app/main/pages/auth/register/register.html',
                    controller : 'RegisterController as vm'
                }
            }
        });

        $translatePartialLoaderProvider.addPart('app/main/pages/auth/register');
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register')
        .controller('RegisterController', RegisterController);

    /** @ngInject */
    function RegisterController()
    {
        var vm = this;

        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login', ['ipCookie'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/login');

       
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.pages.auth.login')
            .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($scope, $location, api, $http, GlobalPool, Utils, ApiService, ipCookie,$rootScope)
    {
        // Data
        var vm = this;
//       var username = {};
//        var password = {};
//        var remember = {};
        // Methods

        vm.login = {
            email: '', // 'demo_admin',
            password: ''//'2A5DCAA813AE7058'
        };

        vm.invalidUser = false;
        //////////
        vm.onLogin = function (e) {

            vm.invalidUser = false;
            Utils.showLoader(true);

            ApiService.Login({
                data: this.login,
                success: function (response) {
                    Utils.showLoader(false);
                    vm.invalidUser = false;
                    $scope.response = response;
                    if (response.status == 0) {
                        Utils.showLoader(false);
//                        Utils.showToast({"text": response.data.message});
                        vm.invalidUser = true;
//                        $scope.error = error;
                    } else {
                        GlobalPool.setUserData(response.data);
                        
                        var arrMenu = getMenuXML(GlobalPool.getMenuPermissions());
                        $rootScope.roleID = response.data.role_id;
                        
                        GlobalPool.setUserMenu(arrMenu);
                        $(document).trigger('AuthDataLoaded', {data: arrMenu});
                        for (var i = 0; i < arrMenu.length; i++) {
                            if (arrMenu[i].title && arrMenu[i].Menu.length != 0) {
//                            var parentTitle = arrMenu[i].title;
//                            parentTitle = parentTitle.toLowerCase();
                                if (arrMenu[i].Menu.length != 0) {
                                    for (var j = 0; j < arrMenu[i].Menu.length; i++) {
                                        if (arrMenu[i].Menu[j].title) {
                                            var title = arrMenu[i].Menu[j].url;
//                                        childUrl = childTitle.toLowerCase();
//                                        var title = parentTitle + '/' + childTitle;
                                            break;
                                        }
                                    }
                                }
                                break;
                            } else {
                                var title = arrMenu[i].url;
                                break;
                            }
                        }
                        if($rootScope.roleID == '1') {
                            $location.path('/dashboard');
                        } else if($rootScope.roleID == '2'){
                            $location.path('/teacher-profile');
                        }else {
                            $location.path(title);
                        }
                    }
//                    $location.path("/dashboard");
                },
            });


        };
        function getMenuXML(data) {
            var menu = Focus.MENUS.MENU;
            // var AllowedMenu = $scope.response.AuthenticateUserResult.UserAccessRights[1]['AccessRightParams'];
            var AllowedMenu = data;
            var arrAllowedMenu = AllowedMenu.split(',');
            var len = arrAllowedMenu.length;
            var menuObj = getMenuObject(arrAllowedMenu);
            var parentNode = menuObj.id;
            var weight = menuObj.weight;
            var arrMenus = [];
            var parentTitle = menuObj['value'];
            var url = menuObj['url']
            var parentArr = [];
            var tempArr = [];
            for (var i = 0; i < len; i++) {
                var splitValue = (arrAllowedMenu[i] + "").split(".");
                if (splitValue.length == 1) {
                    if (parentNode != splitValue[0]) {
                        arrMenus.push({
                            id: parentNode,
                            title: parentTitle,
                            weight: weight,
                            url: url,
                            Menu: tempArr
                        });
                        tempArr = [];
                        parentNode = splitValue[0];
                        var result = $.grep(menu, function (e) {
                            return e.id == splitValue[0];
                        });
                        if (result.length != 0) {
                            parentTitle = result[0]['value'];
                            weight = result[0]['weight'];
                            parentArr = result[0];
                        }
                    } else if (i == 0) {
                        tempArr = [];
                        parentNode = splitValue[0];
                        var result = $.grep(menu, function (e) {
                            return e.id == splitValue[0];
                        });
                        if (result.length != 0) {
                            parentTitle = result[0]['value'];
                            weight = result[0]['weight'];
                            parentArr = result[0];
                        }
                    }
                } else if (splitValue.length == 2) {
                    if (parentNode != splitValue[0]) {
                        arrMenus.push({
                            id: parentNode,
                            title: parentTitle,
                            weight: weight,
                            url: url,
                            Menu: tempArr
                        });
                        tempArr = [];
                        parentNode = splitValue[0];
                        var result = $.grep(menu, function (e) {
                            return e.id == splitValue[0];
                        });
                        if (result.length != 0) {
                            parentTitle = result[0]['value'];
                            weight = result[0]['weight'];
                            parentArr = result[0];
                        }
                    }
                    var result = $.grep(parentArr.Menu, function (e) {
                        return e.id == arrAllowedMenu[i];
                    });
                    if (result.length != 0) {
                        tempArr.push({
                            id: result[0]['id'],
                            weight: result[0]['weight'],
                            title: result[0]['value'],
                            url: result[0]['url']
                        });
                    }
                }
            }
            arrMenus.push({
                id: parentNode,
                title: parentTitle,
                weight: weight,
                url: url,
                Menu: tempArr
            });
            return arrMenus;
        }

        function getMenuObject(arrAllowedMenu) {
            var menu = Focus.MENUS.MENU;
            for (var i = 0; i < arrAllowedMenu.length; i++) {
                var parentNode = arrAllowedMenu[i];
                for (var j = 0; j < menu.length; j++) {
                    if (parentNode == menu[j].id) {
                        var result = menu[j];
                        break;
                    }
//                   
                }
                return result;
            }
        }
        

        function getParsedMenu(data) {
            var menu = Focus.MENUS.MENU;
            // var AllowedMenu = $scope.response.AuthenticateUserResult.UserAccessRights[1]['AccessRightParams'];

            var arrMenus = menu.slice(0);

            // var AllowedMenu = $scope.response.AuthenticateUserResult.UserAccessRights[1]['AccessRightParams'];
            var arrAllowedIDs = data.split(',');
            var curMenu = null;
            var innerMenu = null;
            for (var i = 0; i < arrMenus.length; i++) {
                curMenu = arrMenus[i];
                curMenu.bAllow = false;
                if (arrAllowedIDs.indexOf(curMenu.id.toString()) != -1 && curMenu.Menu.length > 0) {
                    curMenu.bAllow = true;

                    for (var j = 0; j < curMenu.Menu.length; j++) {
                        innerMenu = curMenu.Menu[j];
                        if (arrAllowedIDs.indexOf(innerMenu.id.toString()) != -1)
                        {
                            innerMenu.bAllow = true;
                        }
                    }
                }
            }

        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.lock', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.pages_auth_lock', {
            url  : '/pages/auth/lock',
            views: {
                'main@'                      : {
                    templateUrl: 'app/core/layouts/basic.html'
                },
                'content@app.pages_auth_lock': {
                    templateUrl: 'app/main/pages/auth/lock/lock.html',
                    controller : 'LockController as vm'
                }
            }
        });

        $translatePartialLoaderProvider.addPart('app/main/pages/auth/lock');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.lock')
        .controller('LockController', LockController);

    /** @ngInject */
    function LockController()
    {
        var vm = this;

        // Data
        vm.form = {
            userName: 'Jane Doe'
        };

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_forgot-password', {
            url      : '/forgot-password',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_forgot-password': {
                    templateUrl: 'app/main/pages/auth/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'forgot-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/forgot-password');

        // Navigation
        // msNavigationServiceProvider.saveItem('pages.auth.forgot-password', {
        //     title : 'Forgot Password',
        //     state : 'app.pages_auth_forgot-password',
        //     weight: 5
        // });
    }

})();
(function()
{
    'use strict';

    angular
            .module('app.pages.auth.forgot-password')
            .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController(ApiService, Utils)
    {
        // Data
        var vm = this;

        vm.onForgetPwd = function() {

            var requestData = {
                'email': vm.form.email
            }
            Utils.showLoader(true);
            ApiService.forgetPwd({
                data: requestData,
                success: function(response) {
                    Utils.showLoader(false);
                    Utils.showToast({"text": response.data.message});

                }
            });

        }
        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.thank', ['ipCookie'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        
             $stateProvider.state('app.pages_auth_thank', {
            url: '/thank-you',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.pages_auth_thank': {
                    templateUrl: 'app/main/pages/auth/admission/thank.html',
                    controller: 'ThankController as vm'
                }
            },
            bodyClass: 'admission'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/admission');

       
    }

})();
(function()
{
    'use strict';
    angular
            .module('app.pages.auth.thank')
            .controller('ThankController', ThankController);
    /** @ngInject */
    function ThankController($location, ApiService, Utils, api)
    {
        // Data
        var vm = this;

        var param = $location.path();
        var urlresult = param.split("/");
      
        
        vm.dialogData = {};
        vm.isForm1Visible = true;
        vm.isForm2Visible = false;
        vm.dialogData.school_id = urlresult[2];
        vm.courseName = urlresult[3];
        vm.dialogData.is_company = 0;
        vm.dialogData.is_renewal = 0;
        vm.onChangeCheckBox = false;
        vm.onChangeCheckBox1 = false;
        vm.dialogData.course_name = "South Course";

        vm.days = [
                {id: 0, day: 'Monday', bAllow: false},
                {id: 1, day: 'Tuesday', bAllow: false},
                {id: 2, day: 'Wednesday', bAllow: false},
                {id: 3, day: 'Thursday', bAllow: false},
                {id: 4, day: 'Friday', bAllow: false},
                {id: 5, day: 'Saturday', bAllow: false},
                {id: 6, day: 'Sunday', bAllow: false}

            ];

        vm.timeslot1 = [
                {id: 0, time: '8.30 am', bAllow: false},
                {id: 1, time: '9.30 am', bAllow: false},
                {id: 2, time: '10.00 am', bAllow: false},
                {id: 3, time: '10.30 am', bAllow: false},
                {id: 4, time: 'Other', bAllow: false},
                {id: 5, time: '12.00 am', bAllow: false},
                {id: 6, time: '1.30 am', bAllow: false},
                {id: 7, time: '2.30 am', bAllow: false},
                {id: 8, time: '3.30 am', bAllow: false},
                {id: 9, time: '12.00 am', bAllow: false},
                {id: 10, time: '7.30 am', bAllow: false}
            ];

/*
        vm.timeslot2 = [
                {id: 0, time: '12.00 am', bAllow: false},
                {id: 0, time: '1.30 am', bAllow: false},
                {id: 0, time: '2.30 am', bAllow: false},
                {id: 0, time: '3.30 am', bAllow: false},
              
            ];


        vm.timeslot3 = [
                {id: 0, time: '12.00 am', bAllow: false},
                {id: 0, time: '7.30 am', bAllow: false}
            ];

 */           

        vm.showForm = function()
        {

            vm.isForm1Visible = vm.isForm1Visible ? false : true;
            vm.isForm2Visible = vm.isForm2Visible ? false : true;
        }

       vm.getData = function() {

            var checkData = {
                "name" : "South Course",
                "type": "G",
                "level": "Beginner",
                "school_id": "1" 
            }
            ApiService.GetGroupIntakes({

                data: checkData,

                success: function(response) {
                    
                    if (response.status == 0) {
                        Utils.showToast({text: response.data.message, 'type': 0});
                        
                    }
                    else {
                        vm.courseData = response.data;
                        //alert(vm.courseData.data[0].start_date);
                    }
                }
            })
        };

        vm.ToggleCheckbox = function (e, value) {

        vm.onChangeCheckBox = true;
        var arrDays = vm.days;
        var allowedDays = [];
        for (var i = 0; i < arrDays.length; i++) {
            if (arrDays[i].bAllow === true) {
        
                allowedDays.push(arrDays[i].day);
                vm.dialogData.preferred_days = allowedDays ;
            }
        }
        vm.dialogData.weekdays = allowedDays;
        if (vm.isCourseChanged && vm.isTimeChanged) {
            vm.getAutoSuggestions();
        }
        }


        vm.ToggleTime1Checkbox = function (e, value) {

        vm.onChangeCheckBox1 = true;
        var arrTime1 = vm.timeslot1;
        var allowedTime1 = [];
        for (var i = 0; i < arrTime1.length; i++) {
            if (arrTime1[i].bAllow === true) {
        
                allowedTime1.push(arrTime1[i].time);
        //        vm.dialogData.preferred_timings = allowedTime1 ;
            }
        }
        vm.dialogData.preferred_timings = allowedTime1 ;
        /*vm.dialogData.weekdays = allowedTime1;
        if (vm.isCourseChanged && vm.isTimeChanged) {
            vm.getAutoSuggestions();
        }
        */

        }

        vm.onChangeRenewal = function()
        {
            if (vm.is_renewal == true) {
                vm.dialogData.is_renewal = 1;
            } else {
                vm.dialogData.is_renewal = 0;
            }
        }
        vm.onChangeCompany = function()
        {
            if (vm.is_company == true) {
                vm.dialogData.is_company = 1;
            } else {
                vm.dialogData.is_company = 0;
            }
        }
        vm.addRecord = function()
        {
            alert(vm.dialogData.preferred_timings);
            
            Utils.showLoader(true);
            //here we will have the new data to be saved.
            vm.dialogData;
            ApiService.AddPrivateApplication({
                data: vm.dialogData,
         
                success: function(response) {

                    if (response.status === 0) {
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 0});
                    }
                    else {
                        
                        //$mdDialog.hide(vm.dialogData);
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 1});
                        
                        //vm._reloadDtPage();
                    }
                }
            });
            
        }
    }
})();
(function()
{
    'use strict';

    angular
            .module('app.pages.auth.found', ['ipCookie'])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {

        $stateProvider.state('app.pages_auth_found', {
            url: '/page-not-found',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.pages_auth_found': {
                    templateUrl: 'app/main/pages/auth/admission/pagenotfound.html',
                    controller: 'PageNotFoundController as vm'
                }
            },
            bodyClass: 'pagenotfound'
        });

        // Translation
//        $translatePartialLoaderProvider.addPart('app/main/pages/auth/admission');


    }

})();
(function()
{
    'use strict';
    angular
            .module('app.pages.auth.found')
            .controller('PageNotFoundController', PageNotFoundController);
    /** @ngInject */
    function PageNotFoundController()
    {
        // Data
       
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.admissionprivate', ['ipCookie'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        
             $stateProvider.state('app.pages_auth_admissionprivate', {
            url: '/admissions/1/conversational mandarin/prihjkhvate',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.pages_auth_admissionprivate': {
                    templateUrl: 'app/main/pages/auth/admission/admissionprivate.html',
                    controller: 'AdmissionPrivateController as vm'
                }
            },
            bodyClass: 'admissionprivate'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/admission');

       
    }

})();
(function()
{
    'use strict';
    angular
            .module('app.pages.auth.admissionprivate')
            .controller('AdmissionPrivateController', AdmissionPrivateController);
    /** @ngInject */
    function AdmissionPrivateController($location, ApiService, Utils, api)
    {
        // Data
        var vm = this;
    window.h = vm;
        var param = $location.path();
        var urlresult = param.split("/");
      

        vm.dialogData = {};

        vm.dialogData.type ='P';
        vm.showDiv = false;
        vm.isForm1Visible = true;
        vm.isForm2Visible = false;
        vm.dialogData.school_id = urlresult[2];
        vm.dialogData.is_company = 0;
        vm.dialogData.is_renewal = 0;
        
        vm.onChangeCheckBox = false;
        vm.onChangeCheckBox1 = false;
        vm.dialogData.course_name = urlresult[3];
        vm.dialogData.level = "";
        vm.companyData = false;
        vm.companyRequired = false;
        vm.dialogData.contact_person = "";
        vm.dialogData.company_address = "";
        vm.dialogData.company_name = "";

        vm.days = [
                {id: 0, day: 'Monday', bAllow: false},
                {id: 1, day: 'Tuesday', bAllow: false},
                {id: 2, day: 'Wednesday', bAllow: false},
                {id: 3, day: 'Thursday', bAllow: false},
                {id: 4, day: 'Friday', bAllow: false},
                {id: 5, day: 'Saturday', bAllow: false},
                {id: 6, day: 'Sunday', bAllow: false}

            ];

        vm.timeslot1 = [
                {id: 0, time: '8.30 am', bAllow: false},
                {id: 1, time: '9.30 am', bAllow: false},
                {id: 2, time: '10.00 am', bAllow: false},
                {id: 3, time: '10.30 am', bAllow: false},
                {id: 4, time: 'Other', bAllow: false},
                {id: 5, time: '12.00 am', bAllow: false},
                {id: 6, time: '1.30 am', bAllow: false},
                {id: 7, time: '2.30 am', bAllow: false},
                {id: 8, time: '3.30 am', bAllow: false},
                {id: 9, time: '12.00 am', bAllow: false},
                {id: 10, time: '7.30 am', bAllow: false}
            ];

/*
        vm.timeslot2 = [
                {id: 0, time: '12.00 am', bAllow: false},
                {id: 0, time: '1.30 am', bAllow: false},
                {id: 0, time: '2.30 am', bAllow: false},
                {id: 0, time: '3.30 am', bAllow: false},
              
            ];


        vm.timeslot3 = [
                {id: 0, time: '12.00 am', bAllow: false},
                {id: 0, time: '7.30 am', bAllow: false}
            ];

 */           

        vm.showForm = function()
        {
            if(vm.dialogData.level != "")
            {    
                var elmnt = document.getElementById("admission");
                elmnt.scrollTop = 0;
                vm.isForm1Visible = vm.isForm1Visible ? false : true;
                vm.isForm2Visible = vm.isForm2Visible ? false : true;
            }
        }


/*
       vm.getData = function() {
            alert(vm.dialogData.level);
            var checkData = {
                "name" : "South Course",
                "type": "G",
                "level": "Beginner",
                "school_id": "1" 
            }
            ApiService.GetGroupIntakes({

                data: checkData,

                success: function(response) {
                    
                    if (response.status == 0) {
                        Utils.showToast({text: response.data.message, 'type': 0});
                        
                    }
                    else {
                        vm.courseData = response.data;
                        //alert(vm.courseData.data[0].start_date);
                    }
                }
            })
        };
*/

        vm.ToggleCheckbox = function (e, value) {

        vm.onChangeCheckBox = true;
        var arrDays = vm.days;
        var allowedDays = [];
        for (var i = 0; i < arrDays.length; i++) {
            if (arrDays[i].bAllow === true) {
        
                allowedDays.push(arrDays[i].day);
                //vm.dialogData.preferred_days = allowedDays ;
            }
        }
        vm.dialogData.preferred_days = allowedDays ;
        
        }


        vm.ToggleTime1Checkbox = function (e, value) {

        vm.onChangeCheckBox1 = true;
        var arrTime1 = vm.timeslot1;
        var allowedTime1 = [];
        for (var i = 0; i < arrTime1.length; i++) {
            if (arrTime1[i].bAllow === true) {
        
                allowedTime1.push(arrTime1[i].time);
        //        vm.dialogData.preferred_timings = allowedTime1 ;
            }
        }
        vm.dialogData.preferred_timings = allowedTime1 ;

        }

        vm.onChangeRenewal = function()
        {
            if (vm.is_renewal == true) {
                vm.dialogData.is_renewal = 1;
            } else {
                vm.dialogData.is_renewal = 0;
            }
        }
        vm.onChangeCompany = function()
        {
            vm.companyData = vm.companyData ? false : true;
            

            if (vm.is_company == true) {
                vm.dialogData.is_company = 1;
                vm.companyRequired = true;
            } else {
                vm.dialogData.is_company = 0;
                vm.companyRequired = false;
            }
        }
        // vm.addRecord = function()
        // {
        
        //     Utils.showLoader(true);
        //     //here we will have the new data to be saved.
        //     vm.dialogData;
        //     ApiService.AddPrivateApplication({
        //         data: vm.dialogData,
         
        //         success: function(response) {

        //             if (response.status === 0) {
        //                 Utils.showLoader(false);
        //                 Utils.showToast({text: response.data.message, 'type': 0});
          
        //             }
        //             else {
          
          
        //                 Utils.showLoader(false);
        //                 window.location = "/thank-you";
        //             }
        //         }
        //     });    
        // }
        vm.checkCheckboxLength = function()
        {
        
            if(vm.dialogData.preferred_timings.length >= 1 && vm.dialogData.preferred_days.length )
            {
                vm.addRecord();       
            }
        }
    }
})();
(function()
{
    'use strict';
    angular
            .module('app.pages.auth.admissiononline', ['ipCookie','moment-picker'])
            .config(config);
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, $urlRouterProvider)
    {
//        var url = $location.search();
//        console(url)

        $stateProvider.state('app.pages_auth_admissiononline', {
            // url: '/admissions',
            url: '/admissions/:id/:courseName/:courseType',
            
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.pages_auth_admissiononline': {
                    templateUrl: 'app/main/pages/auth/admission/admissiononline.html',
                    controller: 'AdmissionOnlineController as vm'
                }
            },
            controller: function($stateParams) {
                $stateParams.id //*** Watch Out! DOESN'T EXIST!! ***//
                $stateParams.courseName //*** Exists! ***//  
                $stateParams.courseType
            },
            resolve: {
                id: ['$stateParams', function($stateParams) {
                        return $stateParams.id;
                    }],
                courseName: ['$stateParams', function($stateParams) {
                        return $stateParams.courseName;
                    }],
                courseType: ['$stateParams', function($stateParams) {
                        return $stateParams.courseType;
                    }],
            },
            data: {
                bAllow: 'true'
            },
            // bAllow: 'true',
            bodyClass: 'admission'
        });
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/admission');
    }


})();
(function() {
    'use strict';
    angular
        .module('app.pages.auth.admissiononline')
        .controller('AdmissionOnlineController', AdmissionOnlineController);
    /** @ngInject */
    function AdmissionOnlineController($location, ApiService, Utils, api, $rootScope, $state) {
        // Data

        var vm = this;
        var param = $location.path();
        var urlresult = param.split("/");
        vm.isParamChecked = false;
        vm.dialogData = {};
        vm.isForm1Visible = true;
        vm.isForm2Visible = false;
        vm.dialogData.school_id = urlresult[2];

        vm.dialogData.course_name = urlresult[3];
        vm.dialogData.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        vm.differentiate = urlresult[4];

        vm.submitted = false;
        vm.submittedCompany = false;
        vm.showHeader = false;
        vm.courseLevel = Focus.ENUMS.COURSE_LEVEL;
        vm.showOtherStudyLocation = false;
        vm.showOtherLessonDuration = false;
        vm.showOtherStudyFrequency = false;
        vm.duplicateStudentEmail = false;
        vm.daysEnums = Focus.ENUMS.RECURRANCE_DAYS;
        vm.courseSkill = '';

        if (vm.differentiate == 'group') {
            vm.courseType = 'G';

        } else {
            vm.courseType = 'P';
        }

        // vm.courseType = 'G';
        vm.dialogData.is_company = 0;
        vm.dialogData.is_renewal = 0;
        vm.dialogData.level = "";
        vm.dialogData.scheduleClassID = "";
        vm.companyData = false;
        vm.companyRequired = false;
        vm.dialogData.contact_person = "";
        vm.dialogData.company_address = "";
        vm.dialogData.company_name = "";
        vm.blankTableMessage = false;
        vm.userTime = false;
        vm.selectStartDate = false;
        vm.selectDay = false;
        vm.selectTime = false;
        vm.servicePolicyError = false;
        vm.groupServicePolicyError = false;
        vm.dialogData.preferred_timings = [];
        vm.dialogData.preferred_days = [];
        vm.otherReq = false;
        vm.levels = [];
        vm.blankLevel = false;
        vm.dialogData.countryName = "Singapore";
        vm.dialogData.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        vm.country = "";
        vm.currency_rate = 1;
        vm.currency_symbol = '$';

        vm.setAuthUrlLink = api.baseURI;

        function init() {
            vm.dialogData.email = "";
            vm.dialogData.full_name = "";
        }

        function getIPDetails() {
            $.ajax({
              url: 'https://api.bigdatacloud.net/data/country-by-ip?localityLanguage=en&key=bdc_ab4884f17a55440d91c407474ebb33f7',
              type: 'GET',
              success: function(json)
              {
                vm.dialogData.countryName = json.country.name;
                vm.country = json;
                getRateConversion(vm.country.country.currency.code);
              },
              error: function(err)
              {
                vm.country = "";
                console.log("Request failed, error= " + err);
              }
            });
        }

        function getRateConversion(code) {
            $.ajax({
              url: 'https://api.exchangerate.host/convert?from=SGD&to=' + code,
              type: 'GET',
              success: function(json)
              {
                vm.currency_rate = json.info.rate;
                vm.currency_symbol = currency_sym(code, 'de-DE');
                // console.log(vm.currency_rate);
              },
              error: function(err)
              {
                vm.currency = "";
                vm.currency_rate = 1;
              }
            });
        }
        function currency_sym(currency, locale) {
          var sym = Intl.NumberFormat(locale, {
                  style: 'currency',
                  currency: currency
                }).formatToParts(1).find(function (x) {
                  return x.type === "currency";
                }).value;
            return sym;
        }

        var i = 0,
            str = "";

        for (i = 0; i < vm.setAuthUrlLink.length - 1; i++) {
            str = str + vm.setAuthUrlLink[i];
        }
        var allowedTime1 = [];

        vm.showForm = function() {
            vm.isForm1Visible = vm.isForm1Visible ? false : true;
            vm.isForm2Visible = vm.isForm2Visible ? false : true;
            var elmnt = document.getElementById("admission");
            elmnt.scrollTop = 0;

        }


        vm.getLogoImage = function() {

            var checkData1 = {
                "name": vm.dialogData.course_name,
                "type": vm.courseType,
                "school_id": vm.dialogData.school_id


            }

            vm.dialogData.allLevels;
            Utils.showLoader(true);
            ApiService.GetCourseLevels1({
                data: checkData1,
                success: function(response) {

                    if (response.status == 0) {
                        Utils.showLoader(false);
                        Utils.showToast({ text: response.data.message, 'type': 0 });
                        vm.courseData = {};
                    } else {
                        Utils.showLoader(false);
                        vm.courseImageData = response.data;
                        if (vm.courseImageData.logo == "" || vm.courseImageData.logo == null) {
                            vm.imgPath = "../images/crystal-learning.png";
                        } else {
                            vm.imgPath = str + vm.courseImageData.logo;
                        }
                        vm.courseSkill = vm.courseImageData.skill;

                        if (typeof $rootScope.admissionIntakeID != 'undefined' && $rootScope.admissionLevel != 'undefined') {
                            vm.dialogData.level = $rootScope.admissionLevel;
                            for (var i = 0; i < vm.courseImageData.levels.length; i++) {
                                if (vm.courseImageData.levels[i].toLowerCase() == $rootScope.admissionLevel.toLowerCase()) {
                                    vm.dialogData.level = vm.courseImageData.levels[i];
                                }
                            }
                            vm.getData();
                            vm.dialogData.scheduleClassID = $rootScope.admissionIntakeID;
                        }

                    }
                }
            })
        }
        vm.getLogoImage();

        vm.CheckPrivateForm = function(form, form2) {
            if (form.$invalid || form2.$invalid) {
                vm.submitted = true;
                if (vm.dialogData.is_company == 1) {
                    if (form2.$invalid) {
                        vm.submittedCompany = true;
                        return;
                    } else
                        vm.submittedCompany = true;
                } else {
                    vm.submittedCompany = false;
                }
                return;
            } else {
                vm.submitted = false;
            }

            vm.showForm();
        }

        vm.disable1 = function() {

            if (vm.dialogData.level == "") {
                vm.blankLevel = true;
            } else {
                var data = vm.courseData.length;
                vm.blankLevel = false;
            }

            if (vm.dialogData.level != "" && vm.dialogData.scheduleClassID != "") {

                vm.showForm();
            }



            if (vm.dialogData.level != "" && data == null) {
                vm.selectStartDate = false;
                return;
            }

            if (vm.dialogData.level != "" && vm.dialogData.scheduleClassID == "") {
                vm.selectStartDate = true;
                return;
            }

        }

        vm.selectCourse = function() {
            vm.selectStartDate = false;
        }
        vm.getData = function() {


            if (vm.dialogData.level == "") {
                vm.blankLevel = true;
            } else {
                vm.blankLevel = false;
            }

            vm.dialogData.scheduleClassID = "";
            vm.selectStartDate = false;

            var checkData = {
                "name": vm.dialogData.course_name,
                "type": vm.courseType,
                "school_id": vm.dialogData.school_id,
                "level": vm.dialogData.level,
                "timezone" : Intl.DateTimeFormat().resolvedOptions().timeZone,
            }

            Utils.showLoader(true);
            ApiService.GetGroupIntakes({
                data: checkData,
                success: function(response) {

                    if (response.status == 0) {
                        Utils.showLoader(false);
                        Utils.showToast({ text: response.data.message, 'type': 0 });
                        vm.courseData = {};
                    } else {
                        Utils.showLoader(false);
                        vm.courseData = response.data;
                        // vm.courseData.sort((a,b) => (a.intake_term > b.intake_term) ? 1 : ((b.intake_term > a.intake_term) ? -1 : 0)); 
                        vm.courseData = _.sortBy(vm.courseData, 'intake_term');
                        for (var i = 0; i < vm.courseData.length; i++) {
                            vm.courseData[i].courseCost = (parseFloat(vm.courseData[i].course_price) * (parseFloat(vm.courseData[i].course_duration) * parseFloat(vm.courseData[i].course_no_of_classes)));
                            vm.courseData[i].courseTax = ((parseFloat(vm.courseData[i].courseCost) + parseFloat(vm.courseData[i].course_admin_fee)) * 9) /100;
                            vm.courseData[i].courseTotalCost = parseFloat(vm.courseData[i].courseTax) + parseFloat(vm.courseData[i].courseCost) + parseFloat(vm.courseData[i].course_admin_fee);
                            vm.courseData[i].classDays = '';
                            if (vm.courseData[i].weekdays == null) {
                                vm.courseData[i].classDays = 'Daily'
                            } else {
                                vm.courseData[i].weekdays = vm.courseData[i].weekdays.split(',');
                                if (vm.courseData[i].weekdays.length == 1) {
                                    vm.courseData[i].classDays = vm.courseData[i].classDays + vm.daysEnums[parseInt(vm.courseData[i].weekdays[0])].day;
                                } else {
                                    for (var j = 0; j < vm.courseData[i].weekdays.length; j++) {
                                        if ((j + 1) == vm.courseData[i].weekdays.length) {
                                            vm.courseData[i].classDays = vm.courseData[i].classDays + vm.daysEnums[parseInt(vm.courseData[i].weekdays[j])].day;
                                        } else {
                                            vm.courseData[i].classDays = vm.courseData[i].classDays + vm.daysEnums[parseInt(vm.courseData[i].weekdays[j])].day + ', ';
                                        }
                                    }
                                }
                            }

                        }
                        if (typeof $rootScope.admissionIntakeID != 'undefined' && $rootScope.admissionLevel != 'undefined') {
                            vm.dialogData.scheduleClassID = $rootScope.admissionIntakeID;
                            vm.disable1();
                        }
                    }

                    if (vm.courseData.length >= 1) {
                        vm.blankTableMessage = false;
                    } else {
                        vm.blankTableMessage = true;

                    }

                }
            })

        };

        vm.onChangeRenewal = function() {

            if (vm.is_renewal == true) {
                vm.dialogData.is_renewal = 1;
            } else {
                vm.dialogData.is_renewal = 0;
            }
        }


        vm.onChangeCompany = function() {
            vm.companyData = vm.companyData ? false : true;
            if (vm.is_company == true) {
                vm.dialogData.is_company = 1;
                //                vm.submittedCompany = false;
                vm.companyRequired = true;
            } else {

                vm.dialogData.is_company = 0;
                vm.companyRequired = false;
                vm.submittedCompany = false;
                vm.dialogData.company_name = "";
                vm.dialogData.company_address = "";
                vm.dialogData.contact_person = "";

            }
        }
        vm.days = [
            { id: 0, day: 'Monday', bAllow: false },
            { id: 1, day: 'Tuesday', bAllow: false },
            { id: 2, day: 'Wednesday', bAllow: false },
            { id: 3, day: 'Thursday', bAllow: false },
            { id: 4, day: 'Friday', bAllow: false },
            { id: 5, day: 'Saturday', bAllow: false },
            { id: 6, day: 'Sunday', bAllow: false }

        ];

        vm.timeslot1 = [
            { id: 0, time: '8.00 am', bAllow: false },
            { id: 1, time: '10.00 am', bAllow: false },
            { id: 2, time: '12.00 pm', bAllow: false },
            { id: 3, time: '2.00 pm', bAllow: false },
            { id: 4, time: '4.00 pm', bAllow: false },
            { id: 5, time: '6.00 pm', bAllow: false },
            { id: 6, time: '8.00 pm', bAllow: false },
            { id: 7, time: 'Others', bAllow: false }
        ];

        vm.timeslot2 = [

            { id: 0, time: '8.15 am', bAllow: false },
            { id: 1, time: '8.30 am', bAllow: false },
            { id: 2, time: '8.45 am', bAllow: false },
            { id: 3, time: '9.00 am', bAllow: false },
            { id: 4, time: '9.15 am', bAllow: false },
            { id: 5, time: '9.30 am', bAllow: false },
            { id: 6, time: '9.45 am', bAllow: false },
            { id: 7, time: '10.15 am', bAllow: false },
            { id: 8, time: '10.30 am', bAllow: false },
            { id: 9, time: '10.45 am', bAllow: false },
            { id: 10, time: '11.00 am', bAllow: false },
            { id: 11, time: '11.15 am', bAllow: false },
            { id: 12, time: '11.30 am', bAllow: false },
            { id: 13, time: '11.45 am', bAllow: false },
            { id: 14, time: '12.15 pm', bAllow: false },
            { id: 15, time: '12.30 pm', bAllow: false },
            { id: 16, time: '12.45 pm', bAllow: false },
            { id: 17, time: '1.00 pm', bAllow: false },
            { id: 18, time: '1.15 pm', bAllow: false },
            { id: 19, time: '1.30 pm', bAllow: false },
            { id: 20, time: '1.45 pm', bAllow: false },
            { id: 21, time: '2.15 pm', bAllow: false },
            { id: 22, time: '2.30 pm', bAllow: false },
            { id: 23, time: '2.45 pm', bAllow: false },
            { id: 24, time: '3.00 pm', bAllow: false },
            { id: 25, time: '3.15 pm', bAllow: false },
            { id: 26, time: '3.30 pm', bAllow: false },
            { id: 27, time: '3.45 pm', bAllow: false },
            { id: 28, time: '4.15 pm', bAllow: false },
            { id: 29, time: '4.30 pm', bAllow: false },
            { id: 30, time: '4.45 pm', bAllow: false },
            { id: 31, time: '5.00 pm', bAllow: false },
            { id: 32, time: '5.15 pm', bAllow: false },
            { id: 33, time: '5.30 pm', bAllow: false },
            { id: 34, time: '5.45 pm', bAllow: false },
            { id: 35, time: '6.15 pm', bAllow: false },
            { id: 36, time: '6.30 pm', bAllow: false },
            { id: 37, time: '6.45 pm', bAllow: false },
            { id: 38, time: '7.00 pm', bAllow: false },
            { id: 39, time: '7.15 pm', bAllow: false },
            { id: 40, time: '7.30 pm', bAllow: false },
            { id: 41, time: '7.45 pm', bAllow: false }

        ];

        vm.arrLessonDuration = [
            { id: 0, duration: '1 hours' },
            { id: 1, duration: '2.5 hours' },
            { id: 2, duration: '3 hours' }
        ];

        vm.arrStudyFrequency = [
            { id: 0, frequency: '3x per week' },
            { id: 1, frequency: '4x per week' },
            { id: 2, frequency: '5x per week' }
        ];

        vm.checkCheckboxLength = function(form, form2, form3) {
            if (form.$invalid || form2.$invalid || form3.$invalid) {
                vm.submitted = true;
            } else {
                vm.submitted = false;
            }

            if (vm.timeslot1[7].bAllow === true) {
                if (vm.timepicker != null) {
                    vm.otherReq = false;


                    var i = 0;
                    for (i = 0; i < vm.timepicker.length; i++) {
                        vm.dialogData.preferred_timings.push(vm.timepicker[i]);
                    }
                    vm.submitPrivateForm();
                } else {
                    vm.otherReq = true;
                }
            } else {
                vm.submitPrivateForm();
            }
        }

        vm.checkOtherTime = function(e) {
            if (vm.timepicker != null) {
                vm.otherReq = false;
            } else {
                vm.otherReq = true;
            }
        }

        vm.submitPrivateForm = function() {

            if ((vm.dialogData.preferred_timings.length >= 1) && (vm.dialogData.preferred_days.length) && (vm.dialogData.service_policy == true)) {
                vm.selectDay = false;
                vm.selectTime = false;
                vm.servicePolicyError = false;
                vm.dialogData.lesson_duration = [];
                vm.dialogData.study_frequency = [];
                vm.dialogData.no_of_students = vm.dialogData.no_of_students;
                vm.dialogData.courseSkill = vm.courseSkill;

                if (vm.studyLocation == "Others") {
                    vm.dialogData.study_location = vm.otherStudyLocation;
                } else {
                    vm.dialogData.study_location = vm.studyLocation;
                }

                if (vm.lessonDuration == "Others") {
                    for (i = 0; i < vm.otherLessonDuration.length; i++) {
                        vm.dialogData.lesson_duration.push(vm.otherLessonDuration[i]);
                    }
                } else {
                    vm.dialogData.lesson_duration.push(vm.lessonDuration);
                }

                if (vm.studyFrequency == "Others") {
                    for (i = 0; i < vm.otherStudyFrequency.length; i++) {
                        vm.dialogData.study_frequency.push(vm.otherStudyFrequency[i]);
                    }
                } else {
                    vm.dialogData.study_frequency.push(vm.studyFrequency);
                }

                Utils.showLoader(true);
                if (vm.courseType == 'P') {
                    ApiService.AddPrivateApplication({
                        data: vm.dialogData,
                        success: function(response) {

                            if (response.status === 0) {
                                Utils.showLoader(false);
                                Utils.showToast({ text: response.data.message, 'type': 0 });
                            } else {
                                Utils.showLoader(false);
                                var skill = response.data.message;
                                if (skill == "Bahasa Indonesia") {
                                    $state.go('app.pages_auth_indoslang-thank-you');
                                    // window.location = "https://indoslang.com.sg/class-sign-up-thank-you/";
                                } else if (skill == "Korean") {
                                    $state.go('app.pages_auth_hana-thank-you');
                                    // window.location = "https://yimandarin.com.sg/yi-class-sign-up-thank-you/";
                                } else if (skill == "Business Mandarin" || skill == "Mandarin") {
                                    $state.go('app.pages_auth_yiman-thank-you');
                                    // window.location = "https://yimandarin.com.sg/yi-class-sign-up-thank-you/";
                                } else if (skill == "English") {
                                    $state.go('app.pages_auth_english-express-thank-you');
                                    // window.location = "https://www.englishexpress.com.sg/ee-class-sign-up-thank-you/";
                                } else {
                                    $location.path("/thank-you");
                                    // window.location = "/thank-you";
                                }
                            }
                        }
                    });
                }
            } else {
                vm.selectDay = false;
                vm.selectTime = false;
                vm.servicePolicyError = false;

                if (vm.dialogData.preferred_days.length == 0) {
                    vm.selectDay = true;
                }
                if (vm.dialogData.preferred_timings.length == 0) {
                    vm.selectTime = true;
                }
                if (vm.dialogData.servicePolicy != true) {
                    vm.servicePolicyError = true;
                }
            }
        }

        vm.ToggleCheckbox = function(e, value) {

            vm.onChangeCheckBox = true;
            var arrDays = vm.days;
            var allowedDays = [];
            for (var i = 0; i < arrDays.length; i++) {
                if (arrDays[i].bAllow === true) {

                    allowedDays.push(arrDays[i].day);
                    //vm.dialogData.preferred_days = allowedDays ;
                }
            }
            vm.dialogData.preferred_days = allowedDays;

        }


        vm.ToggleTime1Checkbox = function(e, value) {


            vm.onChangeCheckBox1 = true;

            var arrTime1 = vm.timeslot1;

            if (arrTime1[7].bAllow === true) {
                vm.userTime = true;
                return;
            } else {
                vm.userTime = false;
                allowedTime1 = [];
                for (var i = 0; i < arrTime1.length; i++) {
                    if (arrTime1[i].bAllow === true) {

                        if (i != 10)
                            allowedTime1.push(arrTime1[i].time);
                        //        vm.dialogData.preferred_timings = allowedTime1 ;
                    }
                }

                vm.dialogData.preferred_timings = allowedTime1;
            }



        }
        vm.addRecord = function(form, form2) {

            if (vm.dialogData.group_service_policy != true) {
                vm.groupServicePolicyError = true;

            } else {
                vm.groupServicePolicyError = false;
            }

            if (form.$invalid || form2.$invalid || vm.duplicateStudentEmail) {
                vm.submitted = true;
                if (vm.dialogData.is_company == 1) {
                    if (form2.$invalid) {
                        vm.submittedCompany = true;

                        return;
                    } else
                        vm.submittedCompany = true;
                } else {
                    vm.submittedCompany = false;
                }
                return;
            }



            //here we will have the new data to be saved.
            vm.dialogData;

            if (vm.courseType == 'G') {
                if (vm.groupServicePolicyError == false && vm.submittedCompany == false) {
                    Utils.showLoader(true);
                    ApiService.AddGroupApplication({
                        data: vm.dialogData,
                        success: function(response) {
                            //                            console.log(response);
                            if (response.status === 0) {
                                Utils.showLoader(false);
                                Utils.showToast({ text: response.data.message, 'type': 0 });
                            } else {
                                Utils.showLoader(false);
                                //                                 window.location = "/thank-you";
                                var skill = response.data.message;

                                if (skill == "Bahasa Indonesia") {
                                    $state.go('app.pages_auth_indoslang-thank-you');
                                    // window.location = "https://indoslang.com.sg/class-sign-up-thank-you/";
                                } else if (skill == "Business Mandarin" || skill == "Mandarin") {
                                    $state.go('app.pages_auth_yiman-thank-you');
                                    // window.location = "https://yimandarin.com.sg/yi-class-sign-up-thank-you/";
                                } else if (skill == "Korean") {
                                    $state.go('app.pages_auth_hana-thank-you');
                                    // window.location = "https://yimandarin.com.sg/yi-class-sign-up-thank-you/";
                                } else if (skill == "English") {
                                    $state.go('app.pages_auth_english-express-thank-you');
                                    // window.location = "https://www.englishexpress.com.sg/ee-class-sign-up-thank-you/";
                                } else {
                                    $location.path("/thank-you");
                                    // window.location = "/thank-you";
                                }
                            }
                        }
                    });
                }
            }
            if (vm.courseType == 'P') {
                ApiService.AddPrivateApplication({
                    data: vm.dialogData,
                    success: function(response) {
                        if (response.status === 0) {
                            Utils.showLoader(false);
                            Utils.showToast({ text: response.data.message, 'type': 0 });
                        } else {

                            Utils.showLoader(false);
                            var skill = response.data.message;
                            if (skill == "Bahasa Indonesia") {
                                $state.go('app.pages_auth_indoslang-thank-you');
                                // window.location = "https://indoslang.com.sg/class-sign-up-thank-you/";
                            } else if (skill == "Korean") {
                                $state.go('app.pages_auth_hana-thank-you');
                                // window.location = "https://yimandarin.com.sg/yi-class-sign-up-thank-you/";
                            } else if (skill == "Business Mandarin" || skill == "Mandarin") {
                                $state.go('app.pages_auth_yiman-thank-you');
                                // window.location = "https://yimandarin.com.sg/yi-class-sign-up-thank-you/";
                            } else if (skill == "English") {
                                $state.go('app.pages_auth_english-express-thank-you');
                                // window.location = "https://www.englishexpress.com.sg/ee-class-sign-up-thank-you/";
                            } else {
                                $location.path("/thank-you");
                                // window.location = "/thank-you";
                            }
                        }
                    }
                });
            }
        }
        vm.onEmailChange = function(email, el) {
            if (vm.dialogData.email == '' || vm.dialogData.full_name == '') {
                return;
            } else if (validateEmail(vm.dialogData.email) == false) {
                return;
            }
            Utils.showLoader(true);
            ApiService.CheckDuplicateEmailForStudentEnrolment({
                bSkipAuth: true,
                data: {
                    'school_id': vm.dialogData.school_id,
                    'scheduleClassID': vm.dialogData.scheduleClassID,
                    'email': vm.dialogData.email,
                    'fullName': vm.dialogData.full_name,
                },
                success: function(response) {
                    Utils.showLoader(false);
                    if (response.status == 0) {
                        Utils.showToast({ text: response.data.message, 'type': 0 });
                        vm.duplicateStudentEmail = true;
                    }
                }
            });
        }

        function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }
        //study location
        vm.onChangeStudyLocation = function() {
            if (vm.studyLocation === "Others") {
                vm.showOtherStudyLocation = true;
            } else {
                vm.showOtherStudyLocation = false;
                vm.otherStudyLocation = "";
            }
        }

        //lesson duration
        vm.onChangeLessonDuration = function() {
            if (vm.lessonDuration === "Others") {
                vm.showOtherLessonDuration = true;
            } else {
                vm.showOtherLessonDuration = false;
                vm.otherLessonDuration = "";
            }
        }


        //study frequency

        vm.onChangeStudyFrequency = function() {
            if (vm.studyFrequency === "Others") {
                vm.showOtherStudyFrequency = true;
            } else {
                vm.showOtherStudyFrequency = false;
                vm.otherStudyFrequency = "";
            }
        }
        init();
    }
})();
(function()
{
    'use strict';
    angular
            .module('app.pages.auth.admission', ['ipCookie','moment-picker'])
            .config(config);
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, $urlRouterProvider)
    {
//        var url = $location.search();
//        console(url)

        $stateProvider.state('app.pages_auth_admission', {
            // url: '/admissions',
            url: '/admissions/:id/:courseName/:courseType',
            //   controller: function($stateParams) {
            //     console.log($stateParams.id + $stateParams.courseName);
            // },
            //     params: { id: { value: id } ,
            //     courseName: { value: courseName } ,
            //     courseType: { value: courseType } 

            // },
//            params: {
////                id: {value: :id},
////                courseName: {value: ':courseName'},
////                courseType: {value: ':courseType'}
//
//            },
//         params: {
//                id: null,
//                courseName: null,
//                courseType: null
//
//            },
            //  params: {
            //     id: {squash: true, value: },
            //     courseName: {squash: true, value: null},
            //     courseType: {squash: true, value: null},
            // },
            // url: '/admissions/1/conversational mandarin/group',
            // $routeParams ==> {id:id, courseName:courseName, courseType:courseType}
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.pages_auth_admission': {
                    templateUrl: 'app/main/pages/auth/admission/admission.html',
                    controller: 'AdmissionController as vm'
                }
            },
            controller: function($stateParams) {
                $stateParams.id //*** Watch Out! DOESN'T EXIST!! ***//
                $stateParams.courseName //*** Exists! ***//  
                $stateParams.courseType
            },
            resolve: {
                id: ['$stateParams', function($stateParams) {
                        return $stateParams.id;
                    }],
                courseName: ['$stateParams', function($stateParams) {
                        return $stateParams.courseName;
                    }],
                courseType: ['$stateParams', function($stateParams) {
                        return $stateParams.courseType;
                    }],
            },
            // resolve: {
            //     'CurrentItemID': ['$stateParams',function ($stateParams) {
            //         return $stateParams['id'];
            //     }]
            // },
            data: {
                bAllow: 'true'
            },
            // bAllow: 'true',
            bodyClass: 'admission'
        });
//         $rootScope.$on('$routeChangeStart', function(){ 
//    console.log($route.current); 
// });
        // $urlRouterProvider.when('/admissions/:id/:courseName/:courseType',{
        //     templateUrl:'app/main/pages/auth/admission/admission.html',
        //     controller:'AdmissionController as vm',
        //     publicAccess:true,
        //     sessionAccess:true
        // })

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/admission');
    }


})();
(function() {
    'use strict';
    angular
        .module('app.pages.auth.admission')
        .controller('AdmissionController', AdmissionController);
    /** @ngInject */
    function AdmissionController($location, ApiService, Utils, api, $rootScope, $state) {
        // Data

        var vm = this;
        var param = $location.path();
        var urlresult = param.split("/");
        vm.isParamChecked = false;
        vm.dialogData = {};
        vm.isForm1Visible = true;
        vm.isForm2Visible = false;
        vm.dialogData.school_id = urlresult[2];
        vm.dialogData.contact_number = '+65';
        vm.dialogData.course_name = urlresult[3];

        vm.differentiate = urlresult[4];

        vm.submitted = false;
        vm.submittedCompany = false;
        vm.showHeader = false;
        vm.courseLevel = Focus.ENUMS.COURSE_LEVEL;
        vm.showOtherStudyLocation = false;
        vm.showOtherLessonDuration = false;
        vm.showOtherStudyFrequency = false;
        vm.duplicateStudentEmail = false;
        vm.daysEnums = Focus.ENUMS.RECURRANCE_DAYS;
        vm.courseSkill = '';

        if (vm.differentiate == 'group') {
            vm.courseType = 'G';

        } else if (vm.differentiate == 'online') {
            vm.courseType = 'O';

        } else {
            vm.courseType = 'P';
        }

        vm.dialogData.is_company = 0;
        vm.dialogData.is_renewal = 0;
        vm.dialogData.level = "";
        vm.dialogData.scheduleClassID = "";
        vm.companyData = false;
        vm.companyRequired = false;
        vm.dialogData.contact_person = "";
        vm.dialogData.company_address = "";
        vm.dialogData.company_name = "";
        vm.blankTableMessage = false;
        vm.userTime = false;
        vm.selectStartDate = false;
        vm.selectDay = false;
        vm.selectTime = false;
        vm.servicePolicyError = false;
        vm.groupServicePolicyError = false;
        vm.dialogData.preferred_timings = [];
        vm.dialogData.preferred_days = [];
        vm.otherReq = false;
        vm.levels = [];
        vm.blankLevel = false;
        vm.dialogData.countryName = "Singapore";
        vm.dialogData.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        vm.country = "";
        vm.currency_rate = 1;
        vm.currency_symbol = '$';
        vm.setAuthUrlLink = api.baseURI;

        function init() {
            vm.dialogData.email = "";
            vm.dialogData.full_name = "";
            getIPDetails();
        }
        function getIPDetails() {
            $.ajax({
              url: 'https://api.bigdatacloud.net/data/country-by-ip?localityLanguage=en&key=bdc_ab4884f17a55440d91c407474ebb33f7',
              type: 'GET',
              success: function(json)
              {
                vm.dialogData.countryName = json.country.name;
                vm.country = json;
                getRateConversion(vm.country.country.currency.code);
              },
              error: function(err)
              {
                vm.country = "";
                console.log("Request failed, error= " + err);
              }
            });
        }

        function getRateConversion(code) {
            $.ajax({
              url: 'https://api.exchangerate.host/convert?from=SGD&to=' + code,
              type: 'GET',
              success: function(json)
              {
                vm.currency_rate = json.info.rate;
                vm.currency_symbol = currency_sym(code, 'de-DE');
                // console.log(vm.currency_rate);
              },
              error: function(err)
              {
                vm.currency = "";
                vm.currency_rate = 1;
              }
            });
        }
        function currency_sym(currency, locale) {
          var sym = Intl.NumberFormat(locale, {
                  style: 'currency',
                  currency: currency
                }).formatToParts(1).find(function (x) {
                  return x.type === "currency";
                }).value;
            return sym;
        }

        var i = 0,
            str = "";

        for (i = 0; i < vm.setAuthUrlLink.length - 1; i++) {
            str = str + vm.setAuthUrlLink[i];
        }
        var allowedTime1 = [];

        vm.showForm = function() {
            vm.isForm1Visible = vm.isForm1Visible ? false : true;
            vm.isForm2Visible = vm.isForm2Visible ? false : true;
            var elmnt = document.getElementById("admission");
            elmnt.scrollTop = 0;

        }


        vm.getLogoImage = function() {

            var checkData1 = {
                "name": vm.dialogData.course_name,
                "type": vm.courseType,
                "school_id": vm.dialogData.school_id


            }

            vm.dialogData.allLevels;
            Utils.showLoader(true);
            ApiService.GetCourseLevels1({
                data: checkData1,
                success: function(response) {

                    if (response.status == 0) {
                        Utils.showLoader(false);
                        Utils.showToast({ text: response.data.message, 'type': 0 });
                        vm.courseData = {};
                    } else {
                        Utils.showLoader(false);
                        vm.courseImageData = response.data;
                        if (vm.courseImageData.logo == "" || vm.courseImageData.logo == null) {
                            vm.imgPath = "../images/crystal-learning.png";
                        } else {
                            vm.imgPath = str + vm.courseImageData.logo;
                        }
                        vm.courseSkill = vm.courseImageData.skill;

                        if (typeof $rootScope.admissionIntakeID != 'undefined' && $rootScope.admissionLevel != 'undefined') {
                            vm.dialogData.level = $rootScope.admissionLevel;
                            for (var i = 0; i < vm.courseImageData.levels.length; i++) {
                                if (vm.courseImageData.levels[i].toLowerCase() == $rootScope.admissionLevel.toLowerCase()) {
                                    vm.dialogData.level = vm.courseImageData.levels[i];
                                }
                            }
                            vm.getData();
                            vm.dialogData.scheduleClassID = $rootScope.admissionIntakeID;
                        }

                    }
                }
            })
        }
        vm.getLogoImage();

        vm.CheckPrivateForm = function(form, form2) {
            if (form.$invalid || form2.$invalid) {
                vm.submitted = true;
                if (vm.dialogData.is_company == 1) {
                    if (form2.$invalid) {
                        vm.submittedCompany = true;
                        return;
                    } else
                        vm.submittedCompany = true;
                } else {
                    vm.submittedCompany = false;
                }
                return;
            } else {
                vm.submitted = false;
            }

            vm.showForm();
        }

        vm.disable1 = function() {

            if (vm.dialogData.level == "") {
                vm.blankLevel = true;
            } else {
                var data = vm.courseData.length;
                vm.blankLevel = false;
            }

            if (vm.dialogData.level != "" && vm.dialogData.scheduleClassID != "") {

                vm.showForm();
            }
            if (vm.dialogData.level != "" && data == null) {
                vm.selectStartDate = false;
                return;
            }
            if (vm.dialogData.level != "" && vm.dialogData.scheduleClassID == "") {
                vm.selectStartDate = true;
                return;
            }

        }

        vm.selectCourse = function() {
            vm.selectStartDate = false;
        }
        vm.getData = function() {


            if (vm.dialogData.level == "") {
                vm.blankLevel = true;
            } else {
                vm.blankLevel = false;
            }

            vm.dialogData.scheduleClassID = "";
            vm.selectStartDate = false;

            var checkData = {
                "name": vm.dialogData.course_name,
                "type": vm.courseType,
                "school_id": vm.dialogData.school_id,
                "level": vm.dialogData.level,
                "timezone" : Intl.DateTimeFormat().resolvedOptions().timeZone,
            }

            Utils.showLoader(true);
            ApiService.GetGroupIntakes({
                data: checkData,
                success: function(response) {

                    if (response.status == 0) {
                        Utils.showLoader(false);
                        Utils.showToast({ text: response.data.message, 'type': 0 });
                        vm.courseData = {};
                    } else {
                        Utils.showLoader(false);
                        vm.courseData = response.data;
                        // vm.courseData.sort((a,b) => (a.intake_term > b.intake_term) ? 1 : ((b.intake_term > a.intake_term) ? -1 : 0)); 
                        vm.courseData = _.sortBy(vm.courseData, 'intake_term');
                        for (var i = 0; i < vm.courseData.length; i++) {
                            vm.courseData[i].courseCost = (parseFloat(vm.courseData[i].course_price) * (parseFloat(vm.courseData[i].course_duration) * parseFloat(vm.courseData[i].course_no_of_classes)));
                            vm.courseData[i].courseTax = ((parseFloat(vm.courseData[i].courseCost) + parseFloat(vm.courseData[i].course_admin_fee)) * 9) /100;
                            vm.courseData[i].courseTotalCost = parseFloat(vm.courseData[i].courseTax) + parseFloat(vm.courseData[i].courseCost) + parseFloat(vm.courseData[i].course_admin_fee);
                            vm.courseData[i].classDays = '';
                            if (vm.courseData[i].weekdays == null) {
                                vm.courseData[i].classDays = 'Daily'
                            } else {
                                vm.courseData[i].weekdays = vm.courseData[i].weekdays.split(',');
                                if (vm.courseData[i].weekdays.length == 1) {
                                    vm.courseData[i].classDays = vm.courseData[i].classDays + vm.daysEnums[parseInt(vm.courseData[i].weekdays[0])].day;
                                } else {
                                    for (var j = 0; j < vm.courseData[i].weekdays.length; j++) {
                                        if ((j + 1) == vm.courseData[i].weekdays.length) {
                                            vm.courseData[i].classDays = vm.courseData[i].classDays + vm.daysEnums[parseInt(vm.courseData[i].weekdays[j])].day;
                                        } else {
                                            vm.courseData[i].classDays = vm.courseData[i].classDays + vm.daysEnums[parseInt(vm.courseData[i].weekdays[j])].day + ', ';
                                        }
                                    }
                                }
                            }

                        }
                        if (typeof $rootScope.admissionIntakeID != 'undefined' && $rootScope.admissionLevel != 'undefined') {
                            vm.dialogData.scheduleClassID = $rootScope.admissionIntakeID;
                            vm.disable1();
                        }
                    }

                    if (vm.courseData.length >= 1) {
                        vm.blankTableMessage = false;
                    } else {
                        vm.blankTableMessage = true;

                    }

                }
            })

        };

        vm.onChangeRenewal = function() {

            if (vm.is_renewal == true) {
                vm.dialogData.is_renewal = 1;
            } else {
                vm.dialogData.is_renewal = 0;
            }
        }


        vm.onChangeCompany = function() {
            vm.companyData = vm.companyData ? false : true;
            if (vm.is_company == true) {
                vm.dialogData.is_company = 1;
                //                vm.submittedCompany = false;
                vm.companyRequired = true;
            } else {

                vm.dialogData.is_company = 0;
                vm.companyRequired = false;
                vm.submittedCompany = false;
                vm.dialogData.company_name = "";
                vm.dialogData.company_address = "";
                vm.dialogData.contact_person = "";

            }
        }
        vm.days = [
            { id: 0, day: 'Monday', bAllow: false },
            { id: 1, day: 'Tuesday', bAllow: false },
            { id: 2, day: 'Wednesday', bAllow: false },
            { id: 3, day: 'Thursday', bAllow: false },
            { id: 4, day: 'Friday', bAllow: false },
            { id: 5, day: 'Saturday', bAllow: false },
            { id: 6, day: 'Sunday', bAllow: false }

        ];

        vm.timeslot1 = [
            { id: 0, time: '8.00 am', bAllow: false },
            { id: 1, time: '10.00 am', bAllow: false },
            { id: 2, time: '12.00 pm', bAllow: false },
            { id: 3, time: '2.00 pm', bAllow: false },
            { id: 4, time: '4.00 pm', bAllow: false },
            { id: 5, time: '6.00 pm', bAllow: false },
            { id: 6, time: '8.00 pm', bAllow: false },
            { id: 7, time: 'Others', bAllow: false }
        ];

        vm.timeslot2 = [

            { id: 0, time: '8.15 am', bAllow: false },
            { id: 1, time: '8.30 am', bAllow: false },
            { id: 2, time: '8.45 am', bAllow: false },
            { id: 3, time: '9.00 am', bAllow: false },
            { id: 4, time: '9.15 am', bAllow: false },
            { id: 5, time: '9.30 am', bAllow: false },
            { id: 6, time: '9.45 am', bAllow: false },
            { id: 7, time: '10.15 am', bAllow: false },
            { id: 8, time: '10.30 am', bAllow: false },
            { id: 9, time: '10.45 am', bAllow: false },
            { id: 10, time: '11.00 am', bAllow: false },
            { id: 11, time: '11.15 am', bAllow: false },
            { id: 12, time: '11.30 am', bAllow: false },
            { id: 13, time: '11.45 am', bAllow: false },
            { id: 14, time: '12.15 pm', bAllow: false },
            { id: 15, time: '12.30 pm', bAllow: false },
            { id: 16, time: '12.45 pm', bAllow: false },
            { id: 17, time: '1.00 pm', bAllow: false },
            { id: 18, time: '1.15 pm', bAllow: false },
            { id: 19, time: '1.30 pm', bAllow: false },
            { id: 20, time: '1.45 pm', bAllow: false },
            { id: 21, time: '2.15 pm', bAllow: false },
            { id: 22, time: '2.30 pm', bAllow: false },
            { id: 23, time: '2.45 pm', bAllow: false },
            { id: 24, time: '3.00 pm', bAllow: false },
            { id: 25, time: '3.15 pm', bAllow: false },
            { id: 26, time: '3.30 pm', bAllow: false },
            { id: 27, time: '3.45 pm', bAllow: false },
            { id: 28, time: '4.15 pm', bAllow: false },
            { id: 29, time: '4.30 pm', bAllow: false },
            { id: 30, time: '4.45 pm', bAllow: false },
            { id: 31, time: '5.00 pm', bAllow: false },
            { id: 32, time: '5.15 pm', bAllow: false },
            { id: 33, time: '5.30 pm', bAllow: false },
            { id: 34, time: '5.45 pm', bAllow: false },
            { id: 35, time: '6.15 pm', bAllow: false },
            { id: 36, time: '6.30 pm', bAllow: false },
            { id: 37, time: '6.45 pm', bAllow: false },
            { id: 38, time: '7.00 pm', bAllow: false },
            { id: 39, time: '7.15 pm', bAllow: false },
            { id: 40, time: '7.30 pm', bAllow: false },
            { id: 41, time: '7.45 pm', bAllow: false }

        ];

        vm.arrLessonDuration = [
            { id: 0, duration: '1 hours' },
            { id: 1, duration: '2.5 hours' },
            { id: 2, duration: '3 hours' }
        ];

        vm.arrStudyFrequency = [
            { id: 0, frequency: '3x per week' },
            { id: 1, frequency: '4x per week' },
            { id: 2, frequency: '5x per week' }
        ];

        vm.checkCheckboxLength = function(form, form2, form3) {
            if (form.$invalid || form2.$invalid || form3.$invalid) {
                vm.submitted = true;
            } else {
                vm.submitted = false;
            }

            if (vm.timeslot1[7].bAllow === true) {
                if (vm.timepicker != null) {
                    vm.otherReq = false;


                    var i = 0;
                    for (i = 0; i < vm.timepicker.length; i++) {
                        vm.dialogData.preferred_timings.push(vm.timepicker[i]);
                    }
                    vm.submitPrivateForm();
                } else {
                    vm.otherReq = true;
                }
            } else {
                vm.submitPrivateForm();
            }
        }

        vm.checkOtherTime = function(e) {
            if (vm.timepicker != null) {
                vm.otherReq = false;
            } else {
                vm.otherReq = true;
            }
        }

        vm.submitPrivateForm = function() {

            if ((vm.dialogData.preferred_timings.length >= 1) && (vm.dialogData.preferred_days.length) && (vm.dialogData.service_policy == true)) {
                vm.selectDay = false;
                vm.selectTime = false;
                vm.servicePolicyError = false;
                vm.dialogData.lesson_duration = [];
                vm.dialogData.study_frequency = [];
                vm.dialogData.no_of_students = vm.dialogData.no_of_students;
                vm.dialogData.courseSkill = vm.courseSkill;

                if (vm.studyLocation == "Others") {
                    vm.dialogData.study_location = vm.otherStudyLocation;
                } else {
                    vm.dialogData.study_location = vm.studyLocation;
                }

                if (vm.lessonDuration == "Others") {
                    for (i = 0; i < vm.otherLessonDuration.length; i++) {
                        vm.dialogData.lesson_duration.push(vm.otherLessonDuration[i]);
                    }
                } else {
                    vm.dialogData.lesson_duration.push(vm.lessonDuration);
                }

                if (vm.studyFrequency == "Others") {
                    for (i = 0; i < vm.otherStudyFrequency.length; i++) {
                        vm.dialogData.study_frequency.push(vm.otherStudyFrequency[i]);
                    }
                } else {
                    vm.dialogData.study_frequency.push(vm.studyFrequency);
                }

                Utils.showLoader(true);
                if (vm.courseType == 'P') {
                    ApiService.AddPrivateApplication({
                        data: vm.dialogData,
                        success: function(response) {

                            if (response.status === 0) {
                                Utils.showLoader(false);
                                Utils.showToast({ text: response.data.message, 'type': 0 });
                            } else {
                                Utils.showLoader(false);
                                var skill = response.data.message;
                                if (skill == "Bahasa Indonesia") {
                                    $state.go('app.pages_auth_indoslang-thank-you');
                                    // window.location = "https://indoslang.com.sg/class-sign-up-thank-you/";
                                } else if (skill == "Korean") {
                                    $state.go('app.pages_auth_hana-thank-you');
                                    // window.location = "https://yimandarin.com.sg/yi-class-sign-up-thank-you/";
                                } else if (skill == "Business Mandarin" || skill == "Mandarin") {
                                    $state.go('app.pages_auth_yiman-thank-you');
                                    // window.location = "https://yimandarin.com.sg/yi-class-sign-up-thank-you/";
                                } else if (skill == "English") {
                                    $state.go('app.pages_auth_english-express-thank-you');
                                    // window.location = "https://www.englishexpress.com.sg/ee-class-sign-up-thank-you/";
                                } else {
                                    $location.path("/thank-you");
                                    // window.location = "/thank-you";
                                }
                            }
                        }
                    });
                }
            } else {
                vm.selectDay = false;
                vm.selectTime = false;
                vm.servicePolicyError = false;

                if (vm.dialogData.preferred_days.length == 0) {
                    vm.selectDay = true;
                }
                if (vm.dialogData.preferred_timings.length == 0) {
                    vm.selectTime = true;
                }
                if (vm.dialogData.servicePolicy != true) {
                    vm.servicePolicyError = true;
                }
            }
        }

        vm.ToggleCheckbox = function(e, value) {

            vm.onChangeCheckBox = true;
            var arrDays = vm.days;
            var allowedDays = [];
            for (var i = 0; i < arrDays.length; i++) {
                if (arrDays[i].bAllow === true) {

                    allowedDays.push(arrDays[i].day);
                    //vm.dialogData.preferred_days = allowedDays ;
                }
            }
            vm.dialogData.preferred_days = allowedDays;

        }


        vm.ToggleTime1Checkbox = function(e, value) {


            vm.onChangeCheckBox1 = true;

            var arrTime1 = vm.timeslot1;

            if (arrTime1[7].bAllow === true) {
                vm.userTime = true;
                return;
            } else {
                vm.userTime = false;
                allowedTime1 = [];
                for (var i = 0; i < arrTime1.length; i++) {
                    if (arrTime1[i].bAllow === true) {

                        if (i != 10)
                            allowedTime1.push(arrTime1[i].time);
                        //        vm.dialogData.preferred_timings = allowedTime1 ;
                    }
                }

                vm.dialogData.preferred_timings = allowedTime1;
            }



        }
        vm.addRecord = function(form, form2) {
            debugger;
            if (vm.dialogData.group_service_policy != true) {
                vm.groupServicePolicyError = true;

            } else {
                vm.groupServicePolicyError = false;
            }

            if (form.$invalid || form2.$invalid || vm.duplicateStudentEmail) {
                vm.submitted = true;
                if (vm.dialogData.is_company == 1) {
                    if (form2.$invalid) {
                        vm.submittedCompany = true;

                        return;
                    } else
                        vm.submittedCompany = true;
                } else {
                    vm.submittedCompany = false;
                }
                return;
            }



            //here we will have the new data to be saved.
            vm.dialogData;

            if (vm.courseType == 'G' || vm.courseType == 'O') {
                if (vm.groupServicePolicyError == false && vm.submittedCompany == false) {
                    Utils.showLoader(true);
                    ApiService.AddGroupApplication({
                        data: vm.dialogData,
                        success: function(response) {
                            //                            console.log(response);
                            if (response.status === 0) {
                                Utils.showLoader(false);
                                Utils.showToast({ text: response.data.message, 'type': 0 });
                            } else {
                                Utils.showLoader(false);
                                //                                 window.location = "/thank-you";
                                var skill = response.data.message;

                                if (skill == "Bahasa Indonesia") {
                                    $state.go('app.pages_auth_indoslang-thank-you');
                                    // window.location = "https://indoslang.com.sg/class-sign-up-thank-you/";
                                } else if (skill == "Business Mandarin" || skill == "Mandarin") {
                                    $state.go('app.pages_auth_yiman-thank-you');
                                    // window.location = "https://yimandarin.com.sg/yi-class-sign-up-thank-you/";
                                } else if (skill == "Korean") {
                                    $state.go('app.pages_auth_hana-thank-you');
                                    // window.location = "https://yimandarin.com.sg/yi-class-sign-up-thank-you/";
                                } else if (skill == "English") {
                                    $state.go('app.pages_auth_english-express-thank-you');
                                    // window.location = "https://www.englishexpress.com.sg/ee-class-sign-up-thank-you/";
                                } else {
                                    $location.path("/thank-you");
                                    // window.location = "/thank-you";
                                }
                            }
                        }
                    });
                }
            }
            if (vm.courseType == 'P') {
                ApiService.AddPrivateApplication({
                    data: vm.dialogData,
                    success: function(response) {
                        if (response.status === 0) {
                            Utils.showLoader(false);
                            Utils.showToast({ text: response.data.message, 'type': 0 });
                        } else {

                            Utils.showLoader(false);
                            var skill = response.data.message;
                            if (skill == "Bahasa Indonesia") {
                                $state.go('app.pages_auth_indoslang-thank-you');
                                // window.location = "https://indoslang.com.sg/class-sign-up-thank-you/";
                            } else if (skill == "Korean") {
                                $state.go('app.pages_auth_hana-thank-you');
                                // window.location = "https://yimandarin.com.sg/yi-class-sign-up-thank-you/";
                            } else if (skill == "Business Mandarin" || skill == "Mandarin") {
                                $state.go('app.pages_auth_yiman-thank-you');
                                // window.location = "https://yimandarin.com.sg/yi-class-sign-up-thank-you/";
                            } else if (skill == "English") {
                                $state.go('app.pages_auth_english-express-thank-you');
                                // window.location = "https://www.englishexpress.com.sg/ee-class-sign-up-thank-you/";
                            } else {
                                $location.path("/thank-you");
                                // window.location = "/thank-you";
                            }
                        }
                    }
                });
            }
        }
        vm.onEmailChange = function(email, el) {
            if (vm.dialogData.email == '' || vm.dialogData.full_name == '') {
                return;
            } else if (validateEmail(vm.dialogData.email) == false) {
                return;
            }
            Utils.showLoader(true);
            ApiService.CheckDuplicateEmailForStudentEnrolment({
                bSkipAuth: true,
                data: {
                    'school_id': vm.dialogData.school_id,
                    'scheduleClassID': vm.dialogData.scheduleClassID,
                    'email': vm.dialogData.email,
                    'fullName': vm.dialogData.full_name,
                },
                success: function(response) {
                    Utils.showLoader(false);
                    if (response.status == 0) {
                        Utils.showToast({ text: response.data.message, 'type': 0 });
                        vm.duplicateStudentEmail = true;
                    }
                }
            });
        }

        function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }
        //study location
        vm.onChangeStudyLocation = function() {
            if (vm.studyLocation === "Others") {
                vm.showOtherStudyLocation = true;
            } else {
                vm.showOtherStudyLocation = false;
                vm.otherStudyLocation = "";
            }
        }

        //lesson duration
        vm.onChangeLessonDuration = function() {
            if (vm.lessonDuration === "Others") {
                vm.showOtherLessonDuration = true;
            } else {
                vm.showOtherLessonDuration = false;
                vm.otherLessonDuration = "";
            }
        }


        //study frequency

        vm.onChangeStudyFrequency = function() {
            if (vm.studyFrequency === "Others") {
                vm.showOtherStudyFrequency = true;
            } else {
                vm.showOtherStudyFrequency = false;
                vm.otherStudyFrequency = "";
            }
        }
        init();
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/quick-panel');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(api, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        api.quickPanel.contacts.get({}, function (response)
        {
            vm.contacts = response.data;
        });

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.teachers', ['ngTagsInput','720kb.datepicker','ngMaterial'])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
   
    }
})();
(function()
{
    'use strict';

    angular.module('app.teachers')
            .controller('AddNoteDialogController', AddNoteDialogController);

    /** @ngInject */
    function AddNoteDialogController($mdDialog, dialogData, ApiService,  Utils, dtInstance, dtPromiseFn)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.dtInstance = dtInstance;
        vm.dtPromiseFn = dtPromiseFn;

        // Methods
        vm.closeDialog = closeDialog;
        vm.onSaveBtnTap = onSaveBtnTap;


        init();

        //////////

        /**
         * Initialize
         */
        function init()
        {
            vm.dialogData.title = 'Add Note';
            if(vm.dialogData.note == null) {
                vm.dialogData.note = '';
            }
        }

//        vm._reloadDtPage = function() {
//            vm.dtInstance.reloadData();
//        };


        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }
        vm._reloadDtPage = function() {
            vm.dtInstance.changeData(dtPromiseFn());

        };


        function onSaveBtnTap(e) {
            Utils.showLoader(true);

//here we will have the new data to be saved.
            var requestPayload = {
                'schedule_class_id' : vm.dialogData.intake_id,
                'note' : vm.dialogData.note
            } 
            ApiService.AddScheduleNote({
                data: requestPayload,
                dtInstance: vm.dtInstance,
                success: function(response) {
                    if (response.status === 0) {
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 0});
                    } else {
                        $mdDialog.hide(vm.dialogData);
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 1});
                        vm._reloadDtPage();
                    }
                }
            });
        }
        vm.onDuplicateClick = function(data) {
            dialogData.title = 'Add New Skill';
            dialogData.type = 'add';
            dialogData.id = null;
            dialogData;

        }

    }
})();

(function ()
{
    'use strict';

    angular.module('app.teachers')
            .controller('GeneratePayslipDialogController', GeneratePayslipDialogController);

    /** @ngInject */
    function GeneratePayslipDialogController($mdDialog, dialogData, ApiService, Utils, dtInstance, $scope, dtPromiseFn, api, $http, GlobalPool)
    {
        var vm = this;
        window.h = vm;
        // Data
        vm.dialogData = dialogData;
        vm.dtInstance = dtInstance;
        vm.dtPromiseFn = dtPromiseFn;
        vm.courseType = Focus.ENUMS.COURSE_FILTERTYPE,
                // Methods
                vm.closeDialog = closeDialog;
        vm.onGenerateSlip = onGenerateSlip;
        vm.startDateChange = false;
        vm.endDateChange = false;
        vm.getResponse = false;
        var userInfo = GlobalPool.getUserInfo();
        vm.setAuthToken = userInfo.auth_token;
        vm.setAuthDownloadLink = api.baseURI;
        $scope.log = [];
        vm.noData = true;

//        vm.diaadditional = [{name: "hfdgjf", id: "fdjh"}, {name: "hfdfdgjf", id: "25fdjh"}]
        init();

        //////////

        /**
         * Initialize
         */
        function init()
        {
            vm.dialogData.title = 'Generate Payslip';

        }

        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(dtPromiseFn());

        };
        vm._onStartDateChange = function () {
            vm.startDateChange = true;
            vm.minDate = vm.dialogData.start_date;
            if (vm.endDateChange == true) {
                vm.getTeacherDetails();
            }
        }
        vm._onEndDateChange = function () {
            vm.endDateChange = true;
            if (vm.startDateChange == true) {
                vm.getTeacherDetails();
            }
        }
        vm.getTeacherDetails = function () {
            Utils.showLoader(true);
            var start_date = moment(vm.dialogData.start_date).format('L');
            var end_date = moment(vm.dialogData.end_date).format('L');

            var requestData = {
                'start_date': start_date,
                'end_date': end_date,
                'teacher_id': vm.dialogData.teacherId,
            }

            ApiService.GetTeachersIntakeDetails({
                data: requestData,
                success: function (response) {
                    Utils.showLoader(false);
                    if (response.status != 0) {
                        vm.noData = false;
//                        response.data.teacherIntakes = {};
                        if (response.data.teacherIntakes.length > 0) {
                            vm.getResponse = true;
                        } else {
                            vm.showLabel = true;
                        }
//                        vm.dialogData = response.data;
                        vm.dialogData.school_name = response.data.school_name;
                        vm.dialogData.school_teacher_id = response.data.school_teacher_id;
                        vm.dialogData.email = response.data.email;
                        vm.dialogData.full_name = response.data.full_name;
                        vm.dialogData.teacherRate = response.data.teacherRate;
                        vm.dialogData.pay_date = moment(new Date()).format('L')
                        vm.dialogData.sub_total_amount = response.data.sub_total_amount;
                        vm.dialogData.additional_pay = response.data.additional_pay;
                        vm.courseoptions = response.data.teacherIntakes;
                        vm.dialogData.teacherIntakes = response.data.teacherIntakes;
                        vm.dialogData.hours = 0;
                        vm.dialogData.classes = 0;
                        if (vm.courseoptions) {
                            var arrCoursesArray = [];
                            for (var i = 0; i < vm.courseoptions.length; i++) {
                                for (var j = 0; j < vm.courseType.length; j++) {
                                    if (vm.courseType[j].text == vm.courseoptions[i].courseType) {
                                        var typeName = vm.courseType[j].value;
                                    }
                                }
                                arrCoursesArray.push({title: vm.courseoptions[i].courseName + " " + vm.courseoptions[i].courseLevel + " " + vm.courseoptions[i].courseSeries + " " + typeName + ", " + vm.courseoptions[i].intakeID, courseId: vm.courseoptions[i].courseID, schedule_class_id: vm.courseoptions[i].schedule_class_id, intakeID: vm.courseoptions[i].intakeID, no_of_classes: vm.courseoptions[i].courseClasses, hours: vm.courseoptions[i].hours})
                                vm.dialogData.hours += parseFloat(vm.courseoptions[i].hours);
                                vm.dialogData.classes += vm.courseoptions[i].courseClasses;
                            }
                            vm.listedCourses = arrCoursesArray;
                        }
                    } else {
                        vm.noData = true;
                        Utils.showToast({text: response.data.message, 'type': 0});
                    }
                }
            });
        }
        vm.onChangeIntake = function () {

//            var requestData = {
//                'intake_id': vm.dialogData.course,
//                'teacher_id': vm.dialogData.teacherId
//            }
//            ApiService.GetTeachersPaymentDetails({
//                data: requestData,
//                success: function(response) {
//                    vm.dialogData.amount = (20 * 50);
//
//                }
//            })
        }
        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }






        function onGenerateSlip() {

            if (vm.dialogData.additional_pay) {
                var payment_item = [];
                var payment_value = [];
                for (var i = 0; i < vm.dialogData.additional_pay.length; i++) {
                    payment_item.push(vm.dialogData.additional_pay[i].name);
                    payment_value.push(vm.dialogData.additional_pay[i].value);
                }
                vm.dialogData.additional_payment_item = payment_item;
                vm.dialogData.additional_payment_value = payment_value;
            }
            Utils.showLoader(true);
            vm.dialogData.role_id = 2;
            vm.dialogData.additional_payment_item = vm.dialogData.additional_payment_item === undefined ? null : vm.dialogData.additional_payment_item;
            vm.dialogData.additional_payment_value = vm.dialogData.additional_payment_value === undefined ? null : vm.dialogData.additional_payment_value;
            if (vm.dialogData.type == "edit")
            {
                vm.dialogData.user_id = vm.dialogData.teacherId;
            }

//here we will have the new data to be saved.
            var dialogData = angular.copy(vm.dialogData);
            dialogData.start_date = moment(vm.dialogData.start_date).format('L');
            ;
            dialogData.end_date = moment(vm.dialogData.end_date).format('L');
            ;
            ApiService.GeneratePayslip({
                data: dialogData,
                dtInstance: vm.dtInstance,
                success: function (response) {
                    if (response.status == 0) {
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 0});
                    } else {
                        $mdDialog.hide(vm.dialogData);
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 1});
                        vm._reloadDtPage();
                    }
                }
            });
        }


    }
})();

(function()
{
    'use strict';
    angular.module('app.teachers')
            .config(function($mdDateLocaleProvider) {
                $mdDateLocaleProvider.formatDate = function(date) {
                    return date ? moment(date).format('DD-MM-YYYY') : '';
                };
                $mdDateLocaleProvider.parseDate = function(dateString) {
                    var m = moment(dateString, 'DD-MM-YYYY', true);
                    return m.isValid() ? m.toDate() : new Date(NaN);
                };
            })
            .controller('showTeacherLogsController', showTeacherLogsController);
    /** @ngInject */
    function showTeacherLogsController($mdDialog, dialogData, ApiService, Utils,  $q,  dtInstance, $scope, dtPromiseFn)
    {
        var vm = this;
        // Data
        window.h = vm;
        vm.dialogData = dialogData;
        vm.dtInstance = dtInstance;
        // Methods
        vm.dtPromiseFn = dtPromiseFn;
        vm.closeDialog = closeDialog;
           

        
        init();
        /**
         * Initigalize
         */
        function init()
        {
             vm.dialogData.title = "Teacher Log";
        }

     
            vm.dialogData.title = "Teacher Log";
     
        vm._reloadDtPage = function() {
            vm.dtInstance.changeData(dtPromiseFn());
        };
        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }

        

        
    }



})();

(function ()
{
    'use strict';
    angular.module('app.teachers')
            .controller('AddTeachersDialogController', AddTeachersDialogController);
    /** @ngInject */
    function AddTeachersDialogController($mdDialog, dialogData, ApiService, Utils, dtInstance, $scope, skillobj, dtPromiseFn)
    {
        var vm = this;
        window.h = vm;
        // Data
        vm.dialogData = dialogData;
        var position_no;
        vm.dtInstance = dtInstance;
        vm.skillobj = skillobj;
        vm.dtPromiseFn = dtPromiseFn;
        vm.zones = Focus.ENUMS.TEACHER_ZONES;
        // Methods
        vm.closeDialog = closeDialog;
        vm.onDeleteBtnTap = onDeleteBtnTap;
        vm.onSaveTeacherBtnTap = onSaveTeacherBtnTap;
        vm.readonly = false;
        //vm.positions = loadPositions();
        vm.selectedPosition = [];
        vm.autocompleteDemoRequireMatch = true;
        vm.transformChip = transformChip;

        $scope.log = [];



        vm.readonly = false;
        vm.selectedItem = null;
        vm.searchText = null;
//    vm.querySearch = vm.querySearch;
        //vm.vegetables = vm.loadVegetables();
        vm.dialogData.positions = [];
        vm.numberChips = [];
        vm.numberChips2 = [];
        vm.numberBuffer = '';
        vm.autocompleteDemoRequireMatch = true;
        vm.transformChip = transformChip;
        vm.positions = [];

        /**
         * Return the proper object when the append is called.
         */
        function transformChip(chip) {
//            console.log($index);
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                return chip;
            }
            // Otherwise, create a new one
//            return {name: chip};
        }
        /**
         * Search for vegetables.
         */
        function querySearch(query) {
            var results = query ? vm.positions.filter(createFilterFor(query)) : [];
            return results;
        }
        /**
         * Create filter function for a query string
         */
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(thPosition) {
                return (thPosition._lowername.indexOf(lowercaseQuery) != 0);
            };

        }
        //array of position

        init();
        //////////
        /**
         * Initialize
         */
        function init()
        {
            vm.dialogData.title = (vm.dialogData.type === 'add' ? 'Add New Teacher' : 'Edit Teacher');
            if (vm.dialogData.type === 'add') {
                vm.dialogData.start_of_employment = moment(new Date()).format('L');
                vm.dialogData.position_name = "";
            } else {
                if (vm.dialogData.position_name[0] == null) {
                    position_no = vm.dialogData.position_name[0] = "";

                } else {
                    position_no = vm.dialogData.position_name[0];
                }

            }

            getPositions();

        }

        function getTeacherPositionName()
        {
            for (var i = 0; i < vm.positions.length; i++)
            {
                if (vm.positions[i].id == vm.dialogData.position_name[0])
                {
                    var title = {title: vm.positions[i].title};

                    vm.dialogData.positions.push(title);
                    vm.dialogData.position_name = vm.positions[i].title;
                }
            }
        }
        function getPositions()
        {
            var checkData2 = {

                "auth_token": vm.setAuthToken
            }
            Utils.showLoader(true);
            ApiService.GetPositions({
                data: checkData2,
                success: function (response) {
                    if (response.status == 0) {
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 0});
                        vm.courseData = {};
                    } else {
                        Utils.showLoader(false);
                        vm.positions = response.data;
                        if (vm.dialogData.type === 'edit') {
                            getTeacherPositionName();
                        }

                    }
                }
            })

        }
        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(dtPromiseFn());
        };
        vm._onTabEmail = function () {
            if (vm.dialogData.email != undefined) {
                var requestData = {
                    "email": vm.dialogData.email
                }
                ApiService.checkEmailUnique({
                    data: requestData,
                    dtInstance: vm.dtInstance,
                    success: function (response) {
                        if (response.status == 0) {
                            Utils.showLoader(false);
                            vm.showEmailError = response.data.message;
//                            Utils.showToast({text: response.data.message});
                        } else {
                            vm.showEmailError = false;
                            Utils.showLoader(false);
//                            Utils.showToast({text: response.data.message});
                        }
                    }
                });
            }
        }
        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }


        function onDeleteBtnTap(e) {
            var checkData = {
                "teacherID": vm.dialogData.teacherId
            }
            ApiService.checkTeacherDeletable({
                data: checkData,
                success: function (response) {
                    if (response.status == 0) {
                        Utils.showToast({text: response.data.message, 'type': 0});
                    } else {
                        var deleteData = {
                            "role_id": "2",
                            "users": [vm.dialogData.teacherId]
                        }
                        var confirm = $mdDialog.confirm()
                                .title('Confirm Delete Teacher ?')
                                .textContent('Are you sure you want to delete selected Teacher ?')
                                .ariaLabel('Delete')
                                .targetEvent(e)
                                .ok('Delete')
                                .cancel('Cancel');
                        $mdDialog.show(confirm).then(function () {
                            Utils.showLoader(true);
                            ApiService.DeleteUser({
                                data: deleteData,
                                success: function (response) {
                                    Utils.showLoader(false);
                                    if (response.status == 0) {
                                        Utils.showToast({text: response.data.message, 'type': 0});
                                    } else {
                                        Utils.showToast({text: response.data.message, 'type': 1});
                                        vm._reloadDtPage();
                                    }
                                }
                            });
                        }, function () {
                        });
                    }
                }
            })
        }
        vm.setValue = new Date().toString();
        vm.dateOfBirth = new Date().toString();
        vm.setMaxDate = new Date().toString();
        if (vm.dialogData.type === 'edit') {
            if (!angular.isDate(vm.dialogData.start_of_employment)) {
                if (vm.dialogData.start_of_employment.length != 0) {
                    vm.dialogData.start_of_employment = Utils.getFormattedDate(vm.dialogData.start_of_employment);
                    vm.dialogData.date_of_birth = Utils.getFormattedDate(vm.dialogData.date_of_birth);
                    vm.setValue = vm.dialogData.start_of_employment;
                    vm.dateOfBirth = vm.dialogData.date_of_birth;
                }
            }
            if (vm.dialogData.contact_number != undefined) {
                vm.dialogData.contact_number = vm.dialogData.contact_number;
            }
            if (vm.dialogData.pay_rate != undefined) {
                vm.dialogData.pay_rate = parseInt(vm.dialogData.pay_rate);
            }
        }
        function onSaveTeacherBtnTap(e) {
            Utils.showLoader(true);
            vm.dialogData.role_id = 2;
            vm.dialogData.address = vm.dialogData.address === undefined ? null : vm.dialogData.address;
            vm.dialogData.photo = vm.dialogData.photo === undefined ? null : vm.dialogData.photo;
            vm.dialogData.start_of_employment = vm.dialogData.start_of_employment === undefined ? null : vm.dialogData.start_of_employment;
            vm.dialogData.bank = vm.dialogData.bank === undefined ? null : vm.dialogData.bank;
            vm.dialogData.bank_account = vm.dialogData.bank_account === undefined ? null : vm.dialogData.bank_account;
            vm.dialogData.date_of_birth = vm.dialogData.date_of_birth === undefined ? null : vm.dialogData.date_of_birth;
            vm.dialogData.zones = vm.dialogData.zones === undefined ? null : vm.dialogData.zones;

            if (vm.dialogData.type == "edit")
            {
                vm.dialogData.user_id = vm.dialogData.teacherId;
                if (vm.dialogData.positions.length == 0) {
                    vm.dialogData.position_name = "";
                }
            }
//here we will have the new data to be saved.
            var dialogData = angular.copy(vm.dialogData);
            if (dialogData.address) {
                dialogData.address = dialogData.address.trim();
            }
            if (dialogData.skills == undefined) {
                dialogData.skills = null;
            }
            ApiService.AddUpdateTeacher({
                data: dialogData,
                dtInstance: vm.dtInstance,
                success: function (response) {
                    if (response.status == 0) {
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 0});
                    } else {
                        $mdDialog.hide(vm.dialogData);
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 1});
                        if (vm.dialogData.type == 'edit') {
                            vm.dialogData.teacherID = response.data.teacher_response.teacherID;
                        }
                        vm._reloadDtPage();
                    }
                }
            });
        }

        vm.transformChip = function (chip) {
            if (chip.title == null)
            {
                vm.dialogData.position_name = chip;
            } else
            {
                vm.dialogData.position_name = chip.title;
            }

            if (vm.dialogData.positions.length >= 1)
            {
                vm.dialogData.positions.pop();
            }

            if (angular.isObject(chip)) {

                return chip;
            }
            // Otherwise, create a new one
            return {title: chip}
        }

        vm.querySearch = function (query) {
            var results = query ? vm.vegetables.filter(createFilterFor(query)) : [];
            return results;
        }

        vm.onDuplicateClick = function (data) {
            dialogData.title = 'Add New Teacher';
            dialogData.type = 'add';
            dialogData.teacherId = null;
            dialogData.user_id = null;
            dialogData;
            if (vm.dialogData.email != undefined) {
                var requestData = {
                    "email": vm.dialogData.email
                }
                ApiService.checkEmailUnique({
                    data: requestData,
                    dtInstance: vm.dtInstance,
                    success: function (response) {
                        if (response.status == 0) {
                            Utils.showLoader(false);
                            vm.showEmailError = response.data.message;
//                            Utils.showToast({text: response.data.message});
                        } else {
                            vm.showEmailError = false;
                            Utils.showLoader(false);
//                            Utils.showToast({text: response.data.message});
                        }
                    }
                });
            }
        }
    }
})();
(function()
{
    'use strict';

    angular
            .module('app.students', ['ngFileUpload','threeStateCheckbox'])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {

    }
})();
(function()
{
    'use strict';

    angular.module('app.students')
            .controller('ShowStudentCertificateController', ShowStudentCertificateController);

    /** @ngInject */
    function ShowStudentCertificateController($mdDialog, dialogData, ApiService, dtPromiseFn, api, $http, GlobalPool, Utils, courseObj)
    {
        var vm = this;
        // Data
        vm.dialogData = dialogData;
        vm.closeDialog = closeDialog;
        vm.courseObj = courseObj;
//        vm.dateList = dateList;
        vm.dtPromiseFn = dtPromiseFn;
        vm.PrintPreview = PrintPreview;
        var userInfo = GlobalPool.getUserInfo();
        vm.setAuthToken = userInfo.auth_token;
        vm.setAuthDownloadLink = api.baseURI;
        vm.showListing = false;
        vm.showLabel = false;
//        vm.checkboxModel = false;
        vm.onChange = function() {
            console.log("changed");
        }
        //////////

        /**
         * Initialize
         */
        vm.dialogData.title = "Certificate Report";
        function init()
        {
            vm.dialogData.title = "Certificate Report";
        }

        if (vm.courseObj.length > 0) {
            vm.showListing = true;
        }
        else {
            vm.showLabel = true;
        }


        vm.saveAttendance = function(e) {
            var attendanceObj = [];
            var dataObj = vm.studentsData;
            for (var k = 0; k < dataObj.length; k++) {
                var data = dataObj[k].attendanceList;
                for (var l = 0; l < data.length; l++) {
                    if (data[l].bAllow == false) {
                        data[l].attendance = 0;
                    }
                    else if (data[l].bAllow == true) {
                        data[l].attendance = 1;
                    }
                    else if (data[l].bAllow == null) {
                        data[l].attendance = "";
                    }
                    else {
                        data[l].attendance = -1;
                    }
                }
            }

            var requestData = {
                "schedule_class_id": vm.dialogData.schedule_class_id,
                "intake": vm.dialogData.intakeID,
                "students": dataObj
            }
            ApiService.UpdateAttendance({
                data: requestData,
                success: function(response) {
                    if (response.status == 0) {
                        Utils.showLoader(false);

                        Utils.showToast({text: response.data.message, 'type': 0});
                    }
                    else {
                        Utils.showLoader(false);
//                        vm.btnDisable = true;
                        Utils.showToast({text: response.data.message, 'type': 1});
                    }
                }
            });
        }

        function PrintPreview() {
            var jTemp = $("<div class='print-block'></div>");
            jTemp.html($("#printarea").html());

            var toPrint = jTemp[0];//document.getElementById('printarea');
            jTemp.find("table").css("border-collapse", "collapse")
            jTemp.find("table td").css("border", "1px solid grey")
            jTemp.find("table th").css("border", "1px solid grey")
            var popupWin = window.open('', '_blank', 'width=350,height=150,location=no,left=200px');

            popupWin.document.open();
            popupWin.document.write('<html><title>::Print Preview::</title></head><body">')
            popupWin.document.write(toPrint.innerHTML);
            popupWin.document.write('</html>');
            popupWin.document.close();
        }
//        $http({
//            url: api.localUrl + 'dashboard/trial.json',
//            dataType: "json",
//            method: "GET",
//            headers: {
//                "Content-Type": "application/json"
//            }
//        }).success(function(response) {
//            vm.studentsData = response.attendances;
//            vm.dateList = response.scheduleDates;
//            dialogData.end_date = response.end_date;
//            dialogData.start_date = response.start_date;
////            var data = response.data;
//            var arrSchedules = response.scheduleDates;
//            var arrAttendances = response.attendances;
//
//            var curAttList = null, curScheduleObj = null;
//            for (var i = 0; i < arrAttendances.length; i++)
//            {
//                curAttList = arrAttendances[i].attendanceList;
//                for (var j = 0; j < arrSchedules.length; j++) {
//                    curScheduleObj = arrSchedules[j];
//                    if (!isDateInSchedules(curAttList, curScheduleObj)) {
//                        curAttList.push({
//                            date: curScheduleObj,
//                            attendance: ''
//                        });
//                    }
//                }
//            }
//            console.log(arrSchedules);
//            console.log(arrAttendances);
//        });
//
//        $http({
//            url: api.localUrl + 'dashboard/dateList.json',
//            dataType: "json",
//            method: "GET",
//            headers: {
//                "Content-Type": "application/json"
//            }
//        }).success(function(response) {
//            vm.dateList = response.dataList
//        });
        function reloadData() {
            vm.dtInstance.reloadData();
        }
        vm._reloadDtPage = function() {
            vm.dtInstance.changeData(dtPromiseFn());

        };
        vm.gettingData = function(a) {
            var a = a;
            console.log(a);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
//ng-click="vm.onClickRow(dates)"
//        vm.onClickRow = function(dates) {
//            dates
//            var abc = 1;
//            abc
//        }

    }
})();

(function ()
{
    'use strict';

    angular.module('app.students')
            .controller('StudentFilterDialogController', StudentFilterDialogController);

    /** @ngInject */
    function StudentFilterDialogController($mdDialog, dialogData, ApiService, dtPromiseFn, api, $http, GlobalPool, Utils, $scope)
    {
        var vm = this;
        // Data
        vm.dialogData = dialogData;
        vm.closeDialog = closeDialog;
//        vm.dateList = dateList;
        vm.dtPromiseFn = dtPromiseFn;

        var userInfo = GlobalPool.getUserInfo();
        vm.setAuthToken = userInfo.auth_token;
        vm.setAuthDownloadLink = api.baseURI;
        vm.courseType = Focus.ENUMS.COURSE_FILTERTYPE;
        vm.courseLevel = Focus.ENUMS.COURSE_LEVEL;
        vm.series = '';
        vm.selectedCourseLevel = '';
        vm.selectedCourseType = '';
        vm.startDate = '';
        vm.btnName = 'Export';
        /**
         * Initialize
         */

        vm.dialogData.title = "Certificate Report";
        function init() {
            vm.dialogData.title = "Export Student Record";
        }

        function reloadData() {
            vm.dtInstance.reloadData();
        }
        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(dtPromiseFn());
        };
        function closeDialog()
        {
            $mdDialog.cancel();
        }

        vm.onSubmitBtnTap = function () {
            vm.btnName = 'Checking';
            Utils.showLoader(true);
            var start_date = '';
            if(vm.startDate) {
                start_date = moment(vm.startDate).format('YYYY-MM-DD');
            }
            var requestData = {
                'classLevel': vm.selectedCourseLevel,
                'classType': vm.selectedCourseType,
                'series': vm.series,
                'startDate' : start_date,
                'check': '1'
            };
            ApiService.GetStudentsExport({
                data: requestData,
            }).then(function (response) {
                var data = response.data;
                if (response.status == '1') {
                    debugger;
                    vm.btnName = 'downloading';
                    var linkPage = document.getElementById('btn_export').href;
                    if(start_date) {
                        linkPage = linkPage + '&startDate='  + start_date;
                    }
                    window.location.href = linkPage;
                    Utils.showLoader(false);
                    $mdDialog.hide(vm.dialogData);
                }else{
                    vm.btnName = 'Export';
                    Utils.showLoader(false);
                    Utils.showToast({text: response.data.message, 'type': 1});
                }
            });
        }
    }
})();

(function()
{
    'use strict';
    angular.module('app.students')
            .config(function($mdDateLocaleProvider) {
                $mdDateLocaleProvider.formatDate = function(date) {
                    return date ? moment(date).format('DD-MM-YYYY') : '';
                };
                $mdDateLocaleProvider.parseDate = function(dateString) {
                    var m = moment(dateString, 'DD-MM-YYYY', true);
                    return m.isValid() ? m.toDate() : new Date(NaN);
                };
            })
            .controller('showLogsController', showLogsController);
    /** @ngInject */
    function showLogsController($mdDialog, dialogData, ApiService, Utils,  $q,  dtInstance, $scope, dtPromiseFn)
    {
        var vm = this;
        // Data
        window.h = vm;
        vm.dialogData = dialogData;
        vm.dtInstance = dtInstance;
        // Methods
        vm.dtPromiseFn = dtPromiseFn;
        vm.closeDialog = closeDialog;
           

        
        init();
        /**
         * Initigalize
         */
        function init()
        {
             vm.dialogData.title = "INTAKE";
        }

     
            vm.dialogData.title = "INTAKE";
     
        vm._reloadDtPage = function() {
            vm.dtInstance.changeData(dtPromiseFn());
        };
        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }

        

        
    }



})();

(function ()
{
    'use strict';

    angular.module('app.students')
            .controller('AddStudentsDialogController', AddStudentsDialogController);

    /** @ngInject */
    function AddStudentsDialogController($mdDialog, dialogData, ApiService, Utils, dtInstance, dtPromiseFn,$location)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.dtInstance = dtInstance;

        vm.dtPromiseFn = dtPromiseFn;

        // Methods
        vm.closeDialog = closeDialog;
        vm.onDeleteBtnTap = onDeleteBtnTap;
        vm.onSaveStudentBtnTap = onSaveStudentBtnTap;
        vm.result = false;
        vm.studentPrimaryID= '';
        vm.a1 = 1;

        init();

        //////////

        /**
         * Initialize
         */

        function init()
        {
            vm.dialogData.title = (vm.dialogData.type === 'add' ? 'Add New Student' : 'Edit Student');

            if (vm.dialogData.type == "add")
            {
                vm.dialogData.is_renewal = 0;
                vm.dialogData.contact_number = '+65';
            } else {
                vm.studentPrimaryID = vm.dialogData.studentID;
                
                if (vm.dialogData.address == '-') {
                    vm.dialogData.address = '';
                }
                
                if (vm.dialogData.company_name == '-') {
                    vm.dialogData.company_name = '';
                }
                if (vm.dialogData.company_address == '-') {
                    vm.dialogData.company_address = '';
                }
                if (vm.dialogData.contact_person == '-') {
                    vm.dialogData.contact_person = '';
                }
                
            }
        }



        vm._reloadDtPage = function () {
            if($location.path() != '/dashboard') {
                vm.dtInstance.changeData(dtPromiseFn());
            }
        };

        vm._onTabEmail = function () {



            if (vm.dialogData.email != undefined) {
                var requestData = {
                    "email": vm.dialogData.email
                }
                ApiService.checkEmailUnique({
                    data: requestData,
                    dtInstance: vm.dtInstance,
                    success: function (response) {
                        if (response.status == 0) {
                            Utils.showLoader(false);
                            vm.showEmailError = response.data.message;
                            vm.result = 'false';

//                            return false;
//                            Utils.showToast({text: response.data.message});
                        } else {
                            vm.showEmailError = false;
                            Utils.showLoader(false);

                            vm.result = 'true';
//                            return true;
//                            Utils.showToast({text: response.data.message});
                        }
                    }
                });
            }


        }

        if (vm.dialogData.type === 'edit') {
            if (vm.dialogData.contact_number != undefined) {
                vm.dialogData.contact_number = (vm.dialogData.contact_number);
            }
        }
        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }

        function onDeleteBtnTap(e) {

            var deleteData = {
                "role_id": "3",
                "users": [vm.dialogData.studentID]
            }
            var confirm = $mdDialog.confirm()
                    .title('Confirm Delete Student ?')
                    .textContent('Are you sure you want to delete selected Student ?')
                    .ariaLabel('Delete')
                    .targetEvent(e)
                    .ok('Delete')
                    .cancel('Cancel');
            $mdDialog.show(confirm).then(function () {
                Utils.showLoader(true);
                ApiService.DeleteUser({
                    data: deleteData,
                    success: function (response) {
                        Utils.showLoader(false);
                        if (response.status === 0) {
                            Utils.showToast({text: response.data.message, 'type': 0});
                        } else {
                            Utils.showToast({text: response.data.message, 'type': 1});
                            vm._reloadDtPage();
                        }
                    }
                });
            }, function () {
            });
        }

        if (vm.dialogData.type === 'edit') {
            if (vm.dialogData.contact_number != undefined) {
                vm.dialogData.contact_number = (vm.dialogData.contact_number);
            }
            if (vm.dialogData.contact_person != undefined) {
                vm.dialogData.contact_person = (vm.dialogData.contact_person);
            }
        }


        function onSaveStudentBtnTap(e) {
            Utils.showLoader(true);
            vm.dialogData.role_id = 3;
            vm.dialogData.user_id = vm.dialogData.studentID;
            vm.dialogData.company_name = vm.dialogData.company_name === undefined ? null : vm.dialogData.company_name;
            vm.dialogData.company_address = vm.dialogData.company_address === undefined ? null : vm.dialogData.company_address;
            vm.dialogData.contact_number = vm.dialogData.contact_number === undefined ? null : vm.dialogData.contact_number;
            vm.dialogData.contact_person = vm.dialogData.contact_person === undefined ? null : vm.dialogData.contact_person;
            vm.dialogData.address = vm.dialogData.address === undefined ? null : vm.dialogData.address;


            if (vm.dialogData.type == "edit")
            {
                vm.dialogData.user_id = vm.dialogData.studentID;
            }

            if (dialogData.apiCalled == 'intake')
            {
                ApiService.AddScheduleStudent({
                    data: vm.dialogData,
                    dtInstance: vm.dtInstance,
                    success: function (response) {
                        if (response.status === 0) {
                            Utils.showLoader(false);
                            Utils.showToast({text: response.data.message, 'type': 0});
                        } else {
                            $mdDialog.hide(vm.dialogData);
                            Utils.showLoader(false);
                            Utils.showToast({text: response.data.message, 'type': 1});
                            if (vm.dialogData.type == 'edit') {
                                vm.dialogData.studentID = response.data.student_response.studentID;
                            }
                            vm._reloadDtPage();
                        }
                    }
                });
            } else    //here we will have the new data to be saved.
            {
                ApiService.AddUpdateStudent({
                    data: vm.dialogData,
                    dtInstance: vm.dtInstance,
                    success: function (response) {
                        if (response.status === 0) {
                            Utils.showLoader(false);
                            Utils.showToast({text: response.data.message, 'type': 0});
                        } else {
                            $mdDialog.hide(vm.dialogData);
                            Utils.showLoader(false);
                            Utils.showToast({text: response.data.message, 'type': 1});
                            if (vm.dialogData.type == 'edit') {
                                vm.dialogData.studentID = response.data.student_response.studentID;
                            }
                            vm._reloadDtPage();
                        }
                    }
                });
            }
        }

        if (vm.dialogData.type == "edit")
        {
            if (vm.dialogData.is_renewal == 1) {
                vm.is_renewal = true;
            } else {
                vm.is_renewal = false;
            }
        }
        vm.onChangeRenewal = function ()
        {

            if (vm.is_renewal == true) {
                vm.dialogData.is_renewal = 1;
            } else {
                vm.dialogData.is_renewal = 0;
            }
        }
        vm.btnRedirectToWhatsapp = function() {
            var contact_no = vm.dialogData.contact_number.replaceAll(' ', '');
                if(contact_no[0] == '+'){
                    contact_no = contact_no.replace(/[^a-zA-Z0-9 ]/g, "");
                    var link = 'https://wa.me/' + contact_no + '?text=hi ' + vm.dialogData.full_name;
                } else {
                    contact_no = contact_no.replace(/[^a-zA-Z0-9 ]/g, "");
                    if (contact_no.length > 8) {
                        var code = contact_no.substring(0, 2);
                        if (code == 65) {
                            contact_no = contact_no.substring(2);
                        }
                    }
                    var link = 'https://wa.me/65' + contact_no + '?text=hi ' + vm.dialogData.full_name;
                }
                    
            window.open(link , '_blank');
        }
        vm.onDuplicateClick = function (data) {
            dialogData.title = 'Add New Student';
            dialogData.type = 'add';
            dialogData.studentID = null;
            dialogData.user_id = null;
            dialogData;
            ApiService.GetStudentId({}).then(function (response) {
                if (response.status == 1) {
                    vm.dialogData.studentId_number = response.data;
                }
            });
            if (vm.dialogData.email != undefined) {
                var requestData = {
                    "email": vm.dialogData.email
                }
                ApiService.checkEmailUnique({
                    data: requestData,
                    dtInstance: vm.dtInstance,
                    success: function (response) {
                        if (response.status == 0) {
                            Utils.showLoader(false);
                            vm.showEmailError = response.data.message;
//                            Utils.showToast({text: response.data.message});
                        } else {
                            vm.showEmailError = false;
                            Utils.showLoader(false);
//                            Utils.showToast({text: response.data.message});
                        }
                    }
                });
            }
        }

    }
})();

(function()
{
    'use strict';

    angular.module('app.students')
            .controller('AddStudentAttendanceController', AddStudentAttendanceController);

    /** @ngInject */
    function AddStudentAttendanceController(api, usSpinnerService, dialogData, attendanceObj, ApiService, $http, dtPromiseFn, $mdToast, $mdDialog, $document, $compile, $scope, $q, $resource, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, Utils)
    {

        var vm = this;
        vm.dialogData = dialogData;
        vm.dialogDataCopy = dialogData;
        vm.closeDialog = closeDialog;
        vm.attendanceObj = attendanceObj;
        vm.data = {};
        var checkboxarray = [];
        vm.dtPromiseFn = dtPromiseFn;
       
        // Paginators
        function init(){
            for(var i=0;i<vm.dialogDataCopy.Attendance.length;i++){
                checkboxarray.push(vm.dialogDataCopy.Attendance[i].isPresent);
            }
        }init();

        vm.ToggleCheckbox = function(e, value) {
            var arrAttendance = vm.attendanceObj;

        }
        
        vm.onChange = function(value){
//            console.log(vm.dialogDataCopy.Attendance[0][value.$index].isPresent);
             vm.dialogData.Attendance[value.$index].isPresent = checkboxarray[value.$index];
            console.log("changed");
        }

        vm._reloadDtPage = function() {
            vm.dtInstance.changeData(dtPromiseFn());

        };
        function closeDialog()
        {
            $mdDialog.cancel();
        }


        vm.onSaveAttendanceTap = function(e) {
            var studentsObj = [];
            for (var i = 0; i < vm.attendanceObj.length; i++) {
                if (vm.attendanceObj[i].bAllow == false) {
                    var attendance = 0;
                }
                else {
                    var attendance = 1;
                }
                studentsObj.push({id: vm.attendanceObj[i].id, attendance: attendance})
            }
            var requestData = {
                "schedule_class_id": vm.data.schedule_class_id,
                "schedule_date": vm.data.schedule_date,
                "students": studentsObj
            }
            ApiService.AddAttendance({
                data: requestData,
                dtInstance: vm.dtInstance,
                success: function(response) {

                }
            });
        }

    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.skills', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State

    }
})();
(function()
{
    'use strict';

    angular.module('app.skills')
            .controller('AddSkillsDialogController', AddSkillsDialogController);

    /** @ngInject */
    function AddSkillsDialogController($mdDialog, dialogData, ApiService,  Utils, dtInstance, dtPromiseFn)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.dtInstance = dtInstance;
        vm.dtPromiseFn = dtPromiseFn;

        // Methods
        vm.closeDialog = closeDialog;
        vm.onDeleteBtnTap = onDeleteBtnTap;
        vm.onSaveSkillBtnTap = onSaveSkillBtnTap;


        init();

        //////////

        /**
         * Initialize
         */
        function init()
        {
            vm.dialogData.title = (vm.dialogData.type === 'add' ? 'Add New Skill' : 'Edit Skill');
        }

//        vm._reloadDtPage = function() {
//            vm.dtInstance.reloadData();
//        };


        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }
        vm._reloadDtPage = function() {
            vm.dtInstance.changeData(dtPromiseFn());

        };
        function onDeleteBtnTap(e) {
            var deleteData = {
                "skills": [vm.dialogData.id]
            }

            var confirm = $mdDialog.confirm()
                    .title('Confirm Delete Skill ?')
                    .textContent('Are you sure you want to delete selected Skill ?')
                    .ariaLabel('Delete')
                    .targetEvent(e)
                    .ok('Delete')
                    .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                Utils.showLoader(true);
                ApiService.DeleteSkill({
                    data: deleteData,
                    success: function(response) {
                        Utils.showLoader(false);
                        if (response.status === 0) {
                            Utils.showToast({text: response.data.message, 'type': 0});
                        } else {
                            Utils.showToast({text: response.data.message, 'type': 1});
                            vm._reloadDtPage();
                        }
                    }
                });
            }, function() {
            });
        }


        function onSaveSkillBtnTap(e) {
            Utils.showLoader(true);

//here we will have the new data to be saved.
            vm.dialogData;
            ApiService.AddUpdateSkill({
                data: vm.dialogData,
                dtInstance: vm.dtInstance,
                success: function(response) {
                    if (response.status === 0) {
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 0});
                    } else {
                        $mdDialog.hide(vm.dialogData);
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 1});
                        vm._reloadDtPage();
                    }
                }
            });
        }
        vm.onDuplicateClick = function(data) {
            dialogData.title = 'Add New Skill';
            dialogData.type = 'add';
            dialogData.id = null;
            dialogData;

        }

    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.schools', ['ngFileUpload' ])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State

    }
})();
(function()
{
    'use strict';
    angular.module('app.schools')
            .controller('AddSchoolsDialogController', AddSchoolsDialogController);
    /** @ngInject */
    function AddSchoolsDialogController($mdDialog, dialogData, ApiService, $mdToast, Utils, dtInstance, dtPromiseFn)
    {
        var vm = this;
        vm.dtPromiseFn = dtPromiseFn;
        // Data
        vm.dialogData = dialogData;
        vm.dtInstance = dtInstance;
        vm.imgSize = false;
        // Methods
        vm.closeDialog = closeDialog;
        //vm.onDeleteBtnTap = onDeleteBtnTap;
        vm.onSaveSchoolBtnTap = onSaveSchoolBtnTap;
        init();
        //////////

        /**
         * Initialize
         */
        function init()
        {
            vm.dialogData.dialogName = (vm.dialogData.type === 'add' ? 'Add New School' : 'Edit School');
        }

        vm._reloadDtPage = function() {
            vm.dtInstance.changeData(dtPromiseFn());
        };
        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }
        /*
        if (vm.dialogData.type === 'edit') {
            if (vm.dialogData.capacity != undefined) {
                vm.dialogData.capacity = parseInt(vm.dialogData.capacity);
            }

        }
*/
        function onDeleteBtnTap(e) {
            var deleteData = {
                "schools": vm.dialogData.schoolID
            }

            var confirm = $mdDialog.confirm()
                    .title('Confirm Delete School ?')
                    .textContent('Are you sure you want to delete selected School ?')
                    .ariaLabel('Delete')
                    .targetEvent(e)
                    .ok('Delete')
                    .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                Utils.showLoader(true);
                ApiService.DeleteSchool({
                    data: deleteData,
                    success: function(response) {
                        Utils.showLoader(false);
                        if (response.status === 0) {
                            Utils.showToast({text: response.data.message, 'type': 0});
                        } else {
                            Utils.showToast({text: response.data.message, 'type': 1});
                            vm._reloadDtPage();
                        }
                    }
                });
            }, function() {
            });
        }

        function onSaveSchoolBtnTap(e) {
            Utils.showLoader(true);
            vm.dialogData.logo = vm.dialogData.logo === undefined ? null : vm.dialogData.logo;
//here we will have the new data to be saved.
            vm.dialogData;
            ApiService.AddUpdateSchool({
                data: vm.dialogData,
                dtInstance: vm.dtInstance,
                success: function(response) {
                    if (response.status === 0) {
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 0});
                    }
                    else {
                        $mdDialog.hide(vm.dialogData);
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 1});
                        vm._reloadDtPage();
                    }
                }
            });
        }
        vm.onDuplicateClick = function(data) {
            dialogData.dialogName = 'Add New School';
            dialogData.type = 'add';
            dialogData.schoolID = null;
            dialogData;
        }
        
        
        
        vm.onFileSelect = function(files) {
            if (!files || files.length == 0) {
                return;
            }
            vm.handleFiles(files);

        };

        vm.handleFiles = function(files) {
            // Check for the various File API support.
            if (window.FileReader) {
                // FileReader are supported.
                getAsText(files[0]);
            } else {
                alert('FileReader are not supported in this browser.');
            }
        };

        function getAsText(fileToRead) {
            var reader = new FileReader();
            // Read file into memory as UTF-8      
            reader.readAsText(fileToRead);
            // Handle errors load
            reader.onload = loadHandler;
            reader.onerror = errorHandler;
        }

        function loadHandler(event) {
            var csv = event.target.result;
            processData(csv);
        }

        function processData(csv) {
            var allTextLines = csv.split(/\r\n|\n/);
            var lines = [];
            for (var i = 0; i < allTextLines.length; i++) {
                var data = allTextLines[i].split(';');
                var tarr = [];
                for (var j = 0; j < data.length; j++) {
                    tarr.push(data[j]);
                }
                lines.push(tarr);
            }
            Utils.showLoader(true);
            ApiService.importTeachers({
                data: {dataToImport: 'data:text/csv;charset=utf-8;base64,' + btoa(unescape(encodeURIComponent(csv)))},
                success: function(response) {
                    Utils.showLoader(false);
                    if (response.status == 0) {
                        Utils.showToast({text: response.data.message, 'type': 0});
                    } else {
                        var dialogData = {};
                        dialogData.errors = response.data.message.errors;
                        dialogData.messages = response.data.message.messages;
                        $mdDialog.show({
                            controller: 'showTeacherLogsController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/teachers/add-teachers/show-log-teachers-dialog.html',
                            parent: angular.element($document.body),
//                            clickOutsideToClose: true,
                            locals: {
                                dialogData: angular.copy(dialogData),
                                dtInstance: vm.dtInstance,
                                dtPromiseFn: vm.dtPromiseFn

                            }
                        }).then(function(response)
                        {
                        });
//                        Utils.showToast({text: response.data.message});
                        vm._reloadDtPage();
                    }
                }
            });
        }

        function errorHandler(evt) {
            if (evt.target.error.name == "NotReadableError") {
                alert("Canno't read file !");
            }
        }
        
        vm.encodeImageFileAsURL = function () {
                
                /*
            var fi = document.getElementById('inputFileToLoad'); // GET THE FILE INPUT.

            // VALIDATE OR CHECK IF ANY FILE IS SELECTED.
            if (fi.files.length > 0) {
                // RUN A LOOP TO CHECK EACH SELECTED FILE.
                for (var i = 0; i <= fi.files.length - 1; i++) {

                    var fsize = fi.files.item(i).size;      // THE SIZE OF THE FILE.
                    alert(Math.round((fsize / 1024)));
                    if(Math.round((fsize / 1024)) > 1024)
                    {
                        return;
                    }
                }
            }
            
            */
           
            var fileInput = $('#inputFileToLoad');
            var maxSize = fileInput.data('max-size');
            
                if(fileInput.get(0).files.length){
                    var fileSize = fileInput.get(0).files[0].size;
                    var a = fileInput.get(0).files[0].size /1000;
                    
                    if(fileSize>maxSize){
                        
                        vm.imgSize = true;
                        
                    }
                    else
                    {
                        vm.imgSize = false;
                    }
                }

            
                
                
                
                var filesSelected = document.getElementById("inputFileToLoad").files;
                if (filesSelected.length > 0) {
                var fileToLoad = filesSelected[0];

                var fileReader = new FileReader();

                fileReader.onload = function (fileLoadedEvent) {
                    var srcData = fileLoadedEvent.target.result; // <--- data: base64
                    
                    vm.dialogData.logo = srcData ; 
//                    var newImage = document.createElement('img');
//                    newImage.src = srcData;

//                    document.getElementById("imgTest").innerHTML = newImage.outerHTML;
                    //alert("Converted Base64 version is " + document.getElementById("imgTest").innerHTML);
                    //console.log("Converted Base64 version is " + document.getElementById("imgTest").innerHTML);
                }
                fileReader.readAsDataURL(fileToLoad);
            }
            
        }
        
        function GetFileSize()
        {
            alert();
        }
        
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.schedule', ['ui.timepicker','ngSanitize', 'ui.select','720kb.datepicker'])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
//        $stateProvider
//                    .state('app.courses', {
//                        url: '/courses',
//                        views: {
//                            'content@app': {
//                                templateUrl: 'app/main/courses/courses.html',
//                                controller: 'CoursesController as vm'
//                            }
//                        },
//                         
////                        ncyBreadcrumb: {
////                            label: 'Courses',
////                        },
////                        data: {
////                            bAllow: getAllowedState(mergedArr, "4")
////                        }
//                    });


        // Translation
//        $translatePartialLoaderProvider.addPart('app/main/courses');
    }
})();
(function () {
    'use strict';

    angular.module('app.schedule')
        .controller('ShowDescriptionController', ShowDescriptionController);

    /** @ngInject */
    function ShowDescriptionController($mdDialog, dialogData, Utils, ApiService, $document, dtPromiseFn, curView, updateScheduler, $state, GlobalPool, $rootScope) {
        var vm = this;

        // Data
        vm.roleID = $rootScope.roleID;
        vm.dialogData = dialogData;
        var userInfo = GlobalPool.getUserInfo();

        console.log(userInfo);

        vm.closeDialog = closeDialog;
        vm.dtPromiseFn = dtPromiseFn;
        vm.PrintPreview = PrintPreview;
        vm.currentView = curView;
        vm.updateScheduler = updateScheduler;
        vm.studentName = "";
        vm.selectedTeacher = "";
        vm._bDisableTeacherDropdown = true;
        //////////
        /**
         * Initialize
         */
        vm.dialogData.title = "Course Name";
        vm.dialogData.start_time = tConvert(vm.dialogData.start_time);
        function init() {
            if (vm.dialogData.courseID == null) {
                vm.dialogData.dlgName = vm.dialogData.intakeID;
            }
            vm.dialogData.title = "Course Name";
            var count = vm.dialogData.studentData.length - 1;

            for (var i = 0; i < vm.dialogData.studentData.length; i++) {
                if (count != i) {
                    vm.studentName = vm.studentName + vm.dialogData.studentData[i].full_name + ',';
                    continue;
                }
                vm.studentName = vm.studentName + vm.dialogData.studentData[i].full_name;
            }
            var formateDate = vm.dialogData.scheduleDate.split('-');
            vm.scheduleDate = formateDate[2] + '/' + formateDate[1] + '/' + formateDate[0];
            getTeacherAvailability();
        }
        init();

        function getTeacherAvailability() {
            var requestData = {
                'schedule_class_id': vm.dialogData.scheduleClassID,
                'selected_date': vm.dialogData.scheduleDate,
                'startTime': vm.dialogData.start_time,
                'endTime': vm.dialogData.end_time,
                'auth_token': userInfo.auth_token
            };
            Utils.showLoader(true);
            ApiService.TeacherAvailability({
                data: requestData,
                success: function (response) {

                    Utils.showLoader(false);
                    if (response.status == 0) {
                        Utils.showToast({ text: response.data.message, 'type': 0 });
                    } else {
                        vm.availableTeachers = response.data;

                        if (typeof vm.dialogData.teacherAvailable !== 'undefined' && vm.dialogData.teacherAvailable.length > 0) {
                            vm.selectedTeacher = vm.dialogData.teacherAvailable[0]['id'];
                        }

                    }
                }
            });
        }

        vm.editTeacherDialog = function () {
            vm._bDisableTeacherDropdown = false;
        }

        function tConvert(time) {
            // Check correct time format and split into components
            time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
            if (time.length > 1) { // If time format correct
                time = time.slice(1);  // Remove full string match value
                time[5] = +time[0] < 12 ? ' am' : ' pm'; // Set AM/PM
                time[0] = +time[0] % 12 || 12; // Adjust hours
                time.splice(3, 1)
            }
            return time.join(''); // return adjusted time or original string
        }
        vm.onAdhocEditIntakeTap = function (e, scheduleClassID, intakeID) {
            Utils.showLoader(true);
            var intakeID = {
                "intake": intakeID,
                "scheduleClassId": scheduleClassID
            }
            ApiService.getEditDetails({
                data: intakeID,
                success: function (response) {
                    var dialogData = response.data;
                    dialogData.type = 'edit';
                    console.log(dialogData);
                    $mdDialog.show({
                        controller: 'AddAdhocClassDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/dashboard/add-adhoc-class/add-adhoc-class-dialog.html',
                        parent: angular.element($document.body),
                        targetEvent: e,
                        //                                            clickOutsideToClose: true,
                        locals: {
                            dialogData: angular.copy(dialogData),
                            dtInstance: vm.dtInstance,
                            dtPromiseFn: vm.dtPromiseFn,
                            currentView: vm.currentView,
                            updateScheduler: updateScheduler

                        }
                    }).then(function (response) {
                    });
                    //                              
                }
            });
        }
        vm.onEditIntakeTap = function (e, scheduleClassID, intakeID) {
            vm.intakeID = intakeID;
            vm.scheduleClassID = scheduleClassID;
            var checkData = {
                "schedule_class_id": scheduleClassID
            }
            ApiService.checkIntakeStart({
                data: checkData,
                success: function (response) {
                    if (response.status == 0) {
                        Utils.showToast({ text: response.data.message, 'type': 0 });
                    } else {
                        Utils.showLoader(true);
                        var intakeID = {
                            "intake": vm.intakeID,
                            "scheduleClassId": vm.scheduleClassID
                        }
                        ApiService.getEditDetails({
                            data: intakeID,
                            success: function (response) {
                                var dialogData = response.data;
                                //                                var dialogData = vm.arrIntakes[scheduleClassID];
                                dialogData.Status = dialogData.Status == 1 ? true : false;
                                dialogData.scheduleDate = vm.dialogData.scheduleDate;
                                dialogData.dialogtype = "edit";
                                dialogData.showTypeDialog = "";
                                ApiService.GetCourse({}).then(function (response) {
                                    var arrCourses = response.data;
                                    var courseobj = [];
                                    for (var i = 0; i < arrCourses.length; i++) {
                                        courseobj.push(
                                            {
                                                courseID: arrCourses[i].courseID,
                                                capacity: arrCourses[i].batch,
                                                language: arrCourses[i].language,
                                                title: arrCourses[i].title,
                                                recurrence_rule: arrCourses[i].recurrence_rule,
                                                class_duration: arrCourses[i].class_duration,
                                                level: arrCourses[i].level,
                                                series: arrCourses[i].series,
                                                books: arrCourses[i].books,
                                                type: arrCourses[i].type

                                            });
                                    }
                                    ApiService.GetStudents({}).then(function (response) {
                                        var student = response.data;
                                        var studentobj = [];
                                        for (var i = 0; i < student.length; i++) {
                                            studentobj.push({ id: student[i].studentID, text: student[i].full_name });
                                        }
                                        Utils.showLoader(false);
                                        $mdDialog.show({
                                            controller: 'EditIntakeDialogController',
                                            controllerAs: 'vm',
                                            templateUrl: 'app/main/schedule/add-intake/add-intake-dialog.html',
                                            parent: angular.element($document.body),
                                            targetEvent: e,
                                            //                                            clickOutsideToClose: true,
                                            locals: {
                                                dialogData: angular.copy(dialogData),
                                                dtInstance: vm.dtInstance,
                                                courseoptions: courseobj,
                                                studentsobj: studentobj,
                                                dtPromiseFn: vm.dtPromiseFn,
                                                currentView: vm.currentView,
                                                updateScheduler: updateScheduler

                                            }
                                        }).then(function (response) {
                                        });
                                    });
                                });
                            }
                        });
                    }
                }
            });
        };
        vm.changeTeacher = function () {
            var requestData = {
                teacher_id: vm.selectedTeacher,
                schedule_class_id: vm.dialogData.scheduleClassID,
                scheduleDate: vm.dialogData.scheduleDate
            };
            Utils.showLoader(true);
            ApiService.TrainerSave({
                data: requestData,
                success: function (response) {

                    Utils.showLoader(false);
                    if (response.status == '1') {
                        Utils.showToast({ text: response.data.message, 'type': 1 });
                        $mdDialog.hide(vm.dialogData);
                    } else {
                        Utils.showToast({ text: response.data.message, 'type': 0 });
                    }
                }
            });
        }
        function PrintPreview() {
            var jTemp = $("<div class='print-block'></div>");
            jTemp.html($("#printarea").html());

            var toPrint = jTemp[0];//document.getElementById('printarea');
            jTemp.find("table").css("border-collapse", "collapse")
            jTemp.find("table td").css("border", "1px solid grey")
            jTemp.find("table th").css("border", "1px solid grey")
            var popupWin = window.open('', '_blank', 'width=350,height=150,location=no,left=200px');

            popupWin.document.open();
            popupWin.document.write('<html><title>::Print Preview::</title></head><body">')
            popupWin.document.write(toPrint.innerHTML);
            popupWin.document.write('</html>');
            popupWin.document.close();
        }

        function reloadData() {
            vm.dtInstance.reloadData();
        }
        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(dtPromiseFn());

        };
        vm.onDeleteBtnTap = function () {
            var deleteData = {
                "intakes": [vm.dialogData.scheduleClassID]
            }

            var confirm = $mdDialog.confirm()
                .title('Confirm Delete of selected Intake?')
                .textContent('Are you sure you want to delete selected Intake ?')
                .ariaLabel('Delete')
                .ok('Delete')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function () {
                Utils.showLoader(true);
                ApiService.DeleteIntake({
                    data: deleteData,
                    success: function (response) {
                        vm.updateScheduler();
                        Utils.showLoader(false);
                        if (response.status == 0) {
                            Utils.showToast({ text: response.data.message, 'type': 0 });
                        } else {
                            Utils.showToast({ text: response.data.message, 'type': 1 });
                            // reloading needs to be handled for calendar ..Hence commented reloading line  
                            //                            vm._reloadDtPage();
                        }
                    }
                });
            }, function () {
            });
        }
        function closeDialog() {
            $mdDialog.cancel();
        }

        vm.onSwapRoomTap = function () {

            $rootScope.$root.calendarScheduleClassID = vm.dialogData.scheduleClassID;

            $state.go('app.intakes');
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.schedule')
            .controller('AddScheduleDialogController', AddScheduleDialogController);

    /** @ngInject */
    function AddScheduleDialogController($mdDialog, dialogData, ApiService, $mdToast, Utils, dtInstance, studentsobj, updateScheduler, DTOptionsBuilder, $http, DTColumnBuilder, $compile, $scope) {
        var vm = this;
        window.h = vm;
        // Data
        vm.dialogData = dialogData;
        vm.dtInstance = dtInstance;
        vm.start = new Date();
        vm.end = new Date();
        vm.classType = Focus.ENUMS.CLASS_TYPE;
        vm.courseType = Focus.ENUMS.COURSE_FILTERTYPE;
        vm.coloroption = Focus.ENUMS.INTAKE_COLOR;
        vm.Before = true;
        vm.After = false;
        // Methods
        vm.closeDialog = closeDialog;
        vm.onDeleteBtnTap = onDeleteBtnTap;
        vm.onSaveIntakeBtnTap = onSaveIntakeBtnTap;
        vm.studentsobj = studentsobj;
        vm.updateScheduler = updateScheduler;
        vm.hide = true;
        vm.onchangeOption = onchangeOption;
        vm.isChangeType = false;
        vm.isIntakeChanged = false;
        vm.isTimeChanged = false;
        vm.isStartDateChanged = false;
        vm.isEndTimeChanged = false;
        vm.TypeOther = false;
        vm.enableDates = {};
        vm.onClick = onClick;
        vm.Error = false;
        var cnt = 0;
        init();

        /**
         * Initialize
         */
        function onClick(color) {
            vm.dialogData.color = color;
            if (vm.dialogData.color) {
                vm._isColorSelected = false;
            }
        }

        vm.onlyWeekendsPredicate = function (date) {
            //            date = new Date();
            var day = date.getDay();
            if (isDateInRange(date)) {
                return day === 0 || day === 1 || day === 2 || day === 3 || day === 4 || day === 5 || day === 6 ;
            } else {
                return null;
            }
        }
        var isDateInRange = function (date) {
            //            var dates = ["2016-06-17", "2016-06-18", "6/19/2016", "6/20/2016", "6/21/2016", "6/22/2016", "6/26/2016", "7/3/2016", "7/10/2016", "7/4/2016"];
            //            var day = [];
            if (vm.enableDates.length != 0) {
                var dates = vm.enableDates;
                var curDate = null;
                for (var i = 0; i < dates.length; i++) {
                    curDate = new Date(dates[i]);
                    if (date.getDate() == curDate.getDate() && date.getFullYear() && curDate.getFullYear() &&
                            date.getMonth() == curDate.getMonth()) {
                        return true;
                    }
                }

                return false;
            }
        }

        function init() {
            vm.dialogData.title = (vm.dialogData.Type === 'add' ? 'Create Ad Hoc Class' : 'Edit Intake');
            $(document.body).addClass("schedule-dialog-visible");
            if (vm.dialogData.Type === 'add') {
                vm.dialogData.start_time = new Date();
                vm.dialogData.start_time.setHours(12);
                vm.dialogData.start_time.setMinutes(0);
                vm.dialogData.start_time.setSeconds(0);
                vm.dialogData.start_time.setMilliseconds(0);

            }
        }


        function onchangeOption(typeId) {
            vm.isChangeType = true;
            if (typeId == 4 || typeId == 2) {

                vm.hide = false;
                vm.dialogData.end_time = new Date();
                vm.dialogData.end_time.setHours(0);
                vm.dialogData.end_time.setMinutes(0);
                vm.dialogData.end_time.setSeconds(0);
                vm.dialogData.end_time.setMilliseconds(0);
            } else {

                vm.hide = true;

            }
            if (typeId == 4) {
                vm.TypeOther = true;
                vm.showIntake = false;
            } else {
                vm.showIntake = true;
                vm.TypeOther = false;
                vm.dialogData.color = '';
              
                vm.getAdhocSuggestion();

            }
            
            vm.checkForTeacherCall();
        }

        vm._onStartTimeChange = function () {
            $(".ui-timepicker-wrapper").css("display", 'none');
            if (vm.dialogData.start_time != undefined) {
                if (vm.dialogData.type == '3') {
                    if (vm.isIntakeChanged && vm.isChangeType) {
                        //                if (vm.previousTime != moment(vm.dialogData.start_time).format('h:mm:ss a')) {
                        vm.isTimeChanged = true;
                        if (vm.dialogData.type == 4 || vm.dialogData.type == 2) {
                            return;
                        } else {
                            vm.getAdhocSuggestion();
                        }
                    }
                } else {
                    vm.isTimeChanged = true;
                    if (vm.isEndTimeChanged) {
                        vm.getAdhocSuggestion();
                    }
                }
            }
        };
        vm._onEndTimeChange = function () {
            if (vm.dialogData.end_time != undefined) {


                if (vm.isChangeType && vm.isTimeChanged) {
                    //                if (vm.previousTime != moment(vm.dialogData.start_time).format('h:mm:ss a')) {
                    vm.isEndTimeChanged = true;
                    vm.getAdhocSuggestion();
                    //                    vm.previousTime = moment(vm.dialogData.start_time).format('h:mm:ss a');
                    //                }
                }
            }
        };
        vm._onStartDateChange = function (start_date) {
            
            vm.isStartDateChanged = true;
            if (vm.isIntakeChanged && vm.isChangeType && vm.isTimeChanged) {
                vm.getAdhocSuggestion();
            }
            if (vm.isEndTimeChanged && vm.isChangeType && vm.isTimeChanged) {
                vm.getAdhocSuggestion();
            }
        };
        $scope.$watch('vm.dialogData.intakeID',function(newVal,oldVal){
            
            if(cnt >= 1){
                if(typeof vm.dialogData.intakeID.description.intake_id != 'undefined'){
                    var intakeID = vm.dialogData.intakeID.description.intake_id;
//                    vm.intakeType = intakeType
                    vm.changeIntake(intakeID);
                }
                
            }
            cnt++;
        });
        
        vm.changeIntake = function (intakeID) {
            vm.isIntakeChanged = true;
            
            var dataIntake = {
                "intakeID": intakeID,
            };
            Utils.showLoader(true);
            ApiService.GetAdhocStudent({
                data: dataIntake,
                success: function (response) {
                    Utils.showLoader(false);
                    var students = response.data;
                    var student = [];
                    for (var i = 0; i < students.length; i++) {
                        student.push(students[i].id);
                    }
                    vm.dialogData.students = student;
                }

            });
            vm.checkForTeacherCall();

        }

        vm.getAdhocSuggestion = function () {
            var requestData = {
                "type": vm.dialogData.type,
            };
            if (vm.isChangeType && vm.isTimeChanged) {
                if (vm.isIntakeChanged) {
                    var intakeID = vm.dialogData.intakeID.description.intake_id;
                    requestData.intakeID = intakeID;
                }
                if (angular.isDate(vm.dialogData.start_time)) {
                    var startTime = moment(vm.dialogData.start_time).format('LTS');
                } else {
                    startTime = vm.dialogData.start_time;
                }
                requestData.start_time = startTime;
                if (vm.isStartDateChanged) {
                    requestData.start_date = moment(vm.dialogData.start_date).format('L');
                    ;
                }
                if (vm.isEndTimeChanged) {
                    if (angular.isDate(vm.dialogData.end_time)) {
                        var endTime = moment(vm.dialogData.end_time).format('LTS');
                    } else {
                        endTime = vm.dialogData.end_time;
                    }
                    requestData.end_time = endTime;
                }
            }
            Utils.showLoader(true);
            ApiService.GetAdhocSugegestion({
                data: requestData,
                success: function (response) {

                    Utils.showLoader(false);
                    
                    if (response.status == 1) {
                        response
                        var intakeData = null,
                                intakeobj = [],
                                teacherobj = [],
                                room = null,
                                roomobj = [];
                        ;
                        vm.dialogData.intake_id = response.data.intake_id;
                        if (response.data.startDate) {
                            vm.dialogData.start_date = new Date(response.data.startDate);
                        }
                        intakeData = response.data.intakeIdsForAdhoc;
                        if (intakeData) {
                            for (var i = 0; i < intakeData.length; i++) {
                                for (var j = 0; j < vm.courseType.length; j++) {
                                    if (vm.courseType[j].text == intakeData[i].courseType) {
                                        var typeName = vm.courseType[j].value;
                                    }
                                }
                                intakeobj.push({
                                    title: intakeData[i].intake_id + ", " + intakeData[i].courseName + " " + intakeData[i].courseLevel + " " + intakeData[i].courseSeries + " " + typeName,
                                    courseId: intakeData[i].courseID,
                                    intake_id: intakeData[i].intake_id
                                })
                            }
                        }
                        vm.intakeOptions = intakeobj;
                        room = response.data.roomsAvailable;
                        if (room) {

                            for (var i = 0; i < room.length; i++) {
                                roomobj.push({
                                    id: room[i].roomID,
                                    title: room[i].title
                                });
                            }
                        } else {
                            vm.showRoom = true;
                        }
                        vm.roomoption = roomobj;
                        if (response.data.teachersAvailable) {
                            vm.Before = false;
                            vm.After = true;
                            var teacher = response.data.teachersAvailable;

                            for (var i = 0; i < teacher.length; i++) {
                                teacherobj.push({
                                    id: teacher[i].id,
                                    name: teacher[i].full_name
                                });
                            }
                            vm.teacher = teacherobj;
                        } else {
                            vm.Before = true;
                            vm.After = false;
                            vm.showTeacher = true;
                        }
                        if (response.data.possibleDatesList) {
                            vm.enableDates = response.data.possibleDatesList;
                        }
                    } else {
                        if (response.data.message) {
                            vm.showMessage = response.data.message;
                            Utils.showToast({
                                text: response.data.message,
                                'type': 0
                            });
                        }
                    }
                }

            });
        }

        vm.checkForTeacherCall = function () {
            if (vm.isChangeType == true && vm.isIntakeChanged == true) {
                var intakeID = vm.dialogData.intakeID.description.intake_id;
                var dataIntake = {
                    "intakeID": intakeID,
                };
                ApiService.GetAdhocTeacher({
                    data: dataIntake,
                    success: function (response) {
                        Utils.showLoader(false);
                        if (response.data && (response.status == 1)) {
                            var teacherobj = [];
                            var teacher = response.data;
                            teacherobj.push({
                                id: response.data.id,
                                name: response.data.full_name
                            });
                            if (vm.dialogData.type == 3 || vm.dialogData.type == 2) {
                                vm.teacher = teacherobj;
                                vm.dialogData.teacherID = response.data.id;
                            } else {
                                vm.teacher = [];
                                vm.dialogData.teacherID = [];
                            }

                        }

                    }
                });
            }
        }

        vm._reloadDtPage = function () {
            vm.dtInstance.reloadData();
        };


        /**
         * Close the dialog
         */
        function closeDialog() {
            $(document.body).removeClass("schedule-dialog-visible");
            $mdDialog.cancel();
            vm.isChangeType = false;
            vm.isIntakeChanged = false;
            vm.isTimeChanged = false;
            vm.isStartDateChanged = false;
            vm.isEndTimeChanged = false;
        }

        function onDeleteBtnTap(e) {


            var confirm = $mdDialog.confirm()
                    .title('Confirm Delete of selected Intake?')
                    .textContent('Are you sure you want to delete Intake  : ' + vm.dialogData.TenantName + ' ?.')
                    .ariaLabel('Delete')
                    .targetEvent(e)
                    .ok('Delete')
                    .cancel('Cancel');
            $mdDialog.show(confirm).then(function () {
                Utils.showLoader(true);
                ApiService.DeleteTenant({
                    data: [vm.dialogData.TenantID],
                    success: function (response) {
                        vm.updateScheduler();
                        Utils.showLoader(false);
                        Utils.showToast({
                            text: "Deleted Succesfully",
                            'type': 1
                        });
                        vm._reloadDtPage();
                    }
                });
            }, function () {});
        }

        if (vm.dialogData.Type === 'edit') {
            vm.dialogData.start_date = new Date(vm.dialogData.start_date);
            if (!angular.isDate(vm.dialogData.time)) {
                var timeArr = vm.dialogData.time.split(':');
                vm.dialogData.time = new Date();
                vm.dialogData.time.setHours(timeArr[0]);
                vm.dialogData.time.setMinutes(timeArr[1]);
                vm.dialogData.time.setSeconds(timeArr[2]);
                vm.dialogData.time.setMilliseconds(0);
            }
            var teacher = vm.dialogData.teacherAvailable;
            if (teacher.length == 0) {
                vm.dialogData.teacherID = '';
                vm.Before = true;
                vm.After = false;
            } else {
                vm.Before = false;
                vm.After = true;
            }

        }
        

        function onSaveIntakeBtnTap(e) {
            Utils.showLoader(true);
            
            if (vm.dialogData.type == 4) {
                vm.dialogData.intake_id = vm.dialogData.intake_id;
            }else{
                vm.dialogData.intake_id = vm.dialogData.intakeID.originalObject.intake_id;
            }
            vm.dialogData.comments = vm.dialogData.comments === undefined ? null : vm.dialogData.comments;
            vm.dialogData.students = vm.dialogData.students === undefined ? null : vm.dialogData.students;
            var dialogData = angular.copy(vm.dialogData);
            dialogData.start_date = moment(dialogData.start_date).format('L');
            dialogData.start_time = moment(vm.dialogData.start_time).format('LTS');
            dialogData.end_time = moment(vm.dialogData.end_time).format('LTS');
            Utils.showLoader(false);
            ApiService.AddAdhocStudent({
                data: dialogData,
                dtInstance: vm.dtInstance,
                success: function (response) {
                    if (response.status == 0) {
//                        vm.Error = true;
                        Utils.showLoader(false);
                        
                        if (response.data.message.dates_error) {
                            vm.errorMessage = vm.startDate = response.data.message.dates_error;
                        }

                        if (response.data.message.room_error) {
                            vm.errorMessage = vm.showRoom = response.data.message.room_error;
                        }
                        if (response.data.message.teacher_error) {
                            vm.errorMessage = vm.showTeacher = response.data.message.teacher_error;
                        }
                        if (response.data.message.intake_id_error) {
                            vm.errorMessage = vm.showIntakeError = response.data.message.intake_id_error;
                        }
                        Utils.showToast({
                            text: vm.errorMessage,
                            'type': 0
                        });
                    } else {
                        vm.updateScheduler();
                        $mdDialog.hide(vm.dialogData);
                        Utils.showLoader(false);
                        Utils.showToast({
                            text: "Saved Succesfully",
                            'type': 1
                        });
                    }
                }
            });
        }
        vm.onDuplicateClick = function (data) {
            dialogData.title = 'Create New Intake';
            dialogData.type = 'add';
            dialogData.intakeID = null;
            dialogData;

        }

    }
})();

(function ()
{
    'use strict';
    angular.module('app.schedule')
        .config(function ($mdDateLocaleProvider) {
            $mdDateLocaleProvider.formatDate = function (date) {
                return date ? moment(date).format('DD-MM-YYYY') : '';
            };
            $mdDateLocaleProvider.parseDate = function (dateString) {
                var m = moment(dateString, 'DD-MM-YYYY', true);
                return m.isValid() ? m.toDate() : new Date(NaN);
            };
        })
        .controller('EditIntakeDialogController', EditIntakeDialogController);
    /** @ngInject */
    function EditIntakeDialogController($mdDialog, dialogData, ApiService, Utils, courseoptions, $q, studentsobj, dtInstance, $scope, dtPromiseFn, currentView, updateScheduler)
    {
        var vm = this;
        // Data
        window.h = vm;
        
        vm.dialogData = dialogData;
        vm.oldIntakeDetail = dialogData;
        var oldDateRange = vm.dialogData.dateRange;
        vm.dtInstance = dtInstance;
        vm.courseoptions = courseoptions;
        vm.timeSlot = Focus.ENUMS.TIME_SLOT;
        vm.coloroption = Focus.ENUMS.INTAKE_COLOR;
        vm.intakeSeries = Focus.ENUMS.INTAKE_SERIES;
        // Methods
        vm.dtPromiseFn = dtPromiseFn;
        vm.currentView = currentView;
        vm.updateScheduler = updateScheduler;
        vm.closeDialog = closeDialog;
        vm.onDeleteBtnTap = onDeleteBtnTap;
        vm.onSaveIntakeBtnTap = onSaveIntakeBtnTap;
        vm.onClick = onClick;
        vm.studentsobj = studentsobj;
        vm.isCourseChanged = false;
        vm.isTimeChanged = false;
        vm.isStartEndDateChanged = false;
        vm.showStartDateError = false;
        vm.showEndDateError = false;
        vm.showRoomError = false;
        vm.showTeacherError = false;
        vm._isColorSelected = true;
        vm._isFirstEditLoad = false;
        vm.showStuentsLengthError = false;
        vm.enableDates = {};
        vm.showDays = false;
        vm.onChangeCheckBox = false;
        vm.courseType = Focus.ENUMS.COURSE_FILTERTYPE,
            vm.simulateQuery = false;
        vm.isDisabled = false;
        // list of `state` value/display objects
        vm.states = loadAll();
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;
        vm.selectCourseError = false;
        function querySearch(query) {
            vm.states
            var results = query ? vm.states.filter(createFilterFor(query)) : vm.states,
                deferred;
            if (vm.simulateQuery) {
                deferred = $q.defer();
                $timeout(function () {
                    deferred.resolve(results);
                }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }
        function searchTextChange(text) {
            if (text != "") {
                var arrCourses = [];
                for (var i = 0; i < vm.courseoptions.length; i++) {
                    arrCourses.push({title: vm.courseoptions[i].title + "-" + vm.courseoptions[i].level + "-" + vm.courseoptions[i].series + "-" + vm.courseoptions[i].recurrence_rule, courseId: vm.courseoptions[i].courseID})
                }
                for (var j = 0; j < arrCourses.length; j++) {
                    if (arrCourses[j].title != text) {
                        vm.selectCourseError = true;
                    }

                }
            } else {
                vm.selectCourseError = false;
            }
//            $log.info('Text changed to ' + text);
        }


        function selectedItemChange(item) {
            debugger;
        }
//        /**
//         * Build `states` list of key/value pairs
//         */
        function loadAll() {
            var allStates = [];
            for (var i = 0; i < vm.courseoptions.length; i++) {
//                allStates.push({display: vm.courseoptions[i].title + "-" + vm.courseoptions[i].level + "-" + vm.courseoptions[i].series + "-" + vm.courseoptions[i].recurrence_rule, value: vm.courseoptions[i].courseID})
                for (var j = 0; j < vm.courseType.length; j++) {
                    if (vm.courseType[j].text == vm.courseoptions[i].type) {
                        var typeName = vm.courseType[j].value;
                    }
                }

                allStates.push(vm.courseoptions[i].title + "-" + vm.courseoptions[i].level + "-" + vm.courseoptions[i].series + "-" + typeName)
            }
//            return allStates;
            allStates = allStates.join();
            return allStates.split(',').map(function (state) {
                return {
                    value: state.toLowerCase(),
                    display: state
                };
            });
            ;
        }
////        /**
////         * Create filter function for a query string
////         */
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(state) {
                return (state.value.indexOf(lowercaseQuery) === 0);
            };
        }

        vm.days = Focus.ENUMS.RECURRANCE_DAYS;
        vm.onlyWeekendsPredicate = function (date) {
            var day = date.getDay();
            if (isDateInRange(date)) {
                return true;
            } else
            {
                return null;
            }
        };
        var isDateInRange = function (date) {
            if (vm.enableDates.length != 0) {
                var dates = vm.enableDates;
                var curDate = null;
                for (var i = 0; i < dates.length; i++) {
                    curDate = new Date(dates[i]);
                    if (date.getDate() == curDate.getDate() && date.getFullYear() && curDate.getFullYear()
                        && date.getMonth() == curDate.getMonth()) {
                        return true;
                    }
                }

                return false;
            }
        };
        vm.onChangeFlexible = function () {
            Utils.showLoader(true);
            vm.searchText = '';
            if (vm.showDays == true) {
                vm.showDays = false;
            }
            if (vm.dialogData.is_flexible == true) {
                var flexible = 1;
            } else {
                var flexible = 0;
            }
            var requestData = {
                'flexible': flexible
            }
            ApiService.GetCourse({
                data: requestData,
                success: function (response) {
                    Utils.showLoader(false);
                    if (response.status != 0) {
                        var arrCourses = response.data;
                        var courseobj = [];
                        for (var i = 0; i < arrCourses.length; i++) {
                            courseobj.push(
                                {courseID: arrCourses[i].courseID,
                                    capacity: arrCourses[i].batch,
                                    language: arrCourses[i].language,
                                    title: arrCourses[i].title,
                                    recurrence_rule: arrCourses[i].recurrence_rule,
                                    class_duration: arrCourses[i].class_duration,
                                    level: arrCourses[i].level,
                                    series: arrCourses[i].series,
                                    books: arrCourses[i].books,
                                    type: arrCourses[i].type
                                });
                        }
                        vm.courseoptions = courseobj;

                        vm.states = loadAll();
                    } else {
                        vm.dialogData.is_flexible == false;
                        Utils.showToast({text: "No Flexible Courses Available", 'type': 0});
                    }
                }
            });
        }

        $scope.select2Options = {
            'multiple': true,
            'simple_tags': true
        };
        function onClick(color) {
            vm.dialogData.color = color;
            if (vm.dialogData.color) {
                vm._isColorSelected = false;
            }
        }
        vm.ToggleCheckbox = function (e, value) {
            vm.onChangeCheckBox = true;
            var arrDays = vm.days;
            var allowedDays = [];
            for (var i = 0; i < arrDays.length; i++) {
                if (arrDays[i].bAllow === true) {
                    allowedDays.push(arrDays[i].id);
                }
            }
            vm.dialogData.weekdays = allowedDays;
            if (vm.isCourseChanged && vm.isTimeChanged) {
                vm.getAutoSuggestions();
            }
        }
        vm._onCourseChanged = function () {

            if (vm.selectedItem != null) {
                vm.selectCourseError = false;
                var arrCourses = [];
                for (var i = 0; i < vm.courseoptions.length; i++) {
                    for (var j = 0; j < vm.courseType.length; j++) {
                        if (vm.courseType[j].text == vm.courseoptions[i].type) {
                            var typeName = vm.courseType[j].value;
                        }
                    }
                    arrCourses.push({title: vm.courseoptions[i].title + "-" + vm.courseoptions[i].level + "-" + vm.courseoptions[i].series + "-" + typeName, courseId: vm.courseoptions[i].courseID})

                }
                for (var j = 0; j < arrCourses.length; j++) {
                    if (arrCourses[j].title == vm.selectedItem.display) {
                        vm.dialogData.courseID = arrCourses[j].courseId
                    }

                }

                vm.selectedCourse = vm.dialogData.courseID;
                for (var i = 0; i < vm.courseoptions.length; i++) {
                    if (vm.dialogData.courseID == vm.courseoptions[i].courseID) {
                        vm.batchLength = vm.courseoptions[i].capacity;
                        if (vm.courseoptions[i].recurrence_rule == "Weekly") {
                            vm.showDays = true;
                        } else {
                            vm.dialogData.weekdays = [];
                            vm.showDays = false;
                        }
                    }
                }
                vm.isCourseChanged = true;
                if (vm.isTimeChanged) {
                    vm.getAutoSuggestions();
                }
            } else {

            }
        };
        vm._onStartTimeChange = function () {
//            $(".ui-timepicker-wrapper").css("display", 'none');
            if (vm.dialogData.start_time != undefined) {
                if (vm.isCourseChanged) {
                    if (vm.previousTime != moment(vm.dialogData.start_time).format('h:mm:ss a')) {
                        vm.isTimeChanged = true;
                        vm.getAutoSuggestions();
                        vm.previousTime = moment(vm.dialogData.start_time).format('h:mm:ss a');
                    }
                }
                if (vm.isCourseChanged && vm.onChangeCheckBox) {
                    if (vm.previousTime != moment(vm.dialogData.start_time).format('h:mm:ss a')) {
                        vm.isTimeChanged = true;
                        vm.getAutoSuggestions();
                        vm.previousTime = moment(vm.dialogData.start_time).format('h:mm:ss a');
                    }
                }
            }
        };
        vm._onStartDateChange = function (start_date) {
            vm.isStartEndDateChanged = true;
            if (vm.isCourseChanged && vm.isTimeChanged) {
                vm.getAutoSuggestions();
            }
            vm.startDate = false;
        };
        vm._onEndDateChange = function () {
            vm.isStartEndDateChanged = true;
            if (vm.isCourseChanged && vm.isTimeChanged) {
                vm.getAutoSuggestions();
            }
            vm.startDate = false;
        };

        vm._onChangeReschedule = function () {
            if (vm.dialogData.shift_instance == "current") {
                vm.showDays = false;
            } else {
                vm.showDays = true;
            }
            vm.getAutoSuggestions();
        }
        vm.GetFormattedDate = function (formatDate) {
            var month = formatDate.getMonth() + 1;
            var day = formatDate.getDate();
            var year = formatDate.getFullYear();
            if (month <= 9) {
                month = '0' + month;
            }
            return day + "/" + month + "/" + year;
        }
        vm.getAutoSuggestions = function () {
            if (angular.isDate(vm.dialogData.start_time)) {
                var startTime = moment(vm.dialogData.start_time).format('LTS');
            } else {
                startTime = vm.dialogData.start_time;
            }

            var courseid = vm.dialogData.courseID;
            var course = vm.courseoptions;
            var courseobj = [];
            for (var i = 0; i < course.length; i++) {
                if (courseid === course[i].courseID) {
                    courseobj.push(course[i]);
                }
            }
            if (vm.dialogData.dialogtype == "edit") {

                if (vm.dialogData.weekdays != undefined) {
                    if (!angular.isArray(vm.dialogData.weekdays)) {
                        var arrWeekDay = vm.dialogData.weekdays.split(",");
                        vm.dialogData.weekdays = arrWeekDay;
                    }
                }
            }
            var requestData = {
                "courseID": courseobj[0].courseID,
                "time": startTime,
                "weekdays": ["0","1","2","3","4","5","6"],
                "shift_instance": vm.dialogData.shift_instance,
                "scheduleDate": vm.dialogData.scheduleDate
            };
            if (vm.dialogData.shift_instance == "current") {
                requestData.weekdays = vm.dialogData.weekdays;
            } else {
                requestData.weekdays = vm.dialogData.weekdays;
            } // Commented and passed explicitly as client wants to select as per dates availability
            if (!(vm.isTimeChanged && !vm.isStartEndDateChanged))
            {
                if (vm.dialogData.dialogtype == "add") {
                    requestData.start_date = vm.GetFormattedDate(vm.dialogData.start_date);
                } else {
                    if (angular.isDate(vm.dialogData.start_date)) {
                        requestData.start_date = vm.GetFormattedDate(vm.dialogData.start_date);
                        requestData.end_date = vm.GetFormattedDate(vm.dialogData.end_date);
                    } else {
                        requestData.start_date = vm.dialogData.start_date;
                        requestData.end_date = vm.dialogData.end_date;
                    }
                }
                if (vm.dialogData.dialogtype == "edit") {
                    requestData.intakeID = vm.dialogData.intakeID;
                    requestData.intake_id = vm.dialogData.scheduleClassID;
                    if (!vm.isStartEndDateChanged) {
                        if (vm.dialogData.dialogtype == "add") {
                            requestData.end_date = vm.GetFormattedDate(vm.dialogData.end_date);
                        } else {
                            requestData.end_date = vm.dialogData.end_date;
                        }
                    }
                }
            }

            Utils.showLoader(true);
            ApiService.GetIntakeSuggestion({
                data: requestData,
                success: function (response) {

                    Utils.showLoader(false);
                    if (vm._isFirstEditLoad)
                    {
                        vm._isFirstEditLoad = false;
                        if (response && response.data && response.data.possibleDatesList) {
                            vm.enableDates = response.data.possibleDatesList;
                        }
                        return;
                    }
                    if (response.status == 1) {
                        vm.showMessage = false
                        var room = null, roomobj = [], teacherobj = [];
                        if (response.data) {
                            vm.dialogData.intakeID = response.data.intakeID;
                            vm.dialogData.end_time = response.data.endTime;
                            vm.dialogData.start_date = new Date(response.data.startDate);
                            vm.dialogData.end_date = new Date(response.data.endDate);
                            vm.dialogData.frequency_type = response.data.frequency_type;
                            vm.dialogData.dateRange = response.data.dateRange;
                        }
                        room = response.data.roomsAvailable;
                        if (room) {
                            roomobj = [];
                            for (var i = 0; i < room.length; i++) {
                                roomobj.push({id: room[i].roomID, title: room[i].title});
                            }
                        } else {
                            vm.showRoom = true;
//                            Utils.showToast({text: "Rooms not available"});
                        }
                        vm.roomoption = roomobj;
                        if (response.data.teachersAvailable) {
                            var teacher = response.data.teachersAvailable;
                            for (var i = 0; i < teacher.length; i++) {
                                teacherobj.push({id: teacher[i].id, name: teacher[i].full_name});
                            }
                        } else
                        {
                            vm.showTeacher = true;
//                            Utils.showToast({text: "Teachers not available"});
                        }

                        vm.teacher = teacherobj;
                        if (response.data.possibleDatesList) {
                            vm.dateRanges = response.data.datesList;
                            vm.enableDates = response.data.possibleDatesList;
                        }


                    } else {
                        if (response.data.message) {
                            vm.showMessage = response.data.message;
                            Utils.showToast({text: response.data.message, 'type': 0});
                        }
                    }
                }

            });
        };
        init();
        /**
         * Initigalize
         */
        function init()
        {
            vm.dialogData.title = (vm.dialogData.dialogtype === 'add' ? 'Add New Intake' : 'Edit Intake');
        }

        if (vm.dialogData.showTypeDialog === 'info' && vm.dialogData.dialogtype === 'edit') {
            vm.dialogData.title = "INTAKE";
        }
        $(document.body).addClass("intake-dialog-visible");
        if (vm.dialogData.dialogtype === 'add') {
            vm.isDisabled = false;
            vm.dialogData.start_date = new Date();
            vm.dialogData.end_date = new Date();
            vm.dialogData.start_time = new Date();
            vm.dialogData.start_time.setHours(0);
            vm.dialogData.start_time.setMinutes(0);
            vm.dialogData.start_time.setSeconds(0);
            vm.dialogData.start_time.setMilliseconds(0);
            ;
            vm.dialogData.end_time = new Date();
            vm.dialogData.end_time.setHours(0);
            vm.dialogData.end_time.setMinutes(0);
            vm.dialogData.end_time.setSeconds(0);
            vm.dialogData.end_time.setMilliseconds(0);
        }
        vm.previousTime = moment(vm.dialogData.start_time).format('h:mm:ss a');
        if (vm.dialogData.dialogtype === 'edit') {
            vm.isDisabled = true;
            if (vm.dialogData.courseType) {
                for (var j = 0; j < vm.courseType.length; j++) {
                    if (vm.courseType[j].text == vm.dialogData.courseType) {
                        var typeName = vm.courseType[j].value;
                    }
                }
                vm.searchText = vm.dialogData.courseName + "-" + vm.dialogData.courseLevel + "-" + vm.dialogData.courseSeries + "-" + typeName;
            }
            vm._isFirstEditLoad = true;
            vm._isColorSelected = false;
            vm.isCourseChanged = true;
            vm.isTimeChanged = true;
            vm.isStartEndDateChanged = true;
            vm.onChangeCheckBox = true;
//            vm.getAutoSuggestions();
            var room = vm.dialogData.roomAvailable;
            if (room.length == 0) {
                vm.dialogData.roomID = '';
            }
            var roomobj = [];
            for (var i = 0; i < room.length; i++) {
                roomobj.push({id: room[i].id, title: room[i].title});
            }
            vm.roomoption = roomobj;
            var teacher = vm.dialogData.teacherAvailable;
            if (teacher.length == 0) {
                vm.dialogData.teacherID = '';
            }
            var teacherobj = [];
            for (var i = 0; i < teacher.length; i++) {
                teacherobj.push({id: teacher[i].id, name: teacher[i].full_name});
            }
            vm.teacher = teacherobj;
//            vm.dialogData.start_date = new Date(vm.dialogData.start_date);
            if (!angular.isDate(vm.dialogData.start_date)) {
                vm.dialogData.start_date = Utils.getFormattedIntakeDate(vm.dialogData.start_date);
//                vm.setValue = vm.dialogData.start_of_employment;
            }
            if (!angular.isDate(vm.dialogData.end_date)) {
                vm.dialogData.end_date = Utils.getFormattedIntakeDate(vm.dialogData.end_date);
//                vm.setValue = vm.dialogData.start_of_employment;
            }
//            vm.dialogData.end_date = new Date(vm.dialogData.end_date);
            if (!angular.isDate(vm.dialogData.start_time)) {
                var timeArr = vm.dialogData.start_time.split(':');
                vm.dialogData.start_time = new Date();
                vm.dialogData.start_time.setHours(timeArr[0]);
                vm.dialogData.start_time.setMinutes(timeArr[1]);
                vm.dialogData.start_time.setSeconds(timeArr[2]);
                vm.dialogData.start_time.setMilliseconds(0);
            }
            if (vm.dialogData.frequency_type == "Weekly") {
                if (vm.dialogData.weekdays != undefined) {
                    vm.showDays = true;
                    for (var j = 0; j < vm.days.length; j++) {
                        for (var i = 0; i < vm.dialogData.weekdays.length; i++) {

                            if (vm.days[j].id == vm.dialogData.weekdays[i]) {
                                vm.days[j].bAllow = true;
                            }

                        }
                    }
                }
            }
        }

        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(dtPromiseFn());
        };
        /**
         * Close the dialog
         */
        function closeDialog()
        {
            vm.enableDates = {};
            $mdDialog.cancel();
            vm.isTimeChanged = false;
            vm.isStartEndDateChanged = false;
            vm.isEndDateChanged = false;
            vm.showStartDateError = false;
            vm.showEndDateError = false;
            vm.showRoom = false;
            vm.showTeacher = false;
            vm.startDate = false;
            vm._isFirstEditLoad = false;
            vm.onChangeCheckBox = false;
            for (var i = 0; i < vm.days.length; i++) {
                vm.days[i].bAllow = false;
            }
            $(document.body).removeClass("intake-dialog-visible");
        }

        function onDeleteBtnTap(e) {

            var deleteData = {
                "intakes": [vm.dialogData.scheduleClassID]
            }

            var confirm = $mdDialog.confirm()
                .title('Confirm Delete of selected Intake?')
                .textContent('Are you sure you want to delete selected Intake ?')
                .ariaLabel('Delete')
                .targetEvent(e)
                .ok('Delete')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function () {
                Utils.showLoader(true);
                ApiService.DeleteIntake({
                    data: deleteData,
                    success: function (response) {
                        Utils.showLoader(false);
                        if (response.status == 0) {
                            Utils.showToast({text: response.data.message, 'type': 0});
                        } else {
                            Utils.showToast({text: response.data.message, 'type': 1});
                            vm._reloadDtPage();
                        }
                    }
                });
            }, function () {
            });
        }

        function calculateDates(newDates) {
            var formatedDates = [];
            var currentDate = new Date();
            var j = 0;
            if (vm.dialogData.shift_instance == "remaining") {
                for (var i = 0; i < oldDateRange.length; i++) {
                    if (oldDateRange[i] == vm.dialogData.scheduleDate) {
                        formatedDates.push(vm.dialogData.scheduleDate);
                    } else {
                        if (new Date(oldDateRange[i]) < currentDate) {
                            formatedDates.push(oldDateRange[i]);
                        } else {
                            formatedDates.push(newDates[j]);
                            j++;
                        }
                    }
                }
            } else {
                
                var totalOldDates = Object.keys(oldDateRange).length;
                for (var i = 0; i < totalOldDates; i++) {
                    if (oldDateRange[i] == vm.dialogData.scheduleDate) {
                        formatedDates.push(newDates[j]);
                        j++;
                    } else {
                        formatedDates.push(oldDateRange[i]);
                    }
                }
            }
            return formatedDates;
        }
        
        function onSaveIntakeBtnTap(e) {
            var dialogData = angular.copy(vm.dialogData);
            if (vm.dialogData.shift_instance == "remaining") {
                var currentDate = new Date();
                var selectedDatePos;
                var scheduleDate = moment(vm.dialogData.scheduleDate).format('YYYY-MM-DD');
                var index = selectedDatePos = vm.dialogData.dateRange.indexOf(scheduleDate);
                if (vm.dialogData.dateRange.equals(oldDateRange)) {
                    if(selectedDatePos != -1)
                        vm.enableDates.splice( vm.enableDates.indexOf(scheduleDate), 1 );
                    var newDatesLength = vm.enableDates.length;
                    for(var i=0;i<=newDatesLength;i++) {
                        // remove old date for reschedule all clss
                        if(currentDate >= new Date(vm.enableDates[i])){
                            var pos = vm.enableDates.indexOf(vm.enableDates[i]);
                            if(pos != -1)
                                vm.enableDates.splice( vm.enableDates.indexOf(vm.enableDates[i]), 1 );
                        }
                    }
                    dialogData.dateRange = calculateDates(vm.enableDates);
                } else {
                    dialogData.dateRange = calculateDates(vm.dialogData.dateRange);
                }


                dialogData.start_date = moment(dialogData.start_date).format('L');
                dialogData.end_date = moment(dialogData.end_date).format('L');
            } else {
                dialogData.dateRange = calculateDates(vm.dialogData.dateRange);
                dialogData.start_date = moment(vm.oldIntakeDetail.start_date).format('L');
                dialogData.end_date = moment(dialogData.start_date).format('L');
            }

            Utils.showLoader(true);
            vm.dialogData;

            dialogData.dateRange = dialogData.dateRange.sort(function (x, y) {
                x = x.split('-').join('');
                y = y.split('-').join('');
                return x > y ? 1 : x < y ? -1 : 0;

            });
            dialogData.start_time = moment(vm.dialogData.start_time).format('LTS');
            ;
            if (dialogData.students != undefined) {
                dialogData.students = dialogData.students;
            } else {
                dialogData.students = null;
            }
            
            ApiService.AddUpdateIntake({
                data: dialogData,
                dtInstance: vm.dtInstance,
                success: function (response) {
                    vm.updateScheduler();
                    if (response.status == 0) {
                        Utils.showLoader(false);
                        if (response.data.message) {
                            Utils.showToast({text: "Sorry, could not be saved", 'type': 0});
                        }
                        if (response.data.message.dates_error) {
                            vm.startDate = response.data.message.dates_error;
                        }
                        if (response.data.message.room_error) {
                            vm.showRoom = response.data.message.room_error;
                        }
                        if (response.data.message.teacher_error) {
                            vm.showTeacher = response.data.message.teacher_error;
                        }
                    } else {
                        $mdDialog.hide(vm.dialogData);
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 1});
                    }
                }
            });
        }
        vm.onDuplicateClick = function () {
            dialogData.title = 'Add New Intake';
            dialogData.dialogtype = 'add';
            dialogData.scheduleClassID = null;
            dialogData;
        };
        
        Array.prototype.equals = function (array) {
            // if the other array is a falsy value, return
            if (!array)
                return false;

            // compare lengths - can save a lot of time 
            if (this.length != array.length)
                return false;

            for (var i = 0, l = this.length; i < l; i++) {
                // Check if we have nested arrays
                if (this[i] instanceof Array && array[i] instanceof Array) {
                    // recurse into the nested arrays
                    if (!this[i].equals(array[i]))
                        return false;
                } else if (this[i] != array[i]) {
                    // Warning - two different object instances will never be equal: {x:20} != {x:20}
                    return false;
                }
            }
            return true;
        }
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.rooms', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State

    }
})();
(function() {
    'use strict';
    angular.module('app.rooms')
        .controller('AddRoomsDialogController', AddRoomsDialogController);
    /** @ngInject */
    function AddRoomsDialogController($mdDialog, dialogData, ApiService, $mdToast, Utils, dtInstance, dtPromiseFn) {
        var vm = this;
        vm.dtPromiseFn = dtPromiseFn;
        // Data
        vm.dialogData = dialogData;
        vm.dtInstance = dtInstance;
        // Methods
        vm.closeDialog = closeDialog;
        vm.onDeleteBtnTap = onDeleteBtnTap;
        vm.onSaveRoomBtnTap = onSaveRoomBtnTap;
        init();
        //////////

        /**
         * Initialize
         */
        function init() {
            vm.dialogData.name = (vm.dialogData.type === 'add' ? 'Add New Room' : 'Edit Room');
        }

        vm._reloadDtPage = function() {
            vm.dtInstance.changeData(dtPromiseFn());
        };
        /**
         * Close the dialog
         */
        function closeDialog() {
            $mdDialog.cancel();
        }
        if (vm.dialogData.type === 'edit') {
            if (vm.dialogData.capacity != undefined) {
                vm.dialogData.capacity = parseInt(vm.dialogData.capacity);
            }

        }

        function onDeleteBtnTap(e) {
            // var checkData = {
            //     "roomID": vm.dialogData.roomID
            // }
            // ApiService.checkRoomDeletable({
            //     data: checkData,
            //     success: function(response) {
            // if (response.status == 0) {
            //     Utils.showToast({text: response.data.message, 'type': 0});
            // }
            // else {
            var deleteData = {
                "rooms": [vm.dialogData.roomID]
            }

            var confirm = $mdDialog.confirm()
                .title('Confirm Delete Room?')
                .textContent('Are you sure you want to delete Selected Room ?')
                .ariaLabel('Delete')
                .targetEvent(e)
                .ok('Delete')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                Utils.showLoader(true);
                ApiService.DeleteRoom({
                    data: deleteData,
                    success: function(response) {
                        Utils.showLoader(false);
                        if (response.status === 0) {
                            Utils.showToast({ text: response.data.message, 'type': 0 });
                        } else {
                            Utils.showToast({ text: response.data.message, 'type': 1 });
                            vm._reloadDtPage();
                        }
                    }
                });
            }, function() {});
            //  }
            //     }

            // });
        }

        function onSaveRoomBtnTap(e) {
            Utils.showLoader(true);
            // here we will have the new data to be saved.
            vm.dialogData;
            ApiService.AddUpdateRoom({
                data: vm.dialogData,
                dtInstance: vm.dtInstance,
                success: function(response) {
                    if (response.status === 0) {
                        Utils.showLoader(false);
                        Utils.showToast({ text: response.data.message, 'type': 0 });
                    } else {
                        $mdDialog.hide(vm.dialogData);
                        Utils.showLoader(false);
                        Utils.showToast({ text: response.data.message, 'type': 1 });
                        vm._reloadDtPage();
                    }
                }
            });
        }
        vm.onDuplicateClick = function(data) {
            dialogData.name = 'Add New Room';
            dialogData.type = 'add';
            dialogData.roomID = null;
            dialogData;
        }
    }
})();
(function()
{
    'use strict';

    angular
            .module('app.intakes', ['ui.timepicker', 'ui.select2','angucomplete-alt','ngSanitize','ui.select'])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
//        $stateProvider
//                    .state('app.courses', {
//                        url: '/courses',
//                        views: {
//                            'content@app': {
//                                templateUrl: 'app/main/courses/courses.html',
//                                controller: 'CoursesController as vm'
//                            }
//                        },
//                         
////                        ncyBreadcrumb: {
////                            label: 'Courses',
////                        },
////                        data: {
////                            bAllow: getAllowedState(mergedArr, "4")
////                        }
//                    });


        // Translation
//        $translatePartialLoaderProvider.addPart('app/main/courses');
    }
})();
(function ()
{
    'use strict';
    angular.module('app.intakes')
            .controller('SwapClassMessage', SwapClassMessage);
    /** @ngInject */
    function SwapClassMessage($mdDialog, dialogData, ApiService, $mdToast, Utils, dtInstance, dtPromiseFn)
    {
        var vm = this;
        vm.dtPromiseFn = dtPromiseFn;
        // Data

        vm.dialogData = dialogData;
        vm.dialogData.students = [];

        console.log(vm.dialogData);

        vm.dtInstance = dtInstance;
        // Methods
        vm.closeDialog = closeDialog;

        init();
        //////////

        /**
         * Initialize
         */
        function init()
        {
            // vm.rooms = vm.dialogData;
        }

        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(dtPromiseFn());
        };
        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }
        /*if (vm.dialogData.type === 'edit') {
         if (vm.dialogData.capacity != undefined) {
         vm.dialogData.capacity = parseInt(vm.dialogData.capacity);
         }
         
         }*/


        vm.onSaveBtnTap = function (e) {

        }
    }
})();


(function ()
{
    'use strict';
    angular.module('app.intakes')
            .config(function ($mdDateLocaleProvider) {
                $mdDateLocaleProvider.formatDate = function (date) {
                    return date ? moment(date).format('DD-MM-YYYY') : '';
                };
                $mdDateLocaleProvider.parseDate = function (dateString) {
                    var m = moment(dateString, 'DD-MM-YYYY', true);
                    return m.isValid() ? m.toDate() : new Date(NaN);
                };
            })
            .directive('autoComplete', function ($timeout) {
                return function (scope, iElement, iAttrs) {
                    iElement.autocomplete({
                        source: scope[iAttrs.uiItems],
                        select: function () {
                            $timeout(function () {
                                iElement.trigger('input');
                            }, 0);
                        }
                    });
                };
            })
            .controller('DeletePrivateClassDialogController', DeletePrivateClassDialogController);
    /** @ngInject */
    function DeletePrivateClassDialogController($mdDialog, dialogData, ApiService, Utils, $q, dateobj, dtInstance, $scope, dtPromiseFn, $rootScope, GlobalPool)
    {
        var vm = this;

        // Data

        window.h = vm;
        vm.dialogData = dialogData;
        vm.dtInstance = dtInstance;
        vm.Before = true;
        vm.After = false;
        // Methods
        vm.dtPromiseFn = dtPromiseFn;
        vm.closeDialog = closeDialog;
        vm.dateobj = dateobj;
        var userInfo = GlobalPool.getUserInfo();
        vm.setAuthToken = userInfo.auth_token;
        vm._bDisbleSaveButton = false;
        vm.privateClassCourseType = [{text: 'Normal', value: 'G'}, {text: 'Private', value: 'P'}];
//        vm.selectedStudent = "";
        vm.date = "";

        /**
         * Initigalize
         */



        $(document.body).addClass("intake-dialog-visible");
        //   $(".custom-selc").select2({
        //       placeholder: "Select Teacher",
        //     allowClear: true
        // });
        if (vm.dialogData.dialogtype === 'add') {
            vm.isDisabled = false;
        }
        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(dtPromiseFn());
        };
        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
            $(document.body).removeClass("intake-dialog-visible");
        }
        $(document).keyup(function (e) {
            if (e.keyCode == 27) { // escape key maps to keycode `27`
                // <DO YOUR WORK HERE>

                vm.enableDates = {};
                $mdDialog.cancel();
                vm.onChangeCheckBox = false;
                for (var i = 0; i < vm.days.length; i++) {
                    vm.days[i].bAllow = false;
                }
                $(document.body).removeClass("intake-dialog-visible");
            }
        });

        vm.deletePrivateClass = function () {
            Utils.showLoader(true);
            var requestData = {
                "auth_token": vm.setAuthToken,
                "schedule_class_id": vm.dialogData.schedule_class_id,
                "schedule_date": vm.date
            };
            ApiService.DeletePrivateClass({
                data: requestData,
                dtInstance: vm.dtInstance,
                success: function (response) {
                    if (response.status == 0) {
                        Utils.showLoader(false);
                        if (response.data) {
                            Utils.showToast({text: response.data.message, 'type': 0});
                        }
                    } else {
                        $mdDialog.hide(vm.dialogData);
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 1});
                        vm._reloadDtPage();
                    }
                }
            });
        }



        function init() {
            vm.dialogData.title = 'Select Date to Delete';
//            vm.students = vm.dialogData.students;
        }
        init();

    }


})();

(function ()
{
    'use strict';
    angular.module('app.intakes')
            .controller('UpdateMakeUpInvoiceController', UpdateMakeUpInvoiceController);
    /** @ngInject */
    function UpdateMakeUpInvoiceController($mdDialog, dialogData, ApiService, $mdToast, Utils, dtInstance, dtPromiseFn)
    {
        var vm = this;
        vm.dtPromiseFn = dtPromiseFn;
        // Data
        vm.dialogData = dialogData;



        vm.dtInstance = dtInstance;
        // Methods
        vm.closeDialog = closeDialog;
        vm.studentCost = {};

        vm.dialogData.basic_cost = parseInt(vm.dialogData.basic_cost);

        init();
        //////////

        /**
         * Initialize
         */
        function init()
        {
            // vm.dialogData.name = (vm.dialogData.type === 'add' ? 'Add New Room' : 'Edit Room');
        }

        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(dtPromiseFn());
        };
        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }
        /*if (vm.dialogData.type === 'edit') {
         if (vm.dialogData.capacity != undefined) {
         vm.dialogData.capacity = parseInt(vm.dialogData.capacity);
         }
         
         }*/

        vm.onSaveBtnTap = function (e) {

            Utils.showLoader(true);
// here we will have the new data to be saved.
            vm.dialogData;
            ApiService.UpdateMakeUpInvoiceAmount({
                data: vm.dialogData,
                dtInstance: vm.dtInstance,
                success: function (response) {
                    if (response.status === 0) {
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 0});
                    } else {
                        $mdDialog.hide(vm.dialogData);
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 1});
                    }
                }
            });
        }

    }
})();

(function() {
    'use strict';
    angular.module('app.intakes')
        .controller('UpdateInvoiceController', UpdateInvoiceController);
    /** @ngInject */
    function UpdateInvoiceController($mdDialog, dialogData, ApiService, $mdToast, Utils, dtInstance, dtPromiseFn) {
        var vm = this;
        vm.dtPromiseFn = dtPromiseFn;
        // Data
        vm.dialogData = dialogData;



        vm.dtInstance = dtInstance;
        // Methods
        vm.closeDialog = closeDialog;
        vm.studentCost = {};

        vm.dialogData.admin_fee = parseInt(vm.dialogData.admin_fee);
        vm.dialogData.basic_cost = parseInt(vm.dialogData.basic_cost);

        init();
        //////////

        /**
         * Initialize
         */
        function init() {
            // vm.dialogData.name = (vm.dialogData.type === 'add' ? 'Add New Room' : 'Edit Room');
        }

        vm._reloadDtPage = function() {
            vm.dtInstance.changeData(dtPromiseFn());
        };
        /**
         * Close the dialog
         */
        function closeDialog() {
            $mdDialog.cancel();
        }
        /*if (vm.dialogData.type === 'edit') {
         if (vm.dialogData.capacity != undefined) {
         vm.dialogData.capacity = parseInt(vm.dialogData.capacity);
         }
         
         }*/

        vm.onSaveBtnTap = function(e) {

            Utils.showLoader(true);
            // here we will have the new data to be saved.
            vm.dialogData;
            ApiService.UpdateInvoice({
                data: vm.dialogData,
                // dtInstance: vm.dtInstance,
                success: function(response) {
                    if (response.status === 0) {
                        Utils.showLoader(false);
                        Utils.showToast({ text: response.data.message, 'type': 0 });
                    } else {
                        $mdDialog.hide(vm.dialogData);
                        Utils.showLoader(false);
                        var checkData = {
                            "auth_token": vm.setAuthToken,
                            "studentID": vm.dialogData.StudentID,
                            "schedule_class_id": vm.dialogData.intake
                        }
                        ApiService.GetStudentById({
                            data: checkData,
                            success: function(response) {
                                Utils.showLoader(false);
                                if (response.status == 0) {
                                    Utils.showToast({ text: response.data.message, 'type': 0 });

                                } else {
                                    vm.studentFullDetail = response.data;
                                    vm.invoice_id = vm.studentFullDetail.invoice_id;

                                    vm.studentCost.StudentID = vm.studentFullDetail.studentID;




                                }
                            }
                        })
                        Utils.showToast({ text: response.data.message, 'type': 1 });
                        vm._reloadDtPage();
                    }
                }
            });
        }

        vm.onUpdateInvoiceTap = function(e) {
            Utils.showLoader(true);
            // here we will have the new data to be saved.
            vm.dialogData;
            console.log(vm.dialogData);
            ApiService.UpdateMakeUpInvoiceAmount({
                data: vm.dialogData,
                dtInstance: vm.dtInstance,
                success: function(response) {
                    if (response.status === 0) {
                        Utils.showLoader(false);
                        Utils.showToast({ text: response.data.message, 'type': 0 });
                    } else {
                        $mdDialog.hide(vm.dialogData);
                        Utils.showLoader(false);
                        var checkData = {
                            "auth_token": vm.setAuthToken,
                            "studentID": vm.dialogData.StudentID,
                            "schedule_class_id": vm.dialogData.intake
                        }
                        ApiService.GetStudentById({
                            data: checkData,
                            success: function(response) {
                                Utils.showLoader(false);
                                if (response.status == 0) {
                                    Utils.showToast({ text: response.data.message, 'type': 0 });

                                } else {
                                    vm.studentFullDetail = response.data;
                                    vm.invoice_id = vm.studentFullDetail.invoice_id;

                                    vm.studentCost.StudentID = vm.studentFullDetail.studentID;




                                }
                            }
                        })
                        Utils.showToast({ text: response.data.message, 'type': 1 });
                        vm._reloadDtPage();
                    }
                }
            });
        }

    }
})();
(function ()
{
    'use strict';
    angular.module('app.intakes')
            .controller('UpdateCommentController', UpdateCommentController);
    /** @ngInject */
    function UpdateCommentController($mdDialog, dialogData, ApiService, $mdToast, Utils, dtInstance, dtPromiseFn)
    {
        var vm = this;
        vm.dtPromiseFn = dtPromiseFn;
        // Data
        vm.dialogData = dialogData;
        
        vm.dtInstance = dtInstance;
        // Methods
        vm.closeDialog = closeDialog;
        vm.studentCost = {};

        init();
        //////////

        /**
         * Initialize
         */
        function init()
        {
            vm.dialogData.title = 'Edit Comment';
            if(vm.dialogData.comment == 'null'){
                vm.dialogData.comment = "";
            }
        }

        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(dtPromiseFn());
        };
        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }
       
        vm.onSaveBtnTap = function (e) {

            Utils.showLoader(true);
// here we will have the new data to be saved.
            vm.dialogData;
            ApiService.UpdateStudentComment({
                data: vm.dialogData,
                dtInstance: vm.dtInstance,
                success: function (response) {
                    if (response.status === 0) {
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 0});
                    } else {
                        $mdDialog.hide(vm.dialogData);
                        Utils.showLoader(false);
                        
                        vm._reloadDtPage();
                    }
                }
            });
        }
    }
})();

(function ()
{
    'use strict';
    angular.module('app.intakes')
        .controller('TransferStudentsDialogController', TransferStudentsDialogController);
    /** @ngInject */
    function TransferStudentsDialogController($mdDialog, dialogData, ApiService, $mdToast, Utils, dtInstance, dtPromiseFn)
    {
        var vm = this;
        vm.dtPromiseFn = dtPromiseFn;
        // Data

        vm.dialogData = dialogData;
        vm.dialogData.students = [];

        console.log(vm.dialogData);

        vm.dtInstance = dtInstance;
        // Methods
        vm.closeDialog = closeDialog;

        init();
        //////////

        /**
         * Initialize
         */
        function init()
        {
            vm.rooms = vm.dialogData;
        }

        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(dtPromiseFn());
        };
        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }
        /*if (vm.dialogData.type === 'edit') {
         if (vm.dialogData.capacity != undefined) {
         vm.dialogData.capacity = parseInt(vm.dialogData.capacity);
         }
         
         }*/

        function beforeSaveProcess() {
            var requestData = {
                student_id : vm.dialogData.student_id,
                ScheduleClassStudentID : vm.dialogData.ScheduleClassStudentID,
                scheduleClassID : vm.dialogData.scheduleClassID,
                updatedScheduleClassID : vm.updated_schedule_classID
            }
            return requestData;
        }

        vm.onSaveBtnTap = function (e) {
            var dialogData = beforeSaveProcess();

            Utils.showLoader(true);
            ApiService.TransferStudent({
                data: dialogData,

                success: function (response) {
                    if (response.status === 0) {
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 0});
                    } else {
                        $mdDialog.hide(vm.dialogData);
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 1});
                        vm._reloadDtPage();
                    }
                }
            });
        }
    }
})();


(function ()
{
    'use strict';
    angular.module('app.intakes')
            .controller('ShowAvailableRoomController', ShowAvailableRoomController);
    /** @ngInject */
    function ShowAvailableRoomController($mdDialog, dialogData, ApiService, $mdToast, Utils, dtInstance, dtPromiseFn)
    {
        var vm = this;
        vm.dtPromiseFn = dtPromiseFn;
        // Data

        vm.dialogData = dialogData;
        vm.dialogData.students = [];

        console.log(vm.dialogData);

        vm.dtInstance = dtInstance;
        // Methods
        vm.closeDialog = closeDialog;

        init();
        //////////

        /**
         * Initialize
         */
        function init()
        {
            vm.rooms = vm.dialogData;
        }

        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(dtPromiseFn());
        };
        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }
        /*if (vm.dialogData.type === 'edit') {
         if (vm.dialogData.capacity != undefined) {
         vm.dialogData.capacity = parseInt(vm.dialogData.capacity);
         }
         
         }*/

        function beforeSaveProcess() {
            var selectedRoomDetail;
            for (var i = 0; i < vm.rooms.length; i++) {
                if (vm.rooms[i].roomID == vm.roomID) {
                    selectedRoomDetail = vm.rooms[i];
                    break;
                }
            }
            var requestData = {
                "startDate": vm.dialogData.Intake_detail.courseDetails.startDate,
                "endDate": vm.dialogData.Intake_detail.courseDetails.endDate,
                "dateRange": vm.dialogData.Intake_detail.dateRange,
                "startTime": vm.dialogData.Intake_detail.courseDetails.startTime,
                "endTime": vm.dialogData.Intake_detail.courseDetails.endTime,
                "schedule_class_id": vm.dialogData.Intake_detail.courseDetails.scheduleClassID,
                "current_room_student_count": vm.dialogData.Intake_detail.studentList.length,
                "currentRoomID": vm.dialogData.Intake_detail.courseDetails.roomID,
                "swapRoomID": vm.roomID                
            }
            return requestData;
        }

        vm.onSaveBtnTap = function (e) {
            var dialogData = beforeSaveProcess();
            // Utils.showLoader(true);
// here we will have the new data to be saved.
            Utils.showLoader(true);
            ApiService.CheckAvailableRoom({
                data: dialogData,

                success: function (response) {
                    if (response.status === 0) {
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 0});
                    } else {
                        $mdDialog.hide(vm.dialogData);
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 1});
                        vm._reloadDtPage();
                    }
                }
            });
        }
    }
})();


(function ()
{
    'use strict';
    angular.module('app.intakes')
            .controller('AddUpdateStudentsDialogController', AddUpdateStudentsDialogController);
    /** @ngInject */
    function AddUpdateStudentsDialogController($mdDialog, dialogData, studentsobj, ApiService, $mdToast, Utils, dtInstance, dtPromiseFn)
    {
        var vm = this;
        vm.dtPromiseFn = dtPromiseFn;
        // Data

        vm.dialogData = dialogData;
        vm.dialogData.students = [];


        
        vm.dtInstance = dtInstance;
        vm.studentsobj = studentsobj;
        // Methods
        vm.closeDialog = closeDialog;
        vm.studentCost = {};

        vm.dialogData.admin_fee = parseInt(vm.dialogData.admin_fee);
        vm.dialogData.basic_cost = parseInt(vm.dialogData.basic_cost);

        init();
        //////////

        /**
         * Initialize
         */
        function init()
        {


            if (vm.dialogData.studentData.courseDetails.courseId != null) {
                vm.dialogData.courseID = vm.dialogData.studentData.courseDetails.courseId;
            }


            for (var i = 0; i < vm.dialogData.studentData.studentList.length; i++) {
                for (var j = 0; j < vm.studentsobj.length; j++) {

                    if (vm.dialogData.studentData.studentList[i].studentID == vm.studentsobj[j].id) {
                        vm.studentsobj.splice(j, 1);
                    }
                }
            }
            loadStudentDataInDropDown();
        }

        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(dtPromiseFn());
        };
        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }
        /*if (vm.dialogData.type === 'edit') {
         if (vm.dialogData.capacity != undefined) {
         vm.dialogData.capacity = parseInt(vm.dialogData.capacity);
         }
         
         }*/
        
        function beforeSaveProcess(){
            vm.dialogData.students = [];
            for (var i = 0; i < vm.multipleDemo.selectedPeople.length; i++) {
                vm.dialogData.students.push(vm.multipleDemo.selectedPeople[i].id);
            }


            var requestData = {
                'dateRange' : vm.dialogData.studentData.dateRange,
                'courseID' : vm.dialogData.courseID,
                'scheduleClassID' : vm.dialogData.scheduleClassID,
                'students' : vm.dialogData.students
            };
            return requestData;
        }

        vm.onSaveBtnTap = function (e) {
            var dialogData = beforeSaveProcess();
            // Utils.showLoader(true);
// here we will have the new data to be saved.
            Utils.showLoader(true);
            ApiService.AddIntakeStudents({
                data: dialogData,

                success: function (response) {
                    if (response.status === 0) {
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 0});
                    } else {
                        $mdDialog.hide(vm.dialogData);
                        Utils.showLoader(false);


                        Utils.showToast({text: response.data.message, 'type': 1});
                        vm._reloadDtPage();
                    }
                }
            });
        }
         function loadStudentDataInDropDown() {

            vm.allItems = vm.studentsobj;
            vm.multipleDemo = {};
            vm.multipleDemo.selectedPeople = [];
        }
        vm.onStudentListChange = function () {
            if (vm.multipleDemo.selectedPeople.length == 0) {
                vm.multipleDemo.selectedPeople = {};
            }
        }

    }
})();

///below directive used for add student dropdowm
angular.module('app.intakes').directive('uiSelectChoices', ['$timeout', '$parse', '$compile', '$document', '$filter', function ($timeout, $parse, $compile, $document, $filter) {
        return function (scope, elm, attr) {

            var raw = elm[0];
            var scrollCompleted = true;
            if (!attr.allChoices) {
                throw new Error('ief:ui-select: Attribute all-choices is required in  ui-select-choices so that we can handle  pagination.');
            }


            scope.pagingOptions = {
                allOptions: scope.$eval(attr.allChoices)
            };

            attr.refresh = 'addMoreItems()';
            var refreshCallBack = $parse(attr.refresh);
            elm.bind('scroll', function (event) {
                var remainingHeight = raw.offsetHeight - raw.scrollHeight;
                var scrollTop = raw.scrollTop;
                var percent = Math.abs((scrollTop / remainingHeight) * 100);

                if (percent >= 80) {
                    if (scrollCompleted) {
                        scrollCompleted = false;
                        event.preventDefault();
                        event.stopPropagation();
                        var callback = function () {
                            scope.addingMore = true;
                            refreshCallBack(scope, {
                                $event: event
                            });
                            scrollCompleted = true;

                        };
                        $timeout(callback, 100);
                    }
                }
            });

            var closeDestroyer = scope.$on('uis:close', function () {
                var pagingOptions = scope.$select.pagingOptions || {};
                pagingOptions.filteredItems = undefined;
                pagingOptions.page = 0;
            });
            scope.addMoreItems = function (doneCalBack) {

                var $select = scope.$select;
                var allItems = scope.pagingOptions.allOptions;
                var moreItems = [];
                var itemsThreshold = 100;
                var search = $select.search;

                var pagingOptions = $select.pagingOptions = $select.pagingOptions || {
                    page: 0,
                    pageSize: 20,
                    items: $select.items
                };

                if (pagingOptions.page === 0) {
                    pagingOptions.items.length = 0;
                }
                if (!pagingOptions.originalAllItems) {
                    pagingOptions.originalAllItems = scope.pagingOptions.allOptions;
                }
                var searchDidNotChange = search && pagingOptions.prevSearch && search == pagingOptions.prevSearch;
                if (pagingOptions.filteredItems && searchDidNotChange) {
                    allItems = pagingOptions.filteredItems;
                }
                pagingOptions.prevSearch = search;
                if (search && search.length > 0 && pagingOptions.items.length < allItems.length && !searchDidNotChange) {
                    //search
                    if (!pagingOptions.filteredItems) {
                        //console.log('previous ' + pagingOptions.filteredItems);
                    }

                    pagingOptions.filteredItems = undefined;
                    moreItems = $filter('filter')(pagingOptions.originalAllItems, search);
                    //if filtered items are too many scrolling should occur for filtered items
                    if (moreItems.length > itemsThreshold) {
                        if (!pagingOptions.filteredItems) {
                            pagingOptions.page = 0;
                            pagingOptions.items.length = 0;
                        } else {

                        }
                        pagingOptions.page = 0;
                        pagingOptions.items.length = 0;
                        allItems = pagingOptions.filteredItems = moreItems;

                    } else {
                        allItems = moreItems;
                        pagingOptions.items.length = 0;
                        pagingOptions.filteredItems = undefined;
                    }
                } else {
                }
                pagingOptions.page++;
                if (pagingOptions.page * pagingOptions.pageSize < allItems.length) {
                    moreItems = allItems.slice(pagingOptions.items.length, pagingOptions.page * pagingOptions.pageSize);
                }

                for (var k = 0; k < moreItems.length; k++) {
                    pagingOptions.items.push(moreItems[k]);
                }

                scope.calculateDropdownPos();
                scope.$broadcast('uis:refresh');
                if (doneCalBack)
                    doneCalBack();
            };
            scope.$on('$destroy', function () {
                elm.off('scroll');
                closeDestroyer();
            });
        };
    }]);
/**
 * AngularJS default filter with the following expression:
 * "person in people | filter: {name: $select.search, age: $select.search}"
 * performs an AND between 'name: $select.search' and 'age: $select.search'.
 * We want to perform an OR.
 */
angular.module('app.intakes').filter('propsFilter', function () {
    return function (items, props) {
        var out = [];

        if (angular.isArray(items)) {
            var keys = Object.keys(props);


            items.forEach(function (item) {
                if (!item)
                    return;
                var itemMatches = false;

                for (var i = 0; i < keys.length; i++) {
                    var prop = keys[i];
                    var text = props[prop].toLowerCase();
                    if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                        itemMatches = true;
                        break;
                    }
                }

                if (itemMatches) {
                    out.push(item);
                }
            });
        } else {
            // Let the output be the input untouched
            out = items;
        }

        return out;
    };
});


(function ()
{
    'use strict';
    angular.module('app.intakes')
            .config(function ($mdDateLocaleProvider) {
                $mdDateLocaleProvider.formatDate = function (date) {
                    return date ? moment(date).format('DD-MM-YYYY') : '';
                };
                $mdDateLocaleProvider.parseDate = function (dateString) {
                    var m = moment(dateString, 'DD-MM-YYYY', true);
                    return m.isValid() ? m.toDate() : new Date(NaN);
                };
            })
            .controller('AddPrivateDialogController', AddPrivateDialogController);
    /** @ngInject */
    function AddPrivateDialogController($mdDialog, dialogData, ApiService, Utils, $q, dtInstance, $scope, dtPromiseFn, $rootScope, GlobalPool)
    {
        var vm = this;

        // Data

        window.h = vm;
        vm.dialogData = dialogData;
        vm.dtInstance = dtInstance;
        vm.Before = true;
        vm.After = false;
        // Methods
        vm.dtPromiseFn = dtPromiseFn;
        vm.closeDialog = closeDialog;
        var userInfo = GlobalPool.getUserInfo();
        vm.setAuthToken = userInfo.auth_token;
        vm.studentDatesObj = [];
        vm.isCourseChanged = false;
        vm.showStuentsLengthError = false;
        vm._bDisbleSaveButton = false;
        vm.privateClassCourseType = [{text: 'Normal', value: 'G'}, {text: 'Private', value: 'P'}];
        vm.courseType = Focus.ENUMS.COURSE_FILTERTYPE,
                vm.simulateQuery = false;
        vm._bDisableLocation = false;
//        vm.selectedStudent = "";
        vm.date = "";
        vm.scheduleClassId = vm.dialogData.scheduleClassID;

        /**
         * Initialize
         */



        $(document.body).addClass("intake-dialog-visible");
        //   $(".custom-selc").select2({
        //       placeholder: "Select Teacher",
        //     allowClear: true
        // });


        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(dtPromiseFn());
        };
        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
            vm.showIntakeError = false;
            vm.onChangeCheckBox = false;
            $(document.body).removeClass("intake-dialog-visible");
        }
        $(document).keyup(function (e) {
            if (e.keyCode == 27) { // escape key maps to keycode `27`
                // <DO YOUR WORK HERE>

                $mdDialog.cancel();
                vm.onChangeCheckBox = false;
                for (var i = 0; i < vm.days.length; i++) {
                    vm.days[i].bAllow = false;
                }
                $(document.body).removeClass("intake-dialog-visible");
            }
        });

        vm._onStartDateChange = function () {
            Utils.showLoader(true);
            var requestData = {
                "auth_token": vm.setAuthToken,
                "schedule_class_id": vm.dialogData.scheduleClassID,
                "schedule_date": moment(vm.dialogData.start_date).format('L')
            }
            ApiService.CheckPrivateDate({
                data: requestData,
                dtInstance: vm.dtInstance,
                success: function (response) {
                    if (response.status == 0) {
                        Utils.showLoader(false);
                        vm._bDisbleSaveButton = true;
                        if (response.data) {
                            Utils.showToast({text: response.data.message, 'type': 0});
                        }
                    } else {
                        Utils.showLoader(false);
                        vm._bDisbleSaveButton = false;
                        Utils.showToast({text: response.data.message, 'type': 1});
                    }
                }
            });
        };

        vm.savePrivateClass = function () {
            Utils.showLoader(true);
            var start_time = moment(vm.dialogData.start_time).format('H:mm:ss');
            var end_time = moment(vm.dialogData.start_time).add(vm.dialogData.class_duration, 'hours').format('H:mm:ss');
            var requestData = {
                'schedule_date': moment(vm.dialogData.start_date).format('DD-MM-YYYY'),
                'start_time': start_time,
                'end_time': end_time,
                'schedule_class_id': vm.dialogData.scheduleClassID,
                'students': vm.dialogData.students,
                'balance_hours': vm.dialogData.balance_hours,
            }
            ApiService.AddPrivateClass({
                data: requestData,
                success: function (response) {
                    if (response.status == 0) {
                        Utils.showLoader(false);
                        Utils.showToast({
                            text: response.data.message,
                            'type': 0
                        });

                    } else {
                        Utils.showLoader(false);
                        Utils.showToast({
                            text: response.data.message,
                            'type': 1
                        });
                        $mdDialog.hide(vm.dialogData);
                        vm._reloadDtPage();
                    }
                }
            });
        }



        function init() {
            vm.dialogData.title = 'Add Private Class';
//            vm._onStartDateChange();
        }
        init();

    }


})();

(function ()
{
    'use strict';
    angular.module('app.intakes')
            .config(function ($mdDateLocaleProvider) {
                $mdDateLocaleProvider.formatDate = function (date) {
                    return date ? moment(date).format('DD-MM-YYYY') : '';
                };
                $mdDateLocaleProvider.parseDate = function (dateString) {
                    var m = moment(dateString, 'DD-MM-YYYY', true);
                    return m.isValid() ? m.toDate() : new Date(NaN);
                };
            })
            .directive('autoComplete', function ($timeout) {
                return function (scope, iElement, iAttrs) {
                    iElement.autocomplete({
                        source: scope[iAttrs.uiItems],
                        select: function () {
                            $timeout(function () {
                                iElement.trigger('input');
                            }, 0);
                        }
                    });
                };
            })
            .controller('AddMakeUpDialogController', AddMakeUpDialogController);
    /** @ngInject */
    function AddMakeUpDialogController($mdDialog, dialogData, ApiService, Utils, $q, studentsobj, dtInstance, $scope, dtPromiseFn, $rootScope,GlobalPool)
    {
        var vm = this;

        // Data

        window.h = vm;
        vm.dialogData = dialogData;
        vm.dtInstance = dtInstance;
        vm.Before = true;
        vm.After = false;
        // Methods
        vm.dtPromiseFn = dtPromiseFn;
        vm.closeDialog = closeDialog;
        vm.studentsobj = studentsobj;
        var userInfo = GlobalPool.getUserInfo();
        vm.setAuthToken = userInfo.auth_token;
        vm.studentDatesObj = [];
        vm.isCourseChanged = false;
        vm.showStuentsLengthError = false;
        vm._bDisbleSaveButton = false;
        vm.privateClassCourseType = [{text: 'Normal', value: 'G'}, {text: 'Private', value: 'P'}];
        vm.courseType = Focus.ENUMS.COURSE_FILTERTYPE,
                vm.simulateQuery = false;
        vm.isDisabled = false;
        vm._bDisableLocation = false;
//        vm.selectedStudent = "";
        vm.date = "";

        /**
         * Initigalize
         */



        $(document.body).addClass("intake-dialog-visible");
        //   $(".custom-selc").select2({
        //       placeholder: "Select Teacher",
        //     allowClear: true
        // });
        if (vm.dialogData.dialogtype === 'add') {
            vm.isDisabled = false;
        }

        vm.getStudentDates = function () {
            var studentId = vm.student;
            for (var i = 0; i < vm.dialogData.studentList.length; i++) {
                if (vm.dialogData.studentList[i].student_id == studentId) {
                    vm.schedule_class_student_id = vm.dialogData.studentList[i].schedule_class_student_id;
                    vm.studentDatesObj = vm.dialogData.studentList[i].dates;
                    break;
                }

            }
        }




        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(dtPromiseFn());
        };
        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
            vm.showIntakeError = false;
            vm.onChangeCheckBox = false;
            $(document.body).removeClass("intake-dialog-visible");
        }
        $(document).keyup(function (e) {
            if (e.keyCode == 27) { // escape key maps to keycode `27`
                // <DO YOUR WORK HERE>

                vm.enableDates = {};
                $mdDialog.cancel();
                vm.onChangeCheckBox = false;
                for (var i = 0; i < vm.days.length; i++) {
                    vm.days[i].bAllow = false;
                }
                $(document.body).removeClass("intake-dialog-visible");
            }
        });

         vm.saveMakeUpClass = function() {
            Utils.showLoader(true);
            var requestData = {
                "auth_token": vm.setAuthToken,
                "schedule_class_id": vm.dialogData.schedule_class_id,
                "course_id": vm.dialogData.school_course_id,
                "student": vm.student,
//                "schedule_date": moment(vm.date).format('L'),
                "schedule_date": vm.date,
                "schedule_class_student_id" : vm.schedule_class_student_id
            };
            ApiService.AddMakeUpClass({
                data: requestData,
                dtInstance: vm.dtInstance,
                success: function (response) {
                    if (response.status == 0) {
                        Utils.showLoader(false);
                        if (response.data) {
                            Utils.showToast({text: response.data.message, 'type': 0});
                        }
                    } else {
                        $mdDialog.hide(vm.dialogData);
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 1});
                        vm._reloadDtPage();
                    }
                }
            });
        }



        function init() {
            vm.dialogData.title = 'Add Makeup Class';
            vm.students = vm.dialogData.students;
        }
        init();

    }


})();

(function() {
    'use strict';
    angular.module('app.intakes')
    .config(function($mdDateLocaleProvider) {
        $mdDateLocaleProvider.formatDate = function(date) {
            return date ? moment(date).format('DD-MM-YYYY') : '';
        };
        $mdDateLocaleProvider.parseDate = function(dateString) {
            var m = moment(dateString, 'DD-MM-YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };
    })
    .directive('autoComplete', function($timeout) {
        return function(scope, iElement, iAttrs) {
            iElement.autocomplete({
                source: scope[iAttrs.uiItems],
                select: function() {
                    $timeout(function() {
                        iElement.trigger('input');
                    }, 0);
                }
            });
        };
    })
    .controller('AddIntakeDialogController', AddIntakeDialogController);
    /** @ngInject */
    function AddIntakeDialogController($mdDialog, dialogData, ApiService, Utils, courseoptions, $q, studentsobj, dtInstance, $scope, dtPromiseFn,$location) {
        var vm = this;

        // Data

        window.h = vm;
        vm.dialogData = dialogData;
        vm.dtInstance = dtInstance;
        vm.courseoptions = courseoptions;
        vm.timeSlot = Focus.ENUMS.TIME_SLOT;
        vm.coloroption = Focus.ENUMS.INTAKE_COLOR;
        vm.intakeSeries = Focus.ENUMS.INTAKE_SERIES;
        vm.Before = true;
        vm.After = false;
        // Methods
        vm.dtPromiseFn = dtPromiseFn;
        vm.closeDialog = closeDialog;
        vm.onDeleteBtnTap = onDeleteBtnTap;
        vm.onSaveIntakeBtnTap = onSaveIntakeBtnTap;
        vm.onClick = onClick;
        vm.studentsobj = studentsobj;

        vm.isCourseChanged = false;
        vm.isTimeChanged = false;
        vm.isStartEndDateChanged = false;
        vm.showStartDateError = false;
        vm.showEndDateError = false;
        vm.showRoomError = false;
        vm.showTeacherError = false;
        vm._isColorSelected = true;
        vm._isFirstEditLoad = false;
        vm.lastIntakeSuggestion = "";
        vm.showStuentsLengthError = false;
        vm.enableDates = {};
        vm.showDays = false;
        vm._bHideLocation = true;
        vm.locationRequied = true;
        vm.onChangeCheckBox = false;
        vm._bDisbleSaveButton = false;
        vm.privateClassCourseType = [{ text: 'Normal', value: 'G' }, { text: 'Private', value: 'P' }, { text: 'Online', value: 'O' }];
        vm.courseType = Focus.ENUMS.COURSE_FILTERTYPE,
        vm.simulateQuery = false;
        vm.isDisabled = false;
        // list of `state` value/display objects
        vm.states = loadAll();
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;
        vm.selectCourseError = false;
        $scope.selectedPerson;
        $scope.searchStr;
        $scope.arrCourses;
        $scope.selectedPerson;
        $scope.clearSelection = false;
        vm.onCourseArray = onCourseArray;
        vm.allChangedParam = false;
        vm._isChangeRoom = false;
        vm._isChangeTeacher = false;
        vm.commentsShow = false;
        var intakeDetailsRoom = false;
        var intakeDetailsTeacher = false;
        vm._bdisableRoom = false;
        vm._bDisableLocation = false;
        vm.intakeType = '';
        vm.dialogData.sendStudentMail = 0;




        vm.addNewChoice = function() {
            var newItemNo = vm.dialogData.additional_pay.length + 1;
            vm.dialogData.additional_pay.push({ 'id': newItemNo });
        };

        vm.removeChoice = function(index) {
            var lastItem = vm.dialogData.additional_pay.length - 1;
            vm.dialogData.additional_pay.splice(index, 1);
        };

        vm.onCourseTypeChanged = function() {
            vm.searchText = '';
            var requestData = {
                'course_type': vm.intakeType
            }
            if(vm.intakeType == 'O' ) {
                vm.dialogData.roomID = "";
            }
            Utils.showLoader(true);
            ApiService.GetCourseByType({
                data: requestData,
                success: function(response) {
                    Utils.showLoader(false);
                    if (response.status != 0) {
                        var arrCourses = response.data;
                        var courseobj = [];
                        for (var i = 0; i < arrCourses.length; i++) {
                            courseobj.push({
                                courseID: arrCourses[i].courseID,
                                capacity: arrCourses[i].batch,
                                language: arrCourses[i].language,
                                title: arrCourses[i].title,
                                recurrence_rule: arrCourses[i].recurrence_rule,
                                class_duration: arrCourses[i].class_duration,
                                total_class_duration: arrCourses[i].no_of_classes,
                                level: arrCourses[i].level,
                                series: arrCourses[i].series,
                                books: arrCourses[i].books,
                                validity: arrCourses[i].validity,
                                type: arrCourses[i].type
                            });
                        }
                        vm.courseoptions = courseobj;
                        onCourseArray();
                    } else {
                        vm.dialogData.is_flexible == false;
                        Utils.showToast({ text: "No Courses Available", 'type': 0 });
                    }
                }
            });
        }

        function onCourseArray() {
            if (vm.courseoptions) {
                var arrCoursesArray = [];
                for (var i = 0; i < vm.courseoptions.length; i++) {
                    for (var j = 0; j < vm.courseType.length; j++) {
                        if (vm.courseType[j].text == vm.courseoptions[i].type) {
                            var typeName = vm.courseType[j].value;
                        }
                    }
                    arrCoursesArray.push({ title: vm.courseoptions[i].title + " " + vm.courseoptions[i].level + " " + typeName + " - " + vm.courseoptions[i].class_duration + " hours , " + (parseFloat(vm.courseoptions[i].total_class_duration) * parseFloat(vm.courseoptions[i].class_duration)) + " hours", courseId: vm.courseoptions[i].courseID })
                }
                vm.listedCourses = arrCoursesArray;
                $scope.arrCoursesArray = arrCoursesArray;
            }
        }
        if (vm.courseoptions) {
            var arrCoursesArray = [];
            for (var i = 0; i < vm.courseoptions.length; i++) {
                for (var j = 0; j < vm.courseType.length; j++) {
                    if (vm.courseType[j].text == vm.courseoptions[i].type) {
                        var typeName = vm.courseType[j].value;
                    }
                }

                arrCoursesArray.push({ title: vm.courseoptions[i].title + " " + vm.courseoptions[i].level + " " + typeName + " - " + vm.courseoptions[i].class_duration + " hours , " + (parseFloat(vm.courseoptions[i].total_class_duration) * parseFloat(vm.courseoptions[i].class_duration)) + " hours", courseId: vm.courseoptions[i].courseID })
            }
            vm.listedCourses = arrCoursesArray;
            $scope.arrCoursesArray = arrCoursesArray;
        }

        function querySearch(query) {
            vm.states;
            var results = query ? vm.states.filter(createFilterFor(query)) : vm.states,
            deferred;
            if (vm.simulateQuery) {
                deferred = $q.defer();
                $timeout(function() {
                    deferred.resolve(results);
                }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }

        function searchTextChange(text) {

            if (text != "") {
                var arrCourses = [];
                for (var i = 0; i < vm.courseoptions.length; i++) {
                    arrCoursesArray.push({ title: vm.courseoptions[i].title + " " + vm.courseoptions[i].level + " " + typeName + " - " + vm.courseoptions[i].class_duration + " hours , " + (parsrFloat(vm.courseoptions[i].total_class_duration) * parseFloat(vm.courseoptions[i].class_duration)) + " hours", courseId: vm.courseoptions[i].courseID })
                }
                for (var j = 0; j < arrCourses.length; j++) {
                    if (arrCourses[j].title != text) {
                        vm.selectCourseError = true;
                    }
                }
            } else {
                vm.selectCourseError = false;
            }
            //            $log.info('Text changed to ' + text);
        }

        vm.onChangeStudents = function() {
            vm.changeStudents = true;
        }

        function selectedItemChange(item) {

            //            $log.info('Item changed to ' + JSON.stringify(item));
        }
        //        /**
        //         * Build `states` list of key/value pairs
        //         */
        function loadAll() {
            var allStates = [];
            for (var i = 0; i < vm.courseoptions.length; i++) {
                //                allStates.push({display: vm.courseoptions[i].title + "-" + vm.courseoptions[i].level + "-" + vm.courseoptions[i].series + "-" + vm.courseoptions[i].recurrence_rule, value: vm.courseoptions[i].courseID})
                for (var j = 0; j < vm.courseType.length; j++) {
                    if (vm.courseType[j].text == vm.courseoptions[i].type) {
                        var typeName = vm.courseType[j].value;
                    }
                }

                allStates.push(vm.courseoptions[i].title + "-" + vm.courseoptions[i].level + "-" + vm.courseoptions[i].series + "-" + typeName)
                    //            
                }
            //            return allStates;
            allStates = allStates.join();
            return allStates.split(',').map(function(state) {
                return {
                    value: state.toLowerCase(),
                    display: state
                };
            });;
        }
        ////        /**
        ////         * Create filter function for a query string
        ////         */
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(state) {
                return (state.value.indexOf(lowercaseQuery) === 0);
            };
        }

        vm.days = Focus.ENUMS.RECURRANCE_DAYS;
        vm.onlyWeekendsPredicate = function(date) {

            var day = date.getDay();
            //            return day;
            if (isDateInRange(date)) {
                return true;
            } else {
                return null;
            }
        };
        var isDateInRange = function(date) {
            if (vm.enableDates.length != 0) {
                var dates = vm.enableDates;
                var curDate = null;
                for (var i = 0; i < dates.length; i++) {
                    curDate = new Date(dates[i]);
                    if (date.getDate() == curDate.getDate() && date.getFullYear() && curDate.getFullYear() &&
                        date.getMonth() == curDate.getMonth()) {
                        return true;
                }
            }

            return false;
        }
    };

    vm.onChangeFlexible = function() {

        Utils.showLoader(true);
        vm.searchText = '';
        $scope.$broadcast('angucomplete-alt:clearInput', 'ex10');
        if (vm.showDays == true) {
            vm.showDays = false;
        }
        if (vm.dialogData.is_flexible == true) {
            var flexible = 1;
        } else {
            var flexible = 0;
        }
        var requestData = {
            'flexible': flexible,
            'course_type' : vm.intakeType
        }
        ApiService.GetUniqueCourseList({
            data: requestData,
            success: function(response) {
                Utils.showLoader(false);
                if (response.status != 0) {
                    var arrCourses = response.data;
                    var courseobj = [];
                    for (var i = 0; i < arrCourses.length; i++) {
                        courseobj.push({
                            courseID: arrCourses[i].courseID,
                            capacity: arrCourses[i].batch,
                            language: arrCourses[i].language,
                            title: arrCourses[i].title,
                            recurrence_rule: arrCourses[i].recurrence_rule,
                            class_duration: arrCourses[i].class_duration,
                            total_class_duration: arrCourses[i].no_of_classes,
                            level: arrCourses[i].level,
                            series: arrCourses[i].series,
                            books: arrCourses[i].books,
                            validity: arrCourses[i].validity,
                            type: arrCourses[i].type
                        });
                    }
                    vm.courseoptions = courseobj;
                            //                         $scope.selectedPerson = function(selected) {
                            //                             selected = null ;
                            //                         }
                            onCourseArray();

                        } else {
                            vm.dialogData.is_flexible == false;
                            Utils.showToast({ text: "No Flexible Courses Available", 'type': 0 });
                        }
                    }
                });
    }
            //        $("#myselectCourse").select2({
            //            placeholder: "Select a state",
            //        });
            $scope.select2Options = {
                'multiple': true,
                'simple_tags': true
            };
        //        $scope.select2OptionsCourses = {
        //            "placeholder": "Select a Course"
        //        };

        function onClick(color) {
            vm.dialogData.color = color;
            if (vm.dialogData.color) {
                vm._isColorSelected = false;
            }
        }
        vm.ToggleCheckbox = function(e, value) {
            vm.onChangeCheckBox = true;
            var arrDays = vm.days;
            var allowedDays = [];
            for (var i = 0; i < arrDays.length; i++) {
                if (arrDays[i].bAllow === true) {
                    allowedDays.push(arrDays[i].id);
                }
            }
            vm.dialogData.weekdays = allowedDays;
            if (vm.isCourseChanged && vm.isTimeChanged) {
                vm.getAutoSuggestions();
            }
        }

        vm._onCourseChanged = function() {

            if (vm.selectedItem != null) {
                vm.selectCourseError = false;
                var arrCourses = [];
                for (var i = 0; i < vm.courseoptions.length; i++) {
                    for (var j = 0; j < vm.courseType.length; j++) {
                        if (vm.courseType[j].text == vm.courseoptions[i].type) {
                            var typeName = vm.courseType[j].value;
                        }
                    }
                    arrCourses.push({ title: vm.courseoptions[i].title + "-" + vm.courseoptions[i].level + "-" + vm.courseoptions[i].series + "-" + typeName + "-" + vm.courseoptions[i].class_duration + " hours", courseId: vm.courseoptions[i].courseID })

                }
                for (var j = 0; j < arrCourses.length; j++) {
                    if (arrCourses[j].title == vm.selectedItem.display) {

                        vm.dialogData.courseID = arrCourses[j].courseId;
                    }

                }

                vm.selectedCourse = vm.dialogData.courseID;
                for (var i = 0; i < vm.courseoptions.length; i++) {
                    if (vm.dialogData.courseID == vm.courseoptions[i].courseID) {
                        vm.batchLength = vm.courseoptions[i].capacity;
                        if (vm.courseoptions[i].recurrence_rule == "Weekly") {
                            vm.showDays = true;
                        } else {
                            vm.dialogData.weekdays = [];
                            vm.showDays = false;
                        }
                    }
                }
                vm.isCourseChanged = true;
                if (vm.isTimeChanged) {
                    vm.getAutoSuggestions();
                }
            } else {

            }
        };

        $scope.selectedTeacher = function(selected) {
            if (selected != undefined && selected.title != undefined) {
                vm.dialogData.teacherID = selected.originalObject.id;
            }
        }

        $scope.selectedPerson = function(selected) { //
            vm.allChangedParam = true;
            if (selected != undefined && selected.title != undefined) {
                //                if (angular.element('#coursename').val() != undefined) {
                    var courseName = selected.title.trim();
                    vm.selectCourseError = false;

                    for (var j = 0; j < vm.listedCourses.length; j++) {
                        if (vm.listedCourses[j].title == courseName) {
                            vm.dialogData.courseID = vm.listedCourses[j].courseId;
                        }
                    }
                    if (vm.dialogData.courseID != undefined) {
                        vm.clearSelection = false;
                        vm.selectedCourse = vm.dialogData.courseID;
                        for (var i = 0; i < vm.courseoptions.length; i++) {
                            if (vm.dialogData.courseID == vm.courseoptions[i].courseID) {
                                vm.batchLength = vm.courseoptions[i].capacity;
                                if (vm.courseoptions[i].recurrence_rule == "Weekly") {
                                //                                vm.days = [];

                                vm.showDays = true;
                            } else {
                                vm.dialogData.weekdays = [];
                                vm.showDays = false;
                            }

                            if (vm.intakeType == "G") {
                                vm.dialogData.validity = vm.courseoptions[i].validity;
                                vm.dialogData.class_duration = vm.courseoptions[i].class_duration;
                                vm._bHideLocation = true;
                                vm.locationRequied = true;
                                vm.intakeType = "G";

                            } else if(vm.intakeType == 'P'){
                                vm.dialogData.validity = vm.courseoptions[i].validity;
                                vm.dialogData.class_duration = vm.courseoptions[i].class_duration;
                                vm._bHideLocation = false;
                                vm.locationRequied = false;
                                vm.intakeType = "P";
                            } else {
                                vm.dialogData.validity = vm.courseoptions[i].validity;
                                vm.dialogData.class_duration = vm.courseoptions[i].class_duration;
                                vm._bHideLocation = true;
                                vm.locationRequied = true;
                                vm.intakeType = "O";
                            }
                        }
                    }
                    for (var i = 0; i < vm.days.length; i++) {
                        vm.days[i].bAllow = false;
                    }
                    vm.isCourseChanged = true;
                }
                if (vm.isTimeChanged) {
                    vm.getAutoSuggestions();
                }
            } else {
                vm.selectCourseError = true;
            }

        };

        //        vm.changeRoomLocationValidation = function(){
        //            if(vm._bHideLocation == false){
        //                if(vm.dialogData.roomID == ''){
        //                    vm.locationRequied == true;
        //                }else{
        //                    vm.locationRequied == false;
        //                }
        //            }
        //        }

        vm._onStartTimeChange = function() {
            vm.allChangedParam = true;
            $(".ui-timepicker-wrapper").css("display", 'none');
            if (vm.dialogData.start_time != undefined) {
                if (vm.isCourseChanged) {
                    if (vm.previousTime != moment(vm.dialogData.start_time).format('h:mm:ss a')) {
                        vm.isTimeChanged = true;
                        vm.getAutoSuggestions();
                        vm.previousTime = moment(vm.dialogData.start_time).format('h:mm:ss a');
                    }
                }
                if (vm.isCourseChanged && vm.onChangeCheckBox) {
                    if (vm.previousTime != moment(vm.dialogData.start_time).format('h:mm:ss a')) {
                        vm.isTimeChanged = true;
                        vm.getAutoSuggestions();
                        vm.previousTime = moment(vm.dialogData.start_time).format('h:mm:ss a');
                    }
                }
            }
        };
        vm._onStartDateChange = function(start_date) {
            vm.allChangedParam = true;
            vm.isStartEndDateChanged = true;
            if (vm.isCourseChanged && vm.isTimeChanged) {
                vm.getAutoSuggestions();
            }
            vm.startDate = false;
        };
        vm._onEndDateChange = function() {
            vm.allChangedParam = true;
            vm.isStartEndDateChanged = true;
            if (vm.isCourseChanged && vm.isTimeChanged) {
                vm.getAutoSuggestions();
            }
            vm.startDate = false;
        };

        vm.GetFormattedDate = function(formatDate) {
            var month = formatDate.getMonth() + 1;
            var day = formatDate.getDate();
            var year = formatDate.getFullYear();
            if (month <= 9) {
                month = '0' + month;
            }
            return day + "/" + month + "/" + year;
        }
        vm.getAutoSuggestions = function() {

            if (angular.isDate(vm.dialogData.start_time)) {
                var startTime = moment(vm.dialogData.start_time).format('LTS');
            } else {
                //                startTime = vm.dialogData.start_time;
                var time = vm.dialogData.start_time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
                if (time.length > 1) { // If time format correct
                    time = time.slice(1); // Remove full string match value
                    time[5] = +time[0] < 12 ? ' am' : ' pm'; // Set AM/PM
                    time[0] = +time[0] % 12 || 12; // Adjust hours
                    time.splice(3, 1)
                }
                startTime = time.join('');

            }

            var courseid = vm.dialogData.courseID;
            var course = vm.courseoptions;
            if (vm.dialogData.dialogtype == "edit") {

                if (vm.dialogData.weekdays != undefined) {
                    if (!angular.isArray(vm.dialogData.weekdays)) {
                        var arrWeekDay = vm.dialogData.weekdays.split(",");
                        vm.dialogData.weekdays = arrWeekDay;
                    }
                }
                if (vm.dialogData.type == 4) {
                    vm._bDisbleSaveButton = true;
                }
            }

            var requestData = {
                "courseID": vm.dialogData.courseID,
                "time": startTime,
                "weekdays": vm.dialogData.weekdays,
                'intakeType': vm.intakeType,
                'validity': vm.dialogData.validity
            };
            if (!(vm.isTimeChanged && !vm.isStartEndDateChanged)) {
                if (vm.dialogData.dialogtype == "add") {
                    requestData.start_date = vm.GetFormattedDate(vm.dialogData.start_date);
                } else {
                    if (angular.isDate(vm.dialogData.start_date)) {
                        requestData.start_date = vm.GetFormattedDate(vm.dialogData.start_date);
                    } else {
                        requestData.start_date = vm.dialogData.start_date;
                    }
                }
                if (vm.dialogData.dialogtype == "edit") {
                    requestData.intakeID = vm.dialogData.intakeID;
                    requestData.intake_id = vm.dialogData.scheduleClassID;

                    if (vm.dialogData.sendParam == true) {
                        requestData.editOngoingIntake = "1"
                    }
                    if (!vm.isStartEndDateChanged) {
                        if (vm.dialogData.dialogtype == "add") {
                            requestData.end_date = vm.GetFormattedDate(vm.dialogData.end_date);
                        } else {
                            requestData.end_date = vm.dialogData.end_date;
                        }
                    }
                }
            }

            Utils.showLoader(true);
            ApiService.GetIntakeSuggestion({
                data: requestData,
                success: function(response) {
                    vm.lastIntakeSuggestion = response.data;
                    Utils.showLoader(false);
                    if (vm._isFirstEditLoad) {
                        vm._isFirstEditLoad = false;
                        if (response && response.data && response.data.possibleDatesList) {
                            vm.enableDates = response.data.possibleDatesList;
                        }
                        if (response && response.data && response.data.dateRange) {
                            vm.dialogData.intakeID = response.data.intakeID;
                            vm.dialogData.dateRange = response.data.dateRange;
                            vm.dialogData.getSuggestionDate = response.data.dateRange;
                            vm.dialogData.end_time = response.data.endTime;
                            vm.dialogData.start_date = new Date(response.data.startDate);
                            vm.dialogData.end_date = new Date(response.data.endDate);
                        }
                        if (typeof response.data.roomsAvailable != 'undefined') {
                            if (response.data.roomsAvailable.length != 0) {

                                var roomobj = []
                                if (response.data.roomsAvailable) {

                                    var room = response.data.roomsAvailable;
                                    var suggestionRoom = response.data.roomsAvailable;
                                    var intakeRoom = vm.dialogData.roomAvailable;
                                    for (var i = 0; i < suggestionRoom.length; i++) {
                                        roomobj.push({ id: suggestionRoom[i].roomID, title: suggestionRoom[i].title });
                                    }
                                    for (var r = 0; r < roomobj.length; r++) {
                                        if (intakeRoom.length != '') {
                                            if (roomobj[r].roomID != intakeRoom[0].roomID) {
                                                var noRoomObjectFound = true;
                                            } else {
                                                var noRoomObjectFound = false;
                                                break;
                                            }
                                        }
                                    }
                                    if (noRoomObjectFound == true) {
                                        roomobj.push({ id: intakeRoom[0].roomID, title: intakeRoom[0].title });
                                    }
                                } else {
                                    vm.showRoom = true;
                                    //                            Utils.showToast({text: "Teachers not available"});
                                }

                                vm.roomoption = roomobj;
                            }
                        }
                        if (typeof response.data.teachersAvailable != 'undefined') {
                            if (response.data.teachersAvailable.length != 0) {

                                var teacherobj = []
                                if (response.data.teachersAvailable) {
                                    vm.Before = false;
                                    vm.After = true;

                                    var teacher = response.data.teachersAvailable;
                                    var suggestionTeacher = response.data.teachersAvailable;
                                    var intakeTeacher = vm.dialogData.teacherAvailable;
                                    for (var i = 0; i < suggestionTeacher.length; i++) {
                                        teacherobj.push({ id: teacher[i].id, name: teacher[i].full_name });
                                    }
                                    for (var p = 0; p < teacherobj.length; p++) {
                                        if (intakeTeacher.length != '') {
                                            if (teacherobj[p].id != intakeTeacher[0].id) {
                                                var noObjectFound = true;
                                            } else {
                                                var noObjectFound = false;
                                                break;
                                            }
                                        }
                                    }
                                    if (noObjectFound == true) {
                                        teacherobj.push({ id: intakeTeacher[0].id, name: intakeTeacher[0].full_name });
                                    }
                                } else {
                                    vm.Before = true;
                                    vm.After = false;
                                    vm.showTeacher = true;
                                    //                            Utils.showToast({text: "Teachers not available"});
                                }

                                vm.teacher = teacherobj;
                            }
                        }
                        return;
                    }
                    if (response.status == 1) {
                        vm.showMessage = false
                        var room = null,
                        roomobj = [],
                        teacherobj = [];
                        if (response.data) {
                            vm.dialogData.intakeID = response.data.intakeID;
                            vm.dialogData.end_time = response.data.endTime;
                            vm.dialogData.start_date = new Date(response.data.startDate);
                            vm.dialogData.end_date = new Date(response.data.endDate);
                            vm.dialogData.frequency_type = response.data.frequency_type;
                            vm.dialogData.dateRange = response.data.dateRange;
                            vm.dialogData.getSuggestionDate = response.data.dateRange;
                            vm.dialogData.classDuration = response.data.classDuration;
                            if (vm.dialogData.classDuration.length != 0) {
                                vm.showDuration = true;
                            }

                        }
                        room = response.data.roomsAvailable;
                        if (room) {
                            roomobj = [];
                            for (var i = 0; i < room.length; i++) {
                                roomobj.push({ id: room[i].roomID, title: room[i].title });
                            }
                        } else {
                            vm.showRoom = true;
                            //                            Utils.showToast({text: "Rooms not available"});
                        }
                        vm.roomoption = roomobj;
                        if (response.data.teachersAvailable) {
                            vm.Before = false;
                            vm.After = true;
                            var teacher = response.data.teachersAvailable;
                            for (var i = 0; i < teacher.length; i++) {
                                teacherobj.push({ id: teacher[i].id, name: teacher[i].full_name });
                            }
                        } else {
                            vm.Before = true;
                            vm.After = false;
                            vm.showTeacher = true;
                            //                            Utils.showToast({text: "Teachers not available"});
                        }

                        vm.teacher = teacherobj;
                        if (response.data.possibleDatesList) {
                            vm.dateRanges = response.data.datesList;
                            vm.enableDates = response.data.possibleDatesList;
                        }


                    } else {
                        if (response.data.message) {
                            vm.showMessage = response.data.message;
                            Utils.showToast({ text: response.data.message, 'type': 0 });
                        }
                    }
                }

            });
};

        /**
         * Initigalize
         */



         $(document.body).addClass("intake-dialog-visible");
        //   $(".custom-selc").select2({
        //       placeholder: "Select Teacher",
        //     allowClear: true
        // });
        if (vm.dialogData.dialogtype === 'add') {
            vm.isDisabled = false;
            vm.dialogData.start_date = new Date();
            vm.dialogData.end_date = new Date();
            vm.dialogData.start_time = new Date();
            vm.dialogData.start_time.setHours(12);
            vm.dialogData.start_time.setMinutes(0);
            vm.dialogData.start_time.setSeconds(0);
            vm.dialogData.start_time.setMilliseconds(0);
            vm.dialogData.end_time = new Date();
            vm.dialogData.end_time.setHours(0);
            vm.dialogData.end_time.setMinutes(0);
            vm.dialogData.end_time.setSeconds(0);
            vm.dialogData.end_time.setMilliseconds(0);
            vm.dialogData.additional_pay = [];
            vm.dialogData.weekdays = [];
            vm.editShow = false;
            vm._bHideStudentDropdown = true;
        }
        vm.previousTime = moment().format('h:mm:ss a');
        if (vm.dialogData.dialogtype === 'edit') {

            vm._bHideStudentDropdown = false;
            if (vm.dialogData.roomAvailable.length == 0) {
                var intakeDetailsRoom = true;
            }
            if (vm.dialogData.teacherAvailable.length == 0) {
                var intakeDetailsTeacher = true;
            }
            if (vm.dialogData.type != '1') {
                vm.commentsShow = true;
            }

            vm.dialogData.dateRange;
            vm.isDisabled = true;
            if (vm.dialogData.courseType) {
                for (var j = 0; j < vm.courseType.length; j++) {
                    if (vm.courseType[j].text == vm.dialogData.courseType) {
                        var typeName = vm.courseType[j].value;
                    }
                }
                if (typeName == 'Private') {
                    vm._bHideLocation = false;
                    vm.locationRequied = false;
                }
                vm.searchText = vm.dialogData.courseName + " - " + vm.dialogData.courseLevel + " - " + typeName + " - " + vm.dialogData.class_duration + " hours , " + (vm.dialogData.no_of_classes * vm.dialogData.class_duration) + " hours";
            }

            if (vm.dialogData.courseType) {
                for (var j = 0; j < vm.courseType.length; j++) {
                    if (vm.courseType[j].text == vm.dialogData.courseType) {
                        var typeName = vm.courseType[j].value;
                    }
                }
                $scope.arrCourses = [{ title: vm.dialogData.courseName, Level: vm.dialogData.courseLevel, Series: vm.dialogData.courseSeries, Rule: typeName, Duration: vm.dialogData.class_duration + " hours" }];
                $scope.selectedPerson = [{ title: vm.dialogData.courseName, Level: vm.dialogData.courseLevel, Series: vm.dialogData.courseSeries, Rule: typeName }];
                $scope.searchStr = [{ title: vm.dialogData.courseName, Level: vm.dialogData.courseLevel, Series: vm.dialogData.courseSeries, Rule: typeName }];
            }
            vm._isFirstEditLoad = true;
            vm._isColorSelected = false;
            vm.isCourseChanged = true;
            vm.isTimeChanged = true;
            vm.isStartEndDateChanged = true;
            vm.onChangeCheckBox = true;
            //            vm.getAutoSuggestions(); commented for not need to call on edit 
            if (vm.dialogData.noneditable == "editable" && vm.allChangedParam == true) {} else {
                vm.dialogData.dateRange = vm.dialogData.getIntakeDetailsDate;
            }
            if (vm.dialogData.noneditable == "noneditable") {
                vm.dialogData.dateRange = vm.dialogData.dateRange;
            }
            //if(intakeDetailsRoom == false){
            //    
            //}
            var room = vm.dialogData.roomAvailable;
            if (room.length == 0) {
                vm.dialogData.roomID = '';
            }
            var roomobj = [];
            for (var i = 0; i < room.length; i++) {
                roomobj.push({ id: room[i].id, title: room[i].title });
            }
            vm.roomoption = roomobj;
            var teacher = vm.dialogData.teacherAvailable;
            if (teacher.length == 0) {
                vm.dialogData.teacherID = '';
                vm.Before = true;
                vm.After = false;
            } else {
                vm.Before = false;
                vm.After = true;
            }
            if (teacher.length <= 0) {
                vm.editShow = false;
            } else {
                vm.editShow = true;
            }
            var teacherobj = [];
            for (var i = 0; i < teacher.length; i++) {
                teacherobj.push({ id: teacher[i].id, name: teacher[i].full_name });
            }

            vm.teacher = teacherobj;
            if (!angular.isDate(vm.dialogData.start_date)) {
                vm.dialogData.start_date = Utils.getFormattedIntakeDate(vm.dialogData.start_date);
            }
            if (!angular.isDate(vm.dialogData.end_date)) {
                vm.dialogData.end_date = Utils.getFormattedIntakeDate(vm.dialogData.end_date);
            }
            if (!angular.isDate(vm.dialogData.start_time)) {
                var timeArr = vm.dialogData.start_time.split(':');
                vm.dialogData.start_time = new Date();
                vm.dialogData.start_time.setHours(timeArr[0]);
                vm.dialogData.start_time.setMinutes(timeArr[1]);
                vm.dialogData.start_time.setSeconds(timeArr[2]);
                vm.dialogData.start_time.setMilliseconds(0);
            }
            if (vm.dialogData.frequency_type == "Weekly") {
                if (vm.dialogData.weekdays != undefined) {
                    vm.showDays = true;
                    for (var j = 0; j < vm.days.length; j++) {
                        for (var i = 0; i < vm.dialogData.weekdays.length; i++) {

                            if (vm.days[j].id == vm.dialogData.weekdays[i]) {
                                vm.days[j].bAllow = true;
                            }

                        }
                    }
                }
            }
            getTeacherAutoSuggestions();
        }

        function getTeacherAutoSuggestions() {
            console.log(vm.dialogData);
            var requestData = {
                'scheduleClassID': vm.dialogData.scheduleClassID,
                'intakeType': vm.dialogData.courseType,
                "courseID": vm.dialogData.courseID,
            };
            ApiService.GetTeacherSuggestion({
                data: requestData,
                success: function(response) {
                    Utils.showLoader(false);
                    //                    vm.teacher = response.data;
                    if (typeof response.data != 'undefined') {
                        if (response.data.length != 0) {

                            var teacherobj = []
                            if (response.data) {
                                vm.Before = false;
                                vm.After = true;

                                var teacher = response.data;
                                var suggestionTeacher = response.data;
                                var intakeTeacher = vm.dialogData.teacherAvailable;
                                for (var i = 0; i < suggestionTeacher.length; i++) {
                                    teacherobj.push({ id: teacher[i].id, name: teacher[i].full_name });
                                }
                                for (var p = 0; p < teacherobj.length; p++) {
                                    if (intakeTeacher.length != '') {
                                        if (teacherobj[p].id != intakeTeacher[0].id) {
                                            var noObjectFound = true;
                                        } else {
                                            var noObjectFound = false;
                                            break;
                                        }
                                    }
                                }
                                if (noObjectFound == true) {
                                    teacherobj.push({ id: intakeTeacher[0].id, name: intakeTeacher[0].full_name });
                                }
                            } else {
                                vm.Before = true;
                                vm.After = false;
                                vm.showTeacher = true;
                                //                            Utils.showToast({text: "Teachers not available"});
                            }

                            vm.teacher = teacherobj;
                        }
                    }
                }
            });
        }

        vm._reloadDtPage = function() {
            if($location.path() != '/dashboard') {
                vm.dtInstance.changeData(dtPromiseFn());
            }
        };
        /**
         * Close the dialog
         */
         function closeDialog() {
            vm.enableDates = {};
            $mdDialog.cancel();
            vm.isTimeChanged = false;
            vm.isStartEndDateChanged = false;
            vm.isEndDateChanged = false;
            vm.showStartDateError = false;
            vm.showEndDateError = false;
            vm.showRoom = false;
            vm.showTeacher = false;
            vm.showIntakeError = false;
            vm.startDate = false;
            vm._isFirstEditLoad = false;
            vm.onChangeCheckBox = false;
            for (var i = 0; i < vm.days.length; i++) {
                vm.days[i].bAllow = false;
            }
            $(document.body).removeClass("intake-dialog-visible");
        }
        $(document).keyup(function(e) {
            if (e.keyCode == 27) { // escape key maps to keycode `27`
                // <DO YOUR WORK HERE>

                vm.enableDates = {};
                $mdDialog.cancel();
                vm.isTimeChanged = false;
                vm.isStartEndDateChanged = false;
                vm.isEndDateChanged = false;
                vm.showStartDateError = false;
                vm.showEndDateError = false;
                vm.showRoom = false;
                vm.showTeacher = false;
                vm.showIntakeError = false;
                vm.startDate = false;
                vm._isFirstEditLoad = false;
                vm.onChangeCheckBox = false;
                for (var i = 0; i < vm.days.length; i++) {
                    vm.days[i].bAllow = false;
                }
                $(document.body).removeClass("intake-dialog-visible");
            }
        });

        function onDeleteBtnTap(e) {

            var deleteData = {
                "intakes": [vm.dialogData.scheduleClassID]
            }

            var confirm = $mdDialog.confirm()
            .title('Confirm Delete of selected Intake?')
            .textContent('Are you sure you want to delete selected Intake ?')
            .ariaLabel('Delete')
            .targetEvent(e)
            .ok('Delete')
            .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                Utils.showLoader(true);
                ApiService.DeleteIntake({
                    data: deleteData,
                    success: function(response) {
                        Utils.showLoader(false);
                        if (response.status == 0) {
                            Utils.showToast({ text: response.data.message, 'type': 0 });
                        } else {
                            Utils.showToast({ text: response.data.message, 'type': 1 });
                            vm._reloadDtPage();
                        }
                    }
                });
            }, function() {});
        }

        vm.showRoomChange = function() {
            vm.showRoom = false;
            vm._isChangeRoom = true;
            if (vm._bHideLocation == false) {
                if (vm.dialogData.roomID == '') {
                    vm.locationRequied = false;
                } else {
                    vm.locationRequied = true;

                }
            }
            if (vm.dialogData.roomID != '') {
                vm._bDisableLocation = true;
            } else {
                vm._bDisableLocation = false;
            }
        }

        vm.onLocationChange = function() {

            if (typeof vm.dialogData.location == 'undefined' || vm.dialogData.location == '') {
                vm._bdisableRoom = false;
            } else {
                vm._bdisableRoom = true;
            }
        }

        vm.showTeacherChange = function() {
            vm.showTeacher = false;
            vm._isChangeTeacher = true;
            if (vm.dialogData.teacherID.length != 0) {
                vm.editShow = true;
                vm.dialogData.additional_pay = [];
            } else {
                vm.editShow = false;
                vm.dialogData.additional_pay = [];
            }
        }

        function calculatesDateForUpdateIntake() {
            if (typeof vm.dialogData.getSuggestionDate == 'undefined') {
                return;
            }
            var currentDate = new Date();
            var dd = currentDate.getDate();

            var mm = currentDate.getMonth() + 1;
            var yyyy = currentDate.getFullYear();
            if (dd < 10)
                dd = '0' + dd;

            if (mm < 10)
                mm = '0' + mm;
            currentDate = yyyy + '-' + mm + '-' + dd;

            var arrDates = [];
            j = 0;
            for (var i = 0; i < vm.oldIntakeDateRange.length; i++) {
                if (new Date(currentDate).getTime() >= new Date(vm.oldIntakeDateRange[i]).getTime()) {
                    arrDates.push(vm.oldIntakeDateRange[i]);
                } else {
                    if(currentDate == vm.dialogData.getSuggestionDate[j]) {
                        j++;
                    }
                    arrDates.push(vm.dialogData.getSuggestionDate[j]);
                    j++;
                }
            }
            return arrDates;
        }
        vm.checkIntakeStatus = function() {
            Utils.showLoader(true);
            var requestData = {
                'schedule_class_id': vm.dialogData.scheduleClassID
            };
            ApiService.CheckIntakeStatus({
                data: requestData,
                success: function(response) {

                    if (response.status == '0') {
                        Utils.showLoader(false);
                        Utils.showToast({ text: response.data.message, 'type': 0 });
                        vm.editStatus = 0;
                    } else {
                        vm.editStatus = 1;
                        saveIntake(this);

                    }
                }
            });
        }

        function onSaveIntakeBtnTap(ev) {

            if (vm.dialogData.noneditable == "editable") {
                vm.checkIntakeStatus();
                if (vm.editStatus == 0) {
                    return;
                }
            } else {
                if (vm.dialogData.dialogtype == "add" && vm.intakeType == 'G' || vm.intakeType == 'O') {
                    ApiService.CheckIntakeNewTerm({
                        data: vm.dialogData,
                        success: function(response) {
                            var studentCount = 0;
                            if (angular.equals(response.data, {})) {
                                studentCount = 0;
                            } else {
                                studentCount = response.data.length;
                            }


                            var confirm = $mdDialog.confirm()
                            .title('Confirm sending emails')
                            .textContent('Click YES will send emails to ' + studentCount + ' students or click NO to proceed without sending emails.')
                            .ariaLabel('Lucky day')
                            .targetEvent(ev)
                            .clickOutsideToClose(true)
                            .parent(angular.element(document.body))
                            .ok('Yes')
                            .cancel('No ( Skip emails )');
                            $mdDialog.show(confirm).then(function() {
                                vm.dialogData.sendStudentMail = 1;
                                saveIntake(this);
                            }, function() {
                                vm.dialogData.sendStudentMail = 0;
                                saveIntake(this);
                            });
                            // if (confirm(studentCount + ' Student will receive new term email.')) {
                            //     vm.dialogData.sendStudentMail = 1;
                            //     saveIntake(this);
                            // } else {
                            //     vm.dialogData.sendStudentMail = 0;
                            //     saveIntake(this);

                            // }

                        }
                    });
                } else if (vm.dialogData.dialogtype == "add" && vm.intakeType == 'P') {
                    saveIntake(this);
                }
            }
        }

        function saveIntake(e) {
            Utils.showLoader(true);

            if (vm.dialogData.noneditable == "editable" && vm.allChangedParam == true) {

                vm.dialogData.dateRange = vm.dialogData.getSuggestionDate;
                vm.dialogData.dateRange = calculatesDateForUpdateIntake();


            } else if (vm.dialogData.noneditable == "editable" && vm.allChangedParam == false) {
                if (typeof vm.dialogData.getSuggestionDate != 'undefined') {
                    vm.dialogData.dateRange = vm.dialogData.getSuggestionDate;
                } else {
                    vm.dialogData.dateRange = vm.dialogData.getIntakeDetailsDate;
                }

            } else if (vm.dialogData.dialogtype == "add") {
                vm.dialogData.dateRange = vm.dialogData.getSuggestionDate;
            }

            vm.dialogData.intakeType = vm.intakeType;
            vm.dialogData.roomID = vm.dialogData.roomID === undefined ? null : vm.dialogData.roomID;
            vm.dialogData.teacherID = vm.dialogData.teacherID === undefined ? null : vm.dialogData.teacherID;
            vm.dialogData.dateRange = vm.dialogData.dateRange === undefined ? null : vm.dialogData.dateRange;
            vm.dialogData.is_display = vm.dialogData.is_display ? '1' : 0;
            vm.dialogData;
            if (vm.dialogData.sendParam == true) {
                vm.dialogData.editOngoingIntake = "1";
            }
            var dialogData = angular.copy(vm.dialogData);
            dialogData.start_date = moment(dialogData.start_date).format('L');
            dialogData.end_date = moment(dialogData.end_date).format('L');
            dialogData.start_time = moment(vm.dialogData.start_time).format('LTS');

            ;
            if (dialogData.students != undefined) {
                dialogData.students = dialogData.students;
            } else {
                dialogData.students = null;
            }
            //            console.log(dialogData);
            //            
            //            return;
            ApiService.AddUpdateIntake({
                data: dialogData,
                dtInstance: vm.dtInstance,
                success: function(response) {
                    if (response.status == 0) {
                        Utils.showLoader(false);
                        if (response.data) {
                            Utils.showToast({ text: response.data.message, 'type': 0 });
                        }
                        if (response.data.message.dates_error) {
                            vm.startDate = response.data.message.dates_error;
                        }

                        if (response.data.message.room_error) {
                            vm.showRoom = response.data.message.room_error;
                        }
                        if (response.data.message.teacher_error) {
                            vm.showTeacher = response.data.message.teacher_error;
                        }
                        if (response.data.message.intake_id_error) {
                            vm.showIntakeError = response.data.message.intake_id_error;
                        }

                    } else {
                        $mdDialog.hide(vm.dialogData);
                        Utils.showLoader(false);
                        Utils.showToast({ text: response.data.message, 'type': 1 });
                        vm._reloadDtPage();
                    }
                }
            });
        }



        vm.onDuplicateClick = function() {
            dialogData.title = 'Add New Intake';
            dialogData.dialogtype = 'add';
            dialogData.scheduleClassID = null;
            dialogData;
        };

        function init() {
            vm.dialogData.title = (vm.dialogData.dialogtype === 'add' ? 'Add New Intake' : 'Edit Intake');
            console.log(vm.dialogData);
            if (vm.dialogData.title != 'add') {
                vm.oldIntakeDateRange = vm.dialogData.dateRange;
                vm.dialogData.is_display = (vm.dialogData.is_display == '1') ? true : false;

                if (vm.dialogData.courseType == 'P') {
                    vm.intakeType = 'P';
                    if (vm.dialogData.location != "" && vm.dialogData.location != null) {
                        vm._bdisableRoom = true;
                        vm._bDisableLocation = false;
                        vm.locationRequied = false;
                    } else {
                        vm._bdisableRoom = false;
                        vm._bDisableLocation = true;
                        vm.locationRequied = true;
                    }
                } else if(vm.dialogData.courseType == 'O') {
                    vm.intakeType = 'O';
                } else {
                    vm.intakeType = 'G';
                }
            } else {
                vm.dialogData.is_display = false;

            }
            if (vm.dialogData.showTypeDialog === 'info' && vm.dialogData.dialogtype === 'edit') {
                vm.dialogData.title = "INTAKE";

            }

        }
        init();

    }


})();
(function()
{
    'use strict';

    angular
            .module('app.holidays', ['720kb.datepicker'])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
    }
})();
(function ()
{
    'use strict';

    angular.module('app.holidays')
            .controller('AddHolidaysDialogController', AddHolidaysDialogController);

    /** @ngInject */
    function AddHolidaysDialogController($mdDialog, dialogData, ApiService, $mdToast, Utils, dtInstance, dtPromiseFn, currentYear)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.dtInstance = dtInstance;
        vm.cnt = 0;

        // Methods
        vm.closeDialog = closeDialog;
        vm.onSaveHolidayBtnTap = onSaveHolidayBtnTap;
        vm.onDeleteBtnTap = onDeleteBtnTap;
        vm.dtPromiseFn = dtPromiseFn;
        vm.currentYear = currentYear;
        vm.onChangeStartDate = onChangeStartDate
        vm.isStartDateChange = true;
        vm.getDateYear = getDateYear;
        vm.setMinYear = setMinYear;
        vm.setMaxYear = setMaxYear;
        init();


        //////////

        /**
         * Initialize
         */


        function init()
        {

            vm.dialogData.title = (vm.dialogData.type === 'add' ? 'Add New Holiday' : 'Edit Holiday');
            if (vm.dialogData.type === 'add') {
                vm.setStartValue = getDateYear();
                vm.setStartYearMin = setMinYear();
                vm.setStartYearMax = setMaxYear();
                vm.setEndValue = getDateYear();
                vm.setMinDate = getDateYear();
            }
            if (vm.dialogData.type === 'edit') {
                console.log(vm.dialogData);
//                return;
                if (!angular.isDate(vm.dialogData.start_date)) {
                    vm.dialogData.start_date = Utils.getFormattedDate(vm.dialogData.start_date);
                    vm.setStartValue = vm.dialogData.start_date;
                }
                if (!angular.isDate(vm.dialogData.end_date)) {
                    vm.dialogData.end_date = Utils.getFormattedDate(vm.dialogData.end_date);
                    vm.setEndValue = vm.dialogData.end_date;
                }
            }
        }

        function setMinYear() {
            var d = new Date(vm.currentYear, 0, 1);
            return d.toString();
        }

        function setMaxYear() {
            var d = new Date(vm.currentYear, 11, 31);
            return d.toString();
        }
        function getDateYear() {
            var d = new Date();
            d.setFullYear(vm.currentYear);
            return d.toString();
        }
//        vm.dialogData.end_date = Utils.getFormattedDate(vm.dialogData.start_date);
        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(dtPromiseFn(vm.currentYear));

        };

//        vm.minDate = new Date(vm.dialogData.start_date);
        function onChangeStartDate(startDate) {
            vm.dialogData.end_date = startDate;
            vm.setMinDate = Utils.getDashedFormattedDate(startDate);
            ;


        }
        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }
        function onDeleteBtnTap(e) {

            var deleteData = {
                "holidays": [vm.dialogData.holidayID]
            }
            var confirm = $mdDialog.confirm()
                    .title('Confirm Delete Holiday ?')
                    .textContent('Are you sure you want to delete selected Holiday ?')
                    .ariaLabel('Delete')
                    .targetEvent(e)
                    .ok('Delete')
                    .cancel('Cancel');
            $mdDialog.show(confirm).then(function () {
                Utils.showLoader(true);
                ApiService.DeleteHoliday({
                    data: deleteData,
                    success: function (response) {
                        Utils.showLoader(false);
                        if (response.status == 0) {
                            Utils.showToast({text: response.data.message, 'type': 0});
                        } else {
                            Utils.showToast({text: response.data.message, 'type': 1});
                            vm._reloadDtPage();
                        }
                    }
                });
            }, function () {
            });
        }

        function onSaveHolidayBtnTap(e) {
            // counter kept . if counter will be 2 den only holliday wll be saved .
            vm.cnt = vm.cnt + 1;
            Utils.showLoader(true);
            var dialogData = angular.copy(vm.dialogData);
            ApiService.AddUpdateHoliday({
                data: dialogData,
                success: function (response) {
                    if (response.status == 0) {
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 0});
                    } else {
                        $mdDialog.hide(vm.dialogData);
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 1});
                        vm._reloadDtPage();
                    }
                }
            });
        }


    }
})();

(function () {
    'use strict';

    angular.module('app.skills')
        .controller('RequestAdhocClassDialogController', RequestAdhocClassDialogController);

    /** @ngInject */
    function RequestAdhocClassDialogController($mdDialog, dialogData, ApiService, Utils, dtInstance, dtPromiseFn,updateScheduler,GlobalPool) {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        // console.log(vm.dialogData);
        vm.dtInstance = dtInstance;
        vm.dtPromiseFn = dtPromiseFn;
        vm.updateScheduler = '';
        vm.skills = [];
        vm.teachers = [];
        vm.rooms = [];
        vm.durations = ['1','1.30', '2','2.30','3','3.30','4','4.30', '5','5.30', '6','6.30'];
        vm.coloroption = Focus.ENUMS.INTAKE_COLOR;
        var userInfo = GlobalPool.getUserInfo();
        vm.role_id = userInfo.role_id;
        vm.user_id = userInfo.id;
        
        // Methods
        vm.closeDialog = closeDialog;
        vm.onSaveBtnTap = onSaveBtnTap;
        vm.onClick = onClick;



        init();

        //////////

        /**
         * Initialize
         */
        function GetFormattedDate(formatDate) {
            var from = formatDate.split("/");

            return new Date(from[2], from[1] - 1, from[0])
            return day + "/" + month + "/" + year;
        }
        function init() {
            vm.dialogData.title = 'Request AdHoc Class';
            vm.dialogData.teacher_id = vm.user_id;
            // vm.dialogData.start_date = '';
            if(vm.role_id == '2') {
                Utils.showLoader(true);
                ApiService.GetTeacherSkills({
                    data: {
                        'id' : vm.user_id,
                        'role_id' : vm.role_id
                    }
                }).then(function (response) {
                    Utils.showLoader(false);
                    vm.skills = response.data;
                    vm.dialogData.selected_skill = vm.skills[0]['id'];
                    vm.onSkillChanged();
                });
            } else {
                Utils.showLoader(true);
                ApiService.GetSkills({
                    // data: requestData
                }).then(function (response) {
                    Utils.showLoader(false);
                    vm.skills = response.data;
                });
            }
            ApiService.GetRoom({
                // data: requestData
            }).then(function (response) {
                Utils.showLoader(false);
                vm.rooms = response.data;
                for(var i=0;i<vm.rooms.length;i++){
                    if(vm.rooms[i].title == vm.dialogData.data.roomTitle) {
                        // console.log('anis ' + vm.rooms[i].title);
                        vm.dialogData.room_id = vm.rooms[i].roomID;
                        break;
                    }
                }
                console.log(vm.dialogData);
            });
        }



        /**
         * Close the dialog
         */
        function closeDialog() {
            $mdDialog.cancel();
        }
        function onClick(color) {
            vm.dialogData.color = color;
            if (vm.dialogData.color) {
                vm._isColorSelected = false;
            }
        }
        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(dtPromiseFn());

        };
        vm.onSkillChanged = function () {
            Utils.showLoader(true);

            var requestData = {
                'skill': vm.dialogData.selected_skill
            };
            ApiService.GetTeachersBySkill({
                data: requestData
            }).then(function (response) {
                Utils.showLoader(false);

                vm.teachers = response.data;
                console.log(vm.teachers);
            });
        }

        vm.getFilteredRoom = function () {
            
            ApiService.GetRooms({
                // data: requestData
            }).then(function (response) {
                Utils.showLoader(false);

                vm.rooms = response.data;
                console.log(vm.rooms);
            });
        };

        function addHoursToTime(timeStr, hoursToAdd, minutesToAdd) {
            var timeSplit = timeStr.split(' ');
            var time = timeSplit[0];
            var period = timeSplit[1];
        
            var timeParts = time.split(':').map(function (part) {
                return Number(part);
            });
        
            var hours = timeParts[0];
            var minutes = timeParts[1];
            var seconds = timeParts[2];
        
            hours += hoursToAdd;
            minutes += minutesToAdd;
        
            if (minutes >= 60) {
                minutes -= 60;
                hours += 1;
            }
        
            if (hours >= 12) {
                hours -= 12;
                if (period === 'AM') {
                    period = 'PM';
                } else {
                    period = 'AM';
                }
            }
        
            return (hours < 10 ? '0' + hours : hours) + ':' +
                   (minutes < 10 ? '0' + minutes : minutes) + ':' +
                   (seconds < 10 ? '0' + seconds : seconds) + ' ' +
                   period;
        }
        

        function onSaveBtnTap(e) {
            // Utils.showLoader(true);
            console.log(moment(vm.dialogData.start_time).format('LTS'));
            

            var requestData = {
                "Type": "add",
                'type': 4,
                'start_date': moment(vm.dialogData.data.start_date).format('L'),
                'start_time': moment(vm.dialogData.start_time).format('LTS'),
                'end_time' : 'pending',
                'teacherID': vm.dialogData.teacher_id,
                'roomID': vm.dialogData.room_id,
                'duration': vm.dialogData.duration,
                'color': vm.dialogData.color,
                'skill_id': vm.dialogData.selected_skill,
                'students' : [],
                'comments' : vm.dialogData.selected_skill
            }
            var duration = requestData.duration.split('.');
            var minutes = 0;
            if(typeof duration[1] != 'undefined'){
                minutes = duration[1];
            }
            requestData.end_time = addHoursToTime(requestData.start_time,parseInt(duration[0]),parseInt(minutes));
            console.log(requestData);
            ApiService.AddAdhocClassRequest({
                data: requestData,
                dtInstance: vm.dtInstance,
                success: function (response) {
                    if (response.status == 0) {
                        //                        vm.Error = true;
                        Utils.showLoader(false);

                        if (response.data.message.dates_error) {
                            vm.errorMessage = vm.startDate = response.data.message.dates_error;
                        }

                        if (response.data.message.room_error) {
                            vm.errorMessage = vm.showRoom = response.data.message.room_error;
                        }
                        if (response.data.message.teacher_error) {
                            vm.errorMessage = vm.showTeacher = response.data.message.teacher_error;
                        }
                        if (response.data.message.intake_id_error) {
                            vm.errorMessage = vm.showIntakeError = response.data.message.intake_id_error;
                        }
                        Utils.showToast({
                            text: vm.errorMessage,
                            'type': 0
                        });
                    } else {
                        $mdDialog.hide(vm.dialogData);
                        Utils.showLoader(false);
                        Utils.showToast({
                            text: "Saved Succesfully",
                            'type': 1
                        });
                        
                    }
                }
            });
           

        }

        function addTimeToString(timeString, addHours) {
            // The third argument is optional.
            addHours = addHours.split('.');
            var startTime = timeString;
            var hours = parseInt(addHours[0]);
            var minutes = 0;
            if(typeof addHours[1] != 'undefined') {
                minutes = addHours[1];
            }

            var startTimeMoment = moment(startTime, 'hh:mm:ss A');
            var endTimeMoment = startTimeMoment.add(hours, 'hours').add(minutes, 'minutes');
            var endTime = endTimeMoment.format('hh:mm:ss A');

            return endTime;
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.skills')
        .controller('CheckAvailableRoomDialogController', CheckAvailableRoomDialogController);

    /** @ngInject */
    function CheckAvailableRoomDialogController($mdDialog, dialogData, ApiService, Utils, dtInstance, dtPromiseFn, updateScheduler) {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.dtInstance = dtInstance;
        vm.dtPromiseFn = dtPromiseFn;
        vm.availableRooms = [];
        vm.dates = [];
        // Methods
        vm.closeDialog = closeDialog;
        vm.onSaveBtnTap = onSaveBtnTap;
        vm.onClick = onClick;



        init();

        //////////

        /**
         * Initialize
         */

        function init() {
            var today = new Date();

            // Loop through the next 7 days
            for (var i = 0; i < 7; i++) {
                var nextDate = new Date(today);
                nextDate.setDate(today.getDate() + i);
                vm.dates.push(nextDate);
            }
            Utils.showLoader(true);
            ApiService.GetAvailableRoomSlots({
                // data: requestData
            }).then(function (response) {
                Utils.showLoader(false);
                vm.availableRooms = response.data;
                
                console.log(vm.availableRooms);
            });
        }

        /**
         * Close the dialog
         */
        function closeDialog() {
            $mdDialog.cancel();
        }
        function onClick(color) {
            vm.dialogData.color = color;
            if (vm.dialogData.color) {
                vm._isColorSelected = false;
            }
        }
        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(dtPromiseFn());

        };


        function onSaveBtnTap(e) {
            // Utils.showLoader(true);


        }
    }
})();

(function () {
    'use strict';

    angular.module('app.skills')
        .controller('AddAdhocClassDialogController', AddAdhocClassDialogController);

    /** @ngInject */
    function AddAdhocClassDialogController($mdDialog, dialogData, ApiService, Utils, dtInstance, dtPromiseFn,updateScheduler) {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        console.log(vm.dialogData);
        vm.dtInstance = dtInstance;
        vm.dtPromiseFn = dtPromiseFn;
        vm.updateScheduler = '';
        vm.skills = [];
        vm.teachers = [];
        vm.rooms = [];
        vm.durations = ['1','1.30', '2','2.30','3','3.30','4','4.30', '5','5.30', '6','6.30'];
        vm.coloroption = Focus.ENUMS.INTAKE_COLOR;

        // Methods
        vm.closeDialog = closeDialog;
        vm.onSaveBtnTap = onSaveBtnTap;
        vm.onClick = onClick;



        init();

        //////////

        /**
         * Initialize
         */
        function GetFormattedDate(formatDate) {
            var from = formatDate.split("/");

            return new Date(from[2], from[1] - 1, from[0])
            return day + "/" + month + "/" + year;
        }
        function init() {
            Utils.showLoader(true);
            ApiService.GetSkills({
                // data: requestData
            }).then(function (response) {
                Utils.showLoader(false);
                vm.skills = response.data;
                if (vm.dialogData.type == 'edit') {
                    vm.dialogData.selected_skill = vm.dialogData.intake_skill_id;
                    vm.onSkillChanged();
                    vm.getFilteredRoom();

                }
            });
            vm.dialogData.title = (vm.dialogData.type === 'add' ? 'Add New AdHoc Class' : 'Edit AdHoc Class');
            if (vm.dialogData.type == 'edit') {
                // vm.dialogData.start_time = "";
                vm.dialogData.room_id = vm.dialogData.roomID;
                vm.dialogData.teacher_id = vm.dialogData.teacherID;
                vm.dialogData.start_date = GetFormattedDate(vm.dialogData.start_date);
                var split_time = vm.dialogData.start_time.split(":");
                vm.dialogData.start_time = new Date(2021, 10, 10, split_time[0], split_time[1], split_time[2]);
                vm.dialogData.duration = vm.dialogData.intake_duration;
                vm.updateScheduler = updateScheduler;

            }

        }



        /**
         * Close the dialog
         */
        function closeDialog() {
            $mdDialog.cancel();
        }
        function onClick(color) {
            vm.dialogData.color = color;
            if (vm.dialogData.color) {
                vm._isColorSelected = false;
            }
        }
        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(dtPromiseFn());

        };
        vm.onSkillChanged = function () {
            Utils.showLoader(true);

            var requestData = {
                'skill': vm.dialogData.selected_skill
            };
            ApiService.GetTeachersBySkill({
                data: requestData
            }).then(function (response) {
                Utils.showLoader(false);

                vm.teachers = response.data;
                console.log(vm.teachers);
            });
        }

        vm.getFilteredRoom = function () {
            if (typeof vm.dialogData.start_date == "undefined" || typeof vm.dialogData.start_time == "undefined" || typeof vm.dialogData.duration == "undefined") {
                return -1;
            }
            var end_time = addTimeToString(moment(vm.dialogData.start_time).format('LTS'), vm.dialogData.duration);
            var exclude_schedule_id = null;
            if (vm.dialogData.type == 'edit') {
                exclude_schedule_id = vm.dialogData.scheduleClassID;
            }
            var requestData = {
                'start_date': moment(dialogData.start_date).format('YYYY-MM-DD'),
                'start_time': moment(vm.dialogData.start_time).format("HH:mm:ss"),
                'end_time': moment(end_time, ["h:mm:ss A"]).format("HH:mm:ss"),
                // 'start_time' : '01:00:00',
                // 'end_time' : '03:00:00',
                'duration': vm.dialogData.duration,
                'exclude_schedule_id' : exclude_schedule_id,
            }

            if (typeof requestData.start_date == "undefined" || typeof requestData.start_time == "undefined" || typeof requestData.duration == "undefined") {
                return -1;
            }
            ApiService.GetAvailableRooms({
                data: requestData
            }).then(function (response) {
                Utils.showLoader(false);

                vm.rooms = response.data;
                console.log(vm.rooms);
            });
        };



        function onSaveBtnTap(e) {
            // Utils.showLoader(true);
            console.log(moment(vm.dialogData.start_time).format('LTS'));
            var end_time = addTimeToString(moment(vm.dialogData.start_time).format('LTS'), vm.dialogData.duration);

            var requestData = {
                "Type": "add",
                'type': 4,
                'start_date': moment(dialogData.start_date).format('L'),
                'start_time': moment(vm.dialogData.start_time).format('LTS'),
                'end_time': end_time,
                'teacherID': vm.dialogData.teacher_id,
                'roomID': vm.dialogData.room_id,
                'duration': vm.dialogData.duration,
                'color': vm.dialogData.color,
                'skill_id': vm.dialogData.selected_skill,
                'students': [],
                'comments': vm.dialogData.selected_skill,
            }
            if (vm.dialogData.type == 'edit') {
                requestData.scheduleClassID = vm.dialogData.scheduleClassID;
            }

            ApiService.AddAdhocStudent({
                data: requestData,
                dtInstance: vm.dtInstance,
                success: function (response) {
                    if (response.status == 0) {
                        //                        vm.Error = true;
                        Utils.showLoader(false);

                        if (response.data.message.dates_error) {
                            vm.errorMessage = vm.startDate = response.data.message.dates_error;
                        }

                        if (response.data.message.room_error) {
                            vm.errorMessage = vm.showRoom = response.data.message.room_error;
                        }
                        if (response.data.message.teacher_error) {
                            vm.errorMessage = vm.showTeacher = response.data.message.teacher_error;
                        }
                        if (response.data.message.intake_id_error) {
                            vm.errorMessage = vm.showIntakeError = response.data.message.intake_id_error;
                        }
                        Utils.showToast({
                            text: vm.errorMessage,
                            'type': 0
                        });
                    } else {
                        $mdDialog.hide(vm.dialogData);
                        Utils.showLoader(false);
                        Utils.showToast({
                            text: "Saved Succesfully",
                            'type': 1
                        });
                        if (vm.dialogData.type == 'edit') {
                            vm.updateScheduler();
                        }
                    }
                }
            });

        }

        function addTimeToString(timeString, addHours) {
            // The third argument is optional.
            addHours = addHours.split('.');
            var startTime = timeString;
            var hours = parseInt(addHours[0]);
            var minutes = 0;
            if(typeof addHours[1] != 'undefined') {
                minutes = addHours[1];
            }

            var startTimeMoment = moment(startTime, 'hh:mm:ss A');
            var endTimeMoment = startTimeMoment.add(hours, 'hours').add(minutes, 'minutes');
            var endTime = endTimeMoment.format('hh:mm:ss A');

            return endTime;
        }

    }
})();

(function()
{
    'use strict';

    angular
            .module('app.courses', ['vAccordion', 'ngAnimate'])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State

    }
})();
(function () {
    'use strict';
    angular.module('app.courses')
        .controller('AddCoursesDialogController', AddCoursesDialogController);
    /** @ngInject */
    function AddCoursesDialogController($mdDialog, dialogData, ApiService, $mdToast, arrSkills, Utils, dtInstance, arrBooks, dtPromiseFn, $location, GlobalPool, $scope) {
        var vm = this;
        // Data
        vm.dialogData = dialogData;
        vm.dtInstance = dtInstance;
        vm.dtPromiseFn = dtPromiseFn;
        // Methods
        vm.closeDialog = closeDialog;
        vm.onDeleteBtnTap = onDeleteBtnTap;
        vm.onSaveCourseBtnTap = onSaveCourseBtnTap;
        vm.arrSkills = arrSkills;
        vm.courseType = Focus.ENUMS.COURSE_TYPE;
        vm.courseLanguage = Focus.ENUMS.COURSE_LANGUAGE;
        vm.courseRecurrance = Focus.ENUMS.COURSE_RECURRANCE;
        vm.courseTime = Focus.ENUMS.COURSE_TIME;
        vm.courseLevel = Focus.ENUMS.COURSE_LEVEL;
        vm.courseValidity = Focus.ENUMS.COURSE_VALIDITY;
        vm.setAuthUrlLink = api.baseURI;
        vm.arrBooks = arrBooks;
        var userInfo = GlobalPool.getUserInfo();
        vm.schoolId = userInfo.school_id;
        vm.showdeletebutton = false;
        vm.imgSize = false;

        vm.show = false;
        init();
        ;

        vm.addNewChoice = function () {
            var newItemNo = vm.dialogData.course_modules.length + 1;
            vm.dialogData.course_modules.push({'id': newItemNo});
        };


        vm.getInvoiceTemplate = function () {
            dialogData = {};
            ApiService.GetInvoiceTemplates({
                data: dialogData,
                success: function (response) {
                    if (response.status === 0) {
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 0});
                    } else {
                        Utils.showLoader(false);
                        vm.invoiceTemplate = response.data;
                    }
                }
            });
        }

        vm.getInvoiceTemplate();

        vm.removeChoice = function (index) {
            var lastItem = vm.dialogData.course_modules.length - 1;
            vm.dialogData.course_modules.splice(index, 1);
        };

        /**
         * Initialize
         */
        function init() {
            vm.dialogData.name = (vm.dialogData.Type === 'add' ? 'Add New Course' : 'Edit Course');
        }
        if (vm.dialogData.Type === 'add') {
            vm.dialogData.admin_fee = 50;
            vm.showdeletebutton = false;
            vm.dialogData.is_flexible = false;
            vm.dialogData.course_logo = "";
            vm.dialogData.course_modules = [];
            vm.dialogData.audio_url = '';
            vm.dialogData.is_display = false;

        } else {

            vm.showdeletebutton = true;
            var distinguishType, url;
            if (vm.dialogData.type == 'P') {
                distinguishType = 'private';
            } else if (vm.dialogData.type == 'G') {
                distinguishType = 'group';
            } else if (vm.dialogData.type == 'O') {
                distinguishType = 'online';
            }
            url = location.origin;
            vm.showUrl = url + "/admissions/" + vm.schoolId + "/" + vm.dialogData.title + "/" + distinguishType;
            vm.dialogData.admin_fee = parseInt(vm.dialogData.admin_fee);

            if (vm.dialogData.is_flexible == 1) {
                vm.dialogData.is_flexible = true;
            }
            if (vm.dialogData.batch != undefined) {
                vm.dialogData.batch = parseInt(vm.dialogData.batch);
            }
            if (vm.dialogData.no_of_classes != undefined) {
                vm.dialogData.no_of_classes = parseInt(vm.dialogData.no_of_classes);
            }
            if (vm.dialogData.class_duration != undefined) {
                vm.dialogData.class_duration = parseFloat(vm.dialogData.class_duration);
            }

            if (vm.dialogData.price != undefined) {
                vm.dialogData.price = parseFloat(vm.dialogData.price);
            }
            if (vm.dialogData.is_display == '1') {
                vm.dialogData.is_display = true;
            } else {
                vm.dialogData.is_display = false;
            }
            for (var i = 0; i < vm.arrSkills.length; i++) {
                if (vm.dialogData.skills == vm.arrSkills[i].id) {
                    vm.dialogData.skills = vm.arrSkills[i].name;
                }
            }
        }

        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(dtPromiseFn());

        };

        /**
         * Close the dialog
         */
        function closeDialog() {
            $mdDialog.cancel();
        }

        vm.ch1 = function () {

            if (vm.dialogData.admin_fee == null) {
                vm.admin_fee1 = true;
            } else {
                vm.admin_fee1 = false;
            }
        }

        function onDeleteBtnTap(e) {
            // var checkData = {
            //     "courseID": vm.dialogData.courseID
            // }
            // ApiService.checkCourseDelete({
            //     data: checkData,
            //     success: function (response) {
            //         if (response.status == 1) {
            //             Utils.showToast({text: response.data.message, 'type': 1});
            //         } else {
                        var deleteData = {
                            "courses": [vm.dialogData.courseID]
                        }
                        var confirm = $mdDialog.confirm()
                            .title('Confirm Delete Course ?')
                            .textContent('Are you sure you want to delete selected Course ?')
                            .ariaLabel('Delete')
                            .targetEvent(e)
                            .ok('Delete')
                            .cancel('Cancel');
                        $mdDialog.show(confirm).then(function () {
                            Utils.showLoader(true);
                            ApiService.DeleteCourse({
                                data: deleteData,
                                success: function (response) {
                                    Utils.showLoader(false);
                                    if (response.status === 0) {
                                        Utils.showToast({text: response.data.message, 'type': 0});
                                    } else {
                                        Utils.showToast({text: response.data.message, 'type': 1});
                                        vm._reloadDtPage();
                                    }
                                }
                            });
                        }, function () {});
                    // }
            //     }
            // });
        }
        
        function onSaveCourseBtnTap(e) {
            Utils.showLoader(true);
            if (vm.dialogData.recurrence_rule == "Daily") {
                vm.dialogData.weekdays = [];
            }
            vm.dialogData.books = vm.dialogData.books === undefined ? null : vm.dialogData.books;
            vm.dialogData.series = vm.dialogData.series === undefined ? null : vm.dialogData.series;

            var dialogData = angular.copy(vm.dialogData);
            if (dialogData.books != undefined) {
                var bookId = [];
                var book = dialogData.books;
                for (var i = 0; i < vm.arrBooks.length; i++) {
                    if (vm.arrBooks[i].title == book) {
                        bookId.push(vm.arrBooks[i].id)
                    }
                }
                dialogData.books = bookId;
            }
            if (dialogData.skills != undefined) {
                var skillId = [];
                var skill = dialogData.skills;
                for (var i = 0; i < vm.arrSkills.length; i++) {
                    if (vm.arrSkills[i].name == skill) {
                        skillId.push(vm.arrSkills[i].id)
                    }
                }
                dialogData.skills = skillId;
            }
            if (vm.dialogData.is_display == true) {
                dialogData.is_display = '1';
            } else {
                dialogData.is_display = '0';
            }
            ApiService.AddUpdateCourse({
                data: dialogData,
                dtInstance: vm.dtInstance,
                success: function (response) {
                    if (response.status === 0) {
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 0});
                    } else {
                        $mdDialog.hide(vm.dialogData);
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 1});
                        vm._reloadDtPage();
                    }
                }
            });
        }
        vm.onDuplicateClick = function (data) {
            dialogData.name = 'Add New Course';
            dialogData.Type = 'add';
            dialogData.courseID = null;
            dialogData;
        }

        vm.encodeImageFileAsURL = function (id) {
            var fileId = '#' + id;

            var fileInput = $(fileId);
            var maxSize = fileInput.data('max-size');

            if (fileInput.get(0).files.length) {
                var fileSize = fileInput.get(0).files[0].size;
                var a = fileInput.get(0).files[0].size / 1000;
                if (id == 'inputFileToLoad') {
                    if (fileSize > maxSize) {
                        vm.imgSize = true;
                    } else {
                        vm.imgSize = false;
                    }
                }
            }

            var filesSelected = document.getElementById(id).files;
            if (filesSelected.length > 0) {
                var fileToLoad = filesSelected[0];
                var fileReader = new FileReader();
                fileReader.onload = function (fileLoadedEvent) {
                    var srcData = fileLoadedEvent.target.result; // <--- data: base64
                    if (id == 'inputFileToLoad') {
                        vm.dialogData.course_logo = srcData;
                    } else {
                        vm.dialogData.banner_image = srcData;
                    }
                }
                fileReader.readAsDataURL(fileToLoad);
            }
        }

        

    }

})();

angular.module('app.courses').directive('isNumber', function () {
	return {
		require: 'ngModel',
		link: function (scope) {	
			scope.$watch('wks.number', function(newValue,oldValue) {
                var arr = String(newValue).split("");
                if (arr.length === 0) return;
                if (arr.length === 1 && (arr[0] == '-' || arr[0] === '.' )) return;
                if (arr.length === 2 && newValue === '-.') return;
                if (isNaN(newValue)) {
                    scope.wks.number = oldValue;
                }
            });
		}
	};
});

(function ()
{
    'use strict';

    angular
            .module('app.books', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State

    }
})();
(function()
{
    'use strict';

    angular.module('app.books')
            .controller('AddBooksDialogController', AddBooksDialogController);

    /** @ngInject */
    function AddBooksDialogController($mdDialog, dialogData, ApiService, $mdToast, arrSkills, Utils, dtInstance, dtPromiseFn)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.dtInstance = dtInstance;
        vm.dtPromiseFn = dtPromiseFn;

        // Methods
        vm.closeDialog = closeDialog;
        vm.onDeleteBtnTap = onDeleteBtnTap;
        vm.onSaveBookBtnTap = onSaveBookBtnTap;
        vm.arrSkills = arrSkills;

        init();

        //////////

        /**
         * Initialize
         */
        function init()
        {
            vm.dialogData.name = (vm.dialogData.type === 'add' ? 'Add New Book' : 'Edit Book');
        }

        vm._reloadDtPage = function() {
            vm.dtInstance.changeData(dtPromiseFn());

        };
        if (vm.dialogData.type === 'edit') {
            if (vm.dialogData.skill != undefined) {

                for (var i = 0; i < vm.arrSkills.length; i++) {
                    if (vm.arrSkills[i].name == vm.dialogData.skill) {
                        vm.dialogData.skill_id = vm.arrSkills[i].id;
                    }
                }

            }
        }
        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }

        function onDeleteBtnTap(e) {
            var deleteData = {
                "books": [vm.dialogData.id]
            }

            var confirm = $mdDialog.confirm()
                    .title('Confirm Delete Book?')
                    .textContent('Are you sure you want to delete Selected Book ?')
                    .ariaLabel('Delete')
                    .targetEvent(e)
                    .ok('Delete')
                    .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                Utils.showLoader(true);
                ApiService.DeleteBooks({
                    data: deleteData,
                    success: function(response) {
                        Utils.showLoader(false);
                        if (response.status === 0) {
                            Utils.showToast({text: response.data.message,'type':0});
                        } else {
                            Utils.showToast({text: response.data.message,'type':1});
                            vm._reloadDtPage();
                        }
                    }
                });
            }, function() {
            });
        }


        function onSaveBookBtnTap(e) {
            Utils.showLoader(true);

//here we will have the new data to be saved.
            vm.dialogData;
            ApiService.AddUpdateBook({
                data: vm.dialogData,
                dtInstance: vm.dtInstance,
                success: function(response) {
                    if (response.status === 0) {
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message,'type':0});
                    }
                    else {
                        $mdDialog.hide(vm.dialogData);
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message,'type':1});
                        vm._reloadDtPage();
                    }
                }
            });
        }
        vm.onDuplicateClick = function(data) {
            dialogData.name = 'Add New Book';
            dialogData.type = 'add';
            dialogData.id = null;
            dialogData;

        }

    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.attendance', ["threeStateCheckbox"])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
//        $stateProvider
//                    .state('app.courses', {
//                        url: '/courses',
//                        views: {
//                            'content@app': {
//                                templateUrl: 'app/main/courses/courses.html',
//                                controller: 'CoursesController as vm'
//                            }
//                        },
//                         
////                        ncyBreadcrumb: {
////                            label: 'Courses',
////                        },
////                        data: {
////                            bAllow: getAllowedState(mergedArr, "4")
////                        }
//                    });


        // Translation
//        $translatePartialLoaderProvider.addPart('app/main/courses');
    }
})();
(function ()
{
    'use strict';

    angular.module('app.attendance')
            .controller('ShowReportController', ShowReportController);
    /** @ngInject */
    function ShowReportController($mdDialog, dialogData, ApiService, studentsData, dateList, dtPromiseFn, api, $http, GlobalPool, Utils, $document)
    {
        var vm = this;
        vm.dialogData = dialogData;
        console.log(vm.dialogData);
        vm.dialogData.nullType;
        vm.closeDialog = closeDialog;
        vm.studentsData = studentsData;
        vm.dateList = dateList;
        vm.dtPromiseFn = dtPromiseFn;
        vm.PrintPreview = PrintPreview;
        vm.UpdatecheduleNote = UpdatecheduleNote;
        var userInfo = GlobalPool.getUserInfo();
        vm.role_id = userInfo.role_id;
        vm.setAuthToken = userInfo.auth_token;
        vm.setAuthDownloadLink = api.baseURI;
        vm.printDisable = false;
        vm.showImage = false;
        vm.updateAttendance = true;
        vm.dialogData.title = "Attendance Report";
        vm.showSignature = false;
        vm.setAuthUrlLink = api.baseURI;
        vm.signaturePath = '';
        vm.onChange = function () {
            vm.printDisable = true;
            vm.updateAttendance = false;
            vm.dialogData.showErrorMsg = false;
        }

        /**
         * Initialize
         */

        function init()
        {
            vm.dialogData.title = "Attendance Report";

            sortStudentattendanceData()
        }
        init();
        function sortStudentattendanceData() {
            for (var i = 0; i < vm.studentsData.length; i++) {
                vm.studentsData[i].attendanceList.sort(function (a, b) {
                    var aa = a.date.split('/').reverse().join(),
                            bb = b.date.split('/').reverse().join();
                    return aa < bb ? -1 : (aa > bb ? 1 : 0);
                });
            }
        }

        vm.saveAttendance = function (e) {
            Utils.showLoader(true);
            var attendanceObj = [];
            var dataObj = vm.studentsData;
            for (var k = 0; k < dataObj.length; k++) {
                var data = dataObj[k].attendanceList;
                for (var l = 0; l < data.length; l++) {
                    if (data[l].bAllow == false || data[l].bAllow == null) {
                        data[l].attendance = 0;
                    } else if (data[l].bAllow == true) {
                        data[l].attendance = 1;
                    }
                }
            }
            vm.dialogData;
            var requestData = {
                "schedule_class_id": vm.dialogData.schedule_class_id,
                "intake": vm.dialogData.intakeID,
                "students": dataObj,
                "type": vm.dialogData.type
            }
            ApiService.UpdateAttendance({
                data: requestData,
                success: function (response) {
                    if (response.status == 0) {
                        Utils.showLoader(false);

                        Utils.showToast({text: response.data.message, 'type': 0});
                    } else {
                        Utils.showToast({text: response.data.message, 'type': 1});
                        Utils.showLoader(false);
                        regenrateDialogForm();
                    }
                }
            });
        }

        function regenrateDialogForm() {
            var requestData = {
                intake_id: vm.dialogData.intakeID,
                schedule_class_id : vm.dialogData.schedule_class_id,
                type: vm.dialogData.nullType
            };
            Utils.showLoader(true);


            ApiService.GetAttendanceReport({data: requestData}).then(function (response) {

                vm.studentsData = response.data[0].attendances;

                vm.dateList = response.data[0].scheduleDates;
                dialogData.nullType = response.data[0].type;
                dialogData.end_date = response.data[0].end_date;
                dialogData.start_date = response.data[0].start_date;
                dialogData.btnEnable = response.data[0].enableCertificate;
                dialogData.intakeID = response.data[0].intakeID;
                dialogData.schedule_class_id = response.data[0].schedule_class_id;
                var arrSchedules = response.data[0].scheduleDates;
                var arrAttendances = response.data[0].attendances;
                dialogData.printData = response.data.printData;
                vm.printDisable = false;
                var curAttList = null, curScheduleObj = null, curAttListobj = null, bAllow, countEligible = 0;
                for (var i = 0; i < arrAttendances.length; i++)
                {
                    var newAtt = [];
                    angular.forEach(arrAttendances[i].attendanceList, function (value, x) {
                        newAtt.push(value);
                    });
                    arrAttendances[i].attendanceList = newAtt;
                    if (response.data[0].enableCertificate == 1) {
                        if (arrAttendances[i].isEligible == 1) {
                            countEligible = countEligible + 1;
                        }
                    }
                    for (var x = 0; x < newAtt.length; x++) {
                        curAttListobj = newAtt[x];
                        if (curAttListobj.attendance == 0 || curAttListobj.attendance == null) {
                            curAttListobj.bAllow = false;
                        } else if (curAttListobj.attendance == 1) {
                            curAttListobj.bAllow = true;
                        } else if (curAttListobj.attendance == 1 && curAttListobj.signature_image != null) {
//                            curAttListobj.signaturePath = 'http://yi-mandarin.local/' + 'uploads/Attendance/M-PB-1-02042019-01/Winnie_1554189489.png';
//                            vm.signaturePath = 'http://yi-mandarin.local/' + 'uploads/Attendance/M-PB-1-02042019-01/Winnie_1554189489.png';
                            vm.showSignature = true;
                        }
                    }
                    var arrNewSchedule = [];
                    angular.forEach(arrSchedules, function (value, x) {
                        arrNewSchedule.push(value);
                    });

                    for (var j = 0; j < arrNewSchedule.length; j++) {
                        curScheduleObj = arrNewSchedule[j];
                        if (!isDateInSchedules(newAtt, curScheduleObj)) {
                            newAtt.push({
                                date: curScheduleObj.date,
                                attendance: '',
                                bAllow: -1
                            });
                        }
                    }
                }
                if (countEligible >= 1) {
                    dialogData.btnEnable = 1;
                } else {
                    dialogData.btnEnable = 0;
                }
                function isDateInSchedules(arrAttendances, strDateToCheck) {
                    if (!arrAttendances) {
                        return false;
                    }

                    for (var i = 0; i < arrAttendances.length; i++) {
                        if (arrAttendances[i].date == strDateToCheck.date) {
                            if (arrAttendances[i].date) {
                                var dateString = arrAttendances[i].date;
                                var dateParts = dateString.split("/");
                                var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
                                var todayDate = new Date();
                                if (dateObject >= todayDate) {
                                    arrAttendances[i].bAllow = -1;
                                }
                            }
                            return true;
                        }
                    }
                    return false;
                }
                arrAttendances;
                Utils.showLoader(false);

                vm.studentsData = arrAttendances;
                vm.dateList = arrSchedules;

            });

        }

        function PrintPreview() {
            vm.showImage = true;
            var jTemp = $("<div class='print-block'></div>");
            jTemp.html($("#printarea").html());

            var toPrint = jTemp[0];//document.getElementById('printarea');
            jTemp.find("table").css("border-collapse", "collapse")
            jTemp.find("table td").css("border", "1px solid grey")
            jTemp.find("table th").css("border", "1px solid grey")
            var popupWin = window.open('', '_blank', 'width=350,height=150,location=no,left=200px');

            popupWin.document.open();
            popupWin.document.write('<html><title>::Print Preview::</title></head><body">')
            popupWin.document.write(toPrint.innerHTML);
            popupWin.document.write('</html>');
            popupWin.document.close();
        }

        function UpdatecheduleNote() {
            Utils.showLoader(true);
            // here we will have the new data to be saved.
            vm.dialogData;
            var data = {
                'note' : vm.dialogData.note,
                'schedule_class_id' :vm.dialogData.schedule_class_id
            }
            ApiService.AddScheduleNote({
                data: data,
                success: function(response) {
                    if (response.status === 0) {
                        Utils.showLoader(false);
                        Utils.showToast({ text: response.data.message, 'type': 0 });
                    } else {
                        Utils.showLoader(false);
                        Utils.showToast({ text: response.data.message, 'type': 1 });
                    }
                }
            });
        }

        function reloadData() {
            vm.dtInstance.reloadData();
        }
        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(dtPromiseFn());

        };
        vm.range = function (min, max, step) {
            step = step || 1;
            var input = [];
            for (var i = min; i <= max; i += step)
                input.push(i);
            return input;
        };
        vm.gettingData = function (a) {
            var a = a;
            console.log(a);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }

        vm.undo = function () {
            vm.version = 0;
        };

        vm.openCanvas = function (attendance_id) {
            dialogData.attendance_id = attendance_id;
            $mdDialog.show({
                controller: 'ShowCanvasController',
                controllerAs: 'vm',
                templateUrl: 'app/main/attendance/show-report/show-canvas-dialog.html',
                parent: angular.element($document.body),
                targetEvent: "e",
                //                    clickOutsideToClose: true,
                locals: {
                    dialogData: dialogData,
                    dtPromiseFn: vm.dtPromiseFn

                }
            }).then(function (response) {

            });
        }
    }
})();
(function ()
{
    'use strict';

    angular.module('app.attendance')
            .controller('ShowCanvasController', ShowCanvasController);
    /** @ngInject */
    function ShowCanvasController($mdDialog, dialogData, ApiService, dtPromiseFn, api, $http, GlobalPool, Utils, $document)
    {
        var vm = this;
        vm.dialogData = dialogData;
        vm.closeDialog = closeDialog;
        vm.dtPromiseFn = dtPromiseFn;
        var userInfo = GlobalPool.getUserInfo();
        vm.role_id = userInfo.role_id;
        vm.setAuthToken = userInfo.auth_token;
        vm.setAuthDownloadLink = api.baseURI;
        vm.showImage = false;

        /**
         * Initialize
         */

        function init()
        {
            vm.dialogData.title = "Signature Pad";

//            sortStudentattendanceData()
        }
        init();
        function reloadData() {
            vm.dtInstance.reloadData();
        }
        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(dtPromiseFn());

        };
        vm.range = function (min, max, step) {
            step = step || 1;
            var input = [];
            for (var i = min; i <= max; i += step)
                input.push(i);
            return input;
        };
        vm.gettingData = function (a) {
            var a = a;
            console.log(a);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }

        vm.undo = function () {
            vm.version = 0;
        };

        vm.saveSignature = function () {
            var canvas = document.getElementById('pwCanvasMain');
            var signature = canvas.toDataURL();
            var requestData = {
                "attendance_id": vm.dialogData.attendance_id,
                "intake": vm.dialogData.intakeID,
                "signature": signature,
                "student_name": "sign"
            }
            ApiService.AddSignature({
                data: requestData,
                success: function (response) {
                    if (response.status == 0) {
                        Utils.showLoader(false);

                        Utils.showToast({text: response.data.message, 'type': 0});
                    } else {
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 1});
                        $mdDialog.hide(vm.dialogData);
//                        regenrateDialogForm();
                    }
                }
            });
        }
    }
})();
angular.module('app.attendance')
        .directive('pwCanvas', function () {
            return {
                restrict: 'AE',
                scope: {
                    options: '=',
                    version: '='
                },
                templateUrl: 'app/main/attendance/template/canvas.html',
                link: function postLink(scope, elm) {

                    var isTouch = !!('ontouchstart' in window);

                    var PAINT_START = isTouch ? 'touchstart' : 'mousedown';
                    var PAINT_MOVE = isTouch ? 'touchmove' : 'mousemove';
                    var PAINT_END = isTouch ? 'touchend' : 'mouseup';

//set default options
                    var options = scope.options;
                    options.canvasId = options.customCanvasId || 'pwCanvasMain';
                    options.tmpCanvasId = options.customCanvasId ? (options.canvasId + 'Tmp') : 'pwCanvasTmp';
                    options.width = options.width || 400;
                    options.height = options.height || 300;
                    options.backgroundColor = options.backgroundColor || '#fff';
                    options.color = options.color || '#000';
                    options.undoEnabled = options.undoEnabled || false;
                    options.opacity = options.opacity || 0.9;
                    options.lineWidth = options.lineWidth || 1;
                    options.undo = options.undo || false;
                    options.imageSrc = options.imageSrc || false;

// background image
                    if (options.imageSrc) {
                        var image = new Image();
                        image.onload = function () {
                            ctx.drawImage(this, 0, 0);
                        };
                        image.src = options.imageSrc;
                    }

//undo
                    if (options.undo) {
                        var undoCache = [];
                        scope.$watch(function () {
                            return undoCache.length;
                        }, function (newVal) {
                            scope.version = newVal;
                        });

                        scope.$watch('version', function (newVal) {
                            if (newVal < 0) {
                                scope.version = 0;
                                return;
                            }
                            if (newVal >= undoCache.length) {
                                scope.version = undoCache.length;
                                return;
                            }
                            undo(newVal);
                        });
                    }

//create canvas and context
                    var canvas = document.createElement('canvas');
                    canvas.id = options.canvasId;
                    var canvasTmp = document.createElement('canvas');
                    canvasTmp.id = options.tmpCanvasId;
                    angular.element(canvasTmp).css({
                        position: 'absolute',
                        top: 0,
                        left: 0
                    });
                    elm.find('div').append(canvas);
                    elm.find('div').append(canvasTmp);
                    var ctx = canvas.getContext('2d');
                    var ctxTmp = canvasTmp.getContext('2d');

//inti variables
                    var point = {
                        x: 0,
                        y: 0
                    };
                    var ppts = [];

//set canvas size
                    canvas.width = canvasTmp.width = options.width;
                    canvas.height = canvasTmp.height = options.height;

//set context style
                    ctx.fillStyle = options.backgroundColor;
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                    ctxTmp.globalAlpha = options.opacity;
                    ctxTmp.lineJoin = ctxTmp.lineCap = 'round';
                    ctxTmp.lineWidth = 10;
                    ctxTmp.strokeStyle = options.color;


//Watch options
                    scope.$watch('options.lineWidth', function (newValue) {
                        if (typeof newValue === 'string') {
                            newValue = parseInt(newValue, 10);
                        }
                        if (newValue && typeof newValue === 'number') {
                            ctxTmp.lineWidth = options.lineWidth = newValue;
                        }
                    });

                    scope.$watch('options.color', function (newValue) {
                        if (newValue) {
//ctx.fillStyle = newValue;
                            ctxTmp.strokeStyle = ctxTmp.fillStyle = newValue;
                        }
                    });

                    scope.$watch('options.opacity', function (newValue) {
                        if (newValue) {
                            ctxTmp.globalAlpha = newValue;
                        }
                    });

                    var getOffset = function (elem) {
                        var bbox = elem.getBoundingClientRect();
                        return {
                            left: bbox.left,
                            top: bbox.top
                        };
                    };

                    var setPointFromEvent = function (point, e) {
                        if (isTouch) {
                            point.x = e.changedTouches[0].pageX - getOffset(e.target).left;
                            point.y = e.changedTouches[0].pageY - getOffset(e.target).top;
                        } else {
                            point.x = e.offsetX !== undefined ? e.offsetX : e.layerX;
                            point.y = e.offsetY !== undefined ? e.offsetY : e.layerY;
                        }
                    };


                    var paint = function (e) {
                        if (e) {
                            e.preventDefault();
                            setPointFromEvent(point, e);
                        }

// Saving all the points in an array
                        ppts.push({
                            x: point.x,
                            y: point.y
                        });

                        if (ppts.length === 3) {
                            var b = ppts[0];
                            ctxTmp.beginPath();
                            ctxTmp.arc(b.x, b.y, ctxTmp.lineWidth / 2, 0, Math.PI * 2, !0);
                            ctxTmp.fill();
                            ctxTmp.closePath();
                            return;
                        }

// Tmp canvas is always cleared up before drawing.
                        ctxTmp.clearRect(0, 0, canvasTmp.width, canvasTmp.height);

                        ctxTmp.beginPath();
                        ctxTmp.moveTo(ppts[0].x, ppts[0].y);

                        for (var i = 1; i < ppts.length - 2; i++) {
                            var c = (ppts[i].x + ppts[i + 1].x) / 2;
                            var d = (ppts[i].y + ppts[i + 1].y) / 2;
                            ctxTmp.quadraticCurveTo(ppts[i].x, ppts[i].y, c, d);
                        }

// For the last 2 points
                        ctxTmp.quadraticCurveTo(
                                ppts[i].x,
                                ppts[i].y,
                                ppts[i + 1].x,
                                ppts[i + 1].y
                                );
                        ctxTmp.stroke();
                    };

                    var copyTmpImage = function () {
                        if (options.undo) {
                            scope.$apply(function () {
                                undoCache.push(ctx.getImageData(0, 0, canvasTmp.width, canvasTmp.height));
                                if (angular.isNumber(options.undo) && options.undo > 0) {
                                    undoCache = undoCache.slice(-1 * options.undo);
                                }
                            });
                        }
                        canvasTmp.removeEventListener(PAINT_MOVE, paint, false);
                        ctx.drawImage(canvasTmp, 0, 0);
                        ctxTmp.clearRect(0, 0, canvasTmp.width, canvasTmp.height);
                        ppts = [];
                    };

                    var startTmpImage = function (e) {
                        e.preventDefault();
                        canvasTmp.addEventListener(PAINT_MOVE, paint, false);

                        setPointFromEvent(point, e);
                        ppts.push({
                            x: point.x,
                            y: point.y
                        });
                        ppts.push({
                            x: point.x,
                            y: point.y
                        });

                        paint();
                    };

                    var initListeners = function () {
                        canvasTmp.addEventListener(PAINT_START, startTmpImage, false);
                        canvasTmp.addEventListener(PAINT_END, copyTmpImage, false);

                        if (!isTouch) {
                            var MOUSE_DOWN;

                            document.body.addEventListener('mousedown', mousedown);
                            document.body.addEventListener('mouseup', mouseup);

                            scope.$on('$destroy', removeEventListeners);

                            canvasTmp.addEventListener('mouseenter', mouseenter);
                            canvasTmp.addEventListener('mouseleave', mouseleave);
                        }

                        function mousedown() {
                            MOUSE_DOWN = true;
                        }

                        function mouseup() {
                            MOUSE_DOWN = false;
                        }

                        function removeEventListeners() {
                            document.body.removeEventListener('mousedown', mousedown);
                            document.body.removeEventListener('mouseup', mouseup);
                        }

                        function mouseenter(e) {
// If the mouse is down when it enters the canvas, start a path
                            if (MOUSE_DOWN) {
                                startTmpImage(e);
                            }
                        }

                        function mouseleave(e) {
// If the mouse is down when it leaves the canvas, end the path
                            if (MOUSE_DOWN) {
                                copyTmpImage(e);
                            }
                        }
                    };

                    var undo = function (version) {
                        if (undoCache.length > 0) {
                            ctx.putImageData(undoCache[version], 0, 0);
                            undoCache = undoCache.slice(0, version);
                        }
                    };

                    initListeners();
                }
            };
        });

angular.module('app.attendance')
        .directive('pwColorSelector', function () {
            return {
                restrict: 'AE',
                scope: {
                    colorList: '=pwColorSelector',
                    selectedColor: '=color'
                },
                templateUrl: 'templates/color-selector.html',
                link: function (scope) {
                    scope.setColor = function (col) {
                        scope.selectedColor = col;
                    };
                }
            };
        });


(function()
{
    'use strict';

    angular.module('app.attendance')
            .controller('ShowDataController', ShowDataController);

    /** @ngInject */
    function ShowDataController(api, $mdDialog, dialogData, $document, ApiService, $http, $mdToast, Utils, ConstructTree, $q, $scope, GlobalPool, DTOptionsBuilder, DTColumnBuilder, $compile, usSpinnerService)
    {
        var vm = this;
        // Data
        vm.dialogData = dialogData;
        vm.closeDialog = closeDialog;
        var titleHtml = "";
        vm.arrAdjustedId = {};
        var userInfo = GlobalPool.getUserInfo();
//        ;
//        ;
        var getCheckHtml = function(ngModel) {
            return '<md-checkbox aria-label="Check" ng-model="vm.arrAdjustedId[\'' + ngModel + '\'].selected" ng-change="vm.toggleOne(\'' + ngModel + '\', $event)"></md-checkbox>';
        };
        init();

        var getHeaderCheckHtml = function() {

            return '<md-checkbox class="no-label" aria-label="{{vm.allChecked?' + '\'Uncheck All\'' + ':' + '\'Check All\'' + '}}" ng-model="vm.allChecked" ng-change="vm.toggleAll()"></md-checkbox> Adjust';
        }

        //////////

        /**
         * Initialize
         */
        function init()
        {
            vm.dialogData.title = vm.dialogData.course;
            if (vm.dialogData.type = "show") {
                var students = vm.dialogData.students;
                var studentName = [];
                for (var i = 0; i < students.length; i++) {
                    studentName.push(students[i].text)
                }
                vm.dialogData.students = studentName;
            }

//            function getData() {
//                var defer = $q.defer();
//                ApiService.GetStockTakeAdjustmentDetail({
//                    data: vm.dialogData,
//                }).then(function(response) {
//                    defer.resolve(response);
//                });
//                return defer.promise;
//            }
//            ;

//            vm.dtOptions = DTOptionsBuilder.fromFnPromise(getData)
//                    .withOption('createdRow', function(row, data, dataIndex) {
//                        // Recompiling so we can bind Angular directive to the DT
//                        $compile(angular.element(row).contents())($scope);
//                    }).withOption('order', [[1, 'asc']]).withOption('paging', false)
//                    .withOption('headerCallback', function(thead, data, start, end, display ) {
//                        
//                        if (!vm.headerCompiled) {
//                            // Use this headerCompiled field to only compile header once
//                            $(thead).find('th').eq(3).html(getHeaderCheckHtml());
//                            vm.headerCompiled = true;
//                            $compile(angular.element(thead).contents())($scope);
//
//                        }
//                    }).withOption('rowCallback', rowCallback)
//                    .withOption("responsive", true);

//            vm.dtColumns = [
//                DTColumnBuilder.newColumn('AssetCode').withTitle('AssetCode'),
//                DTColumnBuilder.newColumn('StockLocation').withTitle('StockLocation'),
//                DTColumnBuilder.newColumn('TagID').withTitle('TagID'),
//                DTColumnBuilder.newColumn(null).withTitle('Adjust').notSortable()
//                        .renderWith(function(data, type, full, meta) {
//                            
//                            vm.arrAdjustedId[data['TagID']] = data;
//                            return getCheckHtml(data.TagID);
//                        }),
//            ];
//            vm.someClickHandler = function(info) {
//
//            };

//            function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
//                // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
//                $('td', nRow).unbind('click');
//                $('td', nRow).bind('click', function() {
//                    $scope.$apply(function() {
//                        vm.someClickHandler(aData);
//                       
//                        vm.isDisabled = false;
//                    });
//                });
//                return nRow;
//            }
        }


        vm.ReportClick = function(e) {
            vm.dialogData.type = "report"
            if (vm.dialogData.type = "report") {
                dialogData.title = "Attendance Report"
            }

            $http({
                url: api.localUrl + 'dashboard/attendanceReport.json',
                dataType: "json",
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            }).success(function(response) {
                vm.showTable = response
            });
//            var dialogData = {
//                "type": "report",
//                "Status": true
//            };
//            $mdDialog.show({
//                controller: 'ShowReportController',
//                controllerAs: 'vm',
//                templateUrl: 'app/main/attendance/show-report/show-report-dialog.html',
//                parent: angular.element($document.body),
//                targetEvent: e,
//                clickOutsideToClose: true,
//                locals: {
//                    dialogData: dialogData,
//                    dtInstance: vm.dtInstance
//                }
//            }).then(function(response)
//            {
//
//            });
        };





        function reloadData() {
            vm.dtInstance.reloadData();
        }
        vm._reloadDtPage = function() {
            vm.dtInstance.reloadData();
        };


        function closeDialog()
        {
            $mdDialog.cancel();
        }



    }
})();

(function()
{
    'use strict';

    angular
            .module('app.attendance_add', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State

    }
})();
(function()
{
    'use strict';

    angular.module('app.attendance_add')
            .controller('AddAttendanceController', AddAttendanceController);

    /** @ngInject */
    function AddAttendanceController(api, usSpinnerService, dialogData, data, attendanceObj, ApiService, $http, dtPromiseFn, $mdToast, $mdDialog, $document, $compile, $scope, $q, $resource, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, Utils)
    {

        var vm = this;
        vm.dialogData = dialogData;
        vm.closeDialog = closeDialog;
        vm.attendanceObj = attendanceObj;
        vm.data = data;
        vm.dtPromiseFn = dtPromiseFn;
        // Paginators

        vm.ToggleCheckbox = function(e, value) {
            var arrAttendance = vm.attendanceObj;

        }

        vm._reloadDtPage = function() {
            vm.dtInstance.changeData(dtPromiseFn());

        };
        function closeDialog()
        {
            $mdDialog.cancel();
        }


        vm.onSaveAttendanceTap = function(e) {
            var studentsObj = [];
            for (var i = 0; i < vm.attendanceObj.length; i++) {
                if (vm.attendanceObj[i].bAllow == false) {
                    var attendance = 0;
                }
                else {
                    var attendance = 1;
                }
                studentsObj.push({id: vm.attendanceObj[i].id, attendance: attendance})
            }
            var requestData = {
                "schedule_class_id": vm.data.schedule_class_id,
                "schedule_date": vm.data.schedule_date,
                "students": studentsObj
            }
            ApiService.AddAttendance({
                data: requestData,
                dtInstance: vm.dtInstance,
                success: function(response) {

                }
            });
        }








    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.admins', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State

    }
})();
(function ()
{
    'use strict';

    angular.module('app.admins')
            .controller('AddAdminsDialogController', AddAdminsDialogController);

    /** @ngInject */
    function AddAdminsDialogController($mdDialog, dialogData, ApiService, $mdToast, Utils, dtInstance, dtPromiseFn)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.dtInstance = dtInstance;
        vm.dtPromiseFn = dtPromiseFn;

        // Methods
        vm.closeDialog = closeDialog;
        vm.onSaveAdminBtnTap = onSaveAdminBtnTap;

        init();

        //////////

        /**
         * Initialize
         */
        function init()
        {
            vm.dialogData.name = (vm.dialogData.type === 'add' ? 'Add New Admin' : 'Edit Admin');
        }

        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(dtPromiseFn());

        };
        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }


        vm._onTabEmail = function () {
            if (vm.dialogData.email != undefined) {
                var requestData = {
                    "email": vm.dialogData.email
                }
                ApiService.checkEmailUnique({
                    data: requestData,
                    dtInstance: vm.dtInstance,
                    success: function (response) {
                        if (response.status == 0) {
                            Utils.showLoader(false);
                            vm.showEmailError = response.data.message;
                            vm.result = 'false';
                        } else {
                            vm.showEmailError = false;
                            Utils.showLoader(false);
                            vm.result = 'true';
                        }
                    }
                });
            }


        }

        function onSaveAdminBtnTap(e) {
            Utils.showLoader(true);

//here we will have the new data to be saved.
//            vm.dialogData;
            vm.dialogData.role_id = 1;
            ApiService.AddUpdateAdmin({
                data: vm.dialogData,
                dtInstance: vm.dtInstance,
                success: function (response) {
                    if (response.status === 0) {
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 0});
                    } else {
                        $mdDialog.hide(vm.dialogData);
                        Utils.showLoader(false);
                        Utils.showToast({text: response.data.message, 'type': 1});
                        vm._reloadDtPage();
                    }
                }
            });
        }
        vm.onDuplicateClick = function (data) {
            dialogData.name = 'Add New Admin';
            dialogData.type = 'add';
            dialogData.id = null;
            dialogData;

        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'angular-chartist',
                'chart.js',
                'datatables',
                'gridshore.c3js.chart',
                'nvd3',
                'pascalprecht.translate',
                'timer',
                'ui.router',
                'uiGmapgoogle-maps',
                'textAngular',
                'ui.sortable',
                'ng-sortable',
                'xeditable'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                loadMore: '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element('#content');
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement.children().eq(1)).then(function ()
                    {
                        // Remove the element if still exists
                        if ( iElement )
                        {
                            iElement.remove();
                        }

                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function()
{
    'use strict';

    angular
            .module('app.core')
            .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict: 'E',
            scope: true,
            templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile: function(tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    var expanderEl,
                            collapserEl;

                    // Initialize
                    init();

                    function init()
                    {
                        expanderEl = iElement.find('#ms-search-bar-expander');
                        collapserEl = iElement.find('#ms-search-bar-collapser');

                        expanderEl.on('click', expand);
                        collapserEl.on('click', collapse);
                    }

                    /**
                     * Expand
                     */
                    function expand()
                    {
                        iElement.addClass('expanded');

                        // Esc key event
                        $document.on('keyup', escKeyEvent);
                    }

                    /**
                     * Collapse
                     */
                    function collapse()
                    {
                        iElement.removeClass('expanded');
                    }

                    /**
                     * Escape key event
                     *
                     * @param e
                     */
                    function escKeyEvent(e)
                    {
                        if (e.keyCode === 27)
                        {
                            collapse();
                            $document.off('keyup', escKeyEvent);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
            .module('app.core')
            .provider('msNavigationService', msNavigationServiceProvider)
            .controller('MsNavigationController', MsNavigationController)
            // Vertical
            .directive('msNavigation', msNavigationDirective)
            .controller('MsNavigationNodeController', MsNavigationNodeController)
            .directive('msNavigationNode', msNavigationNodeDirective)
            .directive('msNavigationItem', msNavigationItemDirective)
            //Horizontal
            .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
            .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
            .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
            .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if (!angular.isString(path))
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for (var i = 0; i < parent.length; i++)
            {
                if (parent[i]._id === id)
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if (updateItem)
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if (angular.isUndefined(item.weight) || !angular.isNumber(item.weight))
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if (!parent)
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for (var i = 0; i < parent.length; i++)
            {
                var children = parent[i].children;
                if (children.length > 1)
                {
                    children.sort(_byWeight);
                }

                if (children.length > 0)
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if (parts.length === 1)
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for (var i = 0; i < parts.length; i++)
            {
                var _id = parts[i],
                        createParent = true;

                for (var p = 0; p < parent.length; p++)
                {
                    if (parent[p]._id === _id)
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if (createParent)
                {
                    var item = {
                        _id: _id,
                        _path: parts.join('.'),
                        title: _id,
                        weight: 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if (angular.isDefined(item.state))
            {
                uisref = item.state;

                if (angular.isDefined(item.stateParams) && angular.isObject(item.stateParams))
                {
                    uisref = uisref + '(' + angular.toString(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                    navigationScope = null,
                    folded = null,
                    foldedOpen = null;

            var service = {
                saveItem: saveItem,
                sort: sortByWeight,
                setActiveItem: setActiveItem,
                getActiveItem: getActiveItem,
                getNavigationObject: getNavigationObject,
                setNavigationScope: setNavigationScope,
                setFolded: setFolded,
                getFolded: getFolded,
                setFoldedOpen: setFoldedOpen,
                getFoldedOpen: getFoldedOpen,
                toggleFolded: toggleFolded
            };

            return service;

            //////////

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node: node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation object
             *
             * @param root
             * @returns {Array}
             */
            function getNavigationObject(root)
            {
                if (root)
                {
                    for (var i = 0; i < navigation.length; i++)
                    {
                        if (navigation[i]._id === root)
                        {
                            return [navigation[i]];
                        }
                    }
                }

                return navigation;
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ($scope.root)
        {
            vm.navigation = msNavigationService.getNavigationObject($scope.root);
        } else
        {
            vm.navigation = msNavigationService.getNavigationObject();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict: 'E',
            scope: {
                folded: '=',
                root: '@'
            },
            controller: 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude: true,
            compile: function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                            foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                            foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                            sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time
                        msNavigationService.setFolded(scope.folded);

                        if (scope.folded)
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if (angular.isUndefined(current) || angular.equals(current, old))
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if (folded)
                        {
                            if (current)
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            } else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if (activeItem)
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if (angular.isUndefined(current) || angular.equals(current, old))
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if (folded)
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        } else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if (activeItem)
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if (event)
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if (activeItem)
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if (event)
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeSuccess
                     */
                    scope.$on('$stateChangeSuccess', function ()
                    {
                        // Close the sidenav
                        sidenav.close();

                        // If navigation is folded open, close it
                        if (msNavigationService.getFolded())
                        {
                            onFoldCollapserHover();
                        }
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if (!vm.hasChildren || vm.group)
            {
                vm.collapsable = false;
            } else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if (!vm.collapsable)
            {
                vm.collapsed = false;
            } else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if (vm.node.state === $state.current.name || $state.includes(vm.node.state))
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params))
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if (vm.collapsable && vm.collapsed)
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if (vm.collapsed || !vm.collapsable)
                {
                    return;
                }

                // If there is no path defined, collapse
                if (angular.isUndefined(path))
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                            activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if (activeItem)
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if (givenPathParts.indexOf(vm.node._id) > -1)
                    {
                        return;
                    }

                    // Test for active path
                    if (activePathParts.indexOf(vm.node._id) > -1)
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if (vm.node.state === $state.current.name)
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params))
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if (vm.collapsed)
            {
                vm.expand();
            } else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                        {
                            'display': 'block',
                            'height': height + 'px'
                        },
                        {
                            'height': '0px'
                        },
                        vm.animateHeightClass
                        ).then(
                        function ()
                        {
                            // Clear the inline styles after animation done
                            collapseEl.css({
                                'display': '',
                                'height': ''
                            });

                            // Clear collapsing class from the node
                            vm.element.removeClass('collapsing');
                        }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position': 'absolute',
                'visibility': 'hidden',
                'display': 'block',
                'height': 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position': '',
                'visibility': '',
                'display': '',
                'height': ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                        {
                            'display': 'block',
                            'height': '0px'
                        },
                        {
                            'height': height + 'px'
                        },
                        vm.animateHeightClass
                        ).then(
                        function ()
                        {
                            // Clear the inline styles after animation done
                            expandEl.css({
                                'height': ''
                            });

                            // Clear expanding class from the node
                            vm.element.removeClass('expanding');
                        }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict: 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller: 'MsNavigationNodeController as vm',
            compile: function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if (MsNavigationNodeCtrl.group)
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require: '^msNavigationNode',
            compile: function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if (MsNavigationNodeCtrl.collapsable)
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict: 'E',
            scope: true,
            controller: 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude: true,
            compile: function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if (vm.node.state === $state.current.name || $state.includes(vm.node.state))
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params))
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if (vm.hasChildren)
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if (!vm.hasChildren)
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if (activeItem)
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if (activePathParts.indexOf(vm.node._id) > -1)
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                } else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if (vm.node.state === $state.current.name)
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params))
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states everything except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict: 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller: 'MsNavigationHorizontalNodeController as vm',
            compile: function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if (MsNavigationHorizontalNodeCtrl.group)
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require: '^msNavigationHorizontalNode',
            compile: function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if (!MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md'))
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    })
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            vm.selectedIndex++;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === vm.forms.length - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean|*}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        }

    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                }
            }
        }
    }

})();
(function()
{
    'use strict';

    angular
            .module('app.toolbar', [
            ])
            .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function()
{
    'use strict';

    angular.module('app.toolbar')
            .controller('SettingController', SettingController);

    /** @ngInject */
    function SettingController($mdDialog, ApiService, Utils, dialogData,GlobalPool)

    {
        var vm = this;


        // Methods
        vm.closeDialog = closeDialog;

        vm.onSaveBtnTap = onSaveBtnTap;
        

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }




        function onSaveBtnTap(e) {
            Utils.showLoader(true);
            vm.dialogData.Status = vm.dialogData.Status === true ? 1 : 0;



            ApiService.ResetAdminPassword({
                data: vm.dialogData,
                success: function(response) {
                    $mdDialog.hide(vm.dialogData);
                    Utils.showLoader(false);
                    Utils.showToast({text: "Saved Succesfully"});
                    vm._reloadDtPage();
                }
            });
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('app.teachers')
        .controller('TeachersController', TeachersController);
    /** @ngInject */
    function TeachersController(api, usSpinnerService, ApiService, $http, $mdToast, $mdDialog, $document, $compile, $scope, $q, $resource, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, Utils, $state, $rootScope) {
        var vm = this;
        vm.arrTeachers = {};
        vm.dtInstance = {};
        vm.getPromise = getPromise;
        vm.dtOngoingCourseInstance = {};
        vm.dtPreviousCourseInstance = {};
        vm.getData = getData;
        vm.reloadData = reloadData;
        vm.someClickHandler = someClickHandler;
        vm.zones = Focus.ENUMS.TEACHER_ZONES;
        vm.daysEnums = Focus.ENUMS.RECURRANCE_DAYS;
        vm.showDeletedUser = false;
        vm.skills;
        // Paginators
        vm.paginators = new Paginator();
        vm.skill = "";
        vm.zone = "";
        vm.search = "";
        vm.teacherDetail = "";
        vm.allTeacherDetail = [];
        vm._bTeacherDetailPage = false;
        
        $scope.$on("changeSearch", function(event, args) {
            vm.searchDone = true;
            vm.dtInstance.changeData(vm.getData());
            vm.searchDone = false;
        });
        var titleHtml = "";
        var getDotsTpl = function(teacherID, full_name) {
            var dotsHtml = "";
            if (vm.showDeletedUser == false) {
                dotsHtml = dotsHtml + '<md-menu>';
                dotsHtml = dotsHtml + ' <md-button aria-label="More" class="md-icon-button" ng-click="$mdOpenMenu($event)" translate >';
                dotsHtml = dotsHtml + ' <md-icon md-font-icon="icon-dots-vertical"></md-icon>';
                dotsHtml = dotsHtml + '<md-tooltip><span >More</span></md-tooltip>';
                dotsHtml = dotsHtml + '</md-button>';
                dotsHtml = dotsHtml + '<md-menu-content width="3">';

                dotsHtml = dotsHtml + '<md-menu-item>';
                dotsHtml = dotsHtml + '<md-button aria-label="certificates"  ng-click="vm.showTeacherDetail($event,\'' + teacherID + '\')" data-info=\'' + teacherID + '\'>';
                dotsHtml = dotsHtml + '<span >Detail</span>';
                dotsHtml = dotsHtml + '</md-button>';
                dotsHtml = dotsHtml + '</md-menu-item>';

                dotsHtml = dotsHtml + '<md-menu-item>';
                dotsHtml = dotsHtml + '<md-button aria-label="Edit" ng-click="vm.onEditTeacherTap($event,\'' + teacherID + '\')" data-info=\'' + teacherID + '\'>';
                dotsHtml = dotsHtml + '<span>Edit</span>';
                dotsHtml = dotsHtml + '</md-button>';
                dotsHtml = dotsHtml + '</md-menu-item>';

                dotsHtml = dotsHtml + '<md-menu-item>';
                dotsHtml = dotsHtml + '<md-button aria-label="Delete"  ng-click="vm.onDeleteTeacherTap($event,\'' + teacherID + '\',\'' + full_name + '\')" data-info=\'' + teacherID + '\'>';
                dotsHtml = dotsHtml + '<span >Delete</span>';
                dotsHtml = dotsHtml + '</md-button>';
                dotsHtml = dotsHtml + '</md-menu-item>';

                dotsHtml = dotsHtml + '</md-menu-content>';
                dotsHtml = dotsHtml + '</md-menu>';
            } else if (vm.showDeletedUser == true) {
                dotsHtml = dotsHtml + '<md-menu>';
                dotsHtml = dotsHtml + ' <md-button aria-label="More" class="md-icon-button" ng-click="$mdOpenMenu($event)" translate >';
                dotsHtml = dotsHtml + ' <md-icon md-font-icon="icon-dots-vertical"></md-icon>';
                dotsHtml = dotsHtml + '<md-tooltip><span >More</span></md-tooltip>';
                dotsHtml = dotsHtml + '</md-button>';

                dotsHtml = dotsHtml + '<md-menu-content width="3">';
                dotsHtml = dotsHtml + '<md-menu-item>';
                dotsHtml = dotsHtml + '<md-button aria-label="Delete"  ng-click="vm.onReActivateUserTap($event,\'' + teacherID + '\',\'' + full_name + '\')" data-info=\'' + teacherID + '\'>';
                dotsHtml = dotsHtml + '<span >ReActivate</span>';
                dotsHtml = dotsHtml + '</md-button>';
                dotsHtml = dotsHtml + '</md-menu-item>';

                dotsHtml = dotsHtml + '</md-menu-content>';
                dotsHtml = dotsHtml + '</md-menu>';
            }
            return dotsHtml;
        };
        vm.dtPromiseFn = function() {
            return vm.getData();
        }
        vm._reloadDtPage = function() {
            vm._bTeacherDetailPage = false;
            vm.dtInstance.changeData(vm.dtPromiseFn());
        };
        vm._reloadTeacherDetail = function() {
            vm.showTeacherDetail('e',vm.teacherId);
        }
        vm.dtOptions = DTOptionsBuilder.fromFnPromise(vm.dtPromiseFn).withOption('createdRow', function(row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            }).withOption('headerCallback', function(header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            }).withOption("responsive", true).withOption("bInfo", false)
            .withOption("order", [1, 'asc']).withOption('rowCallback', rowCallback);

        function someClickHandler(info) {
            var dialogData = info;
            Utils.showLoader(true);
            dialogData.Status = dialogData.Status == 1 ? true : false;
            //            dialogData.start_of_employment = "03/15/2016"
            dialogData.type = "edit";
            ApiService.GetSkills({}).then(function(response) {
                Utils.showLoader(false);
                var skillobj = response.data;
                $mdDialog.show({
                    controller: 'AddTeachersDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/teachers/add-teachers/add-teachers-dialog.html',
                    parent: angular.element($document.body),
                    //                    clickOutsideToClose: true,
                    locals: {
                        dialogData: angular.copy(dialogData),
                        dtInstance: vm.dtInstance,
                        skillobj: skillobj,
                        dtPromiseFn: vm.dtPromiseFn
                    }
                }).then(function(response) {});
            });
        }

        function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    vm.someClickHandler(aData);
                });
            });
            return nRow;
        }
        vm.dtColumns = [
            DTColumnBuilder.newColumn('teacherId').withTitle('teacherID').notVisible().withClass('g-hidden'),
            DTColumnBuilder.newColumn('full_name').withTitle('Name'),
            DTColumnBuilder.newColumn('email').withTitle('Email'),
            DTColumnBuilder.newColumn('address').withTitle('Address'),
            DTColumnBuilder.newColumn('contact_number').withTitle('Contact No.'),
            DTColumnBuilder.newColumn('start_of_employment').withTitle('Joining'),
            DTColumnBuilder.newColumn(null).withTitle('Generate Payslip').notSortable().renderWith(function(data, type, full, meta) {
                return '<md-button class="md-accent md-raised btnviolet md-hue-1 md-button_small g_margin-left-0 increase-index" ng-click="vm.openDataDlg(\'' + full.teacherId + '\',$event); $event.stopPropagation();">' + "Generate Payslip" + '</md-button>';
            }),
            DTColumnBuilder.newColumn(null).withTitle("").notSortable()
            .renderWith(function(data, type, full, meta) {
                vm.arrTeachers[data.teacherId] = data;
                return getDotsTpl(data.teacherId, data.full_name);
            }),
        ];
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(1).withOption("responsivePriority", 1),
            DTColumnDefBuilder.newColumnDef(7).notSortable().withOption("responsivePriority", 2)
        ];

        vm._onFilterChanged = function(val) {
            vm.changeFilter = true;
            vm.dtInstance.changeData(vm.getData());
            vm.changeFilter = false;
        };

        vm.onClearFiltersTap = function() {
            vm.skill = null;
            vm.zone = null;
            vm.showDeletedUser = false;
            vm.dtInstance.changeData(vm.getData());
        }

        function getData() {
            Utils.showLoader(true);
            var defer = $q.defer();
            var requestData = {
                skill: vm.skill,
                zone: vm.zone,
                showDeletedUser: vm.showDeletedUser,
                search: vm.search
            };
            if (vm.changeFilter == true) {
                vm.paginators.curPageIndex = 1;
            }
            if (vm.searchDone == true) {
                vm.paginators.curPageIndex = 1;
            } else {}
            ApiService.GetTeachers({
                paginators: vm.paginators,
                data: requestData
            }).then(function(response) {
                var data = response.data;
                vm.allTeacherDetail = response.data;
                if (response && response.headerFn) {
                    vm.paginators.setTotal(response.headerFn("totalitemscount"));
                }
                defer.resolve(data);
                setTimeout(function() {
                    Utils.showLoader(false);
                }, 0)
            });
            ApiService.GetSkills({}).then(function(response) {
                Utils.showLoader(false);
                vm.skills = response.data;
            });
            return defer.promise;
        };
        vm.onPrevClick = function(e, pageStartIndex, pageEndIndex, totalItems) {
            vm.paginators.previous(e, pageStartIndex, pageEndIndex, totalItems);
            vm.dtInstance.changeData(vm.getData());
        }
        vm.onNextClick = function(e, pageStartIndex, pageEndIndex, totalItems) {
            vm.paginators.next(e, pageStartIndex, pageEndIndex, totalItems);
            vm.dtInstance.changeData(vm.getData());
        }
        vm.openNoteDataDlg = function(intake_id,note, e) {
            e.preventDefault();
            e.stopPropagation();
            var checkData = {
                "intake_id": intake_id,
                "note" : note,
                'teacherID' : vm.teacherId
            };
            $mdDialog.show({
                controller: 'AddNoteDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/teachers/note/add-note-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                //                            clickOutsideToClose: true,
                locals: {
                    dialogData: checkData,
                    dtInstance: vm.dtInstance,
                    dtPromiseFn: vm.dtPromiseFn
                }
            }).then(function(response) {
                vm.showTeacherDetail('e', response.teacherID);
            });

            
        }
        vm.openDataDlg = function(teacherid, e) {
            e.preventDefault();
            e.stopPropagation();
            var checkData = {
                "teacher_id": teacherid
            }
            ApiService.IsTeacherRateDefined({
                data: checkData,
                success: function(response) {
                    if (response.status == 0) {
                        //show message
                        Utils.showToast({
                            text: response.data.message,
                            'type': 0
                        });
                    } else {
                        var dialogData = {};
                        dialogData.teacherId = teacherid;
                        Utils.showLoader(true);
                        Utils.showLoader(false);
                        $mdDialog.show({
                            controller: 'GeneratePayslipDialogController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/teachers/generate-payslip/generate-payslip-dialog.html',
                            parent: angular.element($document.body),
                            targetEvent: e,
                            //                            clickOutsideToClose: true,
                            locals: {
                                dialogData: dialogData,
                                dtInstance: vm.dtInstance,
                                dtPromiseFn: vm.dtPromiseFn
                            }
                        }).then(function(response) {});
                    }
                }
            });
        }
        $scope.$watch("global.search", function(newValue, oldValue) {
            if (oldValue === "") {
                return;
            }
            vm.search = newValue;
            Utils.showLoader(true);
            vm.searchDone = true;
            vm.dtInstance.changeData(vm.getData());
            //            Utils.showLoader(false);
            vm.searchDone = false;
        });
        $scope.$on("on-collapse", function(event, args) {
            vm.searchDone = true;
            vm.dtInstance.changeData(vm.getData());
            vm.searchDone = false;
            Utils.showLoader(false);
        });

        function reloadData() {
            if (vm.dtInstance.reloadData)
                vm.dtInstance.reloadData();
        }
        vm.onCreateTeacherTap = function(e) {
            Utils.showLoader(true);
            var dialogData = {
                "type": "add",
                "Status": true
            };
            ApiService.GetSkills({}).then(function(response) {
                var skillobj = response.data;
                Utils.showLoader(false);
                $mdDialog.show({
                    controller: 'AddTeachersDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/teachers/add-teachers/add-teachers-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    //                    clickOutsideToClose: true,
                    locals: {
                        dialogData: dialogData,
                        dtInstance: vm.dtInstance,
                        skillobj: skillobj,
                        dtPromiseFn: vm.dtPromiseFn
                    }
                }).then(function(response) {});
            });
        };

        function getPromise(data) {
            var dfd = $q.defer();
            if (data.length != 0) {
                dfd.resolve(data);
            } else {
                dfd.resolve({});
            }
            return dfd.promise;
        }

        vm.onReActivateUserTap = function(e, id, name) {
            var reActivateData = {
                "role_id": "2",
                "admins": [id]
            }
            var confirm = $mdDialog.confirm()
                .title('Confirm Reactivate Trainer?')
                .textContent('Are you sure you want to re-activate selected Trainer ?')
                .ariaLabel('reactivateTrainer')
                .targetEvent(e)
                .ok('Re-activate')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                Utils.showLoader(true);
                ApiService.ReActivateAdmin({
                    data: reActivateData,
                    success: function(response) {
                        Utils.showLoader(false);
                        if (response.status == 0) {
                            Utils.showToast({ text: response.data.message, 'type': 0 });
                        } else {
                            Utils.showToast({ text: response.data.message, 'type': 1 });
                            vm._reloadDtPage();
                        }
                    }
                });
            }, function() {});


        };
        vm.onDeleteTeacherTap = function(e, teacherID, name) {
            var checkData = {
                "teacherID": teacherID
            }
            ApiService.checkTeacherDeletable({
                data: checkData,
                success: function(response) {
                    if (response.status == 0) {
                        Utils.showToast({
                            text: response.data.message,
                            'type': 0
                        });
                    } else {
                        var deleteData = {
                            "role_id": "2",
                            "users": [teacherID]
                        }
                        var confirm = $mdDialog.confirm()
                            .title('Confirm Delete Teacher?')
                            .textContent('Are you sure you want to delete selected Teacher ?')
                            .ariaLabel('Delete')
                            .targetEvent(e)
                            .ok('Delete')
                            .cancel('Cancel');
                        $mdDialog.show(confirm).then(function() {
                            Utils.showLoader(true);
                            ApiService.DeleteUser({
                                data: deleteData,
                                success: function(response) {
                                    Utils.showLoader(false);
                                    if (response.status == 0) {
                                        Utils.showToast({
                                            text: response.data.message,
                                            'type': 0
                                        });
                                    } else {
                                        Utils.showToast({
                                            text: response.data.message,
                                            'type': 1
                                        });
                                        vm._reloadDtPage();
                                    }
                                }
                            });
                        }, function() {});
                    }
                }
            })
        };
        vm.onEditTeacherTap = function(e, teacherID) {
            var dialogData = vm.arrTeachers[teacherID];

            dialogData.Status = dialogData.Status == 1 ? true : false;
            //            dialogData.start_of_employment = "03/15/2016"
            dialogData.type = "edit";
            ApiService.GetSkills({}).then(function(response) {
                var skillobj = response.data;
                $mdDialog.show({
                    controller: 'AddTeachersDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/teachers/add-teachers/add-teachers-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    //                    clickOutsideToClose: true,
                    locals: {
                        dialogData: angular.copy(dialogData),
                        dtInstance: vm.dtInstance,
                        skillobj: skillobj,
                        dtPromiseFn: vm.dtPromiseFn
                    }
                }).then(function(response) {
                    vm.showTeacherDetail('e', response.teacherID);
                });
            });
        };
        $scope.onFileSelect = function(files) {
            if (!files || files.length == 0) {
                return;
            }
            vm.handleFiles(files);
        };
        vm.handleFiles = function(files) {
            // Check for the various File API support.
            if (window.FileReader) {
                // FileReader are supported.
                getAsText(files[0]);
            } else {
                alert('FileReader are not supported in this browser.');
            }
        };

        function getAsText(fileToRead) {
            var reader = new FileReader();
            // Read file into memory as UTF-8
            reader.readAsText(fileToRead);
            // Handle errors load
            reader.onload = loadHandler;
            reader.onerror = errorHandler;
        }

        function loadHandler(event) {
            var csv = event.target.result;
            processData(csv);
        }

        function processData(csv) {
            var allTextLines = csv.split(/\r\n|\n/);
            var lines = [];
            for (var i = 0; i < allTextLines.length; i++) {
                var data = allTextLines[i].split(';');
                var tarr = [];
                for (var j = 0; j < data.length; j++) {
                    tarr.push(data[j]);
                }
                lines.push(tarr);
            }
            Utils.showLoader(true);
            ApiService.importTeachers({
                data: {
                    dataToImport: 'data:text/csv;charset=utf-8;base64,' + btoa(unescape(encodeURIComponent(csv)))
                },
                success: function(response) {
                    Utils.showLoader(false);
                    if (response.status == 0) {
                        Utils.showToast({
                            text: response.data.message,
                            'type': 0
                        });
                    } else {
                        var dialogData = {};
                        dialogData.errors = response.data.message.errors;
                        dialogData.messages = response.data.message.messages;
                        $mdDialog.show({
                            controller: 'showTeacherLogsController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/teachers/add-teachers/show-log-teachers-dialog.html',
                            parent: angular.element($document.body),
                            //                            clickOutsideToClose: true,
                            locals: {
                                dialogData: angular.copy(dialogData),
                                dtInstance: vm.dtInstance,
                                dtPromiseFn: vm.dtPromiseFn
                            }
                        }).then(function(response) {});
                        //                        Utils.showToast({text: response.data.message});
                        vm._reloadDtPage();
                    }
                }
            });
        }

        function errorHandler(evt) {
            if (evt.target.error.name == "NotReadableError") {
                alert("Canno't read file !");
            }
        }
        // Methods
        //////////

        vm.showTeacherDetail = function(e, teacherId) {

            vm.teacherId = teacherId;
            Utils.showLoader(true);
            var requestData = {
                teacher_id: teacherId
            };
            ApiService.TrainerProfile({
                data: requestData
            }).then(function(response) {

                vm.teacherDetail = response.data;
            });
            vm.ongoingTablePagination = {};
            vm.ongoingTablePagination.curPageIndex = 1;
            vm.ongoingTablePagination.pageStartIndex = 0;
            vm.ongoingTablePagination.pageEndIndex = 0;
            vm.ongoingTablePagination.totalItems = 0;
            vm.ongoingTablePagination.allowPrevious = false;
            ApiService.TeacherOngoingCourses({
                paginators: vm.ongoingTablePagination,
                data: requestData
            }).then(function(response) {
                vm.teacherOngoingCourses = response.data;
                vm.ongoingTablePagination.totalItems = response.headerFn("totalitemscount");
                if (vm.ongoingTablePagination.totalItems > 0) {
                    vm.ongoingTablePagination.pageStartIndex = 1;
                    if (vm.ongoingTablePagination.totalItems <= 10) {
                        vm.ongoingTablePagination.allowNext = false;
                        vm.ongoingTablePagination.pageEndIndex = vm.ongoingTablePagination.totalItems;
                    } else {
                        vm.ongoingTablePagination.allowNext = true;
                        vm.ongoingTablePagination.pageEndIndex = 10;
                    }
                }
                vm.dtOngoingCourseInstance.changeData(vm.getPromise(response.data));
            });
            vm.previousTablePagination = {};
            vm.previousTablePagination.curPageIndex = 1;
            vm.previousTablePagination.pageStartIndex = 0;
            vm.previousTablePagination.pageEndIndex = 0;
            vm.previousTablePagination.totalItems = 0;
            vm.previousTablePagination.allowPrevious = false;
            ApiService.TeacherPreviousCourses({
                paginators: vm.previousTablePagination,
                data: requestData
            }).then(function(response) {
                Utils.showLoader(false);
                vm.studentPreviousCourses = response.data;
                vm.previousTablePagination.totalItems = response.headerFn("totalitemscount");
                if (vm.previousTablePagination.totalItems > 0) {
                    vm.previousTablePagination.pageStartIndex = 1;
                    if (vm.previousTablePagination.totalItems <= 10) {
                        vm.previousTablePagination.allowNext = false;
                        vm.previousTablePagination.pageEndIndex = vm.previousTablePagination.totalItems;
                    } else {
                        vm.previousTablePagination.allowNext = true;
                        vm.previousTablePagination.pageEndIndex = 10;
                    }
                }
                vm.dtPreviousCourseInstance.changeData(vm.getPromise(response.data));
            });

            vm._bTeacherDetailPage = true;

        }
        vm.onOngoingCourseNextClick = function(e, pageStartIndex, pageEndIndex, totalItems) {
            vm.ongoingTablePagination.allowPrevious = true;
            vm.ongoingTablePagination.curPageIndex = vm.ongoingTablePagination.curPageIndex + 1;
            var requestData = {
                'teacher_id': vm.teacherId
            };
            ApiService.TeacherOngoingCourses({
                paginators: vm.ongoingTablePagination,
                data: requestData
            }).then(function(response) {
                Utils.showLoader(false);
                vm.teacherOngoingCourses = response.data;
                vm.ongoingTablePagination.pageStartIndex = vm.ongoingTablePagination.pageStartIndex + 10;
                vm.ongoingTablePagination.pageEndIndex = vm.ongoingTablePagination.pageEndIndex + 10;
                if (vm.ongoingTablePagination.pageEndIndex > vm.ongoingTablePagination.totalItems) {
                    vm.ongoingTablePagination.pageEndIndex = vm.ongoingTablePagination.totalItems;
                    vm.ongoingTablePagination.allowNext = false;
                } else {
                    vm.ongoingTablePagination.allowNext = true;
                }
                vm.dtOngoingCourseInstance.changeData(vm.getPromise(response.data));
            });
        }
        vm.onOngoingCoursePrevClick = function(e, pageStartIndex, pageEndIndex, totalItems) {
            vm.ongoingTablePagination.allowNext = true;
            vm.ongoingTablePagination.curPageIndex = vm.ongoingTablePagination.curPageIndex - 1;
            if (vm.ongoingTablePagination.curPageIndex == 1) {
                vm.ongoingTablePagination.allowPrevious = false;
            }
            var requestData = {
                'teacher_id': vm.teacherId
            };
            ApiService.TeacherOngoingCourses({
                paginators: vm.ongoingTablePagination,
                data: requestData
            }).then(function(response) {
                Utils.showLoader(false);
                vm.teacherOngoingCourses = response.data;
                vm.ongoingTablePagination.pageStartIndex = vm.ongoingTablePagination.pageStartIndex - 10;
                var mod = vm.ongoingTablePagination.pageEndIndex % 10;
                if (mod == 0) {
                    vm.ongoingTablePagination.pageEndIndex = vm.ongoingTablePagination.pageEndIndex - 10;
                } else {
                    vm.ongoingTablePagination.pageEndIndex = vm.ongoingTablePagination.pageEndIndex - mod;
                }
                vm.dtOngoingCourseInstance.changeData(vm.getPromise(response.data));
            });
        }
        vm.onPreviousCourseNextClick = function(e, pageStartIndex, pageEndIndex, totalItems) {
            vm.previousTablePagination.allowPrevious = true;
            vm.previousTablePagination.curPageIndex = vm.previousTablePagination.curPageIndex + 1;
            var requestData = {
                'teacher_id': vm.teacherId
            };
            ApiService.TeacherPreviousCourses({
                paginators: vm.previousTablePagination,
                data: requestData
            }).then(function(response) {
                Utils.showLoader(false);
                vm.studentPreviousCourses = response.data;
                vm.previousTablePagination.pageStartIndex = vm.previousTablePagination.pageStartIndex + 10;
                vm.previousTablePagination.pageEndIndex = vm.previousTablePagination.pageEndIndex + 10;
                if (vm.previousTablePagination.pageEndIndex > vm.previousTablePagination.totalItems) {
                    vm.previousTablePagination.pageEndIndex = vm.previousTablePagination.totalItems;
                    vm.previousTablePagination.allowNext = false;
                } else {
                    vm.previousTablePagination.allowNext = true;
                }
                vm.dtPreviousCourseInstance.changeData(vm.getPromise(response.data));
            });
        }
        vm.onPreviousCoursePrevClick = function(e, pageStartIndex, pageEndIndex, totalItems) {
            vm.previousTablePagination.allowNext = true;
            vm.previousTablePagination.curPageIndex = vm.previousTablePagination.curPageIndex - 1;
            if (vm.previousTablePagination.curPageIndex == 1) {
                vm.previousTablePagination.allowPrevious = false;
            }
            var requestData = {
                'teacher_id': vm.teacherId
            };
            ApiService.TeacherPreviousCourses({
                paginators: vm.previousTablePagination,
                data: requestData
            }).then(function(response) {
                Utils.showLoader(false);
                vm.studentPreviousCourses = response.data;
                vm.previousTablePagination.pageStartIndex = vm.previousTablePagination.pageStartIndex - 10;
                var mod = vm.previousTablePagination.pageEndIndex % 10;
                if (mod == 0) {
                    vm.previousTablePagination.pageEndIndex = vm.previousTablePagination.pageEndIndex - 10;
                } else {
                    vm.previousTablePagination.pageEndIndex = vm.previousTablePagination.pageEndIndex - mod;
                }


                vm.dtPreviousCourseInstance.changeData(vm.getPromise(response.data));
            });
        }
        vm.backToTeacherListing = function() {
            vm._bTeacherDetailPage = false;
            vm.getData();
        }


        function loadDiscrepancyData(response) {
            if (vm.dtOngoingCourseInstance && vm.dtOngoingCourseInstance.reloadData === undefined && vm.dtPreviousCourseInstance && vm.dtPreviousCourseInstance.reloadData === undefined) {
                vm.dtPreviousCourseOptions = vm.dtCourseOptions = DTOptionsBuilder.fromFnPromise(vm.getPromise({})).
                withOption('createdRow', function(row, data, dataIndex) {
                        $compile(angular.element(row).contents())($scope);
                    }).withOption('headerCallback', function(header) {
                        if (!vm.headerCompiled) {
                            vm.headerCompiled = true;
                            $compile(angular.element(header).contents())($scope);
                        }
                    }).withOption("responsive", true)
                    .withOption("pageLength", 50)
                    .withOption("bInfo", false)
                    .withOption('rowCallback', rowCourseCallback)
                    .withOption("order", []);

            }
        }
        loadDiscrepancyData();

        function rowCourseCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) { // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)

            if (aData.is_futurer == 1) {
                $('td', nRow).addClass('certificate-highlight');
            }
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    //                    vm.courseClickHandler(aData);
                });
            });
            return nRow;
        }
        vm.dtCourseColumns = [
            DTColumnBuilder.newColumn('courseName').withTitle('Title').notSortable().renderWith(function(data, type, full, meta) {

                return '<span id ="' + full.schedule_class_id + '" class="redirect_intake">' + full.courseName + '</span>';
            }),
            DTColumnBuilder.newColumn('start_date').withTitle('Start Date').notSortable().renderWith(function(data, type, full, meta) {

                return '<p>' + full.start_date + '</p>';
            }),
            DTColumnBuilder.newColumn('end_date').withTitle('End Date').notSortable().renderWith(function(data, type, full, meta) {

                return '<p>' + full.end_date + '</p>';
            }),
            DTColumnBuilder.newColumn('start_time').withTitle('Time').notSortable().renderWith(function(data, type, full, meta) {

                return '<p>' + full.start_time + ' - ' + full.end_time + '</p>';
            }),
            DTColumnBuilder.newColumn('frequency_type').withTitle('Days').notSortable().renderWith(function(data, type, full, meta) {
                // var asd = full.frequency_interval.split(',');
                // console.log(asd);
                // return '0';
                if (full.frequency_type == '1') {
                    return '<p>Daily</p>';
                } else {
                    var classDays = '';
                    if (full.frequency_interval != null) {
                        var frequency_interval = full.frequency_interval.split(',');
                        if (frequency_interval.length == 1) {
                            classDays = classDays + vm.daysEnums[parseInt(frequency_interval[0])].day;
                        } else {
                            for (var j = 0; j < frequency_interval.length; j++) {
                                if ((j + 1) == frequency_interval.length) {
                                    classDays = classDays + vm.daysEnums[parseInt(frequency_interval[j])].day;
                                } else {
                                    classDays = classDays + vm.daysEnums[parseInt(frequency_interval[j])].day + ', ';
                                }
                            }
                        }
                    }
                    return '<p>' + classDays + '</p>';
                }
            }),
            DTColumnBuilder.newColumn('hours_clocked').withTitle('Total Hours').notSortable().renderWith(function(data, type, full, meta) {

                // return '<p>' + full.hours_clocked + ' hr</p>';
                return '<p>' + full.no_of_hours_balance + ' hr</p>';
            }),
            DTColumnBuilder.newColumn('action').withTitle('Action').notSortable().renderWith(function(data, type, full, meta) {

                return '<md-button class="md-accent md-raised btnviolet md-hue-1 md-button_small g_margin-left-0 increase-index" ng-click="vm.openNoteDataDlg(\'' + full.schedule_class_id + '\',\'' + full.note + '\',$event); $event.stopPropagation();">' + "Add Note" + '</md-button>';
            })


        ];
        vm.dtPreviousCourseColumns = [
            DTColumnBuilder.newColumn('courseName').withTitle('Title').notSortable().renderWith(function(data, type, full, meta) {

                return '<span id = "' + full.schedule_class_id + '" class="redirect_intake">' + full.courseName + '</span>';
            }),
            DTColumnBuilder.newColumn('start_date').withTitle('Start Date').notSortable().renderWith(function(data, type, full, meta) {

                return '<p>' + full.start_date + '</p>';
            }),
            DTColumnBuilder.newColumn('end_date').withTitle('End Date').notSortable().renderWith(function(data, type, full, meta) {

                return '<p>' + full.end_date + '</p>';
            }),
            DTColumnBuilder.newColumn('start_time').withTitle('Time').notSortable().renderWith(function(data, type, full, meta) {

                return '<p>' + full.start_time + ' - ' + full.end_time + '</p>';
            }),
            DTColumnBuilder.newColumn('frequency_type').withTitle('Days').notSortable().renderWith(function(data, type, full, meta) {
                if (full.frequency_type == '1') {
                    return '<p>Daily</p>';
                } else {
                    var classDays = '';
                    if (full.frequency_interval != null) {
                        var frequency_interval = full.frequency_interval.split(',');
                        if (frequency_interval.length == 1) {
                            classDays = classDays + vm.daysEnums[parseInt(frequency_interval[0])].day;
                        } else {
                            for (var j = 0; j < frequency_interval.length; j++) {
                                if ((j + 1) == frequency_interval.length) {
                                    classDays = classDays + vm.daysEnums[parseInt(frequency_interval[j])].day;
                                } else {
                                    classDays = classDays + vm.daysEnums[parseInt(frequency_interval[j])].day + ', ';
                                }
                            }
                        }
                    }
                    return '<p>' + classDays + '</p>';
                }
            }),
            DTColumnBuilder.newColumn('hours_clocked').withTitle('Hours Clocked').notSortable().renderWith(function(data, type, full, meta) {

                return '<p>' + full.hours_clocked + ' hr</p>';
            })

        ];
        vm.dtCourseColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).notSortable(),
            DTColumnDefBuilder.newColumnDef(1).withOption("responsivePriority", 1),
        ];

        angular.element(document).on("click", "span.redirect_intake", function() {
            var schedule_class_id = $(this).closest('span').attr('id');
            if (typeof schedule_class_id != 'undefined') {
                window.location = '/intake?id=' + schedule_class_id;
            }
        });

    }
})();
(function ()
{
    'use strict';

    angular
            .module('app.profile & class details', ['ngTagsInput','720kb.datepicker','ngMaterial'])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
   
    }
})();
(function () {
    'use strict';
    angular
        .module('app.profile & class details')
        .controller('TeacherProfileController', TeacherProfileController);
    /** @ngInject */
    function TeacherProfileController(api, usSpinnerService, ApiService, $http, $mdToast, $mdDialog, $document, $compile, $scope, $q, $resource, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, Utils, $state, $rootScope, GlobalPool) {
        var vm = this;
        vm.arrTeachers = {};
        vm.dtInstance = {};
        vm.getPromise = getPromise;
        vm.dtOngoingCourseInstance = {};
        vm.dtPreviousCourseInstance = {};
        vm.zones = Focus.ENUMS.TEACHER_ZONES;
        vm.daysEnums = Focus.ENUMS.RECURRANCE_DAYS;
        vm.showDeletedUser = false;
        var userInfo = GlobalPool.getUserInfo();
        vm.skills;
        // Paginators
        vm.paginators = new Paginator();
        vm.skill = "";
        vm.zone = "";
        vm.search = "";
        vm.teacherDetail = "";
        vm.allTeacherDetail = [];
        vm._bTeacherDetailPage = true;
        vm.availableRooms = [];
        vm.dates = [];
        vm._reloadTeacherDetail = function () {
            vm.showTeacherDetail('e', vm.teacherId);
        }

        vm.openDataDlg = function (teacherid, e) {
            e.preventDefault();
            e.stopPropagation();
            var checkData = {
                "teacher_id": teacherid
            }
            ApiService.IsTeacherRateDefined({
                data: checkData,
                success: function (response) {
                    if (response.status == 0) {
                        //show message
                        Utils.showToast({
                            text: response.data.message,
                            'type': 0
                        });
                    } else {
                        var dialogData = {};
                        dialogData.teacherId = teacherid;
                        Utils.showLoader(true);
                        Utils.showLoader(false);
                        $mdDialog.show({
                            controller: 'GeneratePayslipDialogController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/teachers/generate-payslip/generate-payslip-dialog.html',
                            parent: angular.element($document.body),
                            targetEvent: e,
                            //                            clickOutsideToClose: true,
                            locals: {
                                dialogData: dialogData,
                                dtInstance: vm.dtInstance,
                                dtPromiseFn: vm.dtPromiseFn
                            }
                        }).then(function (response) { });
                    }
                }
            });
        }



        function getPromise(data) {
            var dfd = $q.defer();
            if (data.length != 0) {
                dfd.resolve(data);
            } else {
                dfd.resolve({});
            }
            return dfd.promise;
        }


        // Methods
        //////////

        vm.showTeacherDetail = function (e, teacherId) {

            vm.teacherId = teacherId;
            Utils.showLoader(true);
            var requestData = {
                teacher_id: teacherId,
                search: vm.search
            };
            ApiService.TrainerProfile({
                data: requestData
            }).then(function (response) {

                vm.teacherDetail = response.data;
            });
            vm.ongoingTablePagination = {};
            vm.ongoingTablePagination.curPageIndex = 1;
            vm.ongoingTablePagination.pageStartIndex = 0;
            vm.ongoingTablePagination.pageEndIndex = 0;
            vm.ongoingTablePagination.totalItems = 0;
            vm.ongoingTablePagination.allowPrevious = false;
            ApiService.TeacherOngoingCourses({
                paginators: vm.ongoingTablePagination,
                data: requestData
            }).then(function (response) {
                Utils.showLoader(false);

                vm.teacherOngoingCourses = response.data;
                vm.ongoingTablePagination.totalItems = response.headerFn("totalitemscount");
                if (vm.ongoingTablePagination.totalItems > 0) {
                    vm.ongoingTablePagination.pageStartIndex = 1;
                    if (vm.ongoingTablePagination.totalItems <= 10) {
                        vm.ongoingTablePagination.allowNext = false;
                        vm.ongoingTablePagination.pageEndIndex = vm.ongoingTablePagination.totalItems;
                    } else {
                        vm.ongoingTablePagination.allowNext = true;
                        vm.ongoingTablePagination.pageEndIndex = 10;
                    }
                }
                vm.dtOngoingCourseInstance.changeData(vm.getPromise(response.data));
            });
            vm.previousTablePagination = {};
            vm.previousTablePagination.curPageIndex = 1;
            vm.previousTablePagination.pageStartIndex = 0;
            vm.previousTablePagination.pageEndIndex = 0;
            vm.previousTablePagination.totalItems = 0;
            vm.previousTablePagination.allowPrevious = false;
            ApiService.TeacherPreviousCourses({
                paginators: vm.previousTablePagination,
                data: requestData
            }).then(function (response) {
                Utils.showLoader(false);
                vm.studentPreviousCourses = response.data;
                vm.previousTablePagination.totalItems = response.headerFn("totalitemscount");
                if (vm.previousTablePagination.totalItems > 0) {
                    vm.previousTablePagination.pageStartIndex = 1;
                    if (vm.previousTablePagination.totalItems <= 10) {
                        vm.previousTablePagination.allowNext = false;
                        vm.previousTablePagination.pageEndIndex = vm.previousTablePagination.totalItems;
                    } else {
                        vm.previousTablePagination.allowNext = true;
                        vm.previousTablePagination.pageEndIndex = 10;
                    }
                }
                vm.dtPreviousCourseInstance.changeData(vm.getPromise(response.data));
            });

            vm._bTeacherDetailPage = true;

        }
        vm.onOngoingCourseNextClick = function (e, pageStartIndex, pageEndIndex, totalItems) {
            vm.ongoingTablePagination.allowPrevious = true;
            vm.ongoingTablePagination.curPageIndex = vm.ongoingTablePagination.curPageIndex + 1;
            var requestData = {
                'teacher_id': vm.teacherId
            };
            ApiService.TeacherOngoingCourses({
                paginators: vm.ongoingTablePagination,
                data: requestData
            }).then(function (response) {
                Utils.showLoader(false);
                vm.teacherOngoingCourses = response.data;
                vm.ongoingTablePagination.pageStartIndex = vm.ongoingTablePagination.pageStartIndex + 10;
                vm.ongoingTablePagination.pageEndIndex = vm.ongoingTablePagination.pageEndIndex + 10;
                if (vm.ongoingTablePagination.pageEndIndex > vm.ongoingTablePagination.totalItems) {
                    vm.ongoingTablePagination.pageEndIndex = vm.ongoingTablePagination.totalItems;
                    vm.ongoingTablePagination.allowNext = false;
                } else {
                    vm.ongoingTablePagination.allowNext = true;
                }
                vm.dtOngoingCourseInstance.changeData(vm.getPromise(response.data));
            });
        }
        vm.onOngoingCoursePrevClick = function (e, pageStartIndex, pageEndIndex, totalItems) {
            vm.ongoingTablePagination.allowNext = true;
            vm.ongoingTablePagination.curPageIndex = vm.ongoingTablePagination.curPageIndex - 1;
            if (vm.ongoingTablePagination.curPageIndex == 1) {
                vm.ongoingTablePagination.allowPrevious = false;
            }
            var requestData = {
                'teacher_id': vm.teacherId
            };
            ApiService.TeacherOngoingCourses({
                paginators: vm.ongoingTablePagination,
                data: requestData
            }).then(function (response) {
                Utils.showLoader(false);
                vm.teacherOngoingCourses = response.data;
                vm.ongoingTablePagination.pageStartIndex = vm.ongoingTablePagination.pageStartIndex - 10;
                var mod = vm.ongoingTablePagination.pageEndIndex % 10;
                if (mod == 0) {
                    vm.ongoingTablePagination.pageEndIndex = vm.ongoingTablePagination.pageEndIndex - 10;
                } else {
                    vm.ongoingTablePagination.pageEndIndex = vm.ongoingTablePagination.pageEndIndex - mod;
                }
                vm.dtOngoingCourseInstance.changeData(vm.getPromise(response.data));
            });
        }
        vm.onPreviousCourseNextClick = function (e, pageStartIndex, pageEndIndex, totalItems) {
            vm.previousTablePagination.allowPrevious = true;
            vm.previousTablePagination.curPageIndex = vm.previousTablePagination.curPageIndex + 1;
            var requestData = {
                'teacher_id': vm.teacherId
            };
            ApiService.TeacherPreviousCourses({
                paginators: vm.previousTablePagination,
                data: requestData
            }).then(function (response) {
                Utils.showLoader(false);
                vm.studentPreviousCourses = response.data;
                vm.previousTablePagination.pageStartIndex = vm.previousTablePagination.pageStartIndex + 10;
                vm.previousTablePagination.pageEndIndex = vm.previousTablePagination.pageEndIndex + 10;
                if (vm.previousTablePagination.pageEndIndex > vm.previousTablePagination.totalItems) {
                    vm.previousTablePagination.pageEndIndex = vm.previousTablePagination.totalItems;
                    vm.previousTablePagination.allowNext = false;
                } else {
                    vm.previousTablePagination.allowNext = true;
                }
                vm.dtPreviousCourseInstance.changeData(vm.getPromise(response.data));
            });
        }
        vm.onPreviousCoursePrevClick = function (e, pageStartIndex, pageEndIndex, totalItems) {
            vm.previousTablePagination.allowNext = true;
            vm.previousTablePagination.curPageIndex = vm.previousTablePagination.curPageIndex - 1;
            if (vm.previousTablePagination.curPageIndex == 1) {
                vm.previousTablePagination.allowPrevious = false;
            }
            var requestData = {
                'teacher_id': vm.teacherId
            };
            ApiService.TeacherPreviousCourses({
                paginators: vm.previousTablePagination,
                data: requestData
            }).then(function (response) {
                Utils.showLoader(false);
                vm.studentPreviousCourses = response.data;
                vm.previousTablePagination.pageStartIndex = vm.previousTablePagination.pageStartIndex - 10;
                var mod = vm.previousTablePagination.pageEndIndex % 10;
                if (mod == 0) {
                    vm.previousTablePagination.pageEndIndex = vm.previousTablePagination.pageEndIndex - 10;
                } else {
                    vm.previousTablePagination.pageEndIndex = vm.previousTablePagination.pageEndIndex - mod;
                }


                vm.dtPreviousCourseInstance.changeData(vm.getPromise(response.data));
            });
        }
        vm.backToTeacherListing = function () {
            vm._bTeacherDetailPage = false;
            vm.getData();
        }


        function loadDiscrepancyData(response) {
            if (vm.dtOngoingCourseInstance && vm.dtOngoingCourseInstance.reloadData === undefined && vm.dtPreviousCourseInstance && vm.dtPreviousCourseInstance.reloadData === undefined) {
                vm.dtPreviousCourseOptions = vm.dtCourseOptions = DTOptionsBuilder.fromFnPromise(vm.getPromise({})).
                    withOption('createdRow', function (row, data, dataIndex) {
                        $compile(angular.element(row).contents())($scope);
                    }).withOption('headerCallback', function (header) {
                        if (!vm.headerCompiled) {
                            vm.headerCompiled = true;
                            $compile(angular.element(header).contents())($scope);
                        }
                    }).withOption("responsive", true)
                    .withOption("pageLength", 50)
                    .withOption("bInfo", false)
                    .withOption('rowCallback', rowCourseCallback)
                    .withOption("order", []);

            }
        }
        loadDiscrepancyData();

        function rowCourseCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) { // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
            var parts = aData.start_date.split("/");
            var schedule_date = new Date(parts[2], parts[1] - 1, parts[0]);
            if (schedule_date > new Date()) {
                $('td', nRow).addClass('highlight');
            }
            if (aData.is_futurer == 1) {
                $('td', nRow).addClass('certificate-highlight');
            }
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function () {
                $scope.$apply(function () {
                    //                    vm.courseClickHandler(aData);
                });
            });
            return nRow;
        }
        vm.dtCourseColumns = [
            DTColumnBuilder.newColumn('courseName').withTitle('Title').notSortable().renderWith(function (data, type, full, meta) {

                return '<span id ="' + full.schedule_class_id + '" class="redirect_intake">' + full.courseName + '</span>';
            }),
            DTColumnBuilder.newColumn('start_date').withTitle('Start Date').notSortable().renderWith(function (data, type, full, meta) {

                return '<p>' + full.start_date + '</p>';
            }),
            DTColumnBuilder.newColumn('end_date').withTitle('End Date').notSortable().renderWith(function (data, type, full, meta) {

                return '<p>' + full.end_date + '</p>';
            }),
            DTColumnBuilder.newColumn('start_time').withTitle('Time').notSortable().renderWith(function (data, type, full, meta) {

                return '<p>' + full.start_time + ' - ' + full.end_time + '</p>';
            }),
            DTColumnBuilder.newColumn('frequency_type').withTitle('Days').notSortable().renderWith(function (data, type, full, meta) {
                // var asd = full.frequency_interval.split(',');
                // console.log(asd);
                // return '0';
                if (full.frequency_type == '1') {
                    return '<p>Daily</p>';
                } else {
                    var classDays = '';
                    if (full.frequency_interval != null) {
                        var frequency_interval = full.frequency_interval.split(',');
                        if (frequency_interval.length == 1) {
                            classDays = classDays + vm.daysEnums[parseInt(frequency_interval[0])].day;
                        } else {
                            for (var j = 0; j < frequency_interval.length; j++) {
                                if ((j + 1) == frequency_interval.length) {
                                    classDays = classDays + vm.daysEnums[parseInt(frequency_interval[j])].day;
                                } else {
                                    classDays = classDays + vm.daysEnums[parseInt(frequency_interval[j])].day + ', ';
                                }
                            }
                        }
                    }
                    return '<p>' + classDays + '</p>';
                }
            }),
            DTColumnBuilder.newColumn('hours_clocked').withTitle('Balance Hours').notSortable().renderWith(function (data, type, full, meta) {

                // return '<p>' + full.hours_clocked + ' hr</p>';
                return '<p>' + full.no_of_hours_balance + ' hr</p>';

            }),
            DTColumnBuilder.newColumn('note').withTitle('Note').notSortable().renderWith(function (data, type, full, meta) {

                return full.note;
            })


        ];
        vm.dtPreviousCourseColumns = [
            DTColumnBuilder.newColumn('courseName').withTitle('Title').notSortable().renderWith(function (data, type, full, meta) {

                return '<span id = "' + full.schedule_class_id + '" class="redirect_intake">' + full.courseName + '</span>';
            }),
            DTColumnBuilder.newColumn('start_date').withTitle('Start Date').notSortable().renderWith(function (data, type, full, meta) {

                return '<p>' + full.start_date + '</p>';
            }),
            DTColumnBuilder.newColumn('end_date').withTitle('End Date').notSortable().renderWith(function (data, type, full, meta) {

                return '<p>' + full.end_date + '</p>';
            }),
            DTColumnBuilder.newColumn('start_time').withTitle('Time').notSortable().renderWith(function (data, type, full, meta) {

                return '<p>' + full.start_time + ' - ' + full.end_time + '</p>';
            }),
            DTColumnBuilder.newColumn('frequency_type').withTitle('Days').notSortable().renderWith(function (data, type, full, meta) {
                if (full.frequency_type == '1') {
                    return '<p>Daily</p>';
                } else {
                    var classDays = '';
                    if (full.frequency_interval != null) {
                        var frequency_interval = full.frequency_interval.split(',');
                        if (frequency_interval.length == 1) {
                            classDays = classDays + vm.daysEnums[parseInt(frequency_interval[0])].day;
                        } else {
                            for (var j = 0; j < frequency_interval.length; j++) {
                                if ((j + 1) == frequency_interval.length) {
                                    classDays = classDays + vm.daysEnums[parseInt(frequency_interval[j])].day;
                                } else {
                                    classDays = classDays + vm.daysEnums[parseInt(frequency_interval[j])].day + ', ';
                                }
                            }
                        }
                    }
                    return '<p>' + classDays + '</p>';
                }
            }),
            DTColumnBuilder.newColumn('hours_clocked').withTitle('Hours Clocked').notSortable().renderWith(function (data, type, full, meta) {

                return '<p>' + full.hours_clocked + ' hr</p>';
            }),
            DTColumnBuilder.newColumn('note').withTitle('Note').notSortable().renderWith(function (data, type, full, meta) {

                return full.note;
            })

        ];
        vm.dtCourseColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).notSortable(),
            DTColumnDefBuilder.newColumnDef(1).withOption("responsivePriority", 1),
        ];

        vm.testCall = function (date, columnIndex) {
            var firstRowCell = document.querySelector('th[data-cell="' + columnIndex + '"][data-date]');

            // Read the data-date attribute of the first row's cell
            var columnDate = firstRowCell.getAttribute('data-date');
            console.log(columnDate);

            Utils.showLoader(true);
            date.start_date = columnDate;
            var dialogData = {
                data: date,
            };
            var requestData = {
                'flexible': 0,
                'course_type': 'G'
            }

            Utils.showLoader(false);
            $mdDialog.show({
                controller: 'RequestAdhocClassDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dashboard/request-adhoc-class/request-adhoc-class-dialog.html',
                parent: angular.element($document.body),
                // targetEvent: e,
                //                        clickOutsideToClose: true,
                locals: {
                    dialogData: angular.copy(dialogData),
                    dtInstance: vm.dtInstance,
                    dtPromiseFn: vm.dtPromiseFn,
                    updateScheduler: ''
                }
            }).then(function (response) {

            });
        }


        angular.element(document).on("click", "span.redirect_intake", function () {
            var schedule_class_id = $(this).closest('span').attr('id');
            if (typeof schedule_class_id != 'undefined') {
                var link = '/intake?id=' + schedule_class_id;
                window.open(link, '_blank');
            }
        });

        $scope.$watch("global.search", function (newValue, oldValue) {
            console.log(newValue);
            if (oldValue === "") {
                return;
            }
            vm.search = newValue;
            Utils.showLoader(true);
            vm.searchDone = true;
            vm.showTeacherDetail('e', vm.teacherId);
            // vm.dtInstance.changeData(vm.getData());
            vm.searchDone = false;
        });

        $scope.$on("changeSearch", function (event, args) {
            vm.searchDone = true;
            vm.showTeacherDetail('e', vm.teacherId);

            // vm.dtInstance.changeData(vm.getData());
            vm.searchDone = false;
        });


        function init() {
            vm.showTeacherDetail('e', userInfo.id);
            loadAvailableRooms();
        } init();

        function loadAvailableRooms() {
            var today = new Date();

            // Loop through the next 7 days
            for (var i = 0; i < 7; i++) {
                var nextDate = new Date(today);
                nextDate.setDate(today.getDate() + i);
                vm.dates.push(nextDate);
            }
            Utils.showLoader(true);
            ApiService.GetAvailableRoomSlots({
                // data: requestData
            }).then(function (response) {
                Utils.showLoader(false);
                vm.availableRooms = response.data;

                // console.log(vm.availableRooms);
            });
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.students')
        .controller('StudentsController', StudentsController);

    /** @ngInject */
    function StudentsController(api, GlobalPool, ApiService, $http, $mdToast, Upload, $mdDialog, $document, $compile, $scope, $q, $resource, $timeout, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, Utils,$rootScope) {
        var vm = this;
        vm.arrStudents = {};
        vm.getPromise = getPromise;
        vm.dtOngoingCourseInstance = {};
        vm.dtPreviousCourseInstance = {};
        vm.dtInstance = {};
        vm.getData = getData;
        vm.reloadData = reloadData;
        vm.search = "";
        vm.setView = false;
        var userInfo = GlobalPool.getUserInfo();
        vm.setAuthToken = userInfo.auth_token;
        vm.setAuthDownloadLink = api.baseURI;
        vm.someClickHandler = someClickHandler;
        vm.courseType = Focus.ENUMS.COURSE_FILTERTYPE;
        vm.courseLevel = Focus.ENUMS.COURSE_LEVEL;
        vm._bStudentListingPage = true;
        vm._bStudentDetailPage = false;
        vm.studentOngoingCourses = [];
        vm.students = [];
        vm.studentID = '';
        console.log('new code');

        if (userInfo.role_id == 1 || userInfo.role_id == 4) {
            vm.setView = true;
        }
        // Paginators
        vm.paginators = new Paginator();

        $scope.$on("changeSearch", function(event, args) {
            vm.searchDone = true;
            vm.dtInstance.changeData(vm.getData());
            vm.searchDone = false;
        });

        $scope.onFileSelect = function(files) {
            if (!files || files.length == 0) {
                return;
            }
            vm.handleFiles(files);

        };


        var getDotsTpl = function(studentID, full_name) {
            var dotsHtml = "";
            dotsHtml = dotsHtml + '<md-menu>';
            dotsHtml = dotsHtml + ' <md-button aria-label="More" class="md-icon-button" ng-click="$mdOpenMenu($event)" translate >';
            dotsHtml = dotsHtml + ' <md-icon md-font-icon="icon-dots-vertical"></md-icon>';
            dotsHtml = dotsHtml + '<md-tooltip><span >More</span></md-tooltip>';
            dotsHtml = dotsHtml + '</md-button>';
            dotsHtml = dotsHtml + '<md-menu-content width="3">';

            dotsHtml = dotsHtml + '<md-menu-item>';
            dotsHtml = dotsHtml + '<md-button aria-label="certificates"  ng-click="vm.showStudentDetail($event,\'' + studentID + '\')" data-info=\'' + studentID + '\'>';
            dotsHtml = dotsHtml + '<span >Detail</span>';
            dotsHtml = dotsHtml + '</md-button>';
            dotsHtml = dotsHtml + '</md-menu-item>';
            if (userInfo.role_id == 1) {
                dotsHtml = dotsHtml + '<md-menu-item>';
                dotsHtml = dotsHtml + '<md-button aria-label="Edit" ng-click="vm.onEditStudentTap($event,\'' + studentID + '\')" data-info=\'' + studentID + '\'>';
                dotsHtml = dotsHtml + '<span>Edit</span>';
                dotsHtml = dotsHtml + '</md-button>';
                dotsHtml = dotsHtml + '</md-menu-item>';

                dotsHtml = dotsHtml + '<md-menu-item>';
                dotsHtml = dotsHtml + '<md-button aria-label="Delete"  ng-click="vm.onDeleteStudentTap($event,\'' + studentID + '\')" data-info=\'' + studentID + '\'>';
                dotsHtml = dotsHtml + '<span >Delete</span>';
                dotsHtml = dotsHtml + '</md-button>';
                dotsHtml = dotsHtml + '</md-menu-item>';
            }
            dotsHtml = dotsHtml + '</md-menu-content>';
            dotsHtml = dotsHtml + '</md-menu>';
            return dotsHtml;
        };

        vm.dtPromiseFn = function() {
            return vm.getData();

        }

        vm._reloadDtPage = function() {
            vm.dtInstance.changeData(vm.dtPromiseFn());
        };
        vm.dtPreviousCourseOptions = vm.dtCourseOptions = DTOptionsBuilder.fromFnPromise(vm.dtPromiseFn).withOption('createdRow', function(row, data, dataIndex) {
            $compile(angular.element(row).contents())($scope);

        }).withOption('headerCallback', function(header) {
            if (!vm.headerCompiled) {
                vm.headerCompiled = true;
                $compile(angular.element(header).contents())($scope);
            }
        }).withOption("responsive", true).withOption("bInfo", false).withOption("order", [1, 'asc']).withOption('courseRowCallback', courseRowCallback);

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(vm.dtPromiseFn).withOption('createdRow', function(row, data, dataIndex) {
            $compile(angular.element(row).contents())($scope);
        }).withOption('headerCallback', function(header) {
            if (!vm.headerCompiled) {
                vm.headerCompiled = true;
                $compile(angular.element(header).contents())($scope);
            }
        }).withOption("responsive", true).withOption("pageLength", 10).withOption("bInfo", false).withOption("order", []).withOption('rowCallback', rowCallback);

        function someClickHandler(info) {
            if (userInfo.role_id != 1 && userInfo.role_id != 5) {
                return;
            }
            var dialogData = info;
            Utils.showLoader(true);
            dialogData.Status = dialogData.Status == 1 ? true : false;
            dialogData.type = "edit";
            Utils.showLoader(false);
            $mdDialog.show({
                controller: 'AddStudentsDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/students/add-students/add-students-dialog.html',
                parent: angular.element($document.body),
                //                clickOutsideToClose: true,
                locals: {
                    dialogData: dialogData,
                    dtInstance: vm.dtInstance,
                    dtPromiseFn: vm.dtPromiseFn

                }
            }).then(function(response) {});
        }

        vm.filterByCourseTypeAndLevel = function() {
            vm.export = 0;
            vm.dtInstance.changeData(vm.getData());
        }
        vm.exportStudentData = function() {

            Utils.showLoader(true);
            Utils.showLoader(false);
            $mdDialog.show({
                controller: 'StudentFilterDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/students/filter/student-filter-dialog.html',
                parent: angular.element($document.body),
                //                clickOutsideToClose: true,
                locals: {
                    dialogData: {},
                    dtInstance: vm.dtInstance,
                    dtPromiseFn: vm.dtPromiseFn
                }
            }).then(function(response) {});

        }

        vm.openStudentAttendanceDialog = function(scheduleClassID, data, e) {
            var allClasses;
            var ongoinClass = vm.studentOngoingCourses;
            var previousClass = vm.studentPreviousCourses;

            if (angular.equals(ongoinClass, {})) {
                ongoinClass = [];
            }
            if (angular.equals(previousClass, {})) {
                previousClass = [];
            }
            if (typeof previousClass != 'undefined') {
                allClasses = ongoinClass.concat(previousClass);
            } else {
                allClasses = ongoinClass
            }

            var dialogData = [];
            for (var i = 0; i < allClasses.length; i++) {
                if (allClasses[i].schedule_class_id == scheduleClassID) {
                    dialogData = allClasses[i];
                }
            }
            $mdDialog.show({
                controller: 'AddStudentAttendanceController',
                controllerAs: 'vm',
                templateUrl: 'app/main/students/add-attendance/add-student-attendance.html',
                parent: angular.element($document.body),
                targetEvent: e,
                //                    clickOutsideToClose: true,
                locals: {
                    dialogData: dialogData,
                    // courseObj: courseObj,
                    attendanceObj: {},
                    dtPromiseFn: vm.dtPromiseFn

                }
            }).then(function(response) {

            });
        }

        function courseRowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {

            // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)

            $('td', nRow).unbind('click');
            if (aData.deleted == '0') {
                $('td', nRow).addClass('deleted-highlight');
            }
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    vm.someClickHandler(aData);
                });
            });
            return nRow;
        }

        function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {

            // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
            $('td', nRow).unbind('click');

            if (aData.deleted == '0') {
                $('td', nRow).addClass('deleted-highlight');
            }
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    vm.someClickHandler(aData);
                });
            });
            return nRow;
        };
        vm.dtPreviousCourseColumns = [
            DTColumnBuilder.newColumn('courseName').withTitle('Title').notSortable().renderWith(function(data, type, full, meta) {
                if (full.courseType == 'G') {
                    var courseType = 'Group';
                } else if (full.courseType == 'O') {
                    var courseType = 'Online';
                } else {
                    var courseType = 'Private';
                }
                return '<span id = "' + full.schedule_class_id + '" class="redirect_intake">' + full.courseName + ' - ' + full.courseLevel + ' - ' + full.courseSeries + ' - ' + courseType + '</span>';
            }),
            DTColumnBuilder.newColumn('start_date').withTitle('Start Date'),
            DTColumnBuilder.newColumn('end_date').withTitle('End Date'),
            DTColumnBuilder.newColumn('start_time').withTitle('Time').notSortable().renderWith(function(data, type, full, meta) {
                return full.start_time + ' - ' + full.end_time;
            }),
            DTColumnBuilder.newColumn('trainer').withTitle('Trainer').notSortable().renderWith(function(data, type, full, meta) {
                if (full.trainer == null) {
                    return '-';
                }
                return full.trainer;
            }),
            DTColumnBuilder.newColumn('hour_consumed').withTitle('Hour Consumed').notSortable().renderWith(function(data, type, full, meta) {
                var html = '';
                if(typeof full.no_of_hours_consumed != 'undefined' && typeof full.no_of_hours_balance != 'undefined'){
                    html = 'Consumed: ' + full.no_of_hours_consumed + '<br> Balance: ' + full.no_of_hours_balance;

                }
                return html;
            }),
            DTColumnBuilder.newColumn('trainer').withTitle('Certificate').notSortable().renderWith(function(data, type, full, meta) {
                if (full.isEligible == '1' && full.deleted == '0') {
                    return '<a target="_self" href=" ' + vm.setAuthDownloadLink + 'download-student-certificate?auth_token=' + vm.setAuthToken + '&schedule_class_id=' + full.schedule_class_id + '&student_id= ' + vm.studentID + '" ><md-button class="md-accent md-raised btnviolet md-hue-1 md-button_small"     aria-label="SAVE">Download</md-button></a>';

                } else {
                    return '<md-button disabled = "disabled" class="md-accent md-raised btnviolet md-hue-1 md-button_small" aria-label="SAVE">Download</md-button>';
                }
            }),
            DTColumnBuilder.newColumn('trainer').withTitle('').notSortable().renderWith(function(data, type, full, meta) {
                if (full.isEligible == '0') {
                    return '<span style="background-color:red;padding:5px;color:white; border-radius: 2px;">Incomplete</span>'
                } else {
                    return '<span style="background-color:green;padding:5px;color:white; border-radius: 2px;">Complete</span>'
                }
            }),
        ];
        vm.dtCourseColumns = [
            DTColumnBuilder.newColumn('courseName').withTitle('Title').notSortable().renderWith(function(data, type, full, meta) {
                if (full.courseType == 'G') {
                    var courseType = 'Group';
                } else if (full.courseType == 'O') {
                    var courseType = 'Online';
                } else {
                    var courseType = 'Private';
                }
                return '<span id = "' + full.schedule_class_id + '" class="redirect_intake">' + full.courseName + ' - ' + full.courseLevel + ' - ' + full.courseSeries + ' - ' + courseType + '</span>';
            }),
            DTColumnBuilder.newColumn('start_date').withTitle('Start Date'),
            DTColumnBuilder.newColumn('end_date').withTitle('End Date'),
            DTColumnBuilder.newColumn('start_time').withTitle('Time').notSortable().renderWith(function(data, type, full, meta) {
                return full.start_time + ' - ' + full.end_time;
            }),
            DTColumnBuilder.newColumn('trainer').withTitle('Trainer').notSortable().renderWith(function(data, type, full, meta) {
                if (full.trainer == null) {
                    return '-';
                }
                return full.trainer;
            }),
            DTColumnBuilder.newColumn('hour_consumed').withTitle('Hour Consumed').notSortable().renderWith(function(data, type, full, meta) {
                var html = '';
                if(typeof full.no_of_hours_consumed != 'undefined' && typeof full.no_of_hours_balance != 'undefined'){
                    html = 'Consumed: ' + full.no_of_hours_consumed + '<br> Balance: ' + full.no_of_hours_balance;

                }
                return html;
            }),
            DTColumnBuilder.newColumn('trainer').withTitle('Attendance').notSortable().renderWith(function(data, type, full, meta) {

                if (full.deleted == 0) {
                    return '<md-button  class="md-accent md-raised btnviolet md-hue-1 md-button_small g_margin-left-0" style="background-color : #6CBC7D;" ng-click="vm.openStudentAttendanceDialog(\'' + full.schedule_class_id + '\',$event);$event.stopPropagation();">' + "Attendance" + '</md-button>';
                }
                return '';

            }),
        ];
        vm.dtCourseColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).notSortable(),
            DTColumnDefBuilder.newColumnDef(1).withOption("responsivePriority", 1),
            DTColumnDefBuilder.newColumnDef(2).notSortable().withOption("responsivePriority", 2),
            DTColumnDefBuilder.newColumnDef(3).notSortable().withOption("responsivePriority", 3)
        ];
        vm.dtColumns = [
            DTColumnBuilder.newColumn('studentID').withTitle('studentID').notVisible().withClass('g-hidden'),

            DTColumnBuilder.newColumn('full_name').withTitle('Name'),
            DTColumnBuilder.newColumn('email').withTitle('Email'),
            DTColumnBuilder.newColumn('contact_number').withTitle('Contact No.').renderWith(function(data, type, full, meta) {
                if(full.contact_number == null ){
                    return '-';
                } else {
                    var contact_no = full.contact_number.replaceAll(' ', '');
                    // contact_no = contact_no.replace(/[^a-zA-Z0-9 ]/g, "");
                    // if (contact_no.length > 8) {
                    //     var code = contact_no.substring(0, 2);
                    //     if (code == 65) {
                    //         contact_no = contact_no.substring(2);
                    //     }
                    // }
                    return '<md-button  class="md-accent md-raised md-hue-1 btnred md-button_small" style = "text-transform: none;width:140px !important;" ng-click="vm.redirectToWhatsapp(\'' + contact_no + '\',\'' + full.full_name + '\', $event); $event.stopPropagation();"><img src="/assets/icons/whatsapp-icon.png" style="float:left;" ></img>' + contact_no + '</md-button>';
                }
                
            }),
            DTColumnBuilder.newColumn('currentLanguage').withTitle('Language').renderWith(function(data, type, full, meta) {
                if (full.currentLanguage) {
                    return full.currentLanguage;
                } else {
                    return "-"
                }
            }),
            DTColumnBuilder.newColumn('classSeries').withTitle('Level/Series').renderWith(function(data, type, full, meta) {
                if (data == '') {
                    return '-';
                }
                return full.classLevel + ' - ' + data;
            }),
            DTColumnBuilder.newColumn('classType').withTitle('Last Type').renderWith(function(data, type, full, meta) {
                if (full.classType) {
                    var courseTypeVal = full.classType;
                    for (var i = 0; i < vm.courseType.length; i++) {
                        if (vm.courseType[i].text == courseTypeVal) {
                            return vm.courseType[i].value;
                        }
                    }
                } else {
                    return "-"
                }
            }),
            //            DTColumnBuilder.newColumn(null).withTitle('Certificates').notSortable().renderWith(function (data, type, full, meta) {
            //                vm.arrStudents[data.studentID] = data;
            //                return '<md-button class="md-accent md-raised btnviolet md-hue-1 md-button_small g_margin-left-0" ng-click="vm.openDataDlg(\'' + full.studentID + '\',$event);$event.stopPropagation();">' + "Certificates" + '</md-button>';
            //            }),
            DTColumnBuilder.newColumn('courseStatus').withTitle('Status').notSortable().renderWith(function(data, type, full, meta) {
                if (data == 'Ongoing') {
                    return '<span style="background-color:#FF5E00;padding:5px;color:white;border-radius: 2px;">' + data + '</span>';
                } else if (data == 'Incomplete') {
                    return '<span style="background-color:red;padding:5px;color:white;border-radius: 2px;">' + data + '</span>';
                } else if (data == '') {
                    return '-';
                } else {
                    return '<span style="background-color:#2DC63A;padding:5px;color:white;border-radius: 2px;">' + data + '</span>';
                }

            }),
            DTColumnBuilder.newColumn(null).withTitle("").notSortable()
            .renderWith(function(data, type, full, meta) {
                vm.arrStudents[data.studentID] = data;
                if (userInfo.role_id == 1 || userInfo.role_id == 2) {
                    return getDotsTpl(data.studentID, data.full_name);
                } else {
                    return null;
                }
            })
        ];
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).notSortable(),
            DTColumnDefBuilder.newColumnDef(1).withOption("responsivePriority", 1),
            DTColumnDefBuilder.newColumnDef(7).notSortable().withOption("responsivePriority", 2),
            DTColumnDefBuilder.newColumnDef(8).notSortable().withOption("responsivePriority", 3),
            //            DTColumnDefBuilder.newColumnDef(9).notSortable().withOption("responsivePriority", 3)
        ];

        angular.element(document).on("click", "span.redirect_intake", function() {
            var schedule_class_id = $(this).closest('span').attr('id');
            if (typeof schedule_class_id != 'undefined') {
                // window.location = '/intake?id=' + schedule_class_id;
                window.open('/intake?id='+schedule_class_id, '_blank');
            }
        });

        vm.redirectToWhatsapp = function(contact_number,full_name, e) {
            var contact_no = contact_number.replaceAll(' ', '');
                if(contact_no[0] == '+'){
                    contact_no = contact_no.replace(/[^a-zA-Z0-9 ]/g, "");
                    var link = 'https://wa.me/' + contact_no + '?text=hi ' + full_name;
                } else {
                    contact_no = contact_no.replace(/[^a-zA-Z0-9 ]/g, "");
                    if (contact_no.length > 8) {
                        var code = contact_no.substring(0, 2);
                        if (code == 65) {
                            contact_no = contact_no.substring(2);
                        }
                    }
                    var link = 'https://wa.me/65' + contact_no + '?text=hi ' + full_name;
                }
            window.open(link, '_blank');
        }


        function getData() {

            Utils.showLoader(true);
            var defer = $q.defer();
            var requestData = {
                search: vm.search,
                classType: vm.selectedCourseType,
                classLevel: vm.selectedCourseLevel,
                export: vm.export
            };
            if (vm.searchDone == true) {
                vm.paginators.curPageIndex = 1;
            } else {
                //                vm.paginators.curPageIndex = 1;
            }
            ApiService.GetStudents({
                paginators: vm.paginators,
                data: requestData,
            }).then(function(response) {
                var data = response.data;
                vm.students = data;
                if (response && response.headerFn) {
                    vm.paginators.setTotal(response.headerFn("totalitemscount"));
                    //                    vm.allChecked = false;
                }
                defer.resolve(data);
                setTimeout(function() {
                    Utils.showLoader(false);
                }, 0)


            });
            return defer.promise;
        };

        vm.onPrevClick = function(e, pageStartIndex, pageEndIndex, totalItems) {

            vm.paginators.previous(e, pageStartIndex, pageEndIndex, totalItems);
            vm.dtInstance.changeData(vm.getData());


        }

        vm.onNextClick = function(e, pageStartIndex, pageEndIndex, totalItems) {
            vm.paginators.next(e, pageStartIndex, pageEndIndex, totalItems);
            vm.dtInstance.changeData(vm.getData());

        }
        vm.openDataDlg = function(studentID, e) {
            var dialogData = vm.arrStudents[studentID];
            var requestData = {
                student_id: dialogData.studentID,
            };
            Utils.showLoader(true);

            ApiService.getStudentIntakeCertificate({
                data: requestData
            }).then(function(response) {
                Utils.showLoader(false);
                vm.studentCourses = response.data;
                var courseObj = [];
                for (var i = 0; i < vm.studentCourses.length; i++) {
                    for (var j = 0; j < vm.courseType.length; j++) {
                        if (vm.courseType[j].text == vm.studentCourses[i].courseType) {
                            var typeName = vm.courseType[j].value;
                        }
                    }
                    courseObj.push({
                        title: vm.studentCourses[i].courseName + " " + vm.studentCourses[i].courseLevel + " " + vm.studentCourses[i].courseSeries + " " + typeName + ", " + vm.studentCourses[i].intakeID,
                        courseId: vm.studentCourses[i].courseID,
                        schedule_class_id: vm.studentCourses[i].schedule_class_id,
                        isEligible: vm.studentCourses[i].isEligible
                    })
                }
                $mdDialog.show({
                    controller: 'ShowStudentCertificateController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/students/show-certificate/show-certificate-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    locals: {
                        dialogData: dialogData,
                        courseObj: courseObj,
                        dtPromiseFn: vm.dtPromiseFn

                    }
                }).then(function(response) {

                });
            });
        }

        function reloadData() {
            if (vm.dtInstance.reloadData)
                vm.dtInstance.reloadData();
        }
        $scope.$watch("global.search", function(newValue, oldValue) {

            if (oldValue === "") {
                return;
            }
            vm.search = newValue;
            Utils.showLoader(true);
            vm.searchDone = true;
            vm.dtInstance.changeData(vm.getData());
            vm.searchDone = false;
        });

        vm.onCreateStudentTap = function(e) {
            Utils.showLoader(true);
            var dialogData = {
                "type": "add",
                "Status": true
            };
            ApiService.GetStudentId({}).then(function(response) {
                if (response.status == 1) {
                    dialogData.studentId_number = response.data;
                }
                Utils.showLoader(false);
                $mdDialog.show({
                    controller: 'AddStudentsDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/students/add-students/add-students-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    //                    clickOutsideToClose: true,
                    locals: {
                        dialogData: dialogData,
                        dtInstance: vm.dtInstance,
                        dtPromiseFn: vm.dtPromiseFn
                    }
                }).then(function(response) {

                });
            });
        };

        vm.backToStudents = function() {
            vm._bStudentListingPage = true;
            vm._bStudentDetailPage = false;
            vm._reloadDtPage();
        }
        vm.onDeleteStudentTap = function(e, studentID) {
            var deleteData = {
                "role_id": "3",
                "users": [studentID]
            }
            deleteData
            var confirm = $mdDialog.confirm()
                .title('Confirm Delete Student?')
                .textContent('Are you sure you want to delete selected Student ?')
                .ariaLabel('Delete')
                .targetEvent(e)
                .ok('Delete')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                Utils.showLoader(true);
                ApiService.DeleteUser({
                    data: deleteData,
                    success: function(response) {
                        Utils.showLoader(false);
                        if (response.status === 0) {
                            Utils.showToast({
                                text: response.data.message,
                                'type': 0
                            });
                        } else {
                            Utils.showToast({
                                text: response.data.message,
                                'type': 1
                            });
                            vm._reloadDtPage();
                        }
                    }
                });
            }, function() {});
        };

        vm.showStudentDetail = function(e, studentID) {

            vm._bStudentListingPage = false;
            vm._bStudentDetailPage = true;
            vm.studentID = studentID;
            for (var i = 0; i < vm.students.length; i++) {
                if (studentID == vm.students[i].studentID) {
                    vm.studentDetail = vm.students[i];
                    break;
                }
            }

            if (parseInt(vm.studentDetail.is_renewal) == 1) {
                vm.is_renewal = true;
            } else {
                vm.is_renewal = false;
            }

            if (vm.studentDetail.full_name == '') {
                vm.studentDetail.full_name = '-';
            }
            if (vm.studentDetail.contact_number == '') {
                vm.studentDetail.contact_number = '-';
            }
            if (vm.studentDetail.address == '') {
                vm.studentDetail.address = '-';
            }
            if (vm.studentDetail.email == '') {
                vm.studentDetail.email = '-';
            }
            if (vm.studentDetail.company_name == '') {
                vm.studentDetail.company_name = '-';
            }
            if (vm.studentDetail.company_address == '') {
                vm.studentDetail.company_address = '-';
            }

            var requestData = {
                student_id: vm.studentID
            };
            vm.ongoingTablePagination = {};
            vm.ongoingTablePagination.curPageIndex = 1;
            vm.ongoingTablePagination.pageStartIndex = 0;
            vm.ongoingTablePagination.pageEndIndex = 0;
            vm.ongoingTablePagination.totalItems = 0;
            vm.ongoingTablePagination.allowPrevious = false;
            ApiService.StudentsOngoingCourses({
                paginators: vm.ongoingTablePagination,
                data: requestData
            }).then(function(response) {
                vm.studentOngoingCourses = response.data;
                vm.ongoingTablePagination.totalItems = response.headerFn("totalitemscount");
                if (vm.ongoingTablePagination.totalItems > 0) {
                    vm.ongoingTablePagination.pageStartIndex = 1;
                    if (vm.ongoingTablePagination.totalItems <= 10) {
                        vm.ongoingTablePagination.allowNext = false;
                        vm.ongoingTablePagination.pageEndIndex = vm.ongoingTablePagination.totalItems;
                    } else {
                        vm.ongoingTablePagination.allowNext = true;
                        vm.ongoingTablePagination.pageEndIndex = 10;
                    }
                }
                vm.dtOngoingCourseInstance.changeData(vm.getPromise(response.data));
            });

            vm.previousTablePagination = {};
            vm.previousTablePagination.curPageIndex = 1;
            vm.previousTablePagination.pageStartIndex = 0;
            vm.previousTablePagination.pageEndIndex = 0;
            vm.previousTablePagination.totalItems = 0;
            vm.previousTablePagination.allowPrevious = false;
            ApiService.StudentsPreviousCourses({
                paginators: vm.previousTablePagination,
                data: requestData
            }).then(function(response) {
                vm.studentPreviousCourses = response.data;
                vm.previousTablePagination.totalItems = response.headerFn("totalitemscount");
                if (vm.previousTablePagination.totalItems > 0) {
                    vm.previousTablePagination.pageStartIndex = 1;
                    if (vm.previousTablePagination.totalItems <= 10) {
                        vm.previousTablePagination.allowNext = false;
                        vm.previousTablePagination.pageEndIndex = vm.previousTablePagination.totalItems;
                    } else {
                        vm.previousTablePagination.allowNext = true;
                        vm.previousTablePagination.pageEndIndex = 10;
                    }
                }
                vm.dtPreviousCourseInstance.changeData(vm.getPromise(response.data));
            });


        }


        vm.onOngoingCourseNextClick = function(e, pageStartIndex, pageEndIndex, totalItems) {
            vm.ongoingTablePagination.allowPrevious = true;
            vm.ongoingTablePagination.curPageIndex = vm.ongoingTablePagination.curPageIndex + 1;
            var requestData = {
                student_id: vm.studentID
            };
            ApiService.StudentsOngoingCourses({
                paginators: vm.ongoingTablePagination,
                data: requestData
            }).then(function(response) {
                Utils.showLoader(false);
                vm.studentOngoingCourses = response.data;
                vm.ongoingTablePagination.pageStartIndex = vm.ongoingTablePagination.pageStartIndex + 10;
                vm.ongoingTablePagination.pageEndIndex = vm.ongoingTablePagination.pageEndIndex + 10;
                if (vm.ongoingTablePagination.pageEndIndex > vm.ongoingTablePagination.totalItems) {
                    vm.ongoingTablePagination.pageEndIndex = vm.ongoingTablePagination.totalItems;
                    vm.ongoingTablePagination.allowNext = false;
                } else {
                    vm.ongoingTablePagination.allowNext = true;
                }
                vm.dtOngoingCourseInstance.changeData(vm.getPromise(response.data));
            });
        }
        vm.onOngoingCoursePrevClick = function(e, pageStartIndex, pageEndIndex, totalItems) {
            vm.ongoingTablePagination.allowNext = true;
            vm.ongoingTablePagination.curPageIndex = vm.ongoingTablePagination.curPageIndex - 1;
            if (vm.ongoingTablePagination.curPageIndex == 1) {
                vm.ongoingTablePagination.allowPrevious = false;
            }
            var requestData = {
                student_id: vm.studentID
            };
            ApiService.StudentsOngoingCourses({
                paginators: vm.ongoingTablePagination,
                data: requestData
            }).then(function(response) {
                Utils.showLoader(false);
                vm.studentOngoingCourses = response.data;
                vm.ongoingTablePagination.pageStartIndex = vm.ongoingTablePagination.pageStartIndex - 10;
                var mod = vm.ongoingTablePagination.pageEndIndex % 10;
                if (mod == 0) {
                    vm.ongoingTablePagination.pageEndIndex = vm.ongoingTablePagination.pageEndIndex - 10;
                } else {
                    vm.ongoingTablePagination.pageEndIndex = vm.ongoingTablePagination.pageEndIndex - mod;
                }
                vm.dtOngoingCourseInstance.changeData(vm.getPromise(response.data));
            });
        }
        vm.onPreviousCourseNextClick = function(e, pageStartIndex, pageEndIndex, totalItems) {
            vm.previousTablePagination.allowPrevious = true;
            vm.previousTablePagination.curPageIndex = vm.previousTablePagination.curPageIndex + 1;
            var requestData = {
                student_id: vm.studentID
            };
            ApiService.StudentsPreviousCourses({
                paginators: vm.previousTablePagination,
                data: requestData
            }).then(function(response) {
                Utils.showLoader(false);
                vm.studentPreviousCourses = response.data;
                vm.previousTablePagination.pageStartIndex = vm.previousTablePagination.pageStartIndex + 10;
                vm.previousTablePagination.pageEndIndex = vm.previousTablePagination.pageEndIndex + 10;
                if (vm.previousTablePagination.pageEndIndex > vm.previousTablePagination.totalItems) {
                    vm.previousTablePagination.pageEndIndex = vm.previousTablePagination.totalItems;
                    vm.previousTablePagination.allowNext = false;
                } else {
                    vm.previousTablePagination.allowNext = true;
                }
                vm.dtPreviousCourseInstance.changeData(vm.getPromise(response.data));
            });
        }
        vm.onPreviousCoursePrevClick = function(e, pageStartIndex, pageEndIndex, totalItems) {
            vm.previousTablePagination.allowNext = true;
            vm.previousTablePagination.curPageIndex = vm.previousTablePagination.curPageIndex - 1;
            if (vm.previousTablePagination.curPageIndex == 1) {
                vm.previousTablePagination.allowPrevious = false;
            }
            var requestData = {
                student_id: vm.studentID
            };
            ApiService.StudentsPreviousCourses({
                paginators: vm.previousTablePagination,
                data: requestData
            }).then(function(response) {
                Utils.showLoader(false);
                vm.studentPreviousCourses = response.data;
                vm.previousTablePagination.pageStartIndex = vm.previousTablePagination.pageStartIndex - 10;
                var mod = vm.previousTablePagination.pageEndIndex % 10;
                if (mod == 0) {
                    vm.previousTablePagination.pageEndIndex = vm.previousTablePagination.pageEndIndex - 10;
                } else {
                    vm.previousTablePagination.pageEndIndex = vm.previousTablePagination.pageEndIndex - mod;
                }


                vm.dtPreviousCourseInstance.changeData(vm.getPromise(response.data));
            });
        }

        vm.onEditStudentTap = function(e, studentID) {

            var dialogData = vm.arrStudents[studentID];
            dialogData.Status = dialogData.Status == 1 ? true : false;
            dialogData.type = "edit";
            $mdDialog.show({
                controller: 'AddStudentsDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/students/add-students/add-students-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: true,
                locals: {
                    dialogData: dialogData,
                    dtInstance: vm.dtInstance,
                    dtPromiseFn: vm.dtPromiseFn

                }
            }).then(function(response) {
                vm.studentID = response.studentID;
            });
        };



        vm.handleFiles = function(files) {
            // Check for the various File API support.
            if (window.FileReader) {
                // FileReader are supported.
                getAsText(files[0]);
            } else {
                alert('FileReader are not supported in this browser.');
            }
        };

        function getAsText(fileToRead) {
            var reader = new FileReader();
            // Read file into memory as UTF-8      
            reader.readAsText(fileToRead);
            // Handle errors load
            reader.onload = loadHandler;
            reader.onerror = errorHandler;
        }

        function loadHandler(event) {
            var csv = event.target.result;
            processData(csv);
        }

        function processData(csv) {
            var allTextLines = csv.split(/\r\n|\n/);
            var lines = [];
            for (var i = 0; i < allTextLines.length; i++) {
                var data = allTextLines[i].split(';');
                var tarr = [];
                for (var j = 0; j < data.length; j++) {
                    tarr.push(data[j]);
                }
                lines.push(tarr);
            }
            Utils.showLoader(true);
            ApiService.SendStudentCSV({
                data: {
                    dataToImport: 'data:text/csv;charset=utf-8;base64,' + btoa(unescape(encodeURIComponent(csv)))
                },
                success: function(response) {
                    Utils.showLoader(false);
                    if (response.status == 0) {
                        Utils.showToast({
                            text: response.data.message
                        });
                    } else {
                        var dialogData = {};
                        dialogData.errors = response.data.message.errors;
                        dialogData.messages = response.data.message.messages;
                        $mdDialog.show({
                            controller: 'showLogsController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/students/add-students/show-log-student-dialog.html',
                            parent: angular.element($document.body),
                            //                            clickOutsideToClose: true,
                            locals: {
                                dialogData: angular.copy(dialogData),
                                dtInstance: vm.dtInstance,
                                dtPromiseFn: vm.dtPromiseFn

                            }
                        }).then(function(response) {});
                        //                        Utils.showToast({text: response.data.message});
                        vm._reloadDtPage();
                    }
                }
            });
        }

        function errorHandler(evt) {
            if (evt.target.error.name == "NotReadableError") {
                alert("Canno't read file !");
            }
        }

        function loadDiscrepancyData(response) {
            if (vm.dtOngoingCourseInstance && vm.dtOngoingCourseInstance.reloadData === undefined && vm.dtPreviousCourseInstance && vm.dtPreviousCourseInstance.reloadData === undefined) {
                vm.dtPreviousCourseOptions = vm.dtCourseOptions = DTOptionsBuilder.fromFnPromise(vm.getPromise({})).
                withOption('createdRow', function(row, data, dataIndex) {
                    if (data.deleted == '1') {
                        $('td', row).addClass('deleted-highlight');
                    }
                    $compile(angular.element(row).contents())($scope);
                }).withOption('headerCallback', function(header) {
                    if (!vm.headerCompiled) {
                        vm.headerCompiled = true;
                        $compile(angular.element(header).contents())($scope);
                    }
                }).withOption("responsive", true).withOption("pageLength", 50).withOption("bInfo", false).withOption("order", []);
            }
        }
        loadDiscrepancyData();

        function showStudentDetailView() {
            // var student_url = location.href;
            // var a = student_url.indexOf("?");
            // if (a != "-1") {

            //     vm.getData();
            //     setTimeout(function(){ 
            //         var res = student_url.split("=");
            //     vm.studentID = res[1];
            //     vm.showStudentDetail([],vm.studentID);
            //      }, 4000);
                
                
            // }
            if (typeof $rootScope.$root.studentID != 'undefined') {
                vm.studentID = $rootScope.$root.studentID;
                vm.students = $rootScope.$root.students;
                delete $rootScope.$root.studentID;
                vm.showStudentDetail([],vm.studentID);
            }

        }showStudentDetailView();

        function getPromise(data) {
            var dfd = $q.defer();
            if (data.length != 0) {
                dfd.resolve(data);
            } else {
                dfd.resolve({});
            }
            return dfd.promise;
        }


        // Methods

        //////////
    }
})();


app.directive('customOnChange', function() {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            var onChangeHandler = scope.$eval(attrs.customOnChange);
            element.bind('change', onChangeHandler);
        }
    };
});
(function()
{
    'use strict';

    angular
            .module('app.skills')
            .controller('SkillsController', SkillsController);

    /** @ngInject */
    function SkillsController(api, GlobalPool, usSpinnerService, ApiService, $http, $mdToast, $mdDialog, $document, $compile, $scope, $q, $resource, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, Utils)
    {
        var vm = this;
        vm.arrSkills = {};
        vm.dtInstance = {};
        vm.getData = getData;
        vm.reloadData = reloadData;
        vm.search = "";
        vm.someClickHandler = someClickHandler;
        var userInfo = GlobalPool.getUserInfo();
        // Paginators
//        $(function() {
//            $('.ms-search-bar #ms-search-bar-collapser').click(function() {
//                if ($('#ms-search-bar-input').val().length > 0) {
//                    $('#ms-search-bar-input').val('');
//                    $scope.global.search = '';
//                    Utils.showLoader(true);
//                }
//            });
//        });
        $scope.$on("changeSearch", function(event, args) {
            vm.searchDone = true;
            vm.dtInstance.changeData(vm.getData());
            vm.searchDone = false;
        }
        );
        vm.paginators = new Paginator();


        var getDotsTpl = function(skillID, name) {
            var dotsHtml = "";
            dotsHtml = dotsHtml + '<md-menu>';
            dotsHtml = dotsHtml + ' <md-button aria-label="More" class="md-icon-button" ng-click="$mdOpenMenu($event)" translate >';
            dotsHtml = dotsHtml + ' <md-icon md-font-icon="icon-dots-vertical"></md-icon>';
            dotsHtml = dotsHtml + '<md-tooltip><span >More</span></md-tooltip>';
            dotsHtml = dotsHtml + '</md-button>';
            dotsHtml = dotsHtml + '<md-menu-content width="3">';
            dotsHtml = dotsHtml + '<md-menu-item>';
            dotsHtml = dotsHtml + '<md-button aria-label="Edit" ng-click="vm.onEditSkillTap($event,\'' + skillID + '\')" data-info=\'' + skillID + '\'>';
            dotsHtml = dotsHtml + '<span>Edit</span>';
            dotsHtml = dotsHtml + '</md-button>';
            dotsHtml = dotsHtml + '</md-menu-item>';
            dotsHtml = dotsHtml + '<md-menu-item>';

            dotsHtml = dotsHtml + '<md-button aria-label="Delete"  ng-click="vm.onDeleteSkillTap($event,\'' + skillID + '\',\'' + name + '\')" data-info=\'' + skillID + '\'>';
            dotsHtml = dotsHtml + '<span >Delete</span>';
            dotsHtml = dotsHtml + '</md-button>';
            dotsHtml = dotsHtml + '</md-menu-item>';
            dotsHtml = dotsHtml + '</md-menu-content>';
            dotsHtml = dotsHtml + '</md-menu>';
            return dotsHtml;
        };

        vm.dtPromiseFn = function() {
            return vm.getData();

        }

        vm._reloadDtPage = function() {
            vm.dtInstance.changeData(vm.dtPromiseFn());
        };
        vm.dtOptions = DTOptionsBuilder.fromFnPromise(vm.dtPromiseFn).withOption('createdRow', function(row, data, dataIndex) {
            $compile(angular.element(row).contents())($scope);
        }).withOption('headerCallback', function(header) {
            if (!vm.headerCompiled) {
                vm.headerCompiled = true;
                $compile(angular.element(header).contents())($scope);
            }
        }).withOption("responsive", true).withOption("bInfo", false).withOption("order", [1, 'asc']).withOption('rowCallback', rowCallback);
        ;
        function someClickHandler(info) {

            var dialogData = info;
            Utils.showLoader(true);
            var dialogData = info;
            dialogData.type = "edit";
            Utils.showLoader(false);
            $mdDialog.show({
                controller: 'AddSkillsDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/skills/add-skills/add-skills-dialog.html',
                parent: angular.element($document.body),
//                clickOutsideToClose: true,
                locals: {
                    dialogData: dialogData,
                    dtInstance: vm.dtInstance,
                    dtPromiseFn: vm.dtPromiseFn

                }
            }).then(function(response)
            {
            });
        }
        function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    vm.someClickHandler(aData);
                });
            });
            return nRow;
        }
        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('id').notVisible().withClass('g-hidden'),
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle("").notSortable()
                    .renderWith(function(data, type, full, meta) {
                        vm.arrSkills[data.id] = data;
                        return getDotsTpl(data.id, data.name);
                    })
        ];
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).notSortable(),
            DTColumnDefBuilder.newColumnDef(1).withOption("responsivePriority", 1),
            DTColumnDefBuilder.newColumnDef(2).notSortable().withOption("responsivePriority", 2)
        ];
        function getData() {
            Utils.showLoader(true);
            var defer = $q.defer();
            var requestData = {
                search: vm.search
            };
            if (vm.searchDone == true) {
                vm.paginators.curPageIndex = 1;
            }
            else {

            }
            ApiService.GetSkills({paginators: vm.paginators, data: requestData}).then(function(response) {
                var data = response.data;
                if (response && response.headerFn) {
                    vm.paginators.setTotal(response.headerFn("totalitemscount"));
                }
                defer.resolve(data);
                setTimeout(function() {
                    Utils.showLoader(false);
                }, 0);
            });
            return defer.promise;
        }
        vm.onPrevClick = function(e, pageStartIndex, pageEndIndex, totalItems) {
            vm.paginators.previous(e, pageStartIndex, pageEndIndex, totalItems);
//            vm.reloadData();
            vm.dtInstance.changeData(vm.getData());
        }

        vm.onNextClick = function(e, pageStartIndex, pageEndIndex, totalItems) {
            vm.paginators.next(e, pageStartIndex, pageEndIndex, totalItems);
//            vm.reloadData();
            vm.dtInstance.changeData(vm.getData());
        }
        function reloadData() {
            if (vm.dtInstance.reloadData)
                vm.dtInstance.reloadData();
        }
//        vm._reloadDtPage = function() {
//            vm.dtInstance.reloadData();
//        };

        $scope.$watch("global.search", function(newValue, oldValue) {

            if (oldValue === "") {
                return;
            }
//            else if(newValue === "" ) {
//                getData();
//            }
//            else {
            vm.search = newValue;
//                var searchData = {
//                    'search': newValue
//                };
            Utils.showLoader(true);
            vm.searchDone = true;
            vm.dtInstance.changeData(vm.getData());
            vm.searchDone = false;
//                vm.paginators.curPageIndex = 1
//            ApiService.GetSkills({paginators: vm.paginators,
//                data: searchData,
//                dtInstance: vm.dtInstance,
//                success: function(response) {
//                    response
//                    if (response.status == 0) {
//                        Utils.showLoader(false);
//                        Utils.showToast({text: response.data.message});
//                    }
//                    else {
////                        var oTable = $('#skill').dataTable();
////                        oTable.fnClearTable();
////                        oTable.fnAddData(response.data);
//                        if (response && response.headerFn) {
//                            vm.paginators.setTotal(response.headerFn("totalitemscount"));
////                    vm.allChecked = false;
//                        }
////                        vm.dtInstance.changeData(response.data);
//                        Utils.showLoader(false);
//                    }
//                }
//            });
        });
//        });

        vm.onCreateSkillTap = function(e) {
            Utils.showLoader(true);
            var dialogData = {
                "type": "add",
            };
            Utils.showLoader(false);
            $mdDialog.show({
                controller: 'AddSkillsDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/skills/add-skills/add-skills-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
//                clickOutsideToClose: true,
                locals: {
                    dialogData: dialogData,
                    dtInstance: vm.dtInstance,
                    dtPromiseFn: vm.dtPromiseFn
                }
            }).then(function(response)
            {

            });
        };
        vm.onDeleteSkillTap = function(e, skillID, name) {
            var deleteData = {
                "skills": [skillID]
            }
            var confirm = $mdDialog.confirm()
                    .title('Confirm Delete Skill?')
                    .textContent('Are you sure you want to delete selected Skill ?')
                    .ariaLabel('Delete')
                    .targetEvent(e)
                    .ok('Delete')
                    .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                Utils.showLoader(true);
                ApiService.DeleteSkill({
                    data: deleteData,
                    success: function(response) {
                        Utils.showLoader(false);
                        if (response.status === 0) {
                            Utils.showToast({text: response.data.message, 'type': 0});
                        }
                        else {
                            Utils.showToast({text: response.data.message, 'type': 1});
                            vm._reloadDtPage();
                        }
                    }
                });
            }, function() {
            });
        };

        vm.onEditSkillTap = function(e, skillID) {
            var dialogData = vm.arrSkills[skillID];
            dialogData.type = "edit";
            $mdDialog.show({
                controller: 'AddSkillsDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/skills/add-skills/add-skills-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
//                clickOutsideToClose: true,
                locals: {
                    dialogData: dialogData,
                    dtInstance: vm.dtInstance,
                    dtPromiseFn: vm.dtPromiseFn

                }
            }).then(function(response)
            {
            });
        };


        // Methods

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.sidenav', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // Navigation

        var _onAuthDataLoaded = function (event, data) {
            $.each(data.data, function (index, value) {
                var weight = value.weight;
                var iconIndex = value.weight - 1;
                var hypenatedParentTitle = value.title.toLowerCase();
                if (hypenatedParentTitle == 'dashboard') {
                    msNavigationServiceProvider.saveItem(hypenatedParentTitle, {
                        title: value.title,
                        icon: Focus.ICONS[index]['icon'],
                        state: 'app.' + hypenatedParentTitle,
                        weight: weight
                    });
                } else {
                    msNavigationServiceProvider.saveItem(hypenatedParentTitle, {
                        title: value.title,
                        icon: Focus.ICONS[iconIndex]['icon'],
                        state: 'app.' + hypenatedParentTitle,
                        weight: weight  
                    });
                    
                }

            })

        };
        $(document).on('AuthDataLoaded', _onAuthDataLoaded);

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.sidenav')
        .controller('SidenavController', SidenavController);

    /** @ngInject */
    function SidenavController(SidenavData, $http)
    {
        var vm = this;
    }
})();

(function()
{
    'use strict';
    angular
            .module('app.show_attendance', [])
            .config(config);
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.show_attendance', {
            url: '/show-attendance',

            views: {
                'content@app': {
                    templateUrl: 'app/main/show-attendance/show-attendance.html',
                    controller: 'ShowAttedanceController as vm'
                },
                'toolbar@app': {
                    templateUrl: 'app/toolbar/layouts/mark-attendance/toolbar.html',
                    controller: 'ToolbarController as vm'
                },
                'navigation@app': {
                    templateUrl: 'app/navigation/layouts/show-attendance/navigation.html',
                    controller: 'NavigationController as vm'
                },
            },
            bodyClass: 'reset-password'
        });
    }
})();

//                                views: {
//                                'main@': {
//                                templateUrl: 'app/core/layouts/content-only.html',
//                                        controller: 'MainController as vm'
//                                },
//                                        'content@app.attendance_mark': {
//                                        templateUrl: 'app/main/mark-attendance/mark-attendance.html',
//                                                controller: 'MarkAttedanceController as vm'
//                                        }
//                                },
(function () {
    'use strict';

    angular.module('app.show_attendance')
            .controller('ShowAttedanceController', ShowAttedanceController);
    /** @ngInject */
    function ShowAttedanceController(api, usSpinnerService, ApiService, $http, $location, $mdToast, $rootScope, $mdDialog, $document, $compile, $scope, $q, $resource, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, Utils) {

        var vm = this;
        vm.closeDialog = closeDialog;
        vm.btnDisable = false;

        var param = $location.search();
        if (param.intakeID) {
            //            Utils.showLoader(true);
            var id = param.intakeID;
            //            var id = "C-GB-21072016-01"
            var requestData = {
                intakeID: id
            };

            ApiService.ShowCourseAttendance({
                data: requestData
            }).then(function (response) {
                if (response.status == 0) {
                    vm.btnDisable = true;
                    //                    Utils.showLoader(false);
                    if (response.data.message) {
                        Utils.showToast({
                            text: response.data.message,
                            'type': 0
                        });
                    }

                } else {
                    
                    Utils.showLoader(false);
                    vm.data = response.data;
                    var type = "";
                    if(vm.data.type == 'G'){
                        type = 'Group';
                    }else{
                        type = 'Private';
                    }
                    $rootScope.teacher_name = vm.data.teacher_name;
                    $rootScope.course_name = vm.data.title;
                    $rootScope.intakeID = vm.data.intake_id;
                    $rootScope.schedule_date = vm.data.start_date + '-' + vm.data.end_date;
                    $rootScope.full_course_name = vm.data.title + '-' + vm.data.level + '-' + type;
                    $rootScope.class_start_date = '';
                    $rootScope.duration = vm.data.class_duration + ' Hour';
                    $rootScope.start_time = vm.data.start_time;
                    $rootScope.room = vm.data.room_name;
                    vm.attendanceObj = [];
                    vm.btnDisable = true;
                    
                    for(var i=0;i<vm.data.students.length;i++){
                        if(vm.data.students[i].is_renewal == '1'){
                           vm.data.students[i].bAllow = true; 
                        }else{
                            vm.btnDisable = false;
                            vm.data.students[i].bAllow = false;
                        }
                    }

                }
            });

        }
        // Paginators
        vm.ToggleCheckbox = function (e, value) {
            var arrAttendance = vm.attendanceObj;

        }

        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(dtPromiseFn());

        };

        function closeDialog() {
            $mdDialog.cancel();
        }


        vm.onSaveAttendanceTap = function (e) {
            var studentsObj = [];
//            for (var i = 0; i < vm.data.students.length; i++) {
//                if (vm.data.students[i].bAllow == true) {  
//                    studentsObj.push(vm.data.students[i]);
//                }
//            }
            var requestData = {
                'course_name' : $rootScope.full_course_name,
                "schedule_class_id": vm.data.schedule_class_id,
                "schedule_date": $rootScope.schedule_date,
                "teacher_name": $rootScope.teacher_name,
                "intakeId": $rootScope.intakeId,
                "students": vm.data.students
            }
            ApiService.SendRenewCourseMail({
                data: requestData,
                success: function (response) {
                    if (response.status == 0) {
                        Utils.showLoader(false);

                        Utils.showToast({
                            text: response.data.message,
                            'type': 0
                        });
                    } else {
                        Utils.showLoader(false);
                        Utils.showToast({
                            text: response.data.message,
                            'type': 1
                        });
                    }
                }
            });
        }

    }
})();

(function ()
{
    'use strict';
    angular
            .module('app.schools')
            .controller('SchoolController', SchoolController);
    /** @ngInject */
    function SchoolController(api, usSpinnerService, ApiService, $http, $mdToast, $mdDialog, $document, $compile, $scope, $q, $resource, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, Utils)
    {
        var vm = this;
        vm.arrSchools = {};
        vm.dtInstance = {};
        vm.getData = getData;
        vm.reloadData = reloadData;
        vm.setAuthUrlLink = api.baseURI;
        vm.search = "";
        vm.someClickHandler = someClickHandler;
        // Paginators

//        $(function() {
//            $('.ms-search-bar #ms-search-bar-collapser').click(function() {
//                if ($('#ms-search-bar-input').val().length > 0) {
//                    $('#ms-search-bar-input').val('');
//                    $scope.global.search = '';
//                    $scope.$broadcast("changeSearch", {"vm.search": ''})
//                    
//                }
//            });
//        });
        vm.paginators = new Paginator();
        vm.dtPromiseFn = function () {
            return vm.getData();
        }
        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(vm.dtPromiseFn());
        };
        var getDotsTpl = function (schoolID, name) {

            var dotsHtml = "";
            dotsHtml = dotsHtml + '<md-menu>';
            dotsHtml = dotsHtml + ' <md-button aria-label="More" class="md-icon-button" ng-click="$mdOpenMenu($event)" translate >';
            dotsHtml = dotsHtml + ' <md-icon md-font-icon="icon-dots-vertical"></md-icon>';
            dotsHtml = dotsHtml + '<md-tooltip><span >More</span></md-tooltip>';
            dotsHtml = dotsHtml + '</md-button>';
            dotsHtml = dotsHtml + '<md-menu-content width="3">';
            dotsHtml = dotsHtml + '<md-menu-item>';
            dotsHtml = dotsHtml + '<md-button aria-label="Edit" ng-click="vm.onEditSchoolTap($event,\'' + schoolID + '\')" data-info=\'' + schoolID + '\'>';
            dotsHtml = dotsHtml + '<span>Edit</span>';
            dotsHtml = dotsHtml + '</md-button>';
            dotsHtml = dotsHtml + '</md-menu-item>';
            dotsHtml = dotsHtml + '<md-menu-item>';
            dotsHtml = dotsHtml + '<md-button aria-label="Delete"  ng-click="vm.onDeleteSchoolTap($event,\'' + schoolID + '\',\'' + name + '\')" data-info=\'' + schoolID + '\'>';
            dotsHtml = dotsHtml + '<span >Delete</span>';
            dotsHtml = dotsHtml + '</md-button>';
            dotsHtml = dotsHtml + '</md-menu-item>';
            dotsHtml = dotsHtml + '</md-menu-content>';
            dotsHtml = dotsHtml + '</md-menu>';
            return dotsHtml;
        };
        vm.dtOptions = DTOptionsBuilder.fromFnPromise(vm.dtPromiseFn).withOption('createdRow', function (row, data, dataIndex) {
            $compile(angular.element(row).contents())($scope);
        }).withOption('headerCallback', function (header) {
            if (!vm.headerCompiled) {
                vm.headerCompiled = true;
                $compile(angular.element(header).contents())($scope);
            }
        }).withOption("responsive", true).withOption("bInfo", false).withOption("order", []).withOption('rowCallback', rowCallback);
        function someClickHandler(info) {

            var dialogData = info;
            Utils.showLoader(true);
            dialogData.Status = dialogData.Status == 1 ? true : false;
            dialogData.type = "edit";

            Utils.showLoader(false);
            $mdDialog.show({
                controller: 'AddSchoolsDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/schools/add-schools/add-schools-dialog.html',
                parent: angular.element($document.body),
//                clickOutsideToClose: true,
                locals: {
                    dialogData: dialogData,
                    dtInstance: vm.dtInstance,
                    dtPromiseFn: vm.dtPromiseFn

                }
            }).then(function (response)
            {
            });
        }
        function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function () {
                $scope.$apply(function () {
                    vm.someClickHandler(aData);
                });
            });
            return nRow;
        }
        ;
        vm.dtColumns = [
            //DTColumnBuilder.newColumn('id').withTitle('ID'),
            DTColumnBuilder.newColumn('logo').withTitle('Logo').renderWith(function(data, type, full, meta) {
                 
                    if(data != null)
                    {
                        var roomcap = '<img src="'+ vm.setAuthUrlLink + data +'" alt=image not found style="width : 130px; height : 70px;" />';
                        return roomcap;    
                    }
                    else
                    {
                        return "<div style=text-align:center;>-</div>";
                    }
                    
                    
                  

            }),
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn('address').withTitle('Address'),

            DTColumnBuilder.newColumn(null).withTitle("").notSortable()
                    .renderWith(function (data, type, full, meta) {
                        vm.arrSchools[data.id] = data;
                        return getDotsTpl(data.id, data.name);
                    })
        ];

        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).withOption("responsivePriority", 1),
            DTColumnDefBuilder.newColumnDef(2).notSortable().withOption("responsivePriority", 2)
        ];
        function getData() {
            Utils.showLoader(true);
            var defer = $q.defer();
            var requestData = {
                search: vm.search
            };
            if (vm.searchDone == true) {
                vm.paginators.curPageIndex = 1;
            } else {

            }
            ApiService.GetSchool({paginators: vm.paginators, data: requestData}).then(function (response) {
                var data = response.data;
                if (response && response.headerFn) {
                    vm.paginators.setTotal(response.headerFn("totalitemscount"));
                }
                defer.resolve(data);
                setTimeout(function () {
                    Utils.showLoader(false);
                }, 0)
            });
            return defer.promise;
        }



        vm.onPrevClick = function (e, pageStartIndex, pageEndIndex, totalItems) {
            vm.paginators.previous(e, pageStartIndex, pageEndIndex, totalItems);
            vm.dtInstance.changeData(vm.getData());
        }

        vm.onNextClick = function (e, pageStartIndex, pageEndIndex, totalItems) {
            vm.paginators.next(e, pageStartIndex, pageEndIndex, totalItems);
            vm.dtInstance.changeData(vm.getData());
        }
        $scope.$watch("global.search", function (newValue, oldValue) {

            if (oldValue === "") {
                return;
            }
            vm.search = newValue;
            Utils.showLoader(true);
            vm.searchDone = true;
            vm.dtInstance.changeData(vm.getData());
            vm.searchDone = false;
        });

//                        $scope.$watch("global.search", function(newValue, oldValue) {
//                        if (newValue != oldValue) {
//                        $scope.$broadcast("changeSearch", {vm.search:newValue})
//                        }
//
//                        });
        $scope.$on("changeSearch", function (event, args) {
            vm.searchDone = true;
            vm.dtInstance.changeData(vm.getData());
            vm.searchDone = false;
        }
        );
        function reloadData() {
            if (vm.dtInstance.reloadData)
                vm.dtInstance.reloadData();
        }

        vm.onCreateSchoolTap = function (e) {
            Utils.showLoader(true);
            var dialogData = {
                "type": "add",
                "Status": true
            };
            Utils.showLoader(false);
            $mdDialog.show({
                controller: 'AddSchoolsDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/schools/add-schools/add-schools-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
//                clickOutsideToClose: true,
                locals: {
                    dialogData: dialogData,
                    dtInstance: vm.dtInstance,
                    dtPromiseFn: vm.dtPromiseFn
                }
            }).then(function (response)
            {

            });
        };
        /*
         vm.onDeleteSchoolTap = function(e, schoolID, name) {
         var checkData = {
         "schoolID": schoolID
         }
         
         ApiService.checkSchoolDeletable({
         data: checkData,
         success: function(response) {
         if (response.status == 0) {
         Utils.showToast({text: response.data.message, 'type': 0});
         }
         else {
         var deleteData = {
         "schools": [schoolID] // rooms schools
         }
         var confirm = $mdDialog.confirm()
         .title('Confirm Delete School?')
         .textContent('Are you sure you want to delete selected School ?')
         .ariaLabel('Delete')
         .targetEvent(e)
         .ok('Delete')
         .cancel('Cancel');
         $mdDialog.show(confirm).then(function() {
         Utils.showLoader(true);
         ApiService.DeleteSchool({
         data: deleteData,
         success: function(response) {
         Utils.showLoader(false);
         if (response.status === 0) {
         Utils.showToast({text: response.data.message, 'type': 0});
         } else {
         
         Utils.showToast({text: response.data.message, 'type': 1});
         vm._reloadDtPage();
         }
         }
         });
         }, function() {
         });
         }
         }
         })
         };
         */

        vm.onDeleteSchoolTap = function (e, schoolID, name) {
            var deleteData = {
                "schools": [schoolID]
            }
            var confirm = $mdDialog.confirm()
                    .title('Confirm Delete School?')
                    .textContent('Are you sure you want to delete selected School ?')
                    .ariaLabel('Delete')
                    .targetEvent(e)
                    .ok('Delete')
                    .cancel('Cancel');
            $mdDialog.show(confirm).then(function () {
                Utils.showLoader(true);
                ApiService.DeleteSchool({
                    data: deleteData,
                    success: function (response) {
                        Utils.showLoader(false);
                        if (response.status === 0) {
                            Utils.showToast({text: response.data.message, 'type': 0});
                        } else {
                            Utils.showToast({text: response.data.message, 'type': 1});
                            vm._reloadDtPage();
                        }
                    }
                });
            }, function () {
            });
        };

        vm.onEditSchoolTap = function (e, schoolID) {

            var dialogData = vm.arrSchools[schoolID];

            dialogData.Status = dialogData.Status == 1 ? true : false;
            dialogData.type = "edit";
            $mdDialog.show({
                controller: 'AddSchoolsDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/schools/add-schools/add-schools-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
//                clickOutsideToClose: true,
                locals: {
                    dialogData: dialogData,
                    dtInstance: vm.dtInstance,
                    dtPromiseFn: vm.dtPromiseFn
                }
            }).then(function (response)
            {
            });
        };
        // Methods
        


    }


})();







(function ()
{
    'use strict';

    angular
            .module('app.schedule')
            .controller('ScheduleController', ScheduleController);

    /** @ngInject */
    function ScheduleController(api, ApiService, $http, $mdToast, $mdDialog, $document, $compile, $scope, $state, $q, $resource, Utils, GlobalPool)
    {
        var vm = this;
        vm.CRoom = null;
        vm.CType = null;
        vm.search = '';
        var _monthlyScheduler;
        var _weeklyScheduler;
        vm.setView = false;
        var userInfo = GlobalPool.getUserInfo();
        vm.setAuthToken = userInfo.auth_token;
        vm.setAuthDownloadLink = api.baseURI;
        vm.courseType = Focus.ENUMS.COURSE_FILTERTYPE;
        vm.exportDisable = false;
        Focus.ICONS = [{icon: "icon-Books"},
            {icon: "icon-Books"},
            {icon: "icon-Books"}];
        console.log(Focus.ICONS);
        if (userInfo.role_id == 1 || userInfo.role_id == 4) {
            vm.setView = true;
        }
        vm.scheduleType = Focus.ENUMS.SCHEDULE_RECURRANCE,
                ApiService.GetRoom({}).then(function (response) {
            if (response.data.length > 0) {
                vm.room = response.data;
            }
        });

        vm._onFilterChanged = function (val) {
//            Utils.showLoader(true);
            vm.changeFilter = true;
            var requestData = {
                room: vm.CRoom,
                filterType: vm.CType
            };
            _monthlyScheduler.updateFilters({data: requestData});
            _weeklyScheduler.updateFilters({data: requestData});
            _monthlyScheduler.isFiltered(true);
            _weeklyScheduler.isFiltered(true);
            vm.changeFilter = false;
        };

        vm.onClearFiltersTap = function () {
//            Utils.showLoader(true);
            vm.CRoom = null;
            vm.CType = null;
            var requestData = {
                room: vm.CRoom,
                filterType: vm.CType
            };
            _monthlyScheduler.updateFilters({data: requestData});
            _weeklyScheduler.updateFilters({data: requestData});
            _monthlyScheduler.isFiltered(true);
            _weeklyScheduler.isFiltered(true);

        }
        vm.onCreateAdHocTap = function (e) {
            Utils.showLoader(true);
            ApiService.GetStudents({}).then(function (response) {
                var student = response.data;
                var studentobj = [];
                for (var i = 0; i < student.length; i++) {
                    studentobj.push({id: student[i].studentID, text: student[i].email + " (" + student[i].full_name + " )"});
//                 studentobj.push(student[i]);
                }
                var dialogData = {
                    "Type": "add",
                    "Status": true,
                };

                Utils.showLoader(false);
                $mdDialog.show({
                    controller: 'AddScheduleDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/schedule/add-schedule/add-schedule-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    clickOutsideToClose: true,
                    locals: {
                        dialogData: dialogData,
                        dtInstance: vm.dtInstance,
                        studentsobj: studentobj,
                        updateScheduler: updateScheduler
                    }
                }).then(function (response)
                {

                });
            });


        };

        vm.onCreateAdHocTapDescription = function (e) {
            Utils.showLoader(false);
            if (userInfo.role_id != 2) {
                var scheduleclassid = {
                    'intake': e.scheduleClassID
                }
                var dialogData = e;
                for (var j = 0; j < vm.courseType.length; j++) {
                    if (vm.courseType[j].text == dialogData.courseType) {
                        var typeName = vm.courseType[j].value;
                    }
                }
                dialogData.dlgName = dialogData.courseName + " - " + dialogData.courseLevel + " - " + dialogData.courseSeries + " - " + typeName;
                Utils.showLoader(false);
                $mdDialog.show({
                    controller: 'ShowDescriptionController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/schedule/show-description/show-description-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    clickOutsideToClose: true,
                    locals: {
                        dialogData: dialogData,
                        dtPromiseFn: vm.dtPromiseFn,
                        curView: _curView,
                        updateScheduler: updateScheduler,
                    }
                }).then(function (response)
                {
                    updateScheduler();
                });
//            }).then(function (response) {
//            });
            }
        };
        $scope.$on("changeSearch", function (event, args) {
            vm.searchDone = true;
            updateScheduler();
            vm.searchDone = false;
        }
        );
        $scope.$watch("global.search", function (newValue, oldValue) {
            if (oldValue === "") {
                return;
            }
            vm.search = newValue;
//            Utils.showLoader(true);
            _monthlyScheduler.updateOptions({search: vm.search});
            _weeklyScheduler.updateOptions({search: vm.search});
            _weeklyScheduler.issearchDone(true);
            _monthlyScheduler.issearchDone(true);
//            Utils.showLoader(false);

//            $scope.searchValue = vm.search;

            vm.searchDone = true;
//            updateScheduler();
//            initScheduler();

            vm.searchDone = false;

        });
        vm.onClickExport = function () {
            var a = $state.href('state-name', {auth_token: userInfo.auth_token});
            a;

            return $state.href('state-name', {auth_token: userInfo.auth_token});
//            ApiService.exportData({}).then(function(response) {
//            }).then(function(response) {
//            });
        }
//        vm.onClickExport = '/export' ;
//        $scope.csv_link = '/export' ;

        var _curView = null;
        window.customLangModule = {
            "collection": {
                "lastCheckIn": "Last Check in",
                "notCheckedIn": "Not Checked in",
                "on": "on"
            }
        };


        var initScheduler = function () {
            $(".switch__item").on("click", function (e) {
                _curView.hideOverflowPopup();
                var jTarget = $(e.target);
                $(".scheduler__item").addClass("g-hidden");
                $(".switch__item").removeClass("active");
                jTarget.addClass("active");

                if (jTarget.data("target-el") == "#weekly") {
                    _curView = _weeklyScheduler;
                } else {
                    _curView = _monthlyScheduler;
                }


                _curView.el.addClass("g-transparent");
                $(jTarget.data("target-el")).removeClass("g-hidden");
                $.__queue.add(_updateEnableCurView, this);
            });

            var role = 1;
            var allowEdit = (role != 3 ? true : false);
            _monthlyScheduler = new window.Scheduler({
                el: $("#monthly__wrapper"),
                containerEl: $("#monthly"),
                type: Scheduler.TYPES.MONTHLY,
                allowEditing: allowEdit,
                accessLevel: role,
                auth_token: GlobalPool.getUserInfo(),
                search: vm.search,
                Utils: Utils,
                scheduleData: {
                    data: vm.monthlyData,
                    year: new Date().getFullYear(),
                    // arrUsers: window.usersData
                },
                events: {
                    "task_selected": $.proxy(function () {
                    }, this),
                    "task_deselected": $.proxy(function () {
                    }, this),
                    "edit_task": $.proxy(function (data) {
                        var courseType = data.intakeType.toString();
                        var taskID = data.id.toString();
                        var intakeid = data.intakeID.toString();
                        var scheduleDate = new Date(data.date.toString());
                        var currentDate = scheduleDate.getDate();
                        var currentMonth = scheduleDate.getMonth() + 1;
                        var currentYear = scheduleDate.getFullYear();
//                        scheduleDate = (new Date(scheduleDate)).toISOString().split("T")[0];
//                        scheduleDate = scheduleDate.split("-");
//                        scheduleDate[2] = parseInt(scheduleDate[2]) + 1;
                        if (currentMonth <= 9) {
                            currentMonth = '0' + currentMonth;
                        }
                        if (currentDate <= 9) {
                            currentDate = '0' + currentDate;
                        }

                        scheduleDate = currentYear + '-' + currentMonth + '-' + currentDate;
                        var intakeID = {
                            "intake": intakeid,
                            "scheduleClassId": taskID,
                            "schedule_date": scheduleDate,
                            "intakeType": courseType
                        }
                        Utils.showLoader(true);
                        ApiService.getEditDetails({
                            data: intakeID,
                            success: function (response) {
                                response.data.scheduleDate = scheduleDate;
                                vm.onCreateAdHocTapDescription(response.data);
                            }
                        }).then(function (response) {
                        });

                    }, this)
                }
            });

            _weeklyScheduler = new window.Scheduler({
                el: $("#weekly__wrapper"),
                containerEl: $("#weekly"),
                type: Scheduler.TYPES.WEEKLY,
                allowEditing: allowEdit,
                accessLevel: role,
                auth_token: GlobalPool.getUserInfo(),
                search: vm.search,
                Utils: Utils,
                requestUrl: api.baseURI + "get-weekly-schedule",
                scheduleData: {
                    data: vm.weeklyData,
                    year: new Date().getFullYear(),
                    arrRooms: vm.arrRooms//window.usersData
                },
                events: {
                    "task_selected": $.proxy(function () {
                    }, this),
                    "task_deselected": $.proxy(function () {
                    }, this),
                    "edit_task": $.proxy(function (data) {
                        var courseType = data.intakeType.toString();
                        var taskID = data.id.toString();
                        var intakeid = data.intakeID.toString();
                        var scheduleDate = new Date(data.date.toString());
                        var currentDate = scheduleDate.getDate();
                        var currentMonth = scheduleDate.getMonth() + 1;
                        var currentYear = scheduleDate.getFullYear();
                        if (currentMonth <= 9) {
                            currentMonth = '0' + currentMonth;
                        }
                        if (currentDate <= 9) {
                            currentDate = '0' + currentDate;
                        }

                        scheduleDate = currentYear + '-' + currentMonth + '-' + currentDate;
                        var intakeID = {
                            "intake": intakeid,
                            "scheduleClassId": taskID,
                            "schedule_date": scheduleDate,
                            "intakeType": courseType,
                        }
                        Utils.showLoader(true);
                        ApiService.getEditDetails({
                            data: intakeID,
                            success: function (response) {
                                response.data.scheduleDate = scheduleDate;
                                vm.onCreateAdHocTapDescription(response.data);
                            }
                        }).then(function (response) {
                        });



                    }, this)
                }
            });

            _curView = _weeklyScheduler;
            var compiled = $compile(_monthlyScheduler.el);
            compiled($scope);
            var _updateEnableCurView = function (data) {
                _curView.refresh();
                $.__queue.add(function () {
                    _curView.el.removeClass("g-transparent");
                }, this);

                $.__queue.add(_curView.refresh, this);
            };
        };

        var requestCounter = 0;
        var checkInitScheduler = function () {
            if (requestCounter === 3) {
                initScheduler();
                setTimeout(function () {
                    Utils.showLoader(false);
                }, 0);
            }
        };

        var updateScheduler = function () {
            Utils.showLoader(true);
            var requestData = {
                search: vm.search,
                room: vm.CRoom,
                filterType: vm.CType
            };
            ApiService.GetWeeklySchedule({data: requestData}).then(function (response) {
                Utils.showLoader(false);
                if (response && response.status == 1)
                {
                    vm.weeklyData = {"year": 2016, data: response.data.arrSchedules, holidays: response.data.arrHolidays};
                }
                var dataWeekly = {
                    data: vm.weeklyData,
                    year: new Date().getFullYear()
                };
                if (response.data.arrRooms) {
//                    dataWeekly.arrRooms = response.data.arrRooms;
                }
                _weeklyScheduler.update(dataWeekly);
                $.__queue.add(_curView.refresh, this);
            });

            ApiService.GetMonthlySchedule({data: requestData}).then(function (response) {
                Utils.showLoader(false);
                if (response && response.status == 1)
                {
                    vm.monthlyData = {"year": 2016, data: response.data.arrSchedules, holidays: response.data.arrHolidays};

                }
                var dataMonthly = {
                    data: vm.monthlyData,
                    year: new Date().getFullYear()
                };
                _monthlyScheduler.update(dataMonthly);
                $.__queue.add(_curView.refresh, this);
            });
        }

        Utils.showLoader(true);
        ApiService.GetRoom({}).then(function (response) {
            if (response && response.status == 1)
            {
                vm.arrRooms = response.data;
            }
            requestCounter++;

            checkInitScheduler();

        });

        ApiService.GetWeeklySchedule({data: {search: vm.search, room: vm.CRoom,
                filterType: vm.CType}}).then(function (response) {
            if (response && response.status == 1)
            {
                vm.weeklyData = {"year": 2016, data: response.data.arrSchedules, holidays: response.data.arrHolidays};
            }
            requestCounter++;
            checkInitScheduler();
            setTimeout(function(){ 
                // clndr__cell-task_daily 
            }, 3000);
        });

        ApiService.GetMonthlySchedule({data: {search: vm.search, room: vm.CRoom,
                filterType: vm.CType}}).then(function (response) {
            Utils.showLoader(false);
            if (response && response.status == 1)
            {
                vm.monthlyData = {"year": 2016, data: response.data.arrSchedules, holidays: response.data.arrHolidays};

                if (vm.monthlyData.data.length == 0 && vm.monthlyData.holidays.length == 0)
                    vm.exportDisable = true;
                else
                    vm.exportDisable = false;
            }
            requestCounter++;
            checkInitScheduler();
        });
    }
})();

function convert(str) {
    var date = new Date(str),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
    return [mnth, day, date.getFullYear()].join("/");
}

$.__queue = {
    _timer: null,
    _queue: [],
    add: function (fn, context, time) {
        var setTimer = function (time) {
            $.__queue._timer = setTimeout(function () {
                time = $.__queue.add();
                if ($.__queue._queue.length) {
                    setTimer(time);
                }
            }, time || 2);
        }

        if (fn) {
            $.__queue._queue.push([fn, context, time]);
            if ($.__queue._queue.length == 1) {
                setTimer(time);
            }
            return;
        }

        var next = $.__queue._queue.shift();
        if (!next) {
            return 0;
        }
        next[0].call(next[1] || window);
        return next[2];
    },
    clear: function () {
        clearTimeout($.__queue._timer);
        $.__queue._queue = [];
    }
};

(function ($, sr) {

    // debouncing function from John Hann
    // http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
    var debounce = function (func, threshold, execAsap) {
        var timeout;

        return function debounced() {
            var obj = this, args = arguments;
            function delayed() {
                if (!execAsap)
                    func.apply(obj, args);
                timeout = null;
            }
            ;

            if (timeout)
                clearTimeout(timeout);
            else if (execAsap)
                func.apply(obj, args);

            timeout = setTimeout(delayed, threshold || 100);
        };
    }
    // smartresize
    jQuery.fn[sr] = function (fn) {
        return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr);
    };

})(jQuery, 'smartresize');

(function() {
    'use strict';
    angular
        .module('app.rooms')
        .controller('RoomsController', RoomsController);
    /** @ngInject */
    function RoomsController(api, usSpinnerService, ApiService, $http, $mdToast, $mdDialog, $document, $compile, $scope, $q, $resource, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, Utils) {
        var vm = this;
        vm.arrRooms = {};
        vm.dtInstance = {};
        vm.getData = getData;
        vm.reloadData = reloadData;
        vm.search = "";
        vm.showDeletedRooms = false;

        vm.someClickHandler = someClickHandler;
        // Paginators

        //        $(function() {
        //            $('.ms-search-bar #ms-search-bar-collapser').click(function() {
        //                if ($('#ms-search-bar-input').val().length > 0) {
        //                    $('#ms-search-bar-input').val('');
        //                    $scope.global.search = '';
        //                    $scope.$broadcast("changeSearch", {"vm.search": ''})
        //                    
        //                }
        //            });
        //        });
        vm.paginators = new Paginator();
        vm.dtPromiseFn = function() {
            return vm.getData();
        }
        vm._reloadDtPage = function() {
            vm.dtInstance.changeData(vm.dtPromiseFn());
        };
        var getDotsTpl = function(roomID, name) {
            var dotsHtml = "";
            if (vm.showDeletedRooms == false) {
                dotsHtml = dotsHtml + '<md-menu>';
                dotsHtml = dotsHtml + ' <md-button aria-label="More" class="md-icon-button" ng-click="$mdOpenMenu($event)" translate >';
                dotsHtml = dotsHtml + ' <md-icon md-font-icon="icon-dots-vertical"></md-icon>';
                dotsHtml = dotsHtml + '<md-tooltip><span >More</span></md-tooltip>';
                dotsHtml = dotsHtml + '</md-button>';
                dotsHtml = dotsHtml + '<md-menu-content width="3">';
                dotsHtml = dotsHtml + '<md-menu-item>';
                dotsHtml = dotsHtml + '<md-button aria-label="Edit" ng-click="vm.onEditRoomTap($event,\'' + roomID + '\')" data-info=\'' + roomID + '\'>';
                dotsHtml = dotsHtml + '<span>Edit</span>';
                dotsHtml = dotsHtml + '</md-button>';
                dotsHtml = dotsHtml + '</md-menu-item>';
                dotsHtml = dotsHtml + '<md-menu-item>';
                dotsHtml = dotsHtml + '<md-button aria-label="Delete"  ng-click="vm.onDeleteRoomTap($event,\'' + roomID + '\',\'' + name + '\')" data-info=\'' + roomID + '\'>';
                dotsHtml = dotsHtml + '<span >Delete</span>';
                dotsHtml = dotsHtml + '</md-button>';
                dotsHtml = dotsHtml + '</md-menu-item>';
                dotsHtml = dotsHtml + '</md-menu-content>';
                dotsHtml = dotsHtml + '</md-menu>';
            } else {
                dotsHtml = dotsHtml + '<md-menu>';
                dotsHtml = dotsHtml + ' <md-button aria-label="More" class="md-icon-button" ng-click="$mdOpenMenu($event)" translate >';
                dotsHtml = dotsHtml + ' <md-icon md-font-icon="icon-dots-vertical"></md-icon>';
                dotsHtml = dotsHtml + '<md-tooltip><span >More</span></md-tooltip>';
                dotsHtml = dotsHtml + '</md-button>';

                dotsHtml = dotsHtml + '<md-menu-content width="3">';
                dotsHtml = dotsHtml + '<md-menu-item>';
                dotsHtml = dotsHtml + '<md-button aria-label="Delete"  ng-click="vm.onReActivateRoomTap($event,\'' + roomID + '\',\'' + name + '\')" data-info=\'' + roomID + '\'>';
                dotsHtml = dotsHtml + '<span >ReActivate</span>';
                dotsHtml = dotsHtml + '</md-button>';
                dotsHtml = dotsHtml + '</md-menu-item>';

                dotsHtml = dotsHtml + '</md-menu-content>';
                dotsHtml = dotsHtml + '</md-menu>';
            }
            return dotsHtml;
        };
        vm.dtOptions = DTOptionsBuilder.fromFnPromise(vm.dtPromiseFn).withOption('createdRow', function(row, data, dataIndex) {
            $compile(angular.element(row).contents())($scope);
        }).withOption('headerCallback', function(header) {
            if (!vm.headerCompiled) {
                vm.headerCompiled = true;
                $compile(angular.element(header).contents())($scope);
            }
        }).withOption("responsive", true).withOption("bInfo", false).withOption("order", []).withOption('rowCallback', rowCallback);

        function someClickHandler(info) {

            var dialogData = info;
            Utils.showLoader(true);
            dialogData.Status = dialogData.Status == 1 ? true : false;
            dialogData.type = "edit";
            Utils.showLoader(false);
            $mdDialog.show({
                controller: 'AddRoomsDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/rooms/add-rooms/add-rooms-dialog.html',
                parent: angular.element($document.body),
                //                clickOutsideToClose: true,
                locals: {
                    dialogData: dialogData,
                    dtInstance: vm.dtInstance,
                    dtPromiseFn: vm.dtPromiseFn

                }
            }).then(function(response) {});
        }

        vm.onReActivateRoomTap = function(e, id, name) {
            var reActivateData = {
                "id": id
            }
            var confirm = $mdDialog.confirm()
                .title('Confirm Reactivate Room?')
                .textContent('Are you sure you want to re-activate selected Room ?')
                .ariaLabel('reactivateRoom')
                .targetEvent(e)
                .ok('Re-activate')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                Utils.showLoader(true);
                ApiService.ReActivateRoom({
                    data: reActivateData,
                    success: function(response) {
                        Utils.showLoader(false);
                        if (response.status == 0) {
                            Utils.showToast({ text: response.data.message, 'type': 0 });
                        } else {
                            Utils.showToast({ text: response.data.message, 'type': 1 });
                            vm._reloadDtPage();
                        }
                    }
                });
            }, function() {});
        };

        function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    vm.someClickHandler(aData);
                });
            });
            return nRow;
        };
        vm.dtColumns = [
            DTColumnBuilder.newColumn('title').withTitle('Name'),
            DTColumnBuilder.newColumn('capacity').withTitle('Capacity'),
            DTColumnBuilder.newColumn(null).withTitle("").notSortable()
            .renderWith(function(data, type, full, meta) {
                vm.arrRooms[data.roomID] = data;
                return getDotsTpl(data.roomID, data.title);
            })
        ];
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).withOption("responsivePriority", 1),
            DTColumnDefBuilder.newColumnDef(2).notSortable().withOption("responsivePriority", 2)
        ];

        function getData() {
            Utils.showLoader(true);
            var defer = $q.defer();
            var requestData = {
                search: vm.search,
                showDeletedRooms: vm.showDeletedRooms,
            };
            if (vm.changeFilter == true) {
                vm.paginators.curPageIndex = 1;
            }
            if (vm.searchDone == true) {
                vm.paginators.curPageIndex = 1;
            } else {

            }
            ApiService.GetRoom({ paginators: vm.paginators, data: requestData }).then(function(response) {
                var data = response.data;
                if (response && response.headerFn) {
                    vm.paginators.setTotal(response.headerFn("totalitemscount"));
                }
                defer.resolve(data);
                setTimeout(function() {
                    Utils.showLoader(false);
                }, 0)
            });
            return defer.promise;
        }



        vm.onPrevClick = function(e, pageStartIndex, pageEndIndex, totalItems) {
            vm.paginators.previous(e, pageStartIndex, pageEndIndex, totalItems);
            vm.dtInstance.changeData(vm.getData());
        }

        vm.onNextClick = function(e, pageStartIndex, pageEndIndex, totalItems) {
            vm.paginators.next(e, pageStartIndex, pageEndIndex, totalItems);
            vm.dtInstance.changeData(vm.getData());
        }
        $scope.$watch("global.search", function(newValue, oldValue) {

            if (oldValue === "") {
                return;
            }
            vm.search = newValue;
            Utils.showLoader(true);
            vm.searchDone = true;
            vm.dtInstance.changeData(vm.getData());
            vm.searchDone = false;
        });

        //                        $scope.$watch("global.search", function(newValue, oldValue) {
        //                        if (newValue != oldValue) {
        //                        $scope.$broadcast("changeSearch", {vm.search:newValue})
        //                        }
        //
        //                        });
        $scope.$on("changeSearch", function(event, args) {
            vm.searchDone = true;
            vm.dtInstance.changeData(vm.getData());
            vm.searchDone = false;
        });

        function reloadData() {
            if (vm.dtInstance.reloadData)
                vm.dtInstance.reloadData();
        }

        vm._onFilterChanged = function(val) {
            vm.changeFilter = true;
            vm.dtInstance.changeData(vm.getData());
            vm.changeFilter = false;
        };

        vm.onCreateRoomTap = function(e) {
            Utils.showLoader(true);
            var dialogData = {
                "type": "add",
                "Status": true
            };
            Utils.showLoader(false);
            $mdDialog.show({
                controller: 'AddRoomsDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/rooms/add-rooms/add-rooms-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                //                clickOutsideToClose: true,
                locals: {
                    dialogData: dialogData,
                    dtInstance: vm.dtInstance,
                    dtPromiseFn: vm.dtPromiseFn
                }
            }).then(function(response) {

            });
        };
        vm.onDeleteRoomTap = function(e, roomID, name) {
            // var checkData = {
            //     "roomID": roomID
            // }
            // ApiService.checkRoomDeletable({
            // data: checkData,
            // success: function (response) {
            //     if (response.status == 0) {
            //         Utils.showToast({ text: response.data.message, 'type': 0 });
            //     }
            //     else {
            var deleteData = {
                "rooms": [roomID]
            }
            var confirm = $mdDialog.confirm()
                .title('Confirm Delete Room?')
                .textContent('Are you sure you want to delete selected Room ?')
                .ariaLabel('Delete')
                .targetEvent(e)
                .ok('Delete')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                Utils.showLoader(true);
                ApiService.DeleteRoom({
                    data: deleteData,
                    success: function(response) {
                        Utils.showLoader(false);
                        if (response.status === 0) {
                            Utils.showToast({ text: response.data.message, 'type': 0 });
                        } else {

                            Utils.showToast({ text: response.data.message, 'type': 1 });
                            vm._reloadDtPage();
                        }
                    }
                });
            }, function() {});
            //     }
            // }
            // })
        };
        vm.onEditRoomTap = function(e, roomID) {
            var dialogData = vm.arrRooms[roomID];
            dialogData.Status = dialogData.Status == 1 ? true : false;
            dialogData.type = "edit";
            $mdDialog.show({
                controller: 'AddRoomsDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/rooms/add-rooms/add-rooms-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                //                clickOutsideToClose: true,
                locals: {
                    dialogData: dialogData,
                    dtInstance: vm.dtInstance,
                    dtPromiseFn: vm.dtPromiseFn

                }
            }).then(function(response) {});
        };
        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
            .module('app.payroll', ["threeStateCheckbox"])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
//        $stateProvider
//                    .state('app.courses', {
//                        url: '/courses',
//                        views: {
//                            'content@app': {
//                                templateUrl: 'app/main/courses/courses.html',
//                                controller: 'CoursesController as vm'
//                            }
//                        },
//                         
////                        ncyBreadcrumb: {
////                            label: 'Courses',
////                        },
////                        data: {
////                            bAllow: getAllowedState(mergedArr, "4")
////                        }
//                    });


        // Translation
//        $translatePartialLoaderProvider.addPart('app/main/courses');
    }
})();
(function ()
{
    'use strict';

    angular
            .module('app.payroll')
            .controller('PayrollController', PayrollController);

    /** @ngInject */
    function PayrollController(api, usSpinnerService, ApiService, $http, $mdToast, $mdDialog, $location, $document, $compile, $scope, $q, $resource, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, Utils, GlobalPool)
    {
        var vm = this;
        vm.arrCourses = {};
        vm.dtInstance = {};
        vm.getData = getData;
        vm.reloadData = reloadData;
        vm.openDataDlg = openDataDlg;
        // Paginators
        vm.selectedTeacher = null;
        vm.CIntake = null;
        vm.CStartDate = null;
        vm.CEndDate = null;
        vm.search = "";
        vm.courseType = Focus.ENUMS.COURSE_TYPE,
                vm.courseLanguage = Focus.ENUMS.COURSE_LANGUAGE,
                vm.courseRecurrance = Focus.ENUMS.COURSE_RECURRANCE,
                vm.paginators = new Paginator();
        var userInfo = GlobalPool.getUserInfo();
        vm.role_id = userInfo.role_id;
        vm.setAuthToken = userInfo.auth_token;
        vm.setAuthDownloadLink = api.baseURI;

        var getDotsTpl = function (courseID, Language) {
            var dotsHtml = "";
            dotsHtml = dotsHtml + '<md-menu>';
            dotsHtml = dotsHtml + ' <md-button aria-label="More" class="md-icon-button" ng-click="$mdOpenMenu($event)" translate >';
            dotsHtml = dotsHtml + ' <md-icon md-font-icon="icon-dots-vertical"></md-icon>';
            dotsHtml = dotsHtml + '<md-tooltip><span >More</span></md-tooltip>';
            dotsHtml = dotsHtml + '</md-button>';
            dotsHtml = dotsHtml + '<md-menu-content width="3">';
            dotsHtml = dotsHtml + '<md-menu-item>';
            dotsHtml = dotsHtml + '<md-button aria-label="Edit" ng-click="vm.onEditCourseTap($event,\'' + courseID + '\')" data-info=\'' + courseID + '\'>';
            dotsHtml = dotsHtml + '<span>Edit</span>';
            dotsHtml = dotsHtml + '</md-button>';
            dotsHtml = dotsHtml + '</md-menu-item>';
            dotsHtml = dotsHtml + '<md-menu-item>';

            dotsHtml = dotsHtml + '<md-button aria-label="Delete"  ng-click="vm.onDeleteCourseTap($event,\'' + courseID + '\',\'' + Language + '\')" data-info=\'' + courseID + '\'>';
            dotsHtml = dotsHtml + '<span >Delete</span>';
            dotsHtml = dotsHtml + '</md-button>';
            dotsHtml = dotsHtml + '</md-menu-item>';
            dotsHtml = dotsHtml + '</md-menu-content>';
            dotsHtml = dotsHtml + '</md-menu>';
            return dotsHtml;
        };
        vm.dtOptions = DTOptionsBuilder.fromFnPromise(vm.getData).withOption('createdRow', function (row, data, dataIndex) {
            $compile(angular.element(row).contents())($scope);
        }).withOption('headerCallback', function (header) {
            if (!vm.headerCompiled) {
                vm.headerCompiled = true;
                $compile(angular.element(header).contents())($scope);
            }
        }).withOption("responsive", true).withOption("bInfo", false).withOption("order", []).withOption('rowCallback', rowCallback);
        ;

        function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
            if (aData.enableCertificate == 1) {
                $('td', nRow).addClass('certificate-highlight');
            }
            $('td', nRow).unbind('click');
            return nRow;
        }

        if (vm.role_id == 2) {
            vm.dtColumns = [
                DTColumnBuilder.newColumn('pay_date').withTitle('Invoice Date'),
                DTColumnBuilder.newColumn('amount_paid').withTitle('Paid Amount'),
                DTColumnBuilder.newColumn(null).withTitle('Payslip').notSortable().renderWith(function (data, type, full, meta) {
//                vm.arrCourses[data.payslip_id] = data;
                    vm.pay_id = parseInt(data.payslip_id);
                    return   '<a target="_blank" href="'+ vm.setAuthDownloadLink +'download-payslip?payslip_id=' + vm.pay_id + '  "><md-button class="md-accent md-raised btnviolet md-hue-1 md-button_small g_margin-left-0" >' + "Download Payslip" + '</md-button></a>';
                }),
            ];
        } else {

            vm.dtColumns = [
                DTColumnBuilder.newColumn('teacher_name').withTitle('Teacher'),
                DTColumnBuilder.newColumn('start_date').withTitle('Start Date'),
                DTColumnBuilder.newColumn('end_date').withTitle('End Date'),
                DTColumnBuilder.newColumn('amount_paid').withTitle('Paid Amount'),
                DTColumnBuilder.newColumn(null).withTitle('Payslip').notSortable().renderWith(function (data, type, full, meta) {
//                vm.arrCourses[data.payslip_id] = data;
                    vm.pay_id = parseInt(data.payslip_id);
                    return   '<a target="_blank" href="'+ vm.setAuthDownloadLink +'download-payslip?payslip_id=' + vm.pay_id + '  "><md-button class="md-accent md-raised btnviolet md-hue-1 md-button_small g_margin-left-0" >' + "Download Payslip" + '</md-button></a>';
                }),
            ];
            vm.dtColumnDefs = [
                DTColumnDefBuilder.newColumnDef(0),
                DTColumnDefBuilder.newColumnDef(1).withOption("responsivePriority", 1),
                DTColumnDefBuilder.newColumnDef(2).withOption("responsivePriority", 2)
            ];
        }

        $scope.$watch("global.search", function (newValue, oldValue) {

            if (oldValue === "") {
                return;
            }

            vm.search = newValue;
            Utils.showLoader(true);
            vm.searchDone = true;
            vm.dtInstance.changeData(vm.getData());
            vm.searchDone = false;
        });
        function getData() {

            Utils.showLoader(true);
            var defer = $q.defer();
            var requestData = {
                search: vm.search
            };

            ApiService.GetTeacherPayslip({paginators: vm.paginators, data: requestData}).then(function (response) {
                var data = response.data;
                if (response && response.headerFn) {
                    vm.paginators.setTotal(response.headerFn("totalitemscount"));
                }
                defer.resolve(data);
                setTimeout(function () {
                    Utils.showLoader(false);
                }, 0)


            });
            return defer.promise;
        }
        ;

        var param = $location.search();
        if (param.intakeid) {
            var intakeID = param.intakeid;
            var dialogData = {
                "title": "Add Attendance",
                "Status": true
            };


            ApiService.MarkAttendance({}).then(function (response) {
                vm.data = response.data[0];
                vm.studentOptions = response.data[0].students;
                vm.attendanceObj = []
                for (var i = 0; i < vm.studentOptions.length; i++) {
                    vm.attendanceObj.push({id: vm.studentOptions[i].id, name: vm.studentOptions[i].full_name, bAllow: true})
                }


                $mdDialog.show({
                    controller: 'AddAttendanceController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/attendance/add-attendance/add-attendance.html',
                    parent: angular.element($document.body),
//                targetEvent: e,
//                    clickOutsideToClose: true,
                    locals: {
                        dialogData: dialogData,
                        dtInstance: vm.dtInstance,
                        attendanceObj: vm.attendanceObj,
                        data: vm.data,
                        dtPromiseFn: vm.dtPromiseFn
                    }
                }).then(function (response)
                {

                });
            });

        }
//        $(function() {
//            $('.ms-search-bar #ms-search-bar-collapser').click(function() {
//                if ($('#ms-search-bar-input').val().length > 0) {
//                    $('#ms-search-bar-input').val('');
//                    $scope.global.search = '';
//                    Utils.showLoader(true);
//                }
//            });
//        });

        $scope.$on("changeSearch", function (event, args) {
            vm.searchDone = true;
            vm.dtInstance.changeData(vm.getData());
            vm.searchDone = false;
        }
        );
        vm.onPrevClick = function (e, pageStartIndex, pageEndIndex, totalItems) {
            vm.paginators.previous(e, pageStartIndex, pageEndIndex, totalItems);
            vm.dtInstance.changeData(vm.getData());
        }

        vm.onNextClick = function (e, pageStartIndex, pageEndIndex, totalItems) {
            vm.paginators.next(e, pageStartIndex, pageEndIndex, totalItems);
            vm.dtInstance.changeData(vm.getData());
        }

        function reloadData() {
            if (vm.dtInstance.reloadData)
                vm.dtInstance.reloadData();
        }

        vm._reloadDtPage = function () {
            vm.dtInstance.reloadData();
        };
        function openDataDlg(attendanceId, e) {
            var dialogData = vm.arrCourses[attendanceId];
            var requestData = {
                intake_id: dialogData.intakeID,
                schedule_class_id : dialogData.schedule_class_id,
            };
            Utils.showLoader(true);

//            $http({
//                url: api.localUrl + 'dashboard/trial.json',
//                dataType: "json",
//                method: "GET",
//                headers: {
//                    "Content-Type": "application/json"
//                }
//            }).success(function(response) {
            ApiService.GetAttendanceReport({data: requestData}).then(function (response) {
                vm.studentsData = response.data[0].attendances;
                vm.dateList = response.data[0].scheduleDates;
                dialogData.end_date = response.data[0].end_date;
                dialogData.start_date = response.data[0].start_date;
                dialogData.btnEnable = response.data[0].enableCertificate;
                dialogData.intake_id = response.data[0].intakeID;
                dialogData.schedule_class_id = response.data[0].schedule_class_id;
                var arrSchedules = response.data[0].scheduleDates;
                var arrAttendances = response.data[0].attendances;

                var curAttList = null, curScheduleObj = null, curAttListobj = null, bAllow;
                for (var i = 0; i < arrAttendances.length; i++)
                {
                    curAttList = arrAttendances[i].attendanceList;
                    for (var x = 0; x < curAttList.length; x++) {
                        curAttListobj = curAttList[x];
                        if (curAttListobj.attendance == 0) {
                            curAttListobj.bAllow = false;
                        } else if (curAttListobj.attendance == 1) {
                            curAttListobj.bAllow = true;
                        } else {
                            curAttListobj.bAllow = null;
                        }
                    }

                    for (var j = 0; j < arrSchedules.length; j++) {
                        curScheduleObj = arrSchedules[j];
                        if (!isDateInSchedules(curAttList, curScheduleObj)) {
                            curAttList.push({
                                date: curScheduleObj,
                                attendance: '',
                                bAllow: -1
                            });
                        }
                    }
                }
                function isDateInSchedules(arrAttendances, strDateToCheck) {
                    if (!arrAttendances) {
                        return false;
                    }

                    for (var i = 0; i < arrAttendances.length; i++) {
                        if (arrAttendances[i].date == strDateToCheck) {
                            return true;
                        }
                    }

                    return false;
                }
                arrAttendances;
                Utils.showLoader(false);
                $mdDialog.show({
                    controller: 'ShowReportController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/attendance/show-report/show-report-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
//                    clickOutsideToClose: true,
                    locals: {
                        dialogData: dialogData,
                        studentsData: arrAttendances,
                        dateList: arrSchedules,
                        dtPromiseFn: vm.dtPromiseFn

                    }
                }).then(function (response)
                {

                });
            }
            );
        }
        ;







        // Methods

        //////////
    }
})();

(function()
{
    'use strict';
    angular
            .module('app.next_private_class_schedule', ['ui.timepicker'])
            .config(config);
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.next_private_class_schedule', {
            url: '/next-private-class-schedule',

            views: {
                'content@app': {
                    templateUrl: 'app/main/next-private-class-schedule/next-private-class-schedule.html',
                    controller: 'NextPrivateClassScheduleController as vm'
                },
                'toolbar@app': {
                    templateUrl: 'app/toolbar/layouts/mark-attendance/toolbar.html',
                    controller: 'ToolbarController as vm'
                },
                'navigation@app': {
                    templateUrl: 'app/navigation/layouts/mark-attendance/navigation.html',
                    controller: 'NavigationController as vm'
                },
            },
            bodyClass: 'reset-password'
        });
    }
})();

//                                views: {
//                                'main@': {
//                                templateUrl: 'app/core/layouts/content-only.html',
//                                        controller: 'MainController as vm'
//                                },
//                                        'content@app.attendance_mark': {
//                                        templateUrl: 'app/main/mark-attendance/mark-attendance.html',
//                                                controller: 'MarkAttedanceController as vm'
//                                        }
//                                },
(function () {
    'use strict';

    angular.module('app.next_private_class_schedule').config(function ($mdDateLocaleProvider) {
        $mdDateLocaleProvider.formatDate = function (date) {
            return date ? moment(date).format('DD-MM-YYYY') : '';
        };
        $mdDateLocaleProvider.parseDate = function (dateString) {
            var m = moment(dateString, 'DD-MM-YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };
    })
            .controller('NextPrivateClassScheduleController', NextPrivateClassScheduleController);

    /** @ngInject */
    function NextPrivateClassScheduleController(api, usSpinnerService, ApiService, $http, $location, $mdToast, $rootScope, $mdDialog, $document, $compile, $scope, $q, $resource, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, Utils) {

        var vm = this;
        vm.closeDialog = closeDialog;
        vm.btnDisable = false;
        var id = '';
        vm.setMinDate = moment().format('DD-MM-YYYY');
        
        vm.setMinDate = Utils.getDashedFormattedDate(vm.setMinDate);
        
        var param = $location.search();
        if (param.intakeID) {
            //            Utils.showLoader(true);
            var id = param.intakeID;
            //            var id = "C-GB-21072016-01"
            var requestData = {
                intakeID: id
            }
            ApiService.GetNextPrivateScheduleClass({
                data: requestData
            }).then(function (response) {
                if (response.status == 0) {
                    vm.btnDisable = true;
                    //                    Utils.showLoader(false);
                    if (response.data.message) {
                        Utils.showToast({
                            text: response.data.message,
                            'type': 0
                        });
                        $mdDialog.show(
                                $mdDialog.alert()
                                .clickOutsideToClose(true)
                                .title('Attendance Alert !!')
                                .textContent('Attendance Link is aldready Expired')
                                .ariaLabel('Alert Dialog Demo')
                                .ok('Ok')
                                
                                ).then(function () {
                            Utils.showLoader(true);
                            $location.url($location.path("/login"));
                        }, function () {});
                    }

                } else {
                    Utils.showLoader(false);

                    vm.data = response.data;
                    $rootScope.teacher_name = vm.data.teacher_name;
                    $rootScope.course_name = vm.data.CourseName;
                    $rootScope.intakeID = vm.data.intake_id;
                    $rootScope.schedule_date = vm.data.date;
                    $rootScope.full_course_name = vm.data.CourseName;
                    $rootScope.class_start_date = vm.data.start_date;
                    $rootScope.duration = vm.data.class_duration;
                    $rootScope.start_time = vm.data.start_time;
                    $rootScope.room = vm.data.room_name;

                }
            });

        }
        // Paginators

        vm.ToggleCheckbox = function (e, value) {
            var arrAttendance = vm.attendanceObj;

        }

        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(dtPromiseFn());

        };

        function closeDialog() {
            $mdDialog.cancel();
        }




        vm.onSaveAttendanceTap = function (e) {

            var requestData = {
                'schedule_date': vm.dialogData.start_date,
                'start_time': moment(vm.dialogData.start_time).format('H:mm:ss'),
                'end_time': moment(vm.dialogData.end_time).format('H:mm:ss'),
                'schedule_class_id': vm.data.id,
                'schoolId': vm.data.schoolId,
                'schedule_weekly_id': vm.data.schedule_weekly_id,
            }
            ApiService.AddNextPrivateScheduleClass({
                data: requestData,
                success: function (response) {
                    if (response.status == 0) {
                        Utils.showLoader(false);

                        Utils.showToast({
                            text: response.data.message,
                            'type': 0
                        });

                    } else {
                        Utils.showLoader(false);
                        Utils.showToast({
                            text: response.data.message,
                            'type': 1
                        });
                    }
                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular.module('app.attendance_add').config(function ($mdDateLocaleProvider) {
                $mdDateLocaleProvider.formatDate = function (date) {
                    return date ? moment(date).format('DD-MM-YYYY') : '';
                };
                $mdDateLocaleProvider.parseDate = function (dateString) {
                    var m = moment(dateString, 'DD-MM-YYYY', true);
                    return m.isValid() ? m.toDate() : new Date(NaN);
                };
            })
        .controller('MarkAttedanceController', MarkAttedanceController);

    /** @ngInject */
    function MarkAttedanceController(api, usSpinnerService, ApiService, $http, $location, $mdToast, $rootScope, $mdDialog, $document, $compile, $scope, $q, $resource, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, Utils) {

        var vm = this;
        vm.closeDialog = closeDialog;
        vm.btnDisable = false;

        var param = $location.search();
        if (param.intakeID) {
            //            Utils.showLoader(true);
            var id = param.intakeID;
            //            var id = "C-GB-21072016-01"
            var requestData = {
                intakeID: id
            }

            ApiService.MarkAttendance({
                data: requestData
            }).then(function(response) {
                if (response.status == 0) {
                    vm.btnDisable = true;
                    //                    Utils.showLoader(false);
                    if (response.data.message) {
                        Utils.showToast({
                            text: response.data.message,
                            'type': 0
                        });
                        $mdDialog.show(
                            $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Attendance Alert !!')
                            .textContent('Attendance Link is aldready Expired')
                            .ariaLabel('Alert Dialog Demo')
                            .ok('Ok')
                            //
                            ////                            .targetEvent(ev)
                        ).then(function() {
                            Utils.showLoader(true);
                            $location.url($location.path("/login"));
                        }, function() {});
                    }

                } else {
                    Utils.showLoader(false);
                    if (response.data.length > 0) {
                        vm.data = response.data[0];
                        $rootScope.teacher_name = vm.data.teacher_name;
                        $rootScope.course_name = vm.data.course_name;
                        $rootScope.intakeID = vm.data.intakeID;
                        $rootScope.schedule_date = vm.data.schedule_date;
                        $rootScope.full_course_name = vm.data.full_course_name;
                        $rootScope.class_start_date = vm.data.class_start_date;
                        $rootScope.duration = vm.data.duration;
                        $rootScope.start_time = vm.data.start_time;
                        $rootScope.room = vm.data.room;
                        vm.studentOptions = response.data[0].students;
                        vm.attendanceObj = []
                        if (vm.studentOptions) {
                            for (var i = 0; i < vm.studentOptions.length; i++) {
                                if (vm.studentOptions[i].attendance == 1) {
                                    var allowStudent = true;
                                } else {
                                    var allowStudent = false;
                                }
                                vm.attendanceObj.push({
                                    id: vm.studentOptions[i].id,
                                    name: vm.studentOptions[i].full_name,
                                    email: vm.studentOptions[i].email,
                                    contact_number: vm.studentOptions[i].contact_number,
                                    bAllow: allowStudent
                                })
                            }
                        }
                    }
                }
            });

        }
        // Paginators

        vm.ToggleCheckbox = function(e, value) {
            var arrAttendance = vm.attendanceObj;

        }

        vm._reloadDtPage = function() {
            vm.dtInstance.changeData(dtPromiseFn());

        };

        function closeDialog() {
            $mdDialog.cancel();
        }


        vm.onSaveAttendanceTap = function(e) {
            var studentsObj = [];
            for (var i = 0; i < vm.attendanceObj.length; i++) {
                if (vm.attendanceObj[i].bAllow == false) {
                    var attendance = 0;
                } else {
                    var attendance = 1;
                }
                studentsObj.push({
                    id: vm.attendanceObj[i].id,
                    attendance: attendance,
                    full_name : vm.attendanceObj[i].name,
                    email : vm.attendanceObj[i].email,
                })
            }
            var requestData = {
                'courseName' : vm.data.full_course_name,
                'teacherName' : vm.data.teacher_name,
                'start_time' : vm.data.start_time,
                'end_time' : vm.data.end_time,
                'scheduleDate' : vm.data.schedule_date,
                "schedule_class_id": vm.data.schedule_class_id,
                'course_type' : vm.data.course_type,
                "schedule_date": vm.data.schedule_date,
                "students": studentsObj
            }
            ApiService.AddAttendance({
                data: requestData,
                success: function(response) {
                    if (response.status == 0) {
                        Utils.showLoader(false);

                        Utils.showToast({
                            text: response.data.message,
                            'type': 0
                        });
//                        $mdDialog.show(
//                            $mdDialog.alert()
//                            .clickOutsideToClose(true)
//                            .title('Attendance Alert !!')
//                            .textContent(response.data.message)
//                            .ariaLabel('Alert Dialog Demo')
//                            .ok('Ok')
//                        ).then(function() {
//                        }, function() {});
                    } else {
                        Utils.showLoader(false);
                        //                        vm.btnDisable = true;
                        Utils.showToast({
                            text: response.data.message,
                            'type': 1
                        });
                        $mdDialog.show(
                            $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Attendance Alert !!')
                            .textContent(response.data.message)
                            .ariaLabel('Alert Dialog Demo')
                            .ok('Ok')
                        ).then(function() {
                        }, function() {});
                    }
                }
            });
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('app.intakes')
        .controller('IntakeController', IntakeController);
    /** @ngInject */
    function IntakeController(api, usSpinnerService, $state, ApiService, $http, $mdToast, $mdDialog, $document, $compile, $scope, $q, $resource, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, Utils, GlobalPool, $rootScope) {
        var vm = this;


        vm.arrIntakes = {};
        vm.dtInstance = {};
        vm.dtStudentInstance = {};
        vm.getPromise = getPromise;
        vm.editDialogData = {};
        vm.getData = getData;
        vm.reloadData = reloadData;
        vm.search = "";
        vm.CIntake = null;
        vm.CType = null;
        vm.CRoom = null;
        vm.CTeacher = null;
        vm.studentCost = {};
        vm.openAttendance = openAttendance;
        vm.courseType = Focus.ENUMS.COURSE_FILTERTYPE,
            vm.filterType = Focus.ENUMS.INTAKE_FILTERTYPE,
            vm.someClickHandler = someClickHandler;
        vm.someStudentClickHandler = someStudentClickHandler;
        var userInfo = GlobalPool.getUserInfo();
        vm.role_id = userInfo.role_id;
        vm.setAuthToken = userInfo.auth_token;
        vm.setAuthDownloadLink = api.baseURI;
        vm.studentFullDetail = {};
        vm.form1Visible = true;
        vm.form2Visible = false;
        vm.form3Visible = false;
        vm.c_scheduleClassID = 0;
        vm.intake_id;
        vm.studentID1 = 0;
        vm.s_status = 0;
        var intake_url = location.href;
        vm.dialogData3 = 0;
        vm.courseFullname = '';
        vm.onEnrolmentIntakeTap = onEnrolmentIntakeTap;
        vm.onEnrolmentIntakeLinkTap = onEnrolmentIntakeLinkTap;
        vm.invoice_id = "";
        vm.sendInvoiceButton = false;
        vm.sendInvoiceRadio = false;
        vm.studentsSendInvoice = true;
        vm.paidInvoiceRadio = false;
        vm._bHideUpdateInvoice = false;
        vm.availableRooms = [];
        vm.studentData = [];
        vm._bHideSwapRoom = true;
        vm._bDisableSwapButton = false;
        vm.selectedRoomForSwap = "";
        vm.selectedDateForSwap = "";
        vm.days = Focus.ENUMS.RECURRANCE_DAYS;
        vm.showMakeUpStudentList = false;
        vm.makeUpStudents = [];

        function init() {
            
            if (typeof $rootScope.$root.calendarScheduleClassID != 'undefined') {

                if ($rootScope.$root.calendarScheduleClassID != "") {
                    vm._bHideSwapRoom = false;
                    var scheduleClassID = $rootScope.$root.calendarScheduleClassID;
                    $rootScope.$root.calendarScheduleClassID = "";
                    vm.studentData = vm.onEnrolmentIntakeTap("e", scheduleClassID, "", "", "", "", "");

                    var checkData = {
                        "intake": scheduleClassID
                    }
                    Utils.showLoader(true);
                    ApiService.IntakeStudents({
                        data: checkData,
                        success: function(response) {
                            var type = '';
                            if (response.data.courseDetails.courseType == 'G') {
                                type = 'Group';
                            } else if (response.data.courseDetails.courseType == 'O') {
                                type = 'Online';
                            } else {
                                type = 'Private';

                                if (response.data.courseDetails.location != '') {
                                    vm._bDisableSwapButton = true;
                                    vm._bDisableSwapButton = true;
                                } else {
                                    vm._bDisableSwapButton = false;
                                    vm._bDisableSwapButton = false;
                                }
                            }
                            vm.courseFullname = response.data.courseDetails.courseName + " - " + response.data.courseDetails.courseLevel + " - " + response.data.courseDetails.courseSeries + " - " + type;

                            if (response.status == 0) {
                                Utils.showToast({
                                    text: response.data.message,
                                    'type': 0
                                });

                            } else {
                                vm.studentData = response.data;
                                var type = '';
                                if (response.data.courseDetails.courseType == 'G') {
                                    type = 'Group';
                                } else if (response.data.courseDetails.courseType == 'O') {
                                    type = 'Online';
                                } else {
                                    type = 'Private';
                                }
                                vm.intake_id = vm.studentData.courseDetails.intake_id;
                                vm.studentData.courseDetails.frequency_interval = '[' + vm.studentData.courseDetails.frequency_interval + ']';
                                vm.studentData.courseDetails.frequency_interval = JSON.parse(vm.studentData.courseDetails.frequency_interval);
                                vm.classDays = '';
                                for (var i = 0; i < vm.studentData.courseDetails.frequency_interval.length; i++) {
                                    if ((i + 1) == vm.studentData.courseDetails.frequency_interval.length) {
                                        vm.classDays = vm.classDays + vm.days[parseInt(vm.studentData.courseDetails.frequency_interval[i])].day;
                                    } else {
                                        vm.classDays = vm.classDays + vm.days[parseInt(vm.studentData.courseDetails.frequency_interval[i])].day + ', ';
                                    }

                                }
                                if (vm.classDays == '') {
                                    vm.classDays = '-';
                                }
                                vm.dtStudentInstance.changeData(vm.getPromise(response.data.studentList));

                                vm.studentsSendInvoice = true;
                                if (vm.studentData.studentList != null) {
                                    vm.studentsSendInvoice = false;
                                }
                                var cnt = 0;
                                for (var i = 0; i < vm.studentData.studentList.length; i++) {
                                    if (vm.studentData.studentList[i].enrolment_status == 1) {
                                        cnt = cnt + 1;
                                    }
                                }
                                if (cnt == vm.studentData.studentList.length) {
                                    vm.studentsSendInvoice = true;
                                } else {
                                    vm.studentsSendInvoice = false;
                                }
                                Utils.showLoader(true);
                                ApiService.GetRoom({}).then(function(response) {
                                    vm.availableRooms = response.data;
                                    $mdDialog.hide(vm.dialogData);
                                    Utils.showLoader(false);
                                    for (var i = 0; i < vm.availableRooms.length; i++) {
                                        if (vm.studentData.courseDetails.roomID == vm.availableRooms[i].roomID) {
                                            vm.availableRooms.splice(i, 1);
                                        }
                                    }
                                });


                            }
                        }
                    });


                }
            }
        }
        init();

        vm.checkURL = function() {
            var a = intake_url.indexOf("?");
            if (a != "-1") {
                vm.form1Visible = false;
                vm.form2Visible = true;
                vm.form3Visible = false;
                var res = intake_url.split("=");
                vm.c_scheduleClassID = res[1];
                intakeStudents();
            } else {
                if(vm.role_id == '2') {
                    $state.go('app.profile & class details', {
                        // 'makeupid': vm.selectedMakeUpStudent
                    }); //redirect to teacher profile as teacher not have intake access
                }
            }
            if (typeof $rootScope.$root.makeUpIntakeId != 'undefined') {
                vm.c_scheduleClassID = $rootScope.$root.makeUpIntakeId;
                delete $rootScope.$root.makeUpIntakeId;
                intakeStudents();
            }
            if (typeof $rootScope.$root.intakeType != 'undefined') {
                vm.CType = $rootScope.$root.intakeType;
                delete $rootScope.$root.intakeType;                
            }
            if (typeof $rootScope.$root.intakeID != 'undefined') {
                vm.form1Visible = false;
                vm.form2Visible = true;
                vm.form3Visible = false;
                vm.c_scheduleClassID = $rootScope.$root.intakeID;
                delete $rootScope.$root.intakeID;
                intakeStudents();              
            }
        }

        vm.checkURL();

        vm.dtStudentOptions = DTOptionsBuilder.fromFnPromise(vm.getPromise({})).withOption('createdRow', function(row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            }).withOption('headerCallback', function(header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            }).withOption("responsive", true).withOption("bInfo", false)
            .withOption("order", []).withOption('rowCallback', rowStudentCallback);

        if (vm.role_id == 2) {
            vm.dtStudentColumns = [
                DTColumnBuilder.newColumn('studentID').withTitle('studentID').notVisible().withClass('g-hidden'),
                DTColumnBuilder.newColumn('full_name').withTitle('Name'),
                DTColumnBuilder.newColumn('contact_number').withTitle('Contact No.').renderWith(function(data, type, full, meta) {

                    if ('null' == full.contact_number || full.contact_number == null) {
                        console.log(full.contact_number);
                        return '';
                    } else {
                        var contact_no = full.contact_number.replaceAll(' ', '');
                            
                    }
                    
                    return '<md-button  class="md-accent md-raised md-hue-1 btnred md-button_small" style = "text-transform: none;width:140px !important;" ng-click="vm.redirectToWhatsapp(\'' + contact_no + '\', \'' + full.full_name + '\',$event); $event.stopPropagation();"><img src="/assets/icons/whatsapp-icon.png" style="float:left;" ></img>' + contact_no + '</md-button>';
                }),
                DTColumnBuilder.newColumn('enrolment_status').withTitle('Status').renderWith(function(data, type, full, meta) {
                    if (data == 1) {
                        var roomcap = '<div ><label class="status-sent">Invoice sent</label></div>';
                        return roomcap;
                    }
                    if (data == 2) {
                        var roomcap = '<div ><label class="status-paid">Paid</label></div>';
                        return roomcap;
                    }
                    if (data == 3) {
                        var roomcap = '<div  ><label class="status-cancel">Cancelled</label></div>';
                        return roomcap;
                    } else {
                        var roomcap = '<div ><label class="status-review" >Review</label></div>';
                        return roomcap;
                    }

                }),
            ];
        } else {

            vm.dtStudentColumns = [
                DTColumnBuilder.newColumn('studentID').withTitle('studentID').notVisible().withClass('g-hidden'),
                DTColumnBuilder.newColumn('full_name').withTitle('Name'),
                DTColumnBuilder.newColumn('contact_number').withTitle('Contact No.').renderWith(function(data, type, full, meta) {
                    if ('null' == full.contact_number || full.contact_number == null) {
                        console.log(full.contact_number);
                        return '';
                    } else {
                        var contact_no = full.contact_number.replaceAll(' ', '');
                            
                    }
                    return '<md-button  class="md-accent md-raised md-hue-1 btnred md-button_small" style = "text-transform: none;width:150px !important;" ng-click="vm.redirectToWhatsapp(\'' + contact_no + '\',\'' + full.full_name + '\', $event); $event.stopPropagation();"><img src="/assets/icons/whatsapp-icon.png" style="float:left;" ></img>' + contact_no + '</md-button>';
                }),
                DTColumnBuilder.newColumn('comments').withTitle('Comments').notSortable(),
                DTColumnBuilder.newColumn(null).withTitle('').notSortable().renderWith(function(data, type, full, meta) {
                    return '<md-button class="md-accent md-raised md-hue-1 btnred md-button_small" style = "text-transform: none;" ng-click="vm.editEnrolmentStudent(\'' + full.schoolStudentId + '\', $event); $event.stopPropagation();">' + "Edit Comment" + '</md-button>';
                }),
                DTColumnBuilder.newColumn('enrolment_status').withTitle('Status').renderWith(function(data, type, full, meta) {


                    if (data == 1) {
                        var roomcap = '<div ><label class="status-sent">Invoice sent</label></div>';
                        return roomcap;
                    }
                    if (data == 2) {
                        var roomcap = '<div ><label class="status-paid">Paid</label></div>';
                        return roomcap;
                    }
                    if (data == 3) {
                        var roomcap = '<div  ><label class="status-cancel">Cancelled</label></div>';
                        return roomcap;
                    } else {
                        var roomcap = '<div ><label class="status-review" >Review</label></div>';
                        return roomcap;
                    }

                }),
                DTColumnBuilder.newColumn(null).withTitle('').notSortable().renderWith(function(data, type, full, meta) {
                    if (vm.role_id != '2') {
                        if (full.enrolment_status != 2) {
                            return '<md-button class="md-accent md-raised md-hue-1 btnred md-button_small" style = "text-transform: none;" ng-click="vm.deleteEnrolmentStudent(\'' + full.studentID + '\', \'' + full.ScheduleClassStudentID + '\', \'' + full.invoice_id + '\' , $event); $event.stopPropagation();">' + "Delete" + '</md-button>';
                        } else {
                            return '<md-button class="md-accent md-raised md-hue-1 btnred md-button_small " style = "text-transform: none;" ng-disabled = "true" ng-click="vm.deleteEnrolmentStudent(\'' + full.ScheduleClassStudentID + '\', \'' + full.invoice_id + '\' , $event); $event.stopPropagation();">' + "Delete" + '</md-button>';
                        }
                    }
                    return "";
                }),
                DTColumnBuilder.newColumn(null).withTitle('').notSortable().renderWith(function(data, type, full, meta) {
                    if (vm.role_id != '2') {
                        if (full.enrolment_status == '1' || full.enrolment_status == '2') {
                            return '<md-button class="md-accent md-raised btnviolet md-hue  -1 md-button_small g_margin-left-0 increase-index" style = "text-transform: none;" ng-click="vm.transferEnrolmentStudent(\'' + full.studentID + '\', \'' + full.ScheduleClassStudentID + '\', $event); $event.stopPropagation();">' + "Transfer" + '</md-button>';
                        } else {
                            return '<md-button class="md-accent md-raised btnviolet md-hue-1 md-button_small g_margin-left-0 increase-index" ng-disabled = "true" style = "text-transform: none;" ng-click="vm.deleteEnrolmentStudent(\'' + full.ScheduleClassStudentID + '\', \'' + full.invoice_id + '\' , $event); $event.stopPropagation();">' + "Transfer" + '</md-button>';
                        }
                    }
                    return "";
                }),
            ];

            vm.dtStudentColumnDefs = [
                DTColumnDefBuilder.newColumnDef(0).withOption("responsivePriority", 1),
                DTColumnDefBuilder.newColumnDef(1).withOption("responsivePriority", 2),
                DTColumnDefBuilder.newColumnDef(5).withOption("responsivePriority", 3),
                DTColumnDefBuilder.newColumnDef(2).withOption("responsivePriority", 4)

            ];

        }
        //        }

        vm.transferEnrolmentStudent = function(student_id, ScheduleClassStudentID, e) {

            Utils.showLoader(true);
            var dialogData = {
                'student_id': student_id,
                'ScheduleClassStudentID': ScheduleClassStudentID,
                'scheduleClassID': vm.c_scheduleClassID,
            };

            var upcomingClasses = [];
            ApiService.getUpcomingClasses({
                data: dialogData
            }).then(function(response) {
                if (response.status == 1) {
                    dialogData.upcomingClasses = response.data;
                }
                Utils.showLoader(false);
                $mdDialog.show({
                    controller: 'TransferStudentsDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/intake/add-intake/transfer-student-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    //                    clickOutsideToClose: true,
                    locals: {
                        dialogData: dialogData,
                        dtInstance: vm.dtInstance,
                        dtPromiseFn: vm.dtPromiseFn
                    }
                }).then(function(response) {
                    intakeStudents();
                });
            })
        }

        vm.editEnrolmentStudent = function(schoolStudentId, e) {

            vm.studentData
            var comment = "";
            for (var i = 0; i < vm.studentData.studentList.length; i++) {
                if (vm.studentData.studentList[i].schoolStudentId == schoolStudentId) {
                    comment = vm.studentData.studentList[i].comments;
                }
            }
            var dialogData = {
                'schoolStudentId': schoolStudentId,
                'comment': comment
            };
            Utils.showLoader(false);
            $mdDialog.show({
                controller: 'UpdateCommentController',
                controllerAs: 'vm',
                templateUrl: 'app/main/intake/add-intake/update-comment.html',
                parent: angular.element($document.body),
                locals: {
                    dialogData: dialogData,
                    dtInstance: vm.dtInstance,
                    dtPromiseFn: vm.dtPromiseFn

                }
            }).then(function(response) {
                intakeStudents();
            });
        }
        vm.redirectToWhatsapp = function(contact_number, full_name, e) {

             var contact_no = contact_number.replaceAll(' ', '');
                if(contact_no[0] == '+'){
                    contact_no = contact_no.replace(/[^a-zA-Z0-9 ]/g, "");
                    var link = 'https://wa.me/' + contact_no + '?text=hi ' + full_name;
                } else {
                    contact_no = contact_no.replace(/[^a-zA-Z0-9 ]/g, "");
                    if (contact_no.length > 8) {
                        var code = contact_no.substring(0, 2);
                        if (code == 65) {
                            contact_no = contact_no.substring(2);
                        }
                    }
                    var link = 'https://wa.me/65' + contact_no + '?text=hi ' + full_name;
                }
            window.open(link, '_blank');
        }

        vm.deleteEnrolmentStudent = function(student_id, ScheduleClassStudentID, b, e) {
            Utils.showLoader(true);
            var studentData = {};
            studentData.ScheduleClassStudentID = ScheduleClassStudentID;
            studentData.student_id = student_id;
            studentData.scheduleClassID = vm.c_scheduleClassID;
            studentData.invoice_id = b;
            ApiService.DeleteIntakeStudent({
                data: studentData,
                success: function(response) {
                    Utils.showLoader(false);
                    if (response.status == 0) {
                        Utils.showToast({
                            text: response.data.message,
                            'type': 0
                        });

                    } else {
                        Utils.showToast({
                            text: response.data.message,
                            'type': 0
                        });
                    }
                    intakeStudents();
                }
            })
        }


        function someStudentClickHandler(info) {
            var dialogData1 = info;
            vm.studentID1 = dialogData1;
            vm.studentInvoiceStatus = dialogData1.enrolment_status;
            Utils.showLoader(true);
            var checkData = {
                "auth_token": vm.setAuthToken,
                "studentID": dialogData1.studentID,
                "schedule_class_id": vm.c_scheduleClassID,
                'courseId': vm.studentData.courseDetails.courseId
            }
            ApiService.GetStudentById({
                data: checkData,
                success: function(response) {
                    Utils.showLoader(false);
                    if (response.status == 0) {
                        Utils.showToast({
                            text: response.data.message,
                            'type': 0
                        });

                    } else {
                        vm.studentFullDetail = response.data;

                        processStudentFullDetail();


                    }
                }
            })

            if (vm.studentInvoiceStatus == null) {
                vm.studentInvoiceStatus = "0";
            }
            vm.form3Visible = true;
            vm.form2Visible = false;
            vm.form1Visible = false;

        }

        function processStudentFullDetail() {

            vm.studentChecked = vm.studentFullDetail.is_renewal == 1 ? true : false;
            if (vm.studentFullDetail.enrolment_status == 1) {
                vm.sendInvoiceButton = true;
                vm.sendInvoiceRadio = true;
                vm.paidInvoiceRadio = true;
            } else if (vm.studentFullDetail.enrolment_status == 2) {
                vm.sendInvoiceButton = true;
                vm.sendInvoiceRadio = true;
                vm.paidInvoiceRadio = true;
            } else {
                vm.sendInvoiceButton = false;
                vm.sendInvoiceRadio = false;
                vm.paidInvoiceRadio = false;
            }
            vm.invoice_id = vm.studentFullDetail.invoice_id;

            vm.studentCost.StudentID = vm.studentFullDetail.studentID;
            if (vm.studentFullDetail.admin_fee == null) {
                vm.studentFullDetail.admin_fee = 0;
            }
            if (vm.studentFullDetail.basic_cost == null) {
                vm.studentFullDetail.basic_cost = 0;
            }

            vm.total = parseFloat(vm.studentFullDetail.admin_fee) + parseFloat(vm.studentFullDetail.basic_cost);
            if(vm.studentFullDetail.tax != null) {
                vm.total += parseFloat(vm.studentFullDetail.tax); 
            } else {
                vm.studentFullDetail.tax = 0;
            }
            if (vm.studentFullDetail.enrolment_status == null || vm.studentFullDetail.enrolment_status == 0) {
                vm._bHideUpdateInvoice = false;
            } else {
                vm._bHideUpdateInvoice = true;
            }
        }

        vm.backToEnrolmentIntake = function() {
            vm.form3Visible = false;
            vm.form2Visible = true;
            vm.form1Visible = false;
            vm.onEnrolmentIntakeTap("e", vm.c_scheduleClassID, "intakeID", vm.c_courseName, vm.c_courseLevel, vm.c_courseSeries, vm.c_typeName);
        }

        function reloadStudentData(schedule_class_id, studentID) {
            //            Utils.showLoader(true);
            var checkData = {
                //                "auth_token": a,
                "studentID": studentID,
                "schedule_class_id": schedule_class_id,
                'courseId': vm.studentData.courseDetails.courseId
            }
            ApiService.GetStudentById({
                data: checkData,
                success: function(response) {
                    //                    Utils.showLoader(false);

                    if (response.status == 0) {
                        Utils.showToast({
                            text: response.data.message,
                            'type': 0
                        });

                    } else {
                        vm.studentFullDetail = response.data;
                        processStudentFullDetail();
                    }
                }
            })
        }
        vm.onSwapRoomDateChange = function() {
            var requestData = {
                "startTime": vm.studentData.courseDetails.startTime,
                "endTime": vm.studentData.courseDetails.endTime,
                "schedule_class_id": vm.studentData.courseDetails.scheduleClassID,
                "current_room_student_count": vm.studentData.studentList.length,
                "currentRoomID": vm.studentData.courseDetails.roomID,
                "swap_date": vm.selectedDateForSwap
            }
            Utils.showLoader(true);
            ApiService.GetRoom({
                data: requestData,

                success: function(response) {
                    if (response.status === 0) {
                        Utils.showLoader(false);
                        Utils.showToast({
                            text: response.data.message,
                            'type': 0
                        });
                        $('.swap_room_error').html(response.data.message);
                    } else {
                        Utils.showLoader(false);
                        vm.availableRooms = response.data;

                    }
                }
            });
            // ApiService.CheckAvailableRoomByDate({
            //     data: requestData,

            //     success: function(response) {
            //         if (response.status === 0) {
            //             Utils.showLoader(false);
            //             Utils.showToast({
            //                 text: response.data.message,
            //                 'type': 0
            //             });
            //             $('.swap_room_error').html(response.data.message);
            //         } else {
            //             Utils.showLoader(false);
            //             vm.availableRooms = response.data;

            //         }
            //     }
            // });
        }
        vm.swapRoom = function() {
                if (vm.selectedRoomForSwap == "") {
                    $('.swap_room_error').html('Please Select Room');
                    return;
                } else {
                    $('.swap_room_error').html();
                }
                var requestData = {
                    "schedule_class_id": vm.studentData.courseDetails.scheduleClassID,
                    "frequency_type": vm.studentData.courseDetails.scheduleClassFrequencyType,
                    "swapRoomID": vm.selectedRoomForSwap,
                    "swap_date": vm.selectedDateForSwap
                }
                vm._bDisableSwapButton = true;
                Utils.showLoader(true);
                ApiService.SwapRoomByDate({
                    data: requestData,

                    success: function(response) {
                        if (response.status === 0) {
                            Utils.showLoader(false);
                            Utils.showToast({
                                text: response.data.message,
                                'type': 0
                            });
                            $('.swap_room_error').html(response.data.message);
                            vm._bDisableSwapButton = false;
                            
                        } else {
                            Utils.showLoader(false);
                            Utils.showToast({
                                text: response.data.message,
                                'type': 1
                            });
                            vm._reloadDtPage();

                            //                        $('.swap_room_error').html(response.data.message);
                        }
                        vm._bDisableSwapButton = false;

                    }
                });
                intakeStudents();

            }
            // old swap room logic 
            // vm.swapRoom = function() {
            //     if (vm.selectedRoomForSwap == "") {
            //         $('.swap_room_error').html('Please Select Room');
            //         return;
            //     } else {
            //         $('.swap_room_error').html();
            //     }
            //     var requestData = {
            //         "startDate": vm.studentData.courseDetails.startDate,
            //         "endDate": vm.studentData.courseDetails.endDate,
            //         "dateRange": vm.studentData.dateRange,
            //         "startTime": vm.studentData.courseDetails.startTime,
            //         "endTime": vm.studentData.courseDetails.endTime,
            //         "schedule_class_id": vm.studentData.courseDetails.scheduleClassID,
            //         "current_room_student_count": vm.studentData.studentList.length,
            //         "currentRoomID": vm.studentData.courseDetails.roomID,
            //         "swapRoomID": vm.selectedRoomForSwap,
            //         "swap_date": vm.selectedDateForSwap
            //     }
            //     vm._bDisableSwapButton = true;
            //     Utils.showLoader(true);
            //     ApiService.CheckAvailableRoom({
            //         data: requestData,

        //         success: function(response) {
        //             if (response.status === 0) {
        //                 Utils.showLoader(false);
        //                 Utils.showToast({
        //                     text: response.data.message,
        //                     'type': 0
        //                 });
        //                 $('.swap_room_error').html(response.data.message);
        //             } else {
        //                 Utils.showLoader(false);
        //                 Utils.showToast({
        //                     text: response.data.message,
        //                     'type': 1
        //                 });
        //                 vm._reloadDtPage();

        //                 //                        $('.swap_room_error').html(response.data.message);
        //             }
        //         }
        //     });
        //     intakeStudents();

        // }

        vm.showSwapRoomDialog = function() {

            Utils.showLoader(true);
            ApiService.GetRoom({}).then(function(response) {
                Utils.showLoader(false);
                var dialogData = response.data;
                dialogData.title = 'Swap Room';
                dialogData.Intake_detail = vm.studentData;
                Utils.showLoader(false);
                $mdDialog.show({
                    controller: 'ShowAvailableRoomController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/intake/add-intake/show-available-room-dialog.html',
                    parent: angular.element($document.body),
                    //                clickOutsideToClose: true,
                    locals: {
                        dialogData: dialogData,
                        dtInstance: vm.dtInstance,
                        dtPromiseFn: vm.dtPromiseFn,

                    }
                }).then(function(response) {
                    intakeStudents();
                });
            });



        }

        vm.showStudentDialog = function() {
            var dialogData = {};
            dialogData.title = "Add Student";
            dialogData.studentData = vm.studentData;
            dialogData.scheduleClassID = vm.c_scheduleClassID;


            Utils.showLoader(true);

            ApiService.GetStudents({}).then(function(response) {
                var student = response.data;
                var studentobj = [];
                for (var i = 0; i < student.length; i++) {
                    studentobj.push({
                        id: student[i].studentID,
                        text: student[i].email + " (" + student[i].full_name + " )"
                    });
                }
                //            var studentobj = [{id: '1' , 'text' : 'aniskureshi@gmail.com'},{id: '2' , 'text' : 'wasimkureshi@gmail.com'}]
                Utils.showLoader(false);
                $mdDialog.show({
                    controller: 'AddUpdateStudentsDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/intake/add-intake/add-update-student-dialog.html',
                    parent: angular.element($document.body),
                    //                clickOutsideToClose: true,
                    locals: {
                        dialogData: dialogData,
                        dtInstance: vm.dtInstance,
                        dtPromiseFn: vm.dtPromiseFn,
                        studentsobj: studentobj

                    }
                }).then(function(response) {
                    intakeStudents();
                });

            });
        }
        vm.showPrivateClassDialog = function() {
            var balanceHours = vm.studentData.no_of_hours_balance;
            if (balanceHours > 0) {
                Utils.showToast({
                    text: balanceHours + ' hours left',
                    'type': 1
                });
                var dialogData = {};
                dialogData.scheduleClassID = vm.c_scheduleClassID;
                dialogData.intake_id = vm.intake_id;
                dialogData.start_date = new Date();
                dialogData.start_time = new Date();
                dialogData.start_time.setHours(12);
                dialogData.start_time.setMinutes(0);
                dialogData.start_time.setSeconds(0);
                dialogData.start_time.setMilliseconds(0);
                dialogData.class_duration = 1;
                dialogData.students = vm.studentData.studentList;
                dialogData.balance_hours = vm.studentData.no_of_hours_balance;
                $mdDialog.show({
                    controller: 'AddPrivateDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/intake/add-intake/add-private-dialog.html',
                    parent: angular.element($document.body),
                    //                            targetEvent: e,
                    locals: {
                        dialogData: dialogData,
                        dtInstance: vm.dtInstance,
                        dtPromiseFn: vm.dtPromiseFn

                    }
                }).then(function(response) {
                    intakeStudents();
                });
            } else {
                Utils.showToast({
                    text: 'No balance hours left',
                    'type': 0
                });
            }
        }

        vm.showMakeUpClassDialog = function() {
            Utils.showLoader(true);
            var requestData = {
                "schedule_class_id": vm.c_scheduleClassID

            }
            ApiService.GetMakeUpEligibleStudents({
                data: requestData
            }).then(function(response) {
                var dialogData = response.data;
                var student = response.data.studentList;
                if (student.length == 0) {
                    Utils.showLoader(false);
                    Utils.showToast({
                        text: "No make up student found",
                        'type': 0
                    });
                } else {
                    var studentobj = [];
                    for (var i = 0; i < student.length; i++) {
                        studentobj.push({
                            id: student[i].student_id,
                            name: student[i].student_name
                        });
                    }
                    dialogData.Status = dialogData.Status == 1 ? true : false;
                    dialogData.noneditable = "editable";
                    dialogData.sendParam = true;
                    Utils.showLoader(false);
                    $mdDialog.show({
                        controller: 'AddMakeUpDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/intake/add-intake/add-makeup-dialog.html',
                        parent: angular.element($document.body),
                        //                            targetEvent: e,
                        locals: {
                            dialogData: angular.copy(dialogData),
                            dtInstance: vm.dtInstance,
                            studentsobj: studentobj,
                            dtPromiseFn: vm.dtPromiseFn

                        }
                    }).then(function(response) {
                        intakeStudents();
                    });
                }
            });
        }

        vm.deletePrivateClass = function() {
            Utils.showLoader(true);
            var requestData = {
                "schedule_class_id": vm.c_scheduleClassID
            }
            ApiService.GetPrivateDeleteDates({
                data: requestData
            }).then(function(response) {
                Utils.showLoader(false);
                if (response.status == 0) {
                    Utils.showToast({
                        text: response.data.message,
                        'type': 0
                    });

                } else {
                    var dialogData = response.data;
                    var dates = response.data.dates;
                    if (dates.length == 0) {
                        Utils.showToast({
                            text: "No dates found",
                            'type': 0
                        });
                    } else {
                        dialogData.Status = dialogData.Status == 1 ? true : false;
                        dialogData.noneditable = "editable";
                        dialogData.sendParam = true;
                        Utils.showLoader(false);
                        $mdDialog.show({
                            controller: 'DeletePrivateClassDialogController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/intake/delete/delete-private-class.html',
                            parent: angular.element($document.body),
                            //                            targetEvent: e,
                            locals: {
                                dialogData: angular.copy(dialogData),
                                dtInstance: vm.dtInstance,
                                dateobj: dates,
                                dtPromiseFn: vm.dtPromiseFn

                            }
                        }).then(function(response) {
                            intakeStudents();
                        });
                    }
                }
            });
        }

        vm.editFee = function() {
            var dialogData = vm.studentCost;

            dialogData.title = "Update Invoice";
            dialogData.intake = vm.c_scheduleClassID;
            dialogData.invoice_id = vm.invoice_id;
            dialogData.admin_fee = vm.studentFullDetail.admin_fee;
            dialogData.basic_cost = vm.studentFullDetail.basic_cost;
            Utils.showLoader(true);
            //dialogData.Status = dialogData.Status == 1 ? true : false;


            Utils.showLoader(false);
            $mdDialog.show({
                controller: 'UpdateInvoiceController',
                controllerAs: 'vm',
                templateUrl: 'app/main/intake/add-intake/update-invoice.html',
                parent: angular.element($document.body),
                //                clickOutsideToClose: true,
                locals: {
                    dialogData: dialogData,
                    dtInstance: vm.dtInstance,
                    dtPromiseFn: vm.dtPromiseFn

                }
            }).then(function(response) {
                reloadStudentData(vm.c_scheduleClassID, vm.studentID1.studentID);
            });
        }
        vm.editStudentDialog = function() {
            if (vm.editStd == true) {
                var dialogData = vm.studentFullDetail;
                dialogData.type = "edit";
            } else if (vm.editStd == false) {
                vm.studentFullDetail = {};
                var dialogData = vm.studentFullDetail;
                dialogData.type = "add";
                dialogData.apiCalled = 'intake';
                ApiService.GetStudentId({}).then(function(response) {
                    if (response.status == 1) {
                        dialogData.studentId_number = response.data;
                    }
                });
            }

            Utils.showLoader(true);
            dialogData.scheduleClassID = vm.c_scheduleClassID;

            //if company_name != undenided or null then is_company=1
            if (dialogData.company_name != undefined || dialogData.company_name == null) {
                dialogData.is_company = 1;
            }

            Utils.showLoader(false);
            $mdDialog.show({
                controller: 'AddStudentsDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/students/add-students/add-students-dialog.html',
                parent: angular.element($document.body),
                //                clickOutsideToClose: true,
                locals: {
                    dialogData: dialogData,
                    dtInstance: vm.dtInstance,
                    dtPromiseFn: vm.dtPromiseFn

                }
            }).then(function(response) {});
        }


        vm.editFeeDialog = function(e) {

            Utils.showLoader(true);
            var dialogData = {
                "type": "add"
                    //"Status": true
            };
            ApiService.GetStudentId({}).then(function(response) {
                if (response.status == 1) {

                    dialogData.studentId_number = response.data;
                }
                dialogData.apiCalled = 'intake';
                dialogData.scheduleClassID = vm.c_scheduleClassID;
                dialogData.is_company = 1;

                Utils.showLoader(false);
                $mdDialog.show({
                    controller: 'AddStudentsDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/students/add-students/add-students-dialog.html',
                    parent: angular.element($document.body),
                    //targetEvent: e,
                    //                    clickOutsideToClose: true,
                    locals: {
                        dialogData: dialogData,
                        dtInstance: vm.dtInstance,

                        dtPromiseFn: vm.dtPromiseFn
                    }
                }).then(function(response) {

                    vm.onEnrolmentIntakeTap("e", vm.c_scheduleClassID, vm.c_courseName, vm.c_courseLevel, vm.c_courseSeries, vm.c_typeName);

                });
            });


        }

        vm.onChangeRenewal = function() {

                if (vm.is_renewal == true) {
                    vm.dialogData.is_renewal = 1;
                } else {
                    vm.dialogData.is_renewal = 0;
                }
            }
            //dlg end
        vm.onlyWeekendsDisable = function(date) {
                var day = date.getDay();
                return day === 1 || day === 2 || day === 3 || day === 4 || day === 5;
            }
            // Paginators
            //        vm.courseoptions = Focus.ENUMS.COURSE;

        //end table 2
        ApiService.GetIntakeFiletrs({}).then(function(response) {
            vm.intakesList = response.data.intakes;
            $scope.arrIntakes = response.data.intakes;

            vm.datesList = response.data.dates;
            vm.roomList = response.data.rooms;
            $scope.arrRooms = response.data.rooms;
            vm.teacherList = response.data.teachers;
            $scope.arrTeachers = response.data.teachers;
        });
        vm._onFilterChanged = function(val) {
            vm.changeFilter = true;
            vm.filterType;

            if (vm.CStartDate) {
                vm.CStart = Utils.getParsedSlashedDate(vm.CStartDate);
            }
            if (vm.CEndDate) {
                vm.CEnd = Utils.getParsedSlashedDate(vm.CEndDate);
            }

            vm.dtInstance.changeData(vm.getData());
            vm.changeFilter = false;
        };
        vm.timeSlot = Focus.ENUMS.TIME_SLOT;
        vm.paginators = new Paginator();
        var getDotsTpl = function(scheduleClassID, intakeID, Course, courseName, courseLevel, courseSeries, typeName) {
            var dotsHtml = "";
            dotsHtml = dotsHtml + '<md-menu>';
            dotsHtml = dotsHtml + ' <md-button aria-label="More" class="md-icon-button" ng-click="$mdOpenMenu($event)" translate >';
            dotsHtml = dotsHtml + ' <md-icon md-font-icon="icon-dots-vertical"></md-icon>';
            dotsHtml = dotsHtml + '<md-tooltip><span >More</span></md-tooltip>';
            dotsHtml = dotsHtml + '</md-button>';
            dotsHtml = dotsHtml + '<md-menu-content width="3">';

            dotsHtml = dotsHtml + '<md-menu-item>';
            dotsHtml = dotsHtml + '<md-button aria-label="Enrolment" ng-click="vm.onEnrolmentIntakeLinkTap($event,\'' + scheduleClassID + '\',\'' + intakeID + '\',\'' + courseName + '\',\'' + courseLevel + '\',\'' + courseSeries + '\',\'' + typeName + '\')" >';
            //  dotsHtml = dotsHtml + '<md-icon md-font-icon="icon-reply"></md-icon>';
            dotsHtml = dotsHtml + '<span>Enrolment</span>';
            dotsHtml = dotsHtml + '</md-button>';
            dotsHtml = dotsHtml + '</md-menu-item>';

            if (userInfo.role_id != '2') {

                dotsHtml = dotsHtml + '<md-menu-item>';
                dotsHtml = dotsHtml + '<md-button aria-label="Edit" ng-click="vm.onEditIntakeTap($event,\'' + scheduleClassID + '\',\'' + intakeID + '\')" data-info=\'' + scheduleClassID + '\'>';
                //  dotsHtml = dotsHtml + '<md-icon md-font-icon="icon-reply"></md-icon>';
                dotsHtml = dotsHtml + '<span>Edit</span>';
                dotsHtml = dotsHtml + '</md-button>';
                dotsHtml = dotsHtml + '</md-menu-item>';



                dotsHtml = dotsHtml + '<md-menu-item>';
                dotsHtml = dotsHtml + '<md-button aria-label="Delete"  ng-click="vm.onDeleteIntakeTap($event,\'' + scheduleClassID + '\',\'' + Course + '\')" data-info=\'' + scheduleClassID + '\'>';
                //  dotsHtml = dotsHtml + '<md-icon md-font-icon="icon-delete"></md-icon>';
                dotsHtml = dotsHtml + '<span >Delete</span>';
                dotsHtml = dotsHtml + '</md-button>';
                dotsHtml = dotsHtml + '</md-menu-item>';
            }

            dotsHtml = dotsHtml + '</md-menu-content>';
            dotsHtml = dotsHtml + '</md-menu>';
            return dotsHtml;
        };

        $scope.$on("changeSearch", function(event, args) {
            vm.searchDone = true;
            vm.dtInstance.changeData(vm.getData());
            vm.searchDone = false;
        });
        vm.dtPromiseFn = function() {
            return vm.getData();
        }
        $rootScope.$on('$stateChangeSuccess',
            function(event, toState, toParams, fromState, fromParams) {
                if (toState.name == 'app.intakes') {
                    //DO SOMTHING
                    // onEnrolmentIntakeTap(event, dialogData1.schedule_class_id, dialogData1.intakeID, dialogData1.courseName, "", "", "");
                    //                    onEnrolmentIntakeTap(event, "1607", "B-PP-4-02052018-03", "J Urvisha Private Weekly class Test - Pre-Intermediate - 4", "", "", "");
                }
            }
        );

        function onEnrolmentIntakeLinkTap(e, scheduleClassID, intakeID, courseName, courseLevel, courseSeries, typeName) {
            window.open('/intake?intake_id='+scheduleClassID, '_blank');
        }

        function onEnrolmentIntakeTap(e, scheduleClassID, intakeID, courseName, courseLevel, courseSeries, typeName) {
            vm.c_scheduleClassID = scheduleClassID;
            vm.c_courseName = courseName;
            vm.c_courseLevel = courseLevel;
            vm.c_courseSeries = courseSeries;
            vm.c_typeName = typeName;

            intakeStudents();

            vm.form1Visible = false;
            vm.form2Visible = true;
            return vm.studentData;

        }


        function loadDiscrepancyData(response) {
            if (vm.dtStudentInstance && vm.dtStudentInstance.reloadData === undefined) {
                vm.dtStudentOptions = DTOptionsBuilder.fromFnPromise(vm.getPromise({})).
                withOption('createdRow', function(row, data, dataIndex) {
                    $compile(angular.element(row).contents())($scope);
                }).withOption('headerCallback', function(header) {
                    if (!vm.headerCompiled) {
                        vm.headerCompiled = true;
                        $compile(angular.element(header).contents())($scope);
                    }
                }).withOption("responsive", true).withOption("pageLength", 50).withOption("bInfo", false).withOption("order", []).withOption('rowCallback', rowStudentCallback);;;

            }

        }
        loadDiscrepancyData();

        vm.backToIntake = function() {
            vm.form1Visible = true;
            vm.form2Visible = false;
            vm._bHideSwapRoom = true;
            //            $state.reload();
            //            intakeStudents();
            //            getData();
            vm._reloadDtPage();
            setTimeout(function() {
                vm.dtInstance.rerender();
            }, 0);
        }


        vm.dtOptions = DTOptionsBuilder.fromFnPromise(vm.dtPromiseFn).withOption('createdRow', function(row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            }).withOption('headerCallback', function(header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            }).withOption("responsive", true).withOption("bInfo", false)
            .withOption("order", []).withOption('rowCallback', rowCallback);

        function someClickHandler(info) {
            if (info.type != '1' && info.type != '5' && info.type != '6') {
                return;
            }
            var checkData = {
                "schedule_class_id": info.scheduleClassID,

            }
            Utils.showLoader(true);
            ApiService.checkIntakeStart({
                data: checkData,
                success: function(response) {
                    if (response.status == 0) {
                        var intakeID = {
                            "intake": info.intakeID,
                            "scheduleClassId": info.scheduleClassID

                        }
                        ApiService.getEditDetails({
                            data: intakeID,
                            success: function(response) {
                                var dialogData = response.data;
                                dialogData.dateRange = response.data.dateRange;
                                dialogData.getIntakeDetailsDate = response.data.dateRange;
                                dialogData.Status = dialogData.Status == 1 ? true : false;
                                dialogData.noneditable = "noneditable";
                                dialogData.dialogtype = "edit";
                                dialogData.showTypeDialog = "";
                                if (response.data.type != "1") {
                                    dialogData.saveBtnDisableAdhoc = true;
                                }
                                var courseobj = [];

                                var studentobj = dialogData.studentData;

                                Utils.showLoader(false);
                                $mdDialog.show({
                                    controller: 'AddIntakeDialogController',
                                    controllerAs: 'vm',
                                    templateUrl: 'app/main/intake/add-intake/add-intake-dialog.html',
                                    parent: angular.element($document.body),

                                    locals: {
                                        dialogData: angular.copy(dialogData),
                                        dtInstance: vm.dtInstance,
                                        courseoptions: courseobj,
                                        studentsobj: studentobj,
                                        dtPromiseFn: vm.dtPromiseFn

                                    }
                                }).then(function(response) {});
                            }
                        });
                    } else if (response.status == 1) {
                        Utils.showLoader(true);
                        var intakeID = {
                            "intake": info.intakeID,
                            "scheduleClassId": info.scheduleClassID
                        }
                        ApiService.getEditDetails({
                            data: intakeID,
                            success: function(response) {
                                var dialogData = response.data;
                                dialogData.dateRange = response.data.dateRange;
                                dialogData.getIntakeDetailsDate = response.data.dateRange;

                                dialogData.Status = dialogData.Status == 1 ? true : false;
                                dialogData.noneditable = "editable";
                                dialogData.sendParam = true;
                                dialogData.dialogtype = "edit";
                                dialogData.showTypeDialog = "";
                                if (response.data.type != "1") {
                                    dialogData.saveBtnDisableAdhoc = true;
                                }

                                var courseobj = [];
                                var studentobj = [];
                                studentobj = dialogData.studentData;
                                Utils.showLoader(false);
                                $mdDialog.show({
                                    controller: 'AddIntakeDialogController',
                                    controllerAs: 'vm',
                                    templateUrl: 'app/main/intake/add-intake/add-intake-dialog.html',
                                    parent: angular.element($document.body),
                                    //                                        clickOutsideToClose: true,
                                    locals: {
                                        dialogData: angular.copy(dialogData),
                                        dtInstance: vm.dtInstance,
                                        courseoptions: courseobj,
                                        studentsobj: studentobj,
                                        dtPromiseFn: vm.dtPromiseFn

                                    }
                                }).then(function(response) {});
                            }
                        });
                    } else {
                        var intakeID = {
                            "intake": info.intakeID,
                            "scheduleClassId": info.scheduleClassID
                        }
                        ApiService.getEditDetails({
                            data: intakeID,
                            success: function(response) {
                                var dialogData = response.data;
                                dialogData.dateRange = response.data.dateRange;
                                dialogData.getIntakeDetailsDate = response.data.dateRange;
                                //                                dialogData.editOngoingIntake = "1";
                                //                                var dialogData = vm.arrIntakes[scheduleClassID];
                                dialogData.Status = dialogData.Status == 1 ? true : false;
                                dialogData.noneditable = "editable";
                                dialogData.dialogtype = "edit";
                                dialogData.showTypeDialog = "";
                                if (response.data.type != "1") {
                                    dialogData.saveBtnDisableAdhoc = true;
                                }
                                var courseobj = [];
                                var studentobj = [];
                                studentobj = dialogData.studentData;
                                Utils.showLoader(false);
                                $mdDialog.show({
                                    controller: 'AddIntakeDialogController',
                                    controllerAs: 'vm',
                                    templateUrl: 'app/main/intake/add-intake/add-intake-dialog.html',
                                    parent: angular.element($document.body),
                                    //                                        clickOutsideToClose: true,
                                    locals: {
                                        dialogData: angular.copy(dialogData),
                                        dtInstance: vm.dtInstance,
                                        courseoptions: courseobj,
                                        studentsobj: studentobj,
                                        dtPromiseFn: vm.dtPromiseFn

                                    }
                                }).then(function(response) {});
                            }
                        });
                    }

                }
            });


        }

        $scope.selectedIntake = function(selected) {
            if (selected != undefined && selected.title != undefined) {
                for (var i = 0; i < $scope.arrIntakes.length; i++) {
                    if ($scope.arrIntakes[i].id == selected.title) {
                        vm.CIntake = $scope.arrIntakes[i].value;
                        vm._onFilterChanged();
                    }
                }
            }

        }

        function getPromise(data) {
            var dfd = $q.defer();
            if (data.length != 0) {
                dfd.resolve(data);
            } else {
                dfd.resolve({});
            }
            return dfd.promise;
        }


        $scope.selectedRoom = function(selected) {
            if (selected != undefined && selected.title != undefined) {
                for (var i = 0; i < $scope.arrRooms.length; i++) {
                    if ($scope.arrRooms[i].title == selected.title) {
                        vm.CRoom = $scope.arrRooms[i].id;
                        vm._onFilterChanged();
                    }
                }
            }

        }
        $scope.selectedTeacher = function(selected) {
            if (selected != undefined && selected.title != undefined) {
                for (var i = 0; i < $scope.arrTeachers.length; i++) {
                    if ($scope.arrTeachers[i].full_name == selected.title) {
                        vm.CTeacher = $scope.arrTeachers[i].id;
                        vm._onFilterChanged();
                    }
                }
            }

        }

        function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) { // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
            if (aData.teacherAvailable.length == 0) {
                $('td', nRow).addClass('highlight');
            }
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    if (vm.role_id != '2') {
                        vm.someClickHandler(aData);
                    }
                });
            });
            return nRow;
        }

        function rowStudentCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) { // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)

            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    if (vm.role_id != '2') {
                        vm.someStudentClickHandler(aData);
                    }
                });
            });
            return nRow;
        }

        vm.dtColumns = [
            DTColumnBuilder.newColumn('scheduleClassID').withTitle('scheduleClassID').notVisible().withClass('g-hidden'),
            DTColumnBuilder.newColumn('intakeID').withTitle('intakeID').notVisible().withClass('g-hidden'),
            DTColumnBuilder.newColumn('courseName').withTitle('Title').renderWith(function(data, type, full, meta) {
                var courseTypeVal = full.courseType;
                for (var i = 0; i < vm.courseType.length; i++) {
                    if (vm.courseType[i].text == courseTypeVal) {
                        var typeName = vm.courseType[i].value;
                    }
                }

                if (full.courseSeries == null) {
                    full.courseSeries = "";
                }
                if (full.type == "4") {
                    return " - ";
                } else {
                    return full.courseName + " - " + full.courseLevel + " - " + typeName + '-' + full.module;
                }

            }),
            DTColumnBuilder.newColumn('roomAvailable').withTitle('Room').renderWith(function(data, type, full, meta) {
                if(full.type == '6' ) {
                    var roomcap = '<div style=color:green>(' + full.student_count + '/8'  + ')</div>';
                    return roomcap;
                }
                if (data.length > 0) {

                    if (full.student_count >= data[0].capacity) {
                        var roomcap = '<div style=color:red>(' + full.student_count + '/' + data[0].capacity + ')</div>';
                    } else {
                        var roomcap = '<div style=color:green>(' + full.student_count + '/' + data[0].capacity + ')</div>';
                    }
                    return roomcap;
                } else {
                    return "-"
                }
            }),
            DTColumnBuilder.newColumn('start_date').withTitle('Start Date'),
            DTColumnBuilder.newColumn('end_date').withTitle('End Date'),
            DTColumnBuilder.newColumn('start_time').withTitle('Start Time').renderWith(function(data, type, full, meta) {
                // Check correct time format and split into components
                var time = full.start_time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
                if (time.length > 1) { // If time format correct
                    time = time.slice(1); // Remove full string match value
                    time[5] = +time[0] < 12 ? ' am' : ' pm'; // Set AM/PM
                    time[0] = +time[0] % 12 || 12; // Adjust hours
                    time.splice(3, 1)
                }
                return time.join(''); // return adjusted time or original string
            }),
            DTColumnBuilder.newColumn('end_time').withTitle('End Time').renderWith(function(data, type, full, meta) {
                // Check correct time format and split into components
                var time = full.end_time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
                if (time.length > 1) { // If time format correct
                    time = time.slice(1); // Remove full string match value
                    time[5] = +time[0] < 12 ? ' am' : ' pm'; // Set AM/PM
                    time[0] = +time[0] % 12 || 12; // Adjust hours
                    time.splice(3, 1)
                }
                return time.join(''); // return adjusted time or original string
            }),
            DTColumnBuilder.newColumn('module').withTitle('Term').notVisible().withClass('g-hidden').renderWith(function(data, type, full, meta) {
                if (full.type == "4") {
                    return " - ";
                } else if (full.module == null) {
                    return " - ";
                } else {
                    return "   " + full.module + "   ";
                }
            }),
            DTColumnBuilder.newColumn('intakeID').withTitle('IntakeID'),
            DTColumnBuilder.newColumn('teacherAvailable').withTitle('Trainer').renderWith(function(data, type, full, meta) {
                if (data.length > 0) {
                    return data[0].full_name;
                } else {
                    return "-"
                }
            }),
            DTColumnBuilder.newColumn(null).withTitle("").notSortable()
            .renderWith(function(data, type, full, meta) {
                var courseTypeVal = full.courseType;
                for (var i = 0; i < vm.courseType.length; i++) {
                    if (vm.courseType[i].text == courseTypeVal) {
                        var typeName = vm.courseType[i].value;
                    }
                }
                vm.arrIntakes[data.scheduleClassID] = data;
                if (data.type == '1' || data.type == '5' || data.type == '6') {
                    return getDotsTpl(data.scheduleClassID, data.intakeID, data.Course, data.courseName, data.courseLevel, data.courseSeries, typeName);
                } else {
                    return '';
                }

            })
        ];
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).notSortable(),
            DTColumnDefBuilder.newColumnDef(1).withOption("responsivePriority", 1),
            DTColumnDefBuilder.newColumnDef(11).notSortable().withOption("responsivePriority", 2)
        ];



        function getData(config) {
            Utils.showLoader(true);
            var defer = $q.defer();
            var requestData = {
                intake: vm.CIntake,
                type: vm.CType,
                room: vm.CRoom,
                teacher: vm.CTeacher,
                search: vm.search
            };
            if (vm.changeFilter == true) {
                vm.paginators.curPageIndex = 1;
            }
            if (vm.searchDone == true) {
                vm.paginators.curPageIndex = 1;
            } else {

            }
            ApiService.GetIntake({
                paginators: vm.paginators,
                data: requestData
            }).then(function(response) {
                var data = response.data;
                if (response && response.headerFn) {
                    vm.paginators.setTotal(response.headerFn("totalitemscount"));
                }
                defer.resolve(data);
                setTimeout(function() {
                    if (config && config.refreshGrid) {
                        vm.dtInstance.rerender();
                    }
                    setTimeout(function() {
                        Utils.showLoader(false);
                    }, 100);

                }, 1);


            });
            return defer.promise;
        };
        $scope.onFileSelect = function(files) {
            if (!files || files.length == 0) {
                return;
            }
            vm.handleFiles(files);
        };
        vm.handleFiles = function(files) {
            // Check for the various File API support.
            if (window.FileReader) {
                // FileReader are supported.
                getAsText(files[0]);
            } else {
                alert('FileReader are not supported in this browser.');
            }
        };

        function getAsText(fileToRead) {
            var reader = new FileReader();
            // Read file into memory as UTF-8
            reader.readAsText(fileToRead);
            // Handle errors load
            reader.onload = loadHandler;
            reader.onerror = errorHandler;
        }

        function loadHandler(event) {
            var csv = event.target.result;
            processData(csv);
        }

        function processData(csv) {
            var allTextLines = csv.split(/\r\n|\n/);
            var lines = [];
            for (var i = 0; i < allTextLines.length; i++) {
                var data = allTextLines[i].split(';');
                var tarr = [];
                for (var j = 0; j < data.length; j++) {
                    tarr.push(data[j]);
                }
                lines.push(tarr);
            }
            Utils.showLoader(true);
            ApiService.SendStudentCSV({
                data: {
                    dataToImport: 'data:text/csv;charset=utf-8;base64,' + btoa(unescape(encodeURIComponent(csv)))
                },
                success: function(response) {
                    Utils.showLoader(false);
                    if (response.status == 0) {
                        Utils.showToast({
                            text: response.data.message,
                            'type': 0
                        });
                    } else {
                        var dialogData = {};
                        dialogData.errors = response.data.message.errors;
                        dialogData.messages = response.data.message.messages;
                        $mdDialog.show({
                            controller: 'showLogsController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/intake/add-intake/show-log-intake-dialog.html',
                            parent: angular.element($document.body),
                            //                            clickOutsideToClose: true,
                            locals: {
                                dialogData: angular.copy(dialogData),
                                dtInstance: vm.dtInstance,
                                dtPromiseFn: vm.dtPromiseFn

                            }
                        }).then(function(response) {});
                        //                        Utils.showToast({text: response.data.message});
                        vm._reloadDtPage();
                    }
                }
            });
        }

        function errorHandler(evt) {
            if (evt.target.error.name == "NotReadableError") {
                alert("Canno't read file !");
            }
        }

        vm.onClearFiltersTap = function() {
            vm.ValueEmpty = null;
            vm.CTeacher = null;
            vm.CIntake = null;
            $scope.$broadcast('angucomplete-alt:clearInput', 'intake-filter');
            $scope.$broadcast('angucomplete-alt:clearInput', 'room-filter');
            $scope.$broadcast('angucomplete-alt:clearInput', 'teacher-filter');
            vm.CRoom = null;
            vm.CType = null;
            vm.dtInstance.changeData(vm.getData({
                refreshGrid: true
            }));


        }
        vm.onPrevClick = function(e, pageStartIndex, pageEndIndex, totalItems) {
            vm.paginators.previous(e, pageStartIndex, pageEndIndex, totalItems);
            vm.dtInstance.changeData(vm.getData());
        };

        vm.onNextClick = function(e, pageStartIndex, pageEndIndex, totalItems) {
            vm.paginators.next(e, pageStartIndex, pageEndIndex, totalItems);
            vm.dtInstance.changeData(vm.getData());
        };

        function reloadData() {
            if (vm.dtInstance.reloadData)
                vm.dtInstance.reloadData();
        };


        $scope.$watch("global.search", function(newValue, oldValue) {
            if (oldValue === "") {
                return;
            }

            vm.search = newValue;

            Utils.showLoader(true);
            vm.searchDone = true;
            vm.dtInstance.changeData(vm.getData());
            vm.searchDone = false;

        });
        vm.onCreateIntakeTap = function(e) {
            Utils.showLoader(true);
            var dialogData = {
                "dialogtype": "add",
                "Status": true,
            };
            var requestData = {
                'flexible': 0,
                'course_type' : 'G'
            }
            ApiService.GetUniqueCourseList({
                data: requestData
            }).then(function(response) {
                var arrCourses = response.data;

                var courseobj = [];
                for (var i = 0; i < arrCourses.length; i++) {
                    courseobj.push({
                        courseID: arrCourses[i].courseID,
                        validity: arrCourses[i].validity,
                        class_duration: arrCourses[i].class_duration,
                        capacity: arrCourses[i].batch,
                        language: arrCourses[i].language,
                        title: arrCourses[i].title,
                        recurrence_rule: arrCourses[i].recurrence_rule,
                        total_class_duration: arrCourses[i].no_of_classes,
                        series: arrCourses[i].series,
                        level: arrCourses[i].level,
                        books: arrCourses[i].books,
                        type: arrCourses[i].type
                    });
                }
                Utils.showLoader(false);
                $mdDialog.show({
                    controller: 'AddIntakeDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/intake/add-intake/add-intake-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    //                        clickOutsideToClose: true,
                    locals: {
                        dialogData: angular.copy(dialogData),
                        dtInstance: vm.dtInstance,
                        courseoptions: courseobj,
                        studentsobj: {},
                        dtPromiseFn: vm.dtPromiseFn
                    }
                }).then(function(response) {

                });
            });
        };

        vm._reloadDtPage = function() {
            vm.dtInstance.changeData(vm.dtPromiseFn());
            //            vm.dtStudentInstance.changeData(vm.getPromiseFn());
        };

        vm.onDeleteIntakeTap = function(e, scheduleClassID, course) {
            var deleteData = {
                "intakes": [scheduleClassID]
            }

            var confirm = $mdDialog.confirm()
                .title('Confirm Delete Intake?')
                .textContent('Are you sure you want to delete selected Intake ?')
                .ariaLabel('Delete')
                .targetEvent(e)
                .ok('Delete')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                Utils.showLoader(true);
                ApiService.DeleteIntake({
                    data: deleteData,
                    success: function(response) {
                        Utils.showLoader(false);
                        if (response.status === 0) {
                            Utils.showToast({
                                text: response.data.message,
                                'type': 0
                            });
                        } else {

                            Utils.showToast({
                                text: response.data.message,
                                'type': 1
                            });
                            vm._reloadDtPage();
                        }
                    }
                });
            }, function() {});
        };
        vm.onEditIntakeTap = function(e, scheduleClassID, intakeID) {
            e.preventDefault();
            e.stopPropagation();
            vm.passedIntakeID = intakeID;
            vm.passedScheduleClassID = scheduleClassID;
            var checkData = {
                "schedule_class_id": scheduleClassID
            }
            ApiService.checkIntakeStart({
                data: checkData,
                success: function(response) {
                    if (response.status == 0) {
                        var intakeID = {
                            "intake": vm.passedIntakeID,
                            "scheduleClassId": vm.passedScheduleClassID
                        }
                        ApiService.getEditDetails({
                            data: intakeID,
                            success: function(response) {
                                var dialogData = response.data;
                                dialogData.dateRange = response.data.dateRange;
                                dialogData.getIntakeDetailsDate = response.data.dateRange;
                                dialogData.Status = dialogData.Status == 1 ? true : false;
                                dialogData.noneditable = "noneditable";
                                dialogData.dialogtype = "edit";
                                dialogData.showTypeDialog = "";
                                var courseobj = [];
                                Utils.showLoader(false);
                                $mdDialog.show({
                                    controller: 'AddIntakeDialogController',
                                    controllerAs: 'vm',
                                    templateUrl: 'app/main/intake/add-intake/add-intake-dialog.html',
                                    parent: angular.element($document.body),
                                    targetEvent: e,
                                    //                                        clickOutsideToClose: true,
                                    locals: {
                                        dialogData: angular.copy(dialogData),
                                        dtInstance: vm.dtInstance,
                                        courseoptions: courseobj,
                                        studentsobj: studentobj,
                                        dtPromiseFn: vm.dtPromiseFn

                                    }
                                }).then(function(response) {});
                            }
                        });
                    } else if (response.status == 1) {
                        Utils.showLoader(true);
                        var intakeID = {
                            "intake": vm.passedIntakeID,
                            "scheduleClassId": vm.passedScheduleClassID
                        }
                        ApiService.getEditDetails({
                            data: intakeID,
                            success: function(response) {
                                var dialogData = response.data;
                                dialogData.dateRange = response.data.dateRange;
                                dialogData.getIntakeDetailsDate = response.data.dateRange;
                                //                                var dialogData = vm.arrIntakes[scheduleClassID];
                                dialogData.Status = dialogData.Status == 1 ? true : false;
                                dialogData.noneditable = "editable";
                                dialogData.sendParam = true;
                                dialogData.dialogtype = "edit";
                                dialogData.showTypeDialog = "";
                                var courseobj = [];
                                var studentobj = [];
                                studentobj = dialogData.studentData;
                                Utils.showLoader(false);
                                $mdDialog.show({
                                    controller: 'AddIntakeDialogController',
                                    controllerAs: 'vm',
                                    templateUrl: 'app/main/intake/add-intake/add-intake-dialog.html',
                                    parent: angular.element($document.body),
                                    targetEvent: e,
                                    locals: {
                                        dialogData: angular.copy(dialogData),
                                        dtInstance: vm.dtInstance,
                                        courseoptions: courseobj,
                                        studentsobj: studentobj,
                                        dtPromiseFn: vm.dtPromiseFn

                                    }
                                }).then(function(response) {});
                            }
                        });
                    } else {
                        var intakeID = {
                            "intake": vm.passedIntakeID,
                            "scheduleClassId": vm.passedScheduleClassID
                        }
                        ApiService.getEditDetails({
                            data: intakeID,
                            success: function(response) {
                                var dialogData = response.data;
                                dialogData.dateRange = response.data.dateRange;
                                dialogData.getIntakeDetailsDate = response.data.dateRange;
                                //                                dialogData.editOngoingIntake = "1";
                                //                                var dialogData = vm.arrIntakes[scheduleClassID];
                                dialogData.Status = dialogData.Status == 1 ? true : false;
                                dialogData.noneditable = "editable";
                                dialogData.dialogtype = "edit";
                                dialogData.showTypeDialog = "";
                                var courseobj = [];
                                Utils.showLoader(false);
                                $mdDialog.show({
                                    controller: 'AddIntakeDialogController',
                                    controllerAs: 'vm',
                                    templateUrl: 'app/main/intake/add-intake/add-intake-dialog.html',
                                    parent: angular.element($document.body),
                                    targetEvent: e,
                                    //                                        clickOutsideToClose: true,
                                    locals: {
                                        dialogData: angular.copy(dialogData),
                                        dtInstance: vm.dtInstance,
                                        courseoptions: courseobj,
                                        studentsobj: {},
                                        dtPromiseFn: vm.dtPromiseFn

                                    }
                                }).then(function(response) {});
                                //                                });
                                //                                });
                            }
                        });
                    }

                }
            });
        };
        // Methods


        vm.sendInvoice = function() {
            vm.studentFullDetail;
            var invoiceData = {
                "invoice_id": vm.studentFullDetail.invoice_id,
                "full_name": vm.studentFullDetail.full_name,
                "email": vm.studentFullDetail.email,
                "invoice_number": vm.studentFullDetail.invoice_number,

            }
            Utils.showLoader(true);
            ApiService.SendInvoice({
                data: invoiceData,
                success: function(response) {

                    if (response.status == 0) {
                        Utils.showLoader(false);
                        Utils.showToast({
                            text: response.data.message,
                            'type': 0
                        });
                    } else {
                        Utils.showLoader(false);
                        Utils.showToast({
                            text: response.data,
                            'type': 1
                        });
                        vm.studentInvoiceStatus = 1;
                        vm.changeStudentStatus();
                    }
                }
            })
        }

        vm.changeStudentStatus = function() {

            vm.updateStudentID = vm.studentID1.studentID;
            if (vm.studentFullDetail.enrolment_status == vm.studentInvoiceStatus) {
                return;
            }
            var checkData2 = {
                "student_id": vm.studentID1.studentID,
                "schedule_class_id": vm.c_scheduleClassID,
                "invoice_status": vm.studentInvoiceStatus,
                "invoice_id": vm.studentFullDetail.invoice_id
            }

            Utils.showLoader(true);
            ApiService.UpdateInvoiceStatus({
                data: checkData2,
                success: function(response) {

                    if (response.status == 0) {
                        Utils.showLoader(false);
                        Utils.showToast({
                            text: response.data.message,
                            'type': 0
                        });
                        vm.courseData = {};
                    } else {
                        Utils.showLoader(false);
                        Utils.showToast({
                            text: response.data.message,
                            'type': 1
                        });
                        vm.courseData = response.data;
                        reloadStudentData(vm.c_scheduleClassID, vm.studentID1.studentID);

                    }
                }
            })

        };

        function openAttendance() {
            var dialogData = {};
            var type = '1';
            if (vm.studentData.courseDetails.courseType == 'P') {
                type = '5';
            } else if (vm.studentData.courseDetails.courseType == 'O') {
                type = '6';
            }
            var requestData = {
                intake_id: vm.intake_id,
                schedule_class_id : vm.studentData.courseDetails.scheduleClassID,
                type: type
            };

            ApiService.GetAttendanceReport({
                data: requestData
            }).then(function(response) {
                if (response.status == 0) {
                    Utils.showToast({
                        text: response.data.message,
                        'type': 0
                    });

                } else {
                    vm.studentsData = response.data[0].attendances;
                    vm.dateList = response.data[0].scheduleDates;
                    dialogData.nullType = response.data[0].type;
                    dialogData.end_date = response.data[0].end_date;
                    dialogData.start_date = response.data[0].start_date;
                    dialogData.note = response.data[0].note;
                    dialogData.btnEnable = response.data[0].enableCertificate;
                    dialogData.intakeID = response.data[0].intakeID;
                    dialogData.intake_id = response.data[0].intakeID;
                    dialogData.teacher_name = response.data[0].teacher_name;
                    dialogData.startTime = response.data[0].startTime;
                    dialogData.endTime = response.data[0].endTime;
                    dialogData.schedule_class_id = response.data[0].schedule_class_id;
                    dialogData.printData = response.data.printData;
                    var arrSchedules = response.data[0].scheduleDates;
                    var arrAttendances = response.data[0].attendances;
                    var curAttList = null,
                        curScheduleObj = null,
                        curAttListobj = null,
                        bAllow, countEligible = 0;
                    for (var i = 0; i < arrAttendances.length; i++) {
                        //                    curAttList = arrAttendances[i].attendanceList;
                        var newAtt = [];
                        angular.forEach(arrAttendances[i].attendanceList, function(value, x) {
                            newAtt.push(value);
                        });
                        arrAttendances[i].attendanceList = newAtt;
                        if (response.data[0].enableCertificate == 1) {
                            if (arrAttendances[i].isEligible == 1) {
                                countEligible = countEligible + 1;
                            }
                        }

                        for (var x = 0; x < newAtt.length; x++) {

                            curAttListobj = newAtt[x];
                            if (curAttListobj.attendance == 0) {
                                curAttListobj.bAllow = false;
                            } else if (curAttListobj.attendance == 1) {
                                curAttListobj.bAllow = true;
                            } else {
                                curAttListobj.bAllow = null;
                            }
                        }
                        var arrNewSchedule = [];
                        angular.forEach(arrSchedules, function(value, x) {
                            arrNewSchedule.push(value);
                        });
                        for (var j = 0; j < arrNewSchedule.length; j++) {
                            curScheduleObj = arrNewSchedule[j];

                            if (!isDateInSchedules(newAtt, curScheduleObj.date)) {
                                newAtt.push({
                                    date: curScheduleObj.date,
                                    attendance: '',
                                    bAllow: -1
                                });
                            }
                        }

                    }

                    if (countEligible >= 1) {
                        dialogData.btnEnable = 1;
                    } else {
                        dialogData.btnEnable = 0;
                        //                    dialogData.showErrorMsg = true;
                    }

                    function isDateInSchedules(arrAttendances, strDateToCheck) {
                        if (!arrAttendances) {
                            return false;
                        }

                        for (var i = 0; i < arrAttendances.length; i++) {
                            if (arrAttendances[i].date == strDateToCheck) {
                                if (arrAttendances[i].date) {
                                    var dateString = arrAttendances[i].date;
                                    var dateParts = dateString.split("/");
                                    var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
                                    var todayDate = new Date();
                                    if (dateObject >= todayDate) {
                                        arrAttendances[i].bAllow = -1;
                                    }
                                }
                                return true;
                            }
                        }
                        return false;
                    }
                    arrAttendances;

                    Utils.showLoader(false);
                    $mdDialog.show({
                        controller: 'ShowReportController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/attendance/show-report/show-report-dialog.html',
                        parent: angular.element($document.body),
                        targetEvent: "e",
                        //                    clickOutsideToClose: true,
                        locals: {
                            dialogData: dialogData,
                            studentsData: arrAttendances,
                            dateList: arrSchedules,
                            dtPromiseFn: vm.dtPromiseFn

                        }
                    }).then(function(response) {

                    });
                }
            });
        }

        function intakeStudents() {
            var checkData = {
                "auth_token": vm.setAuthToken,
                "intake": vm.c_scheduleClassID
            };
            Utils.showLoader(true);
            ApiService.IntakeStudents({
                data: checkData,
                success: function(response) {
                    Utils.showLoader(false);
                    if (response.status == 0) {
                        Utils.showToast({
                            text: response.data.message,
                            'type': 0
                        });

                    } else {
                        vm.studentData = response.data;
                        var type = '';
                        if (response.data.courseDetails.courseType == 'P') {
                            type = 'Private';
                        } else if (response.data.courseDetails.courseType == 'O') {
                            type = 'Online';
                        } else {
                            type = 'Group';
                        }
                        vm.intake_id = vm.studentData.courseDetails.intake_id;
                        vm.courseFullname = response.data.courseDetails.courseName + " - " + response.data.courseDetails.courseLevel + " - " + type;
                        vm.studentData.courseDetails.frequency_interval = '[' + vm.studentData.courseDetails.frequency_interval + ']';
                        vm.studentData.courseDetails.frequency_interval = JSON.parse(vm.studentData.courseDetails.frequency_interval);
                        vm.classDays = '';
                        for (var i = 0; i < vm.studentData.courseDetails.frequency_interval.length; i++) {
                            if ((i + 1) == vm.studentData.courseDetails.frequency_interval.length) {
                                vm.classDays = vm.classDays + vm.days[parseInt(vm.studentData.courseDetails.frequency_interval[i])].day;
                            } else {
                                vm.classDays = vm.classDays + vm.days[parseInt(vm.studentData.courseDetails.frequency_interval[i])].day + ', ';
                            }

                        }
                        if (vm.classDays == '') {
                            vm.classDays = '-';
                        }
                        vm.dtStudentInstance.changeData(vm.getPromise(response.data.studentList));

                        vm.studentsSendInvoice = true;
                        if (vm.studentData.studentList != null) {
                            vm.studentsSendInvoice = false;
                        }
                        var cnt = 0;
                        for (var i = 0; i < vm.studentData.studentList.length; i++) {
                            if (vm.studentData.studentList[i].enrolment_status == 1) {
                                cnt = cnt + 1;
                            }
                        }
                        if (cnt == vm.studentData.studentList.length) {
                            vm.studentsSendInvoice = true;
                        } else {
                            vm.studentsSendInvoice = false;
                        }
                        var requestData = {
                            "schedule_class_id": vm.c_scheduleClassID
                        }
                        Utils.showLoader(true);
                        ApiService.GetMakeUpStudents({
                            data: requestData,
                            success: function(response) {
                                Utils.showLoader(false);
                                if (response.status == 0) {
                                    //                                    Utils.showToast({
                                    //                                        text: response.data.message,
                                    //                                        'type': 0
                                    //                                    });

                                } else {
                                    if (vm.role_id != '2') {
                                        vm.showMakeUpStudentList = true;
                                    }
                                    vm.makeUpStudents = response.data;
                                }
                            }
                        });
                    }
                }
            });

        }
        vm.showMakeUpClassDetail = function() {
            $rootScope.$root.selectedMakeUpStudent = vm.selectedMakeUpStudent;
            $state.go('app.intakes.detail', {
                'makeupid': vm.selectedMakeUpStudent
            }); //makeup schedule class id
        };

        //////////
    }
})();
(function () {
    'use strict';
    angular
            .module('app.intakes')
            .controller('IntakeMakeupclassController', IntakeMakeupclassController);
    /** @ngInject */
    function IntakeMakeupclassController(api, usSpinnerService, $state, ApiService, $http, $mdToast, $mdDialog, $document, $compile, $scope, $q, $resource, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, Utils, GlobalPool, $rootScope) {

        var vm = this;
        vm.dtInstance = {};
        vm.reloadData = reloadData;
        vm.dtStudentInstance = {};
        vm.getPromise = getPromise;
        vm.form2Visible = true;
        vm.form3Visible = false;
        vm.attendance_id = $rootScope.$root.selectedMakeUpStudent;
        vm.intake_id;
        vm.search = "";
        vm.setAuthDownloadLink = api.baseURI;
        var userInfo = GlobalPool.getUserInfo();
        vm.role_id = userInfo.role_id;
        vm.setAuthToken = userInfo.auth_token;
        vm.studentCost = {};
        vm.sendInvoiceButton = false;
        vm.sendInvoiceRadio = false;
        vm.studentsSendInvoice = true;
        vm.paidInvoiceRadio = false;
        vm._bHideUpdateInvoice = false;
        vm.studentID1 = 0;
        vm.studentData;
        // Paginators

        vm.paginators = new Paginator();
        vm.dtPromiseFn = function () {
//            return vm.intakeStudents();
        }
        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(vm.dtPromiseFn());
        };

        function getPromise(data) {
            var dfd = $q.defer();
            if (data.length != 0) {
                dfd.resolve(data);
            } else {
                dfd.resolve({});
            }
            return dfd.promise;
        }

        function init() {
            getMakeUpStudentInvoice();

        }
        init();
//        intakeStudents();

        function getMakeUpStudentInvoice() {
            var requestData = {
                "attendance_id": vm.attendance_id
            }
            Utils.showLoader(true);
            ApiService.GetMakeUpStudentInvoice({
                data: requestData,
                success: function (response) {
                    Utils.showLoader(false);
                    if (response.status == 0) {
                        Utils.showToast({
                            text: response.data.message,
                            'type': 0
                        });

                    } else {
                        vm.studentData = response.data;
                        setRadioButton();
                        vm.form3Visible = true;
                    }
                }
            });
        }

        function setRadioButton() {
            if (vm.studentData.invoice_status == 1) {
                vm.sendInvoiceButton = true;
                vm.sendInvoiceRadio = true;
                vm.paidInvoiceRadio = true;
            } else if (vm.studentData.invoice_status == 2) {
                vm.sendInvoiceButton = true;
                vm.sendInvoiceRadio = true;
                vm.paidInvoiceRadio = true;
            } else {
                vm.sendInvoiceButton = false;
                vm.sendInvoiceRadio = false;
                vm.paidInvoiceRadio = false;
            }
            if (vm.studentData.invoice_status == null || vm.studentData.invoice_status == 0) {
                vm._bHideUpdateInvoice = false;
            } else {
                vm._bHideUpdateInvoice = true;
            }
        }



        vm.backToEnrolmentIntake = function () {
            $rootScope.$root.makeUpIntakeId = vm.studentData.schedule_class_id;
            $state.go('app.intakes');
        }

        function reloadData() {
            if (vm.dtInstance.reloadData)
                vm.dtInstance.reloadData();
        }

        vm.editFee = function () {
            var dialogData = vm.studentCost;

            dialogData.title = "Update Invoice";
            dialogData.student_id = vm.studentData.student_id;
            dialogData.invoice_id = vm.studentData.invoice_id;
            dialogData.schedule_class_id = vm.c_scheduleClassID;
            dialogData.attendance_id = vm.attendance_id;
            Utils.showLoader(true);
            Utils.showLoader(false);
            $mdDialog.show({
                controller: 'UpdateMakeUpInvoiceController',
                controllerAs: 'vm',
                templateUrl: 'app/main/intake/add-intake/update-makeup-invoice.html',
                parent: angular.element($document.body),
                //                clickOutsideToClose: true,
                locals: {
                    dialogData: dialogData,
                    dtInstance: vm.dtInstance,
                    dtPromiseFn: vm.dtPromiseFn

                }
            }).then(function (response) {
//                vm._reloadDtPage();
                getMakeUpStudentInvoice();
            });
        }

        vm.changeStudentStatus = function () {

            var requestData = {
                "student_id": vm.studentData.student_id,
                "attendance_id": vm.studentData.attendance_id,
                "invoice_status": vm.studentData.invoice_status,
                "invoice_id": vm.studentData.invoice_id
            }

            Utils.showLoader(true);
            ApiService.UpdateMakeUpInvoice({
                data: requestData,
                success: function (response) {
                    Utils.showLoader(false);

                    if (response.status == 0) {
                        Utils.showToast({
                            text: response.data.message,
                            'type': 0
                        });
                        vm.courseData = {};
                    } else {
                        Utils.showToast({
                            text: response.data.message,
                            'type': 1
                        });
                        getMakeUpStudentInvoice();
//                        vm._reloadDtPage();
//                        reloadStudentData(vm.c_scheduleClassID, vm.studentID1.studentID);

                    }
                }
            })

        };

    }
})();

(function()
{
    'use strict';
    angular
            .module('app.holidays')
            .controller('HolidaysController', HolidaysController);
    /** @ngInject */
    function HolidaysController(api, usSpinnerService, ApiService, $http, $mdToast, $mdDialog, $document, $q, $compile, $scope, $resource, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, Utils, ConstructTree, GlobalPool)
    {
        var vm = this;
        vm.arrHolidays = {};
        vm.selected = {};
        vm.dtInstance = {};
        vm.reloadData = reloadData;
        vm.getData = getData;
        vm.search = "";
        var dialogData = {};
        window.h = vm;
        var todaysYear = new Date();
        todaysYear = todaysYear.getFullYear();
        vm.dialogData = {
            "Year": todaysYear
        };
        vm.changeHoliday = changeHoliday;
        vm.holidayYears = Focus.ENUMS.HOLIDAY_YEARS;
        vm.setView = false;
        var userInfo = GlobalPool.getUserInfo();
        vm.roleID = userInfo.role_id;
        vm.someClickHandler = someClickHandler;
        if (userInfo.role_id == 1 || userInfo.role_id == 4) {
            vm.setView = true;
        }
        vm.paginators = new Paginator();
        
        $scope.$on("changeSearch", function(event, args) {
            vm.searchDone = true;
            vm.dtInstance.changeData(vm.getData());
            vm.searchDone = false;
        }
        );

        var titleHtml = "";
        var getDotsTpl = function(holidayID, name) {
            var dotsHtml = "";
            dotsHtml = dotsHtml + '<md-menu>';
            dotsHtml = dotsHtml + ' <md-button aria-label="More" class="md-icon-button" ng-click="$mdOpenMenu($event)" translate >';
            dotsHtml = dotsHtml + ' <md-icon md-font-icon="icon-dots-vertical"></md-icon>';
            dotsHtml = dotsHtml + '<md-tooltip><span >More</span></md-tooltip>';
            dotsHtml = dotsHtml + '</md-button>';
            dotsHtml = dotsHtml + '<md-menu-content width="3">';
            dotsHtml = dotsHtml + '<md-menu-item>';
            dotsHtml = dotsHtml + '<md-button aria-label="Edit" ng-click="vm.onEditHolidayTap($event,\'' + holidayID + '\')" data-info=\'' + holidayID + '\'>';
            dotsHtml = dotsHtml + '<span>Edit</span>';
            dotsHtml = dotsHtml + '</md-button>';
            dotsHtml = dotsHtml + '</md-menu-item>';
            dotsHtml = dotsHtml + '<md-menu-item>';

            dotsHtml = dotsHtml + '<md-button aria-label="Delete"  ng-click="vm.onDeleteHolidayTap($event,\'' + holidayID + '\',\'' + name + '\')" data-info=\'' + holidayID + '\'>';
            dotsHtml = dotsHtml + '<span >Delete</span>';
            dotsHtml = dotsHtml + '</md-button>';
            dotsHtml = dotsHtml + '</md-menu-item>';
            dotsHtml = dotsHtml + '</md-menu-content>';
            dotsHtml = dotsHtml + '</md-menu>';
            return dotsHtml;
        };
        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn('start_date').withTitle('Date').renderWith(function(data, type, full) {
                if (full.start_date == full.end_date) {
                    return full.start_date;
                }
                else {
                    return (full.start_date) + " " + '-' + " " + (full.end_date);
                }
            }),
            DTColumnBuilder.newColumn(null).withTitle("").notSortable()
                    .renderWith(function(data, type, full, meta) {
                        vm.arrHolidays[data.holidayID] = data;
                        if (userInfo.role_id == 1 || userInfo.role_id == 4) {
                            return getDotsTpl(data.holidayID, data.name);
                        }
                        else {
                            return null;
                        }
                    }),
        ];
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).withOption("responsivePriority", 1),
            DTColumnDefBuilder.newColumnDef(1).withOption("responsivePriority", 3),
            DTColumnDefBuilder.newColumnDef(2).notSortable().withOption("responsivePriority", 2)
        ];

        vm.dtPromiseFn = function(nYear) {
            if (nYear) {
                return vm.getData(nYear);
            }
            else
            {
                return vm.getData((new Date()).getFullYear());
            }

        }
        vm.dtOptions = DTOptionsBuilder.fromFnPromise(vm.dtPromiseFn).withOption('createdRow', function(row, data, dataIndex) {
            $compile(angular.element(row).contents())($scope);
        }).withOption('headerCallback', function(header) {
            if (!vm.headerCompiled) {
                vm.headerCompiled = true;
                $compile(angular.element(header).contents())($scope);
            }
        }).withOption("responsive", true).withOption("bInfo", false).withOption("order", []).withOption('rowCallback', rowCallback);

        function someClickHandler(info) {
            Utils.showLoader(true);
            var dialogData = info;
            dialogData.Status = dialogData.Status == 1 ? true : false;
            dialogData.type = "edit";
            Utils.showLoader(false);
            $mdDialog.show({
                controller: 'AddHolidaysDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/holidays/add-holidays/add-holidays-dialog.html',
                parent: angular.element($document.body),
//                clickOutsideToClose: true,
                locals: {
                    dialogData: angular.copy(dialogData),
                    dtInstance: vm.dtInstance,
                    dtPromiseFn: vm.dtPromiseFn,
                    currentYear: vm.dialogData.Year

                }
            }).then(function(response)
            {
            });
        }
        function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    if (vm.roleID != '2') {
                    vm.someClickHandler(aData);}
                });
            });
            return nRow;
        }

        function changeHoliday(nYear) {
            vm.onChangeYear = true;
            vm.dtInstance.changeData(vm.getData(nYear));
            vm.onChangeYear = false;

        }
        function getData(nYear) {
            Utils.showLoader(true);
            var defer = $q.defer();
            var paginators = vm.paginators;
            if (vm.onChangeYear == true) {
                vm.paginators.curPageIndex = 1;
            } else {
            }

            if (vm.searchDone == true) {
                vm.paginators.curPageIndex = 1;
            }
            else {

            }
            ApiService.GetHoliday({paginators: paginators, data: {"year": nYear, "search": vm.search}}).then(function(response) {
                var data = response.data;
                if (response && response.headerFn) {
                    vm.paginators.setTotal(response.headerFn("totalitemscount"));
                }
                defer.resolve(data);
                setTimeout(function() {
                    Utils.showLoader(false);
                }, 0);

            });
            return defer.promise;
        }
        ;
        vm.checkAll = false;
        vm.onAddHolidayTap = function(e) {
            Utils.showLoader(true);
            var dialogData = {
                "type": "add",
            };
            Utils.showLoader(false);
            $mdDialog.show({
                controller: 'AddHolidaysDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/holidays/add-holidays/add-holidays-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
//                clickOutsideToClose: true,
                locals: {
                    dialogData: dialogData,
                    dtInstance: vm.dtInstance,
                    dtPromiseFn: vm.dtPromiseFn,
                    currentYear: vm.dialogData.Year
                }
            }).then(function(response)
            {

            });
        };

        function reloadData() {

            if (vm.dtInstance.reloadData)
                vm.dtInstance.reloadData();
        }
        $scope.$watch("global.search", function(newValue, oldValue) {

            if (oldValue === "") {
                return;
            }
            vm.search = newValue;
            Utils.showLoader(true);
            vm.searchDone = true;
            vm.dtInstance.changeData(vm.getData(vm.dialogData.Year));
            vm.searchDone = false;
        });
        vm._reloadDtPage = function() {
            vm.dtInstance.changeData(vm.dtPromiseFn(vm.dialogData.Year));
        };

        vm.onDeleteHolidayTap = function(e, holidayID, name) {
            var deleteData = {
                "holidays": [holidayID]
            };
            var confirm = $mdDialog.confirm()
                    .title('Confirm Delete Holiday?')
                    .textContent('Are you sure you want to delete selected Holiday ?')
                    .ariaLabel('Delete')
                    .targetEvent(e)
                    .ok('Delete')
                    .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                Utils.showLoader(true);
                ApiService.DeleteHoliday({
                    data: deleteData,
                    success: function(response) {
                        Utils.showLoader(false);
                        if (response.status == 0) {
                            Utils.showToast({text: response.data.message, 'type': 0});
                        } else {
                            Utils.showToast({text: response.data.message, 'type': 1});
                            vm._reloadDtPage();
                        }
                    }
                });
            }, function() {
            });
        };
        vm.onEditHolidayTap = function(e, holidayID) {
            var dialogData = vm.arrHolidays[holidayID];
            dialogData.Status = dialogData.Status == 1 ? true : false;
            dialogData.type = "edit";
            $mdDialog.show({
                controller: 'AddHolidaysDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/holidays/add-holidays/add-holidays-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
//                clickOutsideToClose: true,
                locals: {
                    dialogData: dialogData,
                    dtInstance: vm.dtInstance,
                    dtPromiseFn: vm.dtPromiseFn,
                    currentYear: vm.dialogData.Year

                }
            }).then(function(response)
            {
            });
        };
        function setSeenTime(seenDate, seenDuration) {
            var dt = new Date(seenDate);
            var duration = new Date(seenDuration);
            var newDate = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), duration.getHours(), duration.getMinutes(), duration.getSeconds(), duration.getMilliseconds());
            var timeZone = new Date().toString().match(/([-\+][0-9]+)\s/)[1];
            return '/Date(' + newDate.getTime() + '' + timeZone + ')/';
        }
        vm.onPrevClick = function(e, pageStartIndex, pageEndIndex, totalItems) {
            vm.paginators.previous(e, pageStartIndex, pageEndIndex, totalItems);
            vm.dtInstance.changeData(vm.getData(vm.dialogData.Year));
        }

        vm.onNextClick = function(e, pageStartIndex, pageEndIndex, totalItems) {
            vm.paginators.next(e, pageStartIndex, pageEndIndex, totalItems);
            vm.dtInstance.changeData(vm.getData(vm.dialogData.Year));
        }

        // Methods

        //////////
    }
})();

(function()
{
    'use strict';

    angular
            .module('app.dashboard', ['720kb.datepicker'])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
    }
})();
(function () {
    'use strict';
    angular
        .module('app.dashboard')
        .controller('DashboardController', DashboardController);
    /** @ngInject */
    function DashboardController(api, usSpinnerService, ApiService, $http, $mdToast, $mdDialog, $document, $q, $compile, $scope, $resource, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, Utils, ConstructTree, GlobalPool, $rootScope, $state, $location) {
        var vm = this;
        vm.arrHolidays = {};
        vm.selected = {};
        vm.dtInstance = {};
        vm.search = "";
        var dialogData = {};
        vm.students = [];
        vm.fullStudents = [];
        vm.studentCurrentPage = 1;
        vm.studentPageCount = 0;
        vm.SOCCurrentPage = 1;
        vm.SOCPageCount = 0;
        vm.EOCCurrentPage = 1;
        vm.SOCPageCount = 0;
        vm.SOCIntakes = [];
        vm.SOCChartLabels = ["", ""];
        vm.SOCChartData = [];
        vm.EOCIntakes = [];
        vm.EOCChartLabels = ["", ""];
        vm.EOCChartData = [];
        vm.SOCFilterDate = "";
        vm.EOCFilterDate = "";
        vm.today = new Date();
        vm.SOCDates = [vm.today];
        vm.EOCDates = [vm.today];
        vm.courseType = Focus.ENUMS.COURSE_FILTERTYPE;
        window.h = vm;

        var userInfo = GlobalPool.getUserInfo();
        vm.userInfo = userInfo;
        console.log(vm.userInfo);
        vm.roleID = userInfo.role_id;

        function init() {
            if (vm.roleID != '1') {
                $location.path('/intake');
            }
            getStudentData();
            getSOCIntakes();
            getEOCIntakes();

            for (var i = 1; i <= 2; i++) {
                var tomorow = new Date(vm.today);
                tomorow.setDate(vm.today.getDate() + i);
                vm.SOCDates.push(tomorow);
            }
            for (var i = 1; i <= 13; i++) {
                var tomorow = new Date(vm.today);
                tomorow.setDate(vm.today.getDate() + i);
                vm.EOCDates.push(tomorow);
            }

        } init();
        vm._onFilterSOCChanged = function () {
            vm.SOCCurrentPage = 1;
            vm.SOCPageCount = 0;
            getSOCIntakes();
        }
        vm._onFilterEOCChanged = function () {
            vm.EOCCurrentPage = 1;
            vm.EOCPageCount = 0;
            getEOCIntakes();
        }
        vm.studentPagination = function (action) {

            if (action == '1') {
                if (vm.studentCurrentPage >= vm.studentPageCount) {
                    return -1;
                }
                vm.studentCurrentPage = vm.studentCurrentPage + 1;
            } else {
                if (vm.studentCurrentPage == 1) {
                    return -1;
                }
                vm.studentCurrentPage = vm.studentCurrentPage - 1;
            }
            getStudentData();
        }
        vm.SOCPagination = function (action) {

            if (action == '1') {
                if (vm.SOCCurrentPage >= vm.SOCPageCount) {
                    return -1;
                }
                vm.SOCCurrentPage = vm.SOCCurrentPage + 1;
            } else {
                if (vm.SOCCurrentPage == 1) {
                    return -1;
                }
                vm.SOCCurrentPage = vm.SOCCurrentPage - 1;
            }
            getSOCIntakes();
        }
        vm.EOCPagination = function (action) {

            if (action == '1') {
                if (vm.EOCCurrentPage >= vm.EOCPageCount) {
                    return -1;
                }
                vm.EOCCurrentPage = vm.EOCCurrentPage + 1;
            } else {
                if (vm.EOCCurrentPage == 1) {
                    return -1;
                }
                vm.EOCCurrentPage = vm.EOCCurrentPage - 1;
            }
            getEOCIntakes();
        }

        function getStudentData() {
            Utils.showLoader(true);
            var defer = $q.defer();
            vm.paginators = new Paginator();
            vm.paginators.curPageIndex = vm.studentCurrentPage;
            var requestData = {
                search: vm.search,
                classType: vm.selectedCourseType,
                classLevel: vm.selectedCourseLevel,
                export: vm.export
            };
            ApiService.GetStudents({
                paginators: vm.paginators,
                data: requestData,
            }).then(function (response) {
                Utils.showLoader(false);
                vm.studentPageCount = Math.ceil(response.headerFn("totalitemscount") / 10);
                var data = response.data;
                // vm.fullStudents = response.data;
                // var filterStudents = []; 
                // for(var i=data.length;i>=(data.length -20);i--){
                //     filterStudents.push(data[i]);
                // }
                vm.students = data;
            });
            return defer.promise;
        };


        function getSOCIntakes() {
            Utils.showLoader(true);
            var defer = $q.defer();
            var requestData = {
                intake: null,
                type: '2',
                room: null,
                teacher: null,
                search: null
            };
            if (vm.SOCFilterDate != '') {
                requestData.filter_date = vm.SOCFilterDate;
            }
            vm.paginators = new Paginator();
            vm.paginators.curPageIndex = vm.SOCCurrentPage;
            ApiService.GetIntake({
                paginators: vm.paginators,
                data: requestData
            }).then(function (response) {
                Utils.showLoader(false);
                vm.SOCPageCount = Math.ceil(response.headerFn("totalitemscount") / 10);
                var intakeList = [];
                intakeList = response.data;
                if (intakeList.length > 0) {
                    for (var i = 0; i < intakeList.length; i++) {
                        var intake = intakeList[i];
                        var courseTypeVal = intake.courseType;
                        for (var j = 0; j < vm.courseType.length; j++) {
                            if (vm.courseType[j].text == courseTypeVal) {
                                var typeName = vm.courseType[j].value;
                            }
                        }
                        if (intake.courseSeries == null) {
                            intake.courseSeries = "";
                        }
                        if (intake.type == "4") {
                            intakeList[i].name = " - ";
                        } else {
                            intakeList[i].name = intake.courseName + " - " + intake.courseLevel + " - " + typeName + '-' + intake.module;
                        }

                        if (intake.type == '6') {
                            var roomcap = '<div style=color:green>(' + intake.student_count + '/8' + ')</div>';
                            intakeList[i].roomcap = roomcap;
                        }
                        if (intake.roomAvailable.length > 0) {

                            if (intake.student_count >= intake.roomAvailable[0].capacity) {
                                var roomcap = '<div style=color:red>(' + intake.student_count + '/' + intake.roomAvailable[0].capacity + ')</div>';
                            } else {
                                var roomcap = '<div style=color:green>(' + intake.student_count + '/' + intake.roomAvailable[0].capacity + ')</div>';
                            }
                            intakeList[i].roomcap = roomcap;
                        } else {
                            intakeList[i].roomcap = "-";
                        }

                    }
                }
                vm.SOCIntakes = intakeList;

                if (response.headerFn("totalitemscount") > 5) {
                    vm.SOCChartData = [5, (response.headerFn("totalitemscount") - 5)];
                } else {
                    vm.SOCChartData = [response.headerFn("totalitemscount"), 0];
                }
            });
        }

        function getEOCIntakes() {
            Utils.showLoader(true);
            var defer = $q.defer();
            var requestData = {
                intake: null,
                type: '1',
                room: null,
                teacher: null,
                search: null
            };
            if (vm.EOCFilterDate != '') {
                requestData.filter_date = vm.EOCFilterDate;
            }
            vm.paginators = new Paginator();
            vm.paginators.curPageIndex = vm.EOCCurrentPage;
            ApiService.GetIntake({
                paginators: vm.paginators,
                data: requestData
            }).then(function (response) {
                Utils.showLoader(false);
                vm.EOCPageCount = Math.ceil(response.headerFn("totalitemscount") / 10);
                var intakeList = [];
                intakeList = response.data;
                if (intakeList.length > 0) {
                    for (var i = 0; i < intakeList.length; i++) {
                        var intake = intakeList[i];
                        var courseTypeVal = intake.courseType;
                        for (var j = 0; j < vm.courseType.length; j++) {
                            if (vm.courseType[j].text == courseTypeVal) {
                                var typeName = vm.courseType[j].value;
                            }
                        }
                        if (intake.courseSeries == null) {
                            intake.courseSeries = "";
                        }
                        if (intake.type == "4") {
                            intakeList[i].name = " - ";
                        } else {
                            intakeList[i].name = intake.courseName + " - " + intake.courseLevel + " - " + typeName + '-' + intake.module;
                        }

                        if (intake.type == '6') {
                            var roomcap = '<div style=color:green>(' + intake.student_count + '/8' + ')</div>';
                            intakeList[i].roomcap = roomcap;
                        }
                        if (intake.roomAvailable.length > 0) {

                            if (intake.student_count >= intake.roomAvailable[0].capacity) {
                                var roomcap = '<div style=color:red>(' + intake.student_count + '/' + intake.roomAvailable[0].capacity + ')</div>';
                            } else {
                                var roomcap = '<div style=color:green>(' + intake.student_count + '/' + intake.roomAvailable[0].capacity + ')</div>';
                            }
                            intakeList[i].roomcap = roomcap;
                        } else {
                            intakeList[i].roomcap = "-";
                        }

                    }
                }
                vm.EOCIntakes = intakeList;
                if (response.headerFn("totalitemscount") > 5) {
                    vm.EOCChartData = [5, (response.headerFn("totalitemscount") - 5)];
                } else {
                    vm.EOCChartData = [response.headerFn("totalitemscount"), 0];
                }
            });
        }

        vm.onCreateStudentTap = function (e) {
            Utils.showLoader(true);
            var dialogData = {
                "type": "add",
                "Status": true
            };
            ApiService.GetStudentId({}).then(function (response) {
                if (response.status == 1) {
                    dialogData.studentId_number = response.data;
                }
                Utils.showLoader(false);
                $mdDialog.show({
                    controller: 'AddStudentsDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/students/add-students/add-students-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    //                    clickOutsideToClose: true,
                    locals: {
                        dialogData: dialogData,
                        dtInstance: vm.dtInstance,
                        dtPromiseFn: vm.dtPromiseFn
                    }
                }).then(function (response) {

                });
            });
        };

        vm.onCreateAdHocClassTap = function (e) {
            Utils.showLoader(true);
            var dialogData = {
                "dialogtype": "add",
                "Status": true,
            };
            var requestData = {
                'flexible': 0,
                'course_type': 'G'
            }

            Utils.showLoader(false);
            $mdDialog.show({
                controller: 'AddAdhocClassDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dashboard/add-adhoc-class/add-adhoc-class-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                //                        clickOutsideToClose: true,
                locals: {
                    dialogData: angular.copy(dialogData),
                    dtInstance: vm.dtInstance,
                    dtPromiseFn: vm.dtPromiseFn,
                    updateScheduler : ''
                }
            }).then(function (response) {

            });

        };

        vm.onCheckAvailableRoomTap = function (e) {
            Utils.showLoader(true);
            var dialogData = {
                "dialogtype": "add",
                "Status": true,
            };
            var requestData = {
                'flexible': 0,
                'course_type': 'G'
            }

            Utils.showLoader(false);
            $mdDialog.show({
                controller: 'CheckAvailableRoomDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dashboard/available-room/check-available-room-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                //                        clickOutsideToClose: true,
                locals: {
                    dialogData: angular.copy(dialogData),
                    dtInstance: vm.dtInstance,
                    dtPromiseFn: vm.dtPromiseFn,
                    updateScheduler : ''
                }
            }).then(function (response) {

            });

        };

        vm.onCreateIntakeTap = function (e) {
            Utils.showLoader(true);
            var dialogData = {
                "dialogtype": "add",
                "Status": true,
            };
            var requestData = {
                'flexible': 0,
                'course_type': 'G'
            }
            ApiService.GetUniqueCourseList({
                data: requestData
            }).then(function (response) {
                var arrCourses = response.data;

                var courseobj = [];
                for (var i = 0; i < arrCourses.length; i++) {
                    courseobj.push({
                        courseID: arrCourses[i].courseID,
                        validity: arrCourses[i].validity,
                        class_duration: arrCourses[i].class_duration,
                        capacity: arrCourses[i].batch,
                        language: arrCourses[i].language,
                        title: arrCourses[i].title,
                        recurrence_rule: arrCourses[i].recurrence_rule,
                        total_class_duration: arrCourses[i].no_of_classes,
                        series: arrCourses[i].series,
                        level: arrCourses[i].level,
                        books: arrCourses[i].books,
                        type: arrCourses[i].type
                    });
                }
                Utils.showLoader(false);
                $mdDialog.show({
                    controller: 'AddIntakeDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/intake/add-intake/add-intake-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    //                        clickOutsideToClose: true,
                    locals: {
                        dialogData: angular.copy(dialogData),
                        dtInstance: vm.dtInstance,
                        courseoptions: courseobj,
                        studentsobj: {},
                        dtPromiseFn: vm.dtPromiseFn
                    }
                }).then(function (response) {

                });
            });
        };

        vm.backToIntake = function (type) {
            $rootScope.$root.intakeType = type;
            $state.go('app.intakes');
        }
        vm.redirectToIntakeEnrollment = function (intakeID) {
            // $rootScope.$root.intakeID = intakeID;
            window.open('/intake?intake_id=' + intakeID, '_blank');
            // $state.go('app.intakes');
        }
        vm.showStudentEnrollment = function (student) {
            $rootScope.$root.studentID = student.studentID;
            $rootScope.$root.students = vm.students;
            $state.go('app.students');

        };


    }
})();

(function() {
    'use strict';
    angular
        .module('app.courses')
        .controller('CoursesController', CoursesController);
    /** @ngInject */
    function CoursesController(api, usSpinnerService, ApiService, $http, $mdToast, $mdDialog, $document, $compile, GlobalPool, $scope, $q, $resource, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, Utils) {
        var vm = this;
        vm.arrCourses = {};
        vm.dtInstance = {};
        vm.getData = getData;
        vm.reloadData = reloadData;
        vm.CType = null;
        vm.CLanguage = null;
        vm.CRecurrance = null;
        vm.search = "";
        vm.setView = false;
        vm.showDeletedCourses = false;

        var userInfo = GlobalPool.getUserInfo();
        vm.someClickHandler = someClickHandler;
        if (userInfo.role_id == 1 || userInfo.role_id == 4) {
            vm.setView = true;
        }
        // Paginators
        vm.courseType = Focus.ENUMS.COURSE_FILTERTYPE,
            //                vm.courseLanguage = Focus.ENUMS.COURSE_LANGUAGE,
            vm.courseRecurrance = Focus.ENUMS.COURSE_RECURRANCE,
            vm.paginators = new Paginator();
        ApiService.GetSkills({}).then(function(response) {
            if (response.data.length > 0) {
                vm.courseLanguage = response.data;
            }
        });
        vm.dtPromiseFn = function() {
            return vm.getData();
        }
        var getDotsTpl = function(courseID, Language) {
            var dotsHtml = "";
            if (vm.showDeletedCourses == false) {

                dotsHtml = dotsHtml + '<md-menu>';
                dotsHtml = dotsHtml + ' <md-button aria-label="More" class="md-icon-button" ng-click="$mdOpenMenu($event)" translate >';
                dotsHtml = dotsHtml + ' <md-icon md-font-icon="icon-dots-vertical"></md-icon>';
                dotsHtml = dotsHtml + '<md-tooltip><span >More</span></md-tooltip>';
                dotsHtml = dotsHtml + '</md-button>';
                dotsHtml = dotsHtml + '<md-menu-content width="3">';
                dotsHtml = dotsHtml + '<md-menu-item>';
                dotsHtml = dotsHtml + '<md-button aria-label="Edit" ng-click="vm.onEditCourseTap($event,\'' + courseID + '\')" data-info=\'' + courseID + '\'>';
                dotsHtml = dotsHtml + '<span>Edit</span>';
                dotsHtml = dotsHtml + '</md-button>';
                dotsHtml = dotsHtml + '</md-menu-item>';
                dotsHtml = dotsHtml + '<md-menu-item>';
                dotsHtml = dotsHtml + '<md-button aria-label="Delete"  ng-click="vm.onDeleteCourseTap($event,\'' + courseID + '\',\'' + Language + '\')" data-info=\'' + courseID + '\'>';
                dotsHtml = dotsHtml + '<span >Delete</span>';
                dotsHtml = dotsHtml + '</md-button>';
                dotsHtml = dotsHtml + '</md-menu-item>';
                dotsHtml = dotsHtml + '</md-menu-content>';
                dotsHtml = dotsHtml + '</md-menu>';
            } else {
                dotsHtml = dotsHtml + '<md-menu>';
                dotsHtml = dotsHtml + ' <md-button aria-label="More" class="md-icon-button" ng-click="$mdOpenMenu($event)" translate >';
                dotsHtml = dotsHtml + ' <md-icon md-font-icon="icon-dots-vertical"></md-icon>';
                dotsHtml = dotsHtml + '<md-tooltip><span >More</span></md-tooltip>';
                dotsHtml = dotsHtml + '</md-button>';

                dotsHtml = dotsHtml + '<md-menu-content width="3">';
                dotsHtml = dotsHtml + '<md-menu-item>';
                dotsHtml = dotsHtml + '<md-button aria-label="Delete"  ng-click="vm.onReActivateCourseTap($event,\'' + courseID + '\',\'' + Language + '\')" data-info=\'' + courseID + '\'>';
                dotsHtml = dotsHtml + '<span >ReActivate</span>';
                dotsHtml = dotsHtml + '</md-button>';
                dotsHtml = dotsHtml + '</md-menu-item>';

                dotsHtml = dotsHtml + '</md-menu-content>';
                dotsHtml = dotsHtml + '</md-menu>';
            }
            return dotsHtml;
        };
        vm.dtOptions = DTOptionsBuilder.fromFnPromise(vm.dtPromiseFn).withOption('createdRow', function(row, data, dataIndex) {
            $compile(angular.element(row).contents())($scope);
        }).withOption('headerCallback', function(header) {
            if (!vm.headerCompiled) {
                vm.headerCompiled = true;
                $compile(angular.element(header).contents())($scope);
            }
        }).withOption("responsive", true).withOption("bInfo", false).withOption("order", [1, 'asc']).withOption('rowCallback', rowCallback);;

        function someClickHandler(info) {

            var dialogData = info;
            Utils.showLoader(true);

            dialogData.Status = dialogData.Status == 1 ? true : false;
            dialogData.Type = "edit";

            ApiService.GetSkills({}).then(function(response) {
                var arrSkills = response.data;
                ApiService.GetBooks({}).then(function(response) {
                    var arrBooks = response.data;
                    Utils.showLoader(false);
                    $mdDialog.show({
                        controller: 'AddCoursesDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/courses/add-courses/add-courses-dialog.html',
                        parent: angular.element($document.body),
                        //                        targetEvent: e,
                        //                        clickOutsideToClose: true,
                        locals: {
                            dialogData: dialogData,
                            dtInstance: vm.dtInstance,
                            arrSkills: arrSkills,
                            arrBooks: arrBooks,
                            dtPromiseFn: vm.dtPromiseFn

                        }
                    }).then(function(response) {});
                });
            });
        }

        vm.onReActivateCourseTap = function(e, id, name) {
            var reActivateData = {
                "id": id
            }
            var confirm = $mdDialog.confirm()
                .title('Confirm Reactivate Course?')
                .textContent('Are you sure you want to re-activate selected Course ?')
                .ariaLabel('reactivateCourse')
                .targetEvent(e)
                .ok('Re-activate')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                Utils.showLoader(true);
                ApiService.ReActivateCourse({
                    data: reActivateData,
                    success: function(response) {
                        Utils.showLoader(false);
                        if (response.status == 0) {
                            Utils.showToast({ text: response.data.message, 'type': 0 });
                        } else {
                            Utils.showToast({ text: response.data.message, 'type': 1 });
                            vm._reloadDtPage();
                        }
                    }
                });
            }, function() {});
        };

        function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    vm.someClickHandler(aData);
                });
            });
            return nRow;
        }

        vm.dtColumns = [
            DTColumnBuilder.newColumn('courseID').withTitle('courseID').notVisible().withClass('g-hidden'),
            DTColumnBuilder.newColumn('course_modules').withTitle('Modules').notVisible().withClass('g-hidden'),
            DTColumnBuilder.newColumn('title').withTitle('Title'),
            DTColumnBuilder.newColumn('level').withTitle('Level'),
            // DTColumnBuilder.newColumn('series').withTitle('Series').renderWith(function(data, type, full, meta) {

            //   if (full.series) {
            //     return full.series;
            //   } else {
            //     return null;
            //   }
            // }),
            DTColumnBuilder.newColumn('type').withTitle('Type').renderWith(function(data, type, full) {
                var courseVal = full.type;
                for (var i = 0; i < vm.courseType.length; i++) {
                    if (vm.courseType[i].text == courseVal) {
                        return vm.courseType[i].value;
                    }
                }

            }),
            DTColumnBuilder.newColumn('recurrence_rule').withTitle('Recurrence'),
            DTColumnBuilder.newColumn('no_of_classes').withTitle('Total Duration').renderWith(function(data, type, full) {
                if (full.no_of_classes) {
                    var no_of_classes = parseFloat(full.no_of_classes);
                }
                if (full.class_duration) {
                    var class_duration = parseFloat(full.class_duration);
                }
                return (no_of_classes * class_duration);
            }),
            //            DTColumnBuilder.newColumn('no_of_classes').withTitle('Lessons'),
            //             DTColumnBuilder.newColumn('skills').withTitle('Language'),
            //            DTColumnBuilder.newColumn('books').withTitle('Books'),
            DTColumnBuilder.newColumn(null).withTitle("").notSortable()
            .renderWith(function(data, type, full, meta) {

                vm.arrCourses[data.courseID] = data;
                if (userInfo.role_id == 1 || userInfo.role_id == 4) {
                    return getDotsTpl(data.courseID, data.language);
                } else {
                    return null;
                }
            })

        ];
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).withOption("responsivePriority", 1),
            DTColumnDefBuilder.newColumnDef(7).notSortable().withOption("responsivePriority", 2)

        ];

        function getData() {

            Utils.showLoader(true);
            var defer = $q.defer();
            var requestData = {
                type: vm.CType,
                language: vm.CLanguage,
                recurrence_rule: vm.CRecurrance,
                search: vm.search,
                showDeletedCourses: vm.showDeletedCourses,
            };
            if (vm.changeFilter == true) {
                vm.paginators.curPageIndex = 1;
            }
            if (vm.searchDone == true) {
                vm.paginators.curPageIndex = 1;
            } else {

            }
            ApiService.GetCourse({ paginators: vm.paginators, data: requestData }).then(function(response) {
                var data = response.data;
                if (response && response.headerFn) {
                    vm.paginators.setTotal(response.headerFn("totalitemscount"));
                }
                defer.resolve(data);
                setTimeout(function() {
                    Utils.showLoader(false);
                }, 0)


            });
            return defer.promise;
        };

        vm.onClearFiltersTap = function() {
            vm.CType = null;
            vm.CLanguage = null;
            vm.CRecurrance = null;
            vm.showDeletedCourses = false;
            vm.dtInstance.changeData(vm.getData());
        }
        vm.onPrevClick = function(e, pageStartIndex, pageEndIndex, totalItems) {
            vm.paginators.previous(e, pageStartIndex, pageEndIndex, totalItems);
            vm.dtInstance.changeData(vm.getData());
        }

        vm.onNextClick = function(e, pageStartIndex, pageEndIndex, totalItems) {
                vm.paginators.next(e, pageStartIndex, pageEndIndex, totalItems);
                vm.dtInstance.changeData(vm.getData());
            }
            //        $(function() {
            //            $('.ms-search-bar #ms-search-bar-collapser').click(function() {
            //                if ($('#ms-search-bar-input').val().length > 0) {
            //                    $('#ms-search-bar-input').val('');
            //                    $scope.global.search = '';
            //                    Utils.showLoader(true);
            //                }
            //            });
            //        });

        $scope.$on("changeSearch", function(event, args) {
            vm.searchDone = true;
            vm.dtInstance.changeData(vm.getData());
            vm.searchDone = false;
        });

        function reloadData() {
            if (vm.dtInstance.reloadData)
                vm.dtInstance.reloadData();
        }

        vm._reloadDtPage = function() {
            vm.dtInstance.changeData(vm.dtPromiseFn());
        };

        vm._onFilterChanged = function(val) {
            vm.changeFilter = true;
            vm.dtInstance.changeData(vm.getData());
            vm.changeFilter = false;
        };
        $scope.$watch("global.search", function(newValue, oldValue) {

            if (oldValue === "") {
                return;
            }

            vm.search = newValue;
            Utils.showLoader(true);
            vm.searchDone = true;
            vm.dtInstance.changeData(vm.getData());
            vm.searchDone = false;
        });
        vm.onCreateCourseTap = function(e) {
            Utils.showLoader(true);
            var dialogData = {
                "Type": "add",
                "Status": true
            };
            ApiService.GetSkills({}).then(function(response) {
                var arrSkills = response.data;
                ApiService.GetBooks({}).then(function(response) {
                    var arrBooks = response.data;
                    Utils.showLoader(false);
                    $mdDialog.show({
                        controller: 'AddCoursesDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/courses/add-courses/add-courses-dialog.html',
                        parent: angular.element($document.body),
                        targetEvent: e,
                        //                        clickOutsideToClose: true,
                        locals: {
                            dialogData: dialogData,
                            dtInstance: vm.dtInstance,
                            arrSkills: arrSkills,
                            arrBooks: arrBooks,
                            dtPromiseFn: vm.dtPromiseFn
                        }
                    }).then(function(response) {

                    });
                });
            });
        };
        vm.onDeleteCourseTap = function(e, courseId, language) {
            // var checkData = {
            //     "courseID": courseId
            // }
            // ApiService.checkCourseDelete({
            //     data: checkData,
            //     success: function(response) {
            //         if (response.status == 1) {
            //             Utils.showToast({ text: response.data.message, 'type': 1 });
            //         } else {
                        var deleteData = {
                            "courses": [courseId]
                        }
                        var confirm = $mdDialog.confirm()
                            .title('Confirm Delete Course?')
                            .textContent('Are you sure you want to delete Selected Course ?')
                            .ariaLabel('Delete')
                            .targetEvent(e)
                            .ok('Delete')
                            .cancel('Cancel');
                        $mdDialog.show(confirm).then(function() {
                            Utils.showLoader(true);
                            ApiService.DeleteCourse({
                                data: deleteData,
                                success: function(response) {

                                    Utils.showLoader(false);
                                    if (response.status === 0) {
                                        Utils.showToast({ text: response.data.message, 'type': 0 });
                                    } else {
                                        Utils.showToast({ text: response.data.message, 'type': 1 });
                                        vm._reloadDtPage();
                                    }
                                }
                            });
                        }, function() {});
                    // }
            //     }
            // });
        };
        vm.onEditCourseTap = function(e, courseID) {
            var dialogData = vm.arrCourses[courseID];
            dialogData.Status = dialogData.Status == 1 ? true : false;
            dialogData.Type = "edit";
            ApiService.GetSkills({}).then(function(response) {
                var arrSkills = response.data;
                ApiService.GetBooks({}).then(function(response) {
                    var arrBooks = response.data;
                    $mdDialog.show({
                        controller: 'AddCoursesDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/courses/add-courses/add-courses-dialog.html',
                        parent: angular.element($document.body),
                        targetEvent: e,
                        //                        clickOutsideToClose: true,
                        locals: {
                            dialogData: dialogData,
                            dtInstance: vm.dtInstance,
                            arrSkills: arrSkills,
                            arrBooks: arrBooks,
                            dtPromiseFn: vm.dtPromiseFn
                        }
                    }).then(function(response) {});
                });
            });
            //            console.log("cmdata : "+courseModuleData);

        };
        // Methods

        //////////
    }
})();
(function()
{
    'use strict';
    angular
            .module('app.change_teacher', ['ui.timepicker'])
            .config(config);
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.change_teacher', {
            url: '/change-teacher',

            views: {
                'content@app': {
                    templateUrl: 'app/main/change-teacher/change-teacher.html',
                    controller: 'ChangeTeacherController as vm'
                },
                'toolbar@app': {
                    templateUrl: 'app/toolbar/layouts/mark-attendance/toolbar.html',
                    controller: 'ToolbarController as vm'
                },
                'navigation@app': {
                    templateUrl: 'app/navigation/layouts/mark-attendance/navigation.html',
                    controller: 'NavigationController as vm'
                },
            },
            bodyClass: 'reset-password'
        });
    }
})();

//                                views: {
//                                'main@': {
//                                templateUrl: 'app/core/layouts/content-only.html',
//                                        controller: 'MainController as vm'
//                                },
//                                        'content@app.attendance_mark': {
//                                        templateUrl: 'app/main/mark-attendance/mark-attendance.html',
//                                                controller: 'MarkAttedanceController as vm'
//                                        }
//                                },
(function () {
    'use strict';

    angular.module('app.change_teacher').config(function ($mdDateLocaleProvider) {
        $mdDateLocaleProvider.formatDate = function (date) {
            return date ? moment(date).format('DD-MM-YYYY') : '';
        };
        $mdDateLocaleProvider.parseDate = function (dateString) {
            var m = moment(dateString, 'DD-MM-YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };
    })
            .controller('ChangeTeacherController', ChangeTeacherController);

    /** @ngInject */
    function ChangeTeacherController(api, usSpinnerService, ApiService, $http, $location, $mdToast, $rootScope, $mdDialog, $document, $compile, $scope, $q, $resource, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, Utils) {

        var vm = this;
        vm.closeDialog = closeDialog;
        vm.btnDisable = false;

        var param = $location.search();

        if (param.intakeID && param.date) {
            Utils.showLoader(true);
            var requestData = {
                intakeID: param.intakeID,
                date: param.date
            }
            ApiService.TrainerSelected({
                data: requestData
            }).then(function (response) {
                if (response.status == 0) {
                    vm.btnDisable = true;
                    //                    Utils.showLoader(false);
                    if (response.data.message) {
                        Utils.showToast({
                            text: response.data.message,
                            'type': 0
                        });
                        $location.url($location.path("/login"));
                    }
                } else {
                    Utils.showLoader(false);
                    vm.data = response.data;
                    $rootScope.teacher_name = vm.data.teacher_name;
                    $rootScope.course_name = vm.data.course_name;
                    $rootScope.intakeID = vm.data.intakeID;
                    $rootScope.schedule_date = vm.data.schedule_date;
                    $rootScope.full_course_name = vm.data.full_course_name;
                    $rootScope.class_start_date = vm.data.class_start_date;
                    $rootScope.duration = vm.data.duration;
                    $rootScope.start_time = vm.data.start_time;
                    $rootScope.room = vm.data.room;
                    vm.teacherId = vm.data.teacher_id
                    getFilteredTeacher();
                }
            });
        }
        function getFilteredTeacher(){
            Utils.showLoader(true);
            var requestData = {
                'schedule_class_id' : vm.data.schedule_class_id,
                'selected_date' : vm.data.schedule_date_formatted,
                'startTime' : vm.data.start_time_formatted,
                'endTime' : vm.data.end_time_formatted
            }
            ApiService.TeacherAvailability({
                data: requestData
            }).then(function (response) {
                if (response.status == 0) {
                    Utils.showLoader(false);
                    if (response.data.message) {
                        Utils.showToast({
                            text: response.data.message,
                            'type': 0
                        });
                    }
                } else {
                    Utils.showLoader(false);
                    vm.filterTeachers = response.data;
                    vm.filterTeachers.push({"id" : vm.data.teacher_id, "full_name" : vm.data.teacher_name});
                }
            });
        }
        // Paginators

        vm.ToggleCheckbox = function (e, value) {
            var arrAttendance = vm.attendanceObj;
        }

        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(dtPromiseFn());
        };
        
        function closeDialog() {
            $mdDialog.cancel();
        }
        
        vm.onSaveBtnTap = function (e) {
            
            var requestData = {
                teacher_id : vm.teacherId,
                schedule_class_id : vm.data.schedule_class_id,
                scheduleDate : vm.data.schedule_date_formatted
            }
            ApiService.TrainerSave({
                data: requestData,
                success: function (response) {
                    if (response.status == 0) {
                        Utils.showLoader(false);
                        Utils.showToast({
                            text: response.data.message,
                            'type': 0
                        });
                    } else {
                        Utils.showLoader(false);
                        Utils.showToast({
                            text: response.data.message,
                            'type': 1
                        });
                    }
                }
            });
        }

    }
})();

(function()
{
    'use strict';

    angular
            .module('app.books')
            .controller('BooksController', BooksController);

    /** @ngInject */
    function BooksController(api, usSpinnerService, ApiService, $http, $mdToast, $mdDialog, $document, $compile, $scope, $q, $resource, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, Utils)
    {
        var vm = this;
        vm.arrBooks = {};
        vm.dtInstance = {};
        vm.getData = getData;
        vm.reloadData = reloadData;
        vm.search = "";
        vm.someClickHandler = someClickHandler;
        // Paginators

//        $(function() {
//            $('.ms-search-bar #ms-search-bar-collapser').click(function() {
//                if ($('#ms-search-bar-input').val().length > 0) {
//                    $('#ms-search-bar-input').val('');
//                    $scope.global.search = '';
//                    Utils.showLoader(true);
//                    vm.search = $scope.global.search;
//                    vm.searchDone = true;
//                    Utils.showLoader(false);
//                    vm.dtInstance.changeData(vm.getData());
//
//                    vm.searchDone = false;
//                }
//            });
//        });
        $scope.$on("changeSearch", function(event, args) {
            vm.searchDone = true;
            vm.dtInstance.changeData(vm.getData());
            vm.searchDone = false;
        }
        );
        vm.paginators = new Paginator();

        var getDotsTpl = function(id, name) {
            var dotsHtml = "";
            dotsHtml = dotsHtml + '<md-menu>';
            dotsHtml = dotsHtml + ' <md-button aria-label="More" class="md-icon-button" ng-click="$mdOpenMenu($event)" translate >';
            dotsHtml = dotsHtml + ' <md-icon md-font-icon="icon-dots-vertical"></md-icon>';
            dotsHtml = dotsHtml + '<md-tooltip><span >More</span></md-tooltip>';
            dotsHtml = dotsHtml + '</md-button>';
            dotsHtml = dotsHtml + '<md-menu-content width="3">';
            dotsHtml = dotsHtml + '<md-menu-item>';
            dotsHtml = dotsHtml + '<md-button aria-label="Edit" ng-click="vm.onEditRoomTap($event,\'' + id + '\')" data-info=\'' + id + '\'>';
            dotsHtml = dotsHtml + '<span>Edit</span>';
            dotsHtml = dotsHtml + '</md-button>';
            dotsHtml = dotsHtml + '</md-menu-item>';
            dotsHtml = dotsHtml + '<md-menu-item>';

            dotsHtml = dotsHtml + '<md-button aria-label="Delete"  ng-click="vm.onDeleteRoomTap($event,\'' + id + '\',\'' + name + '\')" data-info=\'' + id + '\'>';
            dotsHtml = dotsHtml + '<span >Delete</span>';
            dotsHtml = dotsHtml + '</md-button>';
            dotsHtml = dotsHtml + '</md-menu-item>';
            dotsHtml = dotsHtml + '</md-menu-content>';
            dotsHtml = dotsHtml + '</md-menu>';
            return dotsHtml;
        };
        vm.dtPromiseFn = function() {
            return vm.getData();

        }

        vm._reloadDtPage = function() {
            vm.dtInstance.changeData(vm.dtPromiseFn());
        };
        vm.dtOptions = DTOptionsBuilder.fromFnPromise(vm.dtPromiseFn).withOption('createdRow', function(row, data, dataIndex) {
            $compile(angular.element(row).contents())($scope);
        }).withOption('headerCallback', function(header) {
            if (!vm.headerCompiled) {
                vm.headerCompiled = true;
                $compile(angular.element(header).contents())($scope);
            }
        }).withOption("responsive", true).withOption("bInfo", false).withOption("order", [1, 'desc']).withOption('rowCallback', rowCallback);

        function someClickHandler(info) {
            var dialogData = info;
            Utils.showLoader(true);
            dialogData.type = "edit";
            ApiService.GetSkills({}).then(function(response) {
                var arrSkills = response.data;
                Utils.showLoader(false);
                $mdDialog.show({
                    controller: 'AddBooksDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/books/add-books/add-books-dialog.html',
                    parent: angular.element($document.body),
//                    clickOutsideToClose: true,
                    locals: {
                        dialogData: dialogData,
                        dtInstance: vm.dtInstance,
                        arrSkills: arrSkills,
                        dtPromiseFn: vm.dtPromiseFn

                    }
                }).then(function(response)
                {
                });
            });
        }

        function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    vm.someClickHandler(aData);
                });
            });
            return nRow;
        }
        vm.dtColumns = [
            DTColumnBuilder.newColumn('title').withTitle('Name'),
            DTColumnBuilder.newColumn('skill').withTitle('Language'),
            DTColumnBuilder.newColumn(null).withTitle("").notSortable()
                    .renderWith(function(data, type, full, meta) {
                        vm.arrBooks[data.id] = data;
                        return getDotsTpl(data.id, data.title);
                    })
        ];
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).withOption("responsivePriority", 1),
            DTColumnDefBuilder.newColumnDef(2).notSortable().withOption("responsivePriority", 2)
        ];


        function getData() {
            Utils.showLoader(true);
            var defer = $q.defer();
            var requestData = {
                search: vm.search
            };
            if (vm.searchDone == true) {
                vm.paginators.curPageIndex = 1;
            }
            else {

            }
            ApiService.GetBooks({paginators: vm.paginators, data: requestData}).then(function(response) {
                var data = response.data;
                if (response && response.headerFn) {
                    vm.paginators.setTotal(response.headerFn("totalitemscount"));
                }
                defer.resolve(data);
                setTimeout(function() {
                    Utils.showLoader(false);
                }, 0)
            });
            return defer.promise;

        }



        vm.onPrevClick = function(e, pageStartIndex, pageEndIndex, totalItems) {
            vm.paginators.previous(e, pageStartIndex, pageEndIndex, totalItems);
            vm.dtInstance.changeData(vm.getData());
        }

        vm.onNextClick = function(e, pageStartIndex, pageEndIndex, totalItems) {
            vm.paginators.next(e, pageStartIndex, pageEndIndex, totalItems);
            vm.dtInstance.changeData(vm.getData());
        }

        function reloadData() {
            if (vm.dtInstance.reloadData)
                vm.dtInstance.reloadData();
        }

        $scope.$watch("global.search", function(newValue, oldValue) {

            if (oldValue === "") {
                return;
            }
            vm.search = newValue;
            Utils.showLoader(true);
            vm.searchDone = true;
            vm.dtInstance.changeData(vm.getData());
//            Utils.showLoader(false);
            vm.searchDone = false;
        });
        vm.onCreateBookTap = function(e) {
            Utils.showLoader(true);
            var dialogData = {
                "type": "add",
            };

            ApiService.GetSkills({}).then(function(response) {
                var arrSkills = response.data;
                Utils.showLoader(false);
                $mdDialog.show({
                    controller: 'AddBooksDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/books/add-books/add-books-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
//                    clickOutsideToClose: true,
                    locals: {
                        dialogData: dialogData,
                        dtInstance: vm.dtInstance,
                        arrSkills: arrSkills,
                        dtPromiseFn: vm.dtPromiseFn
                    }
                }).then(function(response)
                {

                });
            });
        };
        vm.onDeleteRoomTap = function(e, id, name) {
            var deleteData = {
                "books": [id]
            }
            var confirm = $mdDialog.confirm()
                    .title('Confirm Delete Book?')
                    .textContent('Are you sure you want to delete selected Book ?')
                    .ariaLabel('Delete')
                    .targetEvent(e)
                    .ok('Delete')
                    .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                Utils.showLoader(true);
                ApiService.DeleteBooks({
                    data: deleteData,
                    success: function(response) {
                        Utils.showLoader(false);
                        if (response.status === 0) {
                            Utils.showToast({text: response.data.message, 'type': 0});
                        } else {

                            Utils.showToast({text: response.data.message, 'type': 1});
                            vm._reloadDtPage();
                        }
                    }
                });
            }, function() {
            });
        };

        vm.onEditRoomTap = function(e, id) {
            var dialogData = vm.arrBooks[id];
            dialogData.type = "edit";
            ApiService.GetSkills({}).then(function(response) {
                var arrSkills = response.data;
                $mdDialog.show({
                    controller: 'AddBooksDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/books/add-books/add-books-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
//                    clickOutsideToClose: true,
                    locals: {
                        dialogData: dialogData,
                        dtInstance: vm.dtInstance,
                        arrSkills: arrSkills,
                        dtPromiseFn: vm.dtPromiseFn

                    }
                }).then(function(response)
                {
                });
            });
        };



        // Methods

        //////////
    }
})();
(function() {
    'use strict';
    angular
        .module('app.attendance')
        .controller('AttendanceController', AttendanceController);

    /** @ngInject */
    function AttendanceController(api, usSpinnerService, ApiService, $http, $mdToast, $mdDialog, $location, $document, $compile, $scope, $q, $resource, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, Utils, GlobalPool, $rootScope) {
        var vm = this;
        vm.roleID = $rootScope.roleID;
        vm.arrCourses = {};
        vm.dtInstance = {};
        vm.getData = getData;
        vm.reloadData = reloadData;
        vm.openDataDlg = openDataDlg;
        // Paginators
        vm.selectedTeacher = null;
        vm.CIntake = null;
        vm.CStartDate = null;
        vm.CEndDate = null;
        vm.search = "";
        vm.daysEnums = Focus.ENUMS.RECURRANCE_DAYS;
        vm.courseType = Focus.ENUMS.COURSE_TYPE,
            vm.courseLanguage = Focus.ENUMS.COURSE_LANGUAGE,
            vm.courseRecurrance = Focus.ENUMS.COURSE_RECURRANCE,
            vm.paginators = new Paginator();
        var userInfo = GlobalPool.getUserInfo();
        vm.setAuthToken = userInfo.auth_token;
        vm.setAuthDownloadLink = api.baseURI;

        vm.appendHref = function(intakeid, schedule_class_id, type, e) {
            Utils.showLoader(true);
            var requestData = {
                intake_id: intakeid,
                schedule_class_id : schedule_class_id,
                type: type
            };
            ApiService.GetAttendanceReport({ data: requestData }).then(function(response) {
                var dialogData = response.data[0];
                vm.studentsData = response.data[0].attendances;
                vm.dateList = response.data[0].scheduleDates;
                dialogData.end_date = response.data[0].end_date;
                dialogData.start_date = response.data[0].start_date;
                dialogData.btnEnable = response.data[0].enableCertificate;
                dialogData.intake_id = response.data[0].intakeID;
                dialogData.schedule_class_id = response.data[0].schedule_class_id;
                var arrSchedules = response.data[0].scheduleDates;
                var arrAttendances = response.data[0].attendances;
                var curAttList = null,
                    curScheduleObj = null,
                    curAttListobj = null,
                    bAllow, countEligible = 0;
                for (var i = 0; i < arrAttendances.length; i++) {
                    curAttList = arrAttendances[i].attendanceList;
                    if (response.data[0].enableCertificate == 1) {
                        if (arrAttendances[i].isEligible == 1) {
                            countEligible = countEligible + 1;
                        }
                    }
                }
                if (countEligible >= 1) {
                    var url = vm.setAuthDownloadLink + "download-certificates?auth_token=" + vm.setAuthToken + "&intake_id=" + intakeid;
                    window.open(url, 'Download');
                    Utils.showLoader(false);
                } else {
                    Utils.showLoader(false);
                    Utils.showToast({ text: "No students eligible to generate certificates", 'type': 0 });
                }
            });
        }

        var getDotsTpl = function(courseID, Language) {
            var dotsHtml = "";
            dotsHtml = dotsHtml + '<md-menu>';
            dotsHtml = dotsHtml + ' <md-button aria-label="More" class="md-icon-button" ng-click="$mdOpenMenu($event)" translate >';
            dotsHtml = dotsHtml + ' <md-icon md-font-icon="icon-dots-vertical"></md-icon>';
            dotsHtml = dotsHtml + '<md-tooltip><span >More</span></md-tooltip>';
            dotsHtml = dotsHtml + '</md-button>';
            dotsHtml = dotsHtml + '<md-menu-content width="3">';
            dotsHtml = dotsHtml + '<md-menu-item>';
            dotsHtml = dotsHtml + '<md-button aria-label="Edit" ng-click="vm.onEditCourseTap($event,\'' + courseID + '\')" data-info=\'' + courseID + '\'>';
            dotsHtml = dotsHtml + '<span>Edit</span>';
            dotsHtml = dotsHtml + '</md-button>';
            dotsHtml = dotsHtml + '</md-menu-item>';
            dotsHtml = dotsHtml + '<md-menu-item>';
            dotsHtml = dotsHtml + '<md-button aria-label="Delete"  ng-click="vm.onDeleteCourseTap($event,\'' + courseID + '\',\'' + Language + '\')" data-info=\'' + courseID + '\'>';
            dotsHtml = dotsHtml + '<span >Delete</span>';
            dotsHtml = dotsHtml + '</md-button>';
            dotsHtml = dotsHtml + '</md-menu-item>';
            dotsHtml = dotsHtml + '</md-menu-content>';
            dotsHtml = dotsHtml + '</md-menu>';
            return dotsHtml;
        };
        vm.dtOptions = DTOptionsBuilder.fromFnPromise(vm.getData).withOption('createdRow', function(row, data, dataIndex) {
            $compile(angular.element(row).contents())($scope);
        }).withOption('headerCallback', function(header) {
            if (!vm.headerCompiled) {
                vm.headerCompiled = true;
                $compile(angular.element(header).contents())($scope);
            }
        }).withOption("responsive", true).withOption("bInfo", false).withOption("order", []).withOption('rowCallback', rowCallback);;

        function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
            if (aData.enableCertificate == 1) {
                $('td', nRow).addClass('certificate-highlight');
            }
            $('td', nRow).unbind('click');
            return nRow;
        }

        vm.dtColumns = [
            DTColumnBuilder.newColumn('course_id').withTitle('courseID').notVisible().withClass('g-hidden'),
            DTColumnBuilder.newColumn('course_name').withTitle('Course').renderWith(function(data, type, full, meta) {
                var courseTypeVal = full.course_type;
                for (var i = 0; i < vm.courseType.length; i++) {
                    if (vm.courseType[i].text == courseTypeVal) {
                        var typeName = vm.courseType[i].value;
                    }
                }

                if (full.course_series == null) {
                    full.course_series = "";
                }
                if (full.type == "4") {
                    return " - ";
                } else {
                    return full.course_name + " - " + full.course_level + " - " + full.course_series + " - " + typeName + ' - ' + full.module;
                }
            }),
            DTColumnBuilder.newColumn('intakeID').withTitle('Intake Id'),
            // DTColumnBuilder.newColumn('start_date').withTitle('Start Date'),
            // DTColumnBuilder.newColumn('end_date').withTitle('End Date'),
            DTColumnBuilder.newColumn('start_date').withTitle('Date').renderWith(function(data, type, full, meta) {
                return full.start_date + '</br>' + full.end_date;
            }),
            DTColumnBuilder.newColumn('start_time').withTitle('Time').renderWith(function(data, type, full, meta) {
                return full.start_time + '</br>' + full.end_time;
            }),
            DTColumnBuilder.newColumn('frequency_type').withTitle('Days').notSortable().renderWith(function(data, type, full, meta) {
                // var asd = full.frequency_interval.split(',');
                // console.log(asd);
                // return '0';
                if (full.frequency_type == '1') {
                    return '<p>Daily</p>';
                } else {
                    var classDays = '';
                    if (full.frequency_interval != null) {
                        var frequency_interval = full.frequency_interval.split(',');
                        if (frequency_interval.length == 1) {
                            classDays = classDays + vm.daysEnums[parseInt(frequency_interval[0])].day;
                        } else {
                            for (var j = 0; j < frequency_interval.length; j++) {
                                if ((j + 1) == frequency_interval.length) {
                                    classDays = classDays + vm.daysEnums[parseInt(frequency_interval[j])].day;
                                } else {
                                    classDays = classDays + vm.daysEnums[parseInt(frequency_interval[j])].day + ', ';
                                }
                            }
                        }
                    }
                    return '<p>' + classDays + '</p>';
                }
            }),
            DTColumnBuilder.newColumn('teacher_name').withTitle('Teacher'),
            DTColumnBuilder.newColumn(null).withTitle('Attendance').notSortable().renderWith(function(data, type, full, meta) {
                vm.arrCourses[data.attendanceId] = data;
                return '<md-button class="md-accent md-raised btnviolet md-hue-1 md-button_small g_margin-left-0" ng-click="vm.openDataDlg(\'' + full.intakeID + '\',$event)">' + "Report" + '</md-button>';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Generate Certificate').notSortable().renderWith(function(data, type, full, meta) {
                vm.arrCourses[data.attendanceId] = data;
                if (full.type == "4" || full.type == "3") {
                    return "";
                } else {
                    vm.attachment_intake_id = data.intakeID;
                    vm.attachment_schedule_class_id = data.schedule_class_id;
                    var disBtn;
                    var link_disable;
                    if (full.enableCertificate == 1) {
                        disBtn = "false";
                        link_disable = "";
                    } else {
                        disBtn = "true";
                        link_disable = "link_disable";
                    }
                    vm.setID = "createHref" + data.schedule_class_id;
                    return '<a target="_self" id="createHref"  class=\'' + link_disable + '\' ><md-button class="md-accent md-raised btnviolet md-hue-1 md-button_small g_margin-left-0" ng-disabled=\'' + disBtn + '\' ng-click="vm.appendHref(\'' + full.intakeID + '\',\'' + full.schedule_class_id + '\',\'' + full.type + '\',$event)">' + "Certificates" + '</md-button></a>';
                    //                return   '<a target="_self" href="{{vm.setAuthDownloadLink}}download-certificates?auth_token={{vm.setAuthToken}}&intake_id={{vm.attachment_intake_id}}&schedule_class_id={{vm.attachment_schedule_class_id}}" class=\'' + link_disable + '\' ><md-button class="md-accent md-raised btnviolet md-hue-1 md-button_small g_margin-left-0" ng-disabled=\'' + disBtn + '\'>' + "Certificates" + '</md-button></a>';
                }

            }),
            DTColumnBuilder.newColumn(null).withTitle("").notSortable()
            .renderWith(function(data, type, full, meta) {
                vm.arrCourses[data.intakeID] = data;
                //                return getDotsTpl(data.intakeID, data.course);
                return null;
            })
        ];
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).notSortable(),
            DTColumnDefBuilder.newColumnDef(1).withOption("responsivePriority", 1),
            DTColumnDefBuilder.newColumnDef(2).withOption("responsivePriority", 2)
        ];
        ApiService.GetIntakeFiletrs({}).then(function(response) {
            vm.intakesList = response.data.intakes;
            vm.datesList = response.data.dates;
            vm.roomList = response.data.rooms;
            vm.teacherList = response.data.teachers;
        });
        vm._onFilterChanged = function(val) {
            vm.changeFilter = true;
            if (vm.CStartDate) {
                vm.CStart = Utils.getParsedSlashedDate(vm.CStartDate);
            }
            if (vm.CEndDate) {
                vm.CEnd = Utils.getParsedSlashedDate(vm.CEndDate);
            }
            vm.dtInstance.changeData(vm.getData());
            vm.changeFilter = false;
        };
        $scope.$watch("global.search", function(newValue, oldValue) {

            if (oldValue === "") {
                return;
            }

            vm.search = newValue;
            Utils.showLoader(true);
            vm.searchDone = true;
            vm.dtInstance.changeData(vm.getData());
            vm.searchDone = false;
        });

        function getData() {

            Utils.showLoader(true);
            var defer = $q.defer();
            var requestData = {
                intake: vm.CIntake,
                start_date: vm.CStart,
                end_date: vm.CEnd,
                teacher: vm.selectedTeacher,
                search: vm.search
            };
            if (vm.changeFilter == true) {
                vm.paginators.curPageIndex = 1;
            }
            if (vm.searchDone == true) {
                vm.paginators.curPageIndex = 1;
            } else {

            }
            ApiService.GetAttendances({ paginators: vm.paginators, data: requestData }).then(function(response) {
                var data = response.data;
                if (response && response.headerFn) {
                    vm.paginators.setTotal(response.headerFn("totalitemscount"));
                }
                defer.resolve(data);
                setTimeout(function() {
                    Utils.showLoader(false);
                }, 0)


            });
            return defer.promise;
        };
        vm.onClearFiltersTap = function() {
            vm.selectedTeacher = null;
            vm.ValueEmpty = null;
            vm.CIntake = null;
            vm.CStartDate = null;
            vm.CEndDate = null;
            vm.CStart = null;
            vm.CEnd = null;
            $scope.$broadcast('angucomplete-alt:clearInput', 'intake-filter');
            $scope.$broadcast('angucomplete-alt:clearInput', 'teacher-filter');
            vm.CDate = "All";
            vm.dtInstance.changeData(vm.getData());
        }
        var param = $location.search();
        if (param.intakeid) {
            var intakeID = param.intakeid;
            var dialogData = {
                "title": "Add Attendance",
                "Status": true
            };
            ApiService.MarkAttendance({}).then(function(response) {
                vm.data = response.data[0];
                vm.studentOptions = response.data[0].students;
                vm.attendanceObj = []
                for (var i = 0; i < vm.studentOptions.length; i++) {
                    vm.attendanceObj.push({ id: vm.studentOptions[i].id, name: vm.studentOptions[i].full_name, bAllow: true })
                }


                $mdDialog.show({
                    controller: 'AddAttendanceController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/attendance/add-attendance/add-attendance.html',
                    parent: angular.element($document.body),
                    //                targetEvent: e,
                    //                    clickOutsideToClose: true,
                    locals: {
                        dialogData: dialogData,
                        dtInstance: vm.dtInstance,
                        attendanceObj: vm.attendanceObj,
                        data: vm.data,
                        dtPromiseFn: vm.dtPromiseFn
                    }
                }).then(function(response) {

                });
            });
        }
        //        $(function() {
        //            $('.ms-search-bar #ms-search-bar-collapser').click(function() {
        //                if ($('#ms-search-bar-input').val().length > 0) {
        //                    $('#ms-search-bar-input').val('');
        //                    $scope.global.search = '';
        //                    Utils.showLoader(true);
        //                }
        //            });
        //        });
        $scope.$on("changeSearch", function(event, args) {
            vm.searchDone = true;
            vm.dtInstance.changeData(vm.getData());
            vm.searchDone = false;
        });

        vm.onPrevClick = function(e, pageStartIndex, pageEndIndex, totalItems) {
            vm.paginators.previous(e, pageStartIndex, pageEndIndex, totalItems);
            vm.dtInstance.changeData(vm.getData());
        }

        vm.onNextClick = function(e, pageStartIndex, pageEndIndex, totalItems) {
            vm.paginators.next(e, pageStartIndex, pageEndIndex, totalItems);
            vm.dtInstance.changeData(vm.getData());
        }

        function reloadData() {
            if (vm.dtInstance.reloadData)
                vm.dtInstance.reloadData();
        }

        vm._reloadDtPage = function() {
            vm.dtInstance.reloadData();
        };

        function openDataDlg(attendanceId, e) {
            var dialogData = vm.arrCourses[attendanceId];
            var requestData = {
                intake_id: dialogData.intakeID,
                schedule_class_id: dialogData.schedule_class_id,
                type: dialogData.type
            };

            ApiService.GetAttendanceReport({ data: requestData }).then(function(response) {
                vm.studentsData = response.data[0].attendances;
                vm.dateList = response.data[0].scheduleDates;
                dialogData.nullType = response.data[0].type;
                dialogData.end_date = response.data[0].end_date;
                dialogData.start_date = response.data[0].start_date;
                dialogData.btnEnable = response.data[0].enableCertificate;
                dialogData.intake_id = response.data[0].intakeID;
                dialogData.startTime = response.data[0].startTime;
                dialogData.endTime = response.data[0].endTime;
                dialogData.schedule_class_id = response.data[0].schedule_class_id;
                dialogData.printData = response.data.printData;
                var arrSchedules = response.data[0].scheduleDates;
                var arrAttendances = response.data[0].attendances;
                var curAttList = null,
                    curScheduleObj = null,
                    curAttListobj = null,
                    bAllow, countEligible = 0;
                for (var i = 0; i < arrAttendances.length; i++) {
                    //                    curAttList = arrAttendances[i].attendanceList;
                    var newAtt = [];
                    angular.forEach(arrAttendances[i].attendanceList, function(value, x) {
                        newAtt.push(value);
                    });
                    arrAttendances[i].attendanceList = newAtt;
                    if (response.data[0].enableCertificate == 1) {
                        if (arrAttendances[i].isEligible == 1) {
                            countEligible = countEligible + 1;
                        }
                    }

                    for (var x = 0; x < newAtt.length; x++) {

                        curAttListobj = newAtt[x];
                        if (curAttListobj.attendance == 0) {
                            curAttListobj.bAllow = false;
                        } else if (curAttListobj.attendance == 2) {
                            curAttListobj.bAllow = "plus";
                        } else if (curAttListobj.attendance == 1) {
                            curAttListobj.bAllow = true;
                        } else {
                            curAttListobj.bAllow = null;
                        }
                    }
                    var arrNewSchedule = [];
                    angular.forEach(arrSchedules, function(value, x) {
                        arrNewSchedule.push(value);
                    });
                    for (var j = 0; j < arrNewSchedule.length; j++) {
                        curScheduleObj = arrNewSchedule[j];

                        if (!isDateInSchedules(newAtt, curScheduleObj.date)) {
                            newAtt.push({
                                date: curScheduleObj.date,
                                attendance: '',
                                bAllow: -1
                            });
                        }
                    }

                }

                if (countEligible >= 1) {
                    dialogData.btnEnable = 1;
                } else {
                    dialogData.btnEnable = 0;
                    //                    dialogData.showErrorMsg = true;
                }

                function isDateInSchedules(arrAttendances, strDateToCheck) {
                    if (!arrAttendances) {
                        return false;
                    }

                    for (var i = 0; i < arrAttendances.length; i++) {
                        if (arrAttendances[i].date == strDateToCheck) {
                            if (arrAttendances[i].date) {
                                var dateString = arrAttendances[i].date;
                                var dateParts = dateString.split("/");
                                var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
                                var todayDate = new Date();
                                if (dateObject >= todayDate) {
                                    arrAttendances[i].bAllow = -1;
                                }
                            }
                            return true;
                        }
                    }
                    return false;
                }
                arrAttendances;

                Utils.showLoader(false);
                $mdDialog.show({
                    controller: 'ShowReportController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/attendance/show-report/show-report-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    //                    clickOutsideToClose: true,
                    locals: {
                        dialogData: dialogData,
                        studentsData: arrAttendances,
                        dateList: arrSchedules,
                        dtPromiseFn: vm.dtPromiseFn

                    }
                }).then(function(response) {

                });
            });
        };
        $scope.selectedIntake = function(selected) {
            if (selected != undefined && selected.title != undefined) {
                for (var i = 0; i < vm.intakesList.length; i++) {
                    if (vm.intakesList[i].id == selected.title) {
                        vm.CIntake = vm.intakesList[i].value;
                        vm._onFilterChanged();
                    }
                }
            }
        }
        $scope.selectedTeachers = function(selected) {
                if (selected != undefined && selected.title != undefined) {
                    vm.selectedTeacher = selected.description.id;
                    vm._onFilterChanged();
                }
            }
            // Methods

        //////////
    }

})
();
(function ()
{
    'use strict';

    angular
            .module('app.admins')
            .controller('AdminsController', AdminsController);

    /** @ngInject */
    function AdminsController(api, usSpinnerService, ApiService, $http, $mdToast, $mdDialog, $document, $compile, $scope, $q, $resource, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, Utils)
    {
        var vm = this;
        vm.arrAdmins = {};
        vm.dtInstance = {};
        vm.getData = getData;
        vm.reloadData = reloadData;
        vm.search = "";
        vm.showDeletedAdmin = false;
        vm.someClickHandler = someClickHandler;
        // Paginators

        $scope.$on("changeSearch", function (event, args) {
            vm.searchDone = true;
            vm.dtInstance.changeData(vm.getData());
            vm.searchDone = false;
        }
        );
        vm.paginators = new Paginator();

        var getDotsTpl = function (id, name) {
            var dotsHtml = "";
            if (vm.showDeletedAdmin == false) {
                dotsHtml = dotsHtml + '<md-menu>';
                dotsHtml = dotsHtml + ' <md-button aria-label="More" class="md-icon-button" ng-click="$mdOpenMenu($event)" translate >';
                dotsHtml = dotsHtml + ' <md-icon md-font-icon="icon-dots-vertical"></md-icon>';
                dotsHtml = dotsHtml + '<md-tooltip><span >More</span></md-tooltip>';
                dotsHtml = dotsHtml + '</md-button>';
                dotsHtml = dotsHtml + '<md-menu-content width="3">';
                dotsHtml = dotsHtml + '<md-menu-item>';
                dotsHtml = dotsHtml + '<md-button aria-label="Edit" ng-click="vm.onEditAdminTap($event,\'' + id + '\')" data-info=\'' + id + '\'>';
                dotsHtml = dotsHtml + '<span>Edit</span>';
                dotsHtml = dotsHtml + '</md-button>';
                dotsHtml = dotsHtml + '</md-menu-item>';
                dotsHtml = dotsHtml + '<md-menu-item>';

                dotsHtml = dotsHtml + '<md-button aria-label="Delete"  ng-click="vm.onDeleteAdminTap($event,\'' + id + '\',\'' + name + '\')" data-info=\'' + id + '\'>';
                dotsHtml = dotsHtml + '<span >Delete</span>';
                dotsHtml = dotsHtml + '</md-button>';
                dotsHtml = dotsHtml + '</md-menu-item>';
                dotsHtml = dotsHtml + '</md-menu-content>';
                dotsHtml = dotsHtml + '</md-menu>';
            } else if (vm.showDeletedAdmin == true) {
                dotsHtml = dotsHtml + '<md-menu>';
                dotsHtml = dotsHtml + ' <md-button aria-label="More" class="md-icon-button" ng-click="$mdOpenMenu($event)" translate >';
                dotsHtml = dotsHtml + ' <md-icon md-font-icon="icon-dots-vertical"></md-icon>';
                dotsHtml = dotsHtml + '<md-tooltip><span >More</span></md-tooltip>';
                dotsHtml = dotsHtml + '</md-button>';

                dotsHtml = dotsHtml + '<md-menu-content width="3">';
                dotsHtml = dotsHtml + '<md-menu-item>';
                dotsHtml = dotsHtml + '<md-button aria-label="ReActivate"  ng-click="vm.onReActivateAdminTap($event,\'' + id + '\',\'' + name + '\')" data-info=\'' + id + '\'>';
                dotsHtml = dotsHtml + '<span >ReActivate</span>';
                dotsHtml = dotsHtml + '</md-button>';
                dotsHtml = dotsHtml + '</md-menu-item>';
                dotsHtml = dotsHtml + '</md-menu-content>';
                dotsHtml = dotsHtml + '</md-menu>';
            }
            return dotsHtml;
        };
        vm.dtPromiseFn = function () {
            return vm.getData();

        }

        vm._reloadDtPage = function () {
            vm.dtInstance.changeData(vm.dtPromiseFn());
        };
        vm.dtOptions = DTOptionsBuilder.fromFnPromise(vm.dtPromiseFn).withOption('createdRow', function (row, data, dataIndex) {
            $compile(angular.element(row).contents())($scope);
        }).withOption('headerCallback', function (header) {
            if (!vm.headerCompiled) {
                vm.headerCompiled = true;
                $compile(angular.element(header).contents())($scope);
            }
        }).withOption("responsive", true).withOption("bInfo", false).withOption('rowCallback', rowCallback);

        function someClickHandler(info) {
            var dialogData = info;
            Utils.showLoader(true);
            dialogData.type = "edit";
            ApiService.GetSkills({}).then(function (response) {
                var arrSkills = response.data;
                Utils.showLoader(false);
                $mdDialog.show({
                    controller: 'AddAdminsDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/admins/add-admins/add-admins-dialog.html',
                    parent: angular.element($document.body),
//                    clickOutsideToClose: true,
                    locals: {
                        dialogData: dialogData,
                        dtInstance: vm.dtInstance,
                        arrSkills: arrSkills,
                        dtPromiseFn: vm.dtPromiseFn

                    }
                }).then(function (response)
                {
                });
            });
        }

        function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function () {
                $scope.$apply(function () {
                    vm.someClickHandler(aData);
                });
            });
            return nRow;
        }
        vm.dtColumns = [
            DTColumnBuilder.newColumn('full_name').withTitle('Full Name'),
            DTColumnBuilder.newColumn('email').withTitle('Email'),
            DTColumnBuilder.newColumn('contact_number').withTitle('Contact Number'),
            DTColumnBuilder.newColumn(null).withTitle("").notSortable()
                    .renderWith(function (data, type, full, meta) {
                        vm.arrAdmins[data.id] = data;
                        return getDotsTpl(data.id, data.full_name);
                    })
        ];
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).withOption("responsivePriority", 1),
            DTColumnDefBuilder.newColumnDef(2).notSortable().withOption("responsivePriority", 2)
        ];

        vm._onFilterChanged = function (val) {
            vm.changeFilter = true;
            vm.dtInstance.changeData(vm.getData());
            vm.changeFilter = false;
        };
        vm.onClearFiltersTap = function () {
            vm.showDeletedAdmin = false;
            vm.dtInstance.changeData(vm.getData());
        }


        function getData() {
            Utils.showLoader(true);
            var defer = $q.defer();
            var requestData = {
                search: vm.search,
                showDeletedAdmin: vm.showDeletedAdmin
            };
            if (vm.searchDone == true) {
                vm.paginators.curPageIndex = 1;
            } else {

            }
            ApiService.GetAdmins({paginators: vm.paginators, data: requestData}).then(function (response) {
                var data = response.data;
                if (response && response.headerFn) {
                    vm.paginators.setTotal(response.headerFn("totalitemscount"));
                }
                defer.resolve(data);
                setTimeout(function () {
                    Utils.showLoader(false);
                }, 0)
            });
            return defer.promise;

        }



        vm.onPrevClick = function (e, pageStartIndex, pageEndIndex, totalItems) {
            vm.paginators.previous(e, pageStartIndex, pageEndIndex, totalItems);
            vm.dtInstance.changeData(vm.getData());
        }

        vm.onNextClick = function (e, pageStartIndex, pageEndIndex, totalItems) {
            vm.paginators.next(e, pageStartIndex, pageEndIndex, totalItems);
            vm.dtInstance.changeData(vm.getData());
        }

        function reloadData() {
            if (vm.dtInstance.reloadData)
                vm.dtInstance.reloadData();
        }

        $scope.$watch("global.search", function (newValue, oldValue) {

            if (oldValue === "") {
                return;
            }
            vm.search = newValue;
            Utils.showLoader(true);
            vm.searchDone = true;
            vm.dtInstance.changeData(vm.getData());
//            Utils.showLoader(false);
            vm.searchDone = false;
        });
        vm.onCreateAdminTap = function (e) {
            Utils.showLoader(true);
            var dialogData = {
                "type": "add",
            };

            Utils.showLoader(false);
            $mdDialog.show({
                controller: 'AddAdminsDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/admins/add-admins/add-admins-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
//                    clickOutsideToClose: true,
                locals: {
                    dialogData: dialogData,
                    dtInstance: vm.dtInstance,
                    dtPromiseFn: vm.dtPromiseFn
                }
            }).then(function (response)
            {

            });
        };
        vm.onDeleteAdminTap = function (e, id, name) {
            var deleteData = {
                "role_id": "1",
                "admins": [id]
            }
            var confirm = $mdDialog.confirm()
                    .title('Confirm Delete Admin?')
                    .textContent('Are you sure you want to delete selected Admin ?')
                    .ariaLabel('Delete')
                    .targetEvent(e)
                    .ok('Delete')
                    .cancel('Cancel');
            $mdDialog.show(confirm).then(function () {
                Utils.showLoader(true);
                ApiService.DeleteAdmin({
                    data: deleteData,
                    success: function (response) {
                        Utils.showLoader(false);
                        if (response.status === 0) {
                            Utils.showToast({text: response.data.message, 'type': 0});
                        } else {

                            Utils.showToast({text: response.data.message, 'type': 1});
                            vm._reloadDtPage();
                        }
                    }
                });
            }, function () {
            });
        };

        vm.onEditAdminTap = function (e, id) {
            var dialogData = vm.arrAdmins[id];
            dialogData.type = "edit";
            ApiService.GetSkills({}).then(function (response) {
                var arrSkills = response.data;
                $mdDialog.show({
                    controller: 'AddAdminsDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/admins/add-admins/add-admins-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
//                    clickOutsideToClose: true,
                    locals: {
                        dialogData: dialogData,
                        dtInstance: vm.dtInstance,
                        arrSkills: arrSkills,
                        dtPromiseFn: vm.dtPromiseFn

                    }
                }).then(function (response)
                {
                });
            });
        };


        vm.onReActivateAdminTap = function (e, id, name) {
            var reActivateData = {
                "role_id": "1",
                "admins": [id]
            }
            var confirm = $mdDialog.confirm()
                    .title('Confirm Reactivate Admin?')
                    .textContent('Are you sure you want to re-activate selected Employee ?')
                    .ariaLabel('reactivateAdmin')
                    .targetEvent(e)
                    .ok('Re-activate')
                    .cancel('Cancel');
            $mdDialog.show(confirm).then(function () {
                Utils.showLoader(true);
                ApiService.ReActivateAdmin({
                    data: reActivateData,
                    success: function (response) {
                        Utils.showLoader(false);
                        if (response.status == 0) {
                            Utils.showToast({text: response.data.message, 'type': 0});
                        } else {
                            Utils.showToast({text: response.data.message, 'type': 1});
                            vm._reloadDtPage();
                        }
                    }
                });
            }, function () {});


        };



        // Methods

        //////////
    }
})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .provider('fuseTheming', fuseThemingProvider);

    /** @ngInject */
    function fuseThemingProvider() {
        // Inject Cookies Service
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies',
            function(_$cookies) {
                $cookies = _$cookies;
            }
        ]);

        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        var registeredPalettes,
            registeredThemes;

        // Methods
        this.setRegisteredPalettes = setRegisteredPalettes;
        this.setRegisteredThemes = setRegisteredThemes;

        //////////

        /**
         * Set registered palettes
         *
         * @param _registeredPalettes
         */
        function setRegisteredPalettes(_registeredPalettes) {
            registeredPalettes = _registeredPalettes;
        }

        /**
         * Set registered themes
         *
         * @param _registeredThemes
         */
        function setRegisteredThemes(_registeredThemes) {
            registeredThemes = _registeredThemes;
        }

        /**
         * Service
         */
        this.$get = function() {
            var service = {
                getRegisteredPalettes: getRegisteredPalettes,
                getRegisteredThemes: getRegisteredThemes,
                setActiveTheme: setActiveTheme,
                setThemesList: setThemesList,
                themes: {
                    list: {},
                    active: {
                        'name': '',
                        'theme': {}
                    }
                }
            };

            return service;

            //////////

            /**
             * Get registered palettes
             *
             * @returns {*}
             */
            function getRegisteredPalettes() {
                return registeredPalettes;
            }

            /**
             * Get registered themes
             *
             * @returns {*}
             */
            function getRegisteredThemes() {
                return registeredThemes;
            }

            /**
             * Set active theme
             *
             * @param themeName
             */
            function setActiveTheme(themeName) {
                // If theme does not exist, fallback to the default theme
                if (angular.isUndefined(service.themes.list[themeName])) {
                    // If there is no theme called "default"...
                    if (angular.isUndefined(service.themes.list.default)) {
                        $log.error('You must have at least one theme named "default"');
                        return;
                    }

                    $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                    // Otherwise set theme to default theme
                    service.themes.active.name = 'default';
                    service.themes.active.theme = service.themes.list.default;
                    $cookies.put('selectedTheme', service.themes.active.name);

                    return;
                }

                service.themes.active.name = themeName;
                service.themes.active.theme = service.themes.list[themeName];
                $cookies.put('selectedTheme', themeName);
            }

            /**
             * Set available themes list
             *
             * @param themeList
             */
            function setThemesList(themeList) {
                service.themes.list = themeList;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes, fuseThemingProvider)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });

        // Store generated PALETTES and THEMES objects from $mdThemingProvider
        // in our custom provider, so we can inject them into other areas
        fuseThemingProvider.setRegisteredPalettes($mdThemingProvider._PALETTES);
        fuseThemingProvider.setRegisteredThemes($mdThemingProvider._THEMES);
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        'default'  : {
            primary   : {
                name: 'fuse-pale-blue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'red'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'pink': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'blue'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'teal'     : {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'deep-orange'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
//        "CUSTOM_THEME_NAME" : {"primary":{"name":"blue-grey","hues":{"default":"700","hue-1":"500","hue-2":"600","hue-3":"400"}},"accent":{"name":"blue-grey","hues":{"default":"600","hue-1":"400","hue-2":"700","hue-3":"A100"}},"warn":{"name":"red","hues":{"default":"500","hue-1":"300","hue-2":"800","hue-3":"A100"}},"background":{"name":"grey","hues":{"default":"A100","hue-1":"100","hue-2":"50","hue-3":"300"}}}
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-pale-blue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            var registeredThemes = fuseTheming.getRegisteredThemes();
            var registeredPalettes = fuseTheming.getRegisteredPalettes();

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0, color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // Set active theme
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions()
    {
        return {
            restrict   : 'E',
            scope      : {
                panelOpen: '='
            },
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        backdropEl = angular.element('<div class="ms-theme-options-backdrop"></div>');

                    // Panel open status
                    scope.panelOpen = scope.panelOpen || false;

                    /**
                     * Toggle options panel
                     */
                    function toggleOptionsPanel()
                    {
                        if ( scope.panelOpen )
                        {
                            closeOptionsPanel();
                        }
                        else
                        {
                            openOptionsPanel();
                        }
                    }

                    function openOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = true;

                        // Add open class
                        iElement.addClass('open');

                        // Append the backdrop
                        bodyEl.append(backdropEl);

                        // Register the event
                        backdropEl.on('click touch', closeOptionsPanel);
                    }

                    /**
                     * Close options panel
                     */
                    function closeOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = false;

                        // Remove open class
                        iElement.removeClass('open');

                        // De-register the event
                        backdropEl.off('click touch', closeOptionsPanel);

                        // Remove the backdrop
                        backdropEl.remove();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsPanel = toggleOptionsPanel;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Edge",
                    versionSearch: "Edge",
                    identity     : "Edge"
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: "Chrome",
                    identity : "Chrome"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "OmniWeb",
                    versionSearch: "OmniWeb/",
                    identity     : "OmniWeb"
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : "Apple",
                    versionSearch: "Version",
                    identity     : "Safari"
                },
                {
                    prop    : $window.opera,
                    identity: "Opera"
                },
                {
                    string   : $window.navigator.vendor,
                    subString: "iCab",
                    identity : "iCab"
                },
                {
                    string   : $window.navigator.vendor,
                    subString: "KDE",
                    identity : "Konqueror"
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: "Firefox",
                    identity : "Firefox"
                },
                {
                    string   : $window.navigator.vendor,
                    subString: "Camino",
                    identity : "Camino"
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: "Netscape",
                    identity : "Netscape"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "MSIE",
                    identity     : "Explorer",
                    versionSearch: "MSIE"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Trident/7",
                    identity     : "Explorer",
                    versionSearch: "rv"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Gecko",
                    identity     : "Mozilla",
                    versionSearch: "rv"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Mozilla",
                    identity     : "Netscape",
                    versionSearch: "Mozilla"
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: "Win",
                    identity : "Windows"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "Mac",
                    identity : "Mac"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "Linux",
                    identity : "Linux"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "iPhone",
                    identity : "iPhone"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "iPod",
                    identity : "iPod"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "iPad",
                    identity : "iPad"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "Android",
                    identity : "Android"
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) != -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index == -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || "unknown-browser";
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || "unknown-version";
            var os = searchString(osData) || "unknown-os";

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) == -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'EA',
            compile : function (tElement, tAttrs)
            {
                var code;
                //No attribute? code is the content
                if ( !tAttrs.code )
                {
                    code = tElement.html();
                    tElement.empty();
                }

                return function (scope, iElement, iAttrs)
                {
                    if ( iAttrs.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(iAttrs.code);
                    }
                    var shouldInterpolate = scope.$eval(iAttrs.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }

                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );

                            iElement.append(contentParent);

                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {
                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);

                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(iAttrs.language || iAttrs.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function()
{
    'use strict';

    angular
            .module('app.toolbar')
            .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $scope, api, $mdSidenav, $translate, $mdToast, GlobalPool, $http, $location, $mdDialog, $document, Utils, ApiService, Auth, $state)
    {
        var vm = this;
        vm.onChangeSearch = onChangeSearch
//        $rootScope.global.search;
        $rootScope.$on('$stateChangeStart',
                function(event, toState, toParams, fromState, fromParams) {
                    // do someth
                    if (toState.name == 'app.dashboard') {
                        vm.showHeader = true;
                    } else {
                        vm.showHeader = false;
                    }


                });



        if ($state.current.name == 'app.dashboard') {
            vm.showHeader = true;
        } else {
            vm.showHeader = false;
        }
        vm.onCloseSearch = function() {
            if ($('#ms-search-bar-input').val().length > 0) {
                $('#ms-search-bar-input').val('');
                $scope.global.search = '';
                $scope.$broadcast("changeSearch", {"vm.search": ''})

            }
        }
        // Data
        vm.bodyEl = angular.element('body');
        $rootScope.global = {
            search: ''
        };

//        $(document).ready(function() {
//            $("#ms-search-bar-collapser").click(function() {
//                $scope.global.search = "";
//            });
//        });

//        $(function() {
//            $('.ms-search-bar #ms-search-bar-collapser').click(function() {
//                $('#ms-search-bar-input').val('');
//                alert("AHiya che");
//                $scope.global.search = '';
//                Utils.showLoader(true);
//            });
//        });

        $scope.$watch("global.search", function(newValue, oldValue) {
            /* change noticed */
        });
        function onChangeSearch(searchdata) {
            searchdata
        }
        if ($rootScope.global.search.length > 0) {
            var search = $rootScope.global.search;
        }
        vm.userInfo = GlobalPool.getUserInfo();

        if (vm.userInfo != undefined) {
            if (vm.userInfo.full_name.trim().length === 0) {
                vm.userInfo.full_name = "Mandarin User";
            }
        }


        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon': 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon': 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon': 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = [
            {
                'title': 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code': 'en',
                'flag': 'gb'
            },
            {
                'title': 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code': 'es',
                'flag': 'es'
            },
            {
                'title': 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code': 'tr',
                'flag': 'tr'
            }
        ];

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.syncXero = syncXero;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        vm.userStatus = vm.userStatusOptions[0];
        vm.selectedLanguage = vm.languages[0];

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout()
        {
            Utils.showLoader(true);
            Auth.logout();
        }

        function syncXero() {
            var userInfo = GlobalPool.getUserInfo();
            vm.setAuthDownloadLink = api.baseURI;
            var path = api.baseURI + 'show-xero-button?auth-token=' + userInfo.auth_token
            window.open(path);
        }

        vm.onSettingDlgTap = function(e) {
            var userInfo = GlobalPool.getUserInfo();
            var dialogData = {
                "name": userInfo.full_name,
            };

            $mdDialog.show({
                controller: 'SettingController',
                controllerAs: 'vm',
                templateUrl: 'app/toolbar/setting/setting-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: true,
                locals: {
                    dialogData: dialogData,
                }
            }).then(function(response)
            {

            });
        };


        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            // Show temporary message if user selects a language other than English
            if (lang.code !== 'en')
            {
//                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';
//
//                $mdToast.show({
//                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
//                    hideDelay: 7000,
//                    position : 'top right',
//                    parent   : '#content'
//                });

                return;
            }

            //Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(api)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        api.quickPanel.activities.get({}, function (response)
        {
            vm.activities = response.data;
        });

        api.quickPanel.events.get({}, function (response)
        {
            vm.events = response.data;
        });

        api.quickPanel.notes.get({}, function (response)
        {
            vm.notes = response.data;
        });

        // Methods

        //////////
    }

})();
(function() {
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [
            // Core
            'app.core',
            // Navigation
            'app.navigation',
            'angularSpinner',
            'ncy-angular-breadcrumb',
            // Toolbar
            'app.toolbar',
            // Quick panel
            'app.quick-panel',
            'app.authstate',
            // Dashboard
            'app.dashboard',
            'app.schedule',
            'app.skills',
            'app.courses',
            'app.admins',
            'app.teachers',
            'app.profile & class details',
            'app.students',
            'app.intakes',
            'app.intakes1',
            'app.rooms',
            'app.holidays',
            'app.sidenav',
            'app.attendance',
            'app.books',
            'app.attendance_add',
            'app.pages.auth.login',
            'app.pages.auth.reset-password',
            "app.attendance_mark",
            "app.next_private_class_schedule",
            "app.schools",
            "app.payroll",
            'app.pages.auth.admission',
            'app.pages.auth.admissionprivate',

            'app.pages.auth.thank',
            'app.pages.auth.unsubscribe',
            'app.pages.auth.found',
            //                'app.asset-management',
            //                'app.inventory',
            //                 'app.transactions',
            //                 'app.replenish',
            //                 'app.stock-take',
            //                 'app.reports'
            //           Pages
            //            'app.pages.auth.register',
            'app.pages.auth.forgot-password',
            'app.pages.auth.english-express-thank-you',
            'app.pages.auth.indoslang-thank-you',
            'app.pages.auth.hana-thank-you',
            'app.pages.auth.yiman-thank-you',
            'app.show_attendance',
            'app.change_teacher',
            //            // User Interface
            ////            'app.ui',
            //
            //            // Components
            //            'app.components'
        ]).config(function($breadcrumbProvider) {
            $breadcrumbProvider.setOptions({
                prefixStateName: 'app.dashboard',
                templateUrl: 'app/templates/breadcrumb.html',
            });
        });
})();
(function ()
{
    'use strict';

    angular
            .module('fuse')
            .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if (event.targetScope.$id === $scope.$id)
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
//
//        $rootScope.$on('$stateChangeStart', function (event, next) {
//            debugger
////            var authorizedRoles = next.data.authorizedRoles;
////            if (!AuthService.isAuthorized(authorizedRoles)) {
////                event.preventDefault();
////                if (AuthService.isAuthenticated()) {
////                    // user is not allowed
////                    $rootScope.$broadcast(AUTH_EVENTS.notAuthorized);
////                } else {
////                    // user is not logged in
////                    $rootScope.$broadcast(AUTH_EVENTS.notAuthenticated);
////                }
////            }
//        });

        $rootScope.$on("$routeChangeStart", function (event, next, current) {
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/navigation');
    }

})();
(function()
{
    'use strict';

    angular
            .module('app.navigation')
            .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope, $location, ApiService, api)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };
        
        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////
        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active')
        })
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, uiGmapGoogleMapApiProvider, $translateProvider, $provide, fuseConfigProvider)
    {
        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Enable debug logging
        $logProvider.debugEnabled(true);

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        // toastr configuration
        toastr.options.timeOut = 3000;
        toastr.options.positionClass = 'toast-top-right';
        toastr.options.preventDuplicates = true;
        toastr.options.progressBar = true;

        // uiGmapgoogle-maps configuration
        uiGmapGoogleMapApiProvider.configure({
            //    key: 'your api key',
            v        : '3.exp',
            libraries: 'weather,geometry,visualization'
        });

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate', function (taOptions)
            {
                taOptions.toolbar = [
                    ['bold', 'italics', 'underline', 'ul', 'ol', 'quote']
                ];

                taOptions.classes = {
                    focussed           : 'focussed',
                    toolbar            : 'ta-toolbar',
                    toolbarGroup       : 'ta-group',
                    toolbarButton      : 'md-button',
                    toolbarButtonActive: 'active',
                    disabled           : '',
                    textEditor         : 'form-control',
                    htmlEditor         : 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools)
            {
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.quote.iconclass = 'icon-format-quote';

                return taTools;
            }
        ]);

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });
    }
})();
(function() {
    'use strict';
    var _serviceData = {};
    angular
        .module('fuse')
        .factory('GlobalPool', globalPool);
    /** @ngInject */
    function globalPool($resource) {

        var data = {
            userInfo: {
                name: "Henry Vil"
            }
        };
        _serviceData = service;
        var service = {
            setUserData: function(info) {
                var rolePeople = Focus.ENUMS.ROLES;
                data.userInfo = info;
                if (info && info.role_id) {
                    localStorage['userInfo'] = JSON.stringify(info);
                    for (var i = 0; i < rolePeople.length; i++) {
                        if (info.role_id == rolePeople[i].value) {
                            //                        if (info.UserAccessRights[i]['AccessRightType'] == 'Menus') {
                            var menuAllowed = rolePeople[i].id;
                            localStorage['MenuPermission'] = JSON.stringify(menuAllowed);
                            //                            localStorage['MenuPermission'] = JSON.stringify(info.UserAccessRights[i]['AccessRightParams']);
                        }
                    }
                } else {
                    // loggin out
                    delete localStorage['userInfo'];
                    delete localStorage['MenuPermission'];
                    delete localStorage['userMenu'];
                }
            },
            setUserMenu: function(menuObject) {
                data.userMenu = menuObject;
                localStorage['userMenu'] = JSON.stringify(menuObject);
            },
            getUserInfo: function() {
                var userInfo = localStorage['userInfo'];
                if (userInfo) {
                    userInfo = JSON.parse(userInfo);
                }
                return userInfo;
                //                return data.userInfo;
            },
            getMenuPermissions: function() {
                var menuPermission = localStorage['MenuPermission'];
                if (menuPermission) {
                    menuPermission = JSON.parse(menuPermission);
                } else {
                    menuPermission = {};
                }
                return menuPermission;
            },
            getFunctionPermissions: function() {
                var functionPermission = localStorage['FunctionPermission'];
                if (functionPermission) {
                    functionPermission = JSON.parse(functionPermission);
                } else {
                    functionPermission = {};
                }
                return functionPermission;
            },
            getUserMenu: function() {
                var userMenu = localStorage['userMenu'];
                if (userMenu) {
                    userMenu = JSON.parse(userMenu);
                }
                return userMenu;
            }

        };
        return service;
    }

    angular
        .module('fuse')
        .factory('Auth', Auth);
    /** @ngInject */
    function Auth(GlobalPool, $q, ApiService, Utils, $location) {

        var publicUrls = ["/unsubscribe", "/indoslang-admin-class-sign-up-thank-you", "/hana-admin-class-sign-up-thank-you", "/english-express-admin-class-sign-up-thank-you", "/yiman-admin-class-sign-up-thank-you", "/change_teacher", "/thankyou", '/show-attendance', '/next-private-class-schedule', "/thank-you", "/admissions", "/page-not-found", "/admissions/:id/:courseName/:courseType", "/login", "http://yi-mandarin.testground.me/reset-password", "http://yi-mandarin-client.testground.me/reset-password", "http://yi-mandarin.testground.me/mark-attendance", "http://yi-mandarin-client.testground.me/mark-attendance", "http://yi-mandarin-client.testground.me/intake", "http://yi-mandarin.testground.me/intake", "/intake", "/reset-password", "/mark-attendance", 'http://yi-mandarin.testground.me/admissions', 'http://yi-mandarin.testground.me/page-not-found'];
        return {
            isLoggedIn: function(bForce) {
                var defer;
                defer = $q.defer();
                var userInfo = GlobalPool.getUserInfo();
                if (!bForce) {
                    if (userInfo) {
                        defer.resolve(true);
                    } else {
                        defer.resolve(false);
                    }
                    return defer.promise;
                } else {
                    // Send an ajax request to see if user is still logged in
                }
            },
            isPublicUrl: function(url) {
                return publicUrls.indexOf(url) != -1;
            },
            isAllowed: function() {
                return false;
            },
            logout: function(bForce) {
                var userInfo = GlobalPool.getUserInfo();
                if (bForce) {
                    GlobalPool.setUserData(null);
                    location.href = "/";
                } else {
                    //                    var  auth_token = userInfo.auth_token ;
                    ApiService.Logout({
                        //                         data: { "auth_token" : auth_token},
                        success: function(response) {

                            Utils.showLoader(false);
                            GlobalPool.setUserData(null);
                            //                        $location.path("/login");
                            location.href = "/";
                        },
                        failure: function(error) {
                            Utils.showLoader(false);
                        }
                    });
                }
            },
            login: function() {

            },
            getUser: function() {
                return GlobalPool.getUserInfo();
            }
        }
    };
    angular
        .module('fuse')
        .factory('ApiService', ApiService);
    /** @ngInject */
    function ApiService($http, Utils, $q, GlobalPool, $mdToast) {

        function reset() {
            // deferred = $q.defer();
            return;
        }
        var service = {
            _sendRequest: function(config) {
                var deferred = $q.defer();
                var successCallbck = function(serverResponse) {
                    var response = serverResponse.data;
                    if (response && typeof response === "object") {
                        response.headerFn = serverResponse.headers;
                        if (response.status == 0 && response.error == 401) {
                            GlobalPool.setUserData(null);
                            location.pathname = "/login";
                        }
                    }
                    if (config.success) {
                        config.success.call(this, response, serverResponse.headers);
                    }
                    deferred.resolve(response, serverResponse.headers);
                };
                var errorCallbck = function(serverResponse) {
                    if (config.failure) {
                        config.failure.call(this, serverResponse.statusText, serverResponse.headers);
                    } else {
                        Utils.showToast({ text: "Request failure. Please try again later" })
                        Utils.showLoader(false);
                    }

                    deferred.resolve({});
                };
                if (config.route != 'add-next-private-schedule-class' && config.route != 'get-next-private-schedule-class' && config.route != 'send-renew-course-mail' && config.route != "show-course-attendance" && config.route != "add-private-application" && config.route != "add-attendance" && config.route != "get-course-levels" && config.route != "add-group-application" && config.route != "get-group-intakes" && config.route != "login" && config.route != "forget-password" && config.route != "save-password" && config.route != "mark-attendance" && config.route != "trainer-selected" && config.route != "trainer-availability" && config.route != "trainer-save") {
                    if (!config.bSkipAuth) {
                        var userInfo = GlobalPool.getUserInfo();
                        if (userInfo.auth_token) {
                            config.data = $.extend(config.data, { 'auth_token': userInfo.auth_token });
                        }
                    }
                }
                $http({
                    url: api.baseURI + config.route,
                    //                    params : {search:"testing"},
                    dataType: "json",
                    method: "POST",
                    withCredentials: true,
                    data: config.data !== undefined ? JSON.stringify(config.data) : null,
                    headers: {
                        //                        "Content-Type": "application/json",
                        "PageNumber": config.paginators === undefined ? -1 : config.paginators.curPageIndex,
                        ////                        "ItemsPerPage": config.paginators === undefined ? -1 : config.paginators.pageLength
                    }
                }).then(successCallbck, errorCallbck);
                return deferred.promise;
            },

            Login: function(config) {
                config.route = "login";
                service._sendRequest(config);
            },
            Logout: function(config) {
                config.route = "logout";
                service._sendRequest(config);
            },
            AddUpdateTenant: function(config) {
                config.route = "AddOrUpdateTenant";
                return service._sendRequest(config);
            },
            AddUpdateSkill: function(config) {
                config.route = "add-skills";
                return service._sendRequest(config);
            },
            GetSkills: function(config) {
                config.route = "get-skills";
                return service._sendRequest(config);
            },
            GetTeacherSkills: function(config) {
                config.route = "get-teacher-skills";
                return service._sendRequest(config);
            },
            AddAdhocClassRequest: function(config) {
                config.route = "add-adhoc-class-request";
                return service._sendRequest(config);
            },
            GetTeachersBySkill: function(config) {
                config.route = "get-teachers-by-skill";
                return service._sendRequest(config);
            },
            GetAvailableRooms: function(config) {
                config.route = "get-available-rooms";
                return service._sendRequest(config);
            },
            IntakeStudents: function(config) {
                config.route = "intake-students";
                return service._sendRequest(config);
            },
            ShowAvailableRoom: function(config) {
                config.route = "show-available-rooms";
                return service._sendRequest(config);
            },
            DeleteSkill: function(config) {
                config.route = "delete-skill";
                return service._sendRequest(config);
            },
            GetTeacherSuggestion: function(config) {
                config.route = "get-teacher-suggestion";
                return service._sendRequest(config);
            },
            AddUpdateTeacher: function(config) {
                config.route = "add-user";
                return service._sendRequest(config);
            },
            AddIntakeStudents: function(config) {
                config.route = "add-intake-students";
                return service._sendRequest(config);
            },
            CheckIntakeStatus: function(config) {
                config.route = "check-intake-status";
                return service._sendRequest(config);
            },
            AddNextPrivateScheduleClass: function(config) {
                config.route = "add-next-private-schedule-class";
                return service._sendRequest(config);
            },
            GetTeachers: function(config) {
                config.route = "get-teachers";
                return service._sendRequest(config);
            },
            TrainerProfile: function(config) {
                config.route = "trainer-profile";
                return service._sendRequest(config);
            },
            GetPositions: function(config) {
                config.route = "get-positions";
                return service._sendRequest(config);
            },
            StudentsPreviousCourses: function(config) {
                config.route = "students-previous-courses";
                return service._sendRequest(config);
            },
            GetNextPrivateScheduleClass: function(config) {
                config.route = "get-next-private-schedule-class";
                return service._sendRequest(config);
            },
            ShowCourseAttendance: function(config) {
                config.route = "show-course-attendance";
                return service._sendRequest(config);
            },
            TeacherOngoingCourses: function(config) {
                config.route = "teacher-ongoing-courses";
                return service._sendRequest(config);
            },
            TeacherPreviousCourses: function(config) {
                config.route = "teacher-previous-courses";
                return service._sendRequest(config);
            },
            SendRenewCourseMail: function(config) {
                config.route = "send-renew-course-mail";
                return service._sendRequest(config);
            },
            TrainerSelected: function(config) {
                config.route = "trainer-selected";
                return service._sendRequest(config);
            },
            AddScheduleNote: function(config) {
                config.route = "add-schedule-note";
                return service._sendRequest(config);
            },
            TransferStudent: function(config) {
                config.route = "transfer-student";
                return service._sendRequest(config);
            },
            StudentsOngoingCourses: function(config) {
                config.route = "students-ongoing-courses";
                return service._sendRequest(config);
            },
            getUpcomingClasses: function(config) {
                config.route = "get-upcoming-classes";
                return service._sendRequest(config);
            },
            GetInvoiceTemplates: function(config) {
                config.route = "get-invoice-templates";
                return service._sendRequest(config);
            },
            AddUpdateStudent: function(config) {
                config.route = "add-user";
                return service._sendRequest(config);
            },
            AddScheduleStudent: function(config) {
                config.route = "add-schedule-student";
                return service._sendRequest(config);
            },
            GetStudents: function(config) {
                config.route = "get-students";
                return service._sendRequest(config);
            },
            GetStudentsExport: function(config) {
                config.route = "get-students-export";
                return service._sendRequest(config);
            },
            DeleteUser: function(config) {
                config.route = "delete-user";
                return service._sendRequest(config);
            },
            DeleteIntakeStudent: function(config) {
                config.route = "delete-intake-student";
                return service._sendRequest(config);
            },
            AddUpdateRoom: function(config) {
                config.route = "add-room";
                return service._sendRequest(config);
            },
            AddUpdateSchool: function(config) {
                config.route = "add-school";
                return service._sendRequest(config);
            },
            GetRoom: function(config) {
                config.route = "get-rooms";
                return service._sendRequest(config);
            },
            CheckAvailableRoom: function(config) {
                config.route = "check-available-room";
                return service._sendRequest(config);
            },
            CheckAvailableRoomByDate: function(config) {
                config.route = "check-available-room-by-date";
                return service._sendRequest(config);
            },
            SwapRoomByDate: function(config) {
                config.route = "swap-available-room-by-date";
                return service._sendRequest(config);
            },
            GetStudentById: function(config) {
                config.route = "get-studentById";
                return service._sendRequest(config);
            },
            GetGroupIntakes: function(config) {
                config.route = "get-group-intakes";
                return service._sendRequest(config);
            },
            GetCourseLevels1: function(config) {
                config.route = "get-course-levels";
                return service._sendRequest(config);
            },
            GetUniqueCourseList: function(config) {
                config.route = "get-unique-course-list";
                return service._sendRequest(config);
            },
            AddGroupApplication: function(config) {
                config.route = "add-group-application";
                return service._sendRequest(config);
            },
            AddPrivateApplication: function(config) {
                config.route = "add-private-application";
                return service._sendRequest(config);
            },
            GetWeeklySchedule: function(config) {
                config.route = "get-weekly-schedule";
                return service._sendRequest(config);
            },
            GetMonthlySchedule: function(config) {
                config.route = "get-monthly-schedule";
                return service._sendRequest(config);
            },
            DeleteRoom: function(config) {
                config.route = "delete-room";
                return service._sendRequest(config);
            },
            DeleteSchool: function(config) {
                config.route = "delete-school";
                return service._sendRequest(config);
            },
            AddUpdateCourse: function(config) {
                config.route = "add-course";
                return service._sendRequest(config);
            },
            UpdateInvoice: function(config) {
                config.route = "update-invoice";
                return service._sendRequest(config);
            },
            GetCourse: function(config) {
                config.route = "get-courses";
                return service._sendRequest(config);
            },
            GetIntakedata: function(config) {
                config.route = "get-course-intake-details";
                return service._sendRequest(config);
            },
            GetIntakeDates: function(config) {
                config.route = "get-auto-dates";
                return service._sendRequest(config);
            },
            GetIntake: function(config) {
                config.route = "get-intakes";
                return service._sendRequest(config);
            },
            AddUpdateIntake: function(config) {
                config.route = "add-intake";
                return service._sendRequest(config);
            },
            DeleteIntake: function(config) {
                config.route = "delete-intake";
                return service._sendRequest(config);
            },
            AddUpdateHoliday: function(config) {
                config.route = "add-holiday";
                return service._sendRequest(config);
            },
            GetHoliday: function(config) {
                config.route = "get-holidays";
                return service._sendRequest(config);
            },
            TeacherAvailability: function(config) {
                config.route = "trainer-availability";
                return service._sendRequest(config);
            },
            DeleteHoliday: function(config) {
                config.route = "delete-holiday";
                return service._sendRequest(config);
            },
            DeleteCourse: function(config) {
                config.route = "delete-course";
                return service._sendRequest(config);
            },
            checkCourseDelete: function(config) {
                config.route = "is-course-deletable";
                return service._sendRequest(config);
            },
            GetIntakeSuggestion: function(config) {
                config.route = "get-intake-suggestion";
                return service._sendRequest(config);
            },
            GetAdhocSugegestion: function(config) {
                config.route = "get-adhoc-suggestion";
                return service._sendRequest(config);
            },
            GetAdhocStudent: function(config) {
                config.route = "get-adhoc-student";
                return service._sendRequest(config);
            },
            UpdateStudentComment: function(config) {
                config.route = "update-student-comment";
                return service._sendRequest(config);
            },
            GetAdhocTeacher: function(config) {
                config.route = "get-adhoc-teacher";
                return service._sendRequest(config);
            },
            AddAdhocStudent: function(config) {
                config.route = "add-adhoc-class";
                return service._sendRequest(config);
            },
            UpdateInvoiceStatus: function(config) {
                config.route = "update-invoice-status";
                return service._sendRequest(config);
            },
            GetCourseByType: function(config) {
                config.route = "get-course-by-type";
                return service._sendRequest(config);
            },
            checkEmailUnique: function(config) {
                config.route = "is-email-unique";
                return service._sendRequest(config);
            },
            GetStudentId: function(config) {
                config.route = "get-studentID";
                return service._sendRequest(config);
            },
            GetBooks: function(config) {
                config.route = "get-books";
                return service._sendRequest(config);
            },
            AddUpdateBook: function(config) {
                config.route = "add-book";
                return service._sendRequest(config);
            },
            GetIntakeFiletrs: function(config) {
                config.route = "get-intake-filters";
                return service._sendRequest(config);
            },
            DeleteBooks: function(config) {
                config.route = "delete-book";
                return service._sendRequest(config);
            },
            DeleteUsers: function(config) {
                config.route = "delete-book";
                return service._sendRequest(config);
            },
            GetAttendances: function(config) {
                config.route = "get-attendances";
                return service._sendRequest(config);
            },
            GetAttendanceReport: function(config) {
                config.route = "get-attendance-report";
                reset();
                return service._sendRequest(config);
            },
            AddAttendance: function(config) {
                config.route = "add-attendance";
                return service._sendRequest(config);
            },
            MarkAttendance: function(config) {
                config.route = "mark-attendance";
                return service._sendRequest(config);
            },
            forgetPwd: function(config) {
                config.route = "forget-password";
                return service._sendRequest(config);
            },
            checkIntakeStart: function(config) {
                config.route = "is-intake-started";
                return service._sendRequest(config);
            },
            getEditDetails: function(config) {
                config.route = "get-intake-details";
                return service._sendRequest(config);
            },
            TrainerSave: function(config) {
                config.route = "trainer-save";
                return service._sendRequest(config);
            },
            UpdateIntakeRoom: function(config) {
                config.route = "update-intake-room";
                return service._sendRequest(config);
            },

            checkRoomDeletable: function(config) {
                config.route = "is-room-deletable";
                return service._sendRequest(config);
            },
            checkSchoolDeletable: function(config) {
                config.route = "is-school-deletable";
                return service._sendRequest(config);
            },
            checkTeacherDeletable: function(config) {
                config.route = "is-teacher-deletable";
                return service._sendRequest(config);
            },
            exportData: function(config) {
                config.route = "export";

                return service._sendRequest(config);
            },
            setPassword: function(config) {
                config.route = "save-password";
                return service._sendRequest(config);
            },
            GetAllUsers: function(config) {
                config.route = "GetAllUsers";

                return service._sendRequest(config);
            },
            GetAllRoles: function(config) {
                config.route = "GetAllRoles";
                return service._sendRequest(config);
            },
            AddOrUpdateRole: function(config) {
                config.route = "AddOrUpdateRole";
                return service._sendRequest(config);
            },
            DeleteRoles: function(config) {
                config.route = "DeleteRoles";
                return service._sendRequest(config);
            },
            SaveRoleUsers: function(config) {
                config.route = "SaveRoleUsers";
                return service._sendRequest(config);
            },
            GetAllUsersByRole: function(config) {
                config.route = "GetAllUsersByRole";
                return service._sendRequest(config);
            },
            GetAllUserAccessRightsByRole: function(config) {
                config.route = "GetAllUserAccessRightsByRole";
                return service._sendRequest(config);
            },
            SaveUserAccessRight: function(config) {
                config.route = "SaveUserAccessRight";
                return service._sendRequest(config);
            },
            GetAttributeSettings: function(config) {
                config.route = "GetAttributeSettings";
                return service._sendRequest(config);
            },
            GetEmailPhoneList: function(config) {
                config.route = "GetEmailPhoneList";
                return service._sendRequest(config);
            },
            AddOrUpdateEmailPhone: function(config) {
                config.route = "AddOrUpdateEmailPhone";
                return service._sendRequest(config);
            },
            DeleteEmailPhone: function(config) {
                config.route = "DeleteEmailPhone";
                return service._sendRequest(config);
            },
            GetEmailIDList: function(config) {
                config.route = "GetEmailIDList";
                return service._sendRequest(config);
            },
            AddOrUpdateAttributeSetting: function(config) {
                config.route = "AddOrUpdateAttributeSetting";
                return service._sendRequest(config);
            },
            SendStudentCSV: function(config) {
                config.route = "import-csv";
                return service._sendRequest(config);
            },
            GetIntakeStudents: function(config) {
                config.route = "intake-students";
                return service._sendRequest(config);
            },
            importTeachers: function(config) {
                config.route = "import-teachers";
                return service._sendRequest(config);
            },
            UpdateAttendance: function(config) {
                config.route = "update-attendance";
                return service._sendRequest(config);
            },
            CheckIntakeNewTerm: function(config) {
                config.route = "check-intake-new-term";
                return service._sendRequest(config);
            },
            getStudentIntakeCertificate: function(config) {
                config.route = "get-student-intakes";
                return service._sendRequest(config);
            },
            GetTeachersIntakeDetails: function(config) {
                config.route = "get-teacher-intakes";
                return service._sendRequest(config);
            },
            GetTeachersPaymentDetails: function(config) {
                config.route = "get-payment-details";
                return service._sendRequest(config);
            },
            GeneratePayslip: function(config) {
                config.route = "generate-payslip";
                return service._sendRequest(config);
            },
            GetTeacherPayslip: function(config) {
                config.route = "get-teacher-payslips";
                return service._sendRequest(config);
            },
            IsTeacherRateDefined: function(config) {
                config.route = "is-teacher-rate-defined";
                return service._sendRequest(config);
            },
            IsDateBlocked: function(config) {
                config.route = "is-date-blocked";
                return service._sendRequest(config);
            },
            GetSchool: function(config) {
                config.route = "get-schools";
                return service._sendRequest(config);
            },
            SendInvoice: function(config) {
                config.route = "send-invoice";
                return service._sendRequest(config);
            },
            SendAllInvoices: function(config) {
                config.route = "send-all-invoices";
                return service._sendRequest(config);
            },
            CheckDuplicateEmailForStudentEnrolment: function(config) {
                config.route = "check-student-enrol";
                return service._sendRequest(config);
            },
            GetAdmins: function(config) {
                config.route = "get-admins";
                return service._sendRequest(config);
            },
            AddUpdateAdmin: function(config) {
                config.route = "add-admin";
                return service._sendRequest(config);
            },
            DeleteAdmin: function(config) {
                config.route = "delete-admin";
                return service._sendRequest(config);
            },
            ReActivateAdmin: function(config) {
                config.route = "reactivate-deleted-admin";
                return service._sendRequest(config);
            },
            ReActivateRoom: function(config) {
                config.route = "reactivate-deleted-room";
                return service._sendRequest(config);
            },
            ReActivateCourse: function(config) {
                config.route = "reactivate-deleted-course";
                return service._sendRequest(config);
            },
            GetMakeUpEligibleStudents: function(config) {
                config.route = "get-makeup-eligible-students";
                return service._sendRequest(config);
            },
            GetMakeUpStudents: function(config) {
                config.route = "get-makeup-students";
                return service._sendRequest(config);
            },
            AddMakeUpClass: function(config) {
                config.route = "add-makeup-class";
                return service._sendRequest(config);
            },
            GetMakeUpStudentInvoice: function(config) {
                config.route = "get-makeup-student-invoice";
                return service._sendRequest(config);
            },
            UpdateMakeUpInvoice: function(config) {
                config.route = "update-makeup-invoice";
                return service._sendRequest(config);
            },
            UpdateMakeUpInvoiceAmount: function(config) {
                config.route = "update-makeup-invoice-amount";
                return service._sendRequest(config);
            },
            AddPrivateClass: function(config) {
                config.route = "add-private-class";
                return service._sendRequest(config);
            },
            AddSignature: function(config) {
                config.route = "add-signature";
                return service._sendRequest(config);
            },
            GetPrivateDeleteDates: function(config) {
                config.route = "get-private-delete-class-dates";
                return service._sendRequest(config);
            },
            DeletePrivateClass: function(config) {
                config.route = "delete-private-class";
                return service._sendRequest(config);
            },
            CheckPrivateDate: function(config) {
                config.route = "check-private-date-available";
                return service._sendRequest(config);
            },
            GetAvailableRoomSlots: function(config) {
                config.route = "get-available-room-slots";
                return service._sendRequest(config);
            }
        };
        return service;
    }

    angular
        .module('fuse')
        .factory('Utils', Utils);
    /** @ngInject */
    function Utils($mdToast, $document, usSpinnerService) {

        var vm = this;
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        vm.toastPosition = angular.extend({}, last);
        vm.getToastPosition = function() {
            sanitizePosition();
            return Object.keys(vm.toastPosition)
                .filter(function(pos) {
                    return vm.toastPosition[pos];
                })
                .join(' ');
        };

        function sanitizePosition() {
            var current = vm.toastPosition;
            if (current.bottom && last.top)
                current.top = false;
            if (current.top && last.bottom)
                current.bottom = false;
            if (current.right && last.left)
                current.left = false;
            if (current.left && last.right)
                current.right = false;
            last = angular.extend({}, current);
        }

        return {
            showToast: function(config) {
                var bg_class;
                if (config.type == 1) {
                    bg_class = 'success'
                } else {
                    bg_class = 'error'
                }
                $mdToast.show(
                    $mdToast.simple({ template: '<md-toast class="md-toast ' + bg_class + '">' + config.text + '</md-toast>' })
                    //                        .textContent()
                    .position(vm.getToastPosition())
                    .hideDelay(3000)
                )
            },
            showLoader: function(param) {
                if (param == true) {
                    usSpinnerService.spin('spinner-1');
                    $(".spinner-overlay").focus();
                    $(".spinner-overlay").removeClass('g-hidden');
                } else {
                    usSpinnerService.stop('spinner-1');
                    $(".spinner-overlay").addClass('g-hidden');
                }
            },
            getconvertTimeStamp: function(string) {
                if (string != null) {
                    var len = string.length;
                    var timeStamp = string.substring(6, len - 2);
                    var d = new Date(parseInt(timeStamp)),
                        month = '' + (d.getMonth() + 1),
                        day = '' + d.getDate(),
                        year = d.getFullYear();
                    var t = moment(d).format("hh:mm:ss a")
                    if (month.length < 2)
                        month = '0' + month;
                    if (day.length < 2)
                        day = '0' + day;
                    var fullYear = [month, day, year].join('/');
                    return fullYear + "   " + t;
                } else {
                    return "";
                }
            },
            getconvertTime: function(string) {
                if (string != null) {
                    var len = string.length;
                    var timeStamp = string;
                    var d = new Date(timeStamp),
                        month = '' + (d.getMonth() + 1),
                        day = '' + d.getDate(),
                        year = d.getFullYear();
                    if (month.length < 2)
                        month = '0' + month;
                    if (day.length < 2)
                        day = '0' + day;
                    var fullYear = [day, month, year].join('/');
                    return fullYear;
                } else {
                    return "";
                }
            },
            getDateToTimeStamp: function(date) {
                var d = date,
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = d.getFullYear();
                if (month.length < 2)
                    month = '0' + month;
                if (day.length < 2)
                    day = '0' + day;
                var formatedDate = [month, day, year].join('/');
                var dt = new Date(formatedDate);
                var newDate = new Date(Date.UTC(dt.getFullYear(), dt.getMonth(), dt.getDate(), dt.getHours(), dt.getMinutes(), dt.getSeconds(), dt.getMilliseconds()));
                var timeZone = new Date().toString().match(/([-\+][0-9]+)\s/)[1];
                //                var timeZone = '0000' ;
                return '/Date(' + newDate.getTime() + '' + timeZone + ')/';
                //                var newDate = dateFormat(jsonDate, "mm/dd/yyyy");
                //                return new Date(formatedDate).getTime();
                //                  return new Date(formatedDate).getUnixTime()
            },
            getFormattedDate: function(date) {
                var dateParts = date.split("/");
                var formattedDate = new Date(dateParts[2], (dateParts[1] - 1), dateParts[0]).toString();
                return formattedDate;
            },
            getFormattedIntakeDate: function(date) {
                var dateParts = date.split("/");
                var formattedDate = new Date(dateParts[2], (dateParts[1] - 1), dateParts[0]);
                return formattedDate;
            },
            getParsedDate: function(date) {
                var d = date,
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = d.getFullYear();
                var formatedDate = [day, month, year].join('-');
                return formatedDate;
            },
            getParsedSlashedDate: function(date) {
                var d = date,
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = d.getFullYear();
                var formatedDate = [day, month, year].join('/');
                return formatedDate;
            },
            getDashedFormattedDate: function(date) {
                var dateParts = date.split("-");
                var formattedDate = new Date(dateParts[2], (dateParts[1] - 1), dateParts[0]).toString();
                return formattedDate;
            },
        }
    };
    angular
        .module('fuse')
        .factory('ConstructTree', locationData);
    /** @ngInject */
    function locationData() {

        var formatLocationData = function(data) {
            var treeData = [];
            if (data.length != undefined) {

                data.sort(function(a, b) {
                    return b['LocationID'] - a['LocationID']
                });
                data.sort(function(a, b) {
                    return b['ParentLocationID'] - a['ParentLocationID']
                });
                // debugger
                // $.each(data, function(index) {
                //     if (data[index]['ParentLocationID'] == "00000000-0000-0000-0000-000000000000") {
                //         data[index]['ParentLocationID'] = "";
                //     }
                // });
                treeData = getTreeForDueToAnalysis(data, 'LocationID', 'ParentLocationID');
                treeData.sort(function(a, b) {
                    return a['LocationName'] - b['LocationName']
                });
            }

            return treeData;
        }

        var formatAssetTypeData = function(data) {
            var treeData = [];
            if (data.length != undefined) {
                data.sort(function(a, b) {
                    return b['AssetTypeID'] - a['AssetTypeID']
                });
                data.sort(function(a, b) {
                    return b['ParentAssetTypeID'] - a['ParentAssetTypeID']
                });
                // debugger
                // $.each(data, function(index) {
                //     if (data[index]['ParentAssetTypeID'] == "00000000-0000-0000-0000-000000000000") {
                //         data[index]['ParentAssetTypeID'] = "";
                //     }
                // });
                treeData = getTreeForDueToAnalysis(data, 'AssetTypeID', 'ParentAssetTypeID');
                treeData.sort(function(a, b) {
                    return a['Name'] - b['Name']
                });
            }
            return treeData;
        }

        var formatAssetData = function(data) {
            var treeData = [];
            if (data.length != undefined) {
                data.sort(function(a, b) {
                    return b['AssetID'] - a['AssetID']
                });
                data.sort(function(a, b) {
                    return b['ParentAssetID'] - a['ParentAssetID']
                });
                // debugger
                // $.each(data, function(index) {
                //     if (data[index]['ParentAssetID'] == "00000000-0000-0000-0000-000000000000") {
                //         data[index]['ParentAssetID'] = "";
                //     }
                // });
                treeData = getTreeForDueToAnalysis(data, 'AssetID', 'ParentAssetID');
                treeData.sort(function(a, b) {
                    return a['DisplayName'] - b['DisplayName']
                });
            }
            return treeData;
        }

        function getTreeForDueToAnalysis(data, primaryIdName, parentIdName) {
            if (!data || data.length == 0 || !primaryIdName || !parentIdName)
                return [];
            var tree = [],
                rootIds = [],
                item = data[0],
                primaryKey = item[primaryIdName],
                treeObjs = {},
                tempChildren = {},
                parentId,
                parent,
                len = data.length,
                i = 0;
            while (i < len) {
                item = data[i++];
                primaryKey = item[primaryIdName];
                if (tempChildren[primaryKey]) {
                    item.children = tempChildren[primaryKey];
                    delete tempChildren[primaryKey];
                }

                treeObjs[primaryKey] = item;
                parentId = item[parentIdName];
                if (parentId && parentId != "00000000-0000-0000-0000-000000000000") {
                    parent = treeObjs[parentId];
                    if (!parent) {
                        var siblings = tempChildren[parentId];
                        if (siblings) {
                            siblings.push(item);
                        } else {
                            tempChildren[parentId] = [item];
                        }
                    } else if (parent.children) {
                        parent.children.push(item);
                    } else {
                        parent.children = [item];
                    }
                } else {
                    rootIds.push(primaryKey);
                }
            }

            for (var i = 0; i < rootIds.length; i++) {
                tree.push(treeObjs[rootIds[i]]);
            };
            return tree;
        }
        var service = {
            getLocationTree: function(params) {
                return formatLocationData(params);
            },
            getAssetTypeTree: function(params) {
                return formatAssetTypeData(params);
            },
            getAssetTree: function(params) {
                return formatAssetData(params);
            }
        };
        return service;
    };
    angular
        .module('fuse').factory('httpRequestInterceptor', ['$rootScope', function($rootScope) {
            return {
                request: function($config) {
                    $config.headers['Content-Type'] = 'application/json; charset=UTF-8';
                    var userInfo = globalPool().getUserInfo();
                    if (userInfo && userInfo.AuthToken !== undefined) {
                        $config.headers.Authorization = userInfo.AuthToken;
                    }
                    return $config;
                    //                            'Content-Type': 'application/json; charset=UTF-8'
                }
            };
        }]);
    //    angular
    //            .module('fuse').factory('httpResponseInterceptor', ['$q', '$location', '$injector', function ($q, $location, $injector) {
    //            $injector = angular.injector();
    //            return {
    //                response: function (response) {
    //                    $injector.invoke(function (GlobalPool) {
    //                        if (response.status === 401) {
    //                            console.log("Response 401");
    //                        }
    //                        return response || $q.when(response);
    //                    });
    //                },
    //                responseError: function (rejection) {
    //                    if (rejection.status === 401) {
    //                        console.log("Response Error 401", rejection);
    //                        var pool = $injector.get("GlobalPool");
    //                        pool.setUserData(null);
    ////                        $location.path("/login");
    //                        location.href = "/";
    //                    }
    //                    return $q.reject(rejection);
    //                }
    //            }
    //        }])
})();
(function() {
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, Auth, $location, Utils, $document, $window, GlobalPool) {
        //        
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function(event, toState, toParams, GlobalPool) {
            //            var userInfo = GlobalPool.getUserInfo();
            //            console.log(userInfo);
            //            console.log($rootScope.roleID);
            Utils.showLoader(true);
            if (!Auth.isPublicUrl(toState.url)) {
                Auth.isLoggedIn().then(function(bLoggedIn) {
                    if (!bLoggedIn)
                        $location.path("/login");
                });
            }


            var state = toState.url;
            //            $rootScope.previousUrl = toState.url;

            if (toState.url == '/login') {
                Auth.isLoggedIn().then(function(bLoggedIn) {
                    if (bLoggedIn)
                        $timeout(function() {
                            if ($rootScope.roleID == '5') {
                                $state.go("app.schools");
                            } else {
                                if ($rootScope.roleID == '1') {
                                    $state.go("app.dashboard");
                                } else if ($rootScope.roleID == '2') {
                                    $state.go("app.profile & class details");                                    
                                } else {
                                    $state.go("app.intakes");
                                }
                            }
                            //                            $state.go("app.intakes");
                        });
                });
            } else if (toState.url == '/logout') {
                Auth.logout();
            }


            if (toState.url == '/login') {
                $rootScope.loadingProgress = true;
            } else if (toState.url == '/change-teacher' || toState.url == '/unsubscribe' || toState.url == '/next-private-class-schedule' || toState.url == '/thank-you' || toState.url == '/yiman-admin-class-sign-up-thank-you' || toState.url == '/indoslang-admin-class-sign-up-thank-you' || toState.url == '/hana-admin-class-sign-up-thank-you' || toState.url == '/english-express-admin-class-sign-up-thank-you' || toState.url == '/page-not-found' || toState.url == '/admissions' || toState.url == '/admissions/:id/:courseName/:courseType' || toState.url == '/forgot-password' || toState.url == 'http://yi-mandarin.testground.me/reset-password' || toState.url == "http://yi-mandarin-client.testground.me/reset-password" || toState.url == 'http://yi-mandarin.testground.me/mark-attendance' || toState.url == "http://yi-mandarin-client.testground.me/mark-attendance" || toState.url == '/reset-password' || toState.url == '/mark-attendance' || toState.url == '/show-attendance' || toState.url == 'http://yi-mandarin.testground.me/admissions' || toState.url == 'http://yi-mandarin.testground.me/page-not-found') {
                //                event.preventDefault();
                // console.log(toState.url)
            } else if (toState.data['bAllow'] == false) {
                // console.log(toState.url)
                event.preventDefault();
            }
            // $rootScope.loadingProgress = true;
        });
        //    $rootScope.$on('$routeChangeStart', function(){ 
        //     console.log($route.current); 
        // });
        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams) {
            var title = "";
            var url = "";
            if (typeof toState.ncyBreadcrumb != 'undefined') {
                title = toState.ncyBreadcrumb.label;
            } else {
                title = toState.name;
            }

            if (typeof toState.bodyClass != 'undefined' && toState.bodyClass == "admission") {
                url = "/admissions/" + toParams.id + "/" + toParams.courseName + "/" + toParams.courseType;
            } else {
                url = toState.url;
            }
            console.log(url);
            // dataLayer.push({
            //     'event': 'pageviewCustomEvent',
            //     'pagePath': url,
            //     'pageTitle': title
            // });
            Utils.showLoader(false);
            $timeout(function() {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;
        $rootScope.previousUrl = $location.path();

        // $scope.$on("$routeChangeSuccess", function($currentRoute, $previousRoute) {
        //     // $scope.customs.prodoc = $scope.routeParams.prodoc;
        //     alert('1');
        // });
        // Cleanup
        $rootScope.$on('$destroy', function() {
                stateChangeStartEvent();
                stateChangeSuccessEvent();
            })
            //        var d = new Date();
            //        var n = d.getTime();  //n in ms
            //
            //        $rootScope.idleEndTime = n + (15 * 60 * 1000); //set end time to 20 min from now
            //        $document.find('body').on('mousemove keydown DOMMouseScroll mousewheel mousedown touchstart', checkAndResetIdle); //monitor events
            //
            //        function checkAndResetIdle() //user did something
            //        {
            //            var d = new Date();
            //            var n = d.getTime();  //n in ms
            //
            //            if (n > $rootScope.idleEndTime)
            //            {
            //                $document.find('body').off('mousemove keydown DOMMouseScroll mousewheel mousedown touchstart'); //un-monitor events
            //
            //                //$location.search('IntendedURL',$location.absUrl()).path('/login'); //terminate by sending to login page
            ////                $location.path("/login");
            //                Auth.logout(false);
            //                alert('Session ended due to inactivity');
            //            }
            //            else
            //            {
            //                $rootScope.idleEndTime = n + (15 * 60 * 1000); //reset end time
            //            }
            //        }
            ////        window.onbeforeunload = function() {
            ////            window.localStorage.clear();
            ////            window.sessionStorage.clear();
            ////        }
            //        $(window).on('unload', function()
            //        {
            //            window.localStorage.clear();
            //            window.sessionStorage.clear();
            //        })
    }
})();
(function() {
    'use strict';
    angular
        .module('fuse')
        .config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {

        $locationProvider.html5Mode(true);
        // $urlRouterProvider.when('/admissions/:id/:courseName/:courseType',{
        //     templateUrl:'app/main/pages/auth/admission/admission.html',
        //     controller:'AdmissionController as vm',
        //     publicAccess:true,
        //     sessionAccess:true
        // })
        // dataLayer.push({
        //     'event': 'pageviewCustomEvent',
        //     'pagePath': '/Contact Us',
        //     'pageTitle': 'Contact Us'
        // });



        $urlRouterProvider
            .when('/admissions/:id/:courseName/:courseType', ['$state', '$stateParams', '$rootScope', function($state, $stateParams, $rootScope, $location) {
                var main_URL = location.href;
                var main_URL = decodeURIComponent(main_URL);
                var param;
                if (main_URL.includes('?intake_id')) {
                    param = main_URL.split('=');
                    $rootScope.admissionIntakeID = parseInt(param[1]);
                    var admissionLevel = param[2].split('&');
                    $rootScope.admissionLevel = admissionLevel[0];
                }
                var url = $rootScope.previousUrl;
                url = url.split('/')
                if (url[4] == 'group' || url[4] == 'private' || url[4] == 'online') {
                    $state.go('app.pages_auth_admission', { id: url[2], courseName: url[3], courseType: url[4] });
                } else {
                    window.location = "/page-not-found";
                }
            }])
            .when('/schools', ['$state', '$stateParams', '$rootScope', 'GlobalPool', function($state, $stateParams, $rootScope, GlobalPool) {
                var userInfo = GlobalPool.getUserInfo();
                if (userInfo.role_id == '5') {
                    $state.go('app.schools');
                } else {
                    $state.go('app.intakes');
                }
            }])
            .when('/intake/:makeupid', ['$state', '$stateParams', '$rootScope', 'GlobalPool', function($state, $stateParams, $rootScope, GlobalPool) {
                var url = $rootScope.previousUrl;
                url = url.split('/');
                //                    console.log($stateParams);
            }])
            .when('/schedule', ['$state', '$stateParams', '$rootScope', 'GlobalPool', function($state, $stateParams, $rootScope, GlobalPool) {
                var userInfo = GlobalPool.getUserInfo();
                if (userInfo.role_id == '5') {
                    $state.go('app.schools');
                } else {
                    $state.go('app.schedule');
                }

            }])
            .when('/courses', ['$state', '$stateParams', '$rootScope', 'GlobalPool', function($state, $stateParams, $rootScope, GlobalPool) {
                var userInfo = GlobalPool.getUserInfo();
                if (userInfo.role_id == '5') {
                    $state.go('app.schools');
                } else {
                    $state.go('app.courses');
                }
            }])
            .when('/admins', ['$state', '$stateParams', '$rootScope', 'GlobalPool', function($state, $stateParams, $rootScope, GlobalPool) {
                var userInfo = GlobalPool.getUserInfo();
                if (userInfo.role_id == '5') {
                    $state.go('app.schools');
                } else {
                    $state.go('app.admins');
                }
            }])
            .when('/teachers', ['$state', '$stateParams', '$rootScope', 'GlobalPool', function($state, $stateParams, $rootScope, GlobalPool) {
                var userInfo = GlobalPool.getUserInfo();
                if (userInfo.role_id == '5') {
                    $state.go('app.schools');
                } else {
                    $state.go('app.teachers');
                }
            }])
            .when('/students', ['$state', '$stateParams', '$rootScope', 'GlobalPool', function($state, $stateParams, $rootScope, GlobalPool) {
                var userInfo = GlobalPool.getUserInfo();
                if (userInfo.role_id == '5') {
                    $state.go('app.schools');
                } else {
                    $state.go('app.students');
                }
            }])
            .when('/teacher-profile', ['$state', '$stateParams', '$rootScope', 'GlobalPool', function($state, $stateParams, $rootScope, GlobalPool) {
                var userInfo = GlobalPool.getUserInfo();
                if (userInfo.role_id == '5') {
                    $state.go('app.schools');
                } else {
                    $state.go('app.profile & class details');
                }
            }])
            .when('/rooms', ['$state', '$stateParams', '$rootScope', 'GlobalPool', function($state, $stateParams, $rootScope, GlobalPool) {
                var userInfo = GlobalPool.getUserInfo();
                if (userInfo.role_id == '5') {
                    $state.go('app.schools');
                } else {
                    $state.go('app.rooms');
                }
            }])
            .when('/skills', ['$state', '$stateParams', '$rootScope', 'GlobalPool', function($state, $stateParams, $rootScope, GlobalPool) {
                var userInfo = GlobalPool.getUserInfo();
                if (userInfo.role_id == '5') {
                    $state.go('app.schools');
                } else {
                    $state.go('app.skills');
                }
            }])
            .when('/attendance', ['$state', '$stateParams', '$rootScope', 'GlobalPool', function($state, $stateParams, $rootScope, GlobalPool) {
                var userInfo = GlobalPool.getUserInfo();
                if (userInfo.role_id == '5') {
                    $state.go('app.schools');
                } else {
                    $state.go('app.attendance');
                }
            }])
            .when('/holidays', ['$state', '$stateParams', '$rootScope', 'GlobalPool', function($state, $stateParams, $rootScope, GlobalPool) {
                var userInfo = GlobalPool.getUserInfo();
                if (userInfo.role_id == '5') {
                    $state.go('app.schools');
                } else {
                    $state.go('app.holidays');
                }
            }])
            .when('/dashboard', ['$state', '$stateParams', '$rootScope', 'GlobalPool', function($state, $stateParams, $rootScope, GlobalPool) {
                var userInfo = GlobalPool.getUserInfo();
                if (userInfo.role_id == '5') {
                    $state.go('app.schools');
                } else {
                    $state.go('app.dashboard');
                }
            }])
            .when('/books', ['$state', '$stateParams', '$rootScope', 'GlobalPool', function($state, $stateParams, $rootScope, GlobalPool) {
                var userInfo = GlobalPool.getUserInfo();
                if (userInfo.role_id == '5') {
                    $state.go('app.schools');
                } else {
                    $state.go('app.books');
                }
            }])
            .when('/payroll', ['$state', '$stateParams', '$rootScope', 'GlobalPool', function($state, $stateParams, $rootScope, GlobalPool) {
                var userInfo = GlobalPool.getUserInfo();
                if (userInfo.role_id == '5') {
                    $state.go('app.schools');
                } else {
                    $state.go('app.payroll');
                }
            }])
            .otherwise('/login');
        // $urlRouterProvider.otherwise('/login');

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/vertical-navigation.html',
                        controller: 'MainController as vm'
                    },
                    'toolbar@app': {
                        templateUrl: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                        controller: 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: 'app/navigation/layouts/vertical-navigation/navigation.html',
                        controller: 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller: 'QuickPanelController as vm'
                    }
                }
            });
    }

})();
(function() {
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming, GlobalPool, $rootScope) {
        var vm = this;
        var userMenu = GlobalPool.getUserMenu();
        //        if (Auth.isLoggedIn()) {
        var userInfo = GlobalPool.getUserInfo();
        if (userInfo && Object.keys(userInfo).length > 0) {
            $rootScope.roleID = userInfo.role_id;
        }
        //        }
        if (userMenu && Object.keys(userMenu).length > 0) {
            $(document).trigger('AuthDataLoaded', { data: userMenu });
        }
        vm.themes = fuseTheming.themes;
        vm.stagingGoogleAnalytics = true;
    }

    window.Paginator = function() {
        var vm = this;
        this.curPageIndex = 1,
            this.pageLength = 10,
            this.totalItems = -1,
            this.pageStartIndex = 1,
            this.pageEndIndex = this.pageLength,
            this.lastPageIndex = -1;
        this.allowPrevious = false;
        this.allowNext = false;


        this.setDefaults = function() {
            if (this.totalItems != -1) {
                this.lastPageIndex = Math.ceil(this.totalItems / this.pageLength);
            }
            this.setParam();
        };
        this.goToNext = function() {
            vm.curPageIndex += 1;
            this.setParam();
        };
        this.goToPrevious = function() {
            vm.curPageIndex -= 1;
            if (vm.curPageIndex == 1) {
                vm.allowPrevious = true;
                vm.allowNext = false;
            }
            this.setParam();
        };
        this.setParam = function() {
            vm.pageStartIndex = (vm.curPageIndex - 1) * vm.pageLength + 1;
            if (vm.curPageIndex == vm.lastPageIndex) {
                vm.pageEndIndex = vm.totalItems
            } else {
                vm.pageEndIndex = vm.curPageIndex * vm.pageLength;
            }


            if (this.curPageIndex > 1) {
                this.allowPrevious = true;
            } else {
                this.allowPrevious = false;
            }
            if (this.lastPageIndex == this.curPageIndex) {
                this.allowNext = false;
            } else {
                this.allowNext = true;
            }
        };

        this.next = function(e, pageStartIndex, pageEndIndex, totalItems) {
            if (pageEndIndex < totalItems) {
                this.goToNext();
            }
        };

        this.previous = function(e, pageStartIndex, pageEndIndex, totalItems) {

            this.goToPrevious();
        };

        this.setTotal = function(iTotal) {
            vm.totalItems = iTotal;
            this.setDefaults();

        };
    };
})();
(function() {
    'use strict';
    angular
        .module('fuse');
    window.Focus = window.Focus || {};
    var _focus = {
        ENUMS: {
            CLASS_TYPE: [{
                id: "4",
                value: "Other"
            }],
            INTAKE_COLOR: [{
                    id: "1",
                    value: "red",
                    text: "P",
                    bcolor: "#ef4836"
                },
                {
                    id: "2",
                    value: "blue",
                    text: "I",
                    bcolor: "#71b8ff"
                },
                {
                    value: "green",
                    id: 3,
                    text: "G",
                    bcolor: "#26a65b"
                },
                {
                    value: "yellow",
                    id: 4,
                    text: "Y",
                    bcolor: "#f8b735"
                }

            ],
            INTAKE_FILTERTYPE: [{
                    id: "1",
                    value: "1",
                    text: "EOC today"
                },
                {
                    id: "2",
                    value: "2",
                    text: "Ongoing SOC"
                },
                {
                    id: "3",
                    value: "3",
                    text: "Future"
                }
            ],
            COURSE_TYPE: [{
                    value: "Group",
                    id: 3,
                    text: "G"
                },
                {
                    id: "1",
                    value: "Private",
                    text: "P"
                },
                {
                    id: "2",
                    value: "Intensive",
                    text: "I"
                },
                {
                    id: "4",
                    value: "Online",
                    text: "O"
                }
            ],
            COURSE_FILTERTYPE: [{
                    value: "Group",
                    id: 3,
                    text: "G"
                },
                {
                    id: "1",
                    value: "Private",
                    text: "P"
                },
                {
                    id: "2",
                    value: "Intensive",
                    text: "I"
                },
                {
                    id: "4",
                    value: "Online",
                    text: "O"
                }
            ],
            COURSE_VALIDITY: [{
                    value: "1 months",
                    id: 1,
                    text: "1"
                },
                {
                    id: "2",
                    value: "3 months",
                    text: "3"
                },
                {
                    id: "3",
                    value: "6 months",
                    text: "6"
                },
                {
                    value: "9 months",
                    id: 4,
                    text: "9"
                },
                {
                    id: "5",
                    value: "12 months",
                    text: "12"
                }
            ],
            INTAKE_SERIES: [{
                    value: "1",
                    id: 1
                },
                {
                    id: "2",
                    value: "2"
                },
                {
                    id: "3",
                    value: "3"
                },
                {
                    value: "4",
                    id: "4"
                },
                {
                    id: "5",
                    value: "5"
                },
                {
                    id: "6",
                    value: "6"
                },
                {
                    value: "7",
                    id: "7"
                },
                {
                    id: "8",
                    value: "8"
                },
                {
                    id: "9",
                    value: "9"
                },
                {
                    value: "10",
                    id: "10"
                },
                {
                    id: "11",
                    value: "N/A"
                }

            ],
            COURSE_LANGUAGE: [{
                    value: "Indonesian",
                    id: 3,
                    text: "Indonesia"
                },
                {
                    id: "1",
                    value: "English",
                    text: "English"
                },
                {
                    id: "2",
                    value: "Mandarin",
                    text: "Mandarin"
                }
            ],
            COURSE_LEVEL: [{
                    id: "1",
                    value: "Beginner"
                },
                {
                    id: "2",
                    value: "Elementary"
                },
                {
                    id: "3",
                    value: "Pre-Intermediate"
                },
                {
                    id: "4",
                    value: "Intermediate"
                },
                {
                    id: "5",
                    value: "Upper-Intermediate"
                },
                {
                    value: "Advanced",
                    id: 6
                },
                {
                    value: "Customized",
                    id: 7
                }
            ],
            COURSE_RECURRANCE: [{
                    id: "2",
                    value: "Daily"
                },
                {
                    id: "1",
                    value: "Weekly",
                }
            ],
            SCHEDULE_RECURRANCE: [{
                    id: "1",
                    value: "Daily"
                },
                {
                    id: "2",
                    value: "Weekly",
                }
            ],
            RECURRANCE_DAYS: [
                { id: 0, day: 'Sun', bAllow: false },
                { id: 1, day: 'Mon', bAllow: false },
                { id: 2, day: 'Tue', bAllow: false },
                { id: 3, day: 'Wed', bAllow: false },
                { id: 4, day: 'Thu', bAllow: false },
                { id: 5, day: 'Fri', bAllow: false },
                { id: 6, day: 'Sat', bAllow: false }

            ],
            COURSE_TIME: [{
                    value: "Evening",
                    id: 3

                },
                {
                    id: "1",
                    value: "Morning"
                },
                {
                    id: "2",
                    value: "Afternoon"
                }
            ],
            TEACHER_ZONES: [{
                    id: "1",
                    value: "North"
                },
                {
                    id: "2",
                    value: "North East",
                },
                {
                    id: "3",
                    value: "North West",
                },
                {
                    id: "4",
                    value: "South",
                },
                {
                    id: "5",
                    value: "South East",
                },
                {
                    id: "6",
                    value: "South West",
                },
                {
                    id: "7",
                    value: "East",
                },
                {
                    id: "8",
                    value: "West",
                },
            ],
            ROLES: [{
                    value: "1",
                    id: '2,3,4,5,6,7,8,9,10,11,12,15'
                },
                {
                    id: "6,10,12,16",
                    value: "2"
                },
                {
                    id: "10",
                    value: "3"
                },
                {
                    value: "4",
                    id: '2,3,4,5,6,7,8,9,10,11,12,14'
                },
                {
                    value: "5",
                    id: '13'
                }

            ],
            ASSET_PROCESS: [{
                    value: "None",
                    id: 0
                },
                {
                    value: "Check-in",
                    id: 1
                },
                {
                    id: 2,
                    value: "Check-out"
                },
            ],
            ASSET_STATUS: [{
                    value: "Intialised",
                    id: 0
                },
                {
                    value: "TriggerReplenish",
                    id: 1
                },
                {
                    id: "2",
                    value: "Replenished"
                },
                {
                    id: "3",
                    value: "Delivered"
                },
                {
                    id: "20",
                    value: "DeCommission"
                },
                {
                    id: "50",
                    value: "Received"
                },
                {
                    id: "51",
                    value: "Intransit"
                },
                {
                    id: "52",
                    value: "Receive_Billed"
                },
                {
                    id: "53",
                    value: "Issued"
                },
            ],
            ASSET_TABLE: [{
                    id: "1",
                    value: "Asset",
                },
                {
                    id: "2",
                    value: "AssetType"
                }
            ],
            HOLIDAY_YEARS: [{
                    value: "2010",
                    id: 1
                },
                {
                    id: "2",
                    value: "2011"
                },
                {
                    id: "3",
                    value: "2012"
                },
                {
                    id: "4",
                    value: "2013"
                },
                {
                    id: "5",
                    value: "2014"
                }, {
                    id: "6",
                    value: "2015"
                }, {
                    id: "7",
                    value: "2016"
                }, {
                    id: "8",
                    value: "2017"
                }, {
                    id: "9",
                    value: "2018"
                }, {
                    id: "10",
                    value: "2019"
                }, {
                    id: "11",
                    value: "2020"
                }, {
                    id: "12",
                    value: "2021"
                }, {
                    id: "13",
                    value: "2022"
                }, {
                    id: "14",
                    value: "2023"
                }, {
                    id: "15",
                    value: "2024"
                }, {
                    id: "16",
                    value: "2025"
                }, {
                    id: "17",
                    value: "2026"
                }, {
                    id: "18",
                    value: "2027"
                }, {
                    id: "19",
                    value: "2028"
                },
                {
                    id: "20",
                    value: "2029"
                }, {
                    id: "30",
                    value: "2030"
                },
            ],
            ASSET_ATTRIBUTE: [{
                    value: "Field1",
                    id: 1
                },
                {
                    id: "2",
                    value: "Field2"
                },
                {
                    value: "Field3",
                    id: 3
                },
                {
                    id: "4",
                    value: "Field4"
                },
                {
                    value: "Field5",
                    id: 5
                },
                {
                    id: "6",
                    value: "Field6"
                },
                {
                    value: "Field7",
                    id: 7
                },
                {
                    id: "8",
                    value: "Field8"
                },
                {
                    value: "Field9",
                    id: 9
                },
                {
                    id: "10",
                    value: "Field10"
                },
            ],
            TRANSACTION_STATUS: [{
                    value: "None",
                    id: -1
                },
                {
                    value: "Intialised",
                    id: 0
                },
                {
                    value: "Received",
                    id: 1
                },
                {
                    id: "2",
                    value: "Soiled"
                },
                {
                    id: "62",
                    value: "Delivered"
                },
                {
                    id: "20",
                    value: "DeCommission"
                },
                {
                    id: "60",
                    value: "Stored"
                },
                {
                    id: "51",
                    value: "Intransit"
                },
                {
                    id: "52",
                    value: "Receive_Billed"
                },
                {
                    id: "53",
                    value: "Issued"
                },
                {
                    id: "61",
                    value: "Packing"
                },
                {
                    id: "100",
                    value: "Clean"
                },
                {
                    id: "101",
                    value: "Rewashed"
                },
                {
                    id: "102",
                    value: "InLocation"
                },
            ],
            CONTACTMODE: [{
                    value: "Email",
                    id: 1
                },
                {
                    value: "Phone",
                    id: 2
                },
            ],
            INVENTORY_PRINT_OPTION: [{
                    id: "1",
                    value: "By Location - InventoryQty",
                },
                {
                    id: "2",
                    value: "By Location - AssetType Details"
                }
            ],
            ALERT_TYPE: [{
                    id: "1",
                    value: "No Movement",
                    description: ""
                },
                {
                    id: "3",
                    value: "Critical Stock Level"
                },
                {
                    id: "4",
                    value: "FTP Connection"
                },
                {
                    id: "5",
                    value: "Auto Replenish"
                },
                {
                    id: "7",
                    value: "Transaction Trace"
                },
                {
                    id: "8",
                    value: "Auto DailyBilling"
                },
                {
                    id: "9",
                    value: "Generating Topup Info"
                },
                {
                    id: "10",
                    value: "Exception"
                }
            ],
            COURSE: [{
                    id: "1",
                    value: "ABC",
                    description: ""
                },
                {
                    id: "2",
                    value: "PQR"
                },
                {
                    id: "4",
                    value: "XYZ"
                },
                {
                    id: "3",
                    value: "MNO"
                }

            ],
            TIME_SLOT: [{
                    id: "1",
                    value: "MORNING",
                    description: ""
                },
                {
                    id: "2",
                    value: "NOON"
                },
                {
                    id: "4",
                    value: "XYZ"
                },
                {
                    id: "3",
                    value: "EVENING"
                }

            ],
            ROOM: [{
                    id: "1",
                    value: "101-A",
                    description: ""
                },
                {
                    id: "2",
                    value: "202-B"
                },
                {
                    id: "4",
                    value: "404-D"
                },
                {
                    id: "3",
                    value: "303-C"
                }

            ],
            TEACHER: [{
                    id: "1",
                    value: "ABC",
                    description: ""
                },
                {
                    id: "2",
                    value: "PQR"
                },
                {
                    id: "4",
                    value: "MNO"
                },
                {
                    id: "3",
                    value: "XYZ"
                }

            ],
            REPLENISH_STATUS: [{
                    id: "1",
                    value: " TriggerReplenish",
                },
                {
                    id: "2",
                    value: "Replenished"
                },
                {
                    id: "3",
                    value: "Delivered"
                }
            ],
            ALERT_COMPARER: [{
                    id: "1",
                    value: " less than",
                },
                {
                    id: "2",
                    value: "equal"
                },
                {
                    id: "3",
                    value: "greater"
                }
            ],
        },
        MENUS: {
            MENU: [{
                    value: "Intakes",
                    id: 2,
                    url: "/intake",
                    weight: 2,
                    icon: 0,
                    Menu: []
                },
                {
                    value: "Schedule",
                    id: 3,
                    url: "/schedule",
                    weight: 3,
                    icon: 1,
                    Menu: []
                },
                {
                    value: "Courses",
                    id: 4,
                    url: "/courses",
                    weight: 4,
                    icon: 2,
                    Menu: []
                },
                {
                    value: "Admins",
                    id: 14,
                    url: "/admins",
                    weight: 5,
                    icon: 2,
                    Menu: []
                },
                {
                    value: "Teachers",
                    id: 5,
                    url: "/teachers",
                    weight: 6,
                    icon: 3,
                    Menu: []
                },
                {
                    value: "Students",
                    id: 6,
                    url: "/students",
                    weight: 7,
                    icon: 4,
                    Menu: []
                },
                {
                    value: "Rooms",
                    id: 7,
                    url: "/rooms",
                    weight: 8,
                    icon: 5,
                    Menu: []
                },
                {
                    value: "Skills",
                    id: 8,
                    url: "/skills",
                    weight: 9,
                    icon: 6,
                    Menu: []
                },
                {
                    value: "Attendance",
                    id: 9,
                    url: "/attendance",
                    weight: 10,
                    icon: 7,
                    Menu: []
                },
                {
                    value: "Holidays",
                    id: 10,
                    url: "/holidays",
                    weight: 11,
                    icon: 8,
                    Menu: []
                },
                {
                    value: "Books",
                    id: 11,
                    url: "/books",
                    weight: 12,
                    icon: 9,
                    Menu: []
                },
                {
                    value: "Payroll",
                    id: 12,
                    url: "/payroll",
                    weight: 13,
                    icon: 10,
                    Menu: []
                },
                {
                    value: "Schools",
                    id: 13,
                    url: "/schools",
                    weight: 14,
                    icon: 0,
                    Menu: []
                },
                {
                    value: "Dashboard",
                    id: 15,
                    url: "/dashboard",
                    weight: 1,
                    icon: 0,
                    Menu: []
                },
                {
                    value: "Profile & Class details",
                    id: 16,
                    url: "/teacher-profile",
                    weight: 6,
                    icon: 0,
                    Menu: []
                }

            ]
        },
        FUNCTIONS: [{
                value: "User",
                id: 1,
                Menu: [{
                        id: 1.1,
                        value: "Create"
                    },
                    {
                        id: 1.2,
                        value: "Edit"
                    },
                    {
                        id: 1.3,
                        value: "Delete"
                    },
                    {
                        id: 1.4,
                        value: "ResetPassword"
                    }
                ]
            },
            {
                value: "Role",
                id: 2,
                Menu: [{
                        id: 2.1,
                        value: "Create"
                    },
                    {
                        id: 2.2,
                        value: "Edit"
                    },
                    {
                        id: 2.3,
                        value: "Delete"
                    }, {
                        id: 2.4,
                        value: "AddUpdateRoleUsers"
                    }, {
                        id: 2.5,
                        value: "AddUpdateMenuPerms"
                    }, {
                        id: 2.6,
                        value: "AddUpdateFunctionPerms"
                    }
                ]
            },
        ],
        ICONS: [
            { icon: "icon-Intakes" },
            { icon: "icon-Schedule" },
            { icon: "icon-Courses" },
            { icon: "icon-Teachers" },
            { icon: "icon-Teachers" },
            { icon: "icon-Students" },
            { icon: "icon-Rooms" },
            { icon: "icon-Skills" },
            { icon: "icon-Attendance" },
            { icon: "icon-Holidays" },
            { icon: "icon-Books" },
            { icon: "icon-Books" },
            { icon: "icon-Books" },
            { icon: "icon-Books" },
            { icon: "icon-Books" },
        ],
    };
    window.Focus = _focus;
})();
(function()
{
    'use strict';

    angular
            .module('fuse')
            .config(config)
//            .config(config,function($mdThemingProvider) {
//                $mdThemingProvider.theme('default')
//                        .primaryPalette('pink')
//                        .accentPalette('orange');
//            })
            ;

    /** @ngInject */
    function config($httpProvider)
    {


        // Put your custom configurations here
        $httpProvider.interceptors.push('httpRequestInterceptor');
//         $httpProvider.defaults.withCredentials = true;

//        $httpProvider.interceptors.push('httpResponseInterceptor');

    }

})();
(function()
{
    'use strict';

    angular
            .module('fuse')
            .factory('api', apiService).config(function($httpProvider) {
        $httpProvider.defaults.headers.post = {'Content-Type': 'application/json; charset=UTF-8'};
        $httpProvider.defaults.headers.common = {'Content-Type': 'application/json; charset=UTF-8'};
        $httpProvider.defaults.headers.patch = {'Content-Type': 'application/json; charset=UTF-8'};
        $httpProvider.defaults.headers.put = {'Content-Type': 'application/json; charset=UTF-8'};
    });

    /** @ngInject */
    function apiService($resource, $http)
    {
        var api = {};
        
        api.baseURI = SITE_ENV.CONFIG.BASE_URI;
        // Base Url
        api.baseUrl = 'app/data/';
        api.localUrl = '/app/data/';
        api.dashboard = $resource(api.baseUrl + 'dashboard/dashboard.json');
        api.alert = $resource(api.baseUrl + 'alert/alert.json');

        api.assetmanagement = {
            assetmanagement: $resource(api.baseUrl + 'assetmanagement/assetmanagement.json')
        };
        api.quickPanel = {
            activities: $resource(api.baseUrl + 'quick-panel/activities.json'),
            contacts: $resource(api.baseUrl + 'quick-panel/contacts.json'),
            events: $resource(api.baseUrl + 'quick-panel/events.json'),
            notes: $resource(api.baseUrl + 'quick-panel/notes.json')
        };


        // Auth
        api.auth = {
            login: $resource(api.baseURI + 'AuthenticateUser')
        };

        // Administration
        api.administration = {};

        api.configuration = {};
        api.administration.tenant = {
            list: $resource(api.baseURI + 'GetAllTenants'),
        };

        api.administration.useraccount = {
            users: $resource(api.baseURI + 'GetAllUsers')
        };
        api.administration.role = {
            roles: $resource(api.baseUrl + 'administration/role.json'),
        };
        $http.defaults.headers.common["Content-Type"] = "application/json; charset=UTF-8";
        $http.defaults.headers.post["Content-Type"] = "application/json; charset=UTF-8";
//        $http.defaults.headers.get["Content-Type"] = "application/json; charset=UTF-8";

        api.configuration.location = {
            list: $resource(api.baseURI + 'GetAllLocations')
        };

        api.assetmanagement = {};
        api.assetmanagement.asset = {
            list: $resource(api.baseURI + 'GetAllAssets'),
        };

        api.sidenav = {};
        api.sidenav.menu = {
            items: $resource(api.baseUrl + 'menu.xml')
        };
        window.api = api;

        return api;
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.unsubscribe', ['ipCookie'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        
             $stateProvider.state('app.pages_auth_unsubscribe', {
            url: '/unsubscribe',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.pages_auth_unsubscribe': {
                    templateUrl: 'app/main/pages/auth/unsubscribe/unsubscribe.html',
                    controller: 'UnsubscribeController as vm'
                }
            },
            bodyClass: 'unsubscribe'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/unsubscribe');

       
    }

})();
(function()
{
    'use strict';
    angular
            .module('app.attendance_mark', ['ui.timepicker'])
            .config(config);
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.attendance_mark', {
            url: '/mark-attendance',

            views: {
                'content@app': {
                    templateUrl: 'app/main/mark-attendance/mark-attendance.html',
                    controller: 'MarkAttedanceController as vm'
                },
                'toolbar@app': {
                    templateUrl: 'app/toolbar/layouts/mark-attendance/toolbar.html',
                    controller: 'ToolbarController as vm'
                },
                'navigation@app': {
                    templateUrl: 'app/navigation/layouts/mark-attendance/navigation.html',
                    controller: 'NavigationController as vm'
                },
            },
            bodyClass: 'reset-password'
        });
    }
})();

//                                views: {
//                                'main@': {
//                                templateUrl: 'app/core/layouts/content-only.html',
//                                        controller: 'MainController as vm'
//                                },
//                                        'content@app.attendance_mark': {
//                                        templateUrl: 'app/main/mark-attendance/mark-attendance.html',
//                                                controller: 'MarkAttedanceController as vm'
//                                        }
//                                },
(function()
{
    'use strict';

    angular
            .module('app.intakes1', ['ui.timepicker', 'ui.select2','angucomplete-alt','ngSanitize','ui.select'])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
//        $stateProvider
//                    .state('app.courses', {
//                        url: '/courses',
//                        views: {
//                            'content@app': {
//                                templateUrl: 'app/main/courses/courses.html',
//                                controller: 'CoursesController as vm'
//                            }
//                        },
//                         
////                        ncyBreadcrumb: {
////                            label: 'Courses',
////                        },
////                        data: {
////                            bAllow: getAllowedState(mergedArr, "4")
////                        }
//                    });


        // Translation
//        $translatePartialLoaderProvider.addPart('app/main/courses');
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.authstate', ["ui.router"]).
        config(config);

    /** @ngInject */
    function config($stateProvider, $provide)
    {
        // State
        $stateProvider.state('app.pages_auth_login', {
            url: '/login',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.pages_auth_login': {
                    templateUrl: 'app/main/pages/auth/login/login.html',
                    controller: 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });

       
//        $stateProvider.state('app.pages_auth_found', {
//            url: '/page-not-found',
//            views: {
//                'main@': {
//                    templateUrl: 'app/core/layouts/content-only.html',
//                    controller: 'PageNotFoundController as vm'
//                },
//                'content@app.pages_auth_thankyou': {
//                    templateUrl: 'app/main/pages/auth/admission/page-not-found.html',
//                    controller: 'PageNotFoundController as vm'
//                }
//            },
//             data: {
//                bAllow: 'true'
//            },
//            bodyClass: 'thankyou'
//        });

        var onDataLoaded = function () {

            var mergedArr = getMergedDataFunctionParams();




            $stateProvider
                .state('app.courses', {
                    name: 'courses',
                    url: '/courses',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/courses/courses.html',
                            controller: 'CoursesController as vm'
                        }
                    },
                    ncyBreadcrumb: {
                        label: 'Courses',
                    },
                    data: {
                        bAllow: getAllowedState(mergedArr, "4")
                    }
                });
            $stateProvider
                .state('app.books', {
                    name: 'books',
                    url: '/books',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/books/books.html',
                            controller: 'BooksController as vm'
                        }
                    },
                    ncyBreadcrumb: {
                        label: 'Books',
                    },
                    data: {
                        bAllow: getAllowedState(mergedArr, "11")
                    }
                });
            $stateProvider
                .state('app.attendance', {
                    name: 'attendance',
                    url: '/attendance',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/attendance/attendance.html',
                            controller: 'AttendanceController as vm'
                        }
                    },
                    ncyBreadcrumb: {
                        label: 'Attendance',
                    },
                    data: {
                        bAllow: getAllowedState(mergedArr, "9")
                    }
                });
            $stateProvider
                .state('app.attendance_add', {
                    name: 'attendance',
                    url: '/attendance/mark-attendance',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/attendance/attendance.html',
                            controller: 'AttendanceController as vm'
                        }
                    },
                    ncyBreadcrumb: {
                        label: 'Attendance',
                    },
                    data: {
//                            bAllow: getAllowedState(mergedArr, "4")
                    }
                });
//                  $stateProvider
//                 .state('app.pages.auth.unsubscribe', {
//                     name: 'unsubscribe',
//                     url: '/unsubscribe',
//                     views: {
//                         'content@app': {
//                             templateUrl: 'app/main/pages/unsubscribe/unsubscribe.html',
//                             controller: 'UnsubscribeController as vm'
//                         }
//                     },
//                     ncyBreadcrumb: {
//                         label: 'Unsubscribe',
//                     },
//                     data: {
// //                            bAllow: getAllowedState(mergedArr, "4")
//                     }
//                 });
            $stateProvider
                .state('app.holidays', {
                    name: 'holidays',
                    url: '/holidays',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/holidays/holidays.html',
                            controller: 'HolidaysController as vm'
                        }
                    },
                    ncyBreadcrumb: {
                        label: 'holidays',
                    },
                    data: {
                        bAllow: getAllowedState(mergedArr, "10")
                    }
                });
            $stateProvider
                .state('app.dashboard', {
                    name: 'dashboard',
                    url: '/dashboard',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/dashboard/dashboard.html',
                            controller: 'DashboardController as vm'
                        }
                    },
                    ncyBreadcrumb: {
                        label: 'dashboard',
                    },
                    data: {
                        bAllow: getAllowedState(mergedArr, "15")
                    }
                });
                $stateProvider
                .state('app.profile & class details', {
                    name: 'teacherprofile',
                    url: '/teacher-profile',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/teacher-profile/teacher-profile.html',
                            controller: 'TeacherProfileController as vm'
                        }
                    },
                    ncyBreadcrumb: {
                        label: 'teacherprofile',
                    },
                    data: {
                        bAllow: getAllowedState(mergedArr, "16")
                    }
                });
            $stateProvider
                .state('app.admins', {
                    name: 'admins',
                    url: '/admins',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/admins/admins.html',
                            controller: 'AdminsController as vm'
                        }
                    },
                    ncyBreadcrumb: {
                        label: 'admins',
                    },
                    data: {
                        bAllow: getAllowedState(mergedArr, "14")
                    }
                });
            $stateProvider
                .state('app.rooms', {
                    name: 'rooms',
                    url: '/rooms',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/rooms/rooms.html',
                            controller: 'RoomsController as vm'
                        }
                    },
                    ncyBreadcrumb: {
                        label: 'Rooms',
                    },
                    data: {
                        bAllow: getAllowedState(mergedArr, "7")
                    }
                });


            $stateProvider
                .state('app.students', {
                    name: 'students',
                    url: '/students',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/students/students.html',
                            controller: 'StudentsController as vm'
                        }
                    },
                    ncyBreadcrumb: {
                        label: 'Students',
                    },
                    data: {
                        bAllow: getAllowedState(mergedArr, "6")
                    }
                });
            $stateProvider
                .state('app.teachers', {
                    name: 'teachers',
                    url: '/teachers',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/teachers/teachers.html',
                            controller: 'TeachersController as vm'
                        }
                    },
                    ncyBreadcrumb: {
                        label: 'Teachers',
                    },
                    data: {
                        bAllow: getAllowedState(mergedArr, "5")
                    }
                });
            $stateProvider
                .state('app.intakes', {
                    name: 'intake',
                    url: '/intake',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/intake/intake.html',
                            controller: 'IntakeController as vm'
                        }
                    },
                    ncyBreadcrumb: {
                        label: 'Intake',
                    },
                    data: {
                        bAllow: getAllowedState(mergedArr, "2")
                    }
                });
            $stateProvider
                .state('app.intakes.detail', {
                    name: 'intake',
                    url: '/makeup?id=:makeupid',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/intake/intake-makeupclass.html',
                            controller: 'IntakeMakeupclassController as vm'
                        }
                    },
                    ncyBreadcrumb: {
                        label: 'Intake',
                    },
                    data: {
                        bAllow: getAllowedState(mergedArr, "2")
                    }
                });

            $stateProvider
                .state('app.skills', {
                    name: 'skills',
                    url: '/skills',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/skills/skills.html',
                            controller: 'SkillsController as vm'
                        }
                    },
                    ncyBreadcrumb: {
                        label: 'Skills',
                    },
                    data: {
                        bAllow: getAllowedState(mergedArr, "8")
                    }
                });
            $stateProvider
                .state('app.schedule', {
                    name: 'schedule',
                    url: '/schedule',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/schedule/schedule.html',
                            controller: 'ScheduleController as vm'
                        }
                    },
                    ncyBreadcrumb: {
                        label: 'Schedule',
                    },
                    data: {
                        bAllow: getAllowedState(mergedArr, "3")
                    }
                });
            $stateProvider
                .state('app.payroll', {
                    name: 'payroll',
                    url: '/payroll',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/payroll/payroll.html',
                            controller: 'PayrollController as vm'
                        }
                    },
                    ncyBreadcrumb: {
                        label: 'Payroll',
                    },
                    data: {
                        bAllow: getAllowedState(mergedArr, "12")
                    }
                });
            $stateProvider
                .state('app.schools', {
                    name: 'schools',
                    url: '/schools',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/schools/school.html',
                            controller: 'SchoolController as vm'
                        }
                    },
                    ncyBreadcrumb: {
                        label: 'school',
                    },
                    data: {
                        bAllow: getAllowedState(mergedArr, "13")
                    }
                });

        };

        $(document).on("AuthDataLoaded", onDataLoaded);
    }
    var getAllowedState = function (mergedArr, id) {
        var idSliced = id.slice(0);
        if (idSliced.length == 1) {
            var result = $.grep(mergedArr, function (e) {
                return e.id == idSliced[0];
            });
            if (result.length != 0) {
                return result[0].bAllow;
            }
        } else if (idSliced.length == 2) {
            var resultTemp = $.grep(mergedArr, function (e) {
                return e.id == idSliced[0];
            });
            if (resultTemp.length != 0) {
                var childArr = result;
                var result = $.grep(mergedArr, function (e) {
                    return e.id == id;
                });
                if (result.length != 0) {
                    return result[0].bAllow;
                }
            }
        }
    };
    var getMergedDataFunctionParams = function () {
        // var AllowedMenu = $scope.response.AuthenticateUserResult.UserAccessRights[1]['AccessRightParams'];
        var arrSource = Focus.MENUS.MENU;
        var data = "";
        if (localStorage['MenuPermission']) {
            data = JSON.parse(localStorage['MenuPermission']);
        }

        var arrMenus = JSON.parse(JSON.stringify(arrSource));
        // var AllowedMenu = $scope.response.AuthenticateUserResult.UserAccessRights[1]['AccessRightParams'];
        var arrAllowedIDs = data.split(',');
//        var curMenu = null;
//        var innerMenu = null;
//        for (var i = 0; i < arrMenus.length; i++) {
//            curMenu = arrMenus[i];
//            curMenu.bAllow = false;
//            if (arrAllowedIDs.indexOf(curMenu.id.toString()) != -1) {
//                curMenu.bAllow = true;
//                if (curMenu.Menu.length > 0)
//                {
//                    for (var j = 0; j < curMenu.Menu.length; j++) {
//                        innerMenu = curMenu.Menu[j];
//                        if (arrAllowedIDs.indexOf(innerMenu.id.toString()) != -1)
//                        {
//                            innerMenu.bAllow = true;
//                        }
//                    }
//                }
//
//            }
//        }
        return  arrMenus;
    };
})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination=\"\" md-swipe-content=\"\" md-stretch-tabs=\"always\"><md-tab><md-tab-label translate=\"QUICKPANEL.TODAY\">TODAY</md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" ms-scroll=\"\" ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label translate=\"QUICKPANEL.CHAT\">THIS MONTH</md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" ms-scroll=\"\" ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label translate=\"QUICKPANEL.ACTIVITY\">HISTORY</md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" ms-scroll=\"\" ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs></md-content>");
$templateCache.put("app/templates/breadcrumb.html","<div class=\"breadcrumb\"><div ng-repeat=\"step in steps | limitTo:(steps.length-1)\"><span class=\"parent\" ng-bind-html=\"step.ncyBreadcrumbLabel\" ng-hide=\"step.ncyBreadcrumbLabel==\'home\'\"></span><md-icon md-font-icon=\"icon-home\" class=\"s16 separator\" ng-show=\"step.ncyBreadcrumbLabel==\'home\'\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon></div><div ng-repeat=\"step in steps | limitTo:-1\" class=\"active\"><md-icon md-font-icon=\"icon-home\" class=\"s16 separator\" ng-show=\"step.ncyBreadcrumbLabel==\'home\'\"></md-icon><span ng-bind-html=\"step.ncyBreadcrumbLabel\" ng-hide=\"step.ncyBreadcrumbLabel==\'home\'\"></span></div></div>");
$templateCache.put("app/templates/google-analytics-body.html","<noscript><iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-5PLVFJJ\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe></noscript>");
$templateCache.put("app/templates/google-analytics-head.html","<script>\r\n    (function(w, d, s, l, i) {\r\n        w[l] = w[l] || [];\r\n        w[l].push({\r\n            \'gtm.start\': new Date().getTime(),\r\n            event: \'gtm.js\'\r\n        });\r\n        var f = d.getElementsByTagName(s)[0],\r\n            j = d.createElement(s),\r\n            dl = l != \'dataLayer\' ? \'&l=\' + l : \'\';\r\n        j.async = true;\r\n        j.src =\r\n            \'https://www.googletagmanager.com/gtm.js?id=\' + i + dl;\r\n        f.parentNode.insertBefore(j, f);\r\n    })(window, document, \'script\', \'dataLayer\', \'GTM-5PLVFJJ\');\r\n</script>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex=\"\"><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex=\"\"></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex=\"\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex=\"\"></md-content></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex=\"\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar\" ui-view=\"toolbar\"></md-toolbar><div id=\"horizontal-navigation\" class=\"md-whiteframe-1dp\" ui-view=\"navigation\"></div><div id=\"content-container\" flex=\"\" layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ms-scroll=\"\" ui-view=\"content\" flex=\"\"></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll=\"\" ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex=\"\"><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll=\"\" ui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex=\"\" layout=\"column\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ms-scroll=\"\" ui-view=\"content\" flex=\"\"></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll=\"\" ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-panel\" layout=\"row\" layout-align=\"start start\"><div class=\"ms-theme-options-panel-button md-primary-bg\" ng-click=\"toggleOptionsPanel()\"><md-icon md-font-icon=\"icon-cog\" class=\"white-text\"></md-icon></div><div class=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option\"><div class=\"option-title\">Layout Style:</div><md-radio-group layout=\"column\" ng-model=\"vm.layoutStyle\" ng-change=\"vm.updateLayoutStyle()\"><md-radio-button value=\"verticalNavigation\">Vertical Navigation</md-radio-button><md-radio-button value=\"horizontalNavigation\">Horizontal Navigation</md-radio-button><md-radio-button value=\"contentOnly\">Content Only</md-radio-button><md-radio-button value=\"contentWithToolbar\">Content with Toolbar</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group layout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button value=\"boxed\">Boxed</md-radio-button><md-radio-button value=\"wide\">Wide</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Color Palette:</div><md-menu-item ng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"theme\"><md-button class=\"md-raised theme-button\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" ng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" ng-class=\"themeName\"><span><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" md-font-icon=\"icon-palette\"></md-icon><span>{{themeName}}</span></span></md-button></md-menu-item></div></div></div>");
$templateCache.put("app/main/admins/admins.html","<div class=\"page-layout blank layout-row\" layout=\"row\"><div class=\"content\"><div class=\"md-title\"></div><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div layout-gt-ls=\"row\" flex-gt-xs=\"\" class=\"filters\"><div class=\"md-block\"><md-checkbox class=\"md-checkbox\" ng-model=\"vm.showDeletedAdmin\" ng-change=\"vm._onFilterChanged()\">Show Deleted Admins</md-checkbox></div></div><div layout-gt-sm=\"row\" flex-gt-xs=\"\" class=\"filters\"><div layout-md=\"column\" layout-sm=\"column\" layout-xs=\"row\"><md-button class=\"md-accent md-raised md-hue-1 btnred md-button_small g-intake_clearfilter\" ng-click=\"vm.onClearFiltersTap($event);\">Clear Filters</md-button></div></div></div><div layout=\"row\" layout-align=\"center\"></div><div layout=\"row\" layout-align=\"end\"><md-button class=\"md-accent md-raised btnred md-hue-1 md-button_small\" ng-click=\"vm.onCreateAdminTap($event);\">Add new Admin</md-button></div></div></div></div><div class=\"white-bg border-bg md-whiteframe-4dp page-layout__full-width\"><div><table datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-column-defs=\"vm.dtColumnDefs\" class=\"row-border hover\" dt-instance=\"vm.dtInstance\" width=\"100%\" id=\"room\"></table></div></div><div layout=\"row\" ng-show=\"vm.paginators.totalItems != 0\" layout-align=\"space-between center\"><div layout-align=\"start center\"><span class=\"page-info page-info_left\" hide-xs=\"\" hide-sm=\"\">{{vm.paginators.pageStartIndex}} - {{vm.paginators.pageEndIndex}} of {{vm.paginators.totalItems}}</span></div><div layout-align=\"end end\"><md-button class=\"md-icon-button arrow\" ng-disabled=\"!vm.paginators.allowPrevious\" aria-label=\"Previous\" ng-click=\"vm.onPrevClick($event, vm.paginators.pageStartIndex, vm.paginators.pageEndIndex, vm.paginators.totalItems)\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span>Previous</span></md-tooltip></md-button><md-button class=\"md-icon-button arrow\" aria-label=\"Next\" ng-disabled=\"!vm.paginators.allowNext\" ng-click=\"vm.onNextClick($event, vm.paginators.pageStartIndex, vm.paginators.pageEndIndex, vm.paginators.totalItems)\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span>Next</span></md-tooltip></md-button></div></div></div></div>");
$templateCache.put("app/main/attendance/attendance.html","<div class=\"page-layout blank layout-row\" layout=\"row\"><div class=\"content\"><div class=\"md-title\"></div><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"toolbar\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-gt-md=\"row\" layout-align=\"space-between center\"><div layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-gt-md=\"row\"><div layout-sm=\"row\" layout-xs=\"column\" layout-gt-md=\"row\" class=\"filters\" ng-show=\"vm.roleID == \'1\' || vm.roleID == \'4\'\"><md-input-container class=\"md-block intake intake-place\" flex=\"100\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" md-no-float=\"\"><angucomplete-alt id=\"intake-filter\" placeholder=\"All Intakes\" pause=\"100\" selected-object=\"selectedIntake\" local-data=\"vm.intakesList\" search-fields=\"id\" title-field=\"id\" minlength=\"1\" input-class=\"form-control form-control-small\" match-class=\"highlight\"></angucomplete-alt></md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"100\"><angucomplete-alt id=\"teacher-filter\" placeholder=\"All Teachers\" pause=\"100\" selected-object=\"selectedTeachers\" local-data=\"vm.teacherList\" search-fields=\"full_name\" title-field=\"full_name\" minlength=\"1\" input-class=\"form-control form-control-small\" match-class=\"highlight\"></angucomplete-alt></md-input-container></div><div layout-md=\"row\" layout-sm=\"row\" layout-xs=\"column\" layout-gt-md=\"row\" ng-form=\"\" name=\"myForm\"><div class=\"btm-padding md-block g-relative intakeFromTo\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" flex=\"100\"><md-datepicker name=\"start_date\" ng-model=\"vm.CStartDate\" ng-change=\"vm._onFilterChanged()\" md-date-filter=\"vm.onlyWeekendsDisable\" md-placeholder=\"dd-mm-yyyy\" class=\"btm-padding background-transparent\"></md-datepicker><div ng-hide=\"myForm.start_date.$valid\" class=\"g-MarginBottom\"><span class=\"auto-error\">Please enter valid date</span></div></div><div class=\"btm-padding margin_contentLeft g-relative md-block intakeFromTo\" layout-md=\"column\" layout-xs=\"column\" flex=\"100\"><md-datepicker name=\"end_date\" ng-model=\"vm.CEndDate\" md-date-filter=\"vm.onlyWeekendsDisable\" ng-change=\"vm._onFilterChanged()\" md-placeholder=\"dd-mm-yyyy\" class=\"btm-padding background-transparent\"></md-datepicker><div ng-hide=\"myForm.end_date.$valid\" class=\"g-MarginBottom\"><span class=\"auto-error\">Please enter valid date</span></div></div></div></div><div layout-md=\"row\" layout-sm=\"row\" layout-xs=\"row\" layout-gt-md=\"row\" class=\"md-block g-minMargin g-minMarginTop\" flex=\"100\"><div layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\"><md-button class=\"md-accent md-raised md-hue-1 btnred md-button_small\" ng-click=\"vm.onClearFiltersTap($event);\">Clear Filters</md-button></div></div></div></div><div class=\"white-bg border-bg md-whiteframe-4dp page-layout__full-width\"><div><table datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-column-defs=\"vm.dtColumnDefs\" class=\"row-border hover\" dt-instance=\"vm.dtInstance\" width=\"100%\"></table></div></div><div layout=\"row\" ng-show=\"vm.paginators.totalItems != 0\" layout-align=\"space-between center\"><div layout-align=\"start center\"><span class=\"page-info page-info_left\" hide-xs=\"\" hide-sm=\"\">{{vm.paginators.pageStartIndex}} - {{vm.paginators.pageEndIndex}} of {{vm.paginators.totalItems}}</span></div><div layout-align=\"end end\"><md-button class=\"md-icon-button arrow\" ng-disabled=\"!vm.paginators.allowPrevious\" aria-label=\"Previous\" ng-click=\"vm.onPrevClick($event, vm.paginators.pageStartIndex, vm.paginators.pageEndIndex, vm.paginators.totalItems)\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span>Previous</span></md-tooltip></md-button><md-button class=\"md-icon-button arrow\" aria-label=\"Next\" ng-disabled=\"!vm.paginators.allowNext\" ng-click=\"vm.onNextClick($event, vm.paginators.pageStartIndex, vm.paginators.pageEndIndex, vm.paginators.totalItems)\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span>Next</span></md-tooltip></md-button></div></div></div></div>");
$templateCache.put("app/main/books/books.html","<div class=\"page-layout blank layout-row\" layout=\"row\"><div class=\"content\"><div class=\"md-title\"></div><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"></div><div layout=\"row\" layout-align=\"center\"></div><div layout=\"row\" layout-align=\"end\"><md-button class=\"md-accent md-raised btnred md-hue-1 md-button_small\" ng-click=\"vm.onCreateBookTap($event);\">Add new Book</md-button></div></div></div></div><div class=\"white-bg border-bg md-whiteframe-4dp page-layout__full-width\"><div><table datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-column-defs=\"vm.dtColumnDefs\" class=\"row-border hover\" dt-instance=\"vm.dtInstance\" width=\"100%\" id=\"room\"></table></div></div><div layout=\"row\" ng-show=\"vm.paginators.totalItems != 0\" layout-align=\"space-between center\"><div layout-align=\"start center\"><span class=\"page-info page-info_left\" hide-xs=\"\" hide-sm=\"\">{{vm.paginators.pageStartIndex}} - {{vm.paginators.pageEndIndex}} of {{vm.paginators.totalItems}}</span></div><div layout-align=\"end end\"><md-button class=\"md-icon-button arrow\" ng-disabled=\"!vm.paginators.allowPrevious\" aria-label=\"Previous\" ng-click=\"vm.onPrevClick($event, vm.paginators.pageStartIndex, vm.paginators.pageEndIndex, vm.paginators.totalItems)\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span>Previous</span></md-tooltip></md-button><md-button class=\"md-icon-button arrow\" aria-label=\"Next\" ng-disabled=\"!vm.paginators.allowNext\" ng-click=\"vm.onNextClick($event, vm.paginators.pageStartIndex, vm.paginators.pageEndIndex, vm.paginators.totalItems)\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span>Next</span></md-tooltip></md-button></div></div></div></div>");
$templateCache.put("app/main/change-teacher/change-teacher.html","<div class=\"content white-bg page-layout blank email-attendance\" layout=\"column\"><div layout=\"column\" ng-cloak=\"\" class=\"md-inline-form\"><md-content layout-padding=\"\"><div><div class=\"md-title email-attendance-title\">Update Class Trainer for {{vm.data.schedule_date}}</div><form name=\"eventForm\" class=\"md-inline-form email-attendance email-attendance_padding\" novalidate=\"\"><div layout-gt-sm=\"row\" flex-gt-sm=\"\" flex=\"30\" flex-gt-xs=\"20\"><div class=\"btm-padding md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Select Trainer</label><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-select ng-model=\"vm.teacherId\" class=\"g-setContainer\" placeholder=\"Select Trainer\" required=\"\"><md-option ng-repeat=\"options in vm.filterTeachers\" value=\"{{options.id}}\">{{options.full_name}}</md-option></md-select></md-input-container></div></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex=\"30\" flex-gt-xs=\"20\"><md-button class=\"md-accent md-raised btnred md-hue-1 g-clear_margin md-button_small\" ng-click=\"vm.onSaveBtnTap($event);\" ng-disabled=\"vm.btnDisable\" aria-label=\"SAVE\">Submit</md-button></md-input-container></div></form></div></md-content></div></div>");
$templateCache.put("app/main/change-teacher/chgd.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">Crystal Learning</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide=\"\" show-gt-sm=\"\" ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><div layout-gt-sm=\"column\"><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Teacher</label></div><div layout=\"row\" class=\"md-block email-padding-span\"><span layout=\"row\" class=\"email-span\">{{ vm.data.teacher_name}}</span></div><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Course</label></div><div layout=\"row\" class=\"title md-block email-padding-span\"><span class=\"email-span\">{{ vm.data.course_name}}</span></div><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Intake Id</label></div><div layout=\"row\" class=\"title md-block email-padding-span\"><span class=\"email-span\">{{ vm.data.intakeID}}</span></div><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Start-Date</label></div><div layout=\"row\" class=\"title md-block email-padding-span\"><span class=\"email-span\">{{ vm.data.schedule_date}}</span></div></div><md-menu-bar><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"></div><span class=\"username\" hide-xs=\"\">{{ vm.data.teacher_name }}</span></div></md-menu-bar><div class=\"content white-bg page-layout blank email-attendance\" layout=\"column\"><div layout=\"column\" ng-cloak=\"\" class=\"md-inline-form\"><md-content layout-padding=\"\"><div><div class=\"md-title email-attendance-title\">Class Attendance for {{vm.data.teacher_name}}</div><div class=\"md-title email-attendance-caption\">Please mark against the student names below. Leave the circle unmarked if student is absent.</div><form name=\"eventForm\" class=\"md-inline-form email-attendance\" novalidate=\"\"><table class=\"row-border hover\" style=\"border:1px solid #98999b;border-collapse: collapse;\" width=\"70%\"><thead></thead><tr ng-repeat=\"student in vm.attendanceObj\"><td>{{student.name}}</td><td><md-checkbox class=\"no-label\" flex=\"50\" aria-label=\"{{student.bAllow?\'false\':\'true\'}}\" ng-change=\"vm.ToggleCheckbox($event, student)\" ng-model=\"student.bAllow\"></md-checkbox></td></tr><tr ng-repeat=\"attendance in student.data\">{{attendance.attendance}}<td ng-if=\"attendance.attendance == \'1\'\">1</td></tr></table><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex=\"30\" flex-gt-xs=\"20\"><md-button class=\"md-accent md-raised btnred md-hue-1 g-clear_margin md-button_small\" ng-click=\"vm.onSaveAttendanceTap($event);\" aria-label=\"SAVE\">Submit</md-button></md-input-container></div></form></div></md-content></div><md-content class=\"md-padding\"></md-content></div>");
$templateCache.put("app/main/courses/courses.html","<div class=\"page-layout blank layout-row\" layout=\"row\"><div class=\"content\"><div class=\"md-title\"></div><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start\" flex=\"66\"><div layout-gt-sm=\"row\" flex-gt-xs=\"\" class=\"filters\"><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"100\"><label>All Types</label><md-select ng-model=\"vm.CType\" ng-change=\"vm._onFilterChanged()\"><md-option value=\"\">All</md-option><md-option ng-repeat=\"type in vm.courseType\" value=\"{{type.text}}\">{{type.value}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"100\"><label>All Languages</label><md-select ng-model=\"vm.CLanguage\" ng-change=\"vm._onFilterChanged()\"><md-option value=\"\">All</md-option><md-option ng-repeat=\"language in vm.courseLanguage\" value=\"{{language.id}}\">{{language.name}}</md-option></md-select></md-input-container></div><div layout-gt-sm=\"row\" flex-gt-xs=\"\" class=\"filters\"><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\"><label>All Recurrency</label><md-select ng-model=\"vm.CRecurrance\" ng-change=\"vm._onFilterChanged()\"><md-option value=\"\">All</md-option><md-option ng-repeat=\"recurrance in vm.courseRecurrance\" value=\"{{recurrance.value}}\">{{recurrance.value}}</md-option></md-select></md-input-container><div layout-gt-sm=\"row\" flex-gt-xs=\"\" class=\"filters\"><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"150\"><div class=\"md-block\"><md-checkbox class=\"md-checkbox\" ng-model=\"vm.showDeletedCourses\" ng-change=\"vm._onFilterChanged()\">Show Deleted Courses</md-checkbox></div></md-input-container></div></div></div><div layout=\"row\" layout-align=\"end\" ng-show=\"vm.setView\"><div layout-md=\"column\" layout-sm=\"column\" layout-xs=\"row\"><md-button class=\"md-accent md-raised md-hue-1 btnred md-button_small g-intake_clearfilter\" ng-click=\"vm.onClearFiltersTap($event);\">Clear Filters</md-button></div><md-button class=\"md-accent md-raised btnred md-hue-1 md-button_small\" ng-click=\"vm.onCreateCourseTap($event);\">Add new Course</md-button></div></div></div></div><div class=\"white-bg border-bg md-whiteframe-4dp page-layout__full-width\"><div><table datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-column-defs=\"vm.dtColumnDefs\" class=\"row-border hover\" dt-instance=\"vm.dtInstance\" width=\"100%\"></table></div></div><div layout=\"row\" ng-show=\"vm.paginators.totalItems != 0\" layout-align=\"space-between center\"><div layout-align=\"start center\"><span class=\"page-info page-info_left\" hide-xs=\"\" hide-sm=\"\">{{vm.paginators.pageStartIndex}} - {{vm.paginators.pageEndIndex}} of {{vm.paginators.totalItems}}</span></div><div layout-align=\"end end\"><md-button class=\"md-icon-button arrow\" ng-disabled=\"!vm.paginators.allowPrevious\" aria-label=\"Previous\" ng-click=\"vm.onPrevClick($event, vm.paginators.pageStartIndex, vm.paginators.pageEndIndex, vm.paginators.totalItems)\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span>Previous</span></md-tooltip></md-button><md-button class=\"md-icon-button arrow\" aria-label=\"Next\" ng-disabled=\"!vm.paginators.allowNext\" ng-click=\"vm.onNextClick($event, vm.paginators.pageStartIndex, vm.paginators.pageEndIndex, vm.paginators.totalItems)\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span>Next</span></md-tooltip></md-button></div></div></div></div>");
$templateCache.put("app/main/dashboard/dashboard.html","<div class=\"page-layout blank layout-row\" layout=\"row\"><div class=\"content dashboard\" layout=\"column\"><div layout-gt-sm=\"row\"><div class=\"dashboard_banner flex-100\" flex=\"50\" style=\"margin: 10px;background-color: white;\"><h2 class=\"dashboard_welcome-msg\">Welcome , {{vm.userInfo.full_name}}</h2><h3 class=\"dashboard_welcome-submsg --light mt-0\">Hope you have a nice day</h3><div class=\"buttons\"><md-button class=\"md-accent md-raised btnred md-hue-1 md-button_small ml-0\" ng-click=\"vm.onCreateStudentTap($event);\">&plus; Add Student</md-button><md-button class=\"md-accent md-raised md-hue-1 btnred md-button_small\" ng-click=\"vm.onCreateIntakeTap($event);\">&plus; Add Intake</md-button><md-button class=\"md-accent md-raised md-hue-1 btnred md-button_small\" ng-click=\"vm.onCreateAdHocClassTap($event);\">Create Ad Hoc Class</md-button><md-button class=\"md-accent md-raised md-hue-1 btnred md-button_small\" ng-click=\"vm.onCheckAvailableRoomTap($event);\">Check Available Rooms</md-button></div></div><div flex=\"50\" class=\"flex-100\" style=\"margin: 10px;background-color: white;\"><h1 class=\"heading\">Students</h1><div class=\"student-body\"><table class=\"dashboard_table row-border hover ng-isolate-scope dataTable no-footer dtr-inline\" id=\"tblDashboardStudents\"><thead><tr><th>Name</th><th>Email</th><th>Contact</th><th>Language</th></tr></thead><tbody><tr id=\"studentData\" ng-repeat=\"student in vm.students\" ng-click=\"vm.showStudentEnrollment(student)\"><td>{{student.full_name}}</td><td>{{student.email}}</td><td>{{student.contact_number}}</td><td><div ng-if=\"student.currentLanguage == \'\'\"><span>-</span></div><div ng-if=\"student.currentLanguage != \'\'\"><span>{{student.currentLanguage[0]}}</span></div></td></tr></tbody></table><div class=\"text-right\"><md-button class=\"md-icon-button arrow\" aria-label=\"Previous\" ng-click=\"vm.studentPagination(\'0\')\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span>Previous</span></md-tooltip></md-button><md-button class=\"md-icon-button arrow\" aria-label=\"Next\" ng-click=\"vm.studentPagination(\'1\')\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span>Next</span></md-tooltip></md-button></div></div></div></div><div layout-gt-sm=\"row\"><div flex=\"50\" class=\"flex-100\" style=\"margin: 10px;background-color: white;\"><h1 class=\"heading\">Oncoming SOC</h1><div class=\"card-body\"><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"100\" style=\"font-size: 14px;padding: 10px;text-align: right;margin: 20px;\"><label>Filter Date</label><md-select ng-model=\"vm.SOCFilterDate\" ng-change=\"vm._onFilterSOCChanged()\"><md-option value=\"\">All</md-option><md-option ng-repeat=\"SOCDate in vm.SOCDates\" value=\"{{SOCDate | date:\'yyyy-MM-dd 00:00:00\'}}\">{{SOCDate | date:\'dd-MM-yyyy\'}}</md-option></md-select></md-input-container><table class=\"row-border hover ng-isolate-scope dataTable no-footer dtr-inline\" id=\"tblDashboardSOC\"><thead><tr><th>Title</th><th>Student</th><th>Trainer</th><th>Start Date</th></tr></thead><tbody><tr ng-repeat=\"SOCIntakes in vm.SOCIntakes\" ng-click=\"vm.redirectToIntakeEnrollment(SOCIntakes.scheduleClassID)\"><td>{{SOCIntakes.name}}</td><td ng-bind-html=\"SOCIntakes.roomcap\"></td><td><div ng-if=\"SOCIntakes.teacherAvailable.length == 0\"><span>-</span></div><div ng-if=\"SOCIntakes.teacherAvailable.length != 0\"><span>{{SOCIntakes.teacherAvailable[0].full_name}}</span></div></td><td>{{SOCIntakes.start_date}}</td></tr></tbody></table><div class=\"text-right\"><md-button class=\"md-icon-button arrow\" aria-label=\"Previous\" ng-click=\"vm.SOCPagination(\'0\')\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span>Previous</span></md-tooltip></md-button><md-button class=\"md-icon-button arrow\" aria-label=\"Next\" ng-click=\"vm.SOCPagination(\'1\')\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span>Next</span></md-tooltip></md-button></div></div></div><div flex=\"50\" class=\"flex-100\" style=\"margin: 10px;background-color: white;\"><h1 class=\"heading\">Oncoming EOC</h1><div class=\"card-body\"><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"100\" style=\"font-size: 14px;padding: 10px;text-align: right;margin: 20px;\"><label>Filter Date</label><md-select ng-model=\"vm.EOCFilterDate\" ng-change=\"vm._onFilterEOCChanged()\"><md-option value=\"\">All</md-option><md-option ng-repeat=\"EOCDate in vm.EOCDates\" value=\"{{EOCDate | date:\'yyyy-MM-dd 00:00:00\'}}\">{{EOCDate | date:\'dd-MM-yyyy\'}}</md-option></md-select></md-input-container><table class=\"row-border hover ng-isolate-scope dataTable no-footer dtr-inline\" id=\"tblDashboardEOC\"><thead><tr><th>Title</th><th>Student</th><th>Trainer</th><th>End Date</th></tr></thead><tbody><tr ng-repeat=\"EOCIntakes in vm.EOCIntakes\" ng-click=\"vm.redirectToIntakeEnrollment(EOCIntakes.scheduleClassID)\"><td>{{EOCIntakes.name}}</td><td ng-bind-html=\"EOCIntakes.roomcap\"></td><td>{{EOCIntakes.teacherAvailable[0].full_name}}</td><td>{{EOCIntakes.end_date}}</td></tr></tbody></table><div layout=\"row\" layout-align=\"space-between center\"><div layout-align=\"start center\"></div><div layout-align=\"end end\"><md-button class=\"md-icon-button arrow\" aria-label=\"Previous\" ng-click=\"vm.EOCPagination(\'0\')\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span>Previous</span></md-tooltip></md-button><md-button class=\"md-icon-button arrow\" aria-label=\"Next\" ng-click=\"vm.EOCPagination(\'1\')\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span>Next</span></md-tooltip></md-button></div></div></div></div></div><div layout-gt-sm=\"row\"></div><div class=\"white-bg md-whiteframe-4dp page-layout__full-width\"></div><div layout=\"row\" layout-align=\"space-between center\"></div></div></div>");
$templateCache.put("app/main/holidays/holidays.html","<div class=\"page-layout blank layout-row\" layout=\"row\"><div class=\"content\" layout=\"column\"><div layout=\"column\" ng-cloak=\"\" class=\"md-inline-form\"><md-content layout-padding=\"\"><div><div class=\"md-title\">Holidays</div><form name=\"eventForm\" class=\"md-inline-form transaction-search\" novalidate=\"\"><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex=\"20\"><label>Year</label><md-select ng-model=\"vm.dialogData.Year\" ng-change=\"vm.changeHoliday(vm.dialogData.Year)\"><md-option ng-repeat=\"process in vm.holidayYears\" value=\"{{process.value}}\">{{process.value}}</md-option></md-select></md-input-container><md-input-container class=\"md-block add-holiday_btn\" flex-gt-sm=\"\" ng-show=\"vm.setView\"><md-button class=\"md-accent md-raised btnred md-hue-1 md-button_small\" ng-click=\"vm.onAddHolidayTap($event);\">Add Holiday</md-button></md-input-container></div></form></div></md-content></div><div class=\"white-bg md-whiteframe-4dp page-layout__full-width\"><table datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-column-defs=\"vm.dtColumnDefs\" class=\"row-border hover\" width=\"100%\" dt-instance=\"vm.dtInstance\" id=\"holiday\"></table></div><div layout=\"row\" ng-show=\"vm.paginators.totalItems != 0\" layout-align=\"space-between center\"><div layout-align=\"start center\"><span class=\"page-info page-info_left\" hide-xs=\"\" hide-sm=\"\">{{vm.paginators.pageStartIndex}} - {{vm.paginators.pageEndIndex}} of {{vm.paginators.totalItems}}</span></div><div layout-align=\"end end\"><md-button class=\"md-icon-button arrow\" ng-disabled=\"!vm.paginators.allowPrevious\" aria-label=\"Previous\" ng-click=\"vm.onPrevClick($event, vm.paginators.pageStartIndex, vm.paginators.pageEndIndex, vm.paginators.totalItems)\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span>Previous</span></md-tooltip></md-button><md-button class=\"md-icon-button arrow\" aria-label=\"Next\" ng-disabled=\"!vm.paginators.allowNext\" ng-click=\"vm.onNextClick($event, vm.paginators.pageStartIndex, vm.paginators.pageEndIndex, vm.paginators.totalItems)\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span>Next</span></md-tooltip></md-button></div></div></div></div>");
$templateCache.put("app/main/intake/intake-makeupclass.html","<div class=\"page-layout blank layout-row\" layout=\"row\"><div class=\"content\"><div class=\"student-detail\" ng-show=\"vm.form3Visible\"><div><image class=\"back-button\" src=\"../images/back@3x.png\" ng-click=\"vm.backToEnrolmentIntake()\"><button type=\"button\" ng-click=\"vm.backToEnrolmentIntake()\">Back to Enrolment</button></image></div><div class=\"student-name\">{{vm.studentData.full_name}}</div><div class=\"student-navigation\"><div ng-cloak=\"\"><md-content><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab class=\"student-md-tab\" label=\"Student Details\"><md-content class=\"student-md-padding\"><div class=\"student-container\"><div class=\"student-contant\"><div class=\"studentinfo-header\"><div class=\"student-header\"><h1>Student</h1></div></div><div><table width=\"100%\"><tr><th>Name</th><th>Email</th><th>Contact No</th></tr><tr><td>{{vm.studentData.full_name}}</td><td>{{vm.studentData.email}}</td><td><div ng-if=\"vm.studentData.contact_number != null\">{{vm.studentData.contact_number}}</div><div ng-if=\"vm.studentData.contact_number == \'\'\">-</div><div ng-if=\"vm.studentData.contact_number == null\">-</div></td></tr></table></div></div><div style=\"margin-left: 20px;\"><div class=\"student-address\"><div ng-cloak=\"\"><md-content><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab class=\"md-tab\" label=\"ADDRESS\"><md-content><div class=\"address-detail\"><div ng-if=\"vm.studentData.address != null\">{{vm.studentData.address}}</div><div ng-if=\"vm.studentData.address == \'\'\">-</div><div ng-if=\"vm.studentData.address == null\">-</div></div></md-content></md-tab></md-tabs></md-content></div></div></div></div></md-content></md-tab><md-tab label=\"Invoice\" on-click=\"vm.showStudentDialog();\" ng-hide=\"vm.role_id == \'2\'\"><md-content class=\"md-padding\"><div class=\"student-container\"><div class=\"invoice-contant\"><div><div><h1 class=\"invoice-detail\">Invoice Details</h1></div><div class=\"student-edit\" ng-hide=\"vm._bHideUpdateInvoice\"><image src=\"../images/edit@3x.png\" ng-click=\"vm.editFee();\"></image></div></div><div><table width=\"100%\"><tr><th width=\"15%\">Total Cost</th><th width=\"15%\">Tax</th><th width=\"15%\">Total Cost</th><th width=\"15%\">Date</th><th width=\"15%\">Invoice Number</th><th>Payment Date</th></tr><tr><td width=\"15%\">${{vm.studentData.sub_total}}</td><td width=\"15%\">${{vm.studentData.tax}}</td><td width=\"15%\">${{vm.studentData.total}}</td><td width=\"15%\">{{vm.studentData.invoice_date}}</td><td width=\"15%\">{{vm.studentData.invoice_number}}</td><td ng-if=\"vm.studentData.payment_date != null\">{{vm.studentData.payment_date}}</td></tr></table></div></div></div><div class=\"student-container\"><div class=\"invoice-contant\"><div><h1>Invoice Status (Xero)</h1></div><div class=\"invoice-radio\"><form class=\"md-inline-form\"><md-radio-group ng-model=\"vm.studentData.invoice_status\"><div class=\"format-radio\"><label ng-click=\"vm.changeStudentStatus()\"><md-radio-button value=\"0\" ng-disabled=\"vm.sendInvoiceRadio\">Pending Review</md-radio-button></label></div><div class=\"format-radio\"><label ng-click=\"vm.changeStudentStatus()\"><md-radio-button value=\"1\" ng-disabled=\"vm.paidInvoiceRadio\">Invoice Sent</md-radio-button></label></div><div class=\"format-radio\"><label ng-click=\"vm.changeStudentStatus()\"><md-radio-button value=\"2\">Invoice Paid</md-radio-button></label></div></md-radio-group></form></div></div></div><div class=\"invoice-button\"><a target=\"_self\" href=\"{{vm.setAuthDownloadLink}}download-invoice?auth_token={{vm.setAuthToken}}&invoice_id={{vm.studentData.invoice_id}}&invoice_number={{vm.studentData.invoice_number}}\"><button type=\"button\" class=\"invoice-button-download\">DOWNLOAD INVOICE</button></a></div></md-content></md-tab></md-tabs></md-content></div></div></div></div></div>");
$templateCache.put("app/main/intake/intake.html","<div class=\"page-layout blank layout-row\" layout=\"row\"><div class=\"content\"><div ng-show=\"vm.form1Visible\"><div class=\"md-title\"></div><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"toolbar\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-gt-md=\"row\" layout-align=\"space-between center\"><div layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-gt-md=\"row\"><div layout-md=\"row\" layout-sm=\"row\" layout-xs=\"column\" layout-gt-md=\"row\" class=\"filters\"><md-input-container class=\"md-block intake intake-place\" flex=\"70\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" md-no-float=\"\"><angucomplete-alt id=\"intake-filter\" placeholder=\"All Intakes\" pause=\"100\" selected-object=\"selectedIntake\" local-data=\"arrIntakes\" search-fields=\"id\" title-field=\"id\" minlength=\"1\" input-class=\"form-control form-control-small\" match-class=\"highlight\"></angucomplete-alt></md-input-container><md-input-container class=\"md-block room intake-place\" flex=\"70\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" md-no-float=\"\"><angucomplete-alt id=\"room-filter\" placeholder=\"All Rooms\" pause=\"100\" selected-object=\"selectedRoom\" local-data=\"arrRooms\" search-fields=\"title,id\" title-field=\"title\" minlength=\"1\" input-class=\"form-control form-control-small\" match-class=\"highlight\"></angucomplete-alt></md-input-container><md-input-container class=\"md-block teacher intake-place\" flex=\"60\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" md-no-float=\"\" ng-show=\"vm.role_id != \'2\'\"><angucomplete-alt id=\"teacher-filter\" placeholder=\"All Teachers\" pause=\"100\" selected-object=\"selectedTeacher\" local-data=\"arrTeachers\" search-fields=\"full_name,id\" title-field=\"full_name\" minlength=\"1\" input-class=\"form-control form-control-small\" match-class=\"highlight\"></angucomplete-alt></md-input-container><md-input-container class=\"md-block\" flex=\"60\" flex-gt-xs=\"100\"><label>All Types</label><md-select ng-model=\"vm.CType\" ng-change=\"vm._onFilterChanged()\"><md-option value=\"\">All</md-option><md-option ng-repeat=\"type in vm.filterType\" value=\"{{type.value}}\">{{type.text}}</md-option></md-select></md-input-container><div layout-md=\"row\" layout-sm=\"row\" layout-xs=\"row\" layout-gt-md=\"row\" class=\"md-block g-minMargin g-minMarginTop\" flex=\"100\"><div layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\"><md-button class=\"md-accent md-raised md-hue-1 btnred md-button_small\" ng-click=\"vm.onClearFiltersTap($event);\">Clear Filters</md-button></div></div></div></div></div><div class=\"toolbar\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-gt-md=\"row\" layout-align=\"space-between center\"><div layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-gt-md=\"column\"><md-button class=\"md-accent md-raised md-hue-1 btnred md-button_small\" ng-hide=\"vm.role_id == \'2\'\" ng-click=\"vm.onCreateIntakeTap($event);\">Add new Intake</md-button></div><div layout=\"row\" layout-align=\"start center\"><a target=\"_self\" href=\"{{vm.setAuthDownloadLink}}export-intakes?auth_token={{vm.setAuthToken}}\"><md-button class=\"md-accent md-raised md-hue-1 btnred md-button_small\">Export</md-button></a></div></div></div><div class=\"white-bg md-whiteframe-4dp page-layout__full-width\"><div><table datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-column-defs=\"vm.dtColumnDefs\" class=\"row-border hover\" dt-instance=\"vm.dtInstance\" width=\"100%\"></table></div></div><div layout=\"row\" ng-show=\"vm.paginators.totalItems != 0\" layout-align=\"space-between center\"><div layout-align=\"start center\"><span class=\"page-info page-info_left\" hide-xs=\"\" hide-sm=\"\">{{vm.paginators.pageStartIndex}} - {{vm.paginators.pageEndIndex}} of {{vm.paginators.totalItems}}</span></div><div layout-align=\"end end\"><md-button class=\"md-icon-button arrow\" ng-disabled=\"!vm.paginators.allowPrevious\" aria-label=\"Previous\" ng-click=\"vm.onPrevClick($event, vm.paginators.pageStartIndex, vm.paginators.pageEndIndex, vm.paginators.totalItems)\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span>Previous</span></md-tooltip></md-button><md-button class=\"md-icon-button arrow\" aria-label=\"Next\" ng-disabled=\"!vm.paginators.allowNext\" ng-click=\"vm.onNextClick($event, vm.paginators.pageStartIndex, vm.paginators.pageEndIndex, vm.paginators.totalItems)\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span>Next</span></md-tooltip></md-button></div></div></div><div ng-show=\"vm.form2Visible\" class=\"student-form2\"><div ng-hide=\"vm.role_id == \'2\'\"><image class=\"back-button\" src=\"../images/back@3x.png\" ng-click=\"vm.backToIntake()\"><button type=\"button\" ng-click=\"vm.backToIntake()\">Back to Intakes</button></image></div><div class=\"course_detail\"><div class=\"course-title\">{{vm.courseFullname}}</div><div layout=\"row\" layout-xs=\"column\"><div layout=\"row\" flex=\"50\" flex-xs=\"100\"><div flex=\"50\" class=\"detail-label\">Start date:</div><div flex=\"50\" class=\"detail\">{{vm.studentData.courseDetails.startDate}}</div></div><div layout=\"row\" flex=\"50\" flex-xs=\"100\"><div flex=\"50\" class=\"detail-label\">End date:</div><div flex=\"50\" class=\"detail\">{{vm.studentData.courseDetails.endDate}}</div></div></div><div layout=\"row\" layout-xs=\"column\"><div layout=\"row\" flex=\"50\" flex-xs=\"100\"><div flex=\"50\" class=\"detail-label\">Time:</div><div flex=\"50\" class=\"detail\">{{vm.studentData.courseDetails.startTime}} - {{vm.studentData.courseDetails.endTime}}</div></div><div layout=\"row\" flex=\"50\" flex-xs=\"100\"><div flex=\"50\" class=\"detail-label\">Days:</div><div flex=\"50\" class=\"detail\">{{vm.classDays}}</div></div></div><div layout=\"row\" layout-xs=\"column\"><div layout=\"row\" flex=\"50\" flex-xs=\"100\"><div flex=\"50\" class=\"detail-label\">Intake ID:</div><div flex=\"50\" class=\"detail\">{{vm.studentData.courseDetails.intake_id}}</div></div><div layout=\"row\" flex=\"50\" flex-xs=\"100\"><div flex=\"50\" class=\"detail-label\">Students:</div><div flex=\"50\" class=\"detail\">{{vm.studentData.studentList.length}}</div></div></div><div layout=\"row\" layout-xs=\"column\"><div layout=\"row\" flex=\"50\" flex-xs=\"100\"><div flex=\"50\" class=\"detail-label\">Trainer:</div><div flex=\"50\" class=\"detail\"><span ng-if=\"vm.studentData.courseDetails.teacherName == null\">-</span> <span ng-if=\"vm.studentData.courseDetails.teacherName != \'\'\">{{vm.studentData.courseDetails.teacherName}}</span></div></div><div layout=\"row\" flex=\"50\" flex-xs=\"100\" ng-hide=\"vm.role_id == \'2\'\"><div flex=\"50\" class=\"detail-label\">Trainer cost:</div><div flex=\"50\" class=\"detail\"><span ng-if=\"vm.studentData.courseDetails.teacherPayrate == null\">-</span><span ng-if=\"vm.studentData.courseDetails.teacherPayrate != null\">{{vm.studentData.courseDetails.teacherPayrate}}</span></div></div></div><div layout=\"row\" layout-xs=\"column\"><div layout=\"row\" flex=\"50\" flex-xs=\"100\"><div flex=\"50\" class=\"detail-label\">No of hours consumed:</div><div flex=\"50\" class=\"detail\"><span ng-if=\"vm.studentData.no_of_hours_consumed == null || vm.studentData.no_of_hours_consumed == 0\">-</span><span ng-if=\"vm.studentData.no_of_hours_consumed\">{{vm.studentData.no_of_hours_consumed}} hours</span></div></div><div layout=\"row\" flex=\"50\" flex-xs=\"100\"><div flex=\"50\" class=\"detail-label\">Term:</div><div flex=\"50\" class=\"detail\">{{vm.studentData.courseDetails.intakeTerm}}</div></div></div><div layout=\"row\" layout-xs=\"column\"><div layout=\"row\" flex=\"50\" flex-xs=\"100\" ng-if=\"vm.studentData.courseDetails.courseType != \'P\'\"><div flex=\"50\" class=\"detail-label\">No of hours balance:</div><div flex=\"50\" class=\"detail\"><span ng-if=\"vm.studentData.no_of_hours_balance == null || vm.studentData.no_of_hours_balance == 0\">-</span><span ng-if=\"vm.studentData.no_of_hours_balance\">{{vm.studentData.no_of_hours_balance}} hours</span></div></div><div layout=\"row\" flex=\"50\" flex-xs=\"100\" ng-if=\"vm.studentData.courseDetails.courseType == \'P\'\"><div flex=\"50\" class=\"detail-label\">No of hours balance:</div><div flex=\"50\" class=\"detail\"><span ng-if=\"vm.studentData.no_of_hours_balance == null || vm.studentData.no_of_hours_balance == 0\">Private class ended (zero hours)</span><span ng-if=\"vm.studentData.no_of_hours_balance\">{{vm.studentData.no_of_hours_balance}} hours</span></div></div></div><div layout=\"row\" layout-xs=\"column\"><div layout=\"row\" flex=\"50\" flex-xs=\"100\"><div flex=\"50\" class=\"detail-label\" ng-show=\"vm.studentData.courseDetails.courseType == \'P\'\">Location:</div><div flex=\"50\" class=\"detail\" ng-show=\"vm.studentData.courseDetails.courseType == \'P\'\">{{vm.studentData.courseDetails.location}}</div></div></div><div class=\"widget-group layout-wrap layout-row flex-100\" layout=\"row\" flex=\"100\" layout-wrap=\"\"></div></div><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"toolbar addstudentdiv\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-gt-md=\"row\"><div layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-gt-md=\"column\" class=\"btn-add-student\"><md-button class=\"md-accent md-raised md-hue-1 btnred md-button_small\" ng-click=\"vm.showStudentDialog(vm.editStd = false);\" ng-hide=\"vm.role_id == \'2\'\">Add Student</md-button></div><div layout=\"row\" layout-align=\"start left\" class=\"btn-send-invoice\"><md-button class=\"md-accent md-raised md-hue-1 btnred md-button_small\" ng-click=\"vm.openAttendance()\">Report</md-button></div><div layout=\"row\" layout-align=\"start left\" class=\"btn-send-invoice\" ng-if=\"vm.studentData.courseDetails.courseType == \'P\'\"><md-button class=\"md-accent md-raised md-hue-1 btnred md-button_small\" ng-click=\"vm.deletePrivateClass()\">Delete</md-button></div></div></div><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"toolbar addstudentdiv\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-gt-md=\"row\"><div layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-gt-md=\"column\" class=\"btn-add-student\"><md-button class=\"md-accent md-raised md-hue-1 btnred md-button_small\" ng-show=\"vm.studentData.courseDetails.courseType == \'G\' || vm.studentData.courseDetails.courseType == \'I\' || vm.studentData.courseDetails.courseType == \'O\'\" ng-click=\"vm.showMakeUpClassDialog();\">Add MakeUp Class</md-button></div></div></div><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"toolbar addstudentdiv\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-gt-md=\"row\"><div layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-gt-md=\"column\" class=\"btn-add-student\"><md-button class=\"md-accent md-raised md-hue-1 btnred md-button_small\" ng-show=\"vm.studentData.courseDetails.courseType == \'P\'\" ng-click=\"vm.showPrivateClassDialog(vm.editStd = false);\">Add Private Class</md-button></div></div></div><div class=\"content-card white-bg room_detail\" layout=\"column\" flex=\"\" ng-show=\"vm.showMakeUpStudentList\"><div class=\"toolbar addstudentdiv\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-gt-md=\"row\"><div layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-gt-md=\"column\" class=\"btn-swap-class\"><md-select ng-model=\"vm.selectedMakeUpStudent\" class=\"g-setContainer\" placeholder=\"Select MakeUp student\" required=\"\"><md-option ng-repeat=\"students in vm.makeUpStudents\" value=\"{{students.attendance_id}}\">{{ students.student_name + \' - \' + students.schedule_date}}</md-option></md-select><span style=\"padding-left: 20px;font-size:14px;color:red;\" class=\"swap_room_error\"></span></div><md-button class=\"md-accent md-raised md-hue-1 btnred md-button_small\" ng-click=\"vm.showMakeUpClassDetail()\">Show Detail</md-button></div></div><div class=\"content-card white-bg room_detail\" layout=\"column\" flex=\"\" ng-hide=\"vm._bHideSwapRoom\"><div class=\"toolbar addstudentdiv\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-gt-md=\"row\"><div layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-gt-md=\"column\" class=\"btn-add-student\">Current Room : {{ vm.studentData.courseDetails.room_name}}</div><div layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-gt-md=\"column\" class=\"btn-swap-class\"><md-select ng-model=\"vm.selectedDateForSwap\" class=\"g-setContainer\" placeholder=\"Select Date\" ng-change=\"vm.onSwapRoomDateChange()\" ng-disabled=\"vm._bDisableSwapButton\" required=\"\"><md-option ng-repeat=\"option in vm.studentData.dateRange\" value=\"{{option}}\">{{option}}</md-option></md-select></div><div layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-gt-md=\"column\" class=\"btn-swap-class\"><md-select ng-model=\"vm.selectedRoomForSwap\" class=\"g-setContainer\" placeholder=\"Select Room\" ng-disabled=\"vm._bDisableSwapButton\" required=\"\"><md-option ng-repeat=\"options in vm.availableRooms\" value=\"{{options.roomID}}\">{{options.title}}</md-option></md-select></div><md-button class=\"md-accent md-raised md-hue-1 btnred md-button_small\" ng-click=\"vm.swapRoom()\" ng-disabled=\"vm._bDisableSwapButton\">Swap Room</md-button></div><div class=\"toolbar addstudentdiv\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-gt-md=\"row\"><span style=\"padding-left: 20px;font-size:14px;color:red;\" class=\"swap_room_error\"></span></div></div><div class=\"white-bg md-whiteframe-4dp page-layout__full-width\"><div><table datatable=\"\" pagelength=\"50\" dt-options=\"vm.dtStudentOptions\" dt-columns=\"vm.dtStudentColumns\" dt-column-defs=\"vm.dtStudentColumnDefs\" class=\"row-border hover\" width=\"100%\" dt-instance=\"vm.dtStudentInstance\"></table></div></div></div><div class=\"student-detail\" ng-show=\"vm.form3Visible\"><div><image class=\"back-button\" src=\"../images/back@3x.png\" ng-click=\"vm.backToEnrolmentIntake()\"><button type=\"button\" ng-click=\"vm.backToEnrolmentIntake()\">Back to Enrolment</button></image></div><div class=\"student-name\">{{vm.studentFullDetail.full_name}}</div><div class=\"student-navigation\"><div ng-cloak=\"\"><md-content><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab class=\"student-md-tab\" label=\"Student Details\"><md-content class=\"student-md-padding\"><div class=\"student-container\"><div class=\"student-contant\"><div class=\"studentinfo-header\"><div class=\"student-header\"><h1>Student</h1></div><div class=\"student-edit\"><image src=\"../images/edit@3x.png\" ng-click=\"vm.editStudentDialog(vm.editStd = true);\"></image></div></div><div><table width=\"100%\"><tr><th>Name</th><th>Email</th><th>Contact No</th><th>Company Name</th><th>Contact Person No.</th></tr><tr><td>{{vm.studentFullDetail.full_name}}</td><td>{{vm.studentFullDetail.email}}</td><td><div ng-if=\"vm.studentFullDetail.contact_number != null\">{{vm.studentFullDetail.contact_number}}</div><div ng-if=\"vm.studentFullDetail.contact_number == \'\'\">-</div><div ng-if=\"vm.studentFullDetail.contact_number == null\">-</div></td><td><div ng-if=\"vm.studentFullDetail.company_name != null\">{{vm.studentFullDetail.company_name}}</div><div ng-if=\"vm.studentFullDetail.company_name == \'\'\">-</div><div ng-if=\"vm.studentFullDetail.company_name == null\">-</div></td><td><div ng-if=\"vm.studentFullDetail.contact_person != null\">{{vm.studentFullDetail.contact_person}}</div><div ng-if=\"vm.studentFullDetail.contact_person == \'\'\">-</div><div ng-if=\"vm.studentFullDetail.contact_person == null\">-</div></td></tr></table></div></div><div style=\"margin-left: 20px;\"><div class=\"student-address\"><div ng-cloak=\"\"><md-content><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab class=\"md-tab\" label=\"ADDRESS\"><md-content><div class=\"address-detail\"><div ng-if=\"vm.studentFullDetail.address != null\">{{vm.studentFullDetail.address}}</div><div ng-if=\"vm.studentFullDetail.address == \'\'\">-</div><div ng-if=\"vm.studentFullDetail.address == null\">-</div></div></md-content></md-tab><md-tab class=\"md-tab\" label=\"COMPANY ADDRESS\"><md-content><div class=\"address-detail\"><div ng-if=\"vm.studentFullDetail.company_address != null\">{{vm.studentFullDetail.company_address}}</div><div ng-if=\"vm.studentFullDetail.company_address == \'\'\">-</div><div ng-if=\"vm.studentFullDetail.company_address == null\">-</div></div></md-content></md-tab></md-tabs></md-content></div></div></div><div class=\"student-contant\"><div><div class=\"renewal-checkbox\"><lable class=\"renewal-checkbox\">Renewal</lable><md-checkbox ng-model=\"vm.studentChecked\" ng-disabled=\"true\"></md-checkbox></div></div></div></div></md-content></md-tab><md-tab label=\"Invoice\" on-click=\"vm.showStudentDialog();\" ng-hide=\"vm.role_id == \'2\'\"><md-content class=\"md-padding\"><div class=\"student-container\"><div class=\"invoice-contant\"><div><div><h1 class=\"invoice-detail\">Invoice Details</h1></div><div class=\"student-edit\" ng-hide=\"vm._bHideUpdateInvoice\"><image src=\"../images/edit@3x.png\" ng-click=\"vm.editFee();\"></image></div></div><div><table width=\"100%\"><tr><th width=\"15%\">Basic Cost</th><th width=\"15%\">Admin Fee</th><th width=\"15%\">Tax</th><th width=\"15%\">Total Cost</th><th width=\"15%\">Date</th><th>Invoice Number</th></tr><tr><td width=\"15%\">${{vm.studentFullDetail.basic_cost}}</td><td width=\"15%\">${{vm.studentFullDetail.admin_fee}}</td><td width=\"15%\">${{vm.studentFullDetail.tax}}</td><td width=\"15%\">${{vm.total}}</td><td width=\"15%\">{{vm.studentFullDetail.invoice_date}}</td><td>{{vm.studentFullDetail.invoice_number}}</td></tr></table></div></div></div><div class=\"student-container\"><div class=\"invoice-contant\"><div><h1>Invoice Status (Xero)</h1></div><div class=\"invoice-radio\"><form class=\"md-inline-form\"><md-radio-group ng-model=\"vm.studentInvoiceStatus\"><div class=\"format-radio\"><label ng-click=\"vm.changeStudentStatus()\"><md-radio-button value=\"0\" ng-disabled=\"vm.sendInvoiceRadio\">Pending Review</md-radio-button></label></div><div class=\"format-radio\"><label ng-click=\"vm.changeStudentStatus()\"><md-radio-button value=\"1\" ng-disabled=\"vm.paidInvoiceRadio\">Invoice Sent</md-radio-button></label></div><div class=\"format-radio\"><label ng-click=\"vm.changeStudentStatus()\"><md-radio-button value=\"2\">Invoice Paid</md-radio-button></label></div></md-radio-group></form></div></div></div><div class=\"invoice-button\"><a target=\"_self\" href=\"{{vm.setAuthDownloadLink}}download-invoice?auth_token={{vm.setAuthToken}}&invoice_id={{vm.studentFullDetail.invoice_id}}&invoice_number={{vm.studentFullDetail.invoice_number}}\"><button type=\"button\" class=\"invoice-button-download\">DOWNLOAD INVOICE</button></a></div></md-content></md-tab></md-tabs></md-content></div></div></div></div></div>");
$templateCache.put("app/main/mark-attendance/chgd.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">Crystal Learning</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide=\"\" show-gt-sm=\"\" ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><div layout-gt-sm=\"column\"><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Teacher</label></div><div layout=\"row\" class=\"md-block email-padding-span\"><span layout=\"row\" class=\"email-span\">{{ vm.data.teacher_name}}</span></div><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Course</label></div><div layout=\"row\" class=\"title md-block email-padding-span\"><span class=\"email-span\">{{ vm.data.course_name}}</span></div><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Intake Id</label></div><div layout=\"row\" class=\"title md-block email-padding-span\"><span class=\"email-span\">{{ vm.data.intakeID}}</span></div><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Start-Date</label></div><div layout=\"row\" class=\"title md-block email-padding-span\"><span class=\"email-span\">{{ vm.data.schedule_date}}</span></div></div><md-menu-bar><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"></div><span class=\"username\" hide-xs=\"\">{{ vm.data.teacher_name }}</span></div></md-menu-bar><div class=\"content white-bg page-layout blank email-attendance\" layout=\"column\"><div layout=\"column\" ng-cloak=\"\" class=\"md-inline-form\"><md-content layout-padding=\"\"><div><div class=\"md-title email-attendance-title\">Class Attendance for {{vm.data.teacher_name}}</div><div class=\"md-title email-attendance-caption\">Please mark against the student names below. Leave the circle unmarked if student is absent.</div><form name=\"eventForm\" class=\"md-inline-form email-attendance\" novalidate=\"\"><table class=\"row-border hover\" style=\"border:1px solid #98999b;border-collapse: collapse;\" width=\"70%\"><thead></thead><tr ng-repeat=\"student in vm.attendanceObj\"><td>{{student.name}}</td><td><md-checkbox class=\"no-label\" flex=\"50\" aria-label=\"{{student.bAllow?\'false\':\'true\'}}\" ng-change=\"vm.ToggleCheckbox($event, student)\" ng-model=\"student.bAllow\"></md-checkbox></td></tr><tr ng-repeat=\"attendance in student.data\">{{attendance.attendance}}<td ng-if=\"attendance.attendance == \'1\'\">1</td></tr></table><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex=\"30\" flex-gt-xs=\"20\"><md-button class=\"md-accent md-raised btnred md-hue-1 g-clear_margin md-button_small\" ng-click=\"vm.onSaveAttendanceTap($event);\" aria-label=\"SAVE\">Submit</md-button></md-input-container></div></form></div></md-content></div><md-content class=\"md-padding\"></md-content></div>");
$templateCache.put("app/main/mark-attendance/mark-attendance.html","<div class=\"content white-bg page-layout blank email-attendance\" layout=\"column\"><div layout=\"column\" ng-cloak=\"\" class=\"md-inline-form\"><md-content layout-padding=\"\"><div><div class=\"md-title email-attendance-title\">Class Attendance for {{vm.data.teacher_name}}</div><div class=\"md-title email-attendance-caption\">Please mark against the student names below. Leave the circle unmarked if student is absent.</div><form name=\"eventForm\" class=\"md-inline-form email-attendance email-attendance_padding\" novalidate=\"\"><table class=\"row-border hover\" style=\"border:1px solid #98999b;border-collapse: collapse;padding-bottom: 10px;\" width=\"70%\"><thead style=\"border:1px solid #98999b;border-collapse: collapse;\"><tr><th>Name</th><th>Contact Number</th><th>Attendance</th></tr></thead><tr ng-repeat=\"student in vm.attendanceObj\"><td>{{student.name}}</td><td><a href=\"https://wa.me/65{{student.contact_number}}?text=hi {{student.name}}\"><md-button class=\"md-accent md-raised md-hue-1 btnred md-button_small\" style=\"text-transform: none;width:120px !important;\"><img src=\"/assets/icons/whatsapp-icon.png\" style=\"float:left;\">{{student.contact_number}}</md-button></a></td><td><md-checkbox class=\"no-label\" flex=\"50\" aria-label=\"{{student.bAllow?\'false\':\'true\'}}\" ng-change=\"vm.ToggleCheckbox($event, student)\" ng-model=\"student.bAllow\"></md-checkbox></td></tr><tr ng-repeat=\"attendance in student.data\">{{attendance.attendance}}<td ng-if=\"attendance.attendance == \'1\'\">1</td></tr></table><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex=\"30\" flex-gt-xs=\"20\"><md-button class=\"md-accent md-raised btnred md-hue-1 g-clear_margin md-button_small\" ng-click=\"vm.onSaveAttendanceTap($event);\" ng-disabled=\"vm.btnDisable\" aria-label=\"SAVE\">Submit</md-button></md-input-container></div></form></div></md-content></div><md-content class=\"md-padding\"></md-content></div>");
$templateCache.put("app/main/next-private-class-schedule/chgd.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">Crystal Learning</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide=\"\" show-gt-sm=\"\" ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><div layout-gt-sm=\"column\"><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Teacher</label></div><div layout=\"row\" class=\"md-block email-padding-span\"><span layout=\"row\" class=\"email-span\">{{ vm.data.teacher_name}}</span></div><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Course</label></div><div layout=\"row\" class=\"title md-block email-padding-span\"><span class=\"email-span\">{{ vm.data.course_name}}</span></div><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Intake Id</label></div><div layout=\"row\" class=\"title md-block email-padding-span\"><span class=\"email-span\">{{ vm.data.intakeID}}</span></div><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Start-Date</label></div><div layout=\"row\" class=\"title md-block email-padding-span\"><span class=\"email-span\">{{ vm.data.schedule_date}}</span></div></div><md-menu-bar><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"></div><span class=\"username\" hide-xs=\"\">{{ vm.data.teacher_name }}</span></div></md-menu-bar><div class=\"content white-bg page-layout blank email-attendance\" layout=\"column\"><div layout=\"column\" ng-cloak=\"\" class=\"md-inline-form\"><md-content layout-padding=\"\"><div><div class=\"md-title email-attendance-title\">Class Attendance for {{vm.data.teacher_name}}</div><div class=\"md-title email-attendance-caption\">Please mark against the student names below. Leave the circle unmarked if student is absent.</div><form name=\"eventForm\" class=\"md-inline-form email-attendance\" novalidate=\"\"><table class=\"row-border hover\" style=\"border:1px solid #98999b;border-collapse: collapse;\" width=\"70%\"><thead></thead><tr ng-repeat=\"student in vm.attendanceObj\"><td>{{student.name}}</td><td><md-checkbox class=\"no-label\" flex=\"50\" aria-label=\"{{student.bAllow?\'false\':\'true\'}}\" ng-change=\"vm.ToggleCheckbox($event, student)\" ng-model=\"student.bAllow\"></md-checkbox></td></tr><tr ng-repeat=\"attendance in student.data\">{{attendance.attendance}}<td ng-if=\"attendance.attendance == \'1\'\">1</td></tr></table><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex=\"30\" flex-gt-xs=\"20\"><md-button class=\"md-accent md-raised btnred md-hue-1 g-clear_margin md-button_small\" ng-click=\"vm.onSaveAttendanceTap($event);\" aria-label=\"SAVE\">Submit</md-button></md-input-container></div></form></div></md-content></div><md-content class=\"md-padding\"></md-content></div>");
$templateCache.put("app/main/next-private-class-schedule/next-private-class-schedule.html","<div class=\"content white-bg page-layout blank email-attendance\" layout=\"column\"><div layout=\"column\" ng-cloak=\"\" class=\"md-inline-form\"><div><div class=\"md-title email-attendance-title\">Class Set Up for teacher {{vm.data.teacher_name}}</div><div class=\"md-title email-attendance-caption\">Please set date and time for next class.</div><form name=\"eventForm\" class=\"md-inline-form email-attendance email-attendance_padding\" novalidate=\"\"><div layout-md=\"row\" layout-sm=\"row\" layout-xs=\"column\" layout-gt-md=\"row\" ng-form=\"\" name=\"myForm\"><div class=\"btm-padding margin_contentLeft g-relative md-block intakeFromTo\" layout-md=\"column\" layout-xs=\"column\" flex=\"40\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Schedule Date</label><div id=\"dateStartPicker\"><datepicker date-format=\"dd-MM-yyyy\" date-min-limit=\"{{vm.setMinDate}}\" datepicker-append-to=\"dateStartPicker\"><input ng-model=\"vm.dialogData.start_date\" type=\"text\" required=\"\"></datepicker></div></md-input-container></div><div class=\"btm-padding margin_contentLeft g-relative md-block intakeFromTo\" layout-md=\"column\" layout-xs=\"column\" flex=\"40\"><md-input-container class=\"md-block from_time_wrapper\" md-no-float=\"\" flex-gt-sm=\"\"><label class=\"container-labels g-PaddingLeft\">Start Time*</label> <input name=\"start_time\" ui-timepicker=\"\" ng-model=\"vm.dialogData.start_time\" required=\"\"><div ng-messages=\"eventForm.start_time.$error\" ng-show=\"eventForm.start_time.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Start Time</span></div><div ng-hide=\"eventForm.start_time.$valid || eventForm.start_time.$error.required\"><span class=\"g-hidden\">isStartTimeValid = {{eventForm.start_time.$valid}}</span> <span class=\"auto-error\">Please enter valid time</span></div></div></md-input-container></div><div class=\"btm-padding margin_contentLeft g-relative md-block intakeFromTo\" layout-md=\"column\" layout-xs=\"column\" flex=\"40\"><md-input-container class=\"md-block from_time_wrapper\" md-no-float=\"\" flex-gt-sm=\"\"><label class=\"container-labels g-PaddingLeft\">End Time*</label> <input name=\"end_time\" min=\"vm.dialogData.start_time\" ui-timepicker=\"\" ng-model=\"vm.dialogData.end_time\" required=\"\"><div ng-messages=\"eventForm.end_time.$error\" ng-show=\"eventForm.end_time.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Start Time</span></div></div></md-input-container></div></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex=\"30\" flex-gt-xs=\"20\"><md-button class=\"md-accent md-raised btnred md-hue-1 g-clear_margin md-button_small\" ng-click=\"vm.onSaveAttendanceTap($event);\" ng-disabled=\"eventForm.$invalid\" aria-label=\"SAVE\">Submit</md-button></md-input-container></div></form></div></div></div>");
$templateCache.put("app/main/payroll/payroll.html","<div class=\"page-layout blank layout-row\" layout=\"row\"><div class=\"content\"><div class=\"md-title\"></div><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"toolbar\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-gt-md=\"row\" layout-align=\"space-between center\"></div></div><div class=\"white-bg border-bg md-whiteframe-4dp page-layout__full-width\"><div><table datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-column-defs=\"vm.dtColumnDefs\" class=\"row-border hover\" dt-instance=\"vm.dtInstance\" width=\"100%\"></table></div></div><div layout=\"row\" ng-show=\"vm.paginators.totalItems != 0\" layout-align=\"space-between center\"><div layout-align=\"start center\"><span class=\"page-info page-info_left\" hide-xs=\"\" hide-sm=\"\">{{vm.paginators.pageStartIndex}} - {{vm.paginators.pageEndIndex}} of {{vm.paginators.totalItems}}</span></div><div layout-align=\"end end\"><md-button class=\"md-icon-button arrow\" ng-disabled=\"!vm.paginators.allowPrevious\" aria-label=\"Previous\" ng-click=\"vm.onPrevClick($event, vm.paginators.pageStartIndex, vm.paginators.pageEndIndex, vm.paginators.totalItems)\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span>Previous</span></md-tooltip></md-button><md-button class=\"md-icon-button arrow\" aria-label=\"Next\" ng-disabled=\"!vm.paginators.allowNext\" ng-click=\"vm.onNextClick($event, vm.paginators.pageStartIndex, vm.paginators.pageEndIndex, vm.paginators.totalItems)\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span>Next</span></md-tooltip></md-button></div></div></div></div>");
$templateCache.put("app/main/rooms/rooms.html","<div class=\"page-layout blank layout-row\" layout=\"row\"><div class=\"content\"><div class=\"md-title\"></div><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\"><div layout-gt-ls=\"row\" flex-gt-xs=\"\" class=\"filters\"><div class=\"md-block\"><md-checkbox class=\"md-checkbox\" ng-model=\"vm.showDeletedRooms\" ng-change=\"vm._onFilterChanged()\">Show Deleted Rooms</md-checkbox></div></div></div></div><div layout=\"row\" layout-align=\"center\"></div><div layout=\"row\" layout-align=\"end\"><md-button class=\"md-accent md-raised btnred md-hue-1 md-button_small\" ng-click=\"vm.onCreateRoomTap($event);\">Add new Room</md-button></div></div></div></div><div class=\"white-bg border-bg md-whiteframe-4dp page-layout__full-width\"><div><table datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-column-defs=\"vm.dtColumnDefs\" class=\"row-border hover\" dt-instance=\"vm.dtInstance\" width=\"100%\" id=\"room\"></table></div></div><div layout=\"row\" ng-show=\"vm.paginators.totalItems != 0\" layout-align=\"space-between center\"><div layout-align=\"start center\"><span class=\"page-info page-info_left\" hide-xs=\"\" hide-sm=\"\">{{vm.paginators.pageStartIndex}} - {{vm.paginators.pageEndIndex}} of {{vm.paginators.totalItems}}</span></div><div layout-align=\"end end\"><md-button class=\"md-icon-button arrow\" ng-disabled=\"!vm.paginators.allowPrevious\" aria-label=\"Previous\" ng-click=\"vm.onPrevClick($event, vm.paginators.pageStartIndex, vm.paginators.pageEndIndex, vm.paginators.totalItems)\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span>Previous</span></md-tooltip></md-button><md-button class=\"md-icon-button arrow\" aria-label=\"Next\" ng-disabled=\"!vm.paginators.allowNext\" ng-click=\"vm.onNextClick($event, vm.paginators.pageStartIndex, vm.paginators.pageEndIndex, vm.paginators.totalItems)\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span>Next</span></md-tooltip></md-button></div></div></div></div>");
$templateCache.put("app/main/schedule/schedule.html","<div class=\"page-layout blank layout-row\" layout=\"row\"><div class=\"content\"><div class=\"md-title\"></div><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" class=\"filters\"><div class=\"switch\"><div class=\"switch__weekly switch__item active\" data-target-el=\"#weekly\">Week</div><div class=\"divider-vertical\"></div><div class=\"switch__monthly switch__item\" data-target-el=\"#monthly\">Month</div></div><md-input-container class=\"md-block schedule-filters\" flex=\"\"><label>All Types</label><md-select ng-model=\"vm.CType\" ng-change=\"vm._onFilterChanged()\"><md-option value=\"\">All</md-option><md-option ng-repeat=\"type in vm.scheduleType\" value=\"{{type.id}}\">{{type.value}}</md-option></md-select></md-input-container><md-input-container class=\"md-block schedule-filters_marginLeft\" flex=\"\"><label>All Rooms</label><md-select ng-model=\"vm.CRoom\" ng-change=\"vm._onFilterChanged()\"><md-option value=\"\">All</md-option><md-option ng-repeat=\"room in vm.room\" value=\"{{room.roomID}}\">{{room.title}}</md-option></md-select></md-input-container><div layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" class=\"schedule-filters_marginLeft\"><md-button class=\"md-accent md-raised md-hue-1 btnred md-button_small\" ng-click=\"vm.onClearFiltersTap($event);\">Clear Filters</md-button></div></div><div layout=\"row\" layout-align=\"start center\"><a target=\"_self\" href=\"{{vm.setAuthDownloadLink}}export?auth_token={{vm.setAuthToken}}\"><md-button class=\"md-accent md-raised md-hue-1 btnred md-button_small\" ng-disabled=\"vm.exportDisable\">Export</md-button></a></div></div><div><div class=\"scheduler\" id=\"scheduler\"><div class=\"container-fluid clndr clndr_manager\" id=\"calendar-block\" style=\"overflow: hidden; outline: none;\" tabindex=\"0\"><div class=\"scheduler__item weekly\" id=\"weekly\"><div class=\"navigator\"><button class=\"navigator__prev\"><md-icon md-font-icon=\"icon-chevron-left\" class=\"s32\"></md-icon></button> <button class=\"navigator__today navigator__today-header\">Today</button> <button class=\"navigator__next\"><md-icon md-font-icon=\"icon-chevron-right\" class=\"s32\"></md-icon></button></div><div class=\"swiper-container\"><div class=\"swiper-wrapper\" id=\"weekly__wrapper\"></div></div></div><div class=\"scheduler__item monthly g-hidden\" id=\"monthly\"><div class=\"navigator\"><button class=\"navigator__prev\"><md-icon md-font-icon=\"icon-chevron-left\" class=\"s32\"></md-icon></button> <button class=\"navigator__today navigator__today-header\">Today</button> <button class=\"navigator__next\"><md-icon md-font-icon=\"icon-chevron-right\" class=\"s32\"></md-icon></button></div><div class=\"swiper-container\"><div class=\"swiper-wrapper\" id=\"monthly__wrapper\"></div></div></div></div></div></div></div></div><div class=\"white-bg md-whiteframe-4dp page-layout__full-width\"><div></div></div></div></div>");
$templateCache.put("app/main/schools/school.html","<div class=\"page-layout blank layout-row\" layout=\"row\"><div class=\"content\"><div class=\"md-title\"></div><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"></div><div layout=\"row\" layout-align=\"center\"></div><div layout=\"row\" layout-align=\"end\"><md-button class=\"md-accent md-raised btnred md-hue-1 md-button_small\" ng-click=\"vm.onCreateSchoolTap($event);\">Add new School</md-button></div></div></div></div><div class=\"white-bg border-bg md-whiteframe-4dp page-layout__full-width\"><div><table datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-column-defs=\"vm.dtColumnDefs\" class=\"row-border hover\" dt-instance=\"vm.dtInstance\" width=\"100%\" id=\"school\"></table></div></div><div layout=\"row\" ng-show=\"vm.paginators.totalItems != 0\" layout-align=\"space-between center\"><div layout-align=\"start center\"><span class=\"page-info page-info_left\" hide-xs=\"\" hide-sm=\"\">{{vm.paginators.pageStartIndex}} - {{vm.paginators.pageEndIndex}} of {{vm.paginators.totalItems}}</span></div><div layout-align=\"end end\"><md-button class=\"md-icon-button arrow\" ng-disabled=\"!vm.paginators.allowPrevious\" aria-label=\"Previous\" ng-click=\"vm.onPrevClick($event, vm.paginators.pageStartIndex, vm.paginators.pageEndIndex, vm.paginators.totalItems)\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span>Previous</span></md-tooltip></md-button><md-button class=\"md-icon-button arrow\" aria-label=\"Next\" ng-disabled=\"!vm.paginators.allowNext\" ng-click=\"vm.onNextClick($event, vm.paginators.pageStartIndex, vm.paginators.pageEndIndex, vm.paginators.totalItems)\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span>Next</span></md-tooltip></md-button></div></div></div></div><script src=\"https://cdnjs.cloudflare.com/ajax/libs/danialfarid-angular-file-upload/12.0.4/ng-file-upload.min.js\"></script>");
$templateCache.put("app/main/show-attendance/chgd.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">Crystal Learning</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide=\"\" show-gt-sm=\"\" ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><div layout-gt-sm=\"column\"><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Teacher</label></div><div layout=\"row\" class=\"md-block email-padding-span\"><span layout=\"row\" class=\"email-span\">{{ vm.data.teacher_name}}</span></div><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Course</label></div><div layout=\"row\" class=\"title md-block email-padding-span\"><span class=\"email-span\">{{ vm.data.course_name}}</span></div><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Intake Id</label></div><div layout=\"row\" class=\"title md-block email-padding-span\"><span class=\"email-span\">{{ vm.data.intakeID}}</span></div><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Start-Date</label></div><div layout=\"row\" class=\"title md-block email-padding-span\"><span class=\"email-span\">{{ vm.data.schedule_date}}</span></div></div><md-menu-bar><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"></div><span class=\"username\" hide-xs=\"\">{{ vm.data.teacher_name }}</span></div></md-menu-bar><div class=\"content white-bg page-layout blank email-attendance\" layout=\"column\"><div layout=\"column\" ng-cloak=\"\" class=\"md-inline-form\"><md-content layout-padding=\"\"><div><div class=\"md-title email-attendance-title\">Class Attendance for {{vm.data.teacher_name}}</div><div class=\"md-title email-attendance-caption\">Please mark against the student names below. Leave the circle unmarked if student is absent.</div><form name=\"eventForm\" class=\"md-inline-form email-attendance\" novalidate=\"\"><table class=\"row-border hover\" style=\"border:1px solid #98999b;border-collapse: collapse;\" width=\"70%\"><thead></thead><tr ng-repeat=\"student in vm.attendanceObj\"><td>{{student.name}}</td><td><md-checkbox class=\"no-label\" flex=\"50\" aria-label=\"{{student.bAllow?\'false\':\'true\'}}\" ng-change=\"vm.ToggleCheckbox($event, student)\" ng-model=\"student.bAllow\"></md-checkbox></td></tr><tr ng-repeat=\"attendance in student.data\">{{attendance.attendance}}<td ng-if=\"attendance.attendance == \'1\'\">1</td></tr></table><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex=\"30\" flex-gt-xs=\"20\"><md-button class=\"md-accent md-raised btnred md-hue-1 g-clear_margin md-button_small\" ng-click=\"vm.onSaveAttendanceTap($event);\" aria-label=\"SAVE\">Submit</md-button></md-input-container></div></form></div></md-content></div><md-content class=\"md-padding\"></md-content></div>");
$templateCache.put("app/main/show-attendance/show-attendance.html","<div class=\"content white-bg page-layout blank email-attendance\" layout=\"column\"><div layout=\"column\" ng-cloak=\"\" class=\"md-inline-form\"><md-content layout-padding=\"\"><div><div class=\"md-title email-attendance-title\">Class Attendance for {{vm.data.teacher_name}}</div><div class=\"md-title email-attendance-caption\">Please mark against the student names below, for renewal.</div><div class=\"md-title email-attendance-caption blink\">Class is ending soon</div><form name=\"eventForm\" class=\"md-inline-form email-attendance email-attendance_padding\" novalidate=\"\"><table class=\"row-border hover\" style=\"border:1px solid #98999b;border-collapse: collapse;padding-bottom: 10px;\" width=\"70%\"><thead style=\"border:1px solid #98999b;border-collapse: collapse;\"><tr><th>Name</th><th>Contact Number</th><th>Renew</th></tr></thead><tr ng-repeat=\"student in vm.data.students\"><td ng-class=\"{row_color: student.eligible == 0}\">{{student.full_name}}</td><td ng-class=\"{row_color: student.eligible == 0}\">{{student.contact_number}}</td><td ng-class=\"{row_color: student.eligible == 0}\"><md-checkbox class=\"no-label\" flex=\"50\" aria-label=\"{{student.bAllow?\'false\':\'true\'}}\" ng-change=\"vm.ToggleCheckbox($event, student)\" ng-model=\"student.bAllow\"></md-checkbox></td></tr></table><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex=\"30\" flex-gt-xs=\"20\"><md-button class=\"md-accent md-raised btnred md-hue-1 g-clear_margin md-button_small\" ng-click=\"vm.onSaveAttendanceTap($event);\" ng-disabled=\"vm.btnDisable\" aria-label=\"SAVE\">Submit</md-button></md-input-container></div></form></div></md-content></div><md-content class=\"md-padding\"></md-content></div>");
$templateCache.put("app/main/skills/skills.html","<div class=\"page-layout blank layout-row\" layout=\"row\"><div class=\"content\"><div class=\"md-title\"></div><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"></div><div layout=\"row\" layout-align=\"center\"></div><div layout=\"row\" layout-align=\"end\"><md-button class=\"md-accent md-raised btnred md-hue-1 md-button_small\" ng-click=\"vm.onCreateSkillTap($event);\">Add new Skill</md-button></div></div></div></div><div class=\"white-bg border-bg md-whiteframe-4dp page-layout__full-width\"><div><table datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-column-defs=\"vm.dtColumnDefs\" class=\"row-border hover\" dt-instance=\"vm.dtInstance\" width=\"100%\" id=\"skill\"></table></div></div><div layout=\"row\" ng-show=\"vm.paginators.totalItems != 0\" layout-align=\"space-between center\"><div layout-align=\"start center\"><span class=\"page-info page-info_left\" hide-xs=\"\" hide-sm=\"\">{{vm.paginators.pageStartIndex}} - {{vm.paginators.pageEndIndex}} of {{vm.paginators.totalItems}}</span></div><div layout-align=\"end end\"><md-button class=\"md-icon-button arrow\" ng-disabled=\"!vm.paginators.allowPrevious\" aria-label=\"Previous\" ng-click=\"vm.onPrevClick($event, vm.paginators.pageStartIndex, vm.paginators.pageEndIndex, vm.paginators.totalItems)\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span>Previous</span></md-tooltip></md-button><md-button class=\"md-icon-button arrow\" aria-label=\"Next\" ng-disabled=\"!vm.paginators.allowNext\" ng-click=\"vm.onNextClick($event, vm.paginators.pageStartIndex, vm.paginators.pageEndIndex, vm.paginators.totalItems)\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span>Next</span></md-tooltip></md-button></div></div></div></div>");
$templateCache.put("app/main/students/students.html","<div class=\"page-layout blank layout-row\" layout=\"row\"><div class=\"content\"><div ng-show=\"vm._bStudentListingPage\"><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" class=\"filters\"></div><div layout=\"row\" layout-align=\"center\"></div><div layout=\"row\" layout-align=\"end\" ng-show=\"vm.setView\"><md-button class=\"md-accent md-raised btnred md-hue-1 md-button_small\" ng-click=\"vm.onCreateStudentTap($event);\">Add new Student</md-button></div><div layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-gt-md=\"column\" ng-show=\"vm.setView\"><div layout=\"row\" layout-align=\"start\" class=\"filters\"><md-button class=\"md-accent md-raised md-hue-1 btnred md-button_small btn_relative\" ng-click=\"vm.exportStudentData()\">Export</md-button><md-button class=\"md-accent md-raised md-hue-1 btnred md-button_small btn_relative\">Import <input class=\"student__popup_upload btn_pointer\" type=\"file\" ngf-select=\"onFileSelect($files)\" name=\"fileUpload\"></md-button></div></div></div></div></div><div class=\"white-bg border-bg md-whiteframe-4dp page-layout__full-width\"><div><table datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-column-defs=\"vm.dtColumnDefs\" class=\"row-border hover\" dt-instance=\"vm.dtInstance\" width=\"100%\"></table></div></div><div layout=\"row\" ng-show=\"vm.paginators.totalItems != 0\" layout-align=\"space-between center\"><div layout-align=\"start center\"><span class=\"page-info page-info_left\" hide-xs=\"\" hide-sm=\"\">{{vm.paginators.pageStartIndex}} - {{vm.paginators.pageEndIndex}} of {{vm.paginators.totalItems}}</span></div><div layout-align=\"end end\"><md-button class=\"md-icon-button arrow\" ng-disabled=\"!vm.paginators.allowPrevious\" aria-label=\"Previous\" ng-click=\"vm.onPrevClick($event, vm.paginators.pageStartIndex, vm.paginators.pageEndIndex, vm.paginators.totalItems)\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span>Previous</span></md-tooltip></md-button><md-button class=\"md-icon-button arrow\" aria-label=\"Next\" ng-disabled=\"!vm.paginators.allowNext\" ng-click=\"vm.onNextClick($event, vm.paginators.pageStartIndex, vm.paginators.pageEndIndex, vm.paginators.totalItems)\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span>Next</span></md-tooltip></md-button></div></div></div><div class=\"student-detail\" ng-show=\"vm._bStudentDetailPage\"><div><image class=\"back-button\" src=\"../images/back@3x.png\" ng-click=\"vm.backToEnrolmentIntake()\"><button type=\"button\" ng-click=\"vm.backToStudents()\">Back to Students</button></image></div><div class=\"student-name\">{{vm.studentDetail.full_name}}</div><div class=\"student-navigation\"><md-content><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab class=\"student-md-tab\" label=\"Student Details\"><md-content class=\"student-md-padding\"><div class=\"widget-group layout-wrap layout-row flex-100\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><table width=\"100%\"><tr><td class=\"detail-label\" width=\"20%\">Name</td><td class=\"detail\" width=\"30%\">{{vm.studentDetail.full_name}}</td><td class=\"detail-label\" width=\"20%\">Email</td><td class=\"detail\" width=\"30%\">{{vm.studentDetail.email}}</td></tr><tr><td class=\"detail-label\">Contact no</td><td class=\"detail\">{{vm.studentDetail.contact_number}}</td><td class=\"detail-label\">Company name</td><td class=\"detail\">{{vm.studentDetail.company_name}}</td></tr><tr><td class=\"detail-label\">Contact person no</td><td class=\"detail\">{{vm.studentDetail.contact_person}}</td><td class=\"detail-label\">Company address</td><td class=\"detail\">{{vm.studentDetail.company_address}}</td></tr><tr><td class=\"detail-label\">Personal address</td><td class=\"detail\">{{vm.studentDetail.address}}</td><td class=\"detail-label\"></td><td class=\"detail\"></td></tr><tr><td class=\"detail-label\">Renewal</td><td class=\"detail\"><div class=\"renewal-checkbox\"><md-checkbox ng-model=\"vm.is_renewal\" ng-disabled=\"true\"></md-checkbox></div></td><td class=\"detail-label\"></td><td class=\"detail\"></td></tr><tr><td colspan=\"4\" class=\"detail-label\" ng-show=\"vm.setView\"><button type=\"button\" class=\"edit-student\" ng-click=\"vm.onEditStudentTap($event, vm.studentID);\">Edit</button> <button type=\"button\" class=\"delete-student\" ng-click=\"vm.onDeleteStudentTap($event, vm.studentID);\">Delete</button></td></tr></table></div></md-content></md-tab><md-tab class=\"student-md-tab\" label=\"ONGOING COURSES\" on-click=\"\" ng-hide=\"true\"><md-content class=\"student-md-padding\"><div class=\"white-bg border-bg md-whiteframe-4dp page-layout__full-width\"><div><table datatable=\"\" dt-options=\"vm.dtCourseOptions\" dt-columns=\"vm.dtCourseColumns\" dt-column-defs=\"vm.dtCourseColumnDefs\" class=\"row-border hover\" dt-instance=\"vm.dtOngoingCourseInstance\" width=\"100%\"></table><div layout=\"row\" class=\"previouscourse-pagination\" ng-show=\"vm.paginators.totalItems != 0\" layout-align=\"space-between center\"><div layout-align=\"start center\"><span class=\"page-info page-info_left\" hide-xs=\"\" hide-sm=\"\">{{vm.ongoingTablePagination.pageStartIndex}} - {{vm.ongoingTablePagination.pageEndIndex}} of {{vm.ongoingTablePagination.totalItems}}</span></div><div layout-align=\"end end\"><md-button class=\"md-icon-button arrow\" ng-disabled=\"!vm.ongoingTablePagination.allowPrevious\" aria-label=\"Previous\" ng-click=\"vm.onOngoingCoursePrevClick($event, vm.ongoingTablePagination.pageStartIndex, vm.ongoingTablePagination.pageEndIndex, vm.ongoingTablePagination.totalItems)\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span>Previous</span></md-tooltip></md-button><md-button class=\"md-icon-button arrow\" aria-label=\"Next\" ng-disabled=\"!vm.ongoingTablePagination.allowNext\" ng-click=\"vm.onOngoingCoursePrevClick($event, vm.ongoingTablePagination.pageStartIndex, vm.ongoingTablePagination.pageEndIndex, vm.ongoingTablePagination.totalItems)\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span>Next</span></md-tooltip></md-button></div></div></div></div></md-content></md-tab><md-tab class=\"student-md-tab\" label=\"PREVIOUS COURSES\" on-click=\"\"><md-content class=\"student-md-padding\"><table datatable=\"\" dt-options=\"vm.dtPreviousCourseOptions\" dt-columns=\"vm.dtPreviousCourseColumns\" dt-column-defs=\"vm.dtPreviousCourseColumnDefs\" class=\"row-border tbl_previous_course\" dt-instance=\"vm.dtPreviousCourseInstance\" width=\"100%\"></table><div layout=\"row\" class=\"previouscourse-pagination\" ng-show=\"vm.paginators.totalItems != 0\" layout-align=\"space-between center\"><div layout-align=\"start center\"><span class=\"page-info page-info_left\" hide-xs=\"\" hide-sm=\"\">{{vm.previousTablePagination.pageStartIndex}} - {{vm.previousTablePagination.pageEndIndex}} of {{vm.previousTablePagination.totalItems}}</span></div><div layout-align=\"end end\"><md-button class=\"md-icon-button arrow\" ng-disabled=\"!vm.previousTablePagination.allowPrevious\" aria-label=\"Previous\" ng-click=\"vm.onPreviousCoursePrevClick($event, vm.previousTablePagination.pageStartIndex, vm.previousTablePagination.pageEndIndex, vm.previousTablePagination.totalItems)\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span>Previous</span></md-tooltip></md-button><md-button class=\"md-icon-button arrow\" aria-label=\"Next\" ng-disabled=\"!vm.previousTablePagination.allowNext\" ng-click=\"vm.onPreviousCourseNextClick($event, vm.previousTablePagination.pageStartIndex, vm.previousTablePagination.pageEndIndex, vm.previousTablePagination.totalItems)\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span>Next</span></md-tooltip></md-button></div></div></md-content></md-tab></md-tabs></md-content></div></div></div></div>");
$templateCache.put("app/main/teacher-profile/teacher-profile.html","<div class=\"page-layout blank layout-row\" layout=\"row\"><div class=\"content\"><div class=\"\" ng-show=\"vm._bTeacherDetailPage\"><div class=\"teacher-navigation\"><md-content><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab class=\"teacher-md-tab\" label=\"ONGOING COURSES\" on-click=\"\"><md-content class=\"teacher-md-padding\"><div class=\"white-bg border-bg md-whiteframe-4dp page-layout__full-width\"><div><table datatable=\"\" dt-options=\"vm.dtCourseOptions\" dt-columns=\"vm.dtCourseColumns\" dt-column-defs=\"vm.dtCourseColumnDefs\" class=\"row-border hover\" dt-instance=\"vm.dtOngoingCourseInstance\" width=\"100%\"></table><div layout=\"row\" class=\"previouscourse-pagination\" ng-show=\"vm.paginators.totalItems != 0\" layout-align=\"space-between center\"><div layout-align=\"start center\"><span class=\"page-info page-info_left\" hide-xs=\"\" hide-sm=\"\">{{vm.ongoingTablePagination.pageStartIndex}} - {{vm.ongoingTablePagination.pageEndIndex}} of {{vm.ongoingTablePagination.totalItems}}</span></div><div layout-align=\"end end\"><md-button class=\"md-icon-button arrow\" ng-disabled=\"!vm.ongoingTablePagination.allowPrevious\" aria-label=\"Previous\" ng-click=\"vm.onOngoingCoursePrevClick($event, vm.ongoingTablePagination.pageStartIndex, vm.ongoingTablePagination.pageEndIndex, vm.ongoingTablePagination.totalItems)\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span>Previous</span></md-tooltip></md-button><md-button class=\"md-icon-button arrow\" aria-label=\"Next\" ng-disabled=\"!vm.ongoingTablePagination.allowNext\" ng-click=\"vm.onOngoingCourseNextClick($event, vm.ongoingTablePagination.pageStartIndex, vm.ongoingTablePagination.pageEndIndex, vm.ongoingTablePagination.totalItems)\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span>Next</span></md-tooltip></md-button></div></div></div></div></md-content></md-tab><md-tab class=\"teacher-md-tab\" label=\"PREVIOUS COURSES\" on-click=\"\"><md-content class=\"teacher-md-padding\"><table datatable=\"\" dt-options=\"vm.dtPreviousCourseOptions\" dt-columns=\"vm.dtPreviousCourseColumns\" dt-column-defs=\"vm.dtPreviousCourseColumnDefs\" class=\"row-border tbl_previous_course\" dt-instance=\"vm.dtPreviousCourseInstance\" width=\"100%\"></table><div layout=\"row\" class=\"previouscourse-pagination\" ng-show=\"vm.paginators.totalItems != 0\" layout-align=\"space-between center\"><div layout-align=\"start center\"><span class=\"page-info page-info_left\" hide-xs=\"\" hide-sm=\"\">{{vm.previousTablePagination.pageStartIndex}} - {{vm.previousTablePagination.pageEndIndex}} of {{vm.previousTablePagination.totalItems}}</span></div><div layout-align=\"end end\"><md-button class=\"md-icon-button arrow\" ng-disabled=\"!vm.previousTablePagination.allowPrevious\" aria-label=\"Previous\" ng-click=\"vm.onPreviousCoursePrevClick($event, vm.previousTablePagination.pageStartIndex, vm.previousTablePagination.pageEndIndex, vm.previousTablePagination.totalItems)\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span>Previous</span></md-tooltip></md-button><md-button class=\"md-icon-button arrow\" aria-label=\"Next\" ng-disabled=\"!vm.previousTablePagination.allowNext\" ng-click=\"vm.onPreviousCourseNextClick($event, vm.previousTablePagination.pageStartIndex, vm.previousTablePagination.pageEndIndex, vm.previousTablePagination.totalItems)\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span>Next</span></md-tooltip></md-button></div></div></md-content></md-tab><md-tab class=\"teacher-md-tab\" label=\"Personal Details\"><md-content class=\"\"><div class=\"course_detail\"><div layout=\"row\" layout-xs=\"column\"><div layout=\"row\" flex=\"50\" flex-xs=\"100\"><div flex=\"20\" class=\"detail-label\">Name:</div><div flex=\"80\" class=\"detail\">{{vm.teacherDetail.full_name}}</div></div><div layout=\"row\" flex=\"50\" flex-xs=\"100\"><div flex=\"20\" class=\"detail-label\">Email:</div><div flex=\"80\" class=\"detail\">{{vm.teacherDetail.email}}</div></div></div><div layout=\"row\" layout-xs=\"column\"><div layout=\"row\" flex=\"50\" flex-xs=\"100\"><div flex=\"20\" class=\"detail-label\">Contact no:</div><div flex=\"80\" class=\"detail\">{{vm.teacherDetail.contact_number}}</div></div><div layout=\"row\" flex=\"50\" flex-xs=\"100\"><div flex=\"20\" class=\"detail-label\">Username:</div><div flex=\"80\" class=\"detail\">{{vm.teacherDetail.username}}</div></div></div><div layout=\"row\" layout-xs=\"column\"><div layout=\"row\" flex=\"50\" flex-xs=\"100\"><div flex=\"20\" class=\"detail-label\">Joining date:</div><div flex=\"80\" class=\"detail\">{{vm.teacherDetail.start_of_employment}}</div></div><div layout=\"row\" flex=\"50\" flex-xs=\"100\"><div flex=\"20\" class=\"detail-label\">Pay rate:</div><div flex=\"80\" class=\"detail\">${{vm.teacherDetail.pay_rate}}</div></div></div><div layout=\"row\" layout-xs=\"column\"><div layout=\"row\" flex=\"50\" flex-xs=\"100\"><div flex=\"20\" class=\"detail-label\">Position:</div><div flex=\"80\" class=\"detail\">{{vm.teacherDetail.position_name}}</div></div><div layout=\"row\" flex=\"50\" flex-xs=\"100\"><div flex=\"20\" class=\"detail-label\">Skills:</div><div flex=\"80\" class=\"detail\">{{vm.teacherDetail.skills}}</div></div></div><div layout=\"row\" layout-xs=\"column\"><div layout=\"row\" flex=\"50\" flex-xs=\"100\"><div flex=\"20\" class=\"detail-label\">Address:</div><div flex=\"80\" class=\"detail\">{{vm.teacherDetail.address}}</div></div></div><div layout=\"row\" layout-xs=\"column\"><div layout=\"row\" flex=\"100\" flex-xs=\"100\"><div flex=\"100\" class=\"detail-label\"><button type=\"button\" class=\"edit-teacher\" ng-click=\"vm.openDataDlg(vm.teacherDetail.teacherId,$event);\">Generate Payslip</button></div></div></div></div></md-content></md-tab><md-tab class=\"teacher-md-tab\" label=\"Available Room Slots\"><md-content class=\"\"><div class=\"course_detail available-rooms\"><table><tr><th></th><th data-cell=\"{{$index}}\" data-date=\"{{ date | date:\'yyyy-MM-dd\' }}\" ng-repeat=\"date in vm.dates\">{{ date | date:\'fullDate\' }}</th></tr><tr ng-repeat=\"(key,room) in vm.availableRooms\"><th>{{key}}</th><td ng-repeat=\"(key,dates) in room\" data-cell=\"{{$index}}\"><li ng-repeat=\"date in dates\" class=\"text-nowrap\" ng-click=\"vm.testCall(date,$parent.$index)\">{{date.start}} - {{date.end}}</li></td></tr></table></div></md-content></md-tab></md-tabs></md-content></div></div></div></div>");
$templateCache.put("app/main/teachers/teachers.html","<div class=\"page-layout blank layout-row\" layout=\"row\"><div class=\"content\"><div ng-hide=\"vm._bTeacherDetailPage\"><div class=\"md-title\"></div><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div layout-gt-sm=\"row\" flex-gt-xs=\"\" class=\"filters\"><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"100\"><label>All Skills</label><md-select ng-model=\"vm.skill\" ng-change=\"vm._onFilterChanged()\"><md-option value=\"\">All</md-option><md-option ng-repeat=\"skill in vm.skills\" value=\"{{skill.id}}\">{{skill.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"100\"><label>All Zones</label><md-select ng-model=\"vm.zone\" ng-change=\"vm._onFilterChanged()\"><md-option value=\"\">All</md-option><md-option ng-repeat=\"options in vm.zones\" value=\"{{options.id}}\">{{options.value}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"start center\"><div layout-gt-ls=\"row\" flex-gt-xs=\"\" class=\"filters\"><div class=\"md-block\"><md-checkbox class=\"md-checkbox\" ng-model=\"vm.showDeletedUser\" ng-change=\"vm._onFilterChanged()\">Show Deleted Trainers</md-checkbox></div></div></div></div><div layout=\"row\" layout-align=\"center\"><div layout-md=\"column\" layout-sm=\"column\" layout-xs=\"row\"><md-button class=\"md-accent md-raised md-hue-1 btnred md-button_small g-intake_clearfilter\" ng-click=\"vm.onClearFiltersTap($event);\">Clear Filters</md-button></div></div><div layout=\"row\" layout-align=\"end\"><md-button class=\"md-accent md-raised btnred md-hue-1 md-button_small\" ng-click=\"vm.onCreateTeacherTap($event);\">Add new Teacher</md-button></div><div layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-gt-md=\"column\"><md-button class=\"md-accent md-raised md-hue-1 btnred md-button_small btn_relative\">Import <input class=\"student__popup_upload btn_pointer\" type=\"file\" ngf-select=\"onFileSelect($files)\" name=\"fileUpload\"></md-button></div></div></div></div><div class=\"white-bg border-bg md-whiteframe-4dp page-layout__full-width\"><div><table datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-column-defs=\"vm.dtColumnDefs\" class=\"row-border hover\" dt-instance=\"vm.dtInstance\" width=\"100%\" id=\"teacher\"></table></div></div><div layout=\"row\" ng-show=\"vm.paginators.totalItems != 0\" layout-align=\"space-between center\"><div layout-align=\"start center\"><span class=\"page-info page-info_left\" hide-xs=\"\" hide-sm=\"\">{{vm.paginators.pageStartIndex}} - {{vm.paginators.pageEndIndex}} of {{vm.paginators.totalItems}}</span></div><div layout-align=\"end end\"><md-button class=\"md-icon-button arrow\" ng-disabled=\"!vm.paginators.allowPrevious\" aria-label=\"Previous\" ng-click=\"vm.onPrevClick($event, vm.paginators.pageStartIndex, vm.paginators.pageEndIndex, vm.paginators.totalItems)\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span>Previous</span></md-tooltip></md-button><md-button class=\"md-icon-button arrow\" aria-label=\"Next\" ng-disabled=\"!vm.paginators.allowNext\" ng-click=\"vm.onNextClick($event, vm.paginators.pageStartIndex, vm.paginators.pageEndIndex, vm.paginators.totalItems)\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span>Next</span></md-tooltip></md-button></div></div></div><div class=\"teacher-detail\" ng-show=\"vm._bTeacherDetailPage\"><div><image class=\"back-button\" src=\"../images/back@3x.png\" ng-click=\"vm.backToTeacherListing()\"><button type=\"button\" ng-click=\"vm.backToTeacherListing()\">Back to Teachers</button></image></div><div class=\"teacher-name\">{{vm.teacherDetail.full_name}}</div><div class=\"teacher-navigation\"><md-content><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab class=\"teacher-md-tab\" label=\"Personal Details\"><md-content class=\"teacher-md-padding\"><div class=\"widget-group layout-wrap layout-row flex-100\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><table width=\"100%\"><tr><td class=\"detail-label\" width=\"20%\">Name</td><td class=\"detail\" width=\"30%\">{{vm.teacherDetail.full_name}}</td><td class=\"detail-label\" width=\"20%\">Email</td><td class=\"detail\" width=\"30%\">{{vm.teacherDetail.email}}</td></tr><tr><td class=\"detail-label\">Contact no</td><td class=\"detail\">{{vm.teacherDetail.contact_number}}</td><td class=\"detail-label\">Username</td><td class=\"detail\">{{vm.teacherDetail.username}}</td></tr><tr><td class=\"detail-label\">Joining date</td><td class=\"detail\">{{vm.teacherDetail.start_of_employment}}</td><td class=\"detail-label\">Pay rate</td><td class=\"detail\">${{vm.teacherDetail.pay_rate}}</td></tr><tr><td class=\"detail-label\">Position</td><td class=\"detail\">{{vm.teacherDetail.position_name}}</td><td class=\"detail-label\">Skills</td><td class=\"detail\">{{vm.teacherDetail.skills}}</td></tr><tr><td class=\"detail-label\">Address</td><td class=\"detail\">{{vm.teacherDetail.address}}</td><td class=\"detail-label\">Attendance Rate <span class=\"attendance-note\">(Based on Previous Courses)</span></td><td class=\"detail\">{{vm.teacherDetail.attendance_rate.attendance_rate_percentage}}% ({{vm.teacherDetail.attendance_rate.total_attendence_of_teacher}}/{{vm.teacherDetail.attendance_rate.marked_attendence_of_teacher}})</td></tr><tr><td class=\"detail-label\">Renewal Rate <span class=\"attendance-note\">(Based on Previous Courses)</span></td><td class=\"detail\">{{vm.teacherDetail.renewal_rate.attendance_rate_percentage}}% ({{vm.teacherDetail.renewal_rate.total_students}}/{{vm.teacherDetail.renewal_rate.total_renewal}})</td></tr><tr><td colspan=\"4\" class=\"detail-label\"><button type=\"button\" class=\"edit-teacher\" ng-click=\"vm.onEditTeacherTap($event, vm.teacherDetail.teacherId);\">Edit</button> <button type=\"button\" class=\"delete-teacher\" ng-click=\"vm.onDeleteTeacherTap($event, vm.teacherDetail.teacherId, vm.teacherDetail.full_name);\">Delete</button></td></tr></table></div></md-content></md-tab><md-tab class=\"teacher-md-tab\" label=\"ONGOING COURSES\" on-click=\"\"><md-content class=\"teacher-md-padding\"><div class=\"white-bg border-bg md-whiteframe-4dp page-layout__full-width\"><div><table datatable=\"\" dt-options=\"vm.dtCourseOptions\" dt-columns=\"vm.dtCourseColumns\" dt-column-defs=\"vm.dtCourseColumnDefs\" class=\"row-border hover\" dt-instance=\"vm.dtOngoingCourseInstance\" width=\"100%\"></table><div layout=\"row\" class=\"previouscourse-pagination\" ng-show=\"vm.paginators.totalItems != 0\" layout-align=\"space-between center\"><div layout-align=\"start center\"><span class=\"page-info page-info_left\" hide-xs=\"\" hide-sm=\"\">{{vm.ongoingTablePagination.pageStartIndex}} - {{vm.ongoingTablePagination.pageEndIndex}} of {{vm.ongoingTablePagination.totalItems}}</span></div><div layout-align=\"end end\"><md-button class=\"md-icon-button arrow\" ng-disabled=\"!vm.ongoingTablePagination.allowPrevious\" aria-label=\"Previous\" ng-click=\"vm.onOngoingCoursePrevClick($event, vm.ongoingTablePagination.pageStartIndex, vm.ongoingTablePagination.pageEndIndex, vm.ongoingTablePagination.totalItems)\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span>Previous</span></md-tooltip></md-button><md-button class=\"md-icon-button arrow\" aria-label=\"Next\" ng-disabled=\"!vm.ongoingTablePagination.allowNext\" ng-click=\"vm.onOngoingCourseNextClick($event, vm.ongoingTablePagination.pageStartIndex, vm.ongoingTablePagination.pageEndIndex, vm.ongoingTablePagination.totalItems)\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span>Next</span></md-tooltip></md-button></div></div></div></div></md-content></md-tab><md-tab class=\"teacher-md-tab\" label=\"PREVIOUS COURSES\" on-click=\"\"><md-content class=\"teacher-md-padding\"><table datatable=\"\" dt-options=\"vm.dtPreviousCourseOptions\" dt-columns=\"vm.dtPreviousCourseColumns\" dt-column-defs=\"vm.dtPreviousCourseColumnDefs\" class=\"row-border tbl_previous_course\" dt-instance=\"vm.dtPreviousCourseInstance\" width=\"100%\"></table><div layout=\"row\" class=\"previouscourse-pagination\" ng-show=\"vm.paginators.totalItems != 0\" layout-align=\"space-between center\"><div layout-align=\"start center\"><span class=\"page-info page-info_left\" hide-xs=\"\" hide-sm=\"\">{{vm.previousTablePagination.pageStartIndex}} - {{vm.previousTablePagination.pageEndIndex}} of {{vm.previousTablePagination.totalItems}}</span></div><div layout-align=\"end end\"><md-button class=\"md-icon-button arrow\" ng-disabled=\"!vm.previousTablePagination.allowPrevious\" aria-label=\"Previous\" ng-click=\"vm.onPreviousCoursePrevClick($event, vm.previousTablePagination.pageStartIndex, vm.previousTablePagination.pageEndIndex, vm.previousTablePagination.totalItems)\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span>Previous</span></md-tooltip></md-button><md-button class=\"md-icon-button arrow\" aria-label=\"Next\" ng-disabled=\"!vm.previousTablePagination.allowNext\" ng-click=\"vm.onPreviousCourseNextClick($event, vm.previousTablePagination.pageStartIndex, vm.previousTablePagination.pageEndIndex, vm.previousTablePagination.totalItems)\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span>Next</span></md-tooltip></md-button></div></div></md-content></md-tab></md-tabs></md-content></div></div></div></div>");
$templateCache.put("app/toolbar/setting/setting-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Reset Password</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\"><label>Old Password</label> <input name=\"OldPassword\" ng-model=\"vm.dialogData.OldPassword\" type=\"password\" required=\"\"><div ng-messages=\"eventForm.OldPassword.$error\" ng-show=\"eventForm.OldPassword.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide your old password</span></div></div></md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\"><label>New Password</label> <input name=\"NewPassword\" ng-model=\"vm.dialogData.NewPassword\" type=\"password\" required=\"\"><div ng-messages=\"eventForm.NewPassword.$error\" ng-show=\"eventForm.NewPassword.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please type your new password(Minimum 8 characters)</span></div></div></md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\"><label>Confirm Password</label> <input name=\"ConfirmPassword\" ng-model=\"vm.dialogData.ConfirmPassword\" type=\"password\" ng-pattern=\"vm.dialogData.NewPassword\" required=\"\"><div ng-messages=\"eventForm.ConfirmPassword.$error\" ng-show=\"eventForm.ConfirmPassword.$touched\" role=\"alert\"><div ng-message=\"required\">Password Should match</div></div></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button ng-click=\"vm.onSaveBtnTap($event)\" class=\"save-button md-accent md-raised\" ng-disabled=\"eventForm.$invalid\" aria-label=\"SAVE\">SAVE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex=\"\" layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon id=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><md-icon id=\"ms-search-bar-collapser\" md-font-icon=\"icon-close\" class=\"icon s24\" ng-click=\"vm.onCloseSearch()\"></md-icon></label> <input id=\"ms-search-bar-input\" type=\"text\" ng-model=\"global.search\" placeholder=\"Search\" translate=\"\" translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex=\"\"></div>");
$templateCache.put("app/main/admins/add-admins/add-admins-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.name}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"padding_contentTop\"><md-dialog-content ms-scroll=\"\"><md-input-container class=\"md-block\"><label class=\"container-labels\">Name*</label> <input name=\"Name\" placeholder=\"Name of Admin\" ng-pattern=\"/^[a-zA-Z\\s]+[0-9!@#\\$%\\^\\&*\\)\\(+=._-]*$/\" ng-model=\"vm.dialogData.full_name\" required=\"\"><div ng-messages=\"eventForm.Name.$error\" ng-show=\"eventForm.Name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Name of Admin</span></div><div ng-message=\"pattern\"><span>Please provide valid name</span></div></div></md-input-container><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Email*</label> <input type=\"email\" name=\"email\" placeholder=\"Email\" ng-blur=\"vm._onTabEmail()\" ng-change=\"vm._onTabEmail()\" ng-model=\"vm.dialogData.email\" ng-pattern=\"/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/\" required=\"\"><div ng-messages=\"eventForm.email.$error\" ng-show=\"eventForm.email.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Email</span></div><div ng-message=\"pattern\"><span>Please provide valid Email</span></div></div><div ng-show=\"vm.showEmailError.length > 0 ? true : false\"><span class=\"auto-error\">{{vm.showEmailError}}</span></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Contact-Number</label> <input name=\"ContactNumber\" type=\"text\" ng-maxlength=\"20\" ng-pattern=\"/^\\(?\\+?[\\d\\(\\-\\s\\)]+$/\" placeholder=\"Contact Number\" ng-model=\"vm.dialogData.contact_number\"><div ng-messages=\"eventForm.ContactNumber.$error\" ng-show=\"eventForm.ContactNumber.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Contact Number</span></div><div ng-message=\"pattern\"><span>Please provide valid no.</span></div><div ng-message=\"maxlength\"><span>Please provide a valid no. with maximum 20 digits</span></div></div></md-input-container></div></md-dialog-content></div><md-dialog-actions layout=\"row\" class=\"g-section\"><md-button ng-click=\"vm.onSaveAdminBtnTap($event)\" layout-align=\"start\" class=\"save-button md-accent md-accent_g-green md-raised\" ng-disabled=\"eventForm.$invalid || (vm.showEmailError.length > 0)\" aria-label=\"SAVE\">SAVE</md-button><md-button class=\"md-icon-button g-float-right\" ng-click=\"vm.onDeleteBtnTap($event)\" layout-align=\"end\" aria-label=\"Delete\" tabindex=\"-1\" ng-show=\"vm.dialogData.type != \'add\'\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span>Delete</span></md-tooltip></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/attendance/add-attendance/add-attendance.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div layout-gt-sm=\"column\"><div layout=\"row\" class=\"title md-block\"><label flex=\"20\">Teacher</label> <span flex=\"66\">{{vm.data.teacher_name}}</span></div><div layout=\"row\" class=\"title md-block\"><label flex=\"20\">Course</label> <span flex=\"66\">{{vm.data.course_name}}</span></div><div layout=\"row\" class=\"title md-block\"><label flex=\"20\">Intake Id</label> <span flex=\"66\">{{vm.data.intakeID}}</span></div><div layout=\"row\" class=\"title md-block\"><label flex=\"20\">Start-Date</label> <span flex=\"66\">{{vm.data.schedule_date}}</span></div></div><table class=\"row-border hover\" style=\"border:1px solid grey\" width=\"100%\"><thead><tr><th>Roll No.</th><th>Name</th><th>Attendance</th></tr></thead><tr ng-repeat=\"student in vm.attendanceObj\"><td>{{student.id}}</td><td>{{student.name}}</td><td><md-checkbox class=\"no-label\" flex=\"50\" aria-label=\"{{student.bAllow?\'false\':\'true\'}}\" ng-change=\"vm.ToggleCheckbox($event, student)\" ng-model=\"student.bAllow\"></md-checkbox></td></tr></table></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-accent md-raised btnred md-hue-1 g-clear_margin md-button_small\" ng-click=\"vm.onSaveAttendanceTap($event);\" aria-label=\"SAVE\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/attendance/show-data/show-data-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div layout-gt-sm=\"column\"><div layout=\"row\" class=\"title md-block\" ng-show=\"vm.dialogData.type == \'show\'\"><label flex=\"30\">Students List</label> <span flex=\"66\">{{vm.dialogData.students }}</span></div><div layout=\"row\" class=\"title md-block\"><label flex=\"30\">Teacher</label> <span flex=\"66\">{{vm.dialogData.teacher}}</span></div><div layout=\"row\" class=\"title md-block\"><label flex=\"30\">Intake Id</label> <span flex=\"66\">{{vm.dialogData.intakeID}}</span></div><div layout=\"row\" class=\"title md-block\"><label flex=\"30\">Start-Date</label> <span flex=\"66\">{{vm.dialogData.start_date}}</span></div><div layout=\"row\" class=\"title md-block\"><label flex=\"30\">End-Date</label> <span flex=\"66\">{{vm.dialogData.end_date}}</span></div></div><div ng-show=\"vm.dialogData.type == \'report\'\">qwewe</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button ng-click=\"vm.ReportClick($event)\" class=\"save-button md-accent md-raised\" aria-label=\"SAVE\">Report</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/attendance/show-report/show-canvas-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div class=\"attendance-report_block\"><div layout-gt-sm=\"column\"><div layout=\"row\" class=\"title md-block\"><label class=\"report-label\">Intake Id</label> <span class=\"report-container\">{{vm.dialogData.intakeID}}</span></div><div layout=\"row\" class=\"title md-block\"><div id=\"canvas\" class=\"border-bg\" width=\"400\" height=\"300\" pw-canvas=\"\" version=\"vm.version\" options=\"{undo: true, width: 400, height: 300, lineWidth: 1,backgroundColor: \'#fff\', color: \'#000\',}\"></div></div><div layout=\"row\" class=\"title md-block\"><md-button class=\"md-accent md-raised btnviolet md-hue-1 md-button_small\" ng-click=\"vm.saveSignature(newSignature)\">Submit</md-button></div><div layout=\"row\" class=\"title md-block\"><md-button class=\"md-accent md-raised btnviolet md-hue-1 md-button_small\" ng-disabled=\"vm.version < 1\" ng-click=\"vm.undo()\">Reset</md-button></div></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/attendance/show-report/show-report-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div class=\"attendance-report_block\"><div layout-gt-sm=\"column\"><div layout=\"row\" class=\"title md-block\"><label class=\"report-label\">Teacher</label> <span class=\"report-container\">{{vm.dialogData.teacher_name}}</span></div><div layout=\"row\" class=\"title md-block\"><label class=\"report-label\">Intake Id</label> <span class=\"report-container\">{{vm.dialogData.intakeID}}</span></div><div layout=\"row\" class=\"title md-block\"><label class=\"report-label\">Start-Date</label> <span class=\"report-container\">{{vm.dialogData.start_date}}</span></div><div layout=\"row\" class=\"title md-block\" ng-show=\"vm.dialogData.nullType != 5\"><label class=\"report-label\">End-Date</label> <span class=\"report-container\">{{vm.dialogData.end_date}}</span></div><div layout=\"row\" class=\"title md-block\" ng-show=\"vm.dialogData.nullType != 5\"><label class=\"report-label\">Time</label> <span class=\"report-container\">{{vm.dialogData.startTime}} - {{vm.dialogData.endTime}}</span></div></div><div layout-gt-sm=\"row\"></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Note*</label> <input name=\"Name\" placeholder=\"Enter a Note\" ng-model=\"vm.dialogData.note\" ng-pattern=\"\" required=\"\"><md-button class=\"md-accent md-raised btnviolet md-hue-1 md-button_small\" ng-click=\"vm.UpdatecheduleNote()\" aria-label=\"SAVE\">Update</md-button></md-input-container></div><div layout-gt-sm=\"column\"><div layout=\"row\" class=\"title md-block\" ng-show=\"vm.dialogData.showErrorMsg == true\"><span class=\"attendance-error\">Mark attendance to download Certificate</span></div></div><table class=\"row-border hover attendance-report_table border-report\" width=\"100%\"><thead><tr><td class=\"border-report\">{{}}</td><th ng-repeat=\"dates in vm.dateList\" class=\"border-report txt-center attendance-report_date\">{{dates.date}}<div class=\"teacher_name\">({{dates.teacher_name}})</div><div class=\"teacher_name\">({{dates.room_name}})</div><div class=\"teacher_name\" ng-show=\"dates.db_start_time_format != null\">{{dates.db_start_time_format}} - {{dates.db_end_time_format}}</div></th></tr></thead><tr ng-repeat=\"student in vm.studentsData\" ng-class=\"{\'danger\': student.isEligible == 0 }\"><td class=\"border-report txt-center student-name\">{{student.name}}</td><td ng-repeat=\"attendanceData in student.attendanceList\" class=\"border-report attendance-report_field\"><div ng-show=\"vm.dialogData.nullType == \'1\' || vm.dialogData.nullType == \'6\'\"><span three-state-checkbox=\"\" ng-model=\"attendanceData.bAllow\" modelval=\"{{attendanceData.bAllow}}\" ng-class=\"{\'link_disable\': attendanceData.bAllow == -1 }\" ng-change=\"vm.onChange()\" class=\"g-display_block\" options=\"{{attendanceData.bAllow}}\"></span></div><div ng-show=\"vm.dialogData.nullType == \'5\'\"><md-button class=\"md-accent md-raised btnviolet md-hue-1 md-button_small\" ng-click=\"vm.openCanvas(attendanceData.attendance_id)\" ng-if=\"attendanceData.signature_image == null\">Sign it!</md-button><div ng-if=\"attendanceData.signature_image != null\"><a href=\"{{vm.setAuthDownloadLink}}{{attendanceData.signature_image}}\" target=\"_blank\">Show Signature</a></div></div></td></tr></table></div><div id=\"printarea\" class=\"g-display_none\"><div layout-gt-sm=\"column\"><div layout=\"row\" class=\"title md-block\"><label class=\"report-label\">Teacher</label> <span class=\"report-container\">{{vm.dialogData.teacher_name}}</span></div><div layout=\"row\" class=\"title md-block\"><label class=\"report-label\">Intake Id</label> <span class=\"report-container\">{{vm.dialogData.intakeID}}</span></div><div layout=\"row\" class=\"title md-block\"><label class=\"report-label\">Start-Date</label> <span class=\"report-container\">{{vm.dialogData.start_date}}</span></div><div layout=\"row\" class=\"title md-block\" ng-if=\"vm.dialogData.nullType != 5\"><label class=\"report-label\">End-Date</label> <span class=\"report-container\">{{vm.dialogData.end_date}}</span></div><div layout=\"row\" class=\"title md-block\" ng-if=\"vm.dialogData.nullType != 5\"><label class=\"report-label\">Time</label> <span class=\"report-container\">{{vm.dialogData.startTime}} - {{vm.dialogData.endTime}}</span></div></div><table class=\"row-border hover attendance-report_table border-report\"><thead></thead><td class=\"border-report\">{{}}</td><th ng-repeat=\"student in vm.studentsData\" class=\"border-report txt-center attendance-report_date\">{{student.name}}</th><tr ng-repeat=\"attendance in vm.dialogData.printData\"><td class=\"border-report\">{{attendance.date}}<div>Teacher: {{attendance.teacher_name}}</div><div>Room: {{attendance.room_name}}</div><div ng-if=\"attendance.start_time != null\">{{attendance.start_time}} - {{attendance.end_time}}</div></td><td ng-repeat=\"attendanceData in attendance.attendance\" class=\"border-report attendance-report_field\"><img src=\"../../../../images/checkmark1.png\" class=\"center-img\" ng-if=\"attendanceData.attendance == \'1\' && attendanceData.signature_image == null\"> <img src=\"../../../../images/close.png\" class=\"center-img\" ng-if=\"attendanceData.attendance == \'0\'\"><div ng-if=\"attendanceData.signature_image != null\"><img src=\"{{vm.setAuthDownloadLink}}{{attendanceData.signature_image}}\" alt=\"signature not found\" ng-if=\"attendanceData.attendance == \'1\'\"></div></td></tr></table></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-accent md-raised btnviolet md-hue-1 md-button_small\" ng-click=\"vm.PrintPreview()\" ng-show=\"vm.role_id != \'2\'\" ng-disabled=\"vm.printDisable\" aria-label=\"SAVE\">Print</md-button><a target=\"_self\" href=\"{{vm.setAuthDownloadLink}}download-certificates?auth_token={{vm.setAuthToken}}&intake_id={{vm.dialogData.intakeID}}&schedule_class_id={{vm.dialogData.schedule_class_id}}\" ng-class=\"{\'link_disable\': vm.dialogData.btnEnable == 0 }\" ng-hide=\"vm.dialogData.nullType == 3 || vm.dialogData.nullType == 4\"><md-button class=\"md-accent md-raised btnviolet md-hue-1 md-button_small\" ng-disabled=\"vm.dialogData.btnEnable == 0\" ng-show=\"vm.role_id != \'2\'\" aria-label=\"SAVE\" ng-class=\"{\'link_disable\': vm.dialogData.btnEnable == 0 }\">Generate Certificates</md-button></a><md-button class=\"md-accent md-raised btnviolet md-hue-1 md-button_small\" ng-disabled=\"vm.updateAttendance\" ng-click=\"vm.saveAttendance($event)\" aria-label=\"SAVE\">Update Attendance</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/attendance/template/canvas.html","<div class=\"pwCanvasPaint\" style=\"position:relative\"></div>");
$templateCache.put("app/main/attendance/template/color-selector.html","<ul class=\"pwColorSelector\"><li ng-repeat=\"color in colorList track by $index\" class=\"pwColor\" ng-class=\"{\'active\': (selectedColor === color)}\" ng-style=\"{\'background-color\':color}\" ng-click=\"setColor(color)\"></li></ul>");
$templateCache.put("app/main/books/add-books/add-books-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.name}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"padding_contentTop\"><md-dialog-content ms-scroll=\"\"><md-input-container class=\"md-block\"><label class=\"container-labels\">Name*</label> <input name=\"Name\" placeholder=\"Name of Book\" ng-pattern=\"/^[a-zA-Z\\s]+[0-9!@#\\$%\\^\\&*\\)\\(+=._-]*$/\" ng-model=\"vm.dialogData.title\" required=\"\"><div ng-messages=\"eventForm.Name.$error\" ng-show=\"eventForm.Name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Name of Book</span></div><div ng-message=\"pattern\"><span>Please provide valid name</span></div></div></md-input-container><div class=\"g-relative\"><label class=\"container-labels\">Language*</label><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-select ng-model=\"vm.dialogData.skill_id\" class=\"g-absolute g-position_Set\" placeholder=\"Select Language\" required=\"\"><md-option ng-repeat=\"options in vm.arrSkills\" value=\"{{options.id}}\">{{options.name}}</md-option></md-select></md-input-container></div></md-dialog-content></div><md-dialog-actions layout=\"row\" class=\"g-section\"><md-button ng-click=\"vm.onSaveBookBtnTap($event)\" layout-align=\"start\" class=\"save-button md-accent md-accent_g-green md-raised\" ng-disabled=\"eventForm.$invalid\" aria-label=\"SAVE\">SAVE</md-button><md-button class=\"md-icon-button g-float-right\" ng-click=\"vm.onDeleteBtnTap($event)\" layout-align=\"end\" aria-label=\"Delete\" tabindex=\"-1\" ng-show=\"vm.dialogData.type != \'add\'\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span>Delete</span></md-tooltip></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/courses/add-courses/add-courses-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.name}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div ng-cloak=\"\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" class=\"dialog_content scrollable only-y\"><md-tab label=\"Add Course\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-dialog-content ms-scroll=\"\"><div layout-gt-sm=\"row\" layout-align=\"center\"><div ng-show=\"vm.dialogData.Type = \'edit\' && vm.dialogData.type != \'I\'\"><a href=\"{{vm.showUrl}}\" target=\"_blank\"><span class=\"url\">{{vm.showUrl}}</span></a></div></div><md-input-container class=\"md-block g-mdContainer_bottom\" md-no-float=\"\"><label class=\"container-labels\">Title*</label> <input name=\"Title\" placeholder=\"Title of Course\" ng-pattern=\"/^[a-zA-Z\\s]+[0-9!@#\\$%\\^\\&*\\)\\(+=._-]*$/\" ng-model=\"vm.dialogData.title\" required=\"\"><div ng-messages=\"eventForm.Title.$error\" ng-show=\"eventForm.Title.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Title of Course</span></div><div ng-message=\"pattern\"><span>Please provide valid name</span></div></div></md-input-container><div layout-gt-sm=\"row\"><div class=\"g-relative md-block\" flex-gt-sm=\"\"><label class=\"g-relativeResponsiveSet g-absolute container-labels g-positionSet\" for=\"input_155\">Type*</label><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-select ng-model=\"vm.dialogData.type\" class=\"g-setContainer\" placeholder=\"Select Type\" required=\"\"><md-option ng-repeat=\"options in vm.courseType\" value=\"{{options.text}}\">{{options.value}}</md-option></md-select></md-input-container></div><div class=\"g-relative md-block\" flex-gt-sm=\"\"><label class=\"g-relativeResponsiveSet g-absolute container-labels g-positionSet\">Language*</label><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-select ng-model=\"vm.dialogData.skills\" class=\"g-setContainer\" placeholder=\"Select Language\" required=\"\"><md-option ng-repeat=\"options in vm.arrSkills\" value=\"{{options.name}}\">{{options.name}}</md-option></md-select></md-input-container></div></div><div layout-gt-sm=\"row\" class=\"div-height\"><div class=\"g-relative md-block\" flex-gt-sm=\"\"><label class=\"g-relativeResponsiveSet g-absolute container-labels g-positionSet\" for=\"input_155\">Recurrence*</label><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-select ng-model=\"vm.dialogData.recurrence_rule\" class=\"g-setContainer\" ng-change=\"vm.onChangeRecurrance(vm.dialogData.recurrence_rule)\" placeholder=\"Select Recurrence\" required=\"\"><md-option ng-repeat=\"options in vm.courseRecurrance\" value=\"{{options.value}}\">{{options.value}}</md-option></md-select></md-input-container></div><div class=\"g-relative md-block\" flex-gt-sm=\"\"><label class=\"g-relativeResponsiveSet g-absolute container-labels g-positionSet\">Level*</label><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-select ng-model=\"vm.dialogData.level\" class=\"g-setContainer\" placeholder=\"Select Level\" required=\"\"><md-option ng-repeat=\"options in vm.courseLevel\" value=\"{{options.value}}\">{{options.value}}</md-option></md-select></md-input-container></div><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Class Size*</label> <input name=\"ClassSize\" min=\"1\" ng-pattern=\"/^[0-9]+$/\" ng-maxlength=\"3\" placeholder=\"Max capacity of Class\" ng-model=\"vm.dialogData.batch\" required=\"\"><div ng-messages=\"eventForm.ClassSize.$error\" ng-show=\"eventForm.ClassSize.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Class Size</span></div><div ng-message=\"pattern\"><span>Please provide valid number</span></div><div ng-message=\"maxlength\"><span>Please provide valid no. of Class Size</span></div><div ng-message=\"min\"><span>Please provide valid no. of Class Size</span></div><div ng-message=\"eventForm.ClassSize.$invalid\"><span>Please provide valid no. of Class Size</span></div><div ng-message=\"number\"><span>Please provide valid no. of Class Size</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-checkbox ng-model=\"vm.dialogData.is_flexible\" aria-label=\"Flexible\">Flexible</md-checkbox></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block from_time_wrapper g-mdContainer_bottom\" flex-gt-sm=\"\"><label class=\"container-labels\">Lesson Duration*</label> <input ng-maxlength=\"3\" min=\"1\" ng-pattern=\"/^[0-9\\.0-9]+$/\" type=\"number\" placeholder=\"Lesson Duration\" name=\"Duration\" ng-model=\"vm.dialogData.class_duration\" required=\"\"><div ng-messages=\"eventForm.Duration.$error\" ng-show=\"eventForm.Duration.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide duration of Lesson</span></div><div ng-message=\"maxlength\"><span>Please provide duration of Lesson</span></div><div ng-message=\"min\"><span>Please provide duration of Lesson</span></div><div ng-message=\"pattern\"><span>Please provide valid number</span></div></div></md-input-container><md-input-container class=\"md-block g-mdContainer_bottom\" flex-gt-sm=\"\"><label class=\"container-labels\">Lessons*</label> <input name=\"Lessons\" ng-maxlength=\"3\" min=\"1\" ng-pattern=\"/^[0-9]+$/\" placeholder=\"Total no. of Lessons\" ng-model=\"vm.dialogData.no_of_classes\" required=\"\"><div ng-messages=\"eventForm.Lessons.$error\" ng-show=\"eventForm.Lessons.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide no. of Lessons</span></div><div ng-message=\"pattern\"><span>Please provide valid no. of Lessons</span></div><div ng-message=\"maxlength\"><span>Please provide valid no. of Lessons</span></div><div ng-message=\"min\"><span>Please provide valid no. of Lessons</span></div><div ng-message=\"number\"><span>Please provide valid no. of Lessons</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><div class=\"g-relative md-block\" flex-gt-sm=\"\"><label class=\"g-relativeResponsiveSet g-absolute container-labels g-positionSet\">Validity*</label><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-select ng-model=\"vm.dialogData.validity\" class=\"g-setContainer\" placeholder=\"Select Validity\" required=\"\"><md-option ng-repeat=\"options in vm.courseValidity\" value=\"{{options.text}}\">{{options.value}}</md-option></md-select></md-input-container></div><div class=\"g-relative md-block\" flex-gt-sm=\"\"><label class=\"g-relativeResponsiveSet g-absolute container-labels g-positionSet\">Book</label><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-select ng-model=\"vm.dialogData.books\" class=\"g-setContainer\" placeholder=\"Select Book\"><md-option ng-repeat=\"options in vm.arrBooks\" value=\"{{options.title}}\">{{options.title}}</md-option></md-select></md-input-container></div></div><div layout-gt-sm=\"row\"><div class=\"g-relative md-block\" flex-gt-sm=\"\"><md-input-container class=\"md-block\"><label class=\"container-labels\">Hourly Fee*</label> <input type=\"number\" name=\"Fees\" is-number=\"\" ng-model=\"vm.dialogData.price\" min=\"0\" ng-maxlength=\"10\" placeholder=\"Add a Price\" required=\"\"><div ng-messages=\"eventForm.Fees.$error\" ng-show=\"eventForm.Fees.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please enter Fees</span></div><div ng-message=\"maxlength\"><span>Please provide valid Fees</span></div><div ng-message=\"min\"><span>Please provide valid Fees</span></div></div></md-input-container></div><div class=\"g-relative md-block\" flex-gt-sm=\"\"><md-input-container class=\"md-block\"><label class=\"container-labels\">Admin Fee*</label> <input type=\"number\" name=\"AdminFees\" ng-change=\"vm.ch1();\" ng-model=\"vm.dialogData.admin_fee\" min=\"0\" ng-maxlength=\"3\" ng-pattern=\"/^[0-9]+$/\" placeholder=\"Add a Admin Fee\"><div ng-messages=\"eventForm.AdminFees.$error\" ng-show=\"eventForm.AdminFees.$touched\" role=\"alert\"><div ng-show=\"vm.admin_fee1\"><span style=\"font-size : 12px;\">Please enter Admin Fees</span></div><div ng-message=\"pattern\"><span>Please provide valid Fees</span></div><div ng-message=\"maxlength\"><span>Please provide valid Fees</span></div><div ng-message=\"min\"><span>Please provide valid Fees</span></div></div></md-input-container></div></div><div layout-gt-sm=\"row\"><div class=\"g-relative md-block\" flex-gt-sm=\"\"><md-input-container class=\"md-block\"><label class=\"container-labels\">Course Image</label><input id=\"inputFileToLoad\" name=\"imageFile\" type=\"file\" data-max-size=\"1048000\" ngf-select=\"vm.encodeImageFileAsURL(\'inputFileToLoad\');\" accept=\"image/*\"><div ng-show=\"vm.imgSize\"><span class=\"tag-error\">File size should not more than 1 MB</span></div></md-input-container></div><div class=\"g-relative md-block\" flex-gt-sm=\"\"><label class=\"g-relativeResponsiveSet g-absolute container-labels g-positionSet\">Invoice template</label><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-select ng-model=\"vm.dialogData.invoice_template_id\" class=\"g-setContainer\" placeholder=\"Select Invoice template\"><md-option ng-repeat=\"options in vm.invoiceTemplate\" value=\"{{options.invoice_template_id}}\">{{options.name}}</md-option></md-select></md-input-container></div></div><div layout-gt-sm=\"row\"><div class=\"g-relative md-block\" flex-gt-sm=\"\"><md-input-container class=\"md-block\"><label class=\"container-labels\">Banner image</label> <input id=\"inputWebFileToLoad\" name=\"web_image\" type=\"file\" data-max-size=\"1048000\" ngf-select=\"vm.encodeImageFileAsURL(\'inputWebFileToLoad\');\" accept=\"image/*\"><div ng-show=\"vm.imgWebSize\"><span class=\"tag-error\">File size should not more than 1 MB</span></div></md-input-container></div></div><div layout-gt-sm=\"row\"><md-checkbox ng-model=\"vm.dialogData.is_display\" aria-label=\"Flexible\">Is Display</md-checkbox></div><div layout-gt-sm=\"row\"><div class=\"g-relative md-block\" flex-gt-sm=\"\"><md-input-container class=\"md-block\"><label class=\"container-labels\">Audio Link</label> <input type=\"text\" name=\"AdminFees\" ng-model=\"vm.dialogData.audio_url\" placeholder=\"Audio Url\"></md-input-container></div></div><md-input-container class=\"md-block\" style=\"height: auto;\"><label class=\"container-labels\">Description</label> <textarea ng-model=\"vm.dialogData.course_description\" placeholder=\"Add a description\" columns=\"1\" md-maxlength=\"150\" rows=\"3\">\n                            </textarea></md-input-container></md-dialog-content></form></md-tab><md-tab label=\"Add Module\"><md-dialog-content ms-scroll=\"\"><md-content class=\"md-padding\"><v-accordion class=\"vAccordion--default\"><v-pane data-ng-repeat=\"choice in vm.dialogData.course_modules\" id=\"course_module_vpane\"><v-pane-header><div class=\"toolbar_header\" layout=\"row\" layout-align=\"space-between center\"><span>New Module : {{choice.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.removeChoice($index)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></v-pane-header><v-pane-content><div class=\"module_data\"><md-input-container class=\"md-block g-mdContainer_bottom\" md-no-float=\"\"><label class=\"container-labels\">Title*</label> <input ng-model=\"choice.title\" name=\"choicename_{{$index}}\" placeholder=\"Title of module\" ng-pattern=\"/^[a-zA-Z\\s]+[0-9!@#\\$%\\^\\&*\\)\\(+=._-]*$/\" required=\"\"> <span ng-messages=\"eventForm[\'choicename_\' + $index].$error\" ng-show=\"eventForm[\'choicename_\' + $index].$touched\" role=\"alert\"><span ng-message=\"required\" class=\"auto-error\">Please provide title of module</span> <span ng-message=\"pattern\" class=\"auto-error\">Enter a title module</span></span></md-input-container><md-input-container class=\"md-block\" style=\"height: auto;\"><label class=\"container-labels\">Description</label> <textarea ng-model=\"choice.description\" name=\"choicevalue_{{$index}}\" placeholder=\"Description of module\" columns=\"1\" md-maxlength=\"150\" rows=\"1\" class=\"ng-pristine ng-valid md-input ng-touched\" id=\"input_114\" aria-multiline=\"true\" aria-invalid=\"false\" ng-trim=\"false\" style=\"height: 29px;\" required=\"\">\n                                            </textarea> <span ng-messages=\"eventForm[\'choicevalue_\' + $index].$error\" ng-show=\"eventForm[\'choicename_\' + $index].$touched\" role=\"alert\"><span ng-message=\"required\" class=\"auto-error\">Please provide description of module</span></span></md-input-container></div></v-pane-content></v-pane><md-button class=\"md-accent md-raised btnred md-hue-1 md-button_small addfields\" ng-click=\"vm.addNewChoice()\" ng-disabled=\"eventForm.$invalid\">Add New Module</md-button></v-accordion></md-content></md-dialog-content></md-tab></md-tabs></div><md-dialog-actions layout=\"row\" class=\"g-section\"><md-button ng-click=\"vm.onSaveCourseBtnTap($event)\" layout-align=\"start\" class=\"save-button md-accent md-accent_g-green md-raised\" ng-disabled=\"eventForm.$invalid || vm.dialogData.skills.length == 0 || vm.admin_fee1 == true\" aria-label=\"SAVE\">SAVE</md-button><md-button layout-align=\"start\" ng-click=\"vm.onDuplicateClick(vm.dialogData)\" class=\"save-button md-accent md-raised btn-duplicate\" ng-show=\"vm.dialogData.Type != \'add\'\" aria-label=\"Duplicate\">DUPLICATE</md-button><md-button class=\"md-icon-button g-float-right\" ng-click=\"vm.onDeleteBtnTap($event)\" layout-align=\"end\" aria-label=\"Delete\" tabindex=\"-1\" ng-show=\"vm.dialogData.Type != \'add\'\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span>Delete</span></md-tooltip></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/dashboard/add-adhoc-class/add-adhoc-class-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Add Adhoc Class</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"padding_contentTop\"><md-dialog-content ms-scroll=\"\"><div layout-gt-sm=\"row\" class=\"g-clear\"><div class=\"g-relativeResponsive md-block\" flex-gt-sm=\"\"><label class=\"g-absolute container-labels g-positionSet\">Skills*</label><md-input-container class=\"md-block\" md-no-float=\"\" flex-gt-sm=\"\"><md-select ng-model=\"vm.dialogData.selected_skill\" placeholder=\"Select Skill\" ng-change=\"vm.onSkillChanged()\"><md-option ng-repeat=\"options in vm.skills\" value=\"{{options.id}}\">{{options.name}}</md-option></md-select></md-input-container></div></div><div layout-gt-sm=\"row\" class=\"g-clear\"><div class=\"btm-padding md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Start Date</label><md-content class=\"g-overflow_hidden\"><md-datepicker name=\"start_date\" ng-model=\"vm.dialogData.start_date\" md-placeholder=\"Enter date\" class=\"btm-padding\" ng-change=\"vm.getFilteredRoom()\"></md-datepicker></md-content><div ng-hide=\"eventForm.start_date.$valid\"><span class=\"auto-error\">Please enter valid date</span></div></div><div class=\"btm-padding md-block\" flex-gt-sm=\"\"><md-input-container class=\"md-block from_time_wrapper\" md-no-float=\"\" flex-gt-sm=\"\"><label class=\"container-labels g-PaddingLeft\">Start Time*</label> <input name=\"start_time\" ui-timepicker=\"\" ng-model=\"vm.dialogData.start_time\" ng-blur=\"vm.getFilteredRoom()\" required=\"\"><div ng-messages=\"eventForm.start_time.$error\" ng-show=\"eventForm.start_time.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Start Time</span></div><div ng-hide=\"eventForm.start_time.$valid || eventForm.start_time.$error.required\"><span class=\"g-hidden\">isStartTimeValid = {{eventForm.start_time.$valid}}</span> <span class=\"auto-error\">Please enter valid time</span></div></div></md-input-container></div><div class=\"g-relativeResponsive md-block\" flex-gt-sm=\"\"><label class=\"g-absolute container-labels g-positionSet\">Duration*</label><md-input-container class=\"md-block\" md-no-float=\"\" flex-gt-sm=\"\"><md-select name=\"duration\" ng-model=\"vm.dialogData.duration\" placeholder=\"Select Duration\" ng-change=\"vm.getFilteredRoom()\"><md-option ng-repeat=\"options in vm.durations\" value=\"{{options}}\">{{options}}</md-option></md-select></md-input-container><div ng-messages=\"eventForm.duration.$error\" ng-show=\"eventForm.duration.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please Duration Room</span></div></div></div></div><div layout-gt-sm=\"row\" class=\"g-gap g-PaddingLeft layout-gt-sm-row\"><div class=\"g-gap-reducer g-PaddingLeft g-relativeResponsive md-block g-gap-reducer-padding\" flex-gt-sm=\"\"><label class=\"container-labels\">Rooms*</label><md-select name=\"room_id\" ng-model=\"vm.dialogData.room_id\" placeholder=\"Select Room\" required=\"\"><md-option ng-repeat=\"options in vm.rooms\" value=\"{{options.roomID}}\">{{options.title}}</md-option></md-select><div ng-messages=\"eventForm.room_id.$error\" ng-show=\"eventForm.room_id.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please select Room</span></div></div></div><div class=\"g-gap-reducer g-PaddingLeft g-relativeResponsive md-block g-gap-reducer-padding\" flex-gt-sm=\"\"><label class=\"container-labels\">Teacher*</label><md-select name=\"teacher_id\" ng-model=\"vm.dialogData.teacher_id\" placeholder=\"Select Teacher\" required=\"\"><md-option ng-repeat=\"options in vm.teachers\" value=\"{{options.id}}\">{{options.full_name}}</md-option></md-select><div ng-messages=\"eventForm.teacher_id.$error\" ng-show=\"eventForm.teacher_id.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please select Room</span></div></div></div></div><div class=\"md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Category Color*</label><div id=\"color-value\"><a class=\"color-options\" ng-repeat=\"color in vm.coloroption\" id=\"{{color.value}}\" ng-class=\"{ activeColor: $parent.selected == color.value, activeColor: color.value == vm.dialogData.color}\" ng-click=\"$parent.selected = color.value; vm.onClick(color.value)\" style=\"background-color:{{color.bcolor}}\" value=\"{{color.value}}\" ng-model=\"color.value\"></a><div ng-show=\"vm.dialogData.showTypeDialog == \'info\'\" class=\"disableClick\"></div></div></div></md-dialog-content></div><md-dialog-actions layout=\"row\" class=\"g-section\"><md-button ng-click=\"vm.onSaveBtnTap($event)\" layout-align=\"start\" class=\"save-button md-accent md-accent_g-green md-raised\" ng-disabled=\"eventForm.$invalid\" aria-label=\"SAVE\">SAVE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dashboard/available-room/check-available-room-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Available Room Slots</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"padding_contentTop\"><md-dialog-content ms-scroll=\"\"><table><tr><th></th><th ng-repeat=\"date in vm.dates\">{{ date | date:\'fullDate\' }}</th></tr><tr ng-repeat=\"(key,room) in vm.availableRooms\"><th>{{key}}</th><td ng-repeat=\"(key,dates) in room\"><li ng-repeat=\"date in dates\" class=\"text-nowrap\">{{date.start}} - {{date.end}}</li></td></tr></table></md-dialog-content></div></form></md-dialog>");
$templateCache.put("app/main/dashboard/request-adhoc-class/request-adhoc-class-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Request Adhoc Class</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"padding_contentTop\"><md-dialog-content ms-scroll=\"\"><div layout-gt-sm=\"row\" class=\"g-clear\"><div class=\"g-relativeResponsive md-block\" flex-gt-sm=\"\"><label class=\"g-absolute container-labels g-positionSet\">Language*</label><md-input-container class=\"md-block\" md-no-float=\"\" flex-gt-sm=\"\"><md-select ng-model=\"vm.dialogData.selected_skill\" placeholder=\"Select Skill\" ng-change=\"vm.onSkillChanged()\"><md-option ng-repeat=\"options in vm.skills\" value=\"{{options.id}}\">{{options.name}}</md-option></md-select></md-input-container></div></div><div layout-gt-sm=\"row\" class=\"g-clear\"><div class=\"btm-padding md-block\" flex-gt-sm=\"\"><md-input-container class=\"md-block from_time_wrapper\" md-no-float=\"\" flex-gt-sm=\"\"><label class=\"container-labels g-PaddingLeft\">Start Time*</label> <input name=\"start_time\" ui-timepicker=\"\" ng-model=\"vm.dialogData.start_time\" required=\"\"><div ng-messages=\"eventForm.start_time.$error\" ng-show=\"eventForm.start_time.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Start Time</span></div><div ng-hide=\"eventForm.start_time.$valid || eventForm.start_time.$error.required\"><span class=\"g-hidden\">isStartTimeValid = {{eventForm.start_time.$valid}}</span> <span class=\"auto-error\">Please enter valid time</span></div></div></md-input-container></div><div class=\"g-relativeResponsive md-block\" flex-gt-sm=\"\"><label class=\"g-absolute container-labels g-positionSet\">Duration*</label><md-input-container class=\"md-block\" md-no-float=\"\" flex-gt-sm=\"\"><md-select name=\"duration\" ng-model=\"vm.dialogData.duration\" placeholder=\"Select Duration\" required=\"\"><md-option ng-repeat=\"options in vm.durations\" value=\"{{options}}\">{{options}}</md-option></md-select></md-input-container><div ng-messages=\"eventForm.duration.$error\" ng-show=\"eventForm.duration.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please Duration Room</span></div></div></div></div><div layout-gt-sm=\"row\" class=\"g-gap g-PaddingLeft layout-gt-sm-row\"><div class=\"g-gap-reducer g-PaddingLeft g-relativeResponsive md-block g-gap-reducer-padding\" flex-gt-sm=\"\"><label class=\"container-labels\">Rooms*</label><md-select name=\"room_id\" ng-model=\"vm.dialogData.room_id\" placeholder=\"Select Room\" required=\"\" disabled=\"\"><md-option ng-repeat=\"options in vm.rooms\" value=\"{{options.roomID}}\">{{options.title}}</md-option></md-select><div ng-messages=\"eventForm.room_id.$error\" ng-show=\"eventForm.room_id.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please select Room</span></div></div></div><div class=\"g-gap-reducer g-PaddingLeft g-relativeResponsive md-block g-gap-reducer-padding\" flex-gt-sm=\"\"><label class=\"container-labels\">Teacher*</label><md-select name=\"teacher_id\" ng-model=\"vm.dialogData.teacher_id\" placeholder=\"Select Teacher\" disabled=\"\"><md-option ng-repeat=\"options in vm.teachers\" value=\"{{options.id}}\">{{options.full_name}}</md-option></md-select><div ng-messages=\"eventForm.teacher_id.$error\" ng-show=\"eventForm.teacher_id.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please select Room</span></div></div></div></div><div class=\"md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Category Color*</label><div id=\"color-value\"><a class=\"color-options\" ng-repeat=\"color in vm.coloroption\" id=\"{{color.value}}\" ng-class=\"{ activeColor: $parent.selected == color.value, activeColor: color.value == vm.dialogData.color}\" ng-click=\"$parent.selected = color.value; vm.onClick(color.value)\" style=\"background-color:{{color.bcolor}}\" value=\"{{color.value}}\" ng-model=\"color.value\"></a><div ng-show=\"vm.dialogData.showTypeDialog == \'info\'\" class=\"disableClick\"></div></div></div></md-dialog-content></div><md-dialog-actions layout=\"row\" class=\"g-section\"><md-button ng-click=\"vm.onSaveBtnTap($event)\" layout-align=\"start\" class=\"save-button md-accent md-accent_g-green md-raised\" ng-disabled=\"eventForm.$invalid\" aria-label=\"SAVE\">SAVE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/holidays/add-holidays/add-holidays-dialog.html","<md-dialog class=\"event-form-dialog g-overflow_visible\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form g-overflow_visible\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"g-overflow_visible\"><md-input-container class=\"md-block\"><label class=\"container-labels\">Name*</label> <input name=\"Name\" placeholder=\"Name of Holiday\" ng-pattern=\"/^[a-zA-Z\\s]+[0-9!@#\\$%\\^\\&*\\)\\(+=._-]*$/\" ng-model=\"vm.dialogData.name\" required=\"\"><div ng-messages=\"eventForm.Name.$error\" ng-show=\"eventForm.Name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Name of Holiday</span></div><div ng-message=\"pattern\"><span>Please provide valid Name of Holiday</span></div></div></md-input-container><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">From</label><div id=\"dateStartPicker\"><datepicker date-format=\"dd-MM-yyyy\" date-set=\"{{vm.setStartValue}}\" date-min-limit=\"{{vm.setStartYearMin}}\" date-max-limit=\"{{vm.setStartYearMax}}\" datepicker-append-to=\"dateStartPicker\"><input ng-model=\"vm.dialogData.start_date\" ng-change=\"vm.onChangeStartDate(vm.dialogData.start_date)\" type=\"text\"></datepicker></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">To</label><div id=\"dateEndPicker\"><datepicker date-format=\"dd-MM-yyyy\" date-set=\"{{vm.setEndValue}}\" date-min-limit=\"{{vm.setMinDate}}\" date-max-limit=\"{{vm.setStartYearMax}}\" datepicker-append-to=\"dateEndPicker\"><input ng-model=\"vm.dialogData.end_date\" type=\"text\"></datepicker></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"g-section\"><md-button ng-click=\"vm.onSaveHolidayBtnTap($event)\" layout-align=\"start\" class=\"save-button md-accent md-accent_g-green md-raised\" ng-disabled=\"eventForm.$invalid\" aria-label=\"SAVE\">SAVE</md-button><md-button class=\"md-icon-button g-float-right\" ng-click=\"vm.onDeleteBtnTap($event)\" layout-align=\"end\" aria-label=\"Delete\" tabindex=\"-1\" ng-show=\"vm.dialogData.type != \'add\'\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span>Delete</span></md-tooltip></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/intake/add-intake/add-intake-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form add-intake\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\" ng-hide=\"(selectList)\"><div layout-gt-sm=\"row\" layout-align=\"center\"><div ng-show=\"vm.showMessage.length > 0 ? true : false\"><span class=\"auto-error\">{{vm.showMessage}}</span></div></div><div layout-gt-sm=\"row\" class=\"g-clear\"><div class=\"g-relativeResponsive md-block\" flex-gt-sm=\"\"><label class=\"g-absolute container-labels g-positionSet\">Intake Type*</label><md-input-container class=\"md-block\" md-no-float=\"\" flex-gt-sm=\"\"><md-select ng-model=\"vm.intakeType\" placeholder=\"Select Course Type\" ng-change=\"vm.onCourseTypeChanged()\"><md-option ng-repeat=\"options in vm.privateClassCourseType\" value=\"{{options.value}}\">{{options.text}}</md-option></md-select></md-input-container></div></div><label class=\"g-absolute container-labels\">Course*</label><md-input-container class=\"md-block\" md-no-float=\"\" ng-show=\"vm.dialogData.dialogtype == \'edit\'\"><md-autocomplete md-input-name=\"autocompleteField\" ng-disabled=\"vm.isDisabled || vm.dialogData.noneditable == \'noneditable\'\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedItem\" md-search-text-change=\"vm.searchTextChange(vm.searchText)\" md-search-text=\"vm.searchText\" md-selected-item-change=\"vm._onCourseChanged()\" md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.display\" md-min-length=\"0\" placeholder=\"Select a Course\" ng-readonly=\"true\" field-required=\"true\"><md-item-template><span md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.display}}</span></md-item-template><md-not-found>No states matching \"{{vm.searchText}}\" were found.</md-not-found></md-autocomplete><div ng-messages=\"eventForm.autocompleteField.$error.required\" ng-if=\"eventForm.autocompleteField.$touched\" role=\"alert\"><div ng-message=\"required\" ng-show=\"vm.searchText == \'\'\"><span class=\"auto-error\">Please select Course</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" ng-hide=\"vm.dialogData.dialogtype == \'edit\'\"><angucomplete-alt id=\"ex10\" placeholder=\"\" pause=\"100\" selected-object=\"selectedPerson\" local-data=\"arrCoursesArray\" search-fields=\"title,Level,Series,Rule\" title-field=\"title,Level,Series,Rule\" minlength=\"1\" input-class=\"form-control form-control-small\" match-class=\"highlight\" field-required=\"true\"><div ng-messages=\"eventForm.autocompleteField.$error.required\" ng-if=\"eventForm.autocompleteField.$touched\" role=\"alert\"><div ng-message=\"required\" ng-show=\"vm.searchText == \'\'\"><span class=\"auto-error\">Please select Course</span></div></div></angucomplete-alt></md-input-container><input type=\"hidden\" id=\"coursename\" value=\"{{selectedPerson.title}}\"><div layout-gt-sm=\"row\"><div ng-show=\"vm.selectCourseError\"><span class=\"auto-error\">Please select valid course</span></div></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block from_time_wrapper\" md-no-float=\"\" flex-gt-sm=\"\" ng-show=\"vm.dialogData.dialogtype == \'add\'\"><md-checkbox ng-model=\"vm.dialogData.is_flexible\" ng-change=\"vm.onChangeFlexible()\" aria-label=\"Flexible\">Flexible</md-checkbox></md-input-container><md-input-container class=\"md-block from_time_wrapper\" md-no-float=\"\" flex-gt-sm=\"\" ng-show=\"vm.intakeType == \'G\' || vm.intakeType == \'O\'\"><md-checkbox ng-model=\"vm.dialogData.is_display\" ng-change=\"vm.onChangeDisplay()\" aria-label=\"Display\">Is Display</md-checkbox></md-input-container></div><md-input-container class=\"md-block g-PaddingLeft\" ng-show=\"vm.showDays\" md-no-float=\"\"><div ng-repeat=\"day in vm.days\" layout-gt-sm=\"column\" class=\"recuurence-checkbox\" layout=\"row\" flex=\"100\" flex-gt-xs=\"30\" ng-show=\"vm.showDays\"><md-checkbox class=\"no-label\" aria-label=\"{{day.bAllow?\'false\':\'true\'}}\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\' || vm.dialogData.noneditable == \'noneditable\'\" ng-change=\"vm.ToggleCheckbox($event, day)\" ng-model=\"day.bAllow\" ng-readonly=\"vm.dialogData.showTypeDialog == \'info\'\"></md-checkbox><span class=\"title\">{{day.day}}</span></div></md-input-container><div class=\"g-gap-reducer g-PaddingLeft\" ng-hide=\"vm._bHideStudentDropdown || vm.dialogData.students.length == 0\"><label class=\"container-labels\">Student List</label><select ui-select2=\"vm.select2Options\" id=\"myselect\" multiple=\"\" name=\"student\" class=\"md-block slec\" flex-gt-sm=\"\" ng-model=\"vm.dialogData.students\" data-placeholder=\"+Add Students\" ng-change=\"vm.onChangeStudents()\" ng-disabled=\"true\"><option ng-repeat=\"student in vm.dialogData.studentData\" value=\"{{student.id}}\" class=\"md-block\" flex-gt-sm=\"\">{{student.email}}</option></select><div ng-messages=\"eventForm.student.$error\" ng-show=\"eventForm.student.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please select Students</span></div></div></div><div layout-gt-sm=\"row\"><div ng-show=\"vm.dialogData.students.length > vm.batchLength ? true : false\"><span class=\"auto-error\">Selected students exceeds course intake students</span></div></div><div layout-gt-sm=\"row\" class=\"g-clear\"><md-input-container class=\"md-block from_time_wrapper\" md-no-float=\"\" flex-gt-sm=\"\"><label class=\"container-labels g-PaddingLeft\">Start Time*</label> <input name=\"start_time\" ui-timepicker=\"\" ng-model=\"vm.dialogData.start_time\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\' || vm.dialogData.noneditable == \'noneditable\'\" ng-blur=\"vm._onStartTimeChange()\" required=\"\"><div ng-messages=\"eventForm.start_time.$error\" ng-show=\"eventForm.start_time.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Start Time</span></div><div ng-hide=\"eventForm.start_time.$valid || eventForm.start_time.$error.required\"><span class=\"g-hidden\">isStartTimeValid = {{eventForm.start_time.$valid}}</span> <span class=\"auto-error\">Please enter valid time</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" flex-gt-sm=\"\"><label class=\"container-labels\">Intake ID</label> <input name=\"IntakeID\" ng-model=\"vm.dialogData.intakeID\" ng-readonly=\"true\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\' || vm.dialogData.noneditable == \'noneditable\'\" placeholder=\"Intake-Id\" required=\"\"><div ng-show=\"vm.showIntakeError.length > 0 ? true : false\"><span class=\"auto-error\">{{vm.showIntakeError}}</span></div></md-input-container><div class=\"g-relativeResponsive md-block\" flex-gt-sm=\"\"><label class=\"g-absolute container-labels g-positionSet\">Term*</label><md-input-container class=\"md-block\" md-no-float=\"\" flex-gt-sm=\"\"><md-select ng-model=\"vm.dialogData.module\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\'\" placeholder=\"Select Term\" required=\"\"><md-option ng-repeat=\"options in vm.intakeSeries\" value=\"{{options.value}}\">{{options.value}}</md-option></md-select></md-input-container></div></div><div layout-gt-sm=\"row\" class=\"g-clear\" ng-hide=\'vm.intakeType == \"G\" || vm.intakeType == \"O\"\'><md-input-container class=\"md-block\" md-no-float=\"\" flex-gt-sm=\"\"><label class=\"container-labels\">Class Duration</label> <input name=\"IntakeID\" ng-model=\"vm.dialogData.class_duration\" ng-readonly=\"true\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" flex-gt-sm=\"\"><label class=\"container-labels\">Validity</label> <input name=\"IntakeID\" ng-model=\"vm.dialogData.validity\" ng-readonly=\"true\" ng-disabled=\"true\"></md-input-container></div><div layout-gt-sm=\"row\"><div class=\"btm-padding md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Start Date</label><md-content class=\"g-overflow_hidden\"><md-datepicker name=\"start_date\" ng-model=\"vm.dialogData.start_date\" md-date-filter=\"vm.onlyWeekendsPredicate\" ng-change=\"vm._onStartDateChange(vm.dialogData.start_date)\" ng-disabled=\"!((vm.isCourseChanged && vm.isTimeChanged) || (vm.dialogData.dialogtype == \'edit\')) || (vm.dialogData.showTypeDialog == \'info\') || vm.dialogData.noneditable == \'noneditable\'\" md-placeholder=\"Enter date\" class=\"btm-padding\"></md-datepicker></md-content><div ng-hide=\"eventForm.start_date.$valid\"><span class=\"auto-error\">Please enter valid date</span></div></div><div class=\"btm-padding md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">End Date</label><md-content class=\"g-overflow_hidden\"><md-datepicker ng-model=\"vm.dialogData.end_date\" ng-change=\"vm._onEndDateChange()\" ng-disabled=\"true\" md-placeholder=\"Enter date\"></md-datepicker></md-content></div></div><div layout-gt-sm=\"row\"><div ng-show=\"vm.startDate.length > 0 ? true : false\"><span class=\"auto-error\">{{vm.startDate}}</span></div></div><div layout-gt-sm=\"row\" class=\"g-gap g-PaddingLeft\"><label class=\"g-absolute container-labels\" ng-hide=\'vm.intakeType == \"O\"\'>Room</label><md-input-container class=\"md-block\" flex-gt-sm=\"\" md-no-float=\"\" ng-hide=\'vm.intakeType == \"O\"\'><md-select ng-model=\"vm.dialogData.roomID\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\' || vm.dialogData.noneditable == \'noneditable\'\" ng-change=\"vm.showRoomChange()\" placeholder=\"Select Room\"><md-option value=\"\"></md-option><md-option ng-repeat=\"options in vm.roomoption\" value=\"{{options.id}}\">{{options.title}}</md-option></md-select><div ng-show=\"vm.showRoom.length > 0 ? true : false\"><span class=\"auto-error\">{{vm.showRoom}}</span></div></md-input-container><div class=\"g-relativeResponsive md-block\" flex-gt-sm=\"\" ng-show=\"vm.Before\"><label class=\"g-absolute container-labels g-position-Set\">Teacher</label><md-input-container class=\"md-block\" flex-gt-sm=\"\" md-no-float=\"\"><md-select ng-model=\"vm.dialogData.teacherID\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\' || vm.dialogData.noneditable == \'noneditable\'\" ng-change=\"vm.showTeacherChange()\" placeholder=\"Select Teacher\"><md-option value=\"\"></md-option><md-option ng-repeat=\"options in vm.teacher\" value=\"{{options.id}}\">{{options.name}}</md-option></md-select><div ng-show=\"vm.showTeacher.length > 0 ? true : false\"><span class=\"auto-error\">{{vm.showTeacher}}</span></div></md-input-container></div><div class=\"g-gap-reducer g-PaddingLeft g-relativeResponsive md-block g-gap-reducer-padding\" flex-gt-sm=\"\" ng-show=\"vm.After\"><label class=\"container-labels\">Teacher</label><select ui-select2=\"{ allowClear: true}\" id=\"myTeacherselect\" name=\"student\" class=\"md-block slec custom-selc\" flex-gt-sm=\"\" ng-model=\"vm.dialogData.teacherID\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\' || vm.dialogData.noneditable == \'noneditable\'\" data-placeholder=\"Select Teacher\"><option value=\"\" class=\"select2-default\" ng-show=\"vm.Before\"></option><option ng-repeat=\"options in vm.teacher\" value=\"{{options.id}}\" class=\"md-block others\" flex-gt-sm=\"\">{{options.name}}</option></select></div></div><div layout-gt-sm=\"row\" class=\"g-gap g-PaddingLeft\" ng-hide=\'vm.intakeType == \"G\" || vm.intakeType == \"O\"\'><label class=\"g-absolute container-labels\">Location</label><md-input-container class=\"md-block\" flex-gt-sm=\"\" md-no-float=\"\"><textarea ng-model=\"vm.dialogData.location\" columns=\"1\" name=\"location\" md-maxlength=\"250\" rows=\"1\" class=\"ng-pristine ng-valid md-input ng-touched\" id=\"input_114 location\" aria-multiline=\"true\" aria-invalid=\"false\" ng-trim=\"false\" style=\"height: 29px;overflow-y: scroll;\" ng-change=\"vm.onLocationChange()\" ng-required=\"vm.intakeType == \'P\'\" ng-disabled=\"\">\n                    </textarea> <span ng-messages=\"eventForm.location.$error\" ng-show=\"eventForm.location.$touched\" role=\"alert\"><span ng-message=\"required\" class=\"auto-error\">Enter a Location</span></span></md-input-container></div><div class=\"md-block\" ng-show=\"vm.commentsShow\"><label class=\"container-labels\">Comments</label><md-input-container class=\"md-block\" md-no-float=\"\" style=\"height: auto;\"><textarea ng-model=\"vm.dialogData.comments\" columns=\"1\" md-maxlength=\"250\" rows=\"1\" class=\"ng-pristine ng-valid md-input ng-touched\" id=\"input_114\" aria-multiline=\"true\" aria-invalid=\"false\" ng-trim=\"false\" style=\"height: 29px;\">\n                    </textarea></md-input-container></div><div class=\"md-block\" flex-gt-sm=\"\" ng-show=\"vm.editShow\"><label class=\"container-labels\">Additional Payment</label><div class=\"additional-pay\" data-ng-repeat=\"choice in vm.dialogData.additional_pay\"><input type=\"text\" ng-model=\"choice.name\" name=\"choicename_{{$index}}\" ng-pattern=\"/^[a-zA-Z\\s]*$/\" placeholder=\"\" required=\"\"> <span ng-messages=\"eventForm[\'choicename_\' + $index].$error\" ng-show=\"eventForm[\'choicename_\' + $index].$touched\" role=\"alert\"><span ng-message=\"required\" class=\"auto-error\">Enter a name</span> <span ng-message=\"pattern\" class=\"auto-error\">Please provide valid name</span></span> <input type=\"text\" ng-model=\"choice.value\" name=\"choicevalue_{{$index}}\" ng-maxlength=\"4\" ng-pattern=\"/^\\(?\\+?[\\d\\(\\-\\s\\)]+$/\" placeholder=\"\" required=\"\"> <span ng-messages=\"eventForm[\'choicevalue_\' + $index].$error\" ng-show=\"eventForm[\'choicename_\' + $index].$touched\" role=\"alert\"><span ng-message=\"required\" class=\"auto-error\">Enter a value</span> <span ng-message=\"pattern\" class=\"auto-error\">Please provide valid value</span></span> <button class=\"remove-btn\" ng-click=\"vm.removeChoice($index)\">-</button></div><button class=\"addfields\" ng-click=\"vm.addNewChoice()\">Add fields</button></div><div class=\"md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Category Color*</label><div id=\"color-value\"><a class=\"color-options\" ng-repeat=\"color in vm.coloroption\" id=\"{{color.value}}\" ng-class=\"{ activeColor: $parent.selected == color.value, activeColor: color.value == vm.dialogData.color}\" ng-click=\"$parent.selected = color.value; vm.onClick(color.value)\" style=\"background-color:{{color.bcolor}}\" value=\"{{color.value}}\" ng-model=\"color.value\"></a><div ng-show=\"vm.dialogData.showTypeDialog == \'info\'\" class=\"disableClick\"></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"g-section\" ng-hide=\"vm.dialogData.showTypeDialog == \'info\'\"><md-button ng-click=\"vm.onSaveIntakeBtnTap($event)\" class=\"save-button md-accent md-accent_g-green md-raised\" ng-disabled=\"eventForm.$invalid || (vm._isColorSelected) || (vm.dialogData.roomID == \'undefined\' && vm.dialogData.teacherID == \'undefined\') || vm.selectCourseError == true || vm.showMessage.length > 0 || vm.showTeacher.length > 0 || vm.showRoom.length > 0 || vm.showIntakeError.length > 0 || vm._bDisbleSaveButton\" aria-label=\"SAVE\" ng-hide=\"(selectList) || vm.dialogData.showTypeDialog == \'info\'\">SAVE</md-button><md-button ng-click=\"(selectList = false)\" class=\"save-button md-accent md-accent_g-green md-raised\" aria-label=\"SAVE\" id=\"back\" ng-show=\"(selectList)\">Ok</md-button><md-button class=\"md-icon-button g-float-right\" ng-click=\"vm.onDeleteBtnTap($event)\" aria-label=\"Delete\" tabindex=\"-1\" ng-show=\"vm.dialogData.dialogtype == \'edit\'\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span>Delete</span></md-tooltip></md-button></md-dialog-actions></form></md-dialog><script>\n    $(document).ready(function () {\n        $(\".slec\").select2();\n        $(\'#myTeacherselect\').change(function () {\n            var current = $(\'#myTeacherselect\').val();\n            if (current != \'null\') {\n                $(\'#myTeacherselect\').css(\'color\', \'black\');\n            } else {\n                $(\'#myTeacherselect\').css(\'color\', \'#e1e1e1\');\n            }\n        });\n        $(\"#myTeacherselect\").select2({\n            allowClear: true,\n            placeholder: \"Search Teacher\",\n        })\n\n    });\n\n\n    //</script>");
$templateCache.put("app/main/intake/add-intake/add-makeup-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form add-intake\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\" ng-hide=\"(selectList)\"><div layout-gt-sm=\"row\" layout-align=\"center\"><div ng-show=\"vm.showMessage.length > 0 ? true : false\"><span class=\"auto-error\">{{vm.showMessage}}</span></div></div><div layout-gt-sm=\"row\" class=\"g-clear\"><md-input-container class=\"md-block\" md-no-float=\"\" flex-gt-sm=\"\"><label class=\"g-absolute container-labels g-positionSet\">Intake ID</label> <input name=\"IntakeID\" ng-model=\"vm.dialogData.intake_id\" ng-readonly=\"true\" ng-disabled=\"\" placeholder=\"Intake-Id\" required=\"\"><div ng-show=\"vm.showIntakeError.length > 0 ? true : false\"><span class=\"auto-error\">{{vm.showIntakeError}}</span></div></md-input-container></div><div layout-gt-sm=\"row\" class=\"g-clear\"><label class=\"g-absolute container-labels g-positionSet\">Select Student*</label><md-input-container class=\"md-block\" flex-gt-sm=\"\" md-no-float=\"\"><md-select ng-model=\"vm.student\" name=\"student\" placeholder=\"Select Student\" required=\"\" ng-change=\"vm.getStudentDates()\"><md-option ng-repeat=\"student in vm.studentsobj\" value=\"{{student.id}}\">{{student.name}}</md-option></md-select></md-input-container><span ng-messages=\"eventForm.student.$error\" ng-show=\"eventForm.student.$touched\" role=\"alert\"><span ng-message=\"required\" class=\"auto-error\">Please select a student</span></span></div><div layout-gt-sm=\"row\" class=\"g-clear\"><label class=\"g-absolute container-labels g-positionSet\">Select Date*</label><md-input-container class=\"md-block\" flex-gt-sm=\"\" md-no-float=\"\"><md-select ng-model=\"vm.date\" name=\"date\" placeholder=\"Select dates\" required=\"\"><md-option ng-repeat=\"date in vm.studentDatesObj\" value=\"{{date}}\">{{date}}</md-option></md-select></md-input-container><span ng-messages=\"eventForm.date.$error\" ng-show=\"eventForm.date.$touched\" role=\"alert\"><span ng-message=\"required\" class=\"auto-error\">Please select a date</span></span></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"g-section\" ng-hide=\"vm.dialogData.showTypeDialog == \'info\'\"><md-button ng-click=\"vm.saveMakeUpClass()\" class=\"save-button md-accent md-accent_g-green md-raised\" ng-disabled=\"eventForm.$invalid || vm.showMessage.length > 0 || vm.showIntakeError.length > 0 || vm._bDisbleSaveButton\" aria-label=\"SAVE\" ng-hide=\"(selectList) || vm.dialogData.showTypeDialog == \'info\'\">SAVE</md-button><md-button ng-click=\"(selectList = false)\" class=\"save-button md-accent md-accent_g-green md-raised\" aria-label=\"SAVE\" id=\"back\" ng-show=\"(selectList)\">Ok</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/intake/add-intake/add-private-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form add-intake\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\" ng-hide=\"(selectList)\"><div layout-gt-sm=\"row\" layout-align=\"center\"><div ng-show=\"vm.showMessage.length > 0 ? true : false\"><span class=\"auto-error\">{{vm.showMessage}}</span></div></div><div layout-gt-sm=\"row\" class=\"g-clear\"><md-input-container class=\"md-block\" md-no-float=\"\" flex-gt-sm=\"\"><label class=\"g-absolute container-labels g-positionSet\">Intake ID</label> <input name=\"IntakeID\" ng-model=\"vm.dialogData.intake_id\" ng-readonly=\"true\" ng-disabled=\"\" placeholder=\"Intake-Id\" required=\"\"><div ng-show=\"vm.showIntakeError.length > 0 ? true : false\"><span class=\"auto-error\">{{vm.showIntakeError}}</span></div></md-input-container></div><div layout-gt-sm=\"row\" class=\"g-clear\"><div class=\"btm-padding md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Start Date</label><md-content class=\"g-overflow_hidden\"><md-datepicker name=\"start_date\" ng-model=\"vm.dialogData.start_date\" date-format=\"dd-MM-yyyy\" ng-change=\"vm._onStartDateChange()\" md-placeholder=\"Enter date\" class=\"btm-padding\" required=\"\"></md-datepicker></md-content><div ng-hide=\"eventForm.start_date.$valid\"><span class=\"auto-error\">Please enter valid date</span></div></div></div><div layout-gt-sm=\"row\" class=\"g-clear\"><md-input-container class=\"md-block from_time_wrapper\" md-no-float=\"\" flex-gt-sm=\"\"><label class=\"container-labels g-PaddingLeft\">Start Time*</label> <input name=\"start_time\" ui-timepicker=\"\" ng-model=\"vm.dialogData.start_time\" required=\"\"><div ng-messages=\"eventForm.start_time.$error\" ng-show=\"eventForm.start_time.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Start Time</span></div><div ng-hide=\"eventForm.start_time.$valid || eventForm.start_time.$error.required\"><span class=\"g-hidden\">isStartTimeValid = {{eventForm.start_time.$valid}}</span> <span class=\"auto-error\">Please enter valid time</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" class=\"g-clear\"><md-input-container class=\"md-block\" md-no-float=\"\" flex-gt-sm=\"\"><label class=\"container-labels\">Duration*</label> <input name=\"duration\" ng-model=\"vm.dialogData.class_duration\" required=\"\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"g-section\" ng-hide=\"vm.dialogData.showTypeDialog == \'info\'\"><md-button ng-click=\"vm.savePrivateClass()\" class=\"save-button md-accent md-accent_g-green md-raised\" ng-disabled=\"eventForm.$invalid || vm.showMessage.length > 0 || vm.showIntakeError.length > 0 || vm._bDisbleSaveButton\" aria-label=\"SAVE\" ng-hide=\"(selectList) || vm.dialogData.showTypeDialog == \'info\'\">SAVE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/intake/add-intake/add-update-student-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"padding_contentTop\"><md-dialog-content ms-scroll=\"\"><md-input-container class=\"md-block\"><label class=\"container-labels\">Student List</label><ui-select multiple=\"\" ng-model=\"vm.multipleDemo.selectedPeople\" theme=\"select2\" append-to-body=\"true\" close-on-select=\"true\" ng-change=\"vm.onStudentListChange\" style=\"width: 600px;\" required=\"\"><ui-select-match placeholder=\"Select Student...\">{{$item.text}}</ui-select-match><ui-select-choices position=\"up\" all-choices=\"vm.allItems\" refresh-delay=\"0\" repeat=\"person in $select.pageOptions.people | propsFilter: {title: $select.search, age: $select.search}\"><div ng-bind-html=\"person.title | highlight: $select.search\"></div><small>{{person.text}}</small></ui-select-choices></ui-select><div ng-messages=\"eventForm.student.$error\" ng-show=\"eventForm.student.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please select Students</span></div></div></md-input-container></md-dialog-content></div><md-dialog-actions layout=\"row\" class=\"g-section\"><md-button ng-click=\"vm.onSaveBtnTap($event)\" layout-align=\"start\" class=\"save-button md-accent md-accent_g-green md-raised\" ng-disabled=\"eventForm.$invalid\" aria-label=\"SAVE\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/intake/add-intake/show-available-room-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"padding_contentTop\"><md-dialog-content ms-scroll=\"\"><md-input-container class=\"md-block\"><label class=\"container-labels\">Room</label><md-select id=\"myselect\" name=\"student\" class=\"md-block slec\" flex-gt-sm=\"\" ng-model=\"vm.roomID\" data-placeholder=\"Room\" ng-change=\"vm.onChangeStudents()\" required=\"\"><md-option ng-repeat=\"room in vm.rooms\" value=\"{{room.roomID}}\" class=\"md-block\" flex-gt-sm=\"\">{{room.title}} ({{room.capacity}})</md-option></md-select></md-input-container></md-dialog-content></div><md-dialog-actions layout=\"row\" class=\"g-section\"><md-button ng-click=\"vm.onSaveBtnTap($event)\" layout-align=\"start\" class=\"save-button md-accent md-accent_g-green md-raised\" ng-disabled=\"eventForm.$invalid\" aria-label=\"SAVE\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/intake/add-intake/transfer-student-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Transfer Student</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"padding_contentTop\"><md-dialog-content ms-scroll=\"\"><md-input-container class=\"md-block\"><label class=\"container-labels\">Classes</label><md-select id=\"myselect\" name=\"student\" class=\"md-block slec\" flex-gt-sm=\"\" ng-model=\"vm.updated_schedule_classID\" data-placeholder=\"Classes\" required=\"\"><md-option ng-repeat=\"class in vm.dialogData.upcomingClasses\" value=\"{{class.scheduleClassID}}\" class=\"md-block\" flex-gt-sm=\"\">{{\'[\' + class.courseName + \'-\' + class.courseLevel + \' - \' + class.start_date + \' to \' + class.end_date + \']\'}}</md-option></md-select></md-input-container></md-dialog-content></div><md-dialog-actions layout=\"row\" class=\"g-section\"><md-button ng-click=\"vm.onSaveBtnTap($event)\" layout-align=\"start\" class=\"save-button md-accent md-accent_g-green md-raised\" ng-disabled=\"eventForm.$invalid\" aria-label=\"SAVE\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/intake/add-intake/update-comment.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"padding_contentTop\"><md-dialog-content ms-scroll=\"\"><md-input-container class=\"md-block\" style=\"height: auto;\"><label class=\"container-labels\">comment</label> <textarea ng-model=\"vm.dialogData.comment\" columns=\"1\" md-maxlength=\"150\" rows=\"1\" class=\"ng-pristine ng-valid md-input ng-touched\" id=\"input_114\" aria-multiline=\"true\" aria-invalid=\"false\" ng-trim=\"false\" style=\"height: 29px;\">\n                    </textarea></md-input-container></md-dialog-content></div><md-dialog-actions layout=\"row\" class=\"g-section\"><md-button ng-click=\"vm.onSaveBtnTap($event)\" layout-align=\"start\" class=\"save-button md-accent md-accent_g-green md-raised\" ng-disabled=\"eventForm.$invalid\" aria-label=\"SAVE\">Update Comment</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/intake/add-intake/update-invoice.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"padding_contentTop\"><md-dialog-content ms-scroll=\"\"><md-input-container class=\"md-block\"><label class=\"container-labels\">Basic Cost*</label> <input type=\"number\" name=\"Cost\" placeholder=\"Basic Cost\" ng-model=\"vm.dialogData.basic_cost\" ng-pattern=\"/^(\\d)+$/\" required=\"\"><div ng-messages=\"eventForm.Cost.$error\" ng-show=\"eventForm.Cost.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Basic Cost</span></div></div></md-input-container><md-input-container class=\"md-block\"><label class=\"container-labels\">Admin Fee*</label> <input type=\"number\" name=\"Capacity\" placeholder=\"Admin Fee\" ng-model=\"vm.dialogData.admin_fee\" ng-pattern=\"/^(\\d)+$/\" required=\"\"><div ng-messages=\"eventForm.Capacity.$error\" ng-show=\"eventForm.Capacity.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Admin Fee</span></div></div></md-input-container></md-dialog-content></div><md-dialog-actions layout=\"row\" class=\"g-section\"><md-button ng-click=\"vm.onSaveBtnTap($event)\" layout-align=\"start\" class=\"save-button md-accent md-accent_g-green md-raised\" ng-disabled=\"eventForm.$invalid\" aria-label=\"SAVE\">Update Invoice</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/intake/add-intake/update-makeup-invoice.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"padding_contentTop\"><md-dialog-content ms-scroll=\"\"><md-input-container class=\"md-block\"><label class=\"container-labels\">Basic Cost*</label> <input type=\"number\" name=\"Cost\" placeholder=\"Basic Cost\" ng-model=\"vm.dialogData.basic_cost\" ng-pattern=\"/^(\\d)+$/\" required=\"\"><div ng-messages=\"eventForm.Cost.$error\" ng-show=\"eventForm.Cost.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Basic Cost</span></div></div></md-input-container></md-dialog-content></div><md-dialog-actions layout=\"row\" class=\"g-section\"><md-button ng-click=\"vm.onSaveBtnTap($event)\" layout-align=\"start\" class=\"save-button md-accent md-accent_g-green md-raised\" ng-disabled=\"eventForm.$invalid\" aria-label=\"SAVE\">Update Invoice</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/intake/delete/delete-private-class.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form add-intake\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\" ng-hide=\"(selectList)\"><div layout-gt-sm=\"row\" layout-align=\"center\"><div ng-show=\"vm.showMessage.length > 0 ? true : false\"><span class=\"auto-error\">{{vm.showMessage}}</span></div></div><div layout-gt-sm=\"row\" class=\"g-clear\"><label class=\"g-absolute container-labels g-positionSet\">Select Date*</label><md-input-container class=\"md-block\" flex-gt-sm=\"\" md-no-float=\"\"><md-select ng-model=\"vm.date\" name=\"date\" placeholder=\"Select dates\" required=\"\"><md-option ng-repeat=\"date in vm.dateobj\" value=\"{{date}}\">{{date}}</md-option></md-select></md-input-container><span ng-messages=\"eventForm.date.$error\" ng-show=\"eventForm.date.$touched\" role=\"alert\"><span ng-message=\"required\" class=\"auto-error\">Please select a date</span></span></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"g-section\" ng-hide=\"vm.dialogData.showTypeDialog == \'info\'\"><md-button ng-click=\"vm.deletePrivateClass()\" class=\"save-button md-accent md-accent_g-green md-raised\" ng-disabled=\"eventForm.$invalid || vm.showMessage.length > 0\" aria-label=\"DELETE\" ng-hide=\"(selectList) || vm.dialogData.showTypeDialog == \'info\'\">Delete</md-button><md-button ng-click=\"(selectList = false)\" class=\"save-button md-accent md-accent_g-green md-raised\" aria-label=\"SAVE\" id=\"back\" ng-show=\"(selectList)\">Ok</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/intake/notification-popup/swap-class-message-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Swap Room</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-actions layout=\"row\" class=\"g-section\"><md-button ng-click=\"vm.onSaveBtnTap($event)\" layout-align=\"start\" class=\"save-button md-accent md-accent_g-green md-raised\" ng-disabled=\"eventForm.$invalid\" aria-label=\"SAVE\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/rooms/add-rooms/add-rooms-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.name}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"padding_contentTop\"><md-dialog-content ms-scroll=\"\"><md-input-container class=\"md-block\"><label class=\"container-labels\">Name*</label> <input name=\"Name\" placeholder=\"Name of Room\" ng-pattern=\"/^[a-zA-Z\\s]+[0-9!@#\\$%\\^\\&*\\)\\(+=._-]*$/\" ng-model=\"vm.dialogData.title\" required=\"\"><div ng-messages=\"eventForm.Name.$error\" ng-show=\"eventForm.Name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Name of Room</span></div><div ng-message=\"pattern\"><span>Please provide valid name</span></div></div></md-input-container><md-input-container class=\"md-block\"><label class=\"container-labels\">Capacity*</label> <input type=\"number\" name=\"Capacity\" placeholder=\"Capacity of Room\" ng-model=\"vm.dialogData.capacity\" min=\"1\" max=\"999\" ng-pattern=\"/^(\\d)+$/\" ng-minlength=\"0\" ng-maxlength=\"999\" required=\"\"><div ng-messages=\"eventForm.Capacity.$error\" ng-show=\"eventForm.Capacity.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Capacity of Room</span></div><div ng-message=\"pattern\"><span>Please provide valid No. of capacity</span></div><div ng-message=\"max\"><span>Maximum capacity should be 999</span></div><div ng-message=\"min\"><span>Minimum capacity should be 1</span></div></div></md-input-container></md-dialog-content></div><md-dialog-actions layout=\"row\" class=\"g-section\"><md-button ng-click=\"vm.onSaveRoomBtnTap($event)\" layout-align=\"start\" class=\"save-button md-accent md-accent_g-green md-raised\" ng-disabled=\"eventForm.$invalid\" aria-label=\"SAVE\">SAVE</md-button><md-button class=\"md-icon-button g-float-right\" ng-click=\"vm.onDeleteBtnTap($event)\" layout-align=\"end\" aria-label=\"Delete\" tabindex=\"-1\" ng-show=\"vm.dialogData.type != \'add\'\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span>Delete</span></md-tooltip></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/schedule/add-intake/add-intake-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form add-intake\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div layout=\"column\" class=\"editIntake\"><div layout=\"row\"><md-radio-group ng-model=\"vm.dialogData.shift_instance\" ng-change=\"vm._onChangeReschedule()\" required=\"\"><md-radio-button value=\"remaining\">Reschedule the remaining classes</md-radio-button><br><md-radio-button value=\"current\">Reschedule the selected class</md-radio-button></md-radio-group></div></div><div layout-gt-sm=\"row\" layout-align=\"center\"><div ng-show=\"vm.showMessage.length > 0 ? true : false\"><span class=\"auto-error\">{{vm.showMessage}}</span></div></div><label class=\"g-absolute container-labels\">Course*</label><md-input-container class=\"md-block\" md-no-float=\"\"><md-autocomplete required=\"true\" md-input-name=\"autocompleteField\" ng-disabled=\"vm.isDisabled\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedItem\" md-search-text-change=\"vm.searchTextChange(vm.searchText)\" md-search-text=\"vm.searchText\" md-selected-item-change=\"vm._onCourseChanged()\" md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.display\" md-min-length=\"0\" placeholder=\"Select a Course\" ng-readonly=\"true\"><md-item-template><span md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.display}}</span></md-item-template><md-not-found>No states matching \"{{vm.searchText}}\" were found.</md-not-found></md-autocomplete><div ng-messages=\"eventForm.autocompleteField.$error\" ng-if=\"eventForm.autocompleteField.$touched\" role=\"alert\"><div ng-message=\"required\" ng-show=\"vm.searchText == \'\'\"><span class=\"auto-error\">Please select Course</span></div></div></md-input-container><div layout-gt-sm=\"row\"><div ng-show=\"vm.selectCourseError\"><span class=\"auto-error\">Selected Course is not valid</span></div></div><div layout-gt-sm=\"row\" ng-show=\"vm.dialogData.dialogtype == \'add\'\"><md-checkbox ng-model=\"vm.dialogData.is_flexible\" ng-change=\"vm.onChangeFlexible()\" aria-label=\"Flexible\">Flexible</md-checkbox></div><md-input-container class=\"md-block g-PaddingLeft\" ng-show=\"vm.showDays\" md-no-float=\"\"><div ng-repeat=\"day in vm.days\" layout-gt-sm=\"column\" class=\"recuurence-checkbox\" layout=\"row\" flex=\"100\" flex-gt-xs=\"30\" ng-show=\"vm.showDays\"><md-checkbox class=\"no-label\" aria-label=\"{{day.bAllow?\'false\':\'true\'}}\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\'\" ng-change=\"vm.ToggleCheckbox($event, day)\" ng-model=\"day.bAllow\" ng-readonly=\"vm.dialogData.showTypeDialog == \'info\'\"></md-checkbox><span class=\"title\">{{day.day}}</span></div></md-input-container><div class=\"g-gap-reducer g-PaddingLeft\"><label class=\"container-labels\">Student List</label><select ui-select2=\"vm.select2Options\" id=\"myselect\" multiple=\"\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\'\" name=\"student\" class=\"md-block slec\" flex-gt-sm=\"\" ng-model=\"vm.dialogData.students\" data-placeholder=\"+Add Students\"><option ng-repeat=\"student in vm.studentsobj\" value=\"{{student.id}}\" class=\"md-block\" flex-gt-sm=\"\">{{student.text}}</option></select><div ng-messages=\"eventForm.student.$error\" ng-show=\"eventForm.student.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please select Students</span></div></div></div><div layout-gt-sm=\"row\"><div ng-show=\"vm.dialogData.students.length >vm.batchLength ? true : false\"><span class=\"auto-error\">Selected students exceeds course intake students</span></div></div><div layout-gt-sm=\"row\" class=\"g-clear\"><md-input-container class=\"md-block from_time_wrapper\" md-no-float=\"\" flex-gt-sm=\"\"><label class=\"container-labels g-PaddingLeft\">Start Time*</label><input name=\"start_time\" ui-timepicker=\"\" ng-model=\"vm.dialogData.start_time\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\'\" ng-blur=\"vm._onStartTimeChange()\" required=\"\"><div ng-messages=\"eventForm.start_time.$error\" ng-show=\"eventForm.start_time.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Start Time</span></div><div ng-hide=\"eventForm.start_time.$valid || eventForm.start_time.$error.required\"><span class=\"g-hidden\">isStartTimeValid = {{eventForm.start_time.$valid}}</span> <span class=\"auto-error\">Please enter valid time</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" flex-gt-sm=\"\"><label class=\"container-labels\">Intake ID</label> <input name=\"IntakeID\" ng-model=\"vm.dialogData.intakeID\" ng-readonly=\"true\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\'\" placeholder=\"Intake-Id\"><div ng-messages=\"eventForm.IntakeID.$error\" ng-show=\"eventForm.IntakeID.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Intake-ID</span></div></div></md-input-container><div class=\"g-relativeResponsive md-block\" flex-gt-sm=\"\"><label class=\"g-absolute container-labels g-positionSet\">Term*</label><md-input-container class=\"md-block\" md-no-float=\"\" flex-gt-sm=\"\"><md-select ng-model=\"vm.dialogData.module\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\'\" placeholder=\"Select Term\" required=\"\"><md-option ng-repeat=\"options in vm.intakeSeries\" value=\"{{options.value}}\">{{options.value}}</md-option></md-select></md-input-container></div></div><div layout-gt-sm=\"row\"></div><div layout-gt-sm=\"row\"><div class=\"btm-padding md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Start Date</label><md-content class=\"g-overflow_hidden\"><md-datepicker name=\"start_date\" ng-model=\"vm.dialogData.start_date\" md-date-filter=\"vm.onlyWeekendsPredicate\" ng-change=\"vm._onStartDateChange(vm.dialogData.start_date)\" ng-disabled=\"!((vm.isCourseChanged && vm.isTimeChanged) || (vm.dialogData.dialogtype == \'edit\')) || (vm.dialogData.showTypeDialog == \'info\' )\" md-placeholder=\"Enter date\" class=\"btm-padding\"></md-datepicker></md-content><div ng-hide=\"eventForm.start_date.$valid\"><span class=\"auto-error\">Please enter valid date</span></div></div><div class=\"btm-padding md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">End Date</label><md-content class=\"g-overflow_hidden\"><md-datepicker ng-model=\"vm.dialogData.end_date\" ng-change=\"vm._onEndDateChange()\" ng-disabled=\"true\" md-placeholder=\"Enter date\"></md-datepicker></md-content></div></div><div layout-gt-sm=\"row\"><div ng-show=\"vm.startDate.length > 0 ? true : false\"><span class=\"auto-error\">{{vm.startDate}}</span></div></div><div layout-gt-sm=\"row\" class=\"g-gap g-PaddingLeft\"><label class=\"g-absolute container-labels\">Room*</label><md-input-container class=\"md-block\" flex-gt-sm=\"\" md-no-float=\"\"><md-select ng-model=\"vm.dialogData.roomID\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\'\" ng-change=\"vm.showRoom = false\" placeholder=\"Select Room\" required=\"\"><md-option ng-repeat=\"options in vm.roomoption\" value=\"{{options.id}}\">{{options.title}}</md-option></md-select><div ng-show=\"vm.showRoom.length > 0 ? true : false\"><span class=\"auto-error\">{{vm.showRoom}}</span></div></md-input-container><div class=\"g-relativeResponsive md-block\" flex-gt-sm=\"\"><label class=\"g-absolute container-labels g-position-Set\">Teacher*</label><md-input-container class=\"md-block\" flex-gt-sm=\"\" md-no-float=\"\"><md-select ng-model=\"vm.dialogData.teacherID\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\'\" ng-change=\"vm.showTeacher = false\" placeholder=\"Select Teacher\" required=\"\"><md-option ng-repeat=\"options in vm.teacher\" value=\"{{options.id}}\">{{options.name}}</md-option></md-select><div ng-show=\"vm.showTeacher.length > 0 ? true : false\"><span class=\"auto-error\">{{vm.showTeacher}}</span></div></md-input-container></div></div><div class=\"md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Category Color*</label><div id=\"color-value\"><a class=\"color-options\" ng-repeat=\"color in vm.coloroption\" id=\"{{color.value}}\" ng-class=\"{ activeColor: $parent.selected == color.value, activeColor: color.value == vm.dialogData.color}\" ng-click=\"$parent.selected = color.value; vm.onClick(color.value)\" style=\"background-color:{{color.bcolor}}\" value=\"{{color.value}}\" ng-model=\"color.value\"></a><div ng-show=\"vm.dialogData.showTypeDialog == \'info\'\" class=\"disableClick\"></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"g-section\"><md-button ng-click=\"vm.onSaveIntakeBtnTap($event)\" class=\"save-button md-accent md-accent_g-green md-raised\" ng-disabled=\"eventForm.$invalid || (vm._isColorSelected) || (vm.dialogData.roomID == \'undefined\' && vm.dialogData.teacherID == \'undefined\') || (vm.dialogData.students.length >= vm.batchLength) || vm.showTeacher.length > 0 || vm.showRoom.length > 0 ||vm.showMessage.length > 0\" aria-label=\"SAVE\" ng-hide=\"(selectList)\">SAVE</md-button><md-button ng-click=\"(selectList = false)\" class=\"save-button md-accent md-accent_g-green md-raised\" aria-label=\"SAVE\" id=\"back\" ng-show=\"(selectList)\">Ok</md-button><md-button class=\"md-icon-button g-float-right\" ng-click=\"vm.onDeleteBtnTap($event)\" aria-label=\"Delete\" tabindex=\"-1\" ng-show=\"vm.dialogData.type != \'add\'\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span>Delete</span></md-tooltip></md-button></md-dialog-actions></form></md-dialog><script>\n    $(\".slec\").select2();\n    //</script>");
$templateCache.put("app/main/schedule/add-schedule/add-schedule-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\" ng-hide=\"(selectList)\"><label class=\"container-labels\">Type</label><md-input-container class=\"md-block g_margin-top-0\" md-no-float=\"\"><md-select ng-model=\"vm.dialogData.type\" placeholder=\"Select Class Type\" ng-change=\"vm.onchangeOption(vm.dialogData.type)\" required=\"\"><md-option ng-repeat=\"options in vm.classType\" value=\"{{options.id}}\">{{options.value}}</md-option></md-select></md-input-container><div ng-show=\"vm.showIntake\"><label class=\"container-labels g-schedule_margin\">Intake ID</label><md-input-container class=\"md-block room intake-place\" flex=\"100\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" md-no-float=\"\"><angucomplete-alt id=\"room-filter\" placeholder=\"All Intakes\" pause=\"100\" selected-object=\"vm.dialogData.intakeID\" local-data=\"vm.intakeOptions\" search-fields=\"title,id\" title-field=\"title\" minlength=\"1\" input-class=\"form-control form-control-small\" match-class=\"highlight\" focus-out=\"vm.changeIntake()\"></angucomplete-alt></md-input-container></div><div class=\"md-block\"><label class=\"container-labels\">Student List</label><select ui-select2=\"select2Options\" id=\"myselect\" multiple=\"\" name=\"student\" class=\"md-block slec\" flex-gt-sm=\"\" ng-model=\"vm.dialogData.students\" data-placeholder=\"+Add Students\"><option ng-repeat=\"student in vm.studentsobj\" value=\"{{student.id}}\" class=\"md-block\" flex-gt-sm=\"\">{{student.text}}</option></select><div ng-messages=\"eventForm.student.$error\" ng-show=\"eventForm.student.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please select Students</span></div></div></div><div layout-gt-sm=\"row\"><div ng-show=\"vm.showIntakeError.length > 0 ? true : false\"><span class=\"auto-error\">{{vm.showIntakeError}}</span></div></div><div layout-gt-sm=\"row\" class=\"div-height\"><md-input-container class=\"md-block from_time_wrapper\" flex-gt-sm=\"\" md-no-float=\"\"><label class=\"container-labels\">Start Time*</label><input name=\"start_time\" ui-timepicker=\"\" ng-model=\"vm.dialogData.start_time\" ng-change=\"vm._onStartTimeChange()\" class=\"overflow-override\" required=\"\"><div ng-hide=\"eventForm.start_time.$valid\"><span class=\"g-hidden\">isStartTimeValid = {{eventForm.start_time.$valid}}</span> <span class=\"auto-error\">Please enter valid time</span></div></md-input-container><md-input-container class=\"md-block from_time_wrapper\" flex-gt-sm=\"\" ng-hide=\"vm.hide\" md-no-float=\"\"><label class=\"container-labels\">End Time*</label><input name=\"end_time\" ui-timepicker=\"\" ng-model=\"vm.dialogData.end_time\" ng-blur=\"vm._onEndTimeChange()\"><div ng-hide=\"eventForm.end_time.$valid\"><span class=\"g-hidden\">isStartTimeValid = {{eventForm.end_time.$valid}}</span> <span class=\"auto-error\">Please enter valid time</span></div></md-input-container><div class=\"btm-padding md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Start Date</label><md-content class=\"g-overflow_hidden\"><md-datepicker ng-model=\"vm.dialogData.start_date\" md-date-filter=\"vm.onlyWeekendsPredicate\" ng-change=\"vm._onStartDateChange(vm.dialogData.start_date)\" md-placeholder=\"Enter date\" class=\"btm-padding\"></md-datepicker></md-content></div></div><div layout-gt-sm=\"row\"><div ng-show=\"vm.startDate.length > 0 ? true : false\"><span class=\"auto-error\">{{vm.startDate}}</span></div></div><div layout-gt-sm=\"row\" class=\"g-gap g-PaddingLeft\"><label class=\"g-absolute container-labels\">Room*</label><md-input-container class=\"md-block\" flex-gt-sm=\"\" md-no-float=\"\"><md-select ng-model=\"vm.dialogData.roomID\" placeholder=\"Select Room\" required=\"\"><md-option ng-repeat=\"options in vm.roomoption\" value=\"{{options.id}}\">{{options.title}}</md-option></md-select><div ng-show=\"vm.showRoom.length > 0 ? true : false\"><span class=\"auto-error\">{{vm.showRoom}}</span></div></md-input-container><div class=\"g-relativeResponsive md-block\" flex-gt-sm=\"\" ng-show=\"vm.Before\"><label class=\"g-absolute container-labels g-position-Set\">Teacher*</label><md-input-container class=\"md-block\" flex-gt-sm=\"\" md-no-float=\"\"><md-select ng-model=\"vm.dialogData.teacherID\" placeholder=\"Select Teacher\" required=\"\"><md-option ng-repeat=\"options in vm.teacher\" value=\"{{options.id}}\">{{options.name}}</md-option></md-select><div ng-show=\"vm.showTeacher.length > 0 ? true : false\"><span class=\"auto-error\">{{vm.showTeacher}}</span></div></md-input-container></div><div class=\"g-gap-reducer g-PaddingLeft g-relativeResponsive md-block g-gap-reducer-padding\" flex-gt-sm=\"\" ng-show=\"vm.After\"><label class=\"container-labels\">Teacher</label><select ui-select2=\"{ allowClear: true}\" id=\"myTeacherselect\" name=\"student\" class=\"md-block slec custom-selc\" flex-gt-sm=\"\" ng-model=\"vm.dialogData.teacherID\" data-placeholder=\"Select Teacher\"><option ng-repeat=\"options in vm.teacher\" value=\"{{options.id}}\" class=\"md-block others\" flex-gt-sm=\"\">{{options.name}}</option></select></div></div><div class=\"md-block\"><label class=\"container-labels\">Comments</label><md-input-container class=\"md-block\" md-no-float=\"\" style=\"height: auto;\"><textarea ng-model=\"vm.dialogData.comments\" columns=\"1\" md-maxlength=\"250\" rows=\"1\" class=\"ng-pristine ng-valid md-input ng-touched\" id=\"input_114\" aria-multiline=\"true\" aria-invalid=\"false\" ng-trim=\"false\" style=\"height: 29px;\">\n                    </textarea></md-input-container></div><div class=\"md-block\" ng-show=\"vm.TypeOther\" flex-gt-sm=\"\"><label class=\"container-labels\">Category Color*</label><div id=\"color-value\"><input type=\"hidden\" ng-model=\"vm.dialogData.color\" ng-required=\"vm.dialogData.type == \'4\'\"><a class=\"color-options\" ng-repeat=\"color in vm.coloroption\" id=\"{{color.value}}\" ng-class=\"{ activeColor: $parent.selected == color.value, activeColor: color.value == vm.dialogData.color}\" ng-click=\"$parent.selected = color.value; vm.onClick(color.value)\" style=\"background-color:{{color.bcolor}}\" value=\"{{color.value}}\" ng-model=\"color.value\"></a></div></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"g-section\"><md-button ng-click=\"vm.onSaveIntakeBtnTap($event)\" class=\"save-button md-accent md-accent_g-green md-raised\" ng-disabled=\"eventForm.$invalid || vm.Error\" aria-label=\"SAVE\" ng-hide=\"(selectList)\">SAVE</md-button><md-button layout-align=\"start\" class=\"save-button md-accent md-raised btn-duplicate\" ng-click=\"vm.onDuplicateClick(vm.dialogData)\" ng-show=\"vm.dialogData.Type != \'add\'\" aria-label=\"Duplicate\">DUPLICATE</md-button><md-button class=\"md-icon-button g-float-right\" ng-click=\"vm.onDeleteBtnTap($event)\" aria-label=\"Delete\" tabindex=\"-1\" ng-show=\"vm.dialogData.Type != \'add\'\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span>Delete</span></md-tooltip></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/schedule/show-description/show-description-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.dlgName}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div id=\"printarea\"><div layout-gt-sm=\"column\"><div layout=\"row\" class=\"title md-block\"><label flex=\"30\">Date :</label> <span flex=\"66\">{{vm.scheduleDate}}</span></div><div layout=\"row\" class=\"title md-block\"><label flex=\"30\">Students :</label> <span flex=\"66\">{{vm.studentName}}</span></div><div layout=\"row\" class=\"title md-block teacher__block\"><label flex=\"30\">Teacher :</label><md-select ng-model=\"vm.selectedTeacher\" class=\"g-setContainer\" placeholder=\"Select Teacher\" ng-disabled=\"vm._bDisableTeacherDropdown\"><md-option ng-repeat=\"options in vm.availableTeachers\" value=\"{{options.id}}\">{{options.full_name}}</md-option></md-select><md-button class=\"md-accent md-raised md-hue-1 btnred md-button_small\" ng-disabled=\"vm.selectedTeacher == \'\'\" ng-click=\"vm.changeTeacher()\" ng-hide=\"vm._bDisableTeacherDropdown\">Submit</md-button><image src=\"../images/edit@3x.png\" class=\"teacher-edit\" ng-click=\"vm.editTeacherDialog();\" ng-show=\"vm._bDisableTeacherDropdown || vm.roleID == \'1\'\" ng-hide=\"vm.dialogData.type != \'1\'\"></image></div><div layout=\"row\" class=\"title md-block\"><label flex=\"30\">Intake ID :</label> <span flex=\"66\">{{vm.dialogData.intakeID}}</span></div><div layout=\"row\" class=\"title md-block\"><label flex=\"30\">Start Time :</label> <span flex=\"66\">{{vm.dialogData.start_time}}</span></div><div layout=\"row\" class=\"title md-block\"><label flex=\"30\">Start-Date :</label> <span flex=\"66\">{{vm.dialogData.start_date}}</span></div><div layout=\"row\" class=\"title md-block\"><label flex=\"30\">End-Date :</label> <span flex=\"66\">{{vm.dialogData.end_date}}</span></div><div layout=\"row\" class=\"title md-block\"><label flex=\"30\">Room :</label> <span flex=\"66\">{{vm.dialogData.roomAvailable[0][\'title\']}}</span></div><div layout=\"row\" class=\"title md-block\" ng-show=\"vm.dialogData.type != \'1\'\"><label flex=\"30\">Comments :</label> <span flex=\"66\">{{vm.dialogData.comments}}</span></div><div layout=\"row\" class=\"md-block\" ng-show=\"vm.dialogData.type == \'1\'\"><label flex=\"30\" class=\"title\">Category Color:</label> <span flex=\"66\"><div class=\"color-description\" style=\"background-color:#71b8ff\" value=\"{{vm.dialogData.color}}\" ng-model=\"vm.dialogData.color\" ng-if=\"vm.dialogData.color == \'blue\'\"></div><div class=\"color-description\" style=\"background-color:#ef4836\" value=\"{{vm.dialogData.color}}\" ng-model=\"vm.dialogData.color\" ng-if=\"vm.dialogData.color == \'red\'\"></div><div class=\"color-description\" style=\"background-color:#26a65b\" value=\"{{vm.dialogData.color}}\" ng-model=\"vm.dialogData.color\" ng-if=\"vm.dialogData.color == \'green\'\"></div><div class=\"color-description\" style=\"background-color:#F8B735\" value=\"{{vm.dialogData.color}}\" ng-model=\"vm.dialogData.color\" ng-if=\"vm.dialogData.color == \'yellow\'\"></div></span></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button class=\"save-button md-accent md-accent_g-green md-raised\" ng-click=\"vm.onEditIntakeTap($event, vm.dialogData.scheduleClassID, vm.dialogData.intakeID)\" ng-show=\"vm.dialogData.frequency_type == \'Weekly\' && vm.dialogData.courseType == \'G\'\" aria-label=\"SAVE\">Edit</md-button><md-button class=\"save-button md-accent md-accent_g-green md-raised\" ng-click=\"vm.onAdhocEditIntakeTap($event, vm.dialogData.scheduleClassID, vm.dialogData.intakeID)\" ng-show=\"vm.dialogData.type == \'4\'\" aria-label=\"SAVE\">Edit</md-button><md-button class=\"save-button md-accent md-accent_g-green md-raised\" ng-click=\"vm.onEditIntakeTap($event, vm.dialogData.scheduleClassID)\" ng-show=\"vm.dialogData.frequency_type != \'Weekly\' && vm.roleID == \'1\' && vm.dialogData.courseType == \'G\'\" disabled=\"\" aria-label=\"SAVE\">Edit</md-button><md-button class=\"save-button md-accent md-accent_g-green md-raised\" ng-click=\"vm.onSwapRoomTap($event, vm.dialogData.scheduleClassID)\" ng-hide=\"vm.dialogData.type != \'1\' || vm.dialogData.module == null || vm.roleID != \'1\'\" aria-label=\"SAVE\">Swap Room</md-button><md-button class=\"md-icon-button g-float-right\" ng-click=\"vm.onDeleteBtnTap($event)\" aria-label=\"Delete\" tabindex=\"-1\" ng-show=\"vm.dialogData.Type != \'add\' || vm.roleID == \'1\'\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span>Delete</span></md-tooltip></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/schools/add-schools/add-schools-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.dialogName}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"padding_contentTop\"><md-dialog-content ms-scroll=\"\"><md-input-container class=\"md-block\"><label class=\"container-labels\">Schoo Name*</label> <input name=\"Name\" placeholder=\"Name of School\" ng-pattern=\"/^[a-zA-Z\\s]+[0-9!@#\\$%\\^\\&*\\)\\(+=._-]*$/\" ng-model=\"vm.dialogData.name\" required=\"\"><div ng-messages=\"eventForm.Name.$error\" ng-show=\"eventForm.Name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Name of School</span></div><div ng-message=\"pattern\"><span>Please provide valid name</span></div></div></md-input-container><md-input-container class=\"md-block\"><label class=\"container-labels\">Address*</label> <input name=\"Address\" placeholder=\"Address\" ng-model=\"vm.dialogData.address\" required=\"\"><div ng-messages=\"eventForm.Address.$error\" ng-show=\"eventForm.Address.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide School Address</span></div></div></md-input-container><md-input-container class=\"md-block\"><label class=\"container-labels\">Logo*</label><input id=\"inputFileToLoad\" name=\"imageFile\" type=\"file\" data-max-size=\"1048000\" ngf-select=\"vm.encodeImageFileAsURL();\" accept=\"image/*\"><div ng-show=\"vm.imgSize\"><span class=\"tag-error\">File size should not more then 1 MB</span></div></md-input-container><md-input-container class=\"md-block\"><label class=\"container-labels\">Email*</label> <input type=\"email\" name=\"Email\" placeholder=\"Admin Email\" ng-model=\"vm.dialogData.admin_email\" required=\"\"><div ng-messages=\"eventForm.Email.$error\" ng-show=\"eventForm.Email.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Admin Email</span></div></div></md-input-container><md-input-container class=\"md-block\"><label class=\"container-labels\">Full Name*</label> <input name=\"FullName\" placeholder=\"Admin Full Name\" ng-model=\"vm.dialogData.admin_full_name\" ng-pattern=\"/^[a-zA-Z\\s]+[0-9!@#\\$%\\^\\&*\\)\\(+=._-]*$/\" required=\"\"><div ng-messages=\"eventForm.FullName.$error\" ng-show=\"eventForm.FullName.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Admin Full Name</span></div><div ng-message=\"pattern\"><span>Please provide valid name</span></div></div></md-input-container></md-dialog-content></div><md-dialog-actions layout=\"row\" class=\"g-section\"><md-button ng-click=\"vm.onSaveSchoolBtnTap($event)\" layout-align=\"start\" class=\"save-button md-accent md-accent_g-green md-raised\" ng-disabled=\"eventForm.$invalid || vm.imgSize\" aria-label=\"SAVE\">SAVE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/skills/add-skills/add-skills-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"padding_contentTop\"><md-dialog-content ms-scroll=\"\"><md-input-container class=\"md-block\"><label class=\"container-labels\">Name*</label> <input name=\"Name\" placeholder=\"Name of Skill\" ng-pattern=\"/^[a-zA-Z\\s]+[\\s]*[0-9!@#\\$%\\^\\&*\\)\\(+=._-]*$/\" ng-model=\"vm.dialogData.name\" required=\"\"><div ng-messages=\"eventForm.Name.$error\" ng-show=\"eventForm.Name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Name of Skill</span></div><div ng-message=\"pattern\"><span>Please provide valid Name of Skill</span></div></div></md-input-container></md-dialog-content></div><md-dialog-actions layout=\"row\" class=\"g-section\"><md-button ng-click=\"vm.onSaveSkillBtnTap($event)\" layout-align=\"start\" class=\"save-button md-accent md-accent_g-green md-raised\" ng-disabled=\"eventForm.$invalid\" aria-label=\"SAVE\">SAVE</md-button><md-button class=\"md-icon-button g-float-right\" ng-click=\"vm.onDeleteBtnTap($event)\" layout-align=\"end\" aria-label=\"Delete\" tabindex=\"-1\" ng-show=\"vm.dialogData.type != \'add\'\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span>Delete</span></md-tooltip></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/students/add-attendance/add-student-attendance.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Attendance Report</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div layout-gt-sm=\"column\" class=\"student_attendance_course_detail\"><div layout=\"row\" class=\"title md-block\"><label flex=\"30\">Course Name:</label> <span flex=\"66\">{{vm.dialogData.courseName + \'-\' + vm.dialogData.courseLevel }}</span></div><div layout=\"row\" class=\"title md-block\"><label flex=\"30\">Intake ID:</label> <span flex=\"66\">{{vm.dialogData.intakeID}}</span></div><div layout=\"row\" class=\"title md-block\"><label flex=\"30\">Date:</label> <span flex=\"66\">{{vm.dialogData.start_date + \' - \' + vm.dialogData.end_date}}</span></div><div layout=\"row\" class=\"title md-block\"><label flex=\"30\">Time</label> <span flex=\"66\">{{vm.dialogData.start_time + \' - \' + vm.dialogData.end_time}}</span></div></div><table class=\"hover\" style=\"border:1px solid grey\" width=\"70%\"><thead><tr><th></th><th>Attendance</th><th>Trainer</th><th>Room</th></tr></thead><tr ng-repeat=\"Attendance in vm.dialogData.Attendance\"><th>{{Attendance.scheduleDate}}</th><td><span ng-if=\"Attendance.isPresent == \'-\'\">-</span><span ng-if=\"Attendance.isPresent != \'-\'\"><span three-state-checkbox=\"\" ng-model=\"Attendance.isPresent\" ng-change=\"vm.onChange(this)\"></span></span></td><td class=\"trainer_name\"><span ng-if=\"Attendance.trainer == null\">-</span><span ng-if=\"Attendance.trainer != null\">{{Attendance.trainer}}</span></td><td class=\"trainer_name\"><span ng-if=\"Attendance.room_name == null\">-</span><span ng-if=\"Attendance.room_name != null\">{{Attendance.room_name}}</span></td></tr></table></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/students/add-students/add-students-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Name*</label> <input name=\"Name\" placeholder=\"Name of Student\" ng-model=\"vm.dialogData.full_name\" ng-pattern=\"\" required=\"\"><div ng-messages=\"eventForm.Name.$error\" ng-show=\"eventForm.Name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Name</span></div><div ng-message=\"pattern\"><span>Please provide valid Name</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Student No.*</label> <input name=\"StudentIDNO\" placeholder=\"StudentID No.\" ng-maxlength=\"20\" ng-model=\"vm.dialogData.studentId_number\" ng-disabled=\"true\" ng-pattern=\"/^[a-zA-Z0-9]*$/\" required=\"\"><div ng-messages=\"eventForm.StudentIDNO.$error\" ng-show=\"eventForm.StudentIDNO.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Student No.</span></div><div ng-message=\"pattern\"><span>Please provide valid Student No.</span></div><div ng-message=\"maxlength\"><span>Please provide Student No. with maximum 20 digits</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-show=\"vm.dialogData.type ==\'edit\'\"><label class=\"container-labels\">User ID No.*</label> <input placeholder=\"Student Primary ID.\" ng-maxlength=\"20\" ng-model=\"vm.studentPrimaryID\" ng-disabled=\"true\" ng-pattern=\"/^[a-zA-Z0-9]*$/\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Email*</label> <input type=\"email\" name=\"email\" placeholder=\"Email\" ng-change=\"vm.showEmailError = false\" ng-model=\"vm.dialogData.email\" ng-pattern=\"/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/\" required=\"\"><div ng-messages=\"eventForm.email.$error\" ng-show=\"eventForm.email.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Email</span></div><div ng-message=\"pattern\"><span>Please provide valid Email</span></div></div><div ng-show=\"vm.showEmailError.length > 0 ? true : false\"><span class=\"auto-error\">{{vm.showEmailError}}</span></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Contact-Number</label> <input class=\"g-relative\" name=\"ContactNumber\" type=\"text\" ng-maxlength=\"20\" ng-pattern=\"/^\\(?\\+?[\\d\\(\\-\\s\\)]+$/\" placeholder=\"Contact Number\" ng-model=\"vm.dialogData.contact_number\"><div ng-messages=\"eventForm.ContactNumber.$error\" ng-show=\"eventForm.ContactNumber.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Contact Number</span></div><div ng-message=\"pattern\"><span>Please provide valid no.</span></div><div ng-message=\"maxlength\"><span>Please provide a valid no. with maximum 20 digits</span></div></div><img src=\"/assets/icons/whatsapp-icon.png\" class=\"g-absolute btn-whatsapp\" ng-click=\"vm.btnRedirectToWhatsapp()\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Company-Name</label> <input name=\"CName\" placeholder=\"Company Name\" ng-model=\"vm.dialogData.company_name\"><div ng-messages=\"eventForm.CName.$error\" ng-show=\"eventForm.CName.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Company Name</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Company-Address</label> <input name=\"CAddress\" placeholder=\"Company Address\" ng-model=\"vm.dialogData.company_address\"><div ng-messages=\"eventForm.CAddress.$error\" ng-show=\"eventForm.CAddress.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Company Address</span></div><div ng-message=\"pattern\"><span>Please provide valid Company Address</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Contact-Person No.</label> <input name=\"ContactPerson\" type=\"text\" ng-maxlength=\"20\" ng-pattern=\"/^\\(?\\+?[\\d\\(\\-\\s\\)]+$/\" placeholder=\"Contact-Person\'s No.\" ng-model=\"vm.dialogData.contact_person\"><div ng-messages=\"eventForm.ContactPerson.$error\" ng-show=\"eventForm.ContactPerson.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Contact-Person\'s No.</span></div><div ng-message=\"pattern\"><span>Please provide valid no.</span></div><div ng-message=\"maxlength\"><span>Please provide a valid no. with maximum 20 digits</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container><label class=\"container-labels\">NRIC Number</label> <input name=\"NRIC_number\" placeholder=\"NRIC Number\" ng-model=\"vm.dialogData.nric_no\"></md-input-container></div><div layout-gt-sm=\"row\"><md-checkbox ng-model=\"vm.is_renewal\" ng-change=\"vm.onChangeRenewal(vm.is_renewal);\">Renewal</md-checkbox></div><md-input-container class=\"md-block\" style=\"height: auto;\"><label class=\"container-labels\">Address</label> <textarea ng-model=\"vm.dialogData.address\" columns=\"1\" md-maxlength=\"150\" rows=\"1\" class=\"ng-pristine ng-valid md-input ng-touched\" id=\"input_114\" aria-multiline=\"true\" aria-invalid=\"false\" ng-trim=\"false\" style=\"height: 29px;\">\n                </textarea></md-input-container><md-input-container class=\"md-block\" style=\"height: auto;\"><label class=\"container-labels\">comment</label> <textarea ng-model=\"vm.dialogData.special_requirements\" columns=\"1\" md-maxlength=\"150\" rows=\"1\" class=\"ng-pristine ng-valid md-input ng-touched\" id=\"input_114\" aria-multiline=\"true\" aria-invalid=\"false\" ng-trim=\"false\" style=\"height: 29px;\">\n                </textarea></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" class=\"g-section\"><md-button ng-click=\"vm.onSaveStudentBtnTap($event)\" layout-align=\"start\" class=\"save-button md-accent md-accent_g-green md-raised\" ng-disabled=\"eventForm.$invalid || (vm.showEmailError.length > 0)\" aria-label=\"SAVE\">SAVE</md-button><md-button layout-align=\"start\" ng-click=\"vm.onDuplicateClick(vm.dialogData)\" class=\"save-button md-accent md-raised btn-duplicate\" ng-show=\"vm.dialogData.type != \'add\'\" aria-label=\"Duplicate\">DUPLICATE</md-button><md-button class=\"md-icon-button g-float-right\" ng-click=\"vm.onDeleteBtnTap($event)\" layout-align=\"end\" aria-label=\"Delete\" tabindex=\"-1\" ng-show=\"vm.dialogData.type != \'add\'\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span>Delete</span></md-tooltip></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/students/add-students/show-log-student-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form add-intake\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\" ng-hide=\"(selectList)\"><div ng-repeat=\"errors in vm.dialogData.errors\" layout=\"row\">{{errors}}</div><div ng-repeat=\"messages in vm.dialogData.messages\" layout=\"row\">{{messages}}</div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"g-section\"><md-button ng-click=\"vm.closeDialog()\" class=\"save-button md-accent md-accent_g-green md-raised\">Ok</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/students/filter/student-filter-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Export Student Filters</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"g-relativeResponsiveSet g-absolute container-labels g-positionSet\" for=\"input_155\">Type</label><md-select ng-model=\"vm.selectedCourseType\" class=\"g-setContainer\" placeholder=\"Select Type\"><md-option value=\"\"></md-option><md-option ng-repeat=\"options in vm.courseType\" value=\"{{options.text}}\">{{options.value}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"g-relativeResponsiveSet g-absolute container-labels g-positionSet\" for=\"input_155\">Level</label><md-select ng-model=\"vm.selectedCourseLevel\" class=\"g-setContainer\" placeholder=\"Select Level\"><md-option value=\"\"></md-option><md-option ng-repeat=\"options in vm.courseLevel\" value=\"{{options.value}}\">{{options.value}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"g-relativeResponsiveSet g-absolute container-labels g-positionSet\" for=\"input_155\">Series</label> <input type=\"number\" name=\"Series\" placeholder=\"Series\" ng-model=\"vm.series\" min=\"1\" max=\"1000\" ng-pattern=\"/^(\\d)+$/\" ng-minlength=\"0\" ng-maxlength=\"999\"><div ng-messages=\"eventForm.Series.$error\" ng-show=\"eventForm.Series.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Please provide valid Series</span></div><div ng-message=\"max\"><span>Maximum Series should be 999</span></div><div ng-message=\"min\"><span>Minimum Series should be 1</span></div></div></md-input-container><div class=\"btm-padding md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Start Date</label><md-content class=\"g-overflow_hidden\"><md-datepicker name=\"startDate\" ng-model=\"vm.startDate\" md-placeholder=\"Enter date\"></md-datepicker></md-content></div></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"g-section\"><a target=\"_self\" id=\"btn_export\" href=\"{{vm.setAuthDownloadLink}}get-students-export?auth_token={{vm.setAuthToken}}&classLevel={{vm.selectedCourseLevel}}&classType={{vm.selectedCourseType}}&series={{vm.series}}\" style=\"display:none;\"><md-button class=\"md-accent md-raised md-hue-1 btnred md-button_small\">Export</md-button></a><md-button class=\"md-accent md-raised md-hue-1 btnred md-button_small\" ng-click=\"vm.onSubmitBtnTap()\">{{vm.btnName}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/students/show-certificate/show-certificate-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><table class=\"row-border hover attendance-report_table border-report\" width=\"100%\" ng-show=\"vm.showListing == true\"><thead><tr><th class=\"border-report txt-center\">Courses</th><th class=\"border-report txt-center\">Download</th></tr></thead><tr ng-repeat=\"course in vm.courseObj\"><td class=\"border-report txt-center student-name\">{{course.title}}</td><td class=\"border-report txt-center attendance-report_field\"><a target=\"_self\" href=\"{{vm.setAuthDownloadLink}}download-student-certificate?auth_token={{vm.setAuthToken}}&schedule_class_id={{course.schedule_class_id}}&student_id={{vm.dialogData.studentID}}\" ng-class=\"{\'link_disable\': {{course.isEligible}} == 0 }\"><md-button class=\"md-accent md-raised btnviolet md-hue-1 md-button_small\" ng-disabled=\"{{course.isEligible}} == 0\" aria-label=\"SAVE\">Download</md-button></a></td></tr></table><div layout=\"row\" class=\"title md-block\" ng-show=\"vm.showLabel == true\"><label class=\"g-display_block\">Sorry, no certificate !!</label></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/teachers/add-teachers/add-teachers-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Name*</label> <input name=\"Name\" placeholder=\"Name of Teacher\" ng-model=\"vm.dialogData.full_name\" ng-pattern=\"/^[a-zA-Z,\\s]*$/\" required=\"\"><div ng-messages=\"eventForm.Name.$error\" ng-show=\"eventForm.Name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Name</span></div></div><div ng-messages=\"eventForm.Name.$error\"><div ng-message=\"pattern\"><span>Please provide valid Name</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Email*</label> <input type=\"email\" name=\"email\" placeholder=\"Email\" ng-change=\"vm._onTabEmail()\" ng-pattern=\"/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/\" ng-model=\"vm.dialogData.email\" required=\"\"><div ng-messages=\"eventForm.email.$error\" ng-show=\"eventForm.email.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Email</span></div><div ng-message=\"pattern\"><span>Please provide valid Email</span></div></div><div ng-show=\"vm.showEmailError.length > 0 ? true : false\"><span class=\"auto-error\">{{vm.showEmailError}}</span></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Username</label> <input name=\"UserName\" placeholder=\"Username\" ng-model=\"vm.dialogData.username\"><div ng-messages=\"eventForm.UserName.$error\" ng-show=\"eventForm.UserName.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Username</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Contact-Number*</label> <input name=\"ContactNumber\" type=\"text\" ng-maxlength=\"20\" ng-pattern=\"/^\\(?\\+?[\\d\\(\\-\\s\\)]+$/\" placeholder=\"Contact Number\" ng-model=\"vm.dialogData.contact_number\" required=\"\"><div ng-messages=\"eventForm.ContactNumber.$error\" ng-show=\"eventForm.ContactNumber.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Contact Number</span></div><div ng-message=\"pattern\"><span>Please provide valid no.</span></div><div ng-message=\"maxlength\"><span>Please provide a valid no. with maximum 20 digits</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Pay-Rate</label> <input name=\"Pay\" placeholder=\"Pay rate\" ng-maxlength=\"10\" min=\"1\" ng-pattern=\"/^(\\d)+$/\" type=\"number\" ng-model=\"vm.dialogData.pay_rate\"><div ng-messages=\"eventForm.Pay.$error\" ng-show=\"eventForm.Pay.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Please provide valid Pay rate</span></div><div ng-message=\"min\"><span>Please provide valid Pay rate</span></div><div ng-message=\"maxlength\"><span>Please provide pay-rate within 10 digits</span></div></div><div ng-messages=\"eventForm.Pay.$error\" ng-show=\"eventForm.Pay.$error.number\" role=\"alert\"><div ng-message=\"number\"><span>Please provide a valid Pay-rate</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Joining Date</label><div id=\"datePicker\"><datepicker date-format=\"dd-MM-yyyy\" date-set=\"{{vm.setValue}}\" datepicker-append-to=\"datePicker\"><input ng-model=\"vm.dialogData.start_of_employment\" type=\"text\"></datepicker></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Bank</label> <input name=\"Bank\" placeholder=\"Bank\" ng-model=\"vm.dialogData.bank\"><div ng-messages=\"eventForm.Pay.$error\" ng-show=\"eventForm.Pay.$touched\" role=\"alert\"></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Bank Account</label> <input name=\"Bank Account\" placeholder=\"Bank Account\" ng-model=\"vm.dialogData.bank_account\"><div ng-messages=\"eventForm.Pay.$error\" ng-show=\"eventForm.Pay.$touched\" role=\"alert\"></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Date of birth</label><div id=\"datePicker\"><datepicker date-format=\"dd-MM-yyyy\" date-set=\"{{vm.dateOfBirth}}\" datepicker-append-to=\"datePicker\"><input ng-model=\"vm.dialogData.date_of_birth\" type=\"text\"></datepicker></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-select ng-model=\"vm.dialogData.zones\" class=\"g-setContainer\" placeholder=\"Select Zone\"><md-option ng-repeat=\"options in vm.zones\" value=\"{{options.id}}\">{{options.value}}</md-option></md-select></md-input-container></div><div class=\"position_div\"><label class=\"container-labels\">Position</label><md-chips ng-model=\"vm.dialogData.positions\" md-autocomplete-snap=\"\" md-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"false\" readonly=\"false\" md-removable=\"vm.removable\" md-max-chips=\"3\"><md-autocomplete md-selected-item=\"vm.selectedItem\" md-search-text=\"vm.searchText\" md-items=\"item in vm.positions\" md-item-text=\"item.title\" placeholder=\"Add position\"><span md-highlight-text=\"vm.searchText\">{{item.title}}</span></md-autocomplete><md-chip-template><span><strong>{{$chip.title}}</strong></span></md-chip-template></md-chips></div><label class=\"container-labels\">Skills</label><select ui-select2=\"vm.select2Options\" id=\"myselect\" multiple=\"\" name=\"student\" class=\"md-block slec\" flex-gt-sm=\"\" ng-model=\"vm.dialogData.skills\" data-placeholder=\"+Add Skills\"><option ng-repeat=\"skill in vm.skillobj\" value=\"{{skill.id}}\" class=\"md-block\" flex-gt-sm=\"\">{{skill.name}}</option></select><md-input-container class=\"md-block\" style=\"height: auto;\"><label class=\"container-labels\">Address</label> <textarea ng-model=\"vm.dialogData.address\" name=\"address\" columns=\"1\" md-maxlength=\"350\" maxlength=\"350\" rows=\"1\" class=\"md-input\" id=\"input_114\" aria-multiline=\"true\" aria-invalid=\"false\" ng-trim=\"false\" style=\"height: 29px;\">\n                </textarea><div ng-messages=\"eventForm.address.$error\" ng-show=\"eventForm.address.$error.maxlength\" role=\"alert\"><div ng-message=\"maxlength\"><span>Please provide address within 150 letters.</span></div></div></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" class=\"g-section\"><md-button ng-click=\"vm.onSaveTeacherBtnTap($event)\" layout-align=\"start\" class=\"save-button md-accent md-accent_g-green md-raised\" ng-disabled=\"eventForm.$invalid || (vm.showEmailError.length > 0)\" aria-label=\"SAVE\">SAVE</md-button><md-button layout-align=\"start\" ng-click=\"vm.onDuplicateClick(vm.dialogData)\" class=\"save-button md-accent md-raised btn-duplicate\" ng-show=\"vm.dialogData.type != \'add\'\" aria-label=\"Duplicate\">DUPLICATE</md-button><md-button class=\"md-icon-button g-float-right\" ng-click=\"vm.onDeleteBtnTap($event)\" layout-align=\"end\" aria-label=\"Delete\" tabindex=\"-1\" ng-show=\"vm.dialogData.type != \'add\'\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span>Delete</span></md-tooltip></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/teachers/add-teachers/show-log-teachers-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form add-intake\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Teacher Log</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\" ng-hide=\"(selectList)\"><div ng-repeat=\"errors in vm.dialogData.errors\" layout=\"row\">{{errors}}</div><div ng-repeat=\"messages in vm.dialogData.messages\" layout=\"row\">{{messages}}</div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"g-section\"><md-button ng-click=\"vm.closeDialog()\" class=\"save-button md-accent md-accent_g-green md-raised\">Ok</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/teachers/generate-payslip/generate-payslip-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div layout-gt-sm=\"row\"><div class=\"btm-padding md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">Start Date</label><md-content class=\"g-overflow_hidden\"><md-datepicker name=\"start_date\" ng-model=\"vm.dialogData.start_date\" ng-change=\"vm._onStartDateChange(vm.dialogData.start_date)\" md-placeholder=\"Enter date\" class=\"btm-padding\"></md-datepicker></md-content><div ng-hide=\"eventForm.start_date.$valid\"><span class=\"auto-error\">Please enter valid date</span></div></div><div class=\"btm-padding md-block\" flex-gt-sm=\"\"><label class=\"container-labels\">End Date</label><md-content class=\"g-overflow_hidden\"><md-datepicker ng-model=\"vm.dialogData.end_date\" md-min-date=\"vm.minDate\" ng-change=\"vm._onEndDateChange()\" md-placeholder=\"Enter date\"></md-datepicker></md-content></div></div><table class=\"row-border hover attendance-report_table border-report\" ng-show=\"vm.getResponse == true\" width=\"100%\"><thead><tr><th class=\"border-report txt-center\">Courses</th><th class=\"border-report txt-center\">No. of classes</th><th class=\"border-report txt-center\">Hours</th></tr></thead><tr ng-repeat=\"course in vm.listedCourses\"><td class=\"border-report txt-center student-name\">{{course.title}}</td><td class=\"border-report txt-center student-name\">{{course.no_of_classes}}</td><td class=\"border-report txt-center student-name\">{{course.hours}}</td></tr></table><md-input-container class=\"md-block\" ng-show=\"vm.getResponse == true\"><label class=\"container-labels\">Sub Amount*</label> <input name=\"Fees\" ng-model=\"vm.dialogData.sub_total_amount\" ng-pattern=\"/^[0-9]+$/\" ng-readonly=\"true\"></md-input-container><div ng-show=\"vm.getResponse == true\"><span class=\"title\">Additional Payment</span><div layout=\"row\" ng-repeat=\"obj in vm.dialogData.additional_pay\"><label class=\"report-label\">{{obj.name}}</label> <span class=\"report-container\">{{obj.value}}</span></div></div><div layout=\"row\" ng-show=\"vm.showLabel == true\"><span class=\"title label-name g-display_block\">Sorry, no data to show</span></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-accent md-raised btnviolet md-hue-1 md-button_small\" ng-disabled=\"vm.noData\" ng-click=\"vm.onGenerateSlip()\" aria-label=\"SAVE\">Generate Payslip</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/teachers/note/add-note-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogData.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"padding_contentTop\"><md-dialog-content ms-scroll=\"\"><md-input-container class=\"md-block\"><label class=\"container-labels\">Note*</label> <input name=\"Name\" placeholder=\"Note\" ng-model=\"vm.dialogData.note\" required=\"\"><div ng-messages=\"eventForm.Name.$error\" ng-show=\"eventForm.Name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Note</span></div></div></md-input-container></md-dialog-content></div><md-dialog-actions layout=\"row\" class=\"g-section\"><md-button ng-click=\"vm.onSaveBtnTap($event)\" layout-align=\"start\" class=\"save-button md-accent md-accent_g-green md-raised\" ng-disabled=\"eventForm.$invalid\" aria-label=\"SAVE\">SAVE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/mark-attendance/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\"></span></div></md-toolbar><div layout-gt-sm=\"column\" ng-show=\"vm.userInfo == undefined\"><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Course</label></div><div layout=\"row\" class=\"title md-block email-padding-span\"><span class=\"email-span\">{{full_course_name}}</span></div><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Intake Id</label></div><div layout=\"row\" class=\"title md-block email-padding-span\"><span class=\"email-span\">{{intakeID}}</span></div><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Course Start Date</label></div><div layout=\"row\" class=\"title md-block email-padding-span\"><span class=\"email-span\">{{class_start_date}}</span></div><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Date</label></div><div layout=\"row\" class=\"title md-block email-padding-span\"><span class=\"email-span\">{{schedule_date}}</span></div><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Start Time</label></div><div layout=\"row\" class=\"md-block email-padding-span\"><span layout=\"row\" class=\"email-span\">{{start_time}}</span></div><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Duration</label></div><div layout=\"row\" class=\"md-block email-padding-span\"><span layout=\"row\" class=\"email-span\">{{duration}}</span></div><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Main Trainer</label></div><div layout=\"row\" class=\"md-block email-padding-span\"><span layout=\"row\" class=\"email-span\">{{teacher_name}}</span></div><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Room/Location</label></div><div layout=\"row\" class=\"md-block email-padding-span\"><span layout=\"row\" class=\"email-span\">{{room}}</span></div></div>");
$templateCache.put("app/navigation/layouts/show-attendance/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\"></span></div></md-toolbar><div layout-gt-sm=\"column\" ng-show=\"vm.userInfo == undefined\"><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Course</label></div><div layout=\"row\" class=\"title md-block email-padding-span\"><span class=\"email-span\">{{full_course_name}}</span></div><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Intake Id</label></div><div layout=\"row\" class=\"title md-block email-padding-span\"><span class=\"email-span\">{{intakeID}}</span></div><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Date</label></div><div layout=\"row\" class=\"title md-block email-padding-span\"><span class=\"email-span\">{{schedule_date}}</span></div><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Start Time</label></div><div layout=\"row\" class=\"md-block email-padding-span\"><span layout=\"row\" class=\"email-span\">{{start_time}}</span></div><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Duration</label></div><div layout=\"row\" class=\"md-block email-padding-span\"><span layout=\"row\" class=\"email-span\">{{duration}}</span></div><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Main Trainer</label></div><div layout=\"row\" class=\"md-block email-padding-span\"><span layout=\"row\" class=\"email-span\">{{teacher_name}}</span></div><div layout=\"row\" class=\"title md-block email-padding\"><label class=\"email-title\">Room/Location</label></div><div layout=\"row\" class=\"md-block email-padding-span\"><span layout=\"row\" class=\"email-span\">{{room}}</span></div></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\"></span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide=\"\" show-gt-sm=\"\" ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img ng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div ng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div class=\"md-list-item-text\"><h3 class=\"message text-semibold text-bold\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div></md-list-item></md-list><md-divider></md-divider>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item class=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div ng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div class=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" ng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\"><h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div class=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4><span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" aria-label=\"Call\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon md-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div></div></md-toolbar><md-content flex=\"\" layout-paddings=\"\" ms-scroll=\"\" id=\"chat-dialog\"><div layout=\"row\" ng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img ng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex=\"\"><div class=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content><form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea ng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex=\"\" ng-model=\"vm.replyMessage\" placeholder=\"Type and hit enter to send message\" translate=\"\" translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\"></textarea><md-button class=\"md-fab md-icon-button\" type=\"submit\" aria-label=\"Send message\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form></div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader><md-list-item class=\"md-display-1 md-2-line\" layout=\"column\" layout-align=\"start start\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div layout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 translate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" aria-label=\"Notifications\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\"></md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch class=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\"></span></div><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\"></ms-search-bar><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon=\"\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs=\"\">John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs=\"\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"navigation-toggle\" hide-gt-sm=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" aria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\"></span></div><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><ms-search-bar on-search=\"vm.search(query)\"></ms-search-bar><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon=\"\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs=\"\">John Doedf</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs=\"\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/toolbar/layouts/mark-attendance/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex=\"\"><md-button id=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm=\"\" aria-label=\"Toggle navigation\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"toolbar-separator\"></div><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><md-menu-bar><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"></div><span class=\"username username-email\" hide-xs=\"\">{{ teacher_name }}</span></div></md-menu-bar><div class=\"toolbar-separator\"></div></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex=\"\"><md-button id=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm=\"\" aria-label=\"Toggle navigation\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\"></ms-search-bar><div class=\"toolbar-separator\"></div><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><md-menu-bar id=\"user-menu\" ng-show=\"vm.userInfo != undefined\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"></div><span class=\"username\" hide-xs=\"\">{{ vm.userInfo.full_name }}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16 colr_white\" hide-xs=\"\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ng-if=\"vm.userInfo.role_id == 1\"><md-icon md-font-icon=\"icon-sync\" class=\"icon\"></md-icon><md-button ng-click=\"vm.syncXero()\">Xero connect</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" aria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul class=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" ng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script type=\"text/ng-template\" id=\"navigation-horizontal-nested.html\"><div ms-navigation-horizontal-item layout=\"row\"> <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\" ng-class=\"{\'active md-accent-bg\': vm.isActive}\"> <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i> </div> <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\" ng-class=\"{\'active md-accent-bg\': vm.isActive}\" ng-if=\"node.uisref && node.title\"> <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i> </a> </div> <ul ng-if=\"vm.hasChildren\"> <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\" ng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li> </ul></script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul><script type=\"text/ng-template\" id=\"navigation-nested.html\"><div ms-navigation-item layout=\"row\"> <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\"> <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i> </div> <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\" ng-if=\"node.uisref && node.title\"> <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i> </a> </div> <ul ng-if=\"vm.hasChildren\"> <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\" ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li> </ul></script>");
$templateCache.put("app/main/pages/auth/admission/admission.html","<div id=\"admission\" class=\"flex-scrollable\" layout=\"column\" ng-if=\"vm.courseType == \'G\' || vm.courseType == \'O\'\"><div class=\"admission-header\"><div class=\"header-image\"><img src=\"{{vm.imgPath}}\" alt=\"logo not found\"></div></div><div class=\"admission-content\"><div ng-show=\"vm.isForm1Visible\"><div class=\"form-title\">Enrolment Form – {{vm.dialogData.course_name}} Group Class</div><div class=\"form-info\" id=\"a2\">To apply, please complete the application form and click Submit.</div><div class=\"form-level\"><div class=\"level-header\">Select your Level</div><dir class=\"level-radiobox\"><form class=\"md-inline-form\"><md-radio-group ng-model=\"vm.dialogData.level\"><div ng-repeat=\"item in vm.courseImageData.levels\" class=\"radio-format\"><label ng-click=\"vm.getData()\"><md-radio-button value=\"{{item}}\">{{item}}</md-radio-button></label></div></md-radio-group></form></dir></div><div class=\"empty-table\" ng-show=\"vm.blankLevel\">Please select your level</div><div class=\"form-table\"><div class=\"table-header\">Select your Intake Start Date</div><table><thead><tr><th>Courses</th><th>Term</th><th>Start Date</th><th>End Date</th><th>Start Time</th><th>End Time</th><th>Days</th><th>Course Fee</th><th>Registration and Material fees</th><th>TAX (GST)</th><th>Total</th></tr></thead><tr ng-repeat=\"item in vm.courseData\"><td><md-radio-group ng-model=\"vm.dialogData.scheduleClassID\" ng-click=\"vm.selectCourse()\"><md-radio-button value=\"{{item.scheduleClassID}}\">{{item.courseName}}-{{vm.dialogData.level}}-{{vm.courseType}}</md-radio-button></md-radio-group></td><td>{{item.intake_term}}</td><td>{{item.start_date}}</td><td>{{item.end_date}}</td><td>{{item.start_time}}</td><td>{{item.end_time}}</td><td>{{item.classDays}}</td><td>{{vm.country.country.currency.code}} {{item.courseCost * vm.currency_rate | number : 2}}</td><td>{{vm.country.country.currency.code}} {{item.course_admin_fee * vm.currency_rate | number : 2}}</td><td>{{vm.country.country.currency.code}} {{item.courseTax * vm.currency_rate | number : 2}}</td><td>{{vm.country.country.currency.code}} {{item.courseTotalCost * vm.currency_rate | number : 2}}</td></tr></table><div class=\"empty-table\" ng-hide=\"vm.blankTableMessage\">Note :<div>- You do not need to pay GST if you are taking an online program and are not residing in Singapore.</div><div>- The time displayed is based on your local time zone.</div><div>- Prices are displayed in your local currency for reference. Payments will be charged in SGD. The precise amount charged can vary based on the exchange rate.</div></div><div class=\"empty-table\" ng-show=\"vm.blankTableMessage\">There are no intakes available that match the criteria you selected. If you are sure there should be<div>something, please give us a call at: &lt;+65 6222 0583&gt; or email us at <a href=\"mailto:class@crystal.com.sg\">class@crystal.com.sg.</a></div></div><div class=\"empty-table\" ng-show=\"vm.selectStartDate\">Please select intake start date</div></div><div class=\"btn-submit redirect-to-next\"><button type=\"button\" ng-click=\"vm.disable1();\">CONTINUE</button></div></div><div ng-show=\"vm.isForm2Visible\"><div class=\"form-title\">Enrolment Form – {{vm.dialogData.course_name}} Group Class</div><div class=\"form-info\">To apply, please complete the application form and click Submit.</div><div class=\"btn-submit\"><button type=\"button\" class=\"btn-back\" ng-click=\"vm.showForm();\">< BACK TO PREVIOUS STEP</button></div><div class=\"admission-register\"><div class=\"admission-register__header\">Applicant’s Particulars</div><div class=\"admission-register__form\"><div><form name=\"eventForm\" class=\"md-inline-form\" ng-submit=\"vm.addRecord(eventForm, companyForm);\" novalidate=\"\"><md-input-container class=\"md-block\" flex-lg=\"50\" flex-sm=\"100\" flex-xs=\"100\" layout-sm=\"\" md-no-float=\"\"><label>Name of Applicant (as per NRIC/Passport)*</label> <input name=\"Name\" placeholder=\"Your name\" md-no-float=\"\" ng-pattern=\"/^[a-zA-Z\\s]+[0-9!@#\\$%\\^\\&*\\)\\(+=._-]*$/\" ng-model=\"vm.dialogData.full_name\" ng-blur=\"vm.onEmailChange()\" ng-change=\"vm.onEmailChange()\" required=\"\"><div ng-messages=\"eventForm.Name.$error\" ng-show=\"eventForm.Name.$touched || vm.submitted == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"eventForm.Name.$error.required\"><span class=\"validation-error\">Please provide name</span></div><div ng-message=\"pattern\"><span class=\"validation-error\">Please provide valid name</span></div><div ng-message=\"true\"><span class=\"validation-error\">Please provide name</span></div></div></md-input-container><md-input-container class=\"md-block form-input\" flex=\"20\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><label>Contact No.*</label> <input name=\"ContactNo\" type=\"text\" placeholder=\"Your contact no.\" ng-model=\"vm.dialogData.contact_number\" flex=\"\" required=\"\"><div ng-messages=\"eventForm.ContactNo.$error\" ng-show=\"eventForm.ContactNo.$touched || (eventForm.ContactNo.$dirty && eventForm.ContactNo.$invalid) || vm.submitted == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"eventForm.ContactNo.$error.required\"><span class=\"validation-error\">Please provide number</span></div><div ng-message=\"pattern\"><span class=\"validation-error\">Please provide valid number</span></div></div></md-input-container><md-input-container class=\"md-block form-input\" flex=\"30\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><label>Email Address *</label> <input name=\"Email\" type=\"email\" placeholder=\"Your email address\" ng-focus=\"vm.duplicateStudentEmail = false\" ng-model=\"vm.dialogData.email\" ng-pattern=\"/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/\" ng-blur=\"vm.onEmailChange()\" ng-change=\"vm.onEmailChange()\" md-no-float=\"\" required=\"\"><div ng-messages=\"eventForm.Email.$error\" ng-show=\"eventForm.Email.$touched || (eventForm.Email.$dirty && eventForm.Email.$invalid) || vm.submitted == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"eventForm.Email.$error.required\"><span class=\"validation-error\">Please provide email</span></div><div ng-message=\"pattern\"><span class=\"validation-error\">Please provide valid email</span></div><div ng-show=\"vm.duplicateStudentEmail == true\"><span class=\"validation-error\">Email already taken</span></div></div></md-input-container><md-input-container class=\"md-block form-input\" flex=\"90\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><label>Address *</label> <input name=\"Address\" placeholder=\"Your mailing address\" ng-model=\"vm.dialogData.address\" required=\"\"><div ng-messages=\"eventForm.Address.$error\" ng-show=\"eventForm.Address.$touched || (eventForm.Address.$dirty && eventForm.Address.$invalid) || vm.submitted == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"eventForm.Address.$error.required\"><span class=\"validation-error\">Please provide address</span></div></div></md-input-container><div class=\"checkbox-notice\">Please check the options below only if it is applicable to you.</div><div layout-gt-sm=\"row\" class=\"form-checkbox\"><md-checkbox ng-model=\"vm.is_company\" md-no-float=\"\" ng-change=\"vm.onChangeCompany(vm.is_company)\" aria-label=\"Flexible\">My company will pay for my course</md-checkbox></div></form><div ng-show=\"vm.companyData\"><form name=\"companyForm\" class=\"md-inline-form\" ng-submit=\"vm.addRecord(eventForm, companyForm);\" novalidate=\"\"><md-input-container class=\"md-block form-input\" flex=\"50\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><label>Company Name*</label> <input name=\"CompanyName\" placeholder=\"Your company name\" ng-model=\"vm.dialogData.company_name\" ng-required=\"vm.companyRequired\"><div ng-messages=\"companyForm.CompanyName.$error\" ng-show=\"companyForm.CompanyName.$touched || vm.submittedCompany == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"companyForm.CompanyName.$error\"><span class=\"validation-error\">Please provide company name</span></div></div></md-input-container><md-input-container class=\"md-block form-input\" flex=\"90\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><label>Company Address.*</label> <input name=\"CompanyAddress\" placeholder=\"Your company address\" ng-model=\"vm.dialogData.company_address\" ng-required=\"vm.companyRequired\"><div ng-messages=\"companyForm.CompanyAddress.$error\" ng-show=\"companyForm.CompanyAddress.$touched || vm.submittedCompany == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"companyForm.CompanyAddress.$error\"><span class=\"validation-error\">Please provide company address</span></div></div></md-input-container><md-input-container class=\"md-block form-input\" flex=\"35\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><label>Contact Person No.*</label> <input name=\"ContactPersonNo\" type=\"number\" placeholder=\"Contact no. of person in charge\" ng-model=\"vm.dialogData.contact_person\" ng-required=\"vm.companyRequired\"><div ng-messages=\"companyForm.ContactPersonNo.$error\" ng-show=\"companyForm.ContactPersonNo.$touched || vm.submittedCompany == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"companyForm.ContactPersonNo.$error.required\"><span class=\"validation-error\">Please provide Contact Person No</span></div></div></md-input-container></form></div><div layout-gt-sm=\"row\" class=\"form-checkbox\"><md-checkbox ng-model=\"vm.is_renewal\" ng-change=\"vm.onChangeRenewal(vm.is_renewal);\">I have studied with the school before</md-checkbox></div><div class=\"form-fields\"><md-checkbox name=\"servicePolicy\" ng-model=\"vm.dialogData.group_service_policy\" required=\"\"><textarea class=\"terms\" readonly=\"\">\n                                        1) Course fees are payable before the start of class.\n\n                                        2) All fees are non-refundable.\n\n                                        3) Group classes\n                                        - Courses must be completed within 3 months.\n                                        - Makeup classes can be arranged with your respective trainer if you miss a class.\n                                        - Students are only allowed to schedule a maximum of 2 makeup classes each term. This is to maintain learning quality and discourage absences from class.\n                                        - Makeup classes will be charged at $30.00 per hour per student.\n                                        - Makeup classes are to be scheduled before the final lesson of the term.\n                                        - The makeup class is usually scheduled 1 hour before the next class.\n                                        - Students only require 1 hour of makeup lesson for every regular class missed.\n                                        - Makeup lessons are optional.\n                                        - Makeup class fee is to be paid in full at least 1 day before the scheduled makeup class. If no payment is received, the makeup class will not be conducted.\n                                        - For 1 to 2 students, makeup is at $30.00 per hour per student.\n                                        - For 3 to 4 students, makeup is at $30.00 for 2 hours per student. (Makeup classes will be set at 2hrs if there are 3 or 4 students)\n\n                                        4) Intensive classes\n                                        - Courses must be completed within 1 month.\n                                        - Each class must be a minimum of 2 hours.\n                                        - Rescheduling of classes must be arranged and agreed between trainer and student at least 24 hours beforehand, otherwise, the class will be considered consumed.\n\n                                        5) Private classes\n                                        - Courses must be completed within 7 months, unless otherwise specified.\n                                        - Each class must be a minimum of 2 hours.\n                                        - Rescheduling of classes must be arranged and agreed between trainer and student at least 24 hours beforehand, otherwise, the class will be considered consumed.\n                                        - Transport surcharge of $30/class applies for locations more than 150 meters from the nearest MRT.\n                                        - Every lesson should be planned with all students attending if the class is a Private Group of 2 or more.\n\n                                        6) Corporate Training\n                                        - Please refer to quotation proposed.\n\n                                        7) Certification\n                                        - A Letter of Completion (softcopy) for each Term will be sent to the student\'s email with at least 80% attendance achieved.\n                                        - The Letter of Completion can be physically printed for a charge of $5 per Letter/Certificate.\n                                        - Once printed and ready, the Letter of Completion can be collected over our counter between Mondays to Fridays, 11am-6pm.\n\n                                        8) Crystal Learning Centre reserves the rights to alter, augment or reduce our proprietary syllabus to improve learning quality.\n\n                                        9) Crystal Learning Centre reserves the rights to postpone the start of class, with prior notice, if there are insufficient students.\n                                    </textarea></md-checkbox><div ng-show=\"vm.groupServicePolicyError\" layout-gt-sm=\"row\" flex=\"30\"><span class=\"validation-error\">Please accept service policies</span></div></div><div class=\"btn-submit\"><button type=\"submit\" ng-click=\"vm.addRecord(eventForm, companyForm)\">SUBMIT</button></div></div></div></div></div></div></div><div id=\"admission\" class=\"flex-scrollable\" layout=\"column\" ng-if=\"vm.courseType == \'P\'\"><div class=\"admission-header\"><div class=\"header-image\"><img src=\"../images/crystal-learning.png\" alt=\"logo not found\"></div></div><div class=\"admission-content\"><div ng-show=\"vm.isForm1Visible\"><div class=\"form-title\">Enrolment Form – {{vm.dialogData.course_name}} Private Class</div><div class=\"form-info\">To apply, please complete the application form and click Submit.</div><div class=\"form-level\"><div class=\"level-header\">Select your Level</div><dir class=\"level-radiobox\"><form class=\"md-inline-form\"><md-radio-group ng-model=\"vm.dialogData.level\"><div ng-repeat=\"item in vm.courseImageData.levels\" class=\"radio-format\"><md-radio-button value=\"{{item}}\">{{item}}</md-radio-button></div></md-radio-group></form></dir></div><div class=\"admission-register\"><div class=\"admission-register__header\">Applicant’s Particulars</div><div class=\"admission-register__form\"><div><form name=\"eventForm\" class=\"md-inline-form\" ng-submit=\"vm.addRecord(eventForm, companyForm);\" novalidate=\"\"><md-input-container class=\"md-block\" flex=\"50\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><label>Name of Applicant (as per NRIC/Passport)*</label> <input name=\"Name\" placeholder=\"Your name\" md-no-float=\"\" ng-pattern=\"/^[a-zA-Z\\s]+[0-9!@#\\$%\\^\\&*\\)\\(+=._-]*$/\" ng-model=\"vm.dialogData.full_name\" required=\"\"><div ng-messages=\"eventForm.Name.$error\" ng-show=\"eventForm.Name.$touched || vm.submitted == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"eventForm.Name.$error.required\"><span class=\"validation-error\">Please provide name</span></div><div ng-message=\"pattern\"><span class=\"validation-error\">Please provide valid name</span></div><div ng-message=\"true\"><span class=\"validation-error\">Please provide name</span></div></div></md-input-container><md-input-container class=\"md-block form-input\" flex=\"20\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><label>Contact No.*</label> <input name=\"ContactNo\" type=\"text\" placeholder=\"Your contact no.\" ng-model=\"vm.dialogData.contact_number\" required=\"\"><div ng-messages=\"eventForm.ContactNo.$error\" ng-show=\"eventForm.ContactNo.$touched || (eventForm.ContactNo.$dirty && eventForm.ContactNo.$invalid) || vm.submitted == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"eventForm.ContactNo.$error.required\"><span class=\"validation-error\">Please provide number</span></div><div ng-message=\"pattern\"><span class=\"validation-error\">Please provide valid number</span></div></div></md-input-container><md-input-container class=\"md-block form-input\" flex=\"30\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><label>Email Address *</label> <input name=\"Email\" type=\"email\" placeholder=\"Your email address\" ng-model=\"vm.dialogData.email\" ng-focus=\"vm.duplicateStudentEmail = false\" ng-pattern=\"/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/\" md-no-float=\"\" required=\"\"><div ng-messages=\"eventForm.Email.$error\" ng-show=\"eventForm.Email.$touched || (eventForm.Email.$dirty && eventForm.Email.$invalid) || vm.submitted == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"eventForm.Email.$error.required\"><span class=\"validation-error\">Please provide email</span></div><div ng-message=\"pattern\"><span class=\"validation-error\">Please provide valid email</span></div><div ng-show=\"vm.duplicateStudentEmail == true\"><span class=\"validation-error\">Email already taken</span></div></div></md-input-container><md-input-container class=\"md-block form-input\" flex=\"90\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><label>Address *</label> <input name=\"Address\" placeholder=\"Your mailing address\" ng-model=\"vm.dialogData.address\" required=\"\"><div ng-messages=\"eventForm.Address.$error\" ng-show=\"eventForm.Address.$touched || (eventForm.Address.$dirty && eventForm.Address.$invalid) || vm.submitted == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"eventForm.Address.$error.required\"><span class=\"validation-error\">Please provide address</span></div></div></md-input-container><div class=\"checkbox-notice\">Please check the options below only if it is applicable to you.</div><div layout-gt-sm=\"row\" class=\"form-checkbox\"><md-checkbox ng-model=\"vm.is_company\" md-no-float=\"\" ng-change=\"vm.onChangeCompany(vm.is_company)\" aria-label=\"Flexible\">My company will pay for my course</md-checkbox></div></form><div ng-show=\"vm.companyData\"><form name=\"companyForm\" class=\"md-inline-form\" ng-submit=\"vm.addRecord(eventForm, companyForm);\" novalidate=\"\"><md-input-container class=\"md-block form-input\" flex=\"50\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><label>Company Name*</label> <input name=\"CompanyName\" placeholder=\"Your company name\" ng-model=\"vm.dialogData.company_name\" ng-required=\"vm.companyRequired\"><div ng-messages=\"companyForm.CompanyName.$error\" ng-show=\"companyForm.CompanyName.$touched || vm.submittedCompany == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"companyForm.CompanyName.$error\"><span class=\"validation-error\">Please provide company name</span></div></div></md-input-container><md-input-container class=\"md-block form-input\" flex=\"90\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><label>Company Address.*</label> <input name=\"CompanyAddress\" placeholder=\"Your company address\" ng-model=\"vm.dialogData.company_address\" ng-required=\"vm.companyRequired\"><div ng-messages=\"companyForm.CompanyAddress.$error\" ng-show=\"companyForm.CompanyAddress.$touched || vm.submittedCompany == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"companyForm.CompanyAddress.$error\"><span class=\"validation-error\">Please provide company address</span></div></div></md-input-container><md-input-container class=\"md-block form-input\" flex=\"35\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><label>Contact Person No.*</label> <input name=\"ContactPersonNo\" type=\"number\" placeholder=\"Contact no. of person in charge\" ng-model=\"vm.dialogData.contact_person\" ng-required=\"vm.companyRequired\"><div ng-messages=\"companyForm.ContactPersonNo.$error\" ng-show=\"companyForm.ContactPersonNo.$touched || vm.submittedCompany == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"companyForm.ContactPersonNo.$error.required\"><span class=\"validation-error\">Please provide Contact Person No</span></div></div></md-input-container></form></div><div layout-gt-sm=\"row\" class=\"form-checkbox\"><md-checkbox ng-model=\"vm.is_renewal\" ng-change=\"vm.onChangeRenewal(vm.is_renewal);\">I have studied with the school before</md-checkbox></div></div></div><div class=\"btn-submit\"><button type=\"button\" ng-click=\"vm.CheckPrivateForm(eventForm, companyForm);\">CONTINUE</button></div></div></div><div ng-show=\"vm.isForm2Visible\"><div class=\"form-title\">Enrolment Form – {{vm.dialogData.course_name}} Private Class</div><div class=\"form-info\">To apply, please complete the application form and click Submit.</div><div class=\"btn-submit\"><button type=\"button\" class=\"btn-back\" ng-click=\"vm.showForm();\">< BACK TO PREVIOUS STEP</button></div><form name=\"eventForm3\" class=\"md-inline-form\" ng-submit=\"vm.checkCheckboxLength(eventForm, companyForm, eventForm3);\" novalidate=\"\"><div class=\"form-select-day\"><div class=\"form-select-day__header\">Select your Preferred Class Day (you may select more than one)</div><div class=\"form-select-day__checkbox\"><div ng-repeat=\"day in vm.days\"><md-checkbox aria-label=\"{{day.bAllow?\'false\':\'true\'}}\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\' || vm.dialogData.noneditable == \'noneditable\'\" ng-change=\"vm.ToggleCheckbox($event, day)\" ng-model=\"day.bAllow\" ng-readonly=\"vm.dialogData.showTypeDialog == \'info\'\"><label>{{day.day}}</label></md-checkbox></div></div></div><div ng-show=\"vm.selectDay\" layout-gt-sm=\"row\" flex=\"30\"><span class=\"validation-error\">Please Select Day</span></div><div class=\"form-select-time\"><div class=\"form-select-time__header\">Select your Preferred Class Timing (you may select more than one)</div><div class=\"form-select-time__checkbox\"><div class=\"row\"><div class=\"col-3\"><div layout-gt-sm=\"row\"><md-checkbox aria-label=\"{{vm.timeslot1[0].bAllow?\'false\':\'true\'}}\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\' || vm.dialogData.noneditable == \'noneditable\'\" ng-change=\"vm.ToggleTime1Checkbox($event, time)\" ng-model=\"vm.timeslot1[0].bAllow\" ng-readonly=\"vm.dialogData.showTypeDialog == \'info\'\"><label>{{vm.timeslot1[0].time}}</label></md-checkbox></div><div layout-gt-sm=\"row\"><md-checkbox aria-label=\"{{vm.timeslot1[3].bAllow?\'false\':\'true\'}}\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\' || vm.dialogData.noneditable == \'noneditable\'\" ng-change=\"vm.ToggleTime1Checkbox($event, time)\" ng-model=\"vm.timeslot1[3].bAllow\" ng-readonly=\"vm.dialogData.showTypeDialog == \'info\'\"><label>{{vm.timeslot1[3].time}}</label></md-checkbox></div><div layout-gt-sm=\"row\"><md-checkbox aria-label=\"{{vm.timeslot1[5].bAllow?\'false\':\'true\'}}\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\' || vm.dialogData.noneditable == \'noneditable\'\" ng-change=\"vm.ToggleTime1Checkbox($event, time)\" ng-model=\"vm.timeslot1[5].bAllow\" ng-readonly=\"vm.dialogData.showTypeDialog == \'info\'\"><label>{{vm.timeslot1[5].time}}</label></md-checkbox></div><div layout-gt-sm=\"row\"><md-checkbox aria-label=\"{{vm.timeslot1[7].bAllow?\'false\':\'true\'}}\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\' || vm.dialogData.noneditable == \'noneditable\'\" ng-change=\"vm.ToggleTime1Checkbox($event, time)\" ng-model=\"vm.timeslot1[7].bAllow\" ng-readonly=\"vm.dialogData.showTypeDialog == \'info\'\"><label>{{vm.timeslot1[7].time}}</label></md-checkbox></div></div><div class=\"col-3\"><div layout-gt-sm=\"row\"><md-checkbox aria-label=\"{{vm.timeslot1[1].bAllow?\'false\':\'true\'}}\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\' || vm.dialogData.noneditable == \'noneditable\'\" ng-change=\"vm.ToggleTime1Checkbox($event, time)\" ng-model=\"vm.timeslot1[1].bAllow\" ng-readonly=\"vm.dialogData.showTypeDialog == \'info\'\"><label>{{vm.timeslot1[1].time}}</label></md-checkbox></div><div layout-gt-sm=\"row\"><md-checkbox aria-label=\"{{vm.timeslot1[4].bAllow?\'false\':\'true\'}}\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\' || vm.dialogData.noneditable == \'noneditable\'\" ng-change=\"vm.ToggleTime1Checkbox($event, time)\" ng-model=\"vm.timeslot1[4].bAllow\" ng-readonly=\"vm.dialogData.showTypeDialog == \'info\'\"><label>{{vm.timeslot1[4].time}}</label></md-checkbox></div><div layout-gt-sm=\"row\"><md-checkbox aria-label=\"{{vm.timeslot1[6].bAllow?\'false\':\'true\'}}\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\' || vm.dialogData.noneditable == \'noneditable\'\" ng-change=\"vm.ToggleTime1Checkbox($event, time)\" ng-model=\"vm.timeslot1[6].bAllow\" ng-readonly=\"vm.dialogData.showTypeDialog == \'info\'\"><label>{{vm.timeslot1[6].time}}</label></md-checkbox></div></div><div class=\"col-3\"><div layout-gt-sm=\"row\"><md-checkbox aria-label=\"{{vm.timeslot1[2].bAllow?\'false\':\'true\'}}\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\' || vm.dialogData.noneditable == \'noneditable\'\" ng-change=\"vm.ToggleTime1Checkbox($event, time)\" ng-model=\"vm.timeslot1[2].bAllow\" ng-readonly=\"vm.dialogData.showTypeDialog == \'info\'\"><label>{{vm.timeslot1[2].time}}</label></md-checkbox></div></div></div></div></div><div ng-show=\"vm.userTime\"><div class=\"user-time\"><select ui-select2=\"vm.select2Options\" id=\"myselect\" multiple=\"\" name=\"student\" class=\"md-block slec\" flex-gt-sm=\"\" ng-model=\"vm.timepicker\" data-placeholder=\"+Add Time\" width=\"50%\"><option ng-repeat=\"timeSlot in vm.timeslot2\" value=\"{{timeSlot.time}}\" class=\"md-block\" flex-gt-sm=\"\">{{timeSlot.time}}</option></select></div></div><div ng-show=\"vm.selectTime\" layout-gt-sm=\"row\" flex=\"30\" class=\"empty-table\"><span class=\"validation-error\">Please Select Time</span></div><md-input-container class=\"md-block form-input form-fields\" flex=\"20\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><div class=\"form-fields__header\">Number of students</div><input name=\"NumberOfStudents\" type=\"number\" ng-min=\"1\" ng-max=\"9\" class=\"text-field\" placeholder=\"Number of students\" ng-model=\"vm.dialogData.no_of_students\" flex=\"\" required=\"\"><div ng-messages=\"eventForm3.NumberOfStudents.$error\" ng-show=\"eventForm3.NumberOfStudents.$touched || (eventForm3.NumberOfStudents.$dirty && eventForm3.NumberOfStudents.$invalid) || vm.submitted == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"eventForm3.NumberOfStudents.$error.required\"><span class=\"validation-error\">Please provide number of students</span></div><div ng-message=\"max\" ng-show=\"eventForm3.NumberOfStudents.$error.number\"><span class=\"validation-error\">Please provide valid number of students</span></div><div ng-message=\"min\" ng-show=\"eventForm3.NumberOfStudents.$error.number\"><span class=\"validation-error\">Please provide valid number of students</span></div></div></md-input-container><div class=\"form-fields\"><div class=\"form-fields__header\">Study location</div><div class=\"level-radiobox\"><md-radio-group ng-model=\"vm.studyLocation\" ng-change=\"vm.onChangeStudyLocation()\" name=\"studyLocation\" required=\"\"><div class=\"radio-format\"><md-radio-button value=\"Same as Address\">Same as Address</md-radio-button></div><div class=\"radio-format\"><md-radio-button value=\"Crystal Learning Centre\">Crystal Learning Centre</md-radio-button></div><div class=\"radio-format\"><md-radio-button value=\"Others\">Others</md-radio-button></div></md-radio-group><div ng-messages=\"eventForm3.studyLocation.$error\" ng-show=\"eventForm3.studyLocation.$touched || (eventForm3.studyLocation.$dirty && eventForm3.studyLocation.$invalid) || vm.submitted == true\" role=\"alert\" class=\"g-error-top\"><div ng-message=\"required\" ng-show=\"eventForm3.studyLocation.$error.required\"><span class=\"validation-error\">Please provide study location</span></div></div></div></div><div ng-show=\"vm.showOtherStudyLocation\"><md-input-container class=\"md-block\" flex=\"50\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><input name=\"otherStudyLocation\" type=\"text\" class=\"text-field\" placeholder=\"Study location\" ng-model=\"vm.otherStudyLocation\" required=\"\"></md-input-container><div ng-messages=\"eventForm3.otherStudyLocation.$error\" ng-show=\"eventForm3.otherStudyLocation.$touched || (eventForm3.otherStudyLocation.$dirty && eventForm3.otherStudyLocation.$invalid) || vm.submitted == true\" role=\"alert\" class=\"g-error-top\"><div ng-message=\"required\" ng-show=\"eventForm3.otherStudyLocation.$error.required\"><span class=\"validation-error\">Please provide study location</span></div></div></div><div class=\"form-fields\"><div class=\"form-fields__header\">Lesson duration</div><div class=\"level-radiobox\"><md-radio-group ng-model=\"vm.lessonDuration\" ng-change=\"vm.onChangeLessonDuration()\" name=\"lessonDuration\" required=\"\"><div class=\"radio-format\"><md-radio-button value=\"1.5 hours\">1.5 hours</md-radio-button></div><div class=\"radio-format\"><md-radio-button value=\"2 hours\">2 hours</md-radio-button></div><div class=\"radio-format\"><md-radio-button value=\"Others\">Others</md-radio-button></div></md-radio-group></div><div ng-messages=\"eventForm3.lessonDuration.$error\" ng-show=\"eventForm3.lessonDuration.$touched || (eventForm3.lessonDuration.$dirty && eventForm3.lessonDuration.$invalid) || vm.submitted == true\" role=\"alert\" class=\"g-error-top\"><div ng-message=\"required\" ng-show=\"eventForm3.lessonDuration.$error.required\"><span class=\"validation-error\">Please provide lesson duration</span></div></div></div><div ng-show=\"vm.showOtherLessonDuration\"><select ui-select2=\"vm.select2Options\" name=\"otherLessonDuration\" multiple=\"\" class=\"md-block text-field\" flex-gt-sm=\"\" ng-model=\"vm.otherLessonDuration\" data-placeholder=\"+Add lesson duration\" width=\"50%\" required=\"\"><option ng-repeat=\"durationValue in vm.arrLessonDuration\" value=\"{{durationValue.duration}}\" class=\"md-block\" flex-gt-sm=\"\">{{durationValue.duration}}</option></select><div ng-messages=\"eventForm3.otherLessonDuration.$error\" ng-show=\"eventForm3.otherLessonDuration.$touched || (eventForm3.otherLessonDuration.$dirty && eventForm3.otherLessonDuration.$invalid) || vm.submitted == true\" role=\"alert\" class=\"g-error-top\"><div ng-message=\"required\" ng-show=\"eventForm3.otherLessonDuration.$error.required\"><span class=\"validation-error\">Please provide lesson duration</span></div></div></div><div class=\"form-fields\"><div class=\"form-fields__header\">Study frequency</div><div class=\"level-radiobox\"><md-radio-group ng-model=\"vm.studyFrequency\" ng-change=\"vm.onChangeStudyFrequency()\" name=\"studyFrequency\" required=\"\"><div class=\"radio-format\"><md-radio-button value=\"Daily\">Daily</md-radio-button></div><div class=\"radio-format\"><md-radio-button value=\"1x per week\">1x per week</md-radio-button></div><div class=\"radio-format\"><md-radio-button value=\"2x per week\">2x per week</md-radio-button></div><div class=\"radio-format\"><md-radio-button value=\"Others\">Others</md-radio-button></div></md-radio-group></div><div ng-messages=\"eventForm3.studyFrequency.$error\" ng-show=\"eventForm3.studyFrequency.$touched || (eventForm3.studyFrequency.$dirty && eventForm3.studyFrequency.$invalid) || vm.submitted == true\" role=\"alert\" class=\"g-error-top\"><div ng-message=\"required\" ng-show=\"eventForm3.studyFrequency.$error.required\"><span class=\"validation-error\">Please provide study frequency</span></div></div></div><div ng-show=\"vm.showOtherStudyFrequency\"><select ui-select2=\"vm.select2Options\" name=\"otherStudyFrequency\" multiple=\"\" class=\"md-block text-field\" flex-gt-sm=\"\" ng-model=\"vm.otherStudyFrequency\" data-placeholder=\"+Add study frequency\" width=\"50%\" required=\"\"><option ng-repeat=\"frequencyValue in vm.arrStudyFrequency\" value=\"{{frequencyValue.frequency}}\" class=\"md-block\" flex-gt-sm=\"\">{{frequencyValue.frequency}}</option></select><div ng-messages=\"eventForm3.otherStudyFrequency.$error\" ng-show=\"eventForm3.otherStudyFrequency.$touched || (eventForm3.otherStudyFrequency.$dirty && eventForm3.otherStudyFrequency.$invalid) || vm.submitted == true\" role=\"alert\" class=\"g-error-top\"><div ng-message=\"required\" ng-show=\"eventForm3.otherStudyFrequency.$error.required\"><span class=\"validation-error\">Please provide study frequency</span></div></div></div><div class=\"form-fields\"><md-checkbox name=\"servicePolicy\" ng-model=\"vm.dialogData.service_policy\" required=\"\"><textarea class=\"terms\" readonly=\"\">\n                                1) Course fees are payable before start of class.\n\n                                2) All fees are non-refundable.\n\n                                3) Group classes\n                                - Courses must be completed within 3 months.\n                                - Make-up classes can be arranged with trainer at S$30/hour. Usually 1 hour before the next class is sufficient if a 2 hours class is missed.\n                                - Only 2 hours of make-up classes are allowed per course. This is to discourage absence, and to maintain learning quality.\n\n                                4) Intensive classes\n                                - Courses must be completed within 1 month.\n                                - Each class must be a minimum of 2 hours.\n                                - Re scheduling of classes must be arranged and agreed between trainer and student at least 24 hours beforehand, otherwise the class will be considered consumed.\n\n                                5) Private classes\n                                - Courses must be completed within 9 months, unless specified otherwise.\n                                - Each class must be a minimum of 2 hours.\n                                - Re scheduling of classes must be arranged and agreed between trainer and student at least 24 hours beforehand, otherwise the class will be considered consumed.<br>\n                                - Transport surcharge applies for inaccessible areas by public transport.\n\n                                6) Corporate Training\n                                - Please refer to quotation description.\n\n                                7) Certificate of completion will be issued on the last day of class with at least 80% attendance achieved.\n\n                                8) Crystal Learning Centre reserves the rights to alter, augment or reduce our proprietary syllabus to improve learning quality.\n\n                                9) Crystal Learning Centre reserves the rights to postpone start of class, with prior notice, if there are insufficient students.\n                            </textarea></md-checkbox><div ng-messages=\"eventForm3.servicePolicy.$error\" ng-show=\"eventForm3.servicePolicy.$touched || (eventForm3.servicePolicy.$dirty && eventForm3.servicePolicy.$invalid) || vm.submitted == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"eventForm3.servicePolicy.$error.required\"><span class=\"validation-error\">Please accept service policies</span></div></div></div></form><div layout-gt-sm=\"row\" class=\"btn-submit\"><button type=\"button\" ng-click=\"vm.checkCheckboxLength(eventForm, companyForm, eventForm3);\">SUBMIT</button></div></div></div></div>");
$templateCache.put("app/main/pages/auth/admission/admissiononline.html","<div id=\"admission\" class=\"flex-scrollable\" layout=\"column\" ng-if=\"vm.courseType == \'O\'\"><div class=\"admission-header\"><div class=\"header-image\"><img src=\"{{vm.imgPath}}\" alt=\"logo not found\"></div></div><div class=\"admission-content\"><div ng-show=\"vm.isForm1Visible\"><div class=\"form-title\">Enrolment Form – {{vm.dialogData.course_name}} Group Class</div><div class=\"form-info\" id=\"a2\">To apply, please complete the application form and click Submit.</div><div class=\"form-level\"><div class=\"level-header\">Select your Level</div><dir class=\"level-radiobox\"><form class=\"md-inline-form\"><md-radio-group ng-model=\"vm.dialogData.level\"><div ng-repeat=\"item in vm.courseImageData.levels\" class=\"radio-format\"><label ng-click=\"vm.getData()\"><md-radio-button value=\"{{item}}\">{{item}}</md-radio-button></label></div></md-radio-group></form></dir></div><div class=\"empty-table\" ng-show=\"vm.blankLevel\">Please select your level</div><div class=\"form-table\"><div class=\"table-header\">Select your Intake Start Date</div><table><thead><tr><th>Courses</th><th>Term</th><th>Start Date</th><th>End Date</th><th>Start Time</th><th>End Time</th><th>Days</th><th>Course Fee</th><th>Registration and Material fees</th><th>GST</th><th>Total</th></tr></thead><tr ng-repeat=\"item in vm.courseData\"><td><md-radio-group ng-model=\"vm.dialogData.scheduleClassID\" ng-click=\"vm.selectCourse()\"><md-radio-button value=\"{{item.scheduleClassID}}\">{{item.courseName}}-{{vm.dialogData.level}}-{{vm.courseType}}</md-radio-button></md-radio-group></td><td>{{item.intake_term}}</td><td>{{item.start_date}}</td><td>{{item.end_date}}</td><td>{{item.start_time}}</td><td>{{item.end_time}}</td><td>{{item.classDays}}</td><td>{{vm.country.country.currency.code}} {{item.courseCost * vm.currency_rate | number : 2}}</td><td>{{vm.country.country.currency.code}} {{item.course_admin_fee * vm.currency_rate | number : 2}}</td><td>{{vm.country.country.currency.code}} {{item.courseTax * vm.currency_rate | number : 2}}</td><td>{{vm.country.country.currency.code}} {{item.courseTotalCost * vm.currency_rate | number : 2}}</td></tr></table><div class=\"empty-table\" ng-hide=\"vm.blankTableMessage\">Note :<div>- You do not need to pay GST if you are taking an online program and are not residing in Singapore.</div><div>- The time displayed is based on your local time zone.</div><div>- Prices are displayed in your local currency for reference. Payments will be charged in SGD. The precise amount charged can vary based on the exchange rate.</div></div><div class=\"empty-table\" ng-hide=\"vm.blankTableMessage\">Note :<div>- You do not need to pay gst if you are taking an online program and are not residing in Singapore.</div><div>- The timings are in your local time zone, and pricings are in Singapore dollars.</div></div><div class=\"empty-table\" ng-show=\"vm.blankTableMessage\">There are no intakes available that match the criteria you selected. If you are sure there should be<div>something, please give us a call at: &lt;+65 6222 0583&gt; or email us at <a href=\"mailto:class@crystal.com.sg\">class@crystal.com.sg.</a></div></div><div class=\"empty-table\" ng-show=\"vm.selectStartDate\">Please select intake start date</div></div><div class=\"btn-submit redirect-to-next\"><button type=\"button\" ng-click=\"vm.disable1();\">CONTINUE</button></div></div><div ng-show=\"vm.isForm2Visible\"><div class=\"form-title\">Enrolment Form – {{vm.dialogData.course_name}} Group Class</div><div class=\"form-info\">To apply, please complete the application form and click Submit.</div><div class=\"btn-submit\"><button type=\"button\" class=\"btn-back\" ng-click=\"vm.showForm();\">< BACK TO PREVIOUS STEP</button></div><div class=\"admission-register\"><div class=\"admission-register__header\">Applicant’s Particulars</div><div class=\"admission-register__form\"><div><form name=\"eventForm\" class=\"md-inline-form\" ng-submit=\"vm.addRecord(eventForm, companyForm);\" novalidate=\"\"><md-input-container class=\"md-block\" flex-lg=\"50\" flex-sm=\"100\" flex-xs=\"100\" layout-sm=\"\" md-no-float=\"\"><label>Name of Applicant (as per NRIC/Passport)*</label> <input name=\"Name\" placeholder=\"Your name\" md-no-float=\"\" ng-pattern=\"/^[a-zA-Z\\s]+[0-9!@#\\$%\\^\\&*\\)\\(+=._-]*$/\" ng-model=\"vm.dialogData.full_name\" ng-blur=\"vm.onEmailChange()\" ng-change=\"vm.onEmailChange()\" required=\"\"><div ng-messages=\"eventForm.Name.$error\" ng-show=\"eventForm.Name.$touched || vm.submitted == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"eventForm.Name.$error.required\"><span class=\"validation-error\">Please provide name</span></div><div ng-message=\"pattern\"><span class=\"validation-error\">Please provide valid name</span></div><div ng-message=\"true\"><span class=\"validation-error\">Please provide name</span></div></div></md-input-container><md-input-container class=\"md-block form-input\" flex=\"20\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><label>Contact No.*</label> <input name=\"ContactNo\" type=\"number\" placeholder=\"Your contact no.\" ng-model=\"vm.dialogData.contact_number\" flex=\"\" required=\"\"><div ng-messages=\"eventForm.ContactNo.$error\" ng-show=\"eventForm.ContactNo.$touched || (eventForm.ContactNo.$dirty && eventForm.ContactNo.$invalid) || vm.submitted == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"eventForm.ContactNo.$error.required\"><span class=\"validation-error\">Please provide number</span></div><div ng-message=\"pattern\"><span class=\"validation-error\">Please provide valid number</span></div></div></md-input-container><md-input-container class=\"md-block form-input\" flex=\"30\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><label>Email Address *</label> <input name=\"Email\" type=\"email\" placeholder=\"Your email address\" ng-focus=\"vm.duplicateStudentEmail = false\" ng-model=\"vm.dialogData.email\" ng-pattern=\"/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/\" ng-blur=\"vm.onEmailChange()\" ng-change=\"vm.onEmailChange()\" md-no-float=\"\" required=\"\"><div ng-messages=\"eventForm.Email.$error\" ng-show=\"eventForm.Email.$touched || (eventForm.Email.$dirty && eventForm.Email.$invalid) || vm.submitted == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"eventForm.Email.$error.required\"><span class=\"validation-error\">Please provide email</span></div><div ng-message=\"pattern\"><span class=\"validation-error\">Please provide valid email</span></div><div ng-show=\"vm.duplicateStudentEmail == true\"><span class=\"validation-error\">Email already taken</span></div></div></md-input-container><md-input-container class=\"md-block form-input\" flex=\"90\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><label>Address *</label> <input name=\"Address\" placeholder=\"Your mailing address\" ng-model=\"vm.dialogData.address\" required=\"\"><div ng-messages=\"eventForm.Address.$error\" ng-show=\"eventForm.Address.$touched || (eventForm.Address.$dirty && eventForm.Address.$invalid) || vm.submitted == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"eventForm.Address.$error.required\"><span class=\"validation-error\">Please provide address</span></div></div></md-input-container><div class=\"checkbox-notice\">Please check the options below only if it is applicable to you.</div><div layout-gt-sm=\"row\" class=\"form-checkbox\"><md-checkbox ng-model=\"vm.is_company\" md-no-float=\"\" ng-change=\"vm.onChangeCompany(vm.is_company)\" aria-label=\"Flexible\">My company will pay for my course</md-checkbox></div></form><div ng-show=\"vm.companyData\"><form name=\"companyForm\" class=\"md-inline-form\" ng-submit=\"vm.addRecord(eventForm, companyForm);\" novalidate=\"\"><md-input-container class=\"md-block form-input\" flex=\"50\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><label>Company Name*</label> <input name=\"CompanyName\" placeholder=\"Your company name\" ng-model=\"vm.dialogData.company_name\" ng-required=\"vm.companyRequired\"><div ng-messages=\"companyForm.CompanyName.$error\" ng-show=\"companyForm.CompanyName.$touched || vm.submittedCompany == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"companyForm.CompanyName.$error\"><span class=\"validation-error\">Please provide company name</span></div></div></md-input-container><md-input-container class=\"md-block form-input\" flex=\"90\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><label>Company Address.*</label> <input name=\"CompanyAddress\" placeholder=\"Your company address\" ng-model=\"vm.dialogData.company_address\" ng-required=\"vm.companyRequired\"><div ng-messages=\"companyForm.CompanyAddress.$error\" ng-show=\"companyForm.CompanyAddress.$touched || vm.submittedCompany == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"companyForm.CompanyAddress.$error\"><span class=\"validation-error\">Please provide company address</span></div></div></md-input-container><md-input-container class=\"md-block form-input\" flex=\"35\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><label>Contact Person No.*</label> <input name=\"ContactPersonNo\" type=\"number\" placeholder=\"Contact no. of person in charge\" ng-model=\"vm.dialogData.contact_person\" ng-required=\"vm.companyRequired\"><div ng-messages=\"companyForm.ContactPersonNo.$error\" ng-show=\"companyForm.ContactPersonNo.$touched || vm.submittedCompany == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"companyForm.ContactPersonNo.$error.required\"><span class=\"validation-error\">Please provide Contact Person No</span></div></div></md-input-container></form></div><div layout-gt-sm=\"row\" class=\"form-checkbox\"><md-checkbox ng-model=\"vm.is_renewal\" ng-change=\"vm.onChangeRenewal(vm.is_renewal);\">I have studied with the school before</md-checkbox></div><div class=\"form-fields\"><md-checkbox name=\"servicePolicy\" ng-model=\"vm.dialogData.group_service_policy\" required=\"\"><textarea class=\"terms\" readonly=\"\">\n                                        1) Course fees are payable before the start of class.\n\n                                        2) All fees are non-refundable.\n\n                                        3) Group classes\n                                        - Courses must be completed within 3 months.\n                                        - Makeup classes can be arranged with your respective trainer if you miss a class.\n                                        - Students are only allowed to schedule a maximum of 2 makeup classes each term. This is to maintain learning quality and discourage absences from class.\n                                        - Makeup classes will be charged at $30.00 per hour per student.\n                                        - Makeup classes are to be scheduled before the final lesson of the term.\n                                        - The makeup class is usually scheduled 1 hour before the next class.\n                                        - Students only require 1 hour of makeup lesson for every regular class missed.\n                                        - Makeup lessons are optional.\n                                        - Makeup class fee is to be paid in full at least 1 day before the scheduled makeup class. If no payment is received, the makeup class will not be conducted.\n                                        - For 1 to 2 students, makeup is at $30.00 per hour per student.\n                                        - For 3 to 4 students, makeup is at $30.00 for 2 hours per student. (Makeup classes will be set at 2hrs if there are 3 or 4 students)\n\n                                        4) Intensive classes\n                                        - Courses must be completed within 1 month.\n                                        - Each class must be a minimum of 2 hours.\n                                        - Rescheduling of classes must be arranged and agreed between trainer and student at least 24 hours beforehand, otherwise, the class will be considered consumed.\n\n                                        5) Private classes\n                                        - Courses must be completed within 7 months, unless otherwise specified.\n                                        - Each class must be a minimum of 2 hours.\n                                        - Rescheduling of classes must be arranged and agreed between trainer and student at least 24 hours beforehand, otherwise, the class will be considered consumed.\n                                        - Transport surcharge of $30/class applies for locations more than 150 meters from the nearest MRT.\n                                        - Every lesson should be planned with all students attending if the class is a Private Group of 2 or more.\n\n                                        6) Corporate Training\n                                        - Please refer to quotation proposed.\n\n                                        7) Certification\n                                        - A Letter of Completion (softcopy) for each Term will be sent to the student\'s email with at least 80% attendance achieved.\n                                        - The Letter of Completion can be physically printed for a charge of $5 per Letter/Certificate.\n                                        - Once printed and ready, the Letter of Completion can be collected over our counter between Mondays to Fridays, 11am-6pm.\n\n                                        8) Crystal Learning Centre reserves the rights to alter, augment or reduce our proprietary syllabus to improve learning quality.\n\n                                        9) Crystal Learning Centre reserves the rights to postpone the start of class, with prior notice, if there are insufficient students.\n                                    </textarea></md-checkbox><div ng-show=\"vm.groupServicePolicyError\" layout-gt-sm=\"row\" flex=\"30\"><span class=\"validation-error\">Please accept service policies</span></div></div><div class=\"btn-submit\"><button type=\"submit\" ng-click=\"vm.addRecord(eventForm, companyForm)\">SUBMIT</button></div></div></div></div></div></div></div><div id=\"admission\" class=\"flex-scrollable\" layout=\"column\" ng-if=\"vm.courseType == \'P\'\"><div class=\"admission-header\"><div class=\"header-image\"><img src=\"../images/crystal-learning.png\" alt=\"logo not found\"></div></div><div class=\"admission-content\"><div ng-show=\"vm.isForm1Visible\"><div class=\"form-title\">Enrolment Form – {{vm.dialogData.course_name}} Private Class</div><div class=\"form-info\">To apply, please complete the application form and click Submit.</div><div class=\"form-level\"><div class=\"level-header\">Select your Level</div><dir class=\"level-radiobox\"><form class=\"md-inline-form\"><md-radio-group ng-model=\"vm.dialogData.level\"><div ng-repeat=\"item in vm.courseImageData.levels\" class=\"radio-format\"><md-radio-button value=\"{{item}}\">{{item}}</md-radio-button></div></md-radio-group></form></dir></div><div class=\"admission-register\"><div class=\"admission-register__header\">Applicant’s Particulars</div><div class=\"admission-register__form\"><div><form name=\"eventForm\" class=\"md-inline-form\" ng-submit=\"vm.addRecord(eventForm, companyForm);\" novalidate=\"\"><md-input-container class=\"md-block\" flex=\"50\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><label>Name of Applicant (as per NRIC/Passport)*</label> <input name=\"Name\" placeholder=\"Your name\" md-no-float=\"\" ng-pattern=\"/^[a-zA-Z\\s]+[0-9!@#\\$%\\^\\&*\\)\\(+=._-]*$/\" ng-model=\"vm.dialogData.full_name\" required=\"\"><div ng-messages=\"eventForm.Name.$error\" ng-show=\"eventForm.Name.$touched || vm.submitted == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"eventForm.Name.$error.required\"><span class=\"validation-error\">Please provide name</span></div><div ng-message=\"pattern\"><span class=\"validation-error\">Please provide valid name</span></div><div ng-message=\"true\"><span class=\"validation-error\">Please provide name</span></div></div></md-input-container><md-input-container class=\"md-block form-input\" flex=\"20\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><label>Contact No.*</label> <input name=\"ContactNo\" type=\"number\" placeholder=\"Your contact no.\" ng-model=\"vm.dialogData.contact_number\" required=\"\"><div ng-messages=\"eventForm.ContactNo.$error\" ng-show=\"eventForm.ContactNo.$touched || (eventForm.ContactNo.$dirty && eventForm.ContactNo.$invalid) || vm.submitted == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"eventForm.ContactNo.$error.required\"><span class=\"validation-error\">Please provide number</span></div><div ng-message=\"pattern\"><span class=\"validation-error\">Please provide valid number</span></div></div></md-input-container><md-input-container class=\"md-block form-input\" flex=\"30\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><label>Email Address *</label> <input name=\"Email\" type=\"email\" placeholder=\"Your email address\" ng-model=\"vm.dialogData.email\" ng-focus=\"vm.duplicateStudentEmail = false\" ng-pattern=\"/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/\" md-no-float=\"\" required=\"\"><div ng-messages=\"eventForm.Email.$error\" ng-show=\"eventForm.Email.$touched || (eventForm.Email.$dirty && eventForm.Email.$invalid) || vm.submitted == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"eventForm.Email.$error.required\"><span class=\"validation-error\">Please provide email</span></div><div ng-message=\"pattern\"><span class=\"validation-error\">Please provide valid email</span></div><div ng-show=\"vm.duplicateStudentEmail == true\"><span class=\"validation-error\">Email already taken</span></div></div></md-input-container><md-input-container class=\"md-block form-input\" flex=\"90\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><label>Address *</label> <input name=\"Address\" placeholder=\"Your mailing address\" ng-model=\"vm.dialogData.address\" required=\"\"><div ng-messages=\"eventForm.Address.$error\" ng-show=\"eventForm.Address.$touched || (eventForm.Address.$dirty && eventForm.Address.$invalid) || vm.submitted == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"eventForm.Address.$error.required\"><span class=\"validation-error\">Please provide address</span></div></div></md-input-container><div class=\"checkbox-notice\">Please check the options below only if it is applicable to you.</div><div layout-gt-sm=\"row\" class=\"form-checkbox\"><md-checkbox ng-model=\"vm.is_company\" md-no-float=\"\" ng-change=\"vm.onChangeCompany(vm.is_company)\" aria-label=\"Flexible\">My company will pay for my course</md-checkbox></div></form><div ng-show=\"vm.companyData\"><form name=\"companyForm\" class=\"md-inline-form\" ng-submit=\"vm.addRecord(eventForm, companyForm);\" novalidate=\"\"><md-input-container class=\"md-block form-input\" flex=\"50\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><label>Company Name*</label> <input name=\"CompanyName\" placeholder=\"Your company name\" ng-model=\"vm.dialogData.company_name\" ng-required=\"vm.companyRequired\"><div ng-messages=\"companyForm.CompanyName.$error\" ng-show=\"companyForm.CompanyName.$touched || vm.submittedCompany == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"companyForm.CompanyName.$error\"><span class=\"validation-error\">Please provide company name</span></div></div></md-input-container><md-input-container class=\"md-block form-input\" flex=\"90\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><label>Company Address.*</label> <input name=\"CompanyAddress\" placeholder=\"Your company address\" ng-model=\"vm.dialogData.company_address\" ng-required=\"vm.companyRequired\"><div ng-messages=\"companyForm.CompanyAddress.$error\" ng-show=\"companyForm.CompanyAddress.$touched || vm.submittedCompany == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"companyForm.CompanyAddress.$error\"><span class=\"validation-error\">Please provide company address</span></div></div></md-input-container><md-input-container class=\"md-block form-input\" flex=\"35\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><label>Contact Person No.*</label> <input name=\"ContactPersonNo\" type=\"number\" placeholder=\"Contact no. of person in charge\" ng-model=\"vm.dialogData.contact_person\" ng-required=\"vm.companyRequired\"><div ng-messages=\"companyForm.ContactPersonNo.$error\" ng-show=\"companyForm.ContactPersonNo.$touched || vm.submittedCompany == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"companyForm.ContactPersonNo.$error.required\"><span class=\"validation-error\">Please provide Contact Person No</span></div></div></md-input-container></form></div><div layout-gt-sm=\"row\" class=\"form-checkbox\"><md-checkbox ng-model=\"vm.is_renewal\" ng-change=\"vm.onChangeRenewal(vm.is_renewal);\">I have studied with the school before</md-checkbox></div></div></div><div class=\"btn-submit\"><button type=\"button\" ng-click=\"vm.CheckPrivateForm(eventForm, companyForm);\">CONTINUE</button></div></div></div><div ng-show=\"vm.isForm2Visible\"><div class=\"form-title\">Enrolment Form – {{vm.dialogData.course_name}} Private Class</div><div class=\"form-info\">To apply, please complete the application form and click Submit.</div><div class=\"btn-submit\"><button type=\"button\" class=\"btn-back\" ng-click=\"vm.showForm();\">< BACK TO PREVIOUS STEP</button></div><form name=\"eventForm3\" class=\"md-inline-form\" ng-submit=\"vm.checkCheckboxLength(eventForm, companyForm, eventForm3);\" novalidate=\"\"><div class=\"form-select-day\"><div class=\"form-select-day__header\">Select your Preferred Class Day (you may select more than one)</div><div class=\"form-select-day__checkbox\"><div ng-repeat=\"day in vm.days\"><md-checkbox aria-label=\"{{day.bAllow?\'false\':\'true\'}}\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\' || vm.dialogData.noneditable == \'noneditable\'\" ng-change=\"vm.ToggleCheckbox($event, day)\" ng-model=\"day.bAllow\" ng-readonly=\"vm.dialogData.showTypeDialog == \'info\'\"><label>{{day.day}}</label></md-checkbox></div></div></div><div ng-show=\"vm.selectDay\" layout-gt-sm=\"row\" flex=\"30\"><span class=\"validation-error\">Please Select Day</span></div><div class=\"form-select-time\"><div class=\"form-select-time__header\">Select your Preferred Class Timing (you may select more than one)</div><div class=\"form-select-time__checkbox\"><div class=\"row\"><div class=\"col-3\"><div layout-gt-sm=\"row\"><md-checkbox aria-label=\"{{vm.timeslot1[0].bAllow?\'false\':\'true\'}}\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\' || vm.dialogData.noneditable == \'noneditable\'\" ng-change=\"vm.ToggleTime1Checkbox($event, time)\" ng-model=\"vm.timeslot1[0].bAllow\" ng-readonly=\"vm.dialogData.showTypeDialog == \'info\'\"><label>{{vm.timeslot1[0].time}}</label></md-checkbox></div><div layout-gt-sm=\"row\"><md-checkbox aria-label=\"{{vm.timeslot1[3].bAllow?\'false\':\'true\'}}\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\' || vm.dialogData.noneditable == \'noneditable\'\" ng-change=\"vm.ToggleTime1Checkbox($event, time)\" ng-model=\"vm.timeslot1[3].bAllow\" ng-readonly=\"vm.dialogData.showTypeDialog == \'info\'\"><label>{{vm.timeslot1[3].time}}</label></md-checkbox></div><div layout-gt-sm=\"row\"><md-checkbox aria-label=\"{{vm.timeslot1[5].bAllow?\'false\':\'true\'}}\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\' || vm.dialogData.noneditable == \'noneditable\'\" ng-change=\"vm.ToggleTime1Checkbox($event, time)\" ng-model=\"vm.timeslot1[5].bAllow\" ng-readonly=\"vm.dialogData.showTypeDialog == \'info\'\"><label>{{vm.timeslot1[5].time}}</label></md-checkbox></div><div layout-gt-sm=\"row\"><md-checkbox aria-label=\"{{vm.timeslot1[7].bAllow?\'false\':\'true\'}}\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\' || vm.dialogData.noneditable == \'noneditable\'\" ng-change=\"vm.ToggleTime1Checkbox($event, time)\" ng-model=\"vm.timeslot1[7].bAllow\" ng-readonly=\"vm.dialogData.showTypeDialog == \'info\'\"><label>{{vm.timeslot1[7].time}}</label></md-checkbox></div></div><div class=\"col-3\"><div layout-gt-sm=\"row\"><md-checkbox aria-label=\"{{vm.timeslot1[1].bAllow?\'false\':\'true\'}}\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\' || vm.dialogData.noneditable == \'noneditable\'\" ng-change=\"vm.ToggleTime1Checkbox($event, time)\" ng-model=\"vm.timeslot1[1].bAllow\" ng-readonly=\"vm.dialogData.showTypeDialog == \'info\'\"><label>{{vm.timeslot1[1].time}}</label></md-checkbox></div><div layout-gt-sm=\"row\"><md-checkbox aria-label=\"{{vm.timeslot1[4].bAllow?\'false\':\'true\'}}\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\' || vm.dialogData.noneditable == \'noneditable\'\" ng-change=\"vm.ToggleTime1Checkbox($event, time)\" ng-model=\"vm.timeslot1[4].bAllow\" ng-readonly=\"vm.dialogData.showTypeDialog == \'info\'\"><label>{{vm.timeslot1[4].time}}</label></md-checkbox></div><div layout-gt-sm=\"row\"><md-checkbox aria-label=\"{{vm.timeslot1[6].bAllow?\'false\':\'true\'}}\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\' || vm.dialogData.noneditable == \'noneditable\'\" ng-change=\"vm.ToggleTime1Checkbox($event, time)\" ng-model=\"vm.timeslot1[6].bAllow\" ng-readonly=\"vm.dialogData.showTypeDialog == \'info\'\"><label>{{vm.timeslot1[6].time}}</label></md-checkbox></div></div><div class=\"col-3\"><div layout-gt-sm=\"row\"><md-checkbox aria-label=\"{{vm.timeslot1[2].bAllow?\'false\':\'true\'}}\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\' || vm.dialogData.noneditable == \'noneditable\'\" ng-change=\"vm.ToggleTime1Checkbox($event, time)\" ng-model=\"vm.timeslot1[2].bAllow\" ng-readonly=\"vm.dialogData.showTypeDialog == \'info\'\"><label>{{vm.timeslot1[2].time}}</label></md-checkbox></div></div></div></div></div><div ng-show=\"vm.userTime\"><div class=\"user-time\"><select ui-select2=\"vm.select2Options\" id=\"myselect\" multiple=\"\" name=\"student\" class=\"md-block slec\" flex-gt-sm=\"\" ng-model=\"vm.timepicker\" data-placeholder=\"+Add Time\" width=\"50%\"><option ng-repeat=\"timeSlot in vm.timeslot2\" value=\"{{timeSlot.time}}\" class=\"md-block\" flex-gt-sm=\"\">{{timeSlot.time}}</option></select></div></div><div ng-show=\"vm.selectTime\" layout-gt-sm=\"row\" flex=\"30\" class=\"empty-table\"><span class=\"validation-error\">Please Select Time</span></div><md-input-container class=\"md-block form-input form-fields\" flex=\"20\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><div class=\"form-fields__header\">Number of students</div><input name=\"NumberOfStudents\" type=\"number\" ng-min=\"1\" ng-max=\"9\" class=\"text-field\" placeholder=\"Number of students\" ng-model=\"vm.dialogData.no_of_students\" flex=\"\" required=\"\"><div ng-messages=\"eventForm3.NumberOfStudents.$error\" ng-show=\"eventForm3.NumberOfStudents.$touched || (eventForm3.NumberOfStudents.$dirty && eventForm3.NumberOfStudents.$invalid) || vm.submitted == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"eventForm3.NumberOfStudents.$error.required\"><span class=\"validation-error\">Please provide number of students</span></div><div ng-message=\"max\" ng-show=\"eventForm3.NumberOfStudents.$error.number\"><span class=\"validation-error\">Please provide valid number of students</span></div><div ng-message=\"min\" ng-show=\"eventForm3.NumberOfStudents.$error.number\"><span class=\"validation-error\">Please provide valid number of students</span></div></div></md-input-container><div class=\"form-fields\"><div class=\"form-fields__header\">Study location</div><div class=\"level-radiobox\"><md-radio-group ng-model=\"vm.studyLocation\" ng-change=\"vm.onChangeStudyLocation()\" name=\"studyLocation\" required=\"\"><div class=\"radio-format\"><md-radio-button value=\"Same as Address\">Same as Address</md-radio-button></div><div class=\"radio-format\"><md-radio-button value=\"Crystal Learning Centre\">Crystal Learning Centre</md-radio-button></div><div class=\"radio-format\"><md-radio-button value=\"Others\">Others</md-radio-button></div></md-radio-group><div ng-messages=\"eventForm3.studyLocation.$error\" ng-show=\"eventForm3.studyLocation.$touched || (eventForm3.studyLocation.$dirty && eventForm3.studyLocation.$invalid) || vm.submitted == true\" role=\"alert\" class=\"g-error-top\"><div ng-message=\"required\" ng-show=\"eventForm3.studyLocation.$error.required\"><span class=\"validation-error\">Please provide study location</span></div></div></div></div><div ng-show=\"vm.showOtherStudyLocation\"><md-input-container class=\"md-block\" flex=\"50\" flex-sm=\"100\" flex-xs=\"100\" md-no-float=\"\"><input name=\"otherStudyLocation\" type=\"text\" class=\"text-field\" placeholder=\"Study location\" ng-model=\"vm.otherStudyLocation\" required=\"\"></md-input-container><div ng-messages=\"eventForm3.otherStudyLocation.$error\" ng-show=\"eventForm3.otherStudyLocation.$touched || (eventForm3.otherStudyLocation.$dirty && eventForm3.otherStudyLocation.$invalid) || vm.submitted == true\" role=\"alert\" class=\"g-error-top\"><div ng-message=\"required\" ng-show=\"eventForm3.otherStudyLocation.$error.required\"><span class=\"validation-error\">Please provide study location</span></div></div></div><div class=\"form-fields\"><div class=\"form-fields__header\">Lesson duration</div><div class=\"level-radiobox\"><md-radio-group ng-model=\"vm.lessonDuration\" ng-change=\"vm.onChangeLessonDuration()\" name=\"lessonDuration\" required=\"\"><div class=\"radio-format\"><md-radio-button value=\"1.5 hours\">1.5 hours</md-radio-button></div><div class=\"radio-format\"><md-radio-button value=\"2 hours\">2 hours</md-radio-button></div><div class=\"radio-format\"><md-radio-button value=\"Others\">Others</md-radio-button></div></md-radio-group></div><div ng-messages=\"eventForm3.lessonDuration.$error\" ng-show=\"eventForm3.lessonDuration.$touched || (eventForm3.lessonDuration.$dirty && eventForm3.lessonDuration.$invalid) || vm.submitted == true\" role=\"alert\" class=\"g-error-top\"><div ng-message=\"required\" ng-show=\"eventForm3.lessonDuration.$error.required\"><span class=\"validation-error\">Please provide lesson duration</span></div></div></div><div ng-show=\"vm.showOtherLessonDuration\"><select ui-select2=\"vm.select2Options\" name=\"otherLessonDuration\" multiple=\"\" class=\"md-block text-field\" flex-gt-sm=\"\" ng-model=\"vm.otherLessonDuration\" data-placeholder=\"+Add lesson duration\" width=\"50%\" required=\"\"><option ng-repeat=\"durationValue in vm.arrLessonDuration\" value=\"{{durationValue.duration}}\" class=\"md-block\" flex-gt-sm=\"\">{{durationValue.duration}}</option></select><div ng-messages=\"eventForm3.otherLessonDuration.$error\" ng-show=\"eventForm3.otherLessonDuration.$touched || (eventForm3.otherLessonDuration.$dirty && eventForm3.otherLessonDuration.$invalid) || vm.submitted == true\" role=\"alert\" class=\"g-error-top\"><div ng-message=\"required\" ng-show=\"eventForm3.otherLessonDuration.$error.required\"><span class=\"validation-error\">Please provide lesson duration</span></div></div></div><div class=\"form-fields\"><div class=\"form-fields__header\">Study frequency</div><div class=\"level-radiobox\"><md-radio-group ng-model=\"vm.studyFrequency\" ng-change=\"vm.onChangeStudyFrequency()\" name=\"studyFrequency\" required=\"\"><div class=\"radio-format\"><md-radio-button value=\"Daily\">Daily</md-radio-button></div><div class=\"radio-format\"><md-radio-button value=\"1x per week\">1x per week</md-radio-button></div><div class=\"radio-format\"><md-radio-button value=\"2x per week\">2x per week</md-radio-button></div><div class=\"radio-format\"><md-radio-button value=\"Others\">Others</md-radio-button></div></md-radio-group></div><div ng-messages=\"eventForm3.studyFrequency.$error\" ng-show=\"eventForm3.studyFrequency.$touched || (eventForm3.studyFrequency.$dirty && eventForm3.studyFrequency.$invalid) || vm.submitted == true\" role=\"alert\" class=\"g-error-top\"><div ng-message=\"required\" ng-show=\"eventForm3.studyFrequency.$error.required\"><span class=\"validation-error\">Please provide study frequency</span></div></div></div><div ng-show=\"vm.showOtherStudyFrequency\"><select ui-select2=\"vm.select2Options\" name=\"otherStudyFrequency\" multiple=\"\" class=\"md-block text-field\" flex-gt-sm=\"\" ng-model=\"vm.otherStudyFrequency\" data-placeholder=\"+Add study frequency\" width=\"50%\" required=\"\"><option ng-repeat=\"frequencyValue in vm.arrStudyFrequency\" value=\"{{frequencyValue.frequency}}\" class=\"md-block\" flex-gt-sm=\"\">{{frequencyValue.frequency}}</option></select><div ng-messages=\"eventForm3.otherStudyFrequency.$error\" ng-show=\"eventForm3.otherStudyFrequency.$touched || (eventForm3.otherStudyFrequency.$dirty && eventForm3.otherStudyFrequency.$invalid) || vm.submitted == true\" role=\"alert\" class=\"g-error-top\"><div ng-message=\"required\" ng-show=\"eventForm3.otherStudyFrequency.$error.required\"><span class=\"validation-error\">Please provide study frequency</span></div></div></div><div class=\"form-fields\"><md-checkbox name=\"servicePolicy\" ng-model=\"vm.dialogData.service_policy\" required=\"\"><textarea class=\"terms\" readonly=\"\">\n                                1) Course fees are payable before start of class.\n\n                                2) All fees are non-refundable.\n\n                                3) Group classes\n                                - Courses must be completed within 3 months.\n                                - Make-up classes can be arranged with trainer at S$30/hour. Usually 1 hour before the next class is sufficient if a 2 hours class is missed.\n                                - Only 2 hours of make-up classes are allowed per course. This is to discourage absence, and to maintain learning quality.\n\n                                4) Intensive classes\n                                - Courses must be completed within 1 month.\n                                - Each class must be a minimum of 2 hours.\n                                - Re scheduling of classes must be arranged and agreed between trainer and student at least 24 hours beforehand, otherwise the class will be considered consumed.\n\n                                5) Private classes\n                                - Courses must be completed within 9 months, unless specified otherwise.\n                                - Each class must be a minimum of 2 hours.\n                                - Re scheduling of classes must be arranged and agreed between trainer and student at least 24 hours beforehand, otherwise the class will be considered consumed.<br>\n                                - Transport surcharge applies for inaccessible areas by public transport.\n\n                                6) Corporate Training\n                                - Please refer to quotation description.\n\n                                7) Certificate of completion will be issued on the last day of class with at least 80% attendance achieved.\n\n                                8) Crystal Learning Centre reserves the rights to alter, augment or reduce our proprietary syllabus to improve learning quality.\n\n                                9) Crystal Learning Centre reserves the rights to postpone start of class, with prior notice, if there are insufficient students.\n                            </textarea></md-checkbox><div ng-messages=\"eventForm3.servicePolicy.$error\" ng-show=\"eventForm3.servicePolicy.$touched || (eventForm3.servicePolicy.$dirty && eventForm3.servicePolicy.$invalid) || vm.submitted == true\" role=\"alert\"><div ng-message=\"required\" ng-show=\"eventForm3.servicePolicy.$error.required\"><span class=\"validation-error\">Please accept service policies</span></div></div></div></form><div layout-gt-sm=\"row\" class=\"btn-submit\"><button type=\"button\" ng-click=\"vm.checkCheckboxLength(eventForm, companyForm, eventForm3);\">SUBMIT</button></div></div></div></div>");
$templateCache.put("app/main/pages/auth/admission/admissionprivate.html","<div id=\"admission\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div class=\"admission-content\"><div ng-show=\"vm.isForm1Visible\"><form name=\"eventForm\"><div class=\"form-title\">Application for Admission – {{vm.dialogData.course_name}}</div><div class=\"form-info\">To apply, please complete the application form and click Submit.</div><div class=\"form-level\"><div class=\"level-header\">Select your Level</div><dir class=\"level-radiobox\"><md-radio-group ng-model=\"vm.dialogData.level\"><md-radio-button value=\"Beginner\">Beginner</md-radio-button><md-radio-button value=\"Intermediate\">Intermediate</md-radio-button><md-radio-button value=\"Advanced\">Advanced</md-radio-button></md-radio-group></dir></div><div class=\"admission-register\"><div class=\"admission-register__header\">Applicant’s Particulars</div><div class=\"admission-register__form\"><div><md-input-container class=\"md-block\" flex=\"50\" md-no-float=\"\"><label>Name of Applicant(as per NRIC/Passport)*</label> <input name=\"Name\" placeholder=\"Your Name\" md-no-float=\"\" ng-pattern=\"/^[a-zA-Z\\s]+[0-9!@#\\$%\\^\\&*\\)\\(+=._-]*$/\" ng-model=\"vm.dialogData.full_name\" required=\"\"><div ng-messages=\"eventForm.Name.$error\" ng-show=\"eventForm.Name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Name</span></div><div ng-message=\"pattern\"><span>Please provide valid name</span></div></div></md-input-container><md-input-container class=\"md-block form-input\" flex=\"20\" md-no-float=\"\"><label>Contact No*</label> <input name=\"ContactNo\" type=\"number\" placeholder=\"Your Contact No\" ng-model=\"vm.dialogData.contact_number\" required=\"\"><div ng-messages=\"eventForm.ContactNo.$error\" ng-show=\"eventForm.ContactNo.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Number</span></div><div ng-message=\"pattern\"><span>Please provide valid Number</span></div></div></md-input-container><md-input-container class=\"md-block form-input\" flex=\"30\" md-no-float=\"\"><label>Email Address *</label> <input name=\"Email\" type=\"email\" placeholder=\"Your Email Address\" ng-model=\"vm.dialogData.email\" ng-pattern=\"/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/\" md-no-float=\"\" required=\"\"><div ng-messages=\"eventForm.Email.$error\" ng-show=\"eventForm.Email.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Email</span></div><div ng-message=\"pattern\"><span>Please provide valid Email</span></div></div></md-input-container><md-input-container class=\"md-block form-input\" flex=\"90\" md-no-float=\"\"><label>Address *</label> <input name=\"Address\" placeholder=\"Your mailing address\" ng-model=\"vm.dialogData.address\" required=\"\"><div ng-messages=\"eventForm.Address.$error\" ng-show=\"eventForm.Address.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Address</span></div></div></md-input-container><div layout-gt-sm=\"row\" class=\"form-checkbox\"><md-checkbox ng-model=\"vm.is_company\" md-no-float=\"\" ng-change=\"vm.onChangeCompany(vm.is_company)\" aria-label=\"Flexible\">I am Applying under Company</md-checkbox></div><div ng-show=\"vm.companyData\"><md-input-container class=\"md-block form-input\" flex=\"50\" md-no-float=\"\"><label>Company Name *</label> <input name=\"CompanyName\" id=\"cName\" placeholder=\"Your Company Name\" ng-model=\"vm.dialogData.company_name\" class=\"cName\" ng-required=\"vm.companyRequired\"><div ng-messages=\"eventForm.CompanyName.$error\" ng-show=\"eventForm.CompanyName.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Company Name</span></div></div></md-input-container><md-input-container class=\"md-block form-input\" flex=\"90\" md-no-float=\"\"><label>Company Address *</label> <input name=\"CompanyAddress\" placeholder=\"Your Company Address\" ng-model=\"vm.dialogData.company_address\" id=\"cAddress\" class=\"cAddress\" ng-required=\"vm.companyRequired\"><div ng-messages=\"eventForm.CompanyAddress.$error\" ng-show=\"eventForm.CompanyAddress.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Company Address</span></div></div></md-input-container><md-input-container class=\"md-block form-input\" flex=\"30\" md-no-float=\"\"><label>Contact Person No*</label> <input name=\"ContactPersonNo\" type=\"number\" placeholder=\"Contact no, of person in charge\" ng-model=\"vm.dialogData.contact_person\" id=\"cNumber\" class=\"cNumber\" ng-required=\"vm.companyRequired\"><div ng-messages=\"eventForm.ContactPersonNo.$error\" ng-show=\"eventForm.ContactPersonNo.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please provide Contact Person No</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" class=\"form-checkbox\"><md-checkbox ng-model=\"vm.is_renewal\" ng-change=\"vm.onChangeRenewal(vm.is_renewal);\">I have Enrolled with the School Before</md-checkbox></div></div></div></div><div class=\"btn-submit\"><button type=\"button\" ng-disabled=\"eventForm.$invalid\" ng-click=\"vm.showForm();\">CONTINUE</button></div></form></div><div ng-show=\"vm.isForm2Visible\"><div class=\"form-title\">Application for Admission – Conversational Mandarin Private Class</div><div class=\"form-info\">To apply, please complete the application form and click Submit.</div><div class=\"btn-submit\"><button type=\"button\" style=\"background-color: #71B8FF;\" ng-click=\"vm.showForm();\">< BACK TO PREVIOUS STEP</button></div><div class=\"form-select-day\"><div class=\"form-select-day__header\">Select your Preferred Class Day (you may select more than one)</div><div class=\"form-select-day__checkbox\"><div ng-repeat=\"day in vm.days\"><md-checkbox aria-label=\"{{day.bAllow?\'false\':\'true\'}}\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\' || vm.dialogData.noneditable == \'noneditable\'\" ng-change=\"vm.ToggleCheckbox($event, day)\" ng-model=\"day.bAllow\" ng-readonly=\"vm.dialogData.showTypeDialog == \'info\'\">{{day.day}}</md-checkbox></div></div></div><div class=\"form-select-time\"><div class=\"form-select-time__header\">Select your Preferred Class Timing (you may select more than one)</div><div class=\"form-select-time__checkbox\"><div ng-repeat=\"time in vm.timeslot1\"><div class=\"form-select-time__checkbox-align\" flex=\"30\"><div layout-gt-sm=\"row\" class=\"form-checkbox\"><md-checkbox aria-label=\"{{time.bAllow?\'false\':\'true\'}}\" ng-disabled=\"vm.dialogData.showTypeDialog == \'info\' || vm.dialogData.noneditable == \'noneditable\'\" ng-change=\"vm.ToggleTime1Checkbox($event, time)\" ng-model=\"time.bAllow\" ng-readonly=\"vm.dialogData.showTypeDialog == \'info\'\">{{time.time}}</md-checkbox></div></div></div></div></div><br><br><br><br><br><div layout-gt-sm=\"row\" class=\"btn-submit\"><button type=\"button\" ng-click=\"vm.checkCheckboxLength();\">SUBMIT</button></div></div></div></div>");
$templateCache.put("app/main/pages/auth/admission/pagenotfound.html","<div id=\"admission\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div class=\"admission-content\"><div class=\"form-title\">Sorry !! seems you are lost.</div></div></div>");
$templateCache.put("app/main/pages/auth/admission/thank.html","<div id=\"admission\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div class=\"admission-content\"><div ng-show=\"vm.isForm1Visible\"><div class=\"form-title\">Thank You ! Your Application has been Submitted.</div></div></div></div>");
$templateCache.put("app/main/pages/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div id=\"forgot-password-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>Crystal Learning</span></div><div class=\"title\" translate=\"FORGOTPASSWORD.TITLE\">Recover your password</div><form name=\"forgotPasswordForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email address\" translate=\"\" translate-attr-placeholder=\"FORGOTPASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"forgotPasswordForm.email.$error\" ng-show=\"forgotPasswordForm.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span translate=\"FORGOTPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"RESET MY PASSWORD\" ng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" translate=\"FORGOTPASSWORD.SEND_RESET_LINK\" translate-attr-aria-label=\"FORGOTPASSWORD.SEND_RESET_LINK\" ng-click=\"vm.onForgetPwd($event)\">SEND RESET LINK</md-button></form><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"app.pages_auth_login\" translate=\"FORGOTPASSWORD.GO_BACK\">Go back to login</a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/lock/lock.html","<div id=\"lock\" class=\"scrollable\" ms-scroll=\"\"><div id=\"lock-form-wrapper\" layout=\"row\" layout-align=\"center center\"><div id=\"lock-form\" class=\"md-whiteframe-1dp\"><div layout=\"row\" layout-align=\"start center\" layout-sm=\"column\" layout-align-sm=\"center center\"><div class=\"avatar-container\"><img class=\"avatar big\" src=\"assets/images/avatars/katherine.jpg\"><md-icon md-font-icon=\"icon-lock\" class=\"md-warn-fg s36 md-hue-2\"></md-icon></div><div flex=\"\" layout=\"column\" layout-align=\"start\" layout-align-sm=\"center center\"><div class=\"title\" translate=\"LOCK.TITLE\">Your session is locked</div><div class=\"subtitle\" translate=\"LOCK.SUBTITLE\">Due to inactivity, your session is locked. Enter your password to continue.</div></div></div><form><md-input-container flex=\"\" md-no-float=\"\"><input ng-model=\"vm.form.userName\" disabled=\"\" placeholder=\"User Name\" translate=\"\" translate-attr-placeholder=\"LOCK.USERNAME\"></md-input-container><md-input-container flex=\"\" md-no-float=\"\"><input ng-model=\"vm.form.password\" type=\"password\" placeholder=\"Password\" translate=\"\" translate-attr-placeholder=\"LOCK.PASSWORD\"></md-input-container><md-button class=\"md-raised md-accent\" aria-label=\"UNLOCK\" translate=\"LOCK.UNLOCK\" translate-attr-aria-label=\"LOCK.UNLOCK\">UNLOCK</md-button></form><div class=\"message\"><a ui-sref=\"app.pages_auth_login\" class=\"md-accent-color\"><span translate=\"LOCK.ARE_YOU_NOT\">Are you not</span><span>Jane Doe?</span></a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div id=\"login-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\"><span>Crystal Learning</span></div><div class=\"title\" translate=\"LOGIN.TITLE\">Sign in to your account</div><form name=\"loginForm\" novalidate=\"\" autocomplete=\"nope\"><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"LoginUserName\" ng-model=\"vm.login.email\" autocomplete=\"nope\" placeholder=\"Username\" required=\"\"><div ng-messages=\"loginForm.LoginUserName.$error\" ng-show=\"loginForm.LoginUserName.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Please enter a username</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"LoginPassword\" ng-model=\"vm.login.password\" autocomplete=\"nope\" placeholder=\"Password\" required=\"\"><div ng-messages=\"loginForm.LoginPassword.$error\" ng-show=\"loginForm.LoginPassword.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Please enter a password</span></div></div></md-input-container><small class=\"md-warn-fg\" ng-show=\"vm.invalidUser\">Username or Password incorrect.</small><div class=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><md-checkbox class=\"remember-me\" ng-model=\"vm.login.remember\" aria-label=\"Remember Me\"><span translate=\"LOGIN.REMEMBER_ME\">Remember Me</span></md-checkbox><a ui-sref=\"app.pages_auth_forgot-password\" class=\"forgot-password md-accent-color\" translate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button type=\"submit\" class=\"md-raised md-accent md-accent__orange-bg-override\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid\" translate=\"LOGIN.LOG_IN\" translate-attr-aria-label=\"LOGIN.LOG_IN\" ng-click=\"vm.onLogin($event)\">SIGN IN</md-button></form></div></div></div>");
$templateCache.put("app/main/pages/auth/register/register.html","<div id=\"register\" class=\"scrollable\" ms-scroll=\"\"><div id=\"register-form-wrapper\" layout=\"row\" layout-align=\"center center\"><div id=\"register-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"REGISTER.TITLE\">Create an account</div><form><md-input-container flex=\"\" md-no-float=\"\"><input ng-model=\"vm.form.username\" placeholder=\"Name\" translate=\"\" translate-attr-placeholder=\"REGISTER.NAME\"></md-input-container><md-input-container flex=\"\" md-no-float=\"\"><input ng-model=\"vm.form.email\" type=\"email\" placeholder=\"Email\" translate=\"\" translate-attr-placeholder=\"REGISTER.EMAIL\"></md-input-container><md-input-container flex=\"\" md-no-float=\"\"><input ng-model=\"vm.form.password\" type=\"password\" placeholder=\"Password\" translate=\"\" translate-attr-placeholder=\"REGISTER.PASSWORD\"></md-input-container><md-input-container flex=\"\" md-no-float=\"\"><input ng-model=\"vm.form.passwordConfirm\" type=\"password\" placeholder=\"Password (Confirm)\" translate=\"\" translate-attr-placeholder=\"REGISTER.PASSWORD_CONFIRM\"></md-input-container><div class=\"terms\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"center center\"><md-checkbox ng-model=\"data.cb1\" aria-label=\"I read and accept\"></md-checkbox><div layout=\"row\" layout-sm=\"column\" layout-align=\"start center\"><span translate=\"REGISTER.READ_ACCEPT\">I read and accept</span> <a href=\"#\" class=\"md-accent-color\" translate=\"REGISTER.TERMS_COND\">terms and conditions</a></div></div><md-button class=\"md-raised md-accent\" aria-label=\"CREATE MY ACCOUNT\" translate=\"REGISTER.CREATE_ACCOUNT\" translate-attr-aria-label=\"REGISTER.CREATE_ACCOUNT\">CREATE MY ACCOUNT</md-button></form><div class=\"login\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"REGISTER.ALREADY_HAVE\">Already have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_login\" translate=\"REGISTER.LOGIN\">Log in</a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/reset-password/reset-password.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div id=\"reset-password-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>Crystal Learning</span></div><div class=\"title\" translate=\"RESETPASSWORD.TITLE\">Reset your password</div><form name=\"resetPasswordForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" required=\"\"><div ng-messages=\"registerForm.password.$error\" ng-show=\"registerForm.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Password field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" ng-change=\"vm.checkPasswordEntered()\" ng-blur=\"vm.checkPasswordMatch()\" translate=\"\" translate-attr-placeholder=\"RESETPASSWORD.PASSWORD_CONFIRM\" required=\"\"><div ng-messages=\"resetPasswordForm.passwordConfirm.$error\" ng-show=\"resetPasswordForm.passwordConfirm.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Password (Confirm) field is required</span></div><div ng-hide=\"vm.passwordNotMatch\"><span class=\"auto-error\">Password didnt Match</span></div></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"UPDATE MY PASSWORD\" ng-click=\"vm.setResetPassword()\" ng-disabled=\"resetPasswordForm.$invalid || vm.passwordNotMatch == false\">RESET MY PASSWORD</md-button></form></div></div></div>");
$templateCache.put("app/main/pages/auth/thank-you/english-express-thank-you.html","<div id=\"admission\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div class=\"admission-content\"><div><div class=\"form-title\">Thank You ! Your Application has been Submitted.</div></div></div></div>");
$templateCache.put("app/main/pages/auth/thank-you/hana-thank-you.html","<div id=\"admission\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div class=\"admission-content\"><div><div class=\"form-title\">Thank You ! Your Application has been Submitted.</div></div></div></div>");
$templateCache.put("app/main/pages/auth/thank-you/indoslang-thank-you.html","<div id=\"admission\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div class=\"admission-content\"><div><div class=\"form-title\">Thank You ! Your Application has been Submitted.</div></div></div></div>");
$templateCache.put("app/main/pages/auth/thank-you/yiman-thank-you.html","<div id=\"admission\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div class=\"admission-content\"><div><div class=\"form-title\">Thank You ! Your Application has been Submitted.</div></div></div></div>");
$templateCache.put("app/main/pages/auth/unsubscribe/unsubscribe.html","<div id=\"unsubscribe\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div class=\"center\"><h1>Unsubscription</h1><p>You have been successfully removed from this mode of subscribers list. You will not receive any further email notifications related to changes in Terms</p></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\"><div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div class=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div class=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button class=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" layout-align=\"space-between\" layout-fill=\"\" flex=\"\"><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" ng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div class=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" aria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div></div>");}]);